// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../../node_modules/bootstrap-icons/font/fonts/bootstrap-icons.woff2?24e3eb84d0bcaf83d77f904c78ac1f47", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../../node_modules/bootstrap-icons/font/fonts/bootstrap-icons.woff?24e3eb84d0bcaf83d77f904c78ac1f47", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*******************/
/********************/
@font-face {
  font-family: "Poppins";
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Poppins-Medium";
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Poppins-Bold";
  src: local("Poppins"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
/*******************/
/********************/
/*******************/
/********************/
/*******************/
/********************/
/*******************/
/********************/
/*******************/
/********************/
/*******************/
/********************/
.strong-text {
  position: relative;
  bottom: 10px;
}

.blue-image img {
  filter: invert(44%) sepia(17%) saturate(226%) hue-rotate(166deg) brightness(99%) contrast(94%);
}

.white-image img {
  filter: invert(100%) sepia(0%) saturate(3524%) hue-rotate(261deg) brightness(122%) contrast(109%);
}

.file-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.file-icon {
  width: 20px;
  margin: 5px;
}

/* Phone number */
.register_phone .PhoneInputInput {
  height: 47px;
  border-radius: 10px;
  border: 1px solid rgba(0, 146, 159, 0.1490196078);
}

.password-eye {
  position: relative !important;
}

.password-eye .bi.bi-eye,
.password-eye .bi.bi-eye-slash {
  position: absolute !important;
  right: 10px !important;
  z-index: 1 !important;
  bottom: 10px !important;
}

.to-address {
  max-width: 100px;
  overflow: auto;
}

.to-address::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
.to-address::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
.to-address::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

/* Handle on hover */
.transaction_container {
  display: flex;
  justify-content: space-between;
}

.trans_history {
  padding: 15px;
  flex-direction: row;
  justify-content: space-between;
  border-width: 1px;
  border-color: #739cab;
  border-radius: 10px;
  background-color: #e5f1f6;
  margin-top: 30px;
}

.trans_history2 {
  padding: 15px;
  flex-direction: row;
  justify-content: space-between;
  border-width: 1px;
  border-color: #f3d3c2;
  border-radius: 10px;
  background-color: #f7e9db;
  margin-top: 30px;
}

.trans_history3 {
  padding: 15px;
  flex-direction: row;
  justify-content: space-between;
  border-width: 1px;
  border-color: #ca8d98;
  border-radius: 10px;
  background-color: #f5dbdc;
  margin-top: 30px;
}

.sell {
  color: #cc8487;
}

.buy {
  color: #83a189;
}

/* Searchable Dropdown*/
.dropdown {
  position: relative;
  color: #333;
  cursor: default;
}

.dropdown .arrow {
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 0;
  content: " ";
  display: block;
  height: 0;
  margin-top: 0.3rem;
  position: absolute;
  right: 10px;
  top: 14px;
  width: 0;
}

.dropdown .arrow.open {
  border-color: transparent transparent #999;
  border-width: 0 5px 5px;
}

.dropdown .selected-value input {
  line-height: 1.5;
  font-size: 1rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  cursor: default;
  outline: none;
  padding: 8px 52px 8px 10px;
  transition: all 200ms ease;
  width: 100%;
}

.dropdown .options {
  display: none;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
}

.dropdown .options.open {
  display: block;
}

.dropdown .option {
  box-sizing: border-box;
  color: rgba(51, 51, 51, 0.8);
  cursor: pointer;
  display: block;
  padding: 8px 10px;
}

.dropdown .option.selected,
.dropdown .option:hover {
  background-color: #f2f9fc;
  color: #333;
}

.app-border {
  border: 1px solid #00929f;
}

.payment-method {
  background-color: rgb(242, 237, 255);
  padding: 60px;
  cursor: pointer;
}

.table-responsive {
  overflow-y: hidden;
}

.form-check-input[type=checkbox]:checked {
  background-color: #00929f !important;
  border-color: #00929f !important;
}

.chat_box_animation {
  transition: 0.2s;
}

.otp-animation {
  transition: 0.8s;
}

.width_100 {
  width: 100% !important;
}

.dashboard_box_biling {
  background-image: linear-gradient(92deg, #354959 0%, #335539 100%, #3c7546 100%);
}

.bg_gradiant {
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
}

.border-r {
  border-right: 1.8px solid #ccc;
}

.border-l {
  border-left: 1.8px solid #ccc;
}

.cursor-pointer {
  cursor: pointer;
}

.box_shadow {
  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));
}

.poppins-400 {
  font-family: "Poppins-Regular";
}

.poppins-500 {
  font-family: "Poppins-Medium";
}

.poppins-600 {
  font-family: "Poppins-SemiBold";
}

.poppins-700 {
  font-family: "Poppins-Bold";
}

.text_sm {
  font-size: 13px;
}

.text_xs {
  font-size: 12px;
}

.text_15 {
  font-size: 15px;
  line-height: 28px;
}

.text_14 {
  font-size: 14px;
}

.text_18 {
  font-size: 18px;
}

.text_base {
  font-size: 16px;
}

.radius_15 {
  border-radius: 15px;
}

.textgreen {
  color: black;
}

.text-pending {
  color: #7a8892;
}

.text-pending-back {
  background-color: #ebecee;
}

.online-bubble {
  background-color: #00ebbd;
}

.idle-bubble {
  background-color: #ffa200;
}

.idle-text {
  color: #ffa200;
}

.offline-bubble {
  background-color: #b9b9b9;
}

.offline-text {
  color: #b9b9b9;
}

.light_green {
  color: #cce9ec;
}

.dark_blue {
  color: #354959;
}

.text_gray {
  color: #939ea8;
}

.text_gray_700 {
  color: #333333;
}

.text_gray_500 {
  color: #354959;
  opacity: 0.8;
}

.text_gray_light {
  color: #eaecee;
}

.bg_light_green {
  background-color: #cce9ec;
}

.bg_light_green_500 {
  background-color: #f0f9f9;
}

.bg_green_table {
  background-color: #e5f5ec;
}

.bg_green {
  background-color: #00929f;
}

.bg_green_500 {
  background-color: #008b89;
}

.bg_dark_blue {
  background-color: #354959;
}

.bg_gray {
  background-color: #939ea8;
}

.bg_gray_500 {
  background-color: #f2f3f7;
}

.bg_gray_700 {
  background-color: #e5f5ec;
}

.bg_gray_light {
  background-color: #eaecee;
}

.nav_green {
  background-color: #00929f !important;
  border-color: #00929f !important;
}

.border-green {
  border: 1px solid #3c7546 !important;
}

.table-responsive {
  border-radius: 16px;
}

.pl-0 {
  padding-left: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

img {
  max-width: 100%;
}

body {
  background-color: #f2f3f7 !important;
}

.navbar-dark {
  background-color: #ffffff;
}

.navbar-collapse {
  justify-content: end;
}

/*Clear chat*/
.drop_chat {
  top: 60px !important;
  right: 15px !important;
}

.drop_chat:after {
  content: "";
  display: inline-block;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background-color: #fff;
  width: 10px;
  height: 9px;
  position: absolute;
  right: 19px;
  top: -8px;
}

.chat_more:after {
  content: "";
  display: inline-block;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background-color: #fff;
  width: 10px;
  height: 9px;
  position: absolute;
  right: 19px;
  top: -8px;
}

.react-time-picker__wrapper {
  border: none !important;
}

.admin_name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.billing_sec {
  height: 240px;
  background-color: #ffffff;
  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));
  border-radius: 15px;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-content: space-evenly;
}

.billing_sec_top {
  display: flex;
  gap: 10px;
  align-items: center;
}

.billing_sec .billing_sec_top p {
  margin: 0;
  color: #354959;
}

.billing_sec strong {
  font-size: 40px;
  color: #354959;
  font-family: "Poppins-SemiBold";
  font-weight: 100;
  display: flex;
  align-items: center;
  gap: 10px;
}

.billing_sec strong span {
  font-size: 14px;
  color: #3c7546;
  font-family: "Poppins";
  background-color: #cce9ec;
  padding: 3px 10px;
  border-radius: 5px;
}

.billing_sec p {
  color: #354959;
  font-size: 13px;
  line-height: 17px;
  margin: 10px 0;
}

.billing_sec a {
  text-align: center;
  text-decoration: unset;
  font-size: 14px;
  border-radius: 5px;
  color: #3c7546;
  background-color: #cce9ec;
  padding: 5px;
}

.billing_sec a svg {
  margin-top: -3px;
}

.recentappoint_part {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 14px;
}

.recentappoint_part h4, .recentappoint_part .h4 {
  margin: 0;
  width: 38px;
  height: 38px;
  border-radius: 19px;
  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));
  background-color: #3c7546;
  display: block;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
}

.billing_sec .recentappoint_name strong {
  font-size: 14px;
  line-height: 22px;
  color: #354959;
}

.billing_sec .recentappoint_name p {
  margin: 0;
  opacity: 0.502;
  font-size: 12px;
}

.recentappoint_part span {
  font-size: 12px;
  color: #3c7546;
  font-family: "Poppins";
  background-color: #cce9ec;
  padding: 3px 5px;
  border-radius: 5px;
  font-weight: 600;
}

.billing_sec .recentappoint_sec p {
  margin: 0;
  font-size: 15px;
}

.billing_sec.two {
  justify-content: unset;
  padding: 0;
}

.recentappoint_sec {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-bottom: 2px solid #eaecee;
}

.billing_sec .recentappoint_sec a {
  padding: 0;
  background-color: unset;
}

.recentappoint_name.mes {
  width: 70%;
}

.douctorlist_sec {
  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));
  background-color: #ffffff;
  border-radius: 15px;
  padding: 30px 30px 5px;
}

.douctorlist_head h4, .douctorlist_head .h4 {
  margin: 0;
  color: #354959;
  font-size: 20px;
  font-family: "Poppins-SemiBold";
}

.douctorlist_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5em;
}

.douctorlist_part span img {
  width: 58px;
  height: 50px;
  object-fit: cover;
  border-radius: 29px;
}

.douctorlist_name p {
  margin: 0;
}

.douctorlist_part span {
  width: 15%;
  display: inline-block;
}

.douctorlist_name {
  width: 65%;
}

.douctorlist_part {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0;
}

.douctorlist_part svg {
  font-size: 25px;
}

.douctorlist_head a {
  text-decoration: unset;
  color: #3c7546;
}

.patientsname_sec {
  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));
  background-color: #ffffff;
  border-radius: 15px;
  padding: 30px 30px 5px;
}

.patientsname_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
}

.patientsname_top_left h2, .patientsname_top_left .h2 {
  font-size: 20px;
  color: #354959;
  margin: 0;
}

.patientsname_top_left a {
  text-decoration: unset;
  font-size: 13px;
  color: #3c7546;
}

.patientsname_top_right a {
  font-size: 13px;
  line-height: 17px;
  color: #ffffff;
  background-color: #3c7546;
  border-radius: 5px;
  text-decoration: unset;
  padding: 8px 20px;
}

.patientsearch_form input[type=text] {
  outline: unset;
  height: 34px;
  border-radius: 5px;
  border: 1px solid rgba(53, 73, 89, 0.0705882353);
  font-size: 13px;
  padding-left: 2em;
}

.patientstable_sec tr th {
  font-size: 13px;
  color: #354959;
  font-weight: 100;
  opacity: 0.502;
}

.patientstable_sec tr td {
  font-size: 13px;
  color: #354959;
  font-weight: 100;
  opacity: 0.502;
}

.patientstable_sec thead,
tbody,
tfoot,
tr,
td,
th {
  border: 0 !important;
}

.patientstable_sec thead {
  border: 2px solid #eaecee !important;
  border-left: unset !important;
  border-right: unset !important;
}

.patientstable_sec tbody tr td:last-child {
  padding: 5px;
  display: flex;
  gap: 10px;
}

.patientstable_sec tbody tr td:last-child button {
  border: 1px solid #354959;
  border-radius: 5px;
  background-color: unset;
}

.dashpatient_wrap {
  width: 65%;
}

.dashdoctor_wrap {
  width: 35%;
}

.dashbottom_wrap {
  float: left;
  width: 100%;
  display: flex;
}

.patientstable_sec thead tr th {
  padding: 0.8rem 0.5rem;
}

.hospital-drop {
  width: 250px;
}

.headersearch_section input[type=text] {
  width: 70%;
  border: unset;
  font-size: 18px;
  outline: unset;
}

.headersearch_section {
  width: 100%;
  padding-left: 3em;
  position: relative;
}

.headersearch_wrap {
  width: 78%;
}

.headersearch_section svg {
  position: absolute;
  left: 10px;
  top: -2px;
  font-size: 30px;
}

.headersearch_section svg {
  fill: #354959;
  opacity: 0.702;
}

.headernotify_section svg {
  font-size: 40px;
}

.headernotify_section path {
  fill: #354959;
}

.headernotify_section {
  position: relative;
}

.headernotify_section:after {
  content: "";
  position: absolute;
  top: 1px;
  right: 5px;
  width: 0.75em;
  height: 0.75em;
  border-radius: 50%;
  background-color: #3c7546;
}

.headernotify_section:before {
  content: "";
  position: absolute;
  top: 1px;
  right: 5px;
  width: 0.75em;
  height: 0.75em;
  border-radius: 50%;
  background-color: #3c7546;
}

.headernotify_section::before {
  animation: ping 1.7s ease infinite;
  opacity: 0.7;
}

/****doctorpage****/
.panel_top_section {
  border-bottom: 2px solid #eee;
  padding-bottom: 1.3em;
}
.panel_top_section h1, .panel_top_section .h1 {
  color: #354959;
  font-size: 28px;
  display: inline-block;
  padding-top: 4px;
}
.panel_top_section .btn_gradian {
  height: 43px;
  border-radius: 10px;
}

.grid_list_icons span {
  color: #939ea8;
  cursor: pointer;
  padding: 0;
}

.docotr_innder_section {
  border-radius: 15px;
  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));
}

.doctor_image img {
  width: 116px;
  height: 116px;
  object-fit: cover;
  border-radius: 50%;
}

.doctor_detail h4, .doctor_detail .h4 {
  font-size: 18px;
  line-height: 31px;
  font-family: "Poppins-Bold";
}
.doctor_detail p {
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 17px;
  margin-bottom: 10px;
  color: #354959;
}
.doctor_detail ul {
  padding: 0 1em;
  text-align: left;
  margin-bottom: 10px;
}
.doctor_detail ul li {
  list-style-type: none;
  gap: 15px;
  padding: 5px 0 5px;
  align-items: center;
}
.doctor_detail ul P {
  margin: 0;
  display: inline;
}
.doctor_detail ul a {
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 17px;
  color: #354959;
  text-decoration: none;
}
.doctor_detail ul span {
  display: inline-block;
  margin-right: 5px;
}

.profossional span {
  min-width: 156px;
  height: 27px;
  border-radius: 5px;
  color: #3c7546;
  background-color: #cce9ec;
  display: inline-block;
  font-size: 15px;
  line-height: 29px;
  font-family: "Poppins";
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  padding: 0 10px;
}

.delete_btn {
  min-width: 153px;
  height: 36px;
  border-radius: 5px;
  background-color: #b8bfc5;
  border: 0;
  color: #fff;
  margin: 5px;
  cursor: pointer;
}

.card_bottom {
  display: flex;
}

.btn_gradian {
  min-width: 153px;
  height: 36px;
  border-radius: 5px;
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
  border: 0;
  color: #fff;
  margin: 5px;
  cursor: pointer;
  padding: 0 15px;
  transition: 0.5s;
}

.sidebar-active {
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%) !important;
  border-radius: 3rem;
}

.btn_gradian_disabled {
  min-width: 153px;
  height: 36px;
  border-radius: 5px;
  border: 0;
  margin: 5px;
  padding: 0 15px;
}

.notification-body {
  font-size: 13px;
}

.btn_gradian:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  background-image: linear-gradient(to right, #335539, #3c7546);
}

.delet_patiens {
  min-width: 50px;
  height: 42px;
  border-radius: 7px;
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
  border: 0;
  color: #fff;
}

.dark_btn {
  background-image: unset;
  background-color: #354959;
}

@keyframes ping {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/****listpage***/
.list_head {
  background-color: #e5f5ec;
  text-align: center;
}
.list_head th {
  padding: 1.5em 1em;
}

tr.list_detail:hover {
  background-color: #e5f5ec;
  cursor: pointer;
  transition: 0.5s;
}

tr.list_detail.active {
  background-color: #e5f5ec;
}

.list_detail {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #eee !important;
  transition: 0.5s;
}
.list_detail td {
  padding: 15px 10px 15px;
  font-size: 15px;
}
.list_detail p {
  margin: 0;
  display: inline-block;
  padding-left: 15px;
}
.list_detail a {
  color: #3c7546;
  text-decoration: none;
}
.list_detail td span img {
  width: 63px;
  height: 63px;
  object-fit: cover;
  border-radius: 31px;
  filter: drop-shadow(9.962px 0.872px 9px rgba(0, 0, 0, 0.11));
}
.list_detail .dost_btn {
  width: 37px;
  height: 36px;
  background-color: #eaecee;
  display: inline-block;
  line-height: 37px;
  border-radius: 50%;
}

.action {
  width: 112px;
  height: 36px;
  background-color: #eaecee;
  display: inline-block;
  line-height: 37px;
  border-radius: 18px;
  text-align: center;
}
.action button {
  border: 0;
  background-color: transparent;
}

.refill-action {
  display: flex;
  gap: 10px;
}
.refill-action button {
  border-radius: 5px;
  border: none;
  font-size: 18px;
}
.refill-action .accept-btn {
  background-color: #d9eff1;
  color: #3c7546;
}
.refill-action .reject-btn {
  background-color: #e0e4e7;
  color: #677782;
}

.drop_list {
  transform: scale(0.1);
  opacity: 0;
  transition: 0.5s;
  top: 100%;
}

.toast-header .btn-close {
  color: #fff;
}

.three_dots:hover .drop_list {
  transform: scale(1);
  opacity: 1;
  transition: 0.5s;
}

.exclamation_btn:hover .drop_list {
  transform: scale(1);
  opacity: 1;
  transition: 0.5s;
}

.pagination_list ul {
  padding: 0;
  margin: 0;
}
.pagination_list li {
  display: inline-block;
  padding: 10px 5px;
}
.pagination_list a {
  width: 31px;
  height: 31px;
  border-radius: 16px;
  display: inline-block;
  line-height: 31px;
  color: #000;
}
.pagination_list .active a {
  background-color: #059fac;
  color: #fff;
}

/***doctor-detail***/
.doctore_detail_wrap {
  border-radius: 17px;
  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));
  background-color: #fff;
  margin: 2em 0 2em;
  float: left;
  width: 100%;
}

.doctor_detail_image {
  border-radius: 15px;
  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));
  background-color: #f2f3f7;
}
.doctor_detail_image img {
  border-radius: 15px;
  height: 277px;
  object-fit: cover;
  width: 100%;
}

.doctor_detail_page {
  float: left;
  width: 100%;
}
.doctor_detail_page ul {
  padding: 0;
}
.doctor_detail_page ul h5, .doctor_detail_page ul .h5 {
  font-size: 15px;
  line-height: 20px;
  color: #3c7546;
  margin: 0;
}
.doctor_detail_page ul li {
  list-style-type: none;
  float: left;
  width: 100%;
  padding: 5px 0 5px;
}
.doctor_detail_page ul a {
  color: #354959;
  font-size: 12px;
  text-decoration: none;
}
.doctor_detail_page ul P {
  margin-bottom: 5px;
  font-size: 12px;
}
.doctor_detail_page ul .right_box {
  width: 75%;
  padding-left: 10px;
}

.doctor_right_block h1, .doctor_right_block .h1 {
  font-size: 25px;
  line-height: 31px;
  color: #354959;
  font-family: "Poppins-Bold";
}
.doctor_right_block p {
  font-size: 15px;
  letter-spacing: 0px;
  line-height: 28px;
  color: #354959;
  margin-top: 1em;
}

.doctor_right_top {
  border-bottom: 1px solid #ccc;
}

.col-right {
  text-align: right;
}
.col-right button {
  border: 0;
  width: 40px;
  height: 40px;
  margin-left: 10px;
  border-radius: 20px;
  margin-top: 5px;
}
.col-right .dots_btn {
  position: relative;
}
.col-right .dots_btn button {
  background-color: #fff;
}
.col-right .dots_btn :after {
  content: "";
  display: inline-block;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background-color: #fff;
  width: 10px;
  height: 9px;
  position: absolute;
  right: 15px;
  top: -8px;
}

.drop_list {
  position: absolute;
  right: 0px;
  top: 43px;
  filter: drop-shadow(4.532px 2.113px 6.5px rgba(53, 73, 89, 0.19));
  border-radius: 4px;
  min-width: 70px;
  z-index: 1;
}
.drop_list li {
  font-size: 14px;
  line-height: 22px;
  color: #354959;
  list-style-type: none;
  display: block;
  text-align: left;
}
.drop_list a {
  color: #354959;
  text-decoration: none;
}
.drop_list :after {
  content: "";
  display: inline-block;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  background-color: #fff;
  width: 10px;
  height: 9px;
  position: absolute;
  right: 0px;
  top: -8px;
}

.add_pdf {
  min-width: 200px;
}

.sigCanvas {
  width: 100%;
  border: 1px solid black;
}

/***add-docor-page***/
.card_box {
  border-radius: 15px;
  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));
  background-color: #fff;
}

.form-control {
  height: 44px;
}

.form-control.multiple_choose {
  height: auto;
  min-height: 64px;
}

.textarea_input.form-control {
  height: 63px;
}

.form-select {
  height: 44px;
}

.add_doctor_fom p {
  font-family: "Poppins-Medium";
}

.upload_btn {
  display: inline-block;
  width: 170px;
  height: 47px;
  border-radius: 10px;
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
  font-size: 18px;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
  line-height: 47px;
}

.up_arrow {
  font-size: 44px;
  padding-top: 4px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.form_bottom_btn button {
  height: 43px;
  border-radius: 10px;
}

/****patient_detail_page***/
.pateint_profile img {
  width: 113px;
  height: 100px;
  border-radius: 15px;
  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));
  background-color: #f2f3f7;
}

.tab_navigation li {
  border-bottom: 1px solid transparent;
}

.tab_navigation li.active {
  border-bottom: 1px solid #00929f;
}

.location_map img {
  height: 200px;
  object-fit: cover;
}

.location_map_image img {
  height: 412px;
  object-fit: cover;
}

.list_head.billing_head {
  text-align: left;
}
.list_head.billing_head th {
  padding: 1.5em 0.5em;
  font-size: 14px;
  text-align: left;
}

.list_detail.billing_detail td {
  padding: 1.5em 0.5em;
  font-size: 14px;
}

.po_pending {
  min-width: 90px;
}

.percentage {
  background-color: #33a8b2;
}

.demo_card {
  position: relative;
  top: -5em;
  margin-bottom: -4em;
}

.payment_request {
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
}

.payment_button button {
  padding: 12px 0 12px;
  font-size: 20px;
  text-transform: uppercase;
  border-radius: 10px;
}

.card_details {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 1em 3em;
}

.card_type {
  text-align: right;
}

.select_drop_down {
  color: #939ea8 !important;
}
.select_drop_down option {
  color: #354959;
}

.payment_tab {
  margin-bottom: 2em;
}

.payment_tab ul {
  border-radius: 34px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
}

.payment_tab ul li {
  text-align: center;
  display: inline-block;
  float: left;
  width: 48%;
  border-radius: 40px;
}

.payment_tab ul li .nav-link {
  font-size: 20px;
  text-transform: uppercase;
  color: #ffffff;
  font-weight: 600;
  display: flex;
  height: 65px;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  background-color: #00929f;
}

.payment_tab ul li .nav-link.active {
  background-color: #354959;
}

.service_tab {
  margin-bottom: 1em;
}

.service_tab ul {
  background-color: #ffffff;
  display: flex;
  align-items: center !important;
}

.service_tab ul li {
  text-align: center;
  display: inline-block;
  width: 48%;
  border-radius: 40px;
}

.service_tab ul li .nav-link {
  /* text-transform: uppercase; */
  color: #ffffff;
  font-weight: 600;
  display: flex;
  /* height: 65px; */
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  background-color: #00929f;
  padding: 5px;
}

.service_tab ul li .nav-link.active {
  background-color: #354959;
}

.chat-users {
  height: 400px;
  max-height: 400px;
}

/***calend-style***/
.calender_block .react-calendar {
  width: 100%;
  border-radius: 15px;
  border: 0;
}

.calender_block .react-calendar__navigation {
  background-color: #354959;
}

.calender_block .react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #00929f;
}

.calender_block .react-calendar__month-view__weekdays__weekday {
  font-size: 17px;
  letter-spacing: 0px;
  line-height: 17px;
  color: #354959;
  font-family: "Poppins-Medium";
}

.calender_block .react-calendar__month-view__weekdays__weekday abbr[title] {
  text-decoration: none;
}

.calender_block .react-calendar button {
  color: #354959;
  font-size: 16px;
  line-height: 20px;
}

.calender_block.doctor_calender .react-calendar button {
  border-radius: 36px;
}

.calender_block.doctor_calender .react-calendar button {
  font-size: 17px;
  line-height: 32px;
  overflow: unset !important;
  position: relative;
}

.cal_count {
  position: absolute;
  right: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border-radius: 18px;
  color: #ffffff;
  background-color: #00929f;
  font-size: 11px;
  line-height: 18px;
}

.calender_block .react-calendar__month-view {
  padding-bottom: 10px;
}

.calender_block .react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1.28em 0.5em;
}

.calender_block .react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1.28em 0.5em;
}

.calender_block .react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1.28em 0.5em;
}

.calender_block .react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: #00929f;
  color: #fff;
}

.calender_block .react-calendar__tile--now {
  background: #00929f;
  color: #fff !important;
  background: unset;
  color: #000 !important;
  border: 1px solid #00929f;
}

.calender_block .react-calendar__tile--active {
  background: #00929f;
  color: #fff !important;
}

.calender_block .react-calendar__viewContainer {
  padding: 0 20px;
}

.calender_block .react-calendar button {
  border-radius: 20px;
}

.calender_block .react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #00929f !important;
  color: #fff;
}

.calender_block .react-calendar__tile--hasActive {
  background: #cce9ec;
  color: #354959 !important;
}

.calender_block .react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #354959;
}

.calender_block .react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #00929f;
  color: #ffffff !important;
}

.calender_block .react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1.28em 0.5em !important;
}

.react-calendar__tile:disabled {
  background-color: #fff !important;
  opacity: 0.5;
}

.calender_block .react-calendar__navigation {
  display: flex;
  height: 65px;
  margin-bottom: 1em;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  overflow: hidden;
}
.calender_block .react-calendar__navigation button {
  min-width: 44px;
  background: none;
  font-size: 20px;
  letter-spacing: 0px;
  line-height: 17px;
  color: #ffffff;
  font-family: "Poppins";
  border-radius: 0 !important;
}

.local-participant {
  position: absolute;
  z-index: 1;
  bottom: 10px;
  right: 20px;
}

.participants {
  position: relative;
  width: 640px;
}

.call_attend {
  transform: rotate(135deg);
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button {
  font-size: 0 !important;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button:after {
  content: "\\f284";
  font-family: bootstrap-icons !important;
  font-size: 17px;
  line-height: 33px;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button {
  font-size: 0 !important;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button:after {
  content: "\\f285";
  font-family: bootstrap-icons !important;
  font-size: 17px;
  line-height: 33px;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button {
  font-size: 0 !important;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button:after {
  content: "\\f280";
  font-family: bootstrap-icons !important;
  font-size: 17px;
  line-height: 33px;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button {
  font-size: 0 !important;
}

.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button:after {
  content: "\\f27f";
  font-family: bootstrap-icons !important;
  font-size: 17px;
  line-height: 33px;
}

.date_btn button {
  border-radius: 5px;
  background-color: #fff;
  border: 2px solid #3c7546;
  padding: 7px 10px;
  margin: 5px 7px;
  color: #3c7546;
  min-width: 125px;
  text-align: center;
}
.date_btn .active {
  background-color: #3c7546;
  color: #fff;
}

.attachment span {
  vertical-align: middle;
}

.app_content p {
  margin: 0;
}

.treatment p {
  text-align: justify;
  line-height: 23px;
}

/***message***/
.user_chat_img img {
  width: 65px;
  height: 65px;
  border-radius: 5px;
  object-fit: cover;
}

.user_chat:hover {
  background-color: #e5f5ec;
  transition: 0.5s;
}

.user_chat:hover .chat_group {
  border-color: transparent !important;
}

.user_chat:last-child .chat_group {
  border-color: transparent !important;
}

.count {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #00929f;
  line-height: 20px;
  font-size: 12px;
}

.col-right.chat_tools button {
  width: 27px;
  height: 27px;
  font-size: 12px;
  margin-left: 5px;
}

.clickable {
  cursor: pointer;
}

.chat_send {
  border-radius: 8px;
  border-bottom-right-radius: 0 !important;
}

.chat_receive {
  border-radius: 8px;
  border-bottom-left-radius: 0 !important;
}

.message_box .inner_location {
  min-height: 100%;
}

.chat_message.custom_scroll {
  height: 17vw;
  overflow-y: scroll;
}

.chat_height.custom_scroll {
  height: 21vw;
  overflow-y: scroll;
}

.left_user.custom_scroll {
  height: 23.4vw;
  overflow-y: scroll;
}

/* width */
.custom_scroll::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
.custom_scroll::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

/* Handle */
.custom_scroll::-webkit-scrollbar-thumb {
  background: #e5f5ec;
}

/* Handle on hover */
.custom_scroll::-webkit-scrollbar-thumb:hover {
  background: #cce9ec;
}

.patient_info_profile img {
  width: 155px;
  height: 145px;
  border-radius: 5px;
  background-color: #f2f3f7;
  object-fit: cover;
}

.post_image img {
  width: 88px;
  height: 88px;
  border-radius: 5px;
  background-color: #f2f3f7;
  object-fit: cover;
}

.online {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: 1px solid #fff;
  right: 30px;
  bottom: -5px !important;
}

.online1 {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: 1px solid #fff;
  right: -5px;
  bottom: -5px !important;
}

.post_pdf span {
  vertical-align: middle;
}

.user_chat_img.chat_detail_img img {
  width: 30px;
  height: 28px;
  border-radius: 50% !important;
  background-color: #f2f3f7;
}

.user_chat_img.chat_detail_img span {
  width: 30px;
  height: 28px;
  border-radius: 50% !important;
  background-color: #f2f3f7;
  display: inline-block;
}

.chat_msg_content p {
  font-size: 15px;
  letter-spacing: 0px;
  line-height: 28px;
  color: #354959;
  margin-bottom: 20px;
}

.regards p {
  margin: 0;
}

.chat_message.chat_msg_content.custom_scroll {
  height: 610px;
}

.chat_tab button {
  background-color: #f2f3f7;
}
.chat_tab .active {
  background-color: #fff;
  color: #3c7546;
}

.tele_messgage {
  height: 365px;
  overflow-y: scroll;
}

.user_chat:hover .send_btn {
  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);
  transition: 0.5s;
}

.left_refil {
  height: 512px;
  overflow-y: scroll;
}

.map {
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
}

.select_pharmacy {
  border: 1px solid #3c7546 !important;
  color: #939ea8 !important;
}

.user_ {
  outline: none !important;
  border: 0 !important;
}

.sidebar_left span {
  opacity: 0.8;
  color: #333333;
}

.sidebar_left .active {
  background-color: #cce9ec !important;
  color: #3c7546;
}

.sidebar_left .active i {
  color: #3c7546;
}

.switch_toggle .form-switch .form-check-input:checked {
  background-color: #cce9ec !important;
}

.switch_toggle .form-switch .form-check-inputt {
  background-color: #c2c8cd !important;
  height: 22px;
  width: 52px;
}

.switch_toggle .form-check-input:focus {
  border-color: #b2dee2;
  outline: 0;
  box-shadow: unset;
}

.switch {
  position: absolute;
  display: inline-block;
  width: 54px;
  height: 22px;
  left: -30px;
  top: 6px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c2c8cd;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 30px;
  width: 30px;
  left: -1px;
  bottom: -4px;
  background-color: white;
  transition: 0.4s;
  border: 1px solid #c2c8cd;
}

input:checked + .slider {
  background-color: #b2dee2;
}

input:focus + .slider {
  box-shadow: 0 0 1px #b2dee2;
}

input:checked + .slider:before {
  transform: translateX(26px);
  background-color: #00929f;
}

/* Rounded sliders */
.slider.round_toggle {
  border-radius: 34px;
}

.slider.round_toggle:before {
  border-radius: 50%;
}

.vidoe_button button {
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background-color: rgba(0, 0, 0, 0.38);
  border: 0;
  margin: 0 10px;
  color: #fff;
  font-size: 21px;
  transition: 0.5s;
}
.vidoe_button button:hover {
  background-color: #008b89;
  transition: 0.5s;
}

.time_record {
  background-color: rgba(0, 0, 0, 0.46);
}

.small_video {
  position: absolute;
  bottom: 20px;
  right: 23px;
}
.small_video img {
  width: 136px;
  height: 154px;
  border-radius: 15px;
  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));
  background-color: #ffffff;
  object-fit: cover;
}

/** File Renderer **/
.file-details-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.name-container .file-size {
  font-size: 11px;
}

.download-btn {
  margin-left: auto;
}

/***admin-setting***/
.admin_setting .inner_location {
  min-height: 785px;
}

.type_check_box {
  border: 2px solid #00929f;
}

.type_check_box .form-type_control {
  border: 0;
  border-bottom: 2px solid #00929f;
  outline: none;
}

.admin_input .edit_btn {
  width: 40px;
  height: 128px;
  border-radius: 21px;
  filter: drop-shadow(4.532px 2.113px 12px rgba(53, 73, 89, 0.24));
  right: -38px;
  top: -4px;
}

.switch.check_switch_box {
  left: auto;
  right: 0;
  width: 40px;
  height: 15px;
}

.check_switch_box .slider:before {
  height: 20px;
  width: 20px;
  bottom: -2px;
  left: -4px;
}

.type_check_box input[type=date] {
  border: 1px solid #00929f !important;
}

.admin_calender .react-calendar {
  width: 100%;
}

.admin_calender .react-calendar__navigation {
  background-color: #fff;
  color: #354959;
  font-size: 15px;
}

.admin_calender abbr[title] {
  -webkit-text-decoration: none;
  text-decoration: none;
  font-family: "Poppins-Medium";
}

.admin_calender .react-calendar__tile--active {
  background: #cce9ec;
  color: #354959;
}

.admin_calender .react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #cce9ec !important;
  color: #354959 !important;
}

.admin_calender .react-calendar__tile--now {
  background: #3c7546;
  color: #fff;
  border-radius: 26px;
}

.admin_calender .react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #3c7546;
}

.admin_calender .react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #3c7546 !important;
}

.admin_calender .react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background: #3c7546 !important;
  color: #fff !important;
}

.admin_calender .react-calendar__tile {
  font-family: "Poppins-Regular";
  border-radius: 26px;
}

.admin_calender .react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
  padding: 1em 0.5em;
}

.admin_calender .react-calendar {
  border: 1px solid #eee;
  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));
}

.react-calendar__month-view__days__day--weekend {
  color: #d10000;
}

/******doctor-level*****/
.recentappoint_doctor span {
  display: inline-block;
  width: 23px;
  height: 23px;
  border-radius: 12px;
  text-align: center;
  font-size: 11px;
  line-height: 26px;
  color: #354959;
  background-color: #b8bfc5;
  text-transform: uppercase;
}

.billing_sec .recentappoint_doctor {
  display: flex;
  align-items: center;
  gap: 3px;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
}

.billing_sec .recentappoint_doctor .recentappoint_name p {
  font-size: 13px;
  line-height: 31px;
  color: #354959;
  opacity: 1;
  display: inline-block;
}

.billing_sec .recentappoint_doctor .recentappoint_name strong {
  font-size: 13px;
}

.billing_sec .recentappoint_doctor .recentappoint_name {
  display: flex;
  gap: 5px;
  align-items: center;
}

.close_btn {
  opacity: 0.502;
  width: 21px;
  height: 20px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #343a40;
  padding: 0;
  font-size: 14px;
}

.check_btn {
  width: 21px;
  height: 20px;
  border-radius: 5px;
  background-color: #ffffff;
  border: 1px solid #3c7546;
  padding: 0;
  color: #3c7546;
  line-height: 20px;
}

.user_chat:hover .user_chat_detail span {
  color: #3c7546;
}

.user_chat_img.patient_chat_img img {
  width: 101px;
  height: 101px;
  border-radius: 51px;
  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));
  background-color: #333333;
}

.patient_enquiery button {
  border: 1px solid #00929f;
}

.dost_btn:hover .show_option {
  transform: scale(1);
  transition: 0.5s;
}

.vidoe_large_img img {
  height: 535px;
  object-fit: cover;
  width: 100%;
}

/****staff-dashoboard****/
.staff_graph img {
  height: 280px;
  object-fit: cover;
}

.location_map_staff img {
  height: 230px;
  object-fit: cover;
}

.filter_blur {
  opacity: 0.502;
}

.filter_right {
  filter: blur(3px);
}

.requested_access {
  z-index: 2;
}

/***break-poinst***/
@media (max-width: 1200px) {
  .border-r {
    border-right: 0 !important;
    border-bottom: 1.8px solid #ccc !important;
  }
  .demo_card {
    top: 0;
    margin-bottom: 0;
  }
  .headersearch_wrap {
    width: 75%;
  }
  .headernotify_section svg {
    font-size: 30px;
  }
  .login_img {
    max-width: 40px;
  }
  .headersearch_wrap {
    width: 68%;
  }
  .headersearch_section svg {
    font-size: 20px;
    margin-top: 6px;
  }
  .headersearch_section {
    padding-left: 2.5em;
  }
  .headersearch_section input[type=text] {
    width: 80%;
  }
  .user_login {
    padding-right: 0;
    gap: 0 !important;
  }
  .admin_setting .inner_location {
    min-height: auto;
  }
  .user_chat_img.patient_chat_img img {
    height: 75px;
    width: 100px;
  }
  .left_user.custom_scroll {
    height: 400px;
    overflow-y: scroll;
  }
  .user_chat_img img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    object-fit: cover;
    margin-bottom: 10px;
  }
  .online1 {
    bottom: 10px !important;
  }
  .chat_message.custom_scroll {
    height: 400px;
    overflow-y: scroll;
  }
  .chat_height.custom_scroll {
    height: 380px;
    overflow-y: scroll;
  }
}
@media (max-width: 576px) {
  .wrapper.container-fluid, .wrapper.container-xxl, .wrapper.container-xl, .wrapper.container-lg, .wrapper.container-md, .wrapper.container-sm {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
  .headersearch_section svg {
    font-size: 20px;
  }
  .delete_btn {
    min-width: 115px;
  }
  .btn_gradian {
    min-width: 115px;
  }
  .panel_top_section h1,
  .panel_top_section .h1 {
    font-size: 26px;
  }
  .sidebarArea {
    margin-left: -324px;
  }
  .list_detail p {
    padding-left: 0;
    font-size: 14px;
    padding-top: 10px;
  }
  .panel_top_section .btn_gradian {
    min-width: auto;
    font-size: 14px;
  }
  .icons_patients {
    right: 0;
    top: -5px;
  }
  .list_head th {
    min-width: 150px;
  }
  .appointment_table table tr td {
    min-width: 118px;
    width: 100%;
    padding: 10px !important;
    font-size: 14px;
  }
  .list_detail_new td {
    min-width: 118px;
    width: 100%;
  }
  .list_detail_new th {
    min-width: 118px;
    width: 100%;
  }
  .record_img a img {
    max-width: 20px;
  }
  .record_img {
    display: flex;
  }
  .full_width {
    width: 100%;
  }
  .upload_delete {
    position: absolute;
    right: 10px;
    left: auto !important;
    text-align: right;
  }
  .user_chat_detail p {
    font-size: 14px !important;
  }
  .user_chat_detail span {
    font-size: 14px !important;
  }
  .vidoe_large_img img {
    height: 300px;
  }
  .small_video img {
    width: 80px;
    height: 100px;
  }
  .vidoe_button button {
    width: 35px;
    height: 33px;
    border: 0;
    font-size: 16px;
  }
  .mobile-search-icon.d-none {
    display: block !important;
  }
  .mobile-logo.d-none {
    display: block !important;
  }
  .headersearch_section {
    display: none !important;
  }
  .mobile-search-icon.d-none input {
    position: absolute;
    bottom: -45px;
    left: 0;
  }
  .mobile-search-icon.d-none svg {
    font-size: 28px;
    cursor: pointer;
  }
  .header-nav .container-fluid, .header-nav .container-xxl, .header-nav .container-xl, .header-nav .container-lg, .header-nav .container-md, .header-nav .container-sm {
    flex-wrap: nowrap !important;
  }
  .header-nav button.user_login {
    padding: 0 !important;
  }
  .header-nav .align-items-center {
    justify-content: space-between !important;
  }
  nav.header-nav {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .table-responsive,
  .table-responsive.m-0 {
    margin-top: 35px !important;
  }
  input#search_input {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
  }
  .panel_top_section {
    position: relative;
  }
  .header-profile {
    display: none;
  }
  .grid_icons.float-end {
    margin: 0 auto;
    float: unset !important;
    justify-content: space-between;
  }
  .headersearch_wrap {
    width: 100%;
    padding-left: 15px;
  }
  .billing-container input#search_input {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2em;
    width: 100%;
  }
  .appointment-container input#search_input {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -17em;
    width: 100%;
  }
  .appointment-container {
    padding-bottom: 10px;
  }
  .table-responsive.m-0.appoint {
    margin-top: 50px !important;
  }
  .payment_tab ul li .nav-link {
    font-size: 13px;
    height: 45px;
  }
  .service_tab ul li .nav-link {
    font-size: 13px !important;
    height: 45px;
  }
  .payment-method {
    padding: 30px !important;
  }
  .order-number {
    font-size: 13px;
  }
  .pat_group.py-2.d-flex {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
  }
  .d-flex.justify-content-between.mt-2 {
    font-size: 15px;
  }
  .btn_gradian {
    font-size: 12px;
  }
  .popup {
    width: 100% !important;
  }
  .grid_icons.float-end.billing-filter {
    margin: 0 auto;
    float: right !important;
    justify-content: space-between;
  }
  .patient-ques {
    font-size: 14px;
  }
  .ques-title {
    font-size: 20px !important;
  }
  .invoice-header-text {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .dropdown-menu.show {
    display: block;
    width: 100%;
    float: left;
  }
  .header-dropdown {
    position: absolute !important;
    bottom: -45px;
    left: 5px;
    /* z-index: 1; */
    width: 100%;
    float: left;
    right: 0;
    margin: 0 auto;
  }
}
@media (max-width: 992px) {
  .hospital-drop {
    width: 300px;
  }
}
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #2962ff;
  --bs-secondary: #35363b;
  --bs-success: #0bb7af;
  --bs-info: #3699ff;
  --bs-warning: #ee9d01;
  --bs-danger: #f64e60;
  --bs-light: #eaf2fb;
  --bs-dark: #343a40;
  --bs-light-primary: #d6e4f3;
  --bs-light-success: #d5f3f2;
  --bs-light-info: #d3edfa;
  --bs-light-warning: #f8ecdc;
  --bs-light-danger: #f8dddd;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: "Poppins";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0px rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #2962ff;
  --bs-btn-border-color: #2962ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(34.85, 83.3, 216.75);
  --bs-btn-hover-border-color: rgb(32.8, 78.4, 204);
  --bs-btn-focus-shadow-rgb: 73, 122, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(32.8, 78.4, 204);
  --bs-btn-active-border-color: rgb(30.75, 73.5, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2962ff;
  --bs-btn-disabled-border-color: #2962ff;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #35363b;
  --bs-btn-border-color: #35363b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(45.05, 45.9, 50.15);
  --bs-btn-hover-border-color: rgb(42.4, 43.2, 47.2);
  --bs-btn-focus-shadow-rgb: 83, 84, 88;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(42.4, 43.2, 47.2);
  --bs-btn-active-border-color: rgb(39.75, 40.5, 44.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #35363b;
  --bs-btn-disabled-border-color: #35363b;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0bb7af;
  --bs-btn-border-color: #0bb7af;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(9.35, 155.55, 148.75);
  --bs-btn-hover-border-color: rgb(8.8, 146.4, 140);
  --bs-btn-focus-shadow-rgb: 48, 194, 187;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(8.8, 146.4, 140);
  --bs-btn-active-border-color: rgb(8.25, 137.25, 131.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0bb7af;
  --bs-btn-disabled-border-color: #0bb7af;
}

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #3699ff;
  --bs-btn-border-color: #3699ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(45.9, 130.05, 216.75);
  --bs-btn-hover-border-color: rgb(43.2, 122.4, 204);
  --bs-btn-focus-shadow-rgb: 84, 168, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(43.2, 122.4, 204);
  --bs-btn-active-border-color: rgb(40.5, 114.75, 191.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3699ff;
  --bs-btn-disabled-border-color: #3699ff;
}

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #ee9d01;
  --bs-btn-border-color: #ee9d01;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(202.3, 133.45, 0.85);
  --bs-btn-hover-border-color: rgb(190.4, 125.6, 0.8);
  --bs-btn-focus-shadow-rgb: 241, 172, 39;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(190.4, 125.6, 0.8);
  --bs-btn-active-border-color: rgb(178.5, 117.75, 0.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #ee9d01;
  --bs-btn-disabled-border-color: #ee9d01;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f64e60;
  --bs-btn-border-color: #f64e60;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(209.1, 66.3, 81.6);
  --bs-btn-hover-border-color: rgb(196.8, 62.4, 76.8);
  --bs-btn-focus-shadow-rgb: 247, 105, 120;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(196.8, 62.4, 76.8);
  --bs-btn-active-border-color: rgb(184.5, 58.5, 72);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f64e60;
  --bs-btn-disabled-border-color: #f64e60;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eaf2fb;
  --bs-btn-border-color: #eaf2fb;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(198.9, 205.7, 213.35);
  --bs-btn-hover-border-color: rgb(187.2, 193.6, 200.8);
  --bs-btn-focus-shadow-rgb: 199, 206, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(187.2, 193.6, 200.8);
  --bs-btn-active-border-color: rgb(175.5, 181.5, 188.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eaf2fb;
  --bs-btn-disabled-border-color: #eaf2fb;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);
  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-focus-shadow-rgb: 82, 88, 93;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);
  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #343a40;
  --bs-btn-disabled-border-color: #343a40;
}

.btn-light-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #d6e4f3;
  --bs-btn-border-color: #d6e4f3;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(220.15, 232.05, 244.8);
  --bs-btn-hover-border-color: rgb(218.1, 230.7, 244.2);
  --bs-btn-focus-shadow-rgb: 182, 194, 207;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(222.2, 233.4, 245.4);
  --bs-btn-active-border-color: rgb(218.1, 230.7, 244.2);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d6e4f3;
  --bs-btn-disabled-border-color: #d6e4f3;
}

.btn-light-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #d5f3f2;
  --bs-btn-border-color: #d5f3f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(219.3, 244.8, 243.95);
  --bs-btn-hover-border-color: rgb(217.2, 244.2, 243.3);
  --bs-btn-focus-shadow-rgb: 181, 207, 206;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(221.4, 245.4, 244.6);
  --bs-btn-active-border-color: rgb(217.2, 244.2, 243.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d5f3f2;
  --bs-btn-disabled-border-color: #d5f3f2;
}

.btn-light-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #d3edfa;
  --bs-btn-border-color: #d3edfa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(217.6, 239.7, 250.75);
  --bs-btn-hover-border-color: rgb(215.4, 238.8, 250.5);
  --bs-btn-focus-shadow-rgb: 179, 201, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(219.8, 240.6, 251);
  --bs-btn-active-border-color: rgb(215.4, 238.8, 250.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d3edfa;
  --bs-btn-disabled-border-color: #d3edfa;
}

.btn-light-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8ecdc;
  --bs-btn-border-color: #f8ecdc;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(249.05, 238.85, 225.25);
  --bs-btn-hover-border-color: rgb(248.7, 237.9, 223.5);
  --bs-btn-focus-shadow-rgb: 211, 201, 187;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(249.4, 239.8, 227);
  --bs-btn-active-border-color: rgb(248.7, 237.9, 223.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8ecdc;
  --bs-btn-disabled-border-color: #f8ecdc;
}

.btn-light-danger {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8dddd;
  --bs-btn-border-color: #f8dddd;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(249.05, 226.1, 226.1);
  --bs-btn-hover-border-color: rgb(248.7, 224.4, 224.4);
  --bs-btn-focus-shadow-rgb: 211, 188, 188;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(249.4, 227.8, 227.8);
  --bs-btn-active-border-color: rgb(248.7, 224.4, 224.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8dddd;
  --bs-btn-disabled-border-color: #f8dddd;
}

.btn-outline-primary {
  --bs-btn-color: #2962ff;
  --bs-btn-border-color: #2962ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2962ff;
  --bs-btn-hover-border-color: #2962ff;
  --bs-btn-focus-shadow-rgb: 41, 98, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #2962ff;
  --bs-btn-active-border-color: #2962ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #2962ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #2962ff;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #35363b;
  --bs-btn-border-color: #35363b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #35363b;
  --bs-btn-hover-border-color: #35363b;
  --bs-btn-focus-shadow-rgb: 53, 54, 59;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #35363b;
  --bs-btn-active-border-color: #35363b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #35363b;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #35363b;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #0bb7af;
  --bs-btn-border-color: #0bb7af;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0bb7af;
  --bs-btn-hover-border-color: #0bb7af;
  --bs-btn-focus-shadow-rgb: 11, 183, 175;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0bb7af;
  --bs-btn-active-border-color: #0bb7af;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0bb7af;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0bb7af;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #3699ff;
  --bs-btn-border-color: #3699ff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3699ff;
  --bs-btn-hover-border-color: #3699ff;
  --bs-btn-focus-shadow-rgb: 54, 153, 255;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3699ff;
  --bs-btn-active-border-color: #3699ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3699ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3699ff;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ee9d01;
  --bs-btn-border-color: #ee9d01;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ee9d01;
  --bs-btn-hover-border-color: #ee9d01;
  --bs-btn-focus-shadow-rgb: 238, 157, 1;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ee9d01;
  --bs-btn-active-border-color: #ee9d01;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ee9d01;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ee9d01;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f64e60;
  --bs-btn-border-color: #f64e60;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f64e60;
  --bs-btn-hover-border-color: #f64e60;
  --bs-btn-focus-shadow-rgb: 246, 78, 96;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f64e60;
  --bs-btn-active-border-color: #f64e60;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f64e60;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f64e60;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eaf2fb;
  --bs-btn-border-color: #eaf2fb;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eaf2fb;
  --bs-btn-hover-border-color: #eaf2fb;
  --bs-btn-focus-shadow-rgb: 234, 242, 251;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eaf2fb;
  --bs-btn-active-border-color: #eaf2fb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eaf2fb;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eaf2fb;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #343a40;
  --bs-btn-border-color: #343a40;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343a40;
  --bs-btn-hover-border-color: #343a40;
  --bs-btn-focus-shadow-rgb: 52, 58, 64;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #343a40;
  --bs-btn-active-border-color: #343a40;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #343a40;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343a40;
  --bs-gradient: none;
}

.btn-outline-light-primary {
  --bs-btn-color: #d6e4f3;
  --bs-btn-border-color: #d6e4f3;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d6e4f3;
  --bs-btn-hover-border-color: #d6e4f3;
  --bs-btn-focus-shadow-rgb: 214, 228, 243;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d6e4f3;
  --bs-btn-active-border-color: #d6e4f3;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d6e4f3;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d6e4f3;
  --bs-gradient: none;
}

.btn-outline-light-success {
  --bs-btn-color: #d5f3f2;
  --bs-btn-border-color: #d5f3f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d5f3f2;
  --bs-btn-hover-border-color: #d5f3f2;
  --bs-btn-focus-shadow-rgb: 213, 243, 242;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d5f3f2;
  --bs-btn-active-border-color: #d5f3f2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d5f3f2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d5f3f2;
  --bs-gradient: none;
}

.btn-outline-light-info {
  --bs-btn-color: #d3edfa;
  --bs-btn-border-color: #d3edfa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3edfa;
  --bs-btn-hover-border-color: #d3edfa;
  --bs-btn-focus-shadow-rgb: 211, 237, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d3edfa;
  --bs-btn-active-border-color: #d3edfa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d3edfa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d3edfa;
  --bs-gradient: none;
}

.btn-outline-light-warning {
  --bs-btn-color: #f8ecdc;
  --bs-btn-border-color: #f8ecdc;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8ecdc;
  --bs-btn-hover-border-color: #f8ecdc;
  --bs-btn-focus-shadow-rgb: 248, 236, 220;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8ecdc;
  --bs-btn-active-border-color: #f8ecdc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8ecdc;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8ecdc;
  --bs-gradient: none;
}

.btn-outline-light-danger {
  --bs-btn-color: #f8dddd;
  --bs-btn-border-color: #f8dddd;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8dddd;
  --bs-btn-hover-border-color: #f8dddd;
  --bs-btn-focus-shadow-rgb: 248, 221, 221;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8dddd;
  --bs-btn-active-border-color: #f8dddd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8dddd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8dddd;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-light-primary {
  --bs-alert-color: var(--bs-light-primary-text-emphasis);
  --bs-alert-bg: var(--bs-light-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-light-primary-border-subtle);
  --bs-alert-link-color: var(--bs-light-primary-text-emphasis);
}

.alert-light-success {
  --bs-alert-color: var(--bs-light-success-text-emphasis);
  --bs-alert-bg: var(--bs-light-success-bg-subtle);
  --bs-alert-border-color: var(--bs-light-success-border-subtle);
  --bs-alert-link-color: var(--bs-light-success-text-emphasis);
}

.alert-light-info {
  --bs-alert-color: var(--bs-light-info-text-emphasis);
  --bs-alert-bg: var(--bs-light-info-bg-subtle);
  --bs-alert-border-color: var(--bs-light-info-border-subtle);
  --bs-alert-link-color: var(--bs-light-info-text-emphasis);
}

.alert-light-warning {
  --bs-alert-color: var(--bs-light-warning-text-emphasis);
  --bs-alert-bg: var(--bs-light-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-light-warning-border-subtle);
  --bs-alert-link-color: var(--bs-light-warning-text-emphasis);
}

.alert-light-danger {
  --bs-alert-color: var(--bs-light-danger-text-emphasis);
  --bs-alert-bg: var(--bs-light-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-light-danger-border-subtle);
  --bs-alert-link-color: var(--bs-light-danger-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-light-primary {
  --bs-list-group-color: var(--bs-light-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-light-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-light-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-primary-text-emphasis);
}

.list-group-item-light-success {
  --bs-list-group-color: var(--bs-light-success-text-emphasis);
  --bs-list-group-bg: var(--bs-light-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-success-border-subtle);
  --bs-list-group-active-color: var(--bs-light-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-success-text-emphasis);
}

.list-group-item-light-info {
  --bs-list-group-color: var(--bs-light-info-text-emphasis);
  --bs-list-group-bg: var(--bs-light-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-info-border-subtle);
  --bs-list-group-active-color: var(--bs-light-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-info-text-emphasis);
}

.list-group-item-light-warning {
  --bs-list-group-color: var(--bs-light-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-light-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-light-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-warning-text-emphasis);
}

.list-group-item-light-danger {
  --bs-list-group-color: var(--bs-light-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-light-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-light-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-danger-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light-primary {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light-success {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light-danger {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(33, 78, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(33, 78, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(42, 43, 47, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 43, 47, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(9, 146, 140, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(9, 146, 140, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(43, 122, 204, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(43, 122, 204, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(190, 126, 1, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(190, 126, 1, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(197, 62, 77, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(197, 62, 77, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(238, 245, 252, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(238, 245, 252, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light-primary {
  color: RGBA(var(--bs-light-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light-primary:hover, .link-light-primary:focus {
  color: RGBA(222, 233, 245, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(222, 233, 245, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light-success {
  color: RGBA(var(--bs-light-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light-success:hover, .link-light-success:focus {
  color: RGBA(221, 245, 245, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(221, 245, 245, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light-info {
  color: RGBA(var(--bs-light-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light-info:hover, .link-light-info:focus {
  color: RGBA(220, 241, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(220, 241, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light-warning {
  color: RGBA(var(--bs-light-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light-warning:hover, .link-light-warning:focus {
  color: RGBA(249, 240, 227, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 240, 227, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light-danger {
  color: RGBA(var(--bs-light-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light-danger:hover, .link-light-danger:focus {
  color: RGBA(249, 228, 228, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 228, 228, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * Bootstrap Icons v1.11.3 (https://icons.getbootstrap.com/)
 * Copyright 2019-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/icons/blob/main/LICENSE)
 */
@font-face {
  font-display: block;
  font-family: "bootstrap-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff");
}
.bi::before,
[class^=bi-]::before,
[class*=" bi-"]::before {
  display: inline-block;
  font-family: "bootstrap-icons" !important;
  font-style: normal;
  font-weight: normal !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bi-123::before {
  content: "\\f67f";
}

.bi-alarm-fill::before {
  content: "\\f101";
}

.bi-alarm::before {
  content: "\\f102";
}

.bi-align-bottom::before {
  content: "\\f103";
}

.bi-align-center::before {
  content: "\\f104";
}

.bi-align-end::before {
  content: "\\f105";
}

.bi-align-middle::before {
  content: "\\f106";
}

.bi-align-start::before {
  content: "\\f107";
}

.bi-align-top::before {
  content: "\\f108";
}

.bi-alt::before {
  content: "\\f109";
}

.bi-app-indicator::before {
  content: "\\f10a";
}

.bi-app::before {
  content: "\\f10b";
}

.bi-archive-fill::before {
  content: "\\f10c";
}

.bi-archive::before {
  content: "\\f10d";
}

.bi-arrow-90deg-down::before {
  content: "\\f10e";
}

.bi-arrow-90deg-left::before {
  content: "\\f10f";
}

.bi-arrow-90deg-right::before {
  content: "\\f110";
}

.bi-arrow-90deg-up::before {
  content: "\\f111";
}

.bi-arrow-bar-down::before {
  content: "\\f112";
}

.bi-arrow-bar-left::before {
  content: "\\f113";
}

.bi-arrow-bar-right::before {
  content: "\\f114";
}

.bi-arrow-bar-up::before {
  content: "\\f115";
}

.bi-arrow-clockwise::before {
  content: "\\f116";
}

.bi-arrow-counterclockwise::before {
  content: "\\f117";
}

.bi-arrow-down-circle-fill::before {
  content: "\\f118";
}

.bi-arrow-down-circle::before {
  content: "\\f119";
}

.bi-arrow-down-left-circle-fill::before {
  content: "\\f11a";
}

.bi-arrow-down-left-circle::before {
  content: "\\f11b";
}

.bi-arrow-down-left-square-fill::before {
  content: "\\f11c";
}

.bi-arrow-down-left-square::before {
  content: "\\f11d";
}

.bi-arrow-down-left::before {
  content: "\\f11e";
}

.bi-arrow-down-right-circle-fill::before {
  content: "\\f11f";
}

.bi-arrow-down-right-circle::before {
  content: "\\f120";
}

.bi-arrow-down-right-square-fill::before {
  content: "\\f121";
}

.bi-arrow-down-right-square::before {
  content: "\\f122";
}

.bi-arrow-down-right::before {
  content: "\\f123";
}

.bi-arrow-down-short::before {
  content: "\\f124";
}

.bi-arrow-down-square-fill::before {
  content: "\\f125";
}

.bi-arrow-down-square::before {
  content: "\\f126";
}

.bi-arrow-down-up::before {
  content: "\\f127";
}

.bi-arrow-down::before {
  content: "\\f128";
}

.bi-arrow-left-circle-fill::before {
  content: "\\f129";
}

.bi-arrow-left-circle::before {
  content: "\\f12a";
}

.bi-arrow-left-right::before {
  content: "\\f12b";
}

.bi-arrow-left-short::before {
  content: "\\f12c";
}

.bi-arrow-left-square-fill::before {
  content: "\\f12d";
}

.bi-arrow-left-square::before {
  content: "\\f12e";
}

.bi-arrow-left::before {
  content: "\\f12f";
}

.bi-arrow-repeat::before {
  content: "\\f130";
}

.bi-arrow-return-left::before {
  content: "\\f131";
}

.bi-arrow-return-right::before {
  content: "\\f132";
}

.bi-arrow-right-circle-fill::before {
  content: "\\f133";
}

.bi-arrow-right-circle::before {
  content: "\\f134";
}

.bi-arrow-right-short::before {
  content: "\\f135";
}

.bi-arrow-right-square-fill::before {
  content: "\\f136";
}

.bi-arrow-right-square::before {
  content: "\\f137";
}

.bi-arrow-right::before {
  content: "\\f138";
}

.bi-arrow-up-circle-fill::before {
  content: "\\f139";
}

.bi-arrow-up-circle::before {
  content: "\\f13a";
}

.bi-arrow-up-left-circle-fill::before {
  content: "\\f13b";
}

.bi-arrow-up-left-circle::before {
  content: "\\f13c";
}

.bi-arrow-up-left-square-fill::before {
  content: "\\f13d";
}

.bi-arrow-up-left-square::before {
  content: "\\f13e";
}

.bi-arrow-up-left::before {
  content: "\\f13f";
}

.bi-arrow-up-right-circle-fill::before {
  content: "\\f140";
}

.bi-arrow-up-right-circle::before {
  content: "\\f141";
}

.bi-arrow-up-right-square-fill::before {
  content: "\\f142";
}

.bi-arrow-up-right-square::before {
  content: "\\f143";
}

.bi-arrow-up-right::before {
  content: "\\f144";
}

.bi-arrow-up-short::before {
  content: "\\f145";
}

.bi-arrow-up-square-fill::before {
  content: "\\f146";
}

.bi-arrow-up-square::before {
  content: "\\f147";
}

.bi-arrow-up::before {
  content: "\\f148";
}

.bi-arrows-angle-contract::before {
  content: "\\f149";
}

.bi-arrows-angle-expand::before {
  content: "\\f14a";
}

.bi-arrows-collapse::before {
  content: "\\f14b";
}

.bi-arrows-expand::before {
  content: "\\f14c";
}

.bi-arrows-fullscreen::before {
  content: "\\f14d";
}

.bi-arrows-move::before {
  content: "\\f14e";
}

.bi-aspect-ratio-fill::before {
  content: "\\f14f";
}

.bi-aspect-ratio::before {
  content: "\\f150";
}

.bi-asterisk::before {
  content: "\\f151";
}

.bi-at::before {
  content: "\\f152";
}

.bi-award-fill::before {
  content: "\\f153";
}

.bi-award::before {
  content: "\\f154";
}

.bi-back::before {
  content: "\\f155";
}

.bi-backspace-fill::before {
  content: "\\f156";
}

.bi-backspace-reverse-fill::before {
  content: "\\f157";
}

.bi-backspace-reverse::before {
  content: "\\f158";
}

.bi-backspace::before {
  content: "\\f159";
}

.bi-badge-3d-fill::before {
  content: "\\f15a";
}

.bi-badge-3d::before {
  content: "\\f15b";
}

.bi-badge-4k-fill::before {
  content: "\\f15c";
}

.bi-badge-4k::before {
  content: "\\f15d";
}

.bi-badge-8k-fill::before {
  content: "\\f15e";
}

.bi-badge-8k::before {
  content: "\\f15f";
}

.bi-badge-ad-fill::before {
  content: "\\f160";
}

.bi-badge-ad::before {
  content: "\\f161";
}

.bi-badge-ar-fill::before {
  content: "\\f162";
}

.bi-badge-ar::before {
  content: "\\f163";
}

.bi-badge-cc-fill::before {
  content: "\\f164";
}

.bi-badge-cc::before {
  content: "\\f165";
}

.bi-badge-hd-fill::before {
  content: "\\f166";
}

.bi-badge-hd::before {
  content: "\\f167";
}

.bi-badge-tm-fill::before {
  content: "\\f168";
}

.bi-badge-tm::before {
  content: "\\f169";
}

.bi-badge-vo-fill::before {
  content: "\\f16a";
}

.bi-badge-vo::before {
  content: "\\f16b";
}

.bi-badge-vr-fill::before {
  content: "\\f16c";
}

.bi-badge-vr::before {
  content: "\\f16d";
}

.bi-badge-wc-fill::before {
  content: "\\f16e";
}

.bi-badge-wc::before {
  content: "\\f16f";
}

.bi-bag-check-fill::before {
  content: "\\f170";
}

.bi-bag-check::before {
  content: "\\f171";
}

.bi-bag-dash-fill::before {
  content: "\\f172";
}

.bi-bag-dash::before {
  content: "\\f173";
}

.bi-bag-fill::before {
  content: "\\f174";
}

.bi-bag-plus-fill::before {
  content: "\\f175";
}

.bi-bag-plus::before {
  content: "\\f176";
}

.bi-bag-x-fill::before {
  content: "\\f177";
}

.bi-bag-x::before {
  content: "\\f178";
}

.bi-bag::before {
  content: "\\f179";
}

.bi-bar-chart-fill::before {
  content: "\\f17a";
}

.bi-bar-chart-line-fill::before {
  content: "\\f17b";
}

.bi-bar-chart-line::before {
  content: "\\f17c";
}

.bi-bar-chart-steps::before {
  content: "\\f17d";
}

.bi-bar-chart::before {
  content: "\\f17e";
}

.bi-basket-fill::before {
  content: "\\f17f";
}

.bi-basket::before {
  content: "\\f180";
}

.bi-basket2-fill::before {
  content: "\\f181";
}

.bi-basket2::before {
  content: "\\f182";
}

.bi-basket3-fill::before {
  content: "\\f183";
}

.bi-basket3::before {
  content: "\\f184";
}

.bi-battery-charging::before {
  content: "\\f185";
}

.bi-battery-full::before {
  content: "\\f186";
}

.bi-battery-half::before {
  content: "\\f187";
}

.bi-battery::before {
  content: "\\f188";
}

.bi-bell-fill::before {
  content: "\\f189";
}

.bi-bell::before {
  content: "\\f18a";
}

.bi-bezier::before {
  content: "\\f18b";
}

.bi-bezier2::before {
  content: "\\f18c";
}

.bi-bicycle::before {
  content: "\\f18d";
}

.bi-binoculars-fill::before {
  content: "\\f18e";
}

.bi-binoculars::before {
  content: "\\f18f";
}

.bi-blockquote-left::before {
  content: "\\f190";
}

.bi-blockquote-right::before {
  content: "\\f191";
}

.bi-book-fill::before {
  content: "\\f192";
}

.bi-book-half::before {
  content: "\\f193";
}

.bi-book::before {
  content: "\\f194";
}

.bi-bookmark-check-fill::before {
  content: "\\f195";
}

.bi-bookmark-check::before {
  content: "\\f196";
}

.bi-bookmark-dash-fill::before {
  content: "\\f197";
}

.bi-bookmark-dash::before {
  content: "\\f198";
}

.bi-bookmark-fill::before {
  content: "\\f199";
}

.bi-bookmark-heart-fill::before {
  content: "\\f19a";
}

.bi-bookmark-heart::before {
  content: "\\f19b";
}

.bi-bookmark-plus-fill::before {
  content: "\\f19c";
}

.bi-bookmark-plus::before {
  content: "\\f19d";
}

.bi-bookmark-star-fill::before {
  content: "\\f19e";
}

.bi-bookmark-star::before {
  content: "\\f19f";
}

.bi-bookmark-x-fill::before {
  content: "\\f1a0";
}

.bi-bookmark-x::before {
  content: "\\f1a1";
}

.bi-bookmark::before {
  content: "\\f1a2";
}

.bi-bookmarks-fill::before {
  content: "\\f1a3";
}

.bi-bookmarks::before {
  content: "\\f1a4";
}

.bi-bookshelf::before {
  content: "\\f1a5";
}

.bi-bootstrap-fill::before {
  content: "\\f1a6";
}

.bi-bootstrap-reboot::before {
  content: "\\f1a7";
}

.bi-bootstrap::before {
  content: "\\f1a8";
}

.bi-border-all::before {
  content: "\\f1a9";
}

.bi-border-bottom::before {
  content: "\\f1aa";
}

.bi-border-center::before {
  content: "\\f1ab";
}

.bi-border-inner::before {
  content: "\\f1ac";
}

.bi-border-left::before {
  content: "\\f1ad";
}

.bi-border-middle::before {
  content: "\\f1ae";
}

.bi-border-outer::before {
  content: "\\f1af";
}

.bi-border-right::before {
  content: "\\f1b0";
}

.bi-border-style::before {
  content: "\\f1b1";
}

.bi-border-top::before {
  content: "\\f1b2";
}

.bi-border-width::before {
  content: "\\f1b3";
}

.bi-border::before {
  content: "\\f1b4";
}

.bi-bounding-box-circles::before {
  content: "\\f1b5";
}

.bi-bounding-box::before {
  content: "\\f1b6";
}

.bi-box-arrow-down-left::before {
  content: "\\f1b7";
}

.bi-box-arrow-down-right::before {
  content: "\\f1b8";
}

.bi-box-arrow-down::before {
  content: "\\f1b9";
}

.bi-box-arrow-in-down-left::before {
  content: "\\f1ba";
}

.bi-box-arrow-in-down-right::before {
  content: "\\f1bb";
}

.bi-box-arrow-in-down::before {
  content: "\\f1bc";
}

.bi-box-arrow-in-left::before {
  content: "\\f1bd";
}

.bi-box-arrow-in-right::before {
  content: "\\f1be";
}

.bi-box-arrow-in-up-left::before {
  content: "\\f1bf";
}

.bi-box-arrow-in-up-right::before {
  content: "\\f1c0";
}

.bi-box-arrow-in-up::before {
  content: "\\f1c1";
}

.bi-box-arrow-left::before {
  content: "\\f1c2";
}

.bi-box-arrow-right::before {
  content: "\\f1c3";
}

.bi-box-arrow-up-left::before {
  content: "\\f1c4";
}

.bi-box-arrow-up-right::before {
  content: "\\f1c5";
}

.bi-box-arrow-up::before {
  content: "\\f1c6";
}

.bi-box-seam::before {
  content: "\\f1c7";
}

.bi-box::before {
  content: "\\f1c8";
}

.bi-braces::before {
  content: "\\f1c9";
}

.bi-bricks::before {
  content: "\\f1ca";
}

.bi-briefcase-fill::before {
  content: "\\f1cb";
}

.bi-briefcase::before {
  content: "\\f1cc";
}

.bi-brightness-alt-high-fill::before {
  content: "\\f1cd";
}

.bi-brightness-alt-high::before {
  content: "\\f1ce";
}

.bi-brightness-alt-low-fill::before {
  content: "\\f1cf";
}

.bi-brightness-alt-low::before {
  content: "\\f1d0";
}

.bi-brightness-high-fill::before {
  content: "\\f1d1";
}

.bi-brightness-high::before {
  content: "\\f1d2";
}

.bi-brightness-low-fill::before {
  content: "\\f1d3";
}

.bi-brightness-low::before {
  content: "\\f1d4";
}

.bi-broadcast-pin::before {
  content: "\\f1d5";
}

.bi-broadcast::before {
  content: "\\f1d6";
}

.bi-brush-fill::before {
  content: "\\f1d7";
}

.bi-brush::before {
  content: "\\f1d8";
}

.bi-bucket-fill::before {
  content: "\\f1d9";
}

.bi-bucket::before {
  content: "\\f1da";
}

.bi-bug-fill::before {
  content: "\\f1db";
}

.bi-bug::before {
  content: "\\f1dc";
}

.bi-building::before {
  content: "\\f1dd";
}

.bi-bullseye::before {
  content: "\\f1de";
}

.bi-calculator-fill::before {
  content: "\\f1df";
}

.bi-calculator::before {
  content: "\\f1e0";
}

.bi-calendar-check-fill::before {
  content: "\\f1e1";
}

.bi-calendar-check::before {
  content: "\\f1e2";
}

.bi-calendar-date-fill::before {
  content: "\\f1e3";
}

.bi-calendar-date::before {
  content: "\\f1e4";
}

.bi-calendar-day-fill::before {
  content: "\\f1e5";
}

.bi-calendar-day::before {
  content: "\\f1e6";
}

.bi-calendar-event-fill::before {
  content: "\\f1e7";
}

.bi-calendar-event::before {
  content: "\\f1e8";
}

.bi-calendar-fill::before {
  content: "\\f1e9";
}

.bi-calendar-minus-fill::before {
  content: "\\f1ea";
}

.bi-calendar-minus::before {
  content: "\\f1eb";
}

.bi-calendar-month-fill::before {
  content: "\\f1ec";
}

.bi-calendar-month::before {
  content: "\\f1ed";
}

.bi-calendar-plus-fill::before {
  content: "\\f1ee";
}

.bi-calendar-plus::before {
  content: "\\f1ef";
}

.bi-calendar-range-fill::before {
  content: "\\f1f0";
}

.bi-calendar-range::before {
  content: "\\f1f1";
}

.bi-calendar-week-fill::before {
  content: "\\f1f2";
}

.bi-calendar-week::before {
  content: "\\f1f3";
}

.bi-calendar-x-fill::before {
  content: "\\f1f4";
}

.bi-calendar-x::before {
  content: "\\f1f5";
}

.bi-calendar::before {
  content: "\\f1f6";
}

.bi-calendar2-check-fill::before {
  content: "\\f1f7";
}

.bi-calendar2-check::before {
  content: "\\f1f8";
}

.bi-calendar2-date-fill::before {
  content: "\\f1f9";
}

.bi-calendar2-date::before {
  content: "\\f1fa";
}

.bi-calendar2-day-fill::before {
  content: "\\f1fb";
}

.bi-calendar2-day::before {
  content: "\\f1fc";
}

.bi-calendar2-event-fill::before {
  content: "\\f1fd";
}

.bi-calendar2-event::before {
  content: "\\f1fe";
}

.bi-calendar2-fill::before {
  content: "\\f1ff";
}

.bi-calendar2-minus-fill::before {
  content: "\\f200";
}

.bi-calendar2-minus::before {
  content: "\\f201";
}

.bi-calendar2-month-fill::before {
  content: "\\f202";
}

.bi-calendar2-month::before {
  content: "\\f203";
}

.bi-calendar2-plus-fill::before {
  content: "\\f204";
}

.bi-calendar2-plus::before {
  content: "\\f205";
}

.bi-calendar2-range-fill::before {
  content: "\\f206";
}

.bi-calendar2-range::before {
  content: "\\f207";
}

.bi-calendar2-week-fill::before {
  content: "\\f208";
}

.bi-calendar2-week::before {
  content: "\\f209";
}

.bi-calendar2-x-fill::before {
  content: "\\f20a";
}

.bi-calendar2-x::before {
  content: "\\f20b";
}

.bi-calendar2::before {
  content: "\\f20c";
}

.bi-calendar3-event-fill::before {
  content: "\\f20d";
}

.bi-calendar3-event::before {
  content: "\\f20e";
}

.bi-calendar3-fill::before {
  content: "\\f20f";
}

.bi-calendar3-range-fill::before {
  content: "\\f210";
}

.bi-calendar3-range::before {
  content: "\\f211";
}

.bi-calendar3-week-fill::before {
  content: "\\f212";
}

.bi-calendar3-week::before {
  content: "\\f213";
}

.bi-calendar3::before {
  content: "\\f214";
}

.bi-calendar4-event::before {
  content: "\\f215";
}

.bi-calendar4-range::before {
  content: "\\f216";
}

.bi-calendar4-week::before {
  content: "\\f217";
}

.bi-calendar4::before {
  content: "\\f218";
}

.bi-camera-fill::before {
  content: "\\f219";
}

.bi-camera-reels-fill::before {
  content: "\\f21a";
}

.bi-camera-reels::before {
  content: "\\f21b";
}

.bi-camera-video-fill::before {
  content: "\\f21c";
}

.bi-camera-video-off-fill::before {
  content: "\\f21d";
}

.bi-camera-video-off::before {
  content: "\\f21e";
}

.bi-camera-video::before {
  content: "\\f21f";
}

.bi-camera::before {
  content: "\\f220";
}

.bi-camera2::before {
  content: "\\f221";
}

.bi-capslock-fill::before {
  content: "\\f222";
}

.bi-capslock::before {
  content: "\\f223";
}

.bi-card-checklist::before {
  content: "\\f224";
}

.bi-card-heading::before {
  content: "\\f225";
}

.bi-card-image::before {
  content: "\\f226";
}

.bi-card-list::before {
  content: "\\f227";
}

.bi-card-text::before {
  content: "\\f228";
}

.bi-caret-down-fill::before {
  content: "\\f229";
}

.bi-caret-down-square-fill::before {
  content: "\\f22a";
}

.bi-caret-down-square::before {
  content: "\\f22b";
}

.bi-caret-down::before {
  content: "\\f22c";
}

.bi-caret-left-fill::before {
  content: "\\f22d";
}

.bi-caret-left-square-fill::before {
  content: "\\f22e";
}

.bi-caret-left-square::before {
  content: "\\f22f";
}

.bi-caret-left::before {
  content: "\\f230";
}

.bi-caret-right-fill::before {
  content: "\\f231";
}

.bi-caret-right-square-fill::before {
  content: "\\f232";
}

.bi-caret-right-square::before {
  content: "\\f233";
}

.bi-caret-right::before {
  content: "\\f234";
}

.bi-caret-up-fill::before {
  content: "\\f235";
}

.bi-caret-up-square-fill::before {
  content: "\\f236";
}

.bi-caret-up-square::before {
  content: "\\f237";
}

.bi-caret-up::before {
  content: "\\f238";
}

.bi-cart-check-fill::before {
  content: "\\f239";
}

.bi-cart-check::before {
  content: "\\f23a";
}

.bi-cart-dash-fill::before {
  content: "\\f23b";
}

.bi-cart-dash::before {
  content: "\\f23c";
}

.bi-cart-fill::before {
  content: "\\f23d";
}

.bi-cart-plus-fill::before {
  content: "\\f23e";
}

.bi-cart-plus::before {
  content: "\\f23f";
}

.bi-cart-x-fill::before {
  content: "\\f240";
}

.bi-cart-x::before {
  content: "\\f241";
}

.bi-cart::before {
  content: "\\f242";
}

.bi-cart2::before {
  content: "\\f243";
}

.bi-cart3::before {
  content: "\\f244";
}

.bi-cart4::before {
  content: "\\f245";
}

.bi-cash-stack::before {
  content: "\\f246";
}

.bi-cash::before {
  content: "\\f247";
}

.bi-cast::before {
  content: "\\f248";
}

.bi-chat-dots-fill::before {
  content: "\\f249";
}

.bi-chat-dots::before {
  content: "\\f24a";
}

.bi-chat-fill::before {
  content: "\\f24b";
}

.bi-chat-left-dots-fill::before {
  content: "\\f24c";
}

.bi-chat-left-dots::before {
  content: "\\f24d";
}

.bi-chat-left-fill::before {
  content: "\\f24e";
}

.bi-chat-left-quote-fill::before {
  content: "\\f24f";
}

.bi-chat-left-quote::before {
  content: "\\f250";
}

.bi-chat-left-text-fill::before {
  content: "\\f251";
}

.bi-chat-left-text::before {
  content: "\\f252";
}

.bi-chat-left::before {
  content: "\\f253";
}

.bi-chat-quote-fill::before {
  content: "\\f254";
}

.bi-chat-quote::before {
  content: "\\f255";
}

.bi-chat-right-dots-fill::before {
  content: "\\f256";
}

.bi-chat-right-dots::before {
  content: "\\f257";
}

.bi-chat-right-fill::before {
  content: "\\f258";
}

.bi-chat-right-quote-fill::before {
  content: "\\f259";
}

.bi-chat-right-quote::before {
  content: "\\f25a";
}

.bi-chat-right-text-fill::before {
  content: "\\f25b";
}

.bi-chat-right-text::before {
  content: "\\f25c";
}

.bi-chat-right::before {
  content: "\\f25d";
}

.bi-chat-square-dots-fill::before {
  content: "\\f25e";
}

.bi-chat-square-dots::before {
  content: "\\f25f";
}

.bi-chat-square-fill::before {
  content: "\\f260";
}

.bi-chat-square-quote-fill::before {
  content: "\\f261";
}

.bi-chat-square-quote::before {
  content: "\\f262";
}

.bi-chat-square-text-fill::before {
  content: "\\f263";
}

.bi-chat-square-text::before {
  content: "\\f264";
}

.bi-chat-square::before {
  content: "\\f265";
}

.bi-chat-text-fill::before {
  content: "\\f266";
}

.bi-chat-text::before {
  content: "\\f267";
}

.bi-chat::before {
  content: "\\f268";
}

.bi-check-all::before {
  content: "\\f269";
}

.bi-check-circle-fill::before {
  content: "\\f26a";
}

.bi-check-circle::before {
  content: "\\f26b";
}

.bi-check-square-fill::before {
  content: "\\f26c";
}

.bi-check-square::before {
  content: "\\f26d";
}

.bi-check::before {
  content: "\\f26e";
}

.bi-check2-all::before {
  content: "\\f26f";
}

.bi-check2-circle::before {
  content: "\\f270";
}

.bi-check2-square::before {
  content: "\\f271";
}

.bi-check2::before {
  content: "\\f272";
}

.bi-chevron-bar-contract::before {
  content: "\\f273";
}

.bi-chevron-bar-down::before {
  content: "\\f274";
}

.bi-chevron-bar-expand::before {
  content: "\\f275";
}

.bi-chevron-bar-left::before {
  content: "\\f276";
}

.bi-chevron-bar-right::before {
  content: "\\f277";
}

.bi-chevron-bar-up::before {
  content: "\\f278";
}

.bi-chevron-compact-down::before {
  content: "\\f279";
}

.bi-chevron-compact-left::before {
  content: "\\f27a";
}

.bi-chevron-compact-right::before {
  content: "\\f27b";
}

.bi-chevron-compact-up::before {
  content: "\\f27c";
}

.bi-chevron-contract::before {
  content: "\\f27d";
}

.bi-chevron-double-down::before {
  content: "\\f27e";
}

.bi-chevron-double-left::before {
  content: "\\f27f";
}

.bi-chevron-double-right::before {
  content: "\\f280";
}

.bi-chevron-double-up::before {
  content: "\\f281";
}

.bi-chevron-down::before {
  content: "\\f282";
}

.bi-chevron-expand::before {
  content: "\\f283";
}

.bi-chevron-left::before {
  content: "\\f284";
}

.bi-chevron-right::before {
  content: "\\f285";
}

.bi-chevron-up::before {
  content: "\\f286";
}

.bi-circle-fill::before {
  content: "\\f287";
}

.bi-circle-half::before {
  content: "\\f288";
}

.bi-circle-square::before {
  content: "\\f289";
}

.bi-circle::before {
  content: "\\f28a";
}

.bi-clipboard-check::before {
  content: "\\f28b";
}

.bi-clipboard-data::before {
  content: "\\f28c";
}

.bi-clipboard-minus::before {
  content: "\\f28d";
}

.bi-clipboard-plus::before {
  content: "\\f28e";
}

.bi-clipboard-x::before {
  content: "\\f28f";
}

.bi-clipboard::before {
  content: "\\f290";
}

.bi-clock-fill::before {
  content: "\\f291";
}

.bi-clock-history::before {
  content: "\\f292";
}

.bi-clock::before {
  content: "\\f293";
}

.bi-cloud-arrow-down-fill::before {
  content: "\\f294";
}

.bi-cloud-arrow-down::before {
  content: "\\f295";
}

.bi-cloud-arrow-up-fill::before {
  content: "\\f296";
}

.bi-cloud-arrow-up::before {
  content: "\\f297";
}

.bi-cloud-check-fill::before {
  content: "\\f298";
}

.bi-cloud-check::before {
  content: "\\f299";
}

.bi-cloud-download-fill::before {
  content: "\\f29a";
}

.bi-cloud-download::before {
  content: "\\f29b";
}

.bi-cloud-drizzle-fill::before {
  content: "\\f29c";
}

.bi-cloud-drizzle::before {
  content: "\\f29d";
}

.bi-cloud-fill::before {
  content: "\\f29e";
}

.bi-cloud-fog-fill::before {
  content: "\\f29f";
}

.bi-cloud-fog::before {
  content: "\\f2a0";
}

.bi-cloud-fog2-fill::before {
  content: "\\f2a1";
}

.bi-cloud-fog2::before {
  content: "\\f2a2";
}

.bi-cloud-hail-fill::before {
  content: "\\f2a3";
}

.bi-cloud-hail::before {
  content: "\\f2a4";
}

.bi-cloud-haze-fill::before {
  content: "\\f2a6";
}

.bi-cloud-haze::before {
  content: "\\f2a7";
}

.bi-cloud-haze2-fill::before {
  content: "\\f2a8";
}

.bi-cloud-lightning-fill::before {
  content: "\\f2a9";
}

.bi-cloud-lightning-rain-fill::before {
  content: "\\f2aa";
}

.bi-cloud-lightning-rain::before {
  content: "\\f2ab";
}

.bi-cloud-lightning::before {
  content: "\\f2ac";
}

.bi-cloud-minus-fill::before {
  content: "\\f2ad";
}

.bi-cloud-minus::before {
  content: "\\f2ae";
}

.bi-cloud-moon-fill::before {
  content: "\\f2af";
}

.bi-cloud-moon::before {
  content: "\\f2b0";
}

.bi-cloud-plus-fill::before {
  content: "\\f2b1";
}

.bi-cloud-plus::before {
  content: "\\f2b2";
}

.bi-cloud-rain-fill::before {
  content: "\\f2b3";
}

.bi-cloud-rain-heavy-fill::before {
  content: "\\f2b4";
}

.bi-cloud-rain-heavy::before {
  content: "\\f2b5";
}

.bi-cloud-rain::before {
  content: "\\f2b6";
}

.bi-cloud-slash-fill::before {
  content: "\\f2b7";
}

.bi-cloud-slash::before {
  content: "\\f2b8";
}

.bi-cloud-sleet-fill::before {
  content: "\\f2b9";
}

.bi-cloud-sleet::before {
  content: "\\f2ba";
}

.bi-cloud-snow-fill::before {
  content: "\\f2bb";
}

.bi-cloud-snow::before {
  content: "\\f2bc";
}

.bi-cloud-sun-fill::before {
  content: "\\f2bd";
}

.bi-cloud-sun::before {
  content: "\\f2be";
}

.bi-cloud-upload-fill::before {
  content: "\\f2bf";
}

.bi-cloud-upload::before {
  content: "\\f2c0";
}

.bi-cloud::before {
  content: "\\f2c1";
}

.bi-clouds-fill::before {
  content: "\\f2c2";
}

.bi-clouds::before {
  content: "\\f2c3";
}

.bi-cloudy-fill::before {
  content: "\\f2c4";
}

.bi-cloudy::before {
  content: "\\f2c5";
}

.bi-code-slash::before {
  content: "\\f2c6";
}

.bi-code-square::before {
  content: "\\f2c7";
}

.bi-code::before {
  content: "\\f2c8";
}

.bi-collection-fill::before {
  content: "\\f2c9";
}

.bi-collection-play-fill::before {
  content: "\\f2ca";
}

.bi-collection-play::before {
  content: "\\f2cb";
}

.bi-collection::before {
  content: "\\f2cc";
}

.bi-columns-gap::before {
  content: "\\f2cd";
}

.bi-columns::before {
  content: "\\f2ce";
}

.bi-command::before {
  content: "\\f2cf";
}

.bi-compass-fill::before {
  content: "\\f2d0";
}

.bi-compass::before {
  content: "\\f2d1";
}

.bi-cone-striped::before {
  content: "\\f2d2";
}

.bi-cone::before {
  content: "\\f2d3";
}

.bi-controller::before {
  content: "\\f2d4";
}

.bi-cpu-fill::before {
  content: "\\f2d5";
}

.bi-cpu::before {
  content: "\\f2d6";
}

.bi-credit-card-2-back-fill::before {
  content: "\\f2d7";
}

.bi-credit-card-2-back::before {
  content: "\\f2d8";
}

.bi-credit-card-2-front-fill::before {
  content: "\\f2d9";
}

.bi-credit-card-2-front::before {
  content: "\\f2da";
}

.bi-credit-card-fill::before {
  content: "\\f2db";
}

.bi-credit-card::before {
  content: "\\f2dc";
}

.bi-crop::before {
  content: "\\f2dd";
}

.bi-cup-fill::before {
  content: "\\f2de";
}

.bi-cup-straw::before {
  content: "\\f2df";
}

.bi-cup::before {
  content: "\\f2e0";
}

.bi-cursor-fill::before {
  content: "\\f2e1";
}

.bi-cursor-text::before {
  content: "\\f2e2";
}

.bi-cursor::before {
  content: "\\f2e3";
}

.bi-dash-circle-dotted::before {
  content: "\\f2e4";
}

.bi-dash-circle-fill::before {
  content: "\\f2e5";
}

.bi-dash-circle::before {
  content: "\\f2e6";
}

.bi-dash-square-dotted::before {
  content: "\\f2e7";
}

.bi-dash-square-fill::before {
  content: "\\f2e8";
}

.bi-dash-square::before {
  content: "\\f2e9";
}

.bi-dash::before {
  content: "\\f2ea";
}

.bi-diagram-2-fill::before {
  content: "\\f2eb";
}

.bi-diagram-2::before {
  content: "\\f2ec";
}

.bi-diagram-3-fill::before {
  content: "\\f2ed";
}

.bi-diagram-3::before {
  content: "\\f2ee";
}

.bi-diamond-fill::before {
  content: "\\f2ef";
}

.bi-diamond-half::before {
  content: "\\f2f0";
}

.bi-diamond::before {
  content: "\\f2f1";
}

.bi-dice-1-fill::before {
  content: "\\f2f2";
}

.bi-dice-1::before {
  content: "\\f2f3";
}

.bi-dice-2-fill::before {
  content: "\\f2f4";
}

.bi-dice-2::before {
  content: "\\f2f5";
}

.bi-dice-3-fill::before {
  content: "\\f2f6";
}

.bi-dice-3::before {
  content: "\\f2f7";
}

.bi-dice-4-fill::before {
  content: "\\f2f8";
}

.bi-dice-4::before {
  content: "\\f2f9";
}

.bi-dice-5-fill::before {
  content: "\\f2fa";
}

.bi-dice-5::before {
  content: "\\f2fb";
}

.bi-dice-6-fill::before {
  content: "\\f2fc";
}

.bi-dice-6::before {
  content: "\\f2fd";
}

.bi-disc-fill::before {
  content: "\\f2fe";
}

.bi-disc::before {
  content: "\\f2ff";
}

.bi-discord::before {
  content: "\\f300";
}

.bi-display-fill::before {
  content: "\\f301";
}

.bi-display::before {
  content: "\\f302";
}

.bi-distribute-horizontal::before {
  content: "\\f303";
}

.bi-distribute-vertical::before {
  content: "\\f304";
}

.bi-door-closed-fill::before {
  content: "\\f305";
}

.bi-door-closed::before {
  content: "\\f306";
}

.bi-door-open-fill::before {
  content: "\\f307";
}

.bi-door-open::before {
  content: "\\f308";
}

.bi-dot::before {
  content: "\\f309";
}

.bi-download::before {
  content: "\\f30a";
}

.bi-droplet-fill::before {
  content: "\\f30b";
}

.bi-droplet-half::before {
  content: "\\f30c";
}

.bi-droplet::before {
  content: "\\f30d";
}

.bi-earbuds::before {
  content: "\\f30e";
}

.bi-easel-fill::before {
  content: "\\f30f";
}

.bi-easel::before {
  content: "\\f310";
}

.bi-egg-fill::before {
  content: "\\f311";
}

.bi-egg-fried::before {
  content: "\\f312";
}

.bi-egg::before {
  content: "\\f313";
}

.bi-eject-fill::before {
  content: "\\f314";
}

.bi-eject::before {
  content: "\\f315";
}

.bi-emoji-angry-fill::before {
  content: "\\f316";
}

.bi-emoji-angry::before {
  content: "\\f317";
}

.bi-emoji-dizzy-fill::before {
  content: "\\f318";
}

.bi-emoji-dizzy::before {
  content: "\\f319";
}

.bi-emoji-expressionless-fill::before {
  content: "\\f31a";
}

.bi-emoji-expressionless::before {
  content: "\\f31b";
}

.bi-emoji-frown-fill::before {
  content: "\\f31c";
}

.bi-emoji-frown::before {
  content: "\\f31d";
}

.bi-emoji-heart-eyes-fill::before {
  content: "\\f31e";
}

.bi-emoji-heart-eyes::before {
  content: "\\f31f";
}

.bi-emoji-laughing-fill::before {
  content: "\\f320";
}

.bi-emoji-laughing::before {
  content: "\\f321";
}

.bi-emoji-neutral-fill::before {
  content: "\\f322";
}

.bi-emoji-neutral::before {
  content: "\\f323";
}

.bi-emoji-smile-fill::before {
  content: "\\f324";
}

.bi-emoji-smile-upside-down-fill::before {
  content: "\\f325";
}

.bi-emoji-smile-upside-down::before {
  content: "\\f326";
}

.bi-emoji-smile::before {
  content: "\\f327";
}

.bi-emoji-sunglasses-fill::before {
  content: "\\f328";
}

.bi-emoji-sunglasses::before {
  content: "\\f329";
}

.bi-emoji-wink-fill::before {
  content: "\\f32a";
}

.bi-emoji-wink::before {
  content: "\\f32b";
}

.bi-envelope-fill::before {
  content: "\\f32c";
}

.bi-envelope-open-fill::before {
  content: "\\f32d";
}

.bi-envelope-open::before {
  content: "\\f32e";
}

.bi-envelope::before {
  content: "\\f32f";
}

.bi-eraser-fill::before {
  content: "\\f330";
}

.bi-eraser::before {
  content: "\\f331";
}

.bi-exclamation-circle-fill::before {
  content: "\\f332";
}

.bi-exclamation-circle::before {
  content: "\\f333";
}

.bi-exclamation-diamond-fill::before {
  content: "\\f334";
}

.bi-exclamation-diamond::before {
  content: "\\f335";
}

.bi-exclamation-octagon-fill::before {
  content: "\\f336";
}

.bi-exclamation-octagon::before {
  content: "\\f337";
}

.bi-exclamation-square-fill::before {
  content: "\\f338";
}

.bi-exclamation-square::before {
  content: "\\f339";
}

.bi-exclamation-triangle-fill::before {
  content: "\\f33a";
}

.bi-exclamation-triangle::before {
  content: "\\f33b";
}

.bi-exclamation::before {
  content: "\\f33c";
}

.bi-exclude::before {
  content: "\\f33d";
}

.bi-eye-fill::before {
  content: "\\f33e";
}

.bi-eye-slash-fill::before {
  content: "\\f33f";
}

.bi-eye-slash::before {
  content: "\\f340";
}

.bi-eye::before {
  content: "\\f341";
}

.bi-eyedropper::before {
  content: "\\f342";
}

.bi-eyeglasses::before {
  content: "\\f343";
}

.bi-facebook::before {
  content: "\\f344";
}

.bi-file-arrow-down-fill::before {
  content: "\\f345";
}

.bi-file-arrow-down::before {
  content: "\\f346";
}

.bi-file-arrow-up-fill::before {
  content: "\\f347";
}

.bi-file-arrow-up::before {
  content: "\\f348";
}

.bi-file-bar-graph-fill::before {
  content: "\\f349";
}

.bi-file-bar-graph::before {
  content: "\\f34a";
}

.bi-file-binary-fill::before {
  content: "\\f34b";
}

.bi-file-binary::before {
  content: "\\f34c";
}

.bi-file-break-fill::before {
  content: "\\f34d";
}

.bi-file-break::before {
  content: "\\f34e";
}

.bi-file-check-fill::before {
  content: "\\f34f";
}

.bi-file-check::before {
  content: "\\f350";
}

.bi-file-code-fill::before {
  content: "\\f351";
}

.bi-file-code::before {
  content: "\\f352";
}

.bi-file-diff-fill::before {
  content: "\\f353";
}

.bi-file-diff::before {
  content: "\\f354";
}

.bi-file-earmark-arrow-down-fill::before {
  content: "\\f355";
}

.bi-file-earmark-arrow-down::before {
  content: "\\f356";
}

.bi-file-earmark-arrow-up-fill::before {
  content: "\\f357";
}

.bi-file-earmark-arrow-up::before {
  content: "\\f358";
}

.bi-file-earmark-bar-graph-fill::before {
  content: "\\f359";
}

.bi-file-earmark-bar-graph::before {
  content: "\\f35a";
}

.bi-file-earmark-binary-fill::before {
  content: "\\f35b";
}

.bi-file-earmark-binary::before {
  content: "\\f35c";
}

.bi-file-earmark-break-fill::before {
  content: "\\f35d";
}

.bi-file-earmark-break::before {
  content: "\\f35e";
}

.bi-file-earmark-check-fill::before {
  content: "\\f35f";
}

.bi-file-earmark-check::before {
  content: "\\f360";
}

.bi-file-earmark-code-fill::before {
  content: "\\f361";
}

.bi-file-earmark-code::before {
  content: "\\f362";
}

.bi-file-earmark-diff-fill::before {
  content: "\\f363";
}

.bi-file-earmark-diff::before {
  content: "\\f364";
}

.bi-file-earmark-easel-fill::before {
  content: "\\f365";
}

.bi-file-earmark-easel::before {
  content: "\\f366";
}

.bi-file-earmark-excel-fill::before {
  content: "\\f367";
}

.bi-file-earmark-excel::before {
  content: "\\f368";
}

.bi-file-earmark-fill::before {
  content: "\\f369";
}

.bi-file-earmark-font-fill::before {
  content: "\\f36a";
}

.bi-file-earmark-font::before {
  content: "\\f36b";
}

.bi-file-earmark-image-fill::before {
  content: "\\f36c";
}

.bi-file-earmark-image::before {
  content: "\\f36d";
}

.bi-file-earmark-lock-fill::before {
  content: "\\f36e";
}

.bi-file-earmark-lock::before {
  content: "\\f36f";
}

.bi-file-earmark-lock2-fill::before {
  content: "\\f370";
}

.bi-file-earmark-lock2::before {
  content: "\\f371";
}

.bi-file-earmark-medical-fill::before {
  content: "\\f372";
}

.bi-file-earmark-medical::before {
  content: "\\f373";
}

.bi-file-earmark-minus-fill::before {
  content: "\\f374";
}

.bi-file-earmark-minus::before {
  content: "\\f375";
}

.bi-file-earmark-music-fill::before {
  content: "\\f376";
}

.bi-file-earmark-music::before {
  content: "\\f377";
}

.bi-file-earmark-person-fill::before {
  content: "\\f378";
}

.bi-file-earmark-person::before {
  content: "\\f379";
}

.bi-file-earmark-play-fill::before {
  content: "\\f37a";
}

.bi-file-earmark-play::before {
  content: "\\f37b";
}

.bi-file-earmark-plus-fill::before {
  content: "\\f37c";
}

.bi-file-earmark-plus::before {
  content: "\\f37d";
}

.bi-file-earmark-post-fill::before {
  content: "\\f37e";
}

.bi-file-earmark-post::before {
  content: "\\f37f";
}

.bi-file-earmark-ppt-fill::before {
  content: "\\f380";
}

.bi-file-earmark-ppt::before {
  content: "\\f381";
}

.bi-file-earmark-richtext-fill::before {
  content: "\\f382";
}

.bi-file-earmark-richtext::before {
  content: "\\f383";
}

.bi-file-earmark-ruled-fill::before {
  content: "\\f384";
}

.bi-file-earmark-ruled::before {
  content: "\\f385";
}

.bi-file-earmark-slides-fill::before {
  content: "\\f386";
}

.bi-file-earmark-slides::before {
  content: "\\f387";
}

.bi-file-earmark-spreadsheet-fill::before {
  content: "\\f388";
}

.bi-file-earmark-spreadsheet::before {
  content: "\\f389";
}

.bi-file-earmark-text-fill::before {
  content: "\\f38a";
}

.bi-file-earmark-text::before {
  content: "\\f38b";
}

.bi-file-earmark-word-fill::before {
  content: "\\f38c";
}

.bi-file-earmark-word::before {
  content: "\\f38d";
}

.bi-file-earmark-x-fill::before {
  content: "\\f38e";
}

.bi-file-earmark-x::before {
  content: "\\f38f";
}

.bi-file-earmark-zip-fill::before {
  content: "\\f390";
}

.bi-file-earmark-zip::before {
  content: "\\f391";
}

.bi-file-earmark::before {
  content: "\\f392";
}

.bi-file-easel-fill::before {
  content: "\\f393";
}

.bi-file-easel::before {
  content: "\\f394";
}

.bi-file-excel-fill::before {
  content: "\\f395";
}

.bi-file-excel::before {
  content: "\\f396";
}

.bi-file-fill::before {
  content: "\\f397";
}

.bi-file-font-fill::before {
  content: "\\f398";
}

.bi-file-font::before {
  content: "\\f399";
}

.bi-file-image-fill::before {
  content: "\\f39a";
}

.bi-file-image::before {
  content: "\\f39b";
}

.bi-file-lock-fill::before {
  content: "\\f39c";
}

.bi-file-lock::before {
  content: "\\f39d";
}

.bi-file-lock2-fill::before {
  content: "\\f39e";
}

.bi-file-lock2::before {
  content: "\\f39f";
}

.bi-file-medical-fill::before {
  content: "\\f3a0";
}

.bi-file-medical::before {
  content: "\\f3a1";
}

.bi-file-minus-fill::before {
  content: "\\f3a2";
}

.bi-file-minus::before {
  content: "\\f3a3";
}

.bi-file-music-fill::before {
  content: "\\f3a4";
}

.bi-file-music::before {
  content: "\\f3a5";
}

.bi-file-person-fill::before {
  content: "\\f3a6";
}

.bi-file-person::before {
  content: "\\f3a7";
}

.bi-file-play-fill::before {
  content: "\\f3a8";
}

.bi-file-play::before {
  content: "\\f3a9";
}

.bi-file-plus-fill::before {
  content: "\\f3aa";
}

.bi-file-plus::before {
  content: "\\f3ab";
}

.bi-file-post-fill::before {
  content: "\\f3ac";
}

.bi-file-post::before {
  content: "\\f3ad";
}

.bi-file-ppt-fill::before {
  content: "\\f3ae";
}

.bi-file-ppt::before {
  content: "\\f3af";
}

.bi-file-richtext-fill::before {
  content: "\\f3b0";
}

.bi-file-richtext::before {
  content: "\\f3b1";
}

.bi-file-ruled-fill::before {
  content: "\\f3b2";
}

.bi-file-ruled::before {
  content: "\\f3b3";
}

.bi-file-slides-fill::before {
  content: "\\f3b4";
}

.bi-file-slides::before {
  content: "\\f3b5";
}

.bi-file-spreadsheet-fill::before {
  content: "\\f3b6";
}

.bi-file-spreadsheet::before {
  content: "\\f3b7";
}

.bi-file-text-fill::before {
  content: "\\f3b8";
}

.bi-file-text::before {
  content: "\\f3b9";
}

.bi-file-word-fill::before {
  content: "\\f3ba";
}

.bi-file-word::before {
  content: "\\f3bb";
}

.bi-file-x-fill::before {
  content: "\\f3bc";
}

.bi-file-x::before {
  content: "\\f3bd";
}

.bi-file-zip-fill::before {
  content: "\\f3be";
}

.bi-file-zip::before {
  content: "\\f3bf";
}

.bi-file::before {
  content: "\\f3c0";
}

.bi-files-alt::before {
  content: "\\f3c1";
}

.bi-files::before {
  content: "\\f3c2";
}

.bi-film::before {
  content: "\\f3c3";
}

.bi-filter-circle-fill::before {
  content: "\\f3c4";
}

.bi-filter-circle::before {
  content: "\\f3c5";
}

.bi-filter-left::before {
  content: "\\f3c6";
}

.bi-filter-right::before {
  content: "\\f3c7";
}

.bi-filter-square-fill::before {
  content: "\\f3c8";
}

.bi-filter-square::before {
  content: "\\f3c9";
}

.bi-filter::before {
  content: "\\f3ca";
}

.bi-flag-fill::before {
  content: "\\f3cb";
}

.bi-flag::before {
  content: "\\f3cc";
}

.bi-flower1::before {
  content: "\\f3cd";
}

.bi-flower2::before {
  content: "\\f3ce";
}

.bi-flower3::before {
  content: "\\f3cf";
}

.bi-folder-check::before {
  content: "\\f3d0";
}

.bi-folder-fill::before {
  content: "\\f3d1";
}

.bi-folder-minus::before {
  content: "\\f3d2";
}

.bi-folder-plus::before {
  content: "\\f3d3";
}

.bi-folder-symlink-fill::before {
  content: "\\f3d4";
}

.bi-folder-symlink::before {
  content: "\\f3d5";
}

.bi-folder-x::before {
  content: "\\f3d6";
}

.bi-folder::before {
  content: "\\f3d7";
}

.bi-folder2-open::before {
  content: "\\f3d8";
}

.bi-folder2::before {
  content: "\\f3d9";
}

.bi-fonts::before {
  content: "\\f3da";
}

.bi-forward-fill::before {
  content: "\\f3db";
}

.bi-forward::before {
  content: "\\f3dc";
}

.bi-front::before {
  content: "\\f3dd";
}

.bi-fullscreen-exit::before {
  content: "\\f3de";
}

.bi-fullscreen::before {
  content: "\\f3df";
}

.bi-funnel-fill::before {
  content: "\\f3e0";
}

.bi-funnel::before {
  content: "\\f3e1";
}

.bi-gear-fill::before {
  content: "\\f3e2";
}

.bi-gear-wide-connected::before {
  content: "\\f3e3";
}

.bi-gear-wide::before {
  content: "\\f3e4";
}

.bi-gear::before {
  content: "\\f3e5";
}

.bi-gem::before {
  content: "\\f3e6";
}

.bi-geo-alt-fill::before {
  content: "\\f3e7";
}

.bi-geo-alt::before {
  content: "\\f3e8";
}

.bi-geo-fill::before {
  content: "\\f3e9";
}

.bi-geo::before {
  content: "\\f3ea";
}

.bi-gift-fill::before {
  content: "\\f3eb";
}

.bi-gift::before {
  content: "\\f3ec";
}

.bi-github::before {
  content: "\\f3ed";
}

.bi-globe::before {
  content: "\\f3ee";
}

.bi-globe2::before {
  content: "\\f3ef";
}

.bi-google::before {
  content: "\\f3f0";
}

.bi-graph-down::before {
  content: "\\f3f1";
}

.bi-graph-up::before {
  content: "\\f3f2";
}

.bi-grid-1x2-fill::before {
  content: "\\f3f3";
}

.bi-grid-1x2::before {
  content: "\\f3f4";
}

.bi-grid-3x2-gap-fill::before {
  content: "\\f3f5";
}

.bi-grid-3x2-gap::before {
  content: "\\f3f6";
}

.bi-grid-3x2::before {
  content: "\\f3f7";
}

.bi-grid-3x3-gap-fill::before {
  content: "\\f3f8";
}

.bi-grid-3x3-gap::before {
  content: "\\f3f9";
}

.bi-grid-3x3::before {
  content: "\\f3fa";
}

.bi-grid-fill::before {
  content: "\\f3fb";
}

.bi-grid::before {
  content: "\\f3fc";
}

.bi-grip-horizontal::before {
  content: "\\f3fd";
}

.bi-grip-vertical::before {
  content: "\\f3fe";
}

.bi-hammer::before {
  content: "\\f3ff";
}

.bi-hand-index-fill::before {
  content: "\\f400";
}

.bi-hand-index-thumb-fill::before {
  content: "\\f401";
}

.bi-hand-index-thumb::before {
  content: "\\f402";
}

.bi-hand-index::before {
  content: "\\f403";
}

.bi-hand-thumbs-down-fill::before {
  content: "\\f404";
}

.bi-hand-thumbs-down::before {
  content: "\\f405";
}

.bi-hand-thumbs-up-fill::before {
  content: "\\f406";
}

.bi-hand-thumbs-up::before {
  content: "\\f407";
}

.bi-handbag-fill::before {
  content: "\\f408";
}

.bi-handbag::before {
  content: "\\f409";
}

.bi-hash::before {
  content: "\\f40a";
}

.bi-hdd-fill::before {
  content: "\\f40b";
}

.bi-hdd-network-fill::before {
  content: "\\f40c";
}

.bi-hdd-network::before {
  content: "\\f40d";
}

.bi-hdd-rack-fill::before {
  content: "\\f40e";
}

.bi-hdd-rack::before {
  content: "\\f40f";
}

.bi-hdd-stack-fill::before {
  content: "\\f410";
}

.bi-hdd-stack::before {
  content: "\\f411";
}

.bi-hdd::before {
  content: "\\f412";
}

.bi-headphones::before {
  content: "\\f413";
}

.bi-headset::before {
  content: "\\f414";
}

.bi-heart-fill::before {
  content: "\\f415";
}

.bi-heart-half::before {
  content: "\\f416";
}

.bi-heart::before {
  content: "\\f417";
}

.bi-heptagon-fill::before {
  content: "\\f418";
}

.bi-heptagon-half::before {
  content: "\\f419";
}

.bi-heptagon::before {
  content: "\\f41a";
}

.bi-hexagon-fill::before {
  content: "\\f41b";
}

.bi-hexagon-half::before {
  content: "\\f41c";
}

.bi-hexagon::before {
  content: "\\f41d";
}

.bi-hourglass-bottom::before {
  content: "\\f41e";
}

.bi-hourglass-split::before {
  content: "\\f41f";
}

.bi-hourglass-top::before {
  content: "\\f420";
}

.bi-hourglass::before {
  content: "\\f421";
}

.bi-house-door-fill::before {
  content: "\\f422";
}

.bi-house-door::before {
  content: "\\f423";
}

.bi-house-fill::before {
  content: "\\f424";
}

.bi-house::before {
  content: "\\f425";
}

.bi-hr::before {
  content: "\\f426";
}

.bi-hurricane::before {
  content: "\\f427";
}

.bi-image-alt::before {
  content: "\\f428";
}

.bi-image-fill::before {
  content: "\\f429";
}

.bi-image::before {
  content: "\\f42a";
}

.bi-images::before {
  content: "\\f42b";
}

.bi-inbox-fill::before {
  content: "\\f42c";
}

.bi-inbox::before {
  content: "\\f42d";
}

.bi-inboxes-fill::before {
  content: "\\f42e";
}

.bi-inboxes::before {
  content: "\\f42f";
}

.bi-info-circle-fill::before {
  content: "\\f430";
}

.bi-info-circle::before {
  content: "\\f431";
}

.bi-info-square-fill::before {
  content: "\\f432";
}

.bi-info-square::before {
  content: "\\f433";
}

.bi-info::before {
  content: "\\f434";
}

.bi-input-cursor-text::before {
  content: "\\f435";
}

.bi-input-cursor::before {
  content: "\\f436";
}

.bi-instagram::before {
  content: "\\f437";
}

.bi-intersect::before {
  content: "\\f438";
}

.bi-journal-album::before {
  content: "\\f439";
}

.bi-journal-arrow-down::before {
  content: "\\f43a";
}

.bi-journal-arrow-up::before {
  content: "\\f43b";
}

.bi-journal-bookmark-fill::before {
  content: "\\f43c";
}

.bi-journal-bookmark::before {
  content: "\\f43d";
}

.bi-journal-check::before {
  content: "\\f43e";
}

.bi-journal-code::before {
  content: "\\f43f";
}

.bi-journal-medical::before {
  content: "\\f440";
}

.bi-journal-minus::before {
  content: "\\f441";
}

.bi-journal-plus::before {
  content: "\\f442";
}

.bi-journal-richtext::before {
  content: "\\f443";
}

.bi-journal-text::before {
  content: "\\f444";
}

.bi-journal-x::before {
  content: "\\f445";
}

.bi-journal::before {
  content: "\\f446";
}

.bi-journals::before {
  content: "\\f447";
}

.bi-joystick::before {
  content: "\\f448";
}

.bi-justify-left::before {
  content: "\\f449";
}

.bi-justify-right::before {
  content: "\\f44a";
}

.bi-justify::before {
  content: "\\f44b";
}

.bi-kanban-fill::before {
  content: "\\f44c";
}

.bi-kanban::before {
  content: "\\f44d";
}

.bi-key-fill::before {
  content: "\\f44e";
}

.bi-key::before {
  content: "\\f44f";
}

.bi-keyboard-fill::before {
  content: "\\f450";
}

.bi-keyboard::before {
  content: "\\f451";
}

.bi-ladder::before {
  content: "\\f452";
}

.bi-lamp-fill::before {
  content: "\\f453";
}

.bi-lamp::before {
  content: "\\f454";
}

.bi-laptop-fill::before {
  content: "\\f455";
}

.bi-laptop::before {
  content: "\\f456";
}

.bi-layer-backward::before {
  content: "\\f457";
}

.bi-layer-forward::before {
  content: "\\f458";
}

.bi-layers-fill::before {
  content: "\\f459";
}

.bi-layers-half::before {
  content: "\\f45a";
}

.bi-layers::before {
  content: "\\f45b";
}

.bi-layout-sidebar-inset-reverse::before {
  content: "\\f45c";
}

.bi-layout-sidebar-inset::before {
  content: "\\f45d";
}

.bi-layout-sidebar-reverse::before {
  content: "\\f45e";
}

.bi-layout-sidebar::before {
  content: "\\f45f";
}

.bi-layout-split::before {
  content: "\\f460";
}

.bi-layout-text-sidebar-reverse::before {
  content: "\\f461";
}

.bi-layout-text-sidebar::before {
  content: "\\f462";
}

.bi-layout-text-window-reverse::before {
  content: "\\f463";
}

.bi-layout-text-window::before {
  content: "\\f464";
}

.bi-layout-three-columns::before {
  content: "\\f465";
}

.bi-layout-wtf::before {
  content: "\\f466";
}

.bi-life-preserver::before {
  content: "\\f467";
}

.bi-lightbulb-fill::before {
  content: "\\f468";
}

.bi-lightbulb-off-fill::before {
  content: "\\f469";
}

.bi-lightbulb-off::before {
  content: "\\f46a";
}

.bi-lightbulb::before {
  content: "\\f46b";
}

.bi-lightning-charge-fill::before {
  content: "\\f46c";
}

.bi-lightning-charge::before {
  content: "\\f46d";
}

.bi-lightning-fill::before {
  content: "\\f46e";
}

.bi-lightning::before {
  content: "\\f46f";
}

.bi-link-45deg::before {
  content: "\\f470";
}

.bi-link::before {
  content: "\\f471";
}

.bi-linkedin::before {
  content: "\\f472";
}

.bi-list-check::before {
  content: "\\f473";
}

.bi-list-nested::before {
  content: "\\f474";
}

.bi-list-ol::before {
  content: "\\f475";
}

.bi-list-stars::before {
  content: "\\f476";
}

.bi-list-task::before {
  content: "\\f477";
}

.bi-list-ul::before {
  content: "\\f478";
}

.bi-list::before {
  content: "\\f479";
}

.bi-lock-fill::before {
  content: "\\f47a";
}

.bi-lock::before {
  content: "\\f47b";
}

.bi-mailbox::before {
  content: "\\f47c";
}

.bi-mailbox2::before {
  content: "\\f47d";
}

.bi-map-fill::before {
  content: "\\f47e";
}

.bi-map::before {
  content: "\\f47f";
}

.bi-markdown-fill::before {
  content: "\\f480";
}

.bi-markdown::before {
  content: "\\f481";
}

.bi-mask::before {
  content: "\\f482";
}

.bi-megaphone-fill::before {
  content: "\\f483";
}

.bi-megaphone::before {
  content: "\\f484";
}

.bi-menu-app-fill::before {
  content: "\\f485";
}

.bi-menu-app::before {
  content: "\\f486";
}

.bi-menu-button-fill::before {
  content: "\\f487";
}

.bi-menu-button-wide-fill::before {
  content: "\\f488";
}

.bi-menu-button-wide::before {
  content: "\\f489";
}

.bi-menu-button::before {
  content: "\\f48a";
}

.bi-menu-down::before {
  content: "\\f48b";
}

.bi-menu-up::before {
  content: "\\f48c";
}

.bi-mic-fill::before {
  content: "\\f48d";
}

.bi-mic-mute-fill::before {
  content: "\\f48e";
}

.bi-mic-mute::before {
  content: "\\f48f";
}

.bi-mic::before {
  content: "\\f490";
}

.bi-minecart-loaded::before {
  content: "\\f491";
}

.bi-minecart::before {
  content: "\\f492";
}

.bi-moisture::before {
  content: "\\f493";
}

.bi-moon-fill::before {
  content: "\\f494";
}

.bi-moon-stars-fill::before {
  content: "\\f495";
}

.bi-moon-stars::before {
  content: "\\f496";
}

.bi-moon::before {
  content: "\\f497";
}

.bi-mouse-fill::before {
  content: "\\f498";
}

.bi-mouse::before {
  content: "\\f499";
}

.bi-mouse2-fill::before {
  content: "\\f49a";
}

.bi-mouse2::before {
  content: "\\f49b";
}

.bi-mouse3-fill::before {
  content: "\\f49c";
}

.bi-mouse3::before {
  content: "\\f49d";
}

.bi-music-note-beamed::before {
  content: "\\f49e";
}

.bi-music-note-list::before {
  content: "\\f49f";
}

.bi-music-note::before {
  content: "\\f4a0";
}

.bi-music-player-fill::before {
  content: "\\f4a1";
}

.bi-music-player::before {
  content: "\\f4a2";
}

.bi-newspaper::before {
  content: "\\f4a3";
}

.bi-node-minus-fill::before {
  content: "\\f4a4";
}

.bi-node-minus::before {
  content: "\\f4a5";
}

.bi-node-plus-fill::before {
  content: "\\f4a6";
}

.bi-node-plus::before {
  content: "\\f4a7";
}

.bi-nut-fill::before {
  content: "\\f4a8";
}

.bi-nut::before {
  content: "\\f4a9";
}

.bi-octagon-fill::before {
  content: "\\f4aa";
}

.bi-octagon-half::before {
  content: "\\f4ab";
}

.bi-octagon::before {
  content: "\\f4ac";
}

.bi-option::before {
  content: "\\f4ad";
}

.bi-outlet::before {
  content: "\\f4ae";
}

.bi-paint-bucket::before {
  content: "\\f4af";
}

.bi-palette-fill::before {
  content: "\\f4b0";
}

.bi-palette::before {
  content: "\\f4b1";
}

.bi-palette2::before {
  content: "\\f4b2";
}

.bi-paperclip::before {
  content: "\\f4b3";
}

.bi-paragraph::before {
  content: "\\f4b4";
}

.bi-patch-check-fill::before {
  content: "\\f4b5";
}

.bi-patch-check::before {
  content: "\\f4b6";
}

.bi-patch-exclamation-fill::before {
  content: "\\f4b7";
}

.bi-patch-exclamation::before {
  content: "\\f4b8";
}

.bi-patch-minus-fill::before {
  content: "\\f4b9";
}

.bi-patch-minus::before {
  content: "\\f4ba";
}

.bi-patch-plus-fill::before {
  content: "\\f4bb";
}

.bi-patch-plus::before {
  content: "\\f4bc";
}

.bi-patch-question-fill::before {
  content: "\\f4bd";
}

.bi-patch-question::before {
  content: "\\f4be";
}

.bi-pause-btn-fill::before {
  content: "\\f4bf";
}

.bi-pause-btn::before {
  content: "\\f4c0";
}

.bi-pause-circle-fill::before {
  content: "\\f4c1";
}

.bi-pause-circle::before {
  content: "\\f4c2";
}

.bi-pause-fill::before {
  content: "\\f4c3";
}

.bi-pause::before {
  content: "\\f4c4";
}

.bi-peace-fill::before {
  content: "\\f4c5";
}

.bi-peace::before {
  content: "\\f4c6";
}

.bi-pen-fill::before {
  content: "\\f4c7";
}

.bi-pen::before {
  content: "\\f4c8";
}

.bi-pencil-fill::before {
  content: "\\f4c9";
}

.bi-pencil-square::before {
  content: "\\f4ca";
}

.bi-pencil::before {
  content: "\\f4cb";
}

.bi-pentagon-fill::before {
  content: "\\f4cc";
}

.bi-pentagon-half::before {
  content: "\\f4cd";
}

.bi-pentagon::before {
  content: "\\f4ce";
}

.bi-people-fill::before {
  content: "\\f4cf";
}

.bi-people::before {
  content: "\\f4d0";
}

.bi-percent::before {
  content: "\\f4d1";
}

.bi-person-badge-fill::before {
  content: "\\f4d2";
}

.bi-person-badge::before {
  content: "\\f4d3";
}

.bi-person-bounding-box::before {
  content: "\\f4d4";
}

.bi-person-check-fill::before {
  content: "\\f4d5";
}

.bi-person-check::before {
  content: "\\f4d6";
}

.bi-person-circle::before {
  content: "\\f4d7";
}

.bi-person-dash-fill::before {
  content: "\\f4d8";
}

.bi-person-dash::before {
  content: "\\f4d9";
}

.bi-person-fill::before {
  content: "\\f4da";
}

.bi-person-lines-fill::before {
  content: "\\f4db";
}

.bi-person-plus-fill::before {
  content: "\\f4dc";
}

.bi-person-plus::before {
  content: "\\f4dd";
}

.bi-person-square::before {
  content: "\\f4de";
}

.bi-person-x-fill::before {
  content: "\\f4df";
}

.bi-person-x::before {
  content: "\\f4e0";
}

.bi-person::before {
  content: "\\f4e1";
}

.bi-phone-fill::before {
  content: "\\f4e2";
}

.bi-phone-landscape-fill::before {
  content: "\\f4e3";
}

.bi-phone-landscape::before {
  content: "\\f4e4";
}

.bi-phone-vibrate-fill::before {
  content: "\\f4e5";
}

.bi-phone-vibrate::before {
  content: "\\f4e6";
}

.bi-phone::before {
  content: "\\f4e7";
}

.bi-pie-chart-fill::before {
  content: "\\f4e8";
}

.bi-pie-chart::before {
  content: "\\f4e9";
}

.bi-pin-angle-fill::before {
  content: "\\f4ea";
}

.bi-pin-angle::before {
  content: "\\f4eb";
}

.bi-pin-fill::before {
  content: "\\f4ec";
}

.bi-pin::before {
  content: "\\f4ed";
}

.bi-pip-fill::before {
  content: "\\f4ee";
}

.bi-pip::before {
  content: "\\f4ef";
}

.bi-play-btn-fill::before {
  content: "\\f4f0";
}

.bi-play-btn::before {
  content: "\\f4f1";
}

.bi-play-circle-fill::before {
  content: "\\f4f2";
}

.bi-play-circle::before {
  content: "\\f4f3";
}

.bi-play-fill::before {
  content: "\\f4f4";
}

.bi-play::before {
  content: "\\f4f5";
}

.bi-plug-fill::before {
  content: "\\f4f6";
}

.bi-plug::before {
  content: "\\f4f7";
}

.bi-plus-circle-dotted::before {
  content: "\\f4f8";
}

.bi-plus-circle-fill::before {
  content: "\\f4f9";
}

.bi-plus-circle::before {
  content: "\\f4fa";
}

.bi-plus-square-dotted::before {
  content: "\\f4fb";
}

.bi-plus-square-fill::before {
  content: "\\f4fc";
}

.bi-plus-square::before {
  content: "\\f4fd";
}

.bi-plus::before {
  content: "\\f4fe";
}

.bi-power::before {
  content: "\\f4ff";
}

.bi-printer-fill::before {
  content: "\\f500";
}

.bi-printer::before {
  content: "\\f501";
}

.bi-puzzle-fill::before {
  content: "\\f502";
}

.bi-puzzle::before {
  content: "\\f503";
}

.bi-question-circle-fill::before {
  content: "\\f504";
}

.bi-question-circle::before {
  content: "\\f505";
}

.bi-question-diamond-fill::before {
  content: "\\f506";
}

.bi-question-diamond::before {
  content: "\\f507";
}

.bi-question-octagon-fill::before {
  content: "\\f508";
}

.bi-question-octagon::before {
  content: "\\f509";
}

.bi-question-square-fill::before {
  content: "\\f50a";
}

.bi-question-square::before {
  content: "\\f50b";
}

.bi-question::before {
  content: "\\f50c";
}

.bi-rainbow::before {
  content: "\\f50d";
}

.bi-receipt-cutoff::before {
  content: "\\f50e";
}

.bi-receipt::before {
  content: "\\f50f";
}

.bi-reception-0::before {
  content: "\\f510";
}

.bi-reception-1::before {
  content: "\\f511";
}

.bi-reception-2::before {
  content: "\\f512";
}

.bi-reception-3::before {
  content: "\\f513";
}

.bi-reception-4::before {
  content: "\\f514";
}

.bi-record-btn-fill::before {
  content: "\\f515";
}

.bi-record-btn::before {
  content: "\\f516";
}

.bi-record-circle-fill::before {
  content: "\\f517";
}

.bi-record-circle::before {
  content: "\\f518";
}

.bi-record-fill::before {
  content: "\\f519";
}

.bi-record::before {
  content: "\\f51a";
}

.bi-record2-fill::before {
  content: "\\f51b";
}

.bi-record2::before {
  content: "\\f51c";
}

.bi-reply-all-fill::before {
  content: "\\f51d";
}

.bi-reply-all::before {
  content: "\\f51e";
}

.bi-reply-fill::before {
  content: "\\f51f";
}

.bi-reply::before {
  content: "\\f520";
}

.bi-rss-fill::before {
  content: "\\f521";
}

.bi-rss::before {
  content: "\\f522";
}

.bi-rulers::before {
  content: "\\f523";
}

.bi-save-fill::before {
  content: "\\f524";
}

.bi-save::before {
  content: "\\f525";
}

.bi-save2-fill::before {
  content: "\\f526";
}

.bi-save2::before {
  content: "\\f527";
}

.bi-scissors::before {
  content: "\\f528";
}

.bi-screwdriver::before {
  content: "\\f529";
}

.bi-search::before {
  content: "\\f52a";
}

.bi-segmented-nav::before {
  content: "\\f52b";
}

.bi-server::before {
  content: "\\f52c";
}

.bi-share-fill::before {
  content: "\\f52d";
}

.bi-share::before {
  content: "\\f52e";
}

.bi-shield-check::before {
  content: "\\f52f";
}

.bi-shield-exclamation::before {
  content: "\\f530";
}

.bi-shield-fill-check::before {
  content: "\\f531";
}

.bi-shield-fill-exclamation::before {
  content: "\\f532";
}

.bi-shield-fill-minus::before {
  content: "\\f533";
}

.bi-shield-fill-plus::before {
  content: "\\f534";
}

.bi-shield-fill-x::before {
  content: "\\f535";
}

.bi-shield-fill::before {
  content: "\\f536";
}

.bi-shield-lock-fill::before {
  content: "\\f537";
}

.bi-shield-lock::before {
  content: "\\f538";
}

.bi-shield-minus::before {
  content: "\\f539";
}

.bi-shield-plus::before {
  content: "\\f53a";
}

.bi-shield-shaded::before {
  content: "\\f53b";
}

.bi-shield-slash-fill::before {
  content: "\\f53c";
}

.bi-shield-slash::before {
  content: "\\f53d";
}

.bi-shield-x::before {
  content: "\\f53e";
}

.bi-shield::before {
  content: "\\f53f";
}

.bi-shift-fill::before {
  content: "\\f540";
}

.bi-shift::before {
  content: "\\f541";
}

.bi-shop-window::before {
  content: "\\f542";
}

.bi-shop::before {
  content: "\\f543";
}

.bi-shuffle::before {
  content: "\\f544";
}

.bi-signpost-2-fill::before {
  content: "\\f545";
}

.bi-signpost-2::before {
  content: "\\f546";
}

.bi-signpost-fill::before {
  content: "\\f547";
}

.bi-signpost-split-fill::before {
  content: "\\f548";
}

.bi-signpost-split::before {
  content: "\\f549";
}

.bi-signpost::before {
  content: "\\f54a";
}

.bi-sim-fill::before {
  content: "\\f54b";
}

.bi-sim::before {
  content: "\\f54c";
}

.bi-skip-backward-btn-fill::before {
  content: "\\f54d";
}

.bi-skip-backward-btn::before {
  content: "\\f54e";
}

.bi-skip-backward-circle-fill::before {
  content: "\\f54f";
}

.bi-skip-backward-circle::before {
  content: "\\f550";
}

.bi-skip-backward-fill::before {
  content: "\\f551";
}

.bi-skip-backward::before {
  content: "\\f552";
}

.bi-skip-end-btn-fill::before {
  content: "\\f553";
}

.bi-skip-end-btn::before {
  content: "\\f554";
}

.bi-skip-end-circle-fill::before {
  content: "\\f555";
}

.bi-skip-end-circle::before {
  content: "\\f556";
}

.bi-skip-end-fill::before {
  content: "\\f557";
}

.bi-skip-end::before {
  content: "\\f558";
}

.bi-skip-forward-btn-fill::before {
  content: "\\f559";
}

.bi-skip-forward-btn::before {
  content: "\\f55a";
}

.bi-skip-forward-circle-fill::before {
  content: "\\f55b";
}

.bi-skip-forward-circle::before {
  content: "\\f55c";
}

.bi-skip-forward-fill::before {
  content: "\\f55d";
}

.bi-skip-forward::before {
  content: "\\f55e";
}

.bi-skip-start-btn-fill::before {
  content: "\\f55f";
}

.bi-skip-start-btn::before {
  content: "\\f560";
}

.bi-skip-start-circle-fill::before {
  content: "\\f561";
}

.bi-skip-start-circle::before {
  content: "\\f562";
}

.bi-skip-start-fill::before {
  content: "\\f563";
}

.bi-skip-start::before {
  content: "\\f564";
}

.bi-slack::before {
  content: "\\f565";
}

.bi-slash-circle-fill::before {
  content: "\\f566";
}

.bi-slash-circle::before {
  content: "\\f567";
}

.bi-slash-square-fill::before {
  content: "\\f568";
}

.bi-slash-square::before {
  content: "\\f569";
}

.bi-slash::before {
  content: "\\f56a";
}

.bi-sliders::before {
  content: "\\f56b";
}

.bi-smartwatch::before {
  content: "\\f56c";
}

.bi-snow::before {
  content: "\\f56d";
}

.bi-snow2::before {
  content: "\\f56e";
}

.bi-snow3::before {
  content: "\\f56f";
}

.bi-sort-alpha-down-alt::before {
  content: "\\f570";
}

.bi-sort-alpha-down::before {
  content: "\\f571";
}

.bi-sort-alpha-up-alt::before {
  content: "\\f572";
}

.bi-sort-alpha-up::before {
  content: "\\f573";
}

.bi-sort-down-alt::before {
  content: "\\f574";
}

.bi-sort-down::before {
  content: "\\f575";
}

.bi-sort-numeric-down-alt::before {
  content: "\\f576";
}

.bi-sort-numeric-down::before {
  content: "\\f577";
}

.bi-sort-numeric-up-alt::before {
  content: "\\f578";
}

.bi-sort-numeric-up::before {
  content: "\\f579";
}

.bi-sort-up-alt::before {
  content: "\\f57a";
}

.bi-sort-up::before {
  content: "\\f57b";
}

.bi-soundwave::before {
  content: "\\f57c";
}

.bi-speaker-fill::before {
  content: "\\f57d";
}

.bi-speaker::before {
  content: "\\f57e";
}

.bi-speedometer::before {
  content: "\\f57f";
}

.bi-speedometer2::before {
  content: "\\f580";
}

.bi-spellcheck::before {
  content: "\\f581";
}

.bi-square-fill::before {
  content: "\\f582";
}

.bi-square-half::before {
  content: "\\f583";
}

.bi-square::before {
  content: "\\f584";
}

.bi-stack::before {
  content: "\\f585";
}

.bi-star-fill::before {
  content: "\\f586";
}

.bi-star-half::before {
  content: "\\f587";
}

.bi-star::before {
  content: "\\f588";
}

.bi-stars::before {
  content: "\\f589";
}

.bi-stickies-fill::before {
  content: "\\f58a";
}

.bi-stickies::before {
  content: "\\f58b";
}

.bi-sticky-fill::before {
  content: "\\f58c";
}

.bi-sticky::before {
  content: "\\f58d";
}

.bi-stop-btn-fill::before {
  content: "\\f58e";
}

.bi-stop-btn::before {
  content: "\\f58f";
}

.bi-stop-circle-fill::before {
  content: "\\f590";
}

.bi-stop-circle::before {
  content: "\\f591";
}

.bi-stop-fill::before {
  content: "\\f592";
}

.bi-stop::before {
  content: "\\f593";
}

.bi-stoplights-fill::before {
  content: "\\f594";
}

.bi-stoplights::before {
  content: "\\f595";
}

.bi-stopwatch-fill::before {
  content: "\\f596";
}

.bi-stopwatch::before {
  content: "\\f597";
}

.bi-subtract::before {
  content: "\\f598";
}

.bi-suit-club-fill::before {
  content: "\\f599";
}

.bi-suit-club::before {
  content: "\\f59a";
}

.bi-suit-diamond-fill::before {
  content: "\\f59b";
}

.bi-suit-diamond::before {
  content: "\\f59c";
}

.bi-suit-heart-fill::before {
  content: "\\f59d";
}

.bi-suit-heart::before {
  content: "\\f59e";
}

.bi-suit-spade-fill::before {
  content: "\\f59f";
}

.bi-suit-spade::before {
  content: "\\f5a0";
}

.bi-sun-fill::before {
  content: "\\f5a1";
}

.bi-sun::before {
  content: "\\f5a2";
}

.bi-sunglasses::before {
  content: "\\f5a3";
}

.bi-sunrise-fill::before {
  content: "\\f5a4";
}

.bi-sunrise::before {
  content: "\\f5a5";
}

.bi-sunset-fill::before {
  content: "\\f5a6";
}

.bi-sunset::before {
  content: "\\f5a7";
}

.bi-symmetry-horizontal::before {
  content: "\\f5a8";
}

.bi-symmetry-vertical::before {
  content: "\\f5a9";
}

.bi-table::before {
  content: "\\f5aa";
}

.bi-tablet-fill::before {
  content: "\\f5ab";
}

.bi-tablet-landscape-fill::before {
  content: "\\f5ac";
}

.bi-tablet-landscape::before {
  content: "\\f5ad";
}

.bi-tablet::before {
  content: "\\f5ae";
}

.bi-tag-fill::before {
  content: "\\f5af";
}

.bi-tag::before {
  content: "\\f5b0";
}

.bi-tags-fill::before {
  content: "\\f5b1";
}

.bi-tags::before {
  content: "\\f5b2";
}

.bi-telegram::before {
  content: "\\f5b3";
}

.bi-telephone-fill::before {
  content: "\\f5b4";
}

.bi-telephone-forward-fill::before {
  content: "\\f5b5";
}

.bi-telephone-forward::before {
  content: "\\f5b6";
}

.bi-telephone-inbound-fill::before {
  content: "\\f5b7";
}

.bi-telephone-inbound::before {
  content: "\\f5b8";
}

.bi-telephone-minus-fill::before {
  content: "\\f5b9";
}

.bi-telephone-minus::before {
  content: "\\f5ba";
}

.bi-telephone-outbound-fill::before {
  content: "\\f5bb";
}

.bi-telephone-outbound::before {
  content: "\\f5bc";
}

.bi-telephone-plus-fill::before {
  content: "\\f5bd";
}

.bi-telephone-plus::before {
  content: "\\f5be";
}

.bi-telephone-x-fill::before {
  content: "\\f5bf";
}

.bi-telephone-x::before {
  content: "\\f5c0";
}

.bi-telephone::before {
  content: "\\f5c1";
}

.bi-terminal-fill::before {
  content: "\\f5c2";
}

.bi-terminal::before {
  content: "\\f5c3";
}

.bi-text-center::before {
  content: "\\f5c4";
}

.bi-text-indent-left::before {
  content: "\\f5c5";
}

.bi-text-indent-right::before {
  content: "\\f5c6";
}

.bi-text-left::before {
  content: "\\f5c7";
}

.bi-text-paragraph::before {
  content: "\\f5c8";
}

.bi-text-right::before {
  content: "\\f5c9";
}

.bi-textarea-resize::before {
  content: "\\f5ca";
}

.bi-textarea-t::before {
  content: "\\f5cb";
}

.bi-textarea::before {
  content: "\\f5cc";
}

.bi-thermometer-half::before {
  content: "\\f5cd";
}

.bi-thermometer-high::before {
  content: "\\f5ce";
}

.bi-thermometer-low::before {
  content: "\\f5cf";
}

.bi-thermometer-snow::before {
  content: "\\f5d0";
}

.bi-thermometer-sun::before {
  content: "\\f5d1";
}

.bi-thermometer::before {
  content: "\\f5d2";
}

.bi-three-dots-vertical::before {
  content: "\\f5d3";
}

.bi-three-dots::before {
  content: "\\f5d4";
}

.bi-toggle-off::before {
  content: "\\f5d5";
}

.bi-toggle-on::before {
  content: "\\f5d6";
}

.bi-toggle2-off::before {
  content: "\\f5d7";
}

.bi-toggle2-on::before {
  content: "\\f5d8";
}

.bi-toggles::before {
  content: "\\f5d9";
}

.bi-toggles2::before {
  content: "\\f5da";
}

.bi-tools::before {
  content: "\\f5db";
}

.bi-tornado::before {
  content: "\\f5dc";
}

.bi-trash-fill::before {
  content: "\\f5dd";
}

.bi-trash::before {
  content: "\\f5de";
}

.bi-trash2-fill::before {
  content: "\\f5df";
}

.bi-trash2::before {
  content: "\\f5e0";
}

.bi-tree-fill::before {
  content: "\\f5e1";
}

.bi-tree::before {
  content: "\\f5e2";
}

.bi-triangle-fill::before {
  content: "\\f5e3";
}

.bi-triangle-half::before {
  content: "\\f5e4";
}

.bi-triangle::before {
  content: "\\f5e5";
}

.bi-trophy-fill::before {
  content: "\\f5e6";
}

.bi-trophy::before {
  content: "\\f5e7";
}

.bi-tropical-storm::before {
  content: "\\f5e8";
}

.bi-truck-flatbed::before {
  content: "\\f5e9";
}

.bi-truck::before {
  content: "\\f5ea";
}

.bi-tsunami::before {
  content: "\\f5eb";
}

.bi-tv-fill::before {
  content: "\\f5ec";
}

.bi-tv::before {
  content: "\\f5ed";
}

.bi-twitch::before {
  content: "\\f5ee";
}

.bi-twitter::before {
  content: "\\f5ef";
}

.bi-type-bold::before {
  content: "\\f5f0";
}

.bi-type-h1::before {
  content: "\\f5f1";
}

.bi-type-h2::before {
  content: "\\f5f2";
}

.bi-type-h3::before {
  content: "\\f5f3";
}

.bi-type-italic::before {
  content: "\\f5f4";
}

.bi-type-strikethrough::before {
  content: "\\f5f5";
}

.bi-type-underline::before {
  content: "\\f5f6";
}

.bi-type::before {
  content: "\\f5f7";
}

.bi-ui-checks-grid::before {
  content: "\\f5f8";
}

.bi-ui-checks::before {
  content: "\\f5f9";
}

.bi-ui-radios-grid::before {
  content: "\\f5fa";
}

.bi-ui-radios::before {
  content: "\\f5fb";
}

.bi-umbrella-fill::before {
  content: "\\f5fc";
}

.bi-umbrella::before {
  content: "\\f5fd";
}

.bi-union::before {
  content: "\\f5fe";
}

.bi-unlock-fill::before {
  content: "\\f5ff";
}

.bi-unlock::before {
  content: "\\f600";
}

.bi-upc-scan::before {
  content: "\\f601";
}

.bi-upc::before {
  content: "\\f602";
}

.bi-upload::before {
  content: "\\f603";
}

.bi-vector-pen::before {
  content: "\\f604";
}

.bi-view-list::before {
  content: "\\f605";
}

.bi-view-stacked::before {
  content: "\\f606";
}

.bi-vinyl-fill::before {
  content: "\\f607";
}

.bi-vinyl::before {
  content: "\\f608";
}

.bi-voicemail::before {
  content: "\\f609";
}

.bi-volume-down-fill::before {
  content: "\\f60a";
}

.bi-volume-down::before {
  content: "\\f60b";
}

.bi-volume-mute-fill::before {
  content: "\\f60c";
}

.bi-volume-mute::before {
  content: "\\f60d";
}

.bi-volume-off-fill::before {
  content: "\\f60e";
}

.bi-volume-off::before {
  content: "\\f60f";
}

.bi-volume-up-fill::before {
  content: "\\f610";
}

.bi-volume-up::before {
  content: "\\f611";
}

.bi-vr::before {
  content: "\\f612";
}

.bi-wallet-fill::before {
  content: "\\f613";
}

.bi-wallet::before {
  content: "\\f614";
}

.bi-wallet2::before {
  content: "\\f615";
}

.bi-watch::before {
  content: "\\f616";
}

.bi-water::before {
  content: "\\f617";
}

.bi-whatsapp::before {
  content: "\\f618";
}

.bi-wifi-1::before {
  content: "\\f619";
}

.bi-wifi-2::before {
  content: "\\f61a";
}

.bi-wifi-off::before {
  content: "\\f61b";
}

.bi-wifi::before {
  content: "\\f61c";
}

.bi-wind::before {
  content: "\\f61d";
}

.bi-window-dock::before {
  content: "\\f61e";
}

.bi-window-sidebar::before {
  content: "\\f61f";
}

.bi-window::before {
  content: "\\f620";
}

.bi-wrench::before {
  content: "\\f621";
}

.bi-x-circle-fill::before {
  content: "\\f622";
}

.bi-x-circle::before {
  content: "\\f623";
}

.bi-x-diamond-fill::before {
  content: "\\f624";
}

.bi-x-diamond::before {
  content: "\\f625";
}

.bi-x-octagon-fill::before {
  content: "\\f626";
}

.bi-x-octagon::before {
  content: "\\f627";
}

.bi-x-square-fill::before {
  content: "\\f628";
}

.bi-x-square::before {
  content: "\\f629";
}

.bi-x::before {
  content: "\\f62a";
}

.bi-youtube::before {
  content: "\\f62b";
}

.bi-zoom-in::before {
  content: "\\f62c";
}

.bi-zoom-out::before {
  content: "\\f62d";
}

.bi-bank::before {
  content: "\\f62e";
}

.bi-bank2::before {
  content: "\\f62f";
}

.bi-bell-slash-fill::before {
  content: "\\f630";
}

.bi-bell-slash::before {
  content: "\\f631";
}

.bi-cash-coin::before {
  content: "\\f632";
}

.bi-check-lg::before {
  content: "\\f633";
}

.bi-coin::before {
  content: "\\f634";
}

.bi-currency-bitcoin::before {
  content: "\\f635";
}

.bi-currency-dollar::before {
  content: "\\f636";
}

.bi-currency-euro::before {
  content: "\\f637";
}

.bi-currency-exchange::before {
  content: "\\f638";
}

.bi-currency-pound::before {
  content: "\\f639";
}

.bi-currency-yen::before {
  content: "\\f63a";
}

.bi-dash-lg::before {
  content: "\\f63b";
}

.bi-exclamation-lg::before {
  content: "\\f63c";
}

.bi-file-earmark-pdf-fill::before {
  content: "\\f63d";
}

.bi-file-earmark-pdf::before {
  content: "\\f63e";
}

.bi-file-pdf-fill::before {
  content: "\\f63f";
}

.bi-file-pdf::before {
  content: "\\f640";
}

.bi-gender-ambiguous::before {
  content: "\\f641";
}

.bi-gender-female::before {
  content: "\\f642";
}

.bi-gender-male::before {
  content: "\\f643";
}

.bi-gender-trans::before {
  content: "\\f644";
}

.bi-headset-vr::before {
  content: "\\f645";
}

.bi-info-lg::before {
  content: "\\f646";
}

.bi-mastodon::before {
  content: "\\f647";
}

.bi-messenger::before {
  content: "\\f648";
}

.bi-piggy-bank-fill::before {
  content: "\\f649";
}

.bi-piggy-bank::before {
  content: "\\f64a";
}

.bi-pin-map-fill::before {
  content: "\\f64b";
}

.bi-pin-map::before {
  content: "\\f64c";
}

.bi-plus-lg::before {
  content: "\\f64d";
}

.bi-question-lg::before {
  content: "\\f64e";
}

.bi-recycle::before {
  content: "\\f64f";
}

.bi-reddit::before {
  content: "\\f650";
}

.bi-safe-fill::before {
  content: "\\f651";
}

.bi-safe2-fill::before {
  content: "\\f652";
}

.bi-safe2::before {
  content: "\\f653";
}

.bi-sd-card-fill::before {
  content: "\\f654";
}

.bi-sd-card::before {
  content: "\\f655";
}

.bi-skype::before {
  content: "\\f656";
}

.bi-slash-lg::before {
  content: "\\f657";
}

.bi-translate::before {
  content: "\\f658";
}

.bi-x-lg::before {
  content: "\\f659";
}

.bi-safe::before {
  content: "\\f65a";
}

.bi-apple::before {
  content: "\\f65b";
}

.bi-microsoft::before {
  content: "\\f65d";
}

.bi-windows::before {
  content: "\\f65e";
}

.bi-behance::before {
  content: "\\f65c";
}

.bi-dribbble::before {
  content: "\\f65f";
}

.bi-line::before {
  content: "\\f660";
}

.bi-medium::before {
  content: "\\f661";
}

.bi-paypal::before {
  content: "\\f662";
}

.bi-pinterest::before {
  content: "\\f663";
}

.bi-signal::before {
  content: "\\f664";
}

.bi-snapchat::before {
  content: "\\f665";
}

.bi-spotify::before {
  content: "\\f666";
}

.bi-stack-overflow::before {
  content: "\\f667";
}

.bi-strava::before {
  content: "\\f668";
}

.bi-wordpress::before {
  content: "\\f669";
}

.bi-vimeo::before {
  content: "\\f66a";
}

.bi-activity::before {
  content: "\\f66b";
}

.bi-easel2-fill::before {
  content: "\\f66c";
}

.bi-easel2::before {
  content: "\\f66d";
}

.bi-easel3-fill::before {
  content: "\\f66e";
}

.bi-easel3::before {
  content: "\\f66f";
}

.bi-fan::before {
  content: "\\f670";
}

.bi-fingerprint::before {
  content: "\\f671";
}

.bi-graph-down-arrow::before {
  content: "\\f672";
}

.bi-graph-up-arrow::before {
  content: "\\f673";
}

.bi-hypnotize::before {
  content: "\\f674";
}

.bi-magic::before {
  content: "\\f675";
}

.bi-person-rolodex::before {
  content: "\\f676";
}

.bi-person-video::before {
  content: "\\f677";
}

.bi-person-video2::before {
  content: "\\f678";
}

.bi-person-video3::before {
  content: "\\f679";
}

.bi-person-workspace::before {
  content: "\\f67a";
}

.bi-radioactive::before {
  content: "\\f67b";
}

.bi-webcam-fill::before {
  content: "\\f67c";
}

.bi-webcam::before {
  content: "\\f67d";
}

.bi-yin-yang::before {
  content: "\\f67e";
}

.bi-bandaid-fill::before {
  content: "\\f680";
}

.bi-bandaid::before {
  content: "\\f681";
}

.bi-bluetooth::before {
  content: "\\f682";
}

.bi-body-text::before {
  content: "\\f683";
}

.bi-boombox::before {
  content: "\\f684";
}

.bi-boxes::before {
  content: "\\f685";
}

.bi-dpad-fill::before {
  content: "\\f686";
}

.bi-dpad::before {
  content: "\\f687";
}

.bi-ear-fill::before {
  content: "\\f688";
}

.bi-ear::before {
  content: "\\f689";
}

.bi-envelope-check-fill::before {
  content: "\\f68b";
}

.bi-envelope-check::before {
  content: "\\f68c";
}

.bi-envelope-dash-fill::before {
  content: "\\f68e";
}

.bi-envelope-dash::before {
  content: "\\f68f";
}

.bi-envelope-exclamation-fill::before {
  content: "\\f691";
}

.bi-envelope-exclamation::before {
  content: "\\f692";
}

.bi-envelope-plus-fill::before {
  content: "\\f693";
}

.bi-envelope-plus::before {
  content: "\\f694";
}

.bi-envelope-slash-fill::before {
  content: "\\f696";
}

.bi-envelope-slash::before {
  content: "\\f697";
}

.bi-envelope-x-fill::before {
  content: "\\f699";
}

.bi-envelope-x::before {
  content: "\\f69a";
}

.bi-explicit-fill::before {
  content: "\\f69b";
}

.bi-explicit::before {
  content: "\\f69c";
}

.bi-git::before {
  content: "\\f69d";
}

.bi-infinity::before {
  content: "\\f69e";
}

.bi-list-columns-reverse::before {
  content: "\\f69f";
}

.bi-list-columns::before {
  content: "\\f6a0";
}

.bi-meta::before {
  content: "\\f6a1";
}

.bi-nintendo-switch::before {
  content: "\\f6a4";
}

.bi-pc-display-horizontal::before {
  content: "\\f6a5";
}

.bi-pc-display::before {
  content: "\\f6a6";
}

.bi-pc-horizontal::before {
  content: "\\f6a7";
}

.bi-pc::before {
  content: "\\f6a8";
}

.bi-playstation::before {
  content: "\\f6a9";
}

.bi-plus-slash-minus::before {
  content: "\\f6aa";
}

.bi-projector-fill::before {
  content: "\\f6ab";
}

.bi-projector::before {
  content: "\\f6ac";
}

.bi-qr-code-scan::before {
  content: "\\f6ad";
}

.bi-qr-code::before {
  content: "\\f6ae";
}

.bi-quora::before {
  content: "\\f6af";
}

.bi-quote::before {
  content: "\\f6b0";
}

.bi-robot::before {
  content: "\\f6b1";
}

.bi-send-check-fill::before {
  content: "\\f6b2";
}

.bi-send-check::before {
  content: "\\f6b3";
}

.bi-send-dash-fill::before {
  content: "\\f6b4";
}

.bi-send-dash::before {
  content: "\\f6b5";
}

.bi-send-exclamation-fill::before {
  content: "\\f6b7";
}

.bi-send-exclamation::before {
  content: "\\f6b8";
}

.bi-send-fill::before {
  content: "\\f6b9";
}

.bi-send-plus-fill::before {
  content: "\\f6ba";
}

.bi-send-plus::before {
  content: "\\f6bb";
}

.bi-send-slash-fill::before {
  content: "\\f6bc";
}

.bi-send-slash::before {
  content: "\\f6bd";
}

.bi-send-x-fill::before {
  content: "\\f6be";
}

.bi-send-x::before {
  content: "\\f6bf";
}

.bi-send::before {
  content: "\\f6c0";
}

.bi-steam::before {
  content: "\\f6c1";
}

.bi-terminal-dash::before {
  content: "\\f6c3";
}

.bi-terminal-plus::before {
  content: "\\f6c4";
}

.bi-terminal-split::before {
  content: "\\f6c5";
}

.bi-ticket-detailed-fill::before {
  content: "\\f6c6";
}

.bi-ticket-detailed::before {
  content: "\\f6c7";
}

.bi-ticket-fill::before {
  content: "\\f6c8";
}

.bi-ticket-perforated-fill::before {
  content: "\\f6c9";
}

.bi-ticket-perforated::before {
  content: "\\f6ca";
}

.bi-ticket::before {
  content: "\\f6cb";
}

.bi-tiktok::before {
  content: "\\f6cc";
}

.bi-window-dash::before {
  content: "\\f6cd";
}

.bi-window-desktop::before {
  content: "\\f6ce";
}

.bi-window-fullscreen::before {
  content: "\\f6cf";
}

.bi-window-plus::before {
  content: "\\f6d0";
}

.bi-window-split::before {
  content: "\\f6d1";
}

.bi-window-stack::before {
  content: "\\f6d2";
}

.bi-window-x::before {
  content: "\\f6d3";
}

.bi-xbox::before {
  content: "\\f6d4";
}

.bi-ethernet::before {
  content: "\\f6d5";
}

.bi-hdmi-fill::before {
  content: "\\f6d6";
}

.bi-hdmi::before {
  content: "\\f6d7";
}

.bi-usb-c-fill::before {
  content: "\\f6d8";
}

.bi-usb-c::before {
  content: "\\f6d9";
}

.bi-usb-fill::before {
  content: "\\f6da";
}

.bi-usb-plug-fill::before {
  content: "\\f6db";
}

.bi-usb-plug::before {
  content: "\\f6dc";
}

.bi-usb-symbol::before {
  content: "\\f6dd";
}

.bi-usb::before {
  content: "\\f6de";
}

.bi-boombox-fill::before {
  content: "\\f6df";
}

.bi-displayport::before {
  content: "\\f6e1";
}

.bi-gpu-card::before {
  content: "\\f6e2";
}

.bi-memory::before {
  content: "\\f6e3";
}

.bi-modem-fill::before {
  content: "\\f6e4";
}

.bi-modem::before {
  content: "\\f6e5";
}

.bi-motherboard-fill::before {
  content: "\\f6e6";
}

.bi-motherboard::before {
  content: "\\f6e7";
}

.bi-optical-audio-fill::before {
  content: "\\f6e8";
}

.bi-optical-audio::before {
  content: "\\f6e9";
}

.bi-pci-card::before {
  content: "\\f6ea";
}

.bi-router-fill::before {
  content: "\\f6eb";
}

.bi-router::before {
  content: "\\f6ec";
}

.bi-thunderbolt-fill::before {
  content: "\\f6ef";
}

.bi-thunderbolt::before {
  content: "\\f6f0";
}

.bi-usb-drive-fill::before {
  content: "\\f6f1";
}

.bi-usb-drive::before {
  content: "\\f6f2";
}

.bi-usb-micro-fill::before {
  content: "\\f6f3";
}

.bi-usb-micro::before {
  content: "\\f6f4";
}

.bi-usb-mini-fill::before {
  content: "\\f6f5";
}

.bi-usb-mini::before {
  content: "\\f6f6";
}

.bi-cloud-haze2::before {
  content: "\\f6f7";
}

.bi-device-hdd-fill::before {
  content: "\\f6f8";
}

.bi-device-hdd::before {
  content: "\\f6f9";
}

.bi-device-ssd-fill::before {
  content: "\\f6fa";
}

.bi-device-ssd::before {
  content: "\\f6fb";
}

.bi-displayport-fill::before {
  content: "\\f6fc";
}

.bi-mortarboard-fill::before {
  content: "\\f6fd";
}

.bi-mortarboard::before {
  content: "\\f6fe";
}

.bi-terminal-x::before {
  content: "\\f6ff";
}

.bi-arrow-through-heart-fill::before {
  content: "\\f700";
}

.bi-arrow-through-heart::before {
  content: "\\f701";
}

.bi-badge-sd-fill::before {
  content: "\\f702";
}

.bi-badge-sd::before {
  content: "\\f703";
}

.bi-bag-heart-fill::before {
  content: "\\f704";
}

.bi-bag-heart::before {
  content: "\\f705";
}

.bi-balloon-fill::before {
  content: "\\f706";
}

.bi-balloon-heart-fill::before {
  content: "\\f707";
}

.bi-balloon-heart::before {
  content: "\\f708";
}

.bi-balloon::before {
  content: "\\f709";
}

.bi-box2-fill::before {
  content: "\\f70a";
}

.bi-box2-heart-fill::before {
  content: "\\f70b";
}

.bi-box2-heart::before {
  content: "\\f70c";
}

.bi-box2::before {
  content: "\\f70d";
}

.bi-braces-asterisk::before {
  content: "\\f70e";
}

.bi-calendar-heart-fill::before {
  content: "\\f70f";
}

.bi-calendar-heart::before {
  content: "\\f710";
}

.bi-calendar2-heart-fill::before {
  content: "\\f711";
}

.bi-calendar2-heart::before {
  content: "\\f712";
}

.bi-chat-heart-fill::before {
  content: "\\f713";
}

.bi-chat-heart::before {
  content: "\\f714";
}

.bi-chat-left-heart-fill::before {
  content: "\\f715";
}

.bi-chat-left-heart::before {
  content: "\\f716";
}

.bi-chat-right-heart-fill::before {
  content: "\\f717";
}

.bi-chat-right-heart::before {
  content: "\\f718";
}

.bi-chat-square-heart-fill::before {
  content: "\\f719";
}

.bi-chat-square-heart::before {
  content: "\\f71a";
}

.bi-clipboard-check-fill::before {
  content: "\\f71b";
}

.bi-clipboard-data-fill::before {
  content: "\\f71c";
}

.bi-clipboard-fill::before {
  content: "\\f71d";
}

.bi-clipboard-heart-fill::before {
  content: "\\f71e";
}

.bi-clipboard-heart::before {
  content: "\\f71f";
}

.bi-clipboard-minus-fill::before {
  content: "\\f720";
}

.bi-clipboard-plus-fill::before {
  content: "\\f721";
}

.bi-clipboard-pulse::before {
  content: "\\f722";
}

.bi-clipboard-x-fill::before {
  content: "\\f723";
}

.bi-clipboard2-check-fill::before {
  content: "\\f724";
}

.bi-clipboard2-check::before {
  content: "\\f725";
}

.bi-clipboard2-data-fill::before {
  content: "\\f726";
}

.bi-clipboard2-data::before {
  content: "\\f727";
}

.bi-clipboard2-fill::before {
  content: "\\f728";
}

.bi-clipboard2-heart-fill::before {
  content: "\\f729";
}

.bi-clipboard2-heart::before {
  content: "\\f72a";
}

.bi-clipboard2-minus-fill::before {
  content: "\\f72b";
}

.bi-clipboard2-minus::before {
  content: "\\f72c";
}

.bi-clipboard2-plus-fill::before {
  content: "\\f72d";
}

.bi-clipboard2-plus::before {
  content: "\\f72e";
}

.bi-clipboard2-pulse-fill::before {
  content: "\\f72f";
}

.bi-clipboard2-pulse::before {
  content: "\\f730";
}

.bi-clipboard2-x-fill::before {
  content: "\\f731";
}

.bi-clipboard2-x::before {
  content: "\\f732";
}

.bi-clipboard2::before {
  content: "\\f733";
}

.bi-emoji-kiss-fill::before {
  content: "\\f734";
}

.bi-emoji-kiss::before {
  content: "\\f735";
}

.bi-envelope-heart-fill::before {
  content: "\\f736";
}

.bi-envelope-heart::before {
  content: "\\f737";
}

.bi-envelope-open-heart-fill::before {
  content: "\\f738";
}

.bi-envelope-open-heart::before {
  content: "\\f739";
}

.bi-envelope-paper-fill::before {
  content: "\\f73a";
}

.bi-envelope-paper-heart-fill::before {
  content: "\\f73b";
}

.bi-envelope-paper-heart::before {
  content: "\\f73c";
}

.bi-envelope-paper::before {
  content: "\\f73d";
}

.bi-filetype-aac::before {
  content: "\\f73e";
}

.bi-filetype-ai::before {
  content: "\\f73f";
}

.bi-filetype-bmp::before {
  content: "\\f740";
}

.bi-filetype-cs::before {
  content: "\\f741";
}

.bi-filetype-css::before {
  content: "\\f742";
}

.bi-filetype-csv::before {
  content: "\\f743";
}

.bi-filetype-doc::before {
  content: "\\f744";
}

.bi-filetype-docx::before {
  content: "\\f745";
}

.bi-filetype-exe::before {
  content: "\\f746";
}

.bi-filetype-gif::before {
  content: "\\f747";
}

.bi-filetype-heic::before {
  content: "\\f748";
}

.bi-filetype-html::before {
  content: "\\f749";
}

.bi-filetype-java::before {
  content: "\\f74a";
}

.bi-filetype-jpg::before {
  content: "\\f74b";
}

.bi-filetype-js::before {
  content: "\\f74c";
}

.bi-filetype-jsx::before {
  content: "\\f74d";
}

.bi-filetype-key::before {
  content: "\\f74e";
}

.bi-filetype-m4p::before {
  content: "\\f74f";
}

.bi-filetype-md::before {
  content: "\\f750";
}

.bi-filetype-mdx::before {
  content: "\\f751";
}

.bi-filetype-mov::before {
  content: "\\f752";
}

.bi-filetype-mp3::before {
  content: "\\f753";
}

.bi-filetype-mp4::before {
  content: "\\f754";
}

.bi-filetype-otf::before {
  content: "\\f755";
}

.bi-filetype-pdf::before {
  content: "\\f756";
}

.bi-filetype-php::before {
  content: "\\f757";
}

.bi-filetype-png::before {
  content: "\\f758";
}

.bi-filetype-ppt::before {
  content: "\\f75a";
}

.bi-filetype-psd::before {
  content: "\\f75b";
}

.bi-filetype-py::before {
  content: "\\f75c";
}

.bi-filetype-raw::before {
  content: "\\f75d";
}

.bi-filetype-rb::before {
  content: "\\f75e";
}

.bi-filetype-sass::before {
  content: "\\f75f";
}

.bi-filetype-scss::before {
  content: "\\f760";
}

.bi-filetype-sh::before {
  content: "\\f761";
}

.bi-filetype-svg::before {
  content: "\\f762";
}

.bi-filetype-tiff::before {
  content: "\\f763";
}

.bi-filetype-tsx::before {
  content: "\\f764";
}

.bi-filetype-ttf::before {
  content: "\\f765";
}

.bi-filetype-txt::before {
  content: "\\f766";
}

.bi-filetype-wav::before {
  content: "\\f767";
}

.bi-filetype-woff::before {
  content: "\\f768";
}

.bi-filetype-xls::before {
  content: "\\f76a";
}

.bi-filetype-xml::before {
  content: "\\f76b";
}

.bi-filetype-yml::before {
  content: "\\f76c";
}

.bi-heart-arrow::before {
  content: "\\f76d";
}

.bi-heart-pulse-fill::before {
  content: "\\f76e";
}

.bi-heart-pulse::before {
  content: "\\f76f";
}

.bi-heartbreak-fill::before {
  content: "\\f770";
}

.bi-heartbreak::before {
  content: "\\f771";
}

.bi-hearts::before {
  content: "\\f772";
}

.bi-hospital-fill::before {
  content: "\\f773";
}

.bi-hospital::before {
  content: "\\f774";
}

.bi-house-heart-fill::before {
  content: "\\f775";
}

.bi-house-heart::before {
  content: "\\f776";
}

.bi-incognito::before {
  content: "\\f777";
}

.bi-magnet-fill::before {
  content: "\\f778";
}

.bi-magnet::before {
  content: "\\f779";
}

.bi-person-heart::before {
  content: "\\f77a";
}

.bi-person-hearts::before {
  content: "\\f77b";
}

.bi-phone-flip::before {
  content: "\\f77c";
}

.bi-plugin::before {
  content: "\\f77d";
}

.bi-postage-fill::before {
  content: "\\f77e";
}

.bi-postage-heart-fill::before {
  content: "\\f77f";
}

.bi-postage-heart::before {
  content: "\\f780";
}

.bi-postage::before {
  content: "\\f781";
}

.bi-postcard-fill::before {
  content: "\\f782";
}

.bi-postcard-heart-fill::before {
  content: "\\f783";
}

.bi-postcard-heart::before {
  content: "\\f784";
}

.bi-postcard::before {
  content: "\\f785";
}

.bi-search-heart-fill::before {
  content: "\\f786";
}

.bi-search-heart::before {
  content: "\\f787";
}

.bi-sliders2-vertical::before {
  content: "\\f788";
}

.bi-sliders2::before {
  content: "\\f789";
}

.bi-trash3-fill::before {
  content: "\\f78a";
}

.bi-trash3::before {
  content: "\\f78b";
}

.bi-valentine::before {
  content: "\\f78c";
}

.bi-valentine2::before {
  content: "\\f78d";
}

.bi-wrench-adjustable-circle-fill::before {
  content: "\\f78e";
}

.bi-wrench-adjustable-circle::before {
  content: "\\f78f";
}

.bi-wrench-adjustable::before {
  content: "\\f790";
}

.bi-filetype-json::before {
  content: "\\f791";
}

.bi-filetype-pptx::before {
  content: "\\f792";
}

.bi-filetype-xlsx::before {
  content: "\\f793";
}

.bi-1-circle-fill::before {
  content: "\\f796";
}

.bi-1-circle::before {
  content: "\\f797";
}

.bi-1-square-fill::before {
  content: "\\f798";
}

.bi-1-square::before {
  content: "\\f799";
}

.bi-2-circle-fill::before {
  content: "\\f79c";
}

.bi-2-circle::before {
  content: "\\f79d";
}

.bi-2-square-fill::before {
  content: "\\f79e";
}

.bi-2-square::before {
  content: "\\f79f";
}

.bi-3-circle-fill::before {
  content: "\\f7a2";
}

.bi-3-circle::before {
  content: "\\f7a3";
}

.bi-3-square-fill::before {
  content: "\\f7a4";
}

.bi-3-square::before {
  content: "\\f7a5";
}

.bi-4-circle-fill::before {
  content: "\\f7a8";
}

.bi-4-circle::before {
  content: "\\f7a9";
}

.bi-4-square-fill::before {
  content: "\\f7aa";
}

.bi-4-square::before {
  content: "\\f7ab";
}

.bi-5-circle-fill::before {
  content: "\\f7ae";
}

.bi-5-circle::before {
  content: "\\f7af";
}

.bi-5-square-fill::before {
  content: "\\f7b0";
}

.bi-5-square::before {
  content: "\\f7b1";
}

.bi-6-circle-fill::before {
  content: "\\f7b4";
}

.bi-6-circle::before {
  content: "\\f7b5";
}

.bi-6-square-fill::before {
  content: "\\f7b6";
}

.bi-6-square::before {
  content: "\\f7b7";
}

.bi-7-circle-fill::before {
  content: "\\f7ba";
}

.bi-7-circle::before {
  content: "\\f7bb";
}

.bi-7-square-fill::before {
  content: "\\f7bc";
}

.bi-7-square::before {
  content: "\\f7bd";
}

.bi-8-circle-fill::before {
  content: "\\f7c0";
}

.bi-8-circle::before {
  content: "\\f7c1";
}

.bi-8-square-fill::before {
  content: "\\f7c2";
}

.bi-8-square::before {
  content: "\\f7c3";
}

.bi-9-circle-fill::before {
  content: "\\f7c6";
}

.bi-9-circle::before {
  content: "\\f7c7";
}

.bi-9-square-fill::before {
  content: "\\f7c8";
}

.bi-9-square::before {
  content: "\\f7c9";
}

.bi-airplane-engines-fill::before {
  content: "\\f7ca";
}

.bi-airplane-engines::before {
  content: "\\f7cb";
}

.bi-airplane-fill::before {
  content: "\\f7cc";
}

.bi-airplane::before {
  content: "\\f7cd";
}

.bi-alexa::before {
  content: "\\f7ce";
}

.bi-alipay::before {
  content: "\\f7cf";
}

.bi-android::before {
  content: "\\f7d0";
}

.bi-android2::before {
  content: "\\f7d1";
}

.bi-box-fill::before {
  content: "\\f7d2";
}

.bi-box-seam-fill::before {
  content: "\\f7d3";
}

.bi-browser-chrome::before {
  content: "\\f7d4";
}

.bi-browser-edge::before {
  content: "\\f7d5";
}

.bi-browser-firefox::before {
  content: "\\f7d6";
}

.bi-browser-safari::before {
  content: "\\f7d7";
}

.bi-c-circle-fill::before {
  content: "\\f7da";
}

.bi-c-circle::before {
  content: "\\f7db";
}

.bi-c-square-fill::before {
  content: "\\f7dc";
}

.bi-c-square::before {
  content: "\\f7dd";
}

.bi-capsule-pill::before {
  content: "\\f7de";
}

.bi-capsule::before {
  content: "\\f7df";
}

.bi-car-front-fill::before {
  content: "\\f7e0";
}

.bi-car-front::before {
  content: "\\f7e1";
}

.bi-cassette-fill::before {
  content: "\\f7e2";
}

.bi-cassette::before {
  content: "\\f7e3";
}

.bi-cc-circle-fill::before {
  content: "\\f7e6";
}

.bi-cc-circle::before {
  content: "\\f7e7";
}

.bi-cc-square-fill::before {
  content: "\\f7e8";
}

.bi-cc-square::before {
  content: "\\f7e9";
}

.bi-cup-hot-fill::before {
  content: "\\f7ea";
}

.bi-cup-hot::before {
  content: "\\f7eb";
}

.bi-currency-rupee::before {
  content: "\\f7ec";
}

.bi-dropbox::before {
  content: "\\f7ed";
}

.bi-escape::before {
  content: "\\f7ee";
}

.bi-fast-forward-btn-fill::before {
  content: "\\f7ef";
}

.bi-fast-forward-btn::before {
  content: "\\f7f0";
}

.bi-fast-forward-circle-fill::before {
  content: "\\f7f1";
}

.bi-fast-forward-circle::before {
  content: "\\f7f2";
}

.bi-fast-forward-fill::before {
  content: "\\f7f3";
}

.bi-fast-forward::before {
  content: "\\f7f4";
}

.bi-filetype-sql::before {
  content: "\\f7f5";
}

.bi-fire::before {
  content: "\\f7f6";
}

.bi-google-play::before {
  content: "\\f7f7";
}

.bi-h-circle-fill::before {
  content: "\\f7fa";
}

.bi-h-circle::before {
  content: "\\f7fb";
}

.bi-h-square-fill::before {
  content: "\\f7fc";
}

.bi-h-square::before {
  content: "\\f7fd";
}

.bi-indent::before {
  content: "\\f7fe";
}

.bi-lungs-fill::before {
  content: "\\f7ff";
}

.bi-lungs::before {
  content: "\\f800";
}

.bi-microsoft-teams::before {
  content: "\\f801";
}

.bi-p-circle-fill::before {
  content: "\\f804";
}

.bi-p-circle::before {
  content: "\\f805";
}

.bi-p-square-fill::before {
  content: "\\f806";
}

.bi-p-square::before {
  content: "\\f807";
}

.bi-pass-fill::before {
  content: "\\f808";
}

.bi-pass::before {
  content: "\\f809";
}

.bi-prescription::before {
  content: "\\f80a";
}

.bi-prescription2::before {
  content: "\\f80b";
}

.bi-r-circle-fill::before {
  content: "\\f80e";
}

.bi-r-circle::before {
  content: "\\f80f";
}

.bi-r-square-fill::before {
  content: "\\f810";
}

.bi-r-square::before {
  content: "\\f811";
}

.bi-repeat-1::before {
  content: "\\f812";
}

.bi-repeat::before {
  content: "\\f813";
}

.bi-rewind-btn-fill::before {
  content: "\\f814";
}

.bi-rewind-btn::before {
  content: "\\f815";
}

.bi-rewind-circle-fill::before {
  content: "\\f816";
}

.bi-rewind-circle::before {
  content: "\\f817";
}

.bi-rewind-fill::before {
  content: "\\f818";
}

.bi-rewind::before {
  content: "\\f819";
}

.bi-train-freight-front-fill::before {
  content: "\\f81a";
}

.bi-train-freight-front::before {
  content: "\\f81b";
}

.bi-train-front-fill::before {
  content: "\\f81c";
}

.bi-train-front::before {
  content: "\\f81d";
}

.bi-train-lightrail-front-fill::before {
  content: "\\f81e";
}

.bi-train-lightrail-front::before {
  content: "\\f81f";
}

.bi-truck-front-fill::before {
  content: "\\f820";
}

.bi-truck-front::before {
  content: "\\f821";
}

.bi-ubuntu::before {
  content: "\\f822";
}

.bi-unindent::before {
  content: "\\f823";
}

.bi-unity::before {
  content: "\\f824";
}

.bi-universal-access-circle::before {
  content: "\\f825";
}

.bi-universal-access::before {
  content: "\\f826";
}

.bi-virus::before {
  content: "\\f827";
}

.bi-virus2::before {
  content: "\\f828";
}

.bi-wechat::before {
  content: "\\f829";
}

.bi-yelp::before {
  content: "\\f82a";
}

.bi-sign-stop-fill::before {
  content: "\\f82b";
}

.bi-sign-stop-lights-fill::before {
  content: "\\f82c";
}

.bi-sign-stop-lights::before {
  content: "\\f82d";
}

.bi-sign-stop::before {
  content: "\\f82e";
}

.bi-sign-turn-left-fill::before {
  content: "\\f82f";
}

.bi-sign-turn-left::before {
  content: "\\f830";
}

.bi-sign-turn-right-fill::before {
  content: "\\f831";
}

.bi-sign-turn-right::before {
  content: "\\f832";
}

.bi-sign-turn-slight-left-fill::before {
  content: "\\f833";
}

.bi-sign-turn-slight-left::before {
  content: "\\f834";
}

.bi-sign-turn-slight-right-fill::before {
  content: "\\f835";
}

.bi-sign-turn-slight-right::before {
  content: "\\f836";
}

.bi-sign-yield-fill::before {
  content: "\\f837";
}

.bi-sign-yield::before {
  content: "\\f838";
}

.bi-ev-station-fill::before {
  content: "\\f839";
}

.bi-ev-station::before {
  content: "\\f83a";
}

.bi-fuel-pump-diesel-fill::before {
  content: "\\f83b";
}

.bi-fuel-pump-diesel::before {
  content: "\\f83c";
}

.bi-fuel-pump-fill::before {
  content: "\\f83d";
}

.bi-fuel-pump::before {
  content: "\\f83e";
}

.bi-0-circle-fill::before {
  content: "\\f83f";
}

.bi-0-circle::before {
  content: "\\f840";
}

.bi-0-square-fill::before {
  content: "\\f841";
}

.bi-0-square::before {
  content: "\\f842";
}

.bi-rocket-fill::before {
  content: "\\f843";
}

.bi-rocket-takeoff-fill::before {
  content: "\\f844";
}

.bi-rocket-takeoff::before {
  content: "\\f845";
}

.bi-rocket::before {
  content: "\\f846";
}

.bi-stripe::before {
  content: "\\f847";
}

.bi-subscript::before {
  content: "\\f848";
}

.bi-superscript::before {
  content: "\\f849";
}

.bi-trello::before {
  content: "\\f84a";
}

.bi-envelope-at-fill::before {
  content: "\\f84b";
}

.bi-envelope-at::before {
  content: "\\f84c";
}

.bi-regex::before {
  content: "\\f84d";
}

.bi-text-wrap::before {
  content: "\\f84e";
}

.bi-sign-dead-end-fill::before {
  content: "\\f84f";
}

.bi-sign-dead-end::before {
  content: "\\f850";
}

.bi-sign-do-not-enter-fill::before {
  content: "\\f851";
}

.bi-sign-do-not-enter::before {
  content: "\\f852";
}

.bi-sign-intersection-fill::before {
  content: "\\f853";
}

.bi-sign-intersection-side-fill::before {
  content: "\\f854";
}

.bi-sign-intersection-side::before {
  content: "\\f855";
}

.bi-sign-intersection-t-fill::before {
  content: "\\f856";
}

.bi-sign-intersection-t::before {
  content: "\\f857";
}

.bi-sign-intersection-y-fill::before {
  content: "\\f858";
}

.bi-sign-intersection-y::before {
  content: "\\f859";
}

.bi-sign-intersection::before {
  content: "\\f85a";
}

.bi-sign-merge-left-fill::before {
  content: "\\f85b";
}

.bi-sign-merge-left::before {
  content: "\\f85c";
}

.bi-sign-merge-right-fill::before {
  content: "\\f85d";
}

.bi-sign-merge-right::before {
  content: "\\f85e";
}

.bi-sign-no-left-turn-fill::before {
  content: "\\f85f";
}

.bi-sign-no-left-turn::before {
  content: "\\f860";
}

.bi-sign-no-parking-fill::before {
  content: "\\f861";
}

.bi-sign-no-parking::before {
  content: "\\f862";
}

.bi-sign-no-right-turn-fill::before {
  content: "\\f863";
}

.bi-sign-no-right-turn::before {
  content: "\\f864";
}

.bi-sign-railroad-fill::before {
  content: "\\f865";
}

.bi-sign-railroad::before {
  content: "\\f866";
}

.bi-building-add::before {
  content: "\\f867";
}

.bi-building-check::before {
  content: "\\f868";
}

.bi-building-dash::before {
  content: "\\f869";
}

.bi-building-down::before {
  content: "\\f86a";
}

.bi-building-exclamation::before {
  content: "\\f86b";
}

.bi-building-fill-add::before {
  content: "\\f86c";
}

.bi-building-fill-check::before {
  content: "\\f86d";
}

.bi-building-fill-dash::before {
  content: "\\f86e";
}

.bi-building-fill-down::before {
  content: "\\f86f";
}

.bi-building-fill-exclamation::before {
  content: "\\f870";
}

.bi-building-fill-gear::before {
  content: "\\f871";
}

.bi-building-fill-lock::before {
  content: "\\f872";
}

.bi-building-fill-slash::before {
  content: "\\f873";
}

.bi-building-fill-up::before {
  content: "\\f874";
}

.bi-building-fill-x::before {
  content: "\\f875";
}

.bi-building-fill::before {
  content: "\\f876";
}

.bi-building-gear::before {
  content: "\\f877";
}

.bi-building-lock::before {
  content: "\\f878";
}

.bi-building-slash::before {
  content: "\\f879";
}

.bi-building-up::before {
  content: "\\f87a";
}

.bi-building-x::before {
  content: "\\f87b";
}

.bi-buildings-fill::before {
  content: "\\f87c";
}

.bi-buildings::before {
  content: "\\f87d";
}

.bi-bus-front-fill::before {
  content: "\\f87e";
}

.bi-bus-front::before {
  content: "\\f87f";
}

.bi-ev-front-fill::before {
  content: "\\f880";
}

.bi-ev-front::before {
  content: "\\f881";
}

.bi-globe-americas::before {
  content: "\\f882";
}

.bi-globe-asia-australia::before {
  content: "\\f883";
}

.bi-globe-central-south-asia::before {
  content: "\\f884";
}

.bi-globe-europe-africa::before {
  content: "\\f885";
}

.bi-house-add-fill::before {
  content: "\\f886";
}

.bi-house-add::before {
  content: "\\f887";
}

.bi-house-check-fill::before {
  content: "\\f888";
}

.bi-house-check::before {
  content: "\\f889";
}

.bi-house-dash-fill::before {
  content: "\\f88a";
}

.bi-house-dash::before {
  content: "\\f88b";
}

.bi-house-down-fill::before {
  content: "\\f88c";
}

.bi-house-down::before {
  content: "\\f88d";
}

.bi-house-exclamation-fill::before {
  content: "\\f88e";
}

.bi-house-exclamation::before {
  content: "\\f88f";
}

.bi-house-gear-fill::before {
  content: "\\f890";
}

.bi-house-gear::before {
  content: "\\f891";
}

.bi-house-lock-fill::before {
  content: "\\f892";
}

.bi-house-lock::before {
  content: "\\f893";
}

.bi-house-slash-fill::before {
  content: "\\f894";
}

.bi-house-slash::before {
  content: "\\f895";
}

.bi-house-up-fill::before {
  content: "\\f896";
}

.bi-house-up::before {
  content: "\\f897";
}

.bi-house-x-fill::before {
  content: "\\f898";
}

.bi-house-x::before {
  content: "\\f899";
}

.bi-person-add::before {
  content: "\\f89a";
}

.bi-person-down::before {
  content: "\\f89b";
}

.bi-person-exclamation::before {
  content: "\\f89c";
}

.bi-person-fill-add::before {
  content: "\\f89d";
}

.bi-person-fill-check::before {
  content: "\\f89e";
}

.bi-person-fill-dash::before {
  content: "\\f89f";
}

.bi-person-fill-down::before {
  content: "\\f8a0";
}

.bi-person-fill-exclamation::before {
  content: "\\f8a1";
}

.bi-person-fill-gear::before {
  content: "\\f8a2";
}

.bi-person-fill-lock::before {
  content: "\\f8a3";
}

.bi-person-fill-slash::before {
  content: "\\f8a4";
}

.bi-person-fill-up::before {
  content: "\\f8a5";
}

.bi-person-fill-x::before {
  content: "\\f8a6";
}

.bi-person-gear::before {
  content: "\\f8a7";
}

.bi-person-lock::before {
  content: "\\f8a8";
}

.bi-person-slash::before {
  content: "\\f8a9";
}

.bi-person-up::before {
  content: "\\f8aa";
}

.bi-scooter::before {
  content: "\\f8ab";
}

.bi-taxi-front-fill::before {
  content: "\\f8ac";
}

.bi-taxi-front::before {
  content: "\\f8ad";
}

.bi-amd::before {
  content: "\\f8ae";
}

.bi-database-add::before {
  content: "\\f8af";
}

.bi-database-check::before {
  content: "\\f8b0";
}

.bi-database-dash::before {
  content: "\\f8b1";
}

.bi-database-down::before {
  content: "\\f8b2";
}

.bi-database-exclamation::before {
  content: "\\f8b3";
}

.bi-database-fill-add::before {
  content: "\\f8b4";
}

.bi-database-fill-check::before {
  content: "\\f8b5";
}

.bi-database-fill-dash::before {
  content: "\\f8b6";
}

.bi-database-fill-down::before {
  content: "\\f8b7";
}

.bi-database-fill-exclamation::before {
  content: "\\f8b8";
}

.bi-database-fill-gear::before {
  content: "\\f8b9";
}

.bi-database-fill-lock::before {
  content: "\\f8ba";
}

.bi-database-fill-slash::before {
  content: "\\f8bb";
}

.bi-database-fill-up::before {
  content: "\\f8bc";
}

.bi-database-fill-x::before {
  content: "\\f8bd";
}

.bi-database-fill::before {
  content: "\\f8be";
}

.bi-database-gear::before {
  content: "\\f8bf";
}

.bi-database-lock::before {
  content: "\\f8c0";
}

.bi-database-slash::before {
  content: "\\f8c1";
}

.bi-database-up::before {
  content: "\\f8c2";
}

.bi-database-x::before {
  content: "\\f8c3";
}

.bi-database::before {
  content: "\\f8c4";
}

.bi-houses-fill::before {
  content: "\\f8c5";
}

.bi-houses::before {
  content: "\\f8c6";
}

.bi-nvidia::before {
  content: "\\f8c7";
}

.bi-person-vcard-fill::before {
  content: "\\f8c8";
}

.bi-person-vcard::before {
  content: "\\f8c9";
}

.bi-sina-weibo::before {
  content: "\\f8ca";
}

.bi-tencent-qq::before {
  content: "\\f8cb";
}

.bi-wikipedia::before {
  content: "\\f8cc";
}

.bi-alphabet-uppercase::before {
  content: "\\f2a5";
}

.bi-alphabet::before {
  content: "\\f68a";
}

.bi-amazon::before {
  content: "\\f68d";
}

.bi-arrows-collapse-vertical::before {
  content: "\\f690";
}

.bi-arrows-expand-vertical::before {
  content: "\\f695";
}

.bi-arrows-vertical::before {
  content: "\\f698";
}

.bi-arrows::before {
  content: "\\f6a2";
}

.bi-ban-fill::before {
  content: "\\f6a3";
}

.bi-ban::before {
  content: "\\f6b6";
}

.bi-bing::before {
  content: "\\f6c2";
}

.bi-cake::before {
  content: "\\f6e0";
}

.bi-cake2::before {
  content: "\\f6ed";
}

.bi-cookie::before {
  content: "\\f6ee";
}

.bi-copy::before {
  content: "\\f759";
}

.bi-crosshair::before {
  content: "\\f769";
}

.bi-crosshair2::before {
  content: "\\f794";
}

.bi-emoji-astonished-fill::before {
  content: "\\f795";
}

.bi-emoji-astonished::before {
  content: "\\f79a";
}

.bi-emoji-grimace-fill::before {
  content: "\\f79b";
}

.bi-emoji-grimace::before {
  content: "\\f7a0";
}

.bi-emoji-grin-fill::before {
  content: "\\f7a1";
}

.bi-emoji-grin::before {
  content: "\\f7a6";
}

.bi-emoji-surprise-fill::before {
  content: "\\f7a7";
}

.bi-emoji-surprise::before {
  content: "\\f7ac";
}

.bi-emoji-tear-fill::before {
  content: "\\f7ad";
}

.bi-emoji-tear::before {
  content: "\\f7b2";
}

.bi-envelope-arrow-down-fill::before {
  content: "\\f7b3";
}

.bi-envelope-arrow-down::before {
  content: "\\f7b8";
}

.bi-envelope-arrow-up-fill::before {
  content: "\\f7b9";
}

.bi-envelope-arrow-up::before {
  content: "\\f7be";
}

.bi-feather::before {
  content: "\\f7bf";
}

.bi-feather2::before {
  content: "\\f7c4";
}

.bi-floppy-fill::before {
  content: "\\f7c5";
}

.bi-floppy::before {
  content: "\\f7d8";
}

.bi-floppy2-fill::before {
  content: "\\f7d9";
}

.bi-floppy2::before {
  content: "\\f7e4";
}

.bi-gitlab::before {
  content: "\\f7e5";
}

.bi-highlighter::before {
  content: "\\f7f8";
}

.bi-marker-tip::before {
  content: "\\f802";
}

.bi-nvme-fill::before {
  content: "\\f803";
}

.bi-nvme::before {
  content: "\\f80c";
}

.bi-opencollective::before {
  content: "\\f80d";
}

.bi-pci-card-network::before {
  content: "\\f8cd";
}

.bi-pci-card-sound::before {
  content: "\\f8ce";
}

.bi-radar::before {
  content: "\\f8cf";
}

.bi-send-arrow-down-fill::before {
  content: "\\f8d0";
}

.bi-send-arrow-down::before {
  content: "\\f8d1";
}

.bi-send-arrow-up-fill::before {
  content: "\\f8d2";
}

.bi-send-arrow-up::before {
  content: "\\f8d3";
}

.bi-sim-slash-fill::before {
  content: "\\f8d4";
}

.bi-sim-slash::before {
  content: "\\f8d5";
}

.bi-sourceforge::before {
  content: "\\f8d6";
}

.bi-substack::before {
  content: "\\f8d7";
}

.bi-threads-fill::before {
  content: "\\f8d8";
}

.bi-threads::before {
  content: "\\f8d9";
}

.bi-transparency::before {
  content: "\\f8da";
}

.bi-twitter-x::before {
  content: "\\f8db";
}

.bi-type-h4::before {
  content: "\\f8dc";
}

.bi-type-h5::before {
  content: "\\f8dd";
}

.bi-type-h6::before {
  content: "\\f8de";
}

.bi-backpack-fill::before {
  content: "\\f8df";
}

.bi-backpack::before {
  content: "\\f8e0";
}

.bi-backpack2-fill::before {
  content: "\\f8e1";
}

.bi-backpack2::before {
  content: "\\f8e2";
}

.bi-backpack3-fill::before {
  content: "\\f8e3";
}

.bi-backpack3::before {
  content: "\\f8e4";
}

.bi-backpack4-fill::before {
  content: "\\f8e5";
}

.bi-backpack4::before {
  content: "\\f8e6";
}

.bi-brilliance::before {
  content: "\\f8e7";
}

.bi-cake-fill::before {
  content: "\\f8e8";
}

.bi-cake2-fill::before {
  content: "\\f8e9";
}

.bi-duffle-fill::before {
  content: "\\f8ea";
}

.bi-duffle::before {
  content: "\\f8eb";
}

.bi-exposure::before {
  content: "\\f8ec";
}

.bi-gender-neuter::before {
  content: "\\f8ed";
}

.bi-highlights::before {
  content: "\\f8ee";
}

.bi-luggage-fill::before {
  content: "\\f8ef";
}

.bi-luggage::before {
  content: "\\f8f0";
}

.bi-mailbox-flag::before {
  content: "\\f8f1";
}

.bi-mailbox2-flag::before {
  content: "\\f8f2";
}

.bi-noise-reduction::before {
  content: "\\f8f3";
}

.bi-passport-fill::before {
  content: "\\f8f4";
}

.bi-passport::before {
  content: "\\f8f5";
}

.bi-person-arms-up::before {
  content: "\\f8f6";
}

.bi-person-raised-hand::before {
  content: "\\f8f7";
}

.bi-person-standing-dress::before {
  content: "\\f8f8";
}

.bi-person-standing::before {
  content: "\\f8f9";
}

.bi-person-walking::before {
  content: "\\f8fa";
}

.bi-person-wheelchair::before {
  content: "\\f8fb";
}

.bi-shadows::before {
  content: "\\f8fc";
}

.bi-suitcase-fill::before {
  content: "\\f8fd";
}

.bi-suitcase-lg-fill::before {
  content: "\\f8fe";
}

.bi-suitcase-lg::before {
  content: "\\f8ff";
}

.bi-suitcase::before {
  content: "豈";
}

.bi-suitcase2-fill::before {
  content: "更";
}

.bi-suitcase2::before {
  content: "車";
}

.bi-vignette::before {
  content: "賈";
}

.sidebarArea {
  flex-shrink: 0;
  width: 310px;
  background-color: #fff;
  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));
  position: relative;
  z-index: 1;
}
.sidebarArea .sidenav-bg:hover {
  background-color: #f8f9fa;
  border-radius: 3rem;
}
.sidebarArea .sidenav-bg:hover a {
  color: text-primary !important;
}

@media (max-width: 991.98px) {
  .sidebarArea {
    position: fixed;
    height: 100%;
    overflow: auto;
    z-index: 1;
    margin-left: -320px;
    transition: 0.2s ease-in;
  }
  .sidebarArea.showSidebar {
    margin-left: 0px;
  }
}
.pageWrapper {
  min-height: 100vh;
}

.contentArea {
  flex-grow: 1;
}

.wrapper {
  max-width: 1300px;
  margin: 0 auto;
}

.card {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
}

.circle-box {
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 100%;
}
.circle-box.lg-box {
  width: 60px;
  height: 60px;
  font-size: 21px;
  line-height: 60px;
}

.button-group .btn {
  margin: 3px;
}

.table > :not(:first-child) {
  border-top: 2px solid;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap-icons/font/bootstrap-icons.scss","webpack://./src/assets/scss/layout/_sidebar.scss","webpack://./src/assets/scss/layout/_container.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEd;EACE,cAAA;EACA,WAAA;EACA,WAAA;ADAJ;;AEHE;EACE,sBAAA;EACA,iFAAA;AFMJ;;AERE;EACE,sBAAA;EACA,mFAAA;AFWJ;;AEbE;EACE,sBAAA;EACA,iFAAA;AFgBJ;;AElBE;EACE,sBAAA;EACA,8EAAA;AFqBJ;;AEvBE;EACE,sBAAA;EACA,iFAAA;AF0BJ;;AE5BE;EACE,sBAAA;EACA,gFAAA;AF+BJ;;AEjCE;EACE,sBAAA;EACA,+EAAA;AFoCJ;;AEtCE;EACE,sBAAA;EACA,8EAAA;AFyCJ;;AG3CE;EACE,wEAAA;EACA,kGAAA;AH8CJ;AG3CM;EAGE,8DAAA;EACA,wFAAA;AH2CR;;AGpDE;EACE,0EAAA;EACA,oGAAA;AHuDJ;AGpDM;EAGE,8DAAA;EACA,wFAAA;AHoDR;;AG7DE;EACE,wEAAA;EACA,kGAAA;AHgEJ;AG7DM;EAGE,8DAAA;EACA,wFAAA;AH6DR;;AGtEE;EACE,qEAAA;EACA,+FAAA;AHyEJ;AGtEM;EAGE,+DAAA;EACA,yFAAA;AHsER;;AG/EE;EACE,wEAAA;EACA,kGAAA;AHkFJ;AG/EM;EAGE,+DAAA;EACA,yFAAA;AH+ER;;AGxFE;EACE,uEAAA;EACA,iGAAA;AH2FJ;AGxFM;EAGE,8DAAA;EACA,wFAAA;AHwFR;;AGjGE;EACE,sEAAA;EACA,gGAAA;AHoGJ;AGjGM;EAGE,gEAAA;EACA,0FAAA;AHiGR;;AG1GE;EACE,qEAAA;EACA,+FAAA;AH6GJ;AG1GM;EAGE,6DAAA;EACA,uFAAA;AH0GR;;AGnGA;EACE,+EAAA;EACA,yGAAA;AHsGF;AGnGI;EAEE,kFAAA;EACA,4GAAA;AHoGN;;AI9HA;EACE,UAAA;EAEA,kJAAA;AJgIF;;AKnIA;EACE,oBAAA;EACA,aC6c4B;ED5c5B,mBAAA;EACA,kFAAA;EACA,6BC2c4B;ED1c5B,2BAAA;ALsIF;AKpIE;EACE,cAAA;EACA,UCuc0B;EDtc1B,WCsc0B;EDrc1B,kBAAA;EEIE,sCFHF;ALsIJ;AO/HM;EFZJ;IEaM,gBAAA;EPkIN;AACF;;AKpII;EACE,mEAAA;ALuIN;;AQ1JA;EACE,kBAAA;EACA,WAAA;AR6JF;AQ3JE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AR6JJ;AQ1JE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AR4JJ;;AQvJE;EACE,uBAAA;AR0JJ;;AQ3JE;EACE,sBAAA;AR8JJ;;AQ/JE;EACE,yBAAA;ARkKJ;;AQnKE;EACE,iCAAA;ARsKJ;;AS3LA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aHumCkC;ANz6BpC;;AS3LA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aH+lCkC;ANj6BpC;;AStLI;EACE,gBAAA;EACA,MAAA;EACA,aHmlC8B;AN15BpC;;AStLI;EACE,gBAAA;EACA,SAAA;EACA,aH6kC8B;ANp5BpC;;AU1JI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN74BlC;ESnME;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENx4BlC;AACF;AUvKI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENj4BlC;ES/ME;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN53BlC;AACF;AUnLI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENr3BlC;ES3NE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENh3BlC;AACF;AU/LI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENz2BlC;ESvOE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENp2BlC;AACF;AU3MI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN71BlC;ESnPE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENx1BlC;AACF;AWrRA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AXuRF;;AWpRA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AXuRF;;AY/RA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AbgSF;Aa7RE;;EACE,6BAAA;AbgSJ;;Ac9SE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,URgcsC;EQ/btC,WAAA;AdiTJ;;AezTA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AhB6TF;;AiBnUA;EACE,qBAAA;EACA,mBAAA;EACA,6BXisB4B;EWhsB5B,eAAA;EACA,8BAAA;EACA,aX2rB4B;ANrX9B;;AkB1QQ;EAOI,mCAAA;AlBuQZ;;AkB9QQ;EAOI,8BAAA;AlB2QZ;;AkBlRQ;EAOI,iCAAA;AlB+QZ;;AkBtRQ;EAOI,iCAAA;AlBmRZ;;AkB1RQ;EAOI,sCAAA;AlBuRZ;;AkB9RQ;EAOI,mCAAA;AlB2RZ;;AkBlSQ;EAOI,sBAAA;AlB+RZ;;AkBtSQ;EAOI,uBAAA;AlBmSZ;;AkB1SQ;EAOI,sBAAA;AlBuSZ;;AkB9SQ;EAOI,8BAAA;AlB2SZ;;AkBlTQ;EAOI,4BAAA;AlB+SZ;;AkBtTQ;EAOI,2BAAA;AlBmTZ;;AkB1TQ;EAOI,iCAAA;AlBuTZ;;AkB9TQ;EAOI,2BAAA;AlB2TZ;;AkBlUQ;EAOI,qBAAA;AlB+TZ;;AkBtUQ;EAOI,wBAAA;AlBmUZ;;AkB1UQ;EAOI,uBAAA;AlBuUZ;;AkB9UQ;EAOI,wBAAA;AlB2UZ;;AkBlVQ;EAOI,qBAAA;AlB+UZ;;AkBtVQ;EAOI,yBAAA;AlBmVZ;;AkB1VQ;EAOI,2BAAA;AlBuVZ;;AkB9VQ;EAOI,4BAAA;AlB2VZ;;AkBlWQ;EAOI,2BAAA;AlB+VZ;;AkBtWQ;EAOI,2BAAA;AlBmWZ;;AkB1WQ;EAOI,6BAAA;AlBuWZ;;AkB9WQ;EAOI,8BAAA;AlB2WZ;;AkBlXQ;EAOI,6BAAA;AlB+WZ;;AkBtXQ;EAOI,2BAAA;AlBmXZ;;AkB1XQ;EAOI,6BAAA;AlBuXZ;;AkB9XQ;EAOI,8BAAA;AlB2XZ;;AkBlYQ;EAOI,6BAAA;AlB+XZ;;AkBtYQ;EAOI,0BAAA;AlBmYZ;;AkB1YQ;EAOI,gCAAA;AlBuYZ;;AkB9YQ;EAOI,yBAAA;AlB2YZ;;AkBlZQ;EAOI,wBAAA;AlB+YZ;;AkBtZQ;EAOI,+BAAA;AlBmZZ;;AkB1ZQ;EAOI,yBAAA;AlBuZZ;;AkB9ZQ;EAOI,6BAAA;AlB2ZZ;;AkBlaQ;EAOI,8BAAA;AlB+ZZ;;AkBtaQ;EAOI,wBAAA;AlBmaZ;;AkB1aQ;EAOI,+BAAA;AlBuaZ;;AkB9aQ;EAOI,wBAAA;AlB2aZ;;AkBlbQ;EAOI,2CAAA;AlB+aZ;;AkBtbQ;EAOI,8CAAA;AlBmbZ;;AkB1bQ;EAOI,8CAAA;AlBubZ;;AkB9bQ;EAOI,2BAAA;AlB2bZ;;AkB5cQ;EACE,gFAAA;AlB+cV;;AkBhdQ;EACE,kFAAA;AlBmdV;;AkBpdQ;EACE,gFAAA;AlBudV;;AkBxdQ;EACE,6EAAA;AlB2dV;;AkB5dQ;EACE,gFAAA;AlB+dV;;AkBheQ;EACE,+EAAA;AlBmeV;;AkBpeQ;EACE,8EAAA;AlBueV;;AkBxeQ;EACE,6EAAA;AlB2eV;;AkBleQ;EAOI,2BAAA;AlB+dZ;;AkBteQ;EAOI,6BAAA;AlBmeZ;;AkB1eQ;EAOI,6BAAA;AlBueZ;;AkB9eQ;EAOI,0BAAA;AlB2eZ;;AkBlfQ;EAOI,2BAAA;AlB+eZ;;AkBtfQ;EAOI,iBAAA;AlBmfZ;;AkB1fQ;EAOI,mBAAA;AlBufZ;;AkB9fQ;EAOI,oBAAA;AlB2fZ;;AkBlgBQ;EAOI,oBAAA;AlB+fZ;;AkBtgBQ;EAOI,sBAAA;AlBmgBZ;;AkB1gBQ;EAOI,uBAAA;AlBugBZ;;AkB9gBQ;EAOI,kBAAA;AlB2gBZ;;AkBlhBQ;EAOI,oBAAA;AlB+gBZ;;AkBthBQ;EAOI,qBAAA;AlBmhBZ;;AkB1hBQ;EAOI,mBAAA;AlBuhBZ;;AkB9hBQ;EAOI,qBAAA;AlB2hBZ;;AkBliBQ;EAOI,sBAAA;AlB+hBZ;;AkBtiBQ;EAOI,2CAAA;AlBmiBZ;;AkB1iBQ;EAOI,sCAAA;AlBuiBZ;;AkB9iBQ;EAOI,sCAAA;AlB2iBZ;;AkBljBQ;EAOI,uFAAA;AlB+iBZ;;AkBtjBQ;EAOI,oBAAA;AlBmjBZ;;AkB1jBQ;EAOI,2FAAA;AlBujBZ;;AkB9jBQ;EAOI,wBAAA;AlB2jBZ;;AkBlkBQ;EAOI,6FAAA;AlB+jBZ;;AkBtkBQ;EAOI,0BAAA;AlBmkBZ;;AkB1kBQ;EAOI,8FAAA;AlBukBZ;;AkB9kBQ;EAOI,2BAAA;AlB2kBZ;;AkBllBQ;EAOI,4FAAA;AlB+kBZ;;AkBtlBQ;EAOI,yBAAA;AlBmlBZ;;AkB1lBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBwlBZ;;AkB/lBQ;EAIQ,sBAAA;EAGJ,gFAAA;AlB6lBZ;;AkBpmBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBkmBZ;;AkBzmBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlBumBZ;;AkB9mBQ;EAIQ,sBAAA;EAGJ,8EAAA;AlB4mBZ;;AkBnnBQ;EAIQ,sBAAA;EAGJ,6EAAA;AlBinBZ;;AkBxnBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBsnBZ;;AkB7nBQ;EAIQ,sBAAA;EAGJ,2EAAA;AlB2nBZ;;AkBloBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBgoBZ;;AkBvoBQ;EAIQ,sBAAA;EAGJ,4EAAA;AlBqoBZ;;AkB5oBQ;EAOI,wDAAA;AlByoBZ;;AkBhpBQ;EAOI,0DAAA;AlB6oBZ;;AkBppBQ;EAOI,wDAAA;AlBipBZ;;AkBxpBQ;EAOI,qDAAA;AlBqpBZ;;AkB5pBQ;EAOI,wDAAA;AlBypBZ;;AkBhqBQ;EAOI,uDAAA;AlB6pBZ;;AkBpqBQ;EAOI,sDAAA;AlBiqBZ;;AkBxqBQ;EAOI,qDAAA;AlBqqBZ;;AkB5qBQ;EAOI,4BAAA;AlByqBZ;;AkBhrBQ;EAOI,4BAAA;AlB6qBZ;;AkBprBQ;EAOI,4BAAA;AlBirBZ;;AkBxrBQ;EAOI,4BAAA;AlBqrBZ;;AkB5rBQ;EAOI,4BAAA;AlByrBZ;;AkB1sBQ;EACE,wBAAA;AlB6sBV;;AkB9sBQ;EACE,yBAAA;AlBitBV;;AkBltBQ;EACE,wBAAA;AlBqtBV;;AkBttBQ;EACE,yBAAA;AlBytBV;;AkB1tBQ;EACE,sBAAA;AlB6tBV;;AkBptBQ;EAOI,qBAAA;AlBitBZ;;AkBxtBQ;EAOI,qBAAA;AlBqtBZ;;AkB5tBQ;EAOI,qBAAA;AlBytBZ;;AkBhuBQ;EAOI,sBAAA;AlB6tBZ;;AkBpuBQ;EAOI,sBAAA;AlBiuBZ;;AkBxuBQ;EAOI,0BAAA;AlBquBZ;;AkB5uBQ;EAOI,uBAAA;AlByuBZ;;AkBhvBQ;EAOI,2BAAA;AlB6uBZ;;AkBpvBQ;EAOI,sBAAA;AlBivBZ;;AkBxvBQ;EAOI,sBAAA;AlBqvBZ;;AkB5vBQ;EAOI,sBAAA;AlByvBZ;;AkBhwBQ;EAOI,uBAAA;AlB6vBZ;;AkBpwBQ;EAOI,uBAAA;AlBiwBZ;;AkBxwBQ;EAOI,2BAAA;AlBqwBZ;;AkB5wBQ;EAOI,wBAAA;AlBywBZ;;AkBhxBQ;EAOI,4BAAA;AlB6wBZ;;AkBpxBQ;EAOI,yBAAA;AlBixBZ;;AkBxxBQ;EAOI,8BAAA;AlBqxBZ;;AkB5xBQ;EAOI,iCAAA;AlByxBZ;;AkBhyBQ;EAOI,sCAAA;AlB6xBZ;;AkBpyBQ;EAOI,yCAAA;AlBiyBZ;;AkBxyBQ;EAOI,uBAAA;AlBqyBZ;;AkB5yBQ;EAOI,uBAAA;AlByyBZ;;AkBhzBQ;EAOI,yBAAA;AlB6yBZ;;AkBpzBQ;EAOI,yBAAA;AlBizBZ;;AkBxzBQ;EAOI,0BAAA;AlBqzBZ;;AkB5zBQ;EAOI,4BAAA;AlByzBZ;;AkBh0BQ;EAOI,kCAAA;AlB6zBZ;;AkBp0BQ;EAOI,sCAAA;AlBi0BZ;;AkBx0BQ;EAOI,oCAAA;AlBq0BZ;;AkB50BQ;EAOI,kCAAA;AlBy0BZ;;AkBh1BQ;EAOI,yCAAA;AlB60BZ;;AkBp1BQ;EAOI,wCAAA;AlBi1BZ;;AkBx1BQ;EAOI,wCAAA;AlBq1BZ;;AkB51BQ;EAOI,kCAAA;AlBy1BZ;;AkBh2BQ;EAOI,gCAAA;AlB61BZ;;AkBp2BQ;EAOI,8BAAA;AlBi2BZ;;AkBx2BQ;EAOI,gCAAA;AlBq2BZ;;AkB52BQ;EAOI,+BAAA;AlBy2BZ;;AkBh3BQ;EAOI,oCAAA;AlB62BZ;;AkBp3BQ;EAOI,kCAAA;AlBi3BZ;;AkBx3BQ;EAOI,gCAAA;AlBq3BZ;;AkB53BQ;EAOI,uCAAA;AlBy3BZ;;AkBh4BQ;EAOI,sCAAA;AlB63BZ;;AkBp4BQ;EAOI,iCAAA;AlBi4BZ;;AkBx4BQ;EAOI,2BAAA;AlBq4BZ;;AkB54BQ;EAOI,iCAAA;AlBy4BZ;;AkBh5BQ;EAOI,+BAAA;AlB64BZ;;AkBp5BQ;EAOI,6BAAA;AlBi5BZ;;AkBx5BQ;EAOI,+BAAA;AlBq5BZ;;AkB55BQ;EAOI,8BAAA;AlBy5BZ;;AkBh6BQ;EAOI,oBAAA;AlB65BZ;;AkBp6BQ;EAOI,mBAAA;AlBi6BZ;;AkBx6BQ;EAOI,mBAAA;AlBq6BZ;;AkB56BQ;EAOI,mBAAA;AlBy6BZ;;AkBh7BQ;EAOI,mBAAA;AlB66BZ;;AkBp7BQ;EAOI,mBAAA;AlBi7BZ;;AkBx7BQ;EAOI,mBAAA;AlBq7BZ;;AkB57BQ;EAOI,mBAAA;AlBy7BZ;;AkBh8BQ;EAOI,oBAAA;AlB67BZ;;AkBp8BQ;EAOI,0BAAA;AlBi8BZ;;AkBx8BQ;EAOI,yBAAA;AlBq8BZ;;AkB58BQ;EAOI,uBAAA;AlBy8BZ;;AkBh9BQ;EAOI,yBAAA;AlB68BZ;;AkBp9BQ;EAOI,uBAAA;AlBi9BZ;;AkBx9BQ;EAOI,uBAAA;AlBq9BZ;;AkB59BQ;EAOI,0BAAA;EAAA,yBAAA;AlB09BZ;;AkBj+BQ;EAOI,gCAAA;EAAA,+BAAA;AlB+9BZ;;AkBt+BQ;EAOI,+BAAA;EAAA,8BAAA;AlBo+BZ;;AkB3+BQ;EAOI,6BAAA;EAAA,4BAAA;AlBy+BZ;;AkBh/BQ;EAOI,+BAAA;EAAA,8BAAA;AlB8+BZ;;AkBr/BQ;EAOI,6BAAA;EAAA,4BAAA;AlBm/BZ;;AkB1/BQ;EAOI,6BAAA;EAAA,4BAAA;AlBw/BZ;;AkB//BQ;EAOI,wBAAA;EAAA,2BAAA;AlB6/BZ;;AkBpgCQ;EAOI,8BAAA;EAAA,iCAAA;AlBkgCZ;;AkBzgCQ;EAOI,6BAAA;EAAA,gCAAA;AlBugCZ;;AkB9gCQ;EAOI,2BAAA;EAAA,8BAAA;AlB4gCZ;;AkBnhCQ;EAOI,6BAAA;EAAA,gCAAA;AlBihCZ;;AkBxhCQ;EAOI,2BAAA;EAAA,8BAAA;AlBshCZ;;AkB7hCQ;EAOI,2BAAA;EAAA,8BAAA;AlB2hCZ;;AkBliCQ;EAOI,wBAAA;AlB+hCZ;;AkBtiCQ;EAOI,8BAAA;AlBmiCZ;;AkB1iCQ;EAOI,6BAAA;AlBuiCZ;;AkB9iCQ;EAOI,2BAAA;AlB2iCZ;;AkBljCQ;EAOI,6BAAA;AlB+iCZ;;AkBtjCQ;EAOI,2BAAA;AlBmjCZ;;AkB1jCQ;EAOI,2BAAA;AlBujCZ;;AkB9jCQ;EAOI,0BAAA;AlB2jCZ;;AkBlkCQ;EAOI,gCAAA;AlB+jCZ;;AkBtkCQ;EAOI,+BAAA;AlBmkCZ;;AkB1kCQ;EAOI,6BAAA;AlBukCZ;;AkB9kCQ;EAOI,+BAAA;AlB2kCZ;;AkBllCQ;EAOI,6BAAA;AlB+kCZ;;AkBtlCQ;EAOI,6BAAA;AlBmlCZ;;AkB1lCQ;EAOI,2BAAA;AlBulCZ;;AkB9lCQ;EAOI,iCAAA;AlB2lCZ;;AkBlmCQ;EAOI,gCAAA;AlB+lCZ;;AkBtmCQ;EAOI,8BAAA;AlBmmCZ;;AkB1mCQ;EAOI,gCAAA;AlBumCZ;;AkB9mCQ;EAOI,8BAAA;AlB2mCZ;;AkBlnCQ;EAOI,8BAAA;AlB+mCZ;;AkBtnCQ;EAOI,yBAAA;AlBmnCZ;;AkB1nCQ;EAOI,+BAAA;AlBunCZ;;AkB9nCQ;EAOI,8BAAA;AlB2nCZ;;AkBloCQ;EAOI,4BAAA;AlB+nCZ;;AkBtoCQ;EAOI,8BAAA;AlBmoCZ;;AkB1oCQ;EAOI,4BAAA;AlBuoCZ;;AkB9oCQ;EAOI,4BAAA;AlB2oCZ;;AkBlpCQ;EAOI,qBAAA;AlB+oCZ;;AkBtpCQ;EAOI,2BAAA;AlBmpCZ;;AkB1pCQ;EAOI,0BAAA;AlBupCZ;;AkB9pCQ;EAOI,wBAAA;AlB2pCZ;;AkBlqCQ;EAOI,0BAAA;AlB+pCZ;;AkBtqCQ;EAOI,wBAAA;AlBmqCZ;;AkB1qCQ;EAOI,2BAAA;EAAA,0BAAA;AlBwqCZ;;AkB/qCQ;EAOI,iCAAA;EAAA,gCAAA;AlB6qCZ;;AkBprCQ;EAOI,gCAAA;EAAA,+BAAA;AlBkrCZ;;AkBzrCQ;EAOI,8BAAA;EAAA,6BAAA;AlBurCZ;;AkB9rCQ;EAOI,gCAAA;EAAA,+BAAA;AlB4rCZ;;AkBnsCQ;EAOI,8BAAA;EAAA,6BAAA;AlBisCZ;;AkBxsCQ;EAOI,yBAAA;EAAA,4BAAA;AlBssCZ;;AkB7sCQ;EAOI,+BAAA;EAAA,kCAAA;AlB2sCZ;;AkBltCQ;EAOI,8BAAA;EAAA,iCAAA;AlBgtCZ;;AkBvtCQ;EAOI,4BAAA;EAAA,+BAAA;AlBqtCZ;;AkB5tCQ;EAOI,8BAAA;EAAA,iCAAA;AlB0tCZ;;AkBjuCQ;EAOI,4BAAA;EAAA,+BAAA;AlB+tCZ;;AkBtuCQ;EAOI,yBAAA;AlBmuCZ;;AkB1uCQ;EAOI,+BAAA;AlBuuCZ;;AkB9uCQ;EAOI,8BAAA;AlB2uCZ;;AkBlvCQ;EAOI,4BAAA;AlB+uCZ;;AkBtvCQ;EAOI,8BAAA;AlBmvCZ;;AkB1vCQ;EAOI,4BAAA;AlBuvCZ;;AkB9vCQ;EAOI,2BAAA;AlB2vCZ;;AkBlwCQ;EAOI,iCAAA;AlB+vCZ;;AkBtwCQ;EAOI,gCAAA;AlBmwCZ;;AkB1wCQ;EAOI,8BAAA;AlBuwCZ;;AkB9wCQ;EAOI,gCAAA;AlB2wCZ;;AkBlxCQ;EAOI,8BAAA;AlB+wCZ;;AkBtxCQ;EAOI,4BAAA;AlBmxCZ;;AkB1xCQ;EAOI,kCAAA;AlBuxCZ;;AkB9xCQ;EAOI,iCAAA;AlB2xCZ;;AkBlyCQ;EAOI,+BAAA;AlB+xCZ;;AkBtyCQ;EAOI,iCAAA;AlBmyCZ;;AkB1yCQ;EAOI,+BAAA;AlBuyCZ;;AkB9yCQ;EAOI,0BAAA;AlB2yCZ;;AkBlzCQ;EAOI,gCAAA;AlB+yCZ;;AkBtzCQ;EAOI,+BAAA;AlBmzCZ;;AkB1zCQ;EAOI,6BAAA;AlBuzCZ;;AkB9zCQ;EAOI,+BAAA;AlB2zCZ;;AkBl0CQ;EAOI,6BAAA;AlB+zCZ;;AkBt0CQ;EAOI,iBAAA;AlBm0CZ;;AkB10CQ;EAOI,uBAAA;AlBu0CZ;;AkB90CQ;EAOI,sBAAA;AlB20CZ;;AkBl1CQ;EAOI,oBAAA;AlB+0CZ;;AkBt1CQ;EAOI,sBAAA;AlBm1CZ;;AkB11CQ;EAOI,oBAAA;AlBu1CZ;;AkB91CQ;EAOI,qBAAA;AlB21CZ;;AkBl2CQ;EAOI,2BAAA;AlB+1CZ;;AkBt2CQ;EAOI,0BAAA;AlBm2CZ;;AkB12CQ;EAOI,wBAAA;AlBu2CZ;;AkB92CQ;EAOI,0BAAA;AlB22CZ;;AkBl3CQ;EAOI,wBAAA;AlB+2CZ;;AkBt3CQ;EAOI,wBAAA;AlBm3CZ;;AkB13CQ;EAOI,8BAAA;AlBu3CZ;;AkB93CQ;EAOI,6BAAA;AlB23CZ;;AkBl4CQ;EAOI,2BAAA;AlB+3CZ;;AkBt4CQ;EAOI,6BAAA;AlBm4CZ;;AkB14CQ;EAOI,2BAAA;AlBu4CZ;;AkB94CQ;EAOI,gDAAA;AlB24CZ;;AkBl5CQ;EAOI,4CAAA;AlB+4CZ;;AkBt5CQ;EAOI,4CAAA;AlBm5CZ;;AkB15CQ;EAOI,0CAAA;AlBu5CZ;;AkB95CQ;EAOI,4CAAA;AlB25CZ;;AkBl6CQ;EAOI,6BAAA;AlB+5CZ;;AkBt6CQ;EAOI,0BAAA;AlBm6CZ;;AkB16CQ;EAOI,6BAAA;AlBu6CZ;;AkB96CQ;EAOI,6BAAA;AlB26CZ;;AkBl7CQ;EAOI,+BAAA;AlB+6CZ;;AkBt7CQ;EAOI,2BAAA;AlBm7CZ;;AkB17CQ;EAOI,2BAAA;AlBu7CZ;;AkB97CQ;EAOI,2BAAA;AlB27CZ;;AkBl8CQ;EAOI,2BAAA;AlB+7CZ;;AkBt8CQ;EAOI,2BAAA;AlBm8CZ;;AkB18CQ;EAOI,8BAAA;AlBu8CZ;;AkB98CQ;EAOI,yBAAA;AlB28CZ;;AkBl9CQ;EAOI,4BAAA;AlB+8CZ;;AkBt9CQ;EAOI,2BAAA;AlBm9CZ;;AkB19CQ;EAOI,yBAAA;AlBu9CZ;;AkB99CQ;EAOI,2BAAA;AlB29CZ;;AkBl+CQ;EAOI,4BAAA;AlB+9CZ;;AkBt+CQ;EAOI,6BAAA;AlBm+CZ;;AkB1+CQ;EAOI,gCAAA;AlBu+CZ;;AkB9+CQ;EAOI,qCAAA;AlB2+CZ;;AkBl/CQ;EAOI,wCAAA;AlB++CZ;;AkBt/CQ;EAOI,oCAAA;AlBm/CZ;;AkB1/CQ;EAOI,oCAAA;AlBu/CZ;;AkB9/CQ;EAOI,qCAAA;AlB2/CZ;;AkBlgDQ;EAOI,8BAAA;AlB+/CZ;;AkBtgDQ;EAOI,8BAAA;AlBmgDZ;;AkBxhDQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AlBygDZ;;AkBt/CQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AlB+gDZ;;AkBthDQ;EAIQ,oBAAA;EAGJ,uEAAA;AlBohDZ;;AkB3hDQ;EAIQ,oBAAA;EAGJ,qEAAA;AlByhDZ;;AkBhiDQ;EAIQ,oBAAA;EAGJ,kEAAA;AlB8hDZ;;AkBriDQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBmiDZ;;AkB1iDQ;EAIQ,oBAAA;EAGJ,oEAAA;AlBwiDZ;;AkB/iDQ;EAIQ,oBAAA;EAGJ,mEAAA;AlB6iDZ;;AkBpjDQ;EAIQ,oBAAA;EAGJ,kEAAA;AlBkjDZ;;AkBzjDQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBujDZ;;AkB9jDQ;EAIQ,oBAAA;EAGJ,mEAAA;AlB4jDZ;;AkBnkDQ;EAIQ,oBAAA;EAGJ,wEAAA;AlBikDZ;;AkBxkDQ;EAIQ,oBAAA;EAGJ,2CAAA;AlBskDZ;;AkB7kDQ;EAIQ,oBAAA;EAGJ,oCAAA;AlB2kDZ;;AkBllDQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBglDZ;;AkBvlDQ;EAIQ,oBAAA;EAGJ,2CAAA;AlBqlDZ;;AkB5lDQ;EAIQ,oBAAA;EAGJ,0CAAA;AlB0lDZ;;AkBjmDQ;EAIQ,oBAAA;EAGJ,0CAAA;AlB+lDZ;;AkBtmDQ;EAIQ,oBAAA;EAGJ,yBAAA;AlBomDZ;;AkBrnDQ;EACE,uBAAA;AlBwnDV;;AkBznDQ;EACE,sBAAA;AlB4nDV;;AkB7nDQ;EACE,uBAAA;AlBgoDV;;AkBjoDQ;EACE,oBAAA;AlBooDV;;AkB3nDQ;EAOI,iDAAA;AlBwnDZ;;AkB/nDQ;EAOI,mDAAA;AlB4nDZ;;AkBnoDQ;EAOI,iDAAA;AlBgoDZ;;AkBvoDQ;EAOI,8CAAA;AlBooDZ;;AkB3oDQ;EAOI,iDAAA;AlBwoDZ;;AkB/oDQ;EAOI,gDAAA;AlB4oDZ;;AkBnpDQ;EAOI,+CAAA;AlBgpDZ;;AkBvpDQ;EAOI,8CAAA;AlBopDZ;;AkBrqDQ;EACE,sBAAA;AlBwqDV;;AkBpqDU;EACE,sBAAA;AlBuqDZ;;AkB7qDQ;EACE,uBAAA;AlBgrDV;;AkB5qDU;EACE,uBAAA;AlB+qDZ;;AkBrrDQ;EACE,sBAAA;AlBwrDV;;AkBprDU;EACE,sBAAA;AlBurDZ;;AkB7rDQ;EACE,uBAAA;AlBgsDV;;AkB5rDU;EACE,uBAAA;AlB+rDZ;;AkBrsDQ;EACE,oBAAA;AlBwsDV;;AkBpsDU;EACE,oBAAA;AlBusDZ;;AkBnsDQ;EAOI,yCAAA;AlBgsDZ;;AkB3rDU;EAOI,yCAAA;AlBwrDd;;AkB3sDQ;EAOI,wCAAA;AlBwsDZ;;AkBnsDU;EAOI,wCAAA;AlBgsDd;;AkBntDQ;EAOI,yCAAA;AlBgtDZ;;AkB3sDU;EAOI,yCAAA;AlBwsDd;;AkB3tDQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBytDZ;;AkBhuDQ;EAIQ,8BAAA;EAGJ,iGAAA;AlB8tDZ;;AkBruDQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBmuDZ;;AkB1uDQ;EAIQ,8BAAA;EAGJ,4FAAA;AlBwuDZ;;AkB/uDQ;EAIQ,8BAAA;EAGJ,+FAAA;AlB6uDZ;;AkBpvDQ;EAIQ,8BAAA;EAGJ,8FAAA;AlBkvDZ;;AkBzvDQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBuvDZ;;AkB9vDQ;EAIQ,8BAAA;EAGJ,4FAAA;AlB4vDZ;;AkBnwDQ;EAIQ,8BAAA;EAGJ,qGAAA;AlBiwDZ;;AkBlxDQ;EACE,8BAAA;AlBqxDV;;AkBjxDU;EACE,8BAAA;AlBoxDZ;;AkB1xDQ;EACE,gCAAA;AlB6xDV;;AkBzxDU;EACE,gCAAA;AlB4xDZ;;AkBlyDQ;EACE,iCAAA;AlBqyDV;;AkBjyDU;EACE,iCAAA;AlBoyDZ;;AkB1yDQ;EACE,gCAAA;AlB6yDV;;AkBzyDU;EACE,gCAAA;AlB4yDZ;;AkBlzDQ;EACE,iCAAA;AlBqzDV;;AkBjzDU;EACE,iCAAA;AlBozDZ;;AkB1zDQ;EACE,8BAAA;AlB6zDV;;AkBzzDU;EACE,8BAAA;AlB4zDZ;;AkBxzDQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBszDZ;;AkB7zDQ;EAIQ,kBAAA;EAGJ,gFAAA;AlB2zDZ;;AkBl0DQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBg0DZ;;AkBv0DQ;EAIQ,kBAAA;EAGJ,2EAAA;AlBq0DZ;;AkB50DQ;EAIQ,kBAAA;EAGJ,8EAAA;AlB00DZ;;AkBj1DQ;EAIQ,kBAAA;EAGJ,6EAAA;AlB+0DZ;;AkBt1DQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBo1DZ;;AkB31DQ;EAIQ,kBAAA;EAGJ,2EAAA;AlBy1DZ;;AkBh2DQ;EAIQ,kBAAA;EAGJ,4EAAA;AlB81DZ;;AkBr2DQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBm2DZ;;AkB12DQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBw2DZ;;AkB/2DQ;EAIQ,kBAAA;EAGJ,wCAAA;AlB62DZ;;AkBp3DQ;EAIQ,kBAAA;EAGJ,mFAAA;AlBk3DZ;;AkBz3DQ;EAIQ,kBAAA;EAGJ,kFAAA;AlBu3DZ;;AkBx4DQ;EACE,oBAAA;AlB24DV;;AkB54DQ;EACE,qBAAA;AlB+4DV;;AkBh5DQ;EACE,oBAAA;AlBm5DV;;AkBp5DQ;EACE,qBAAA;AlBu5DV;;AkBx5DQ;EACE,kBAAA;AlB25DV;;AkBl5DQ;EAOI,wDAAA;AlB+4DZ;;AkBt5DQ;EAOI,0DAAA;AlBm5DZ;;AkB15DQ;EAOI,wDAAA;AlBu5DZ;;AkB95DQ;EAOI,qDAAA;AlB25DZ;;AkBl6DQ;EAOI,wDAAA;AlB+5DZ;;AkBt6DQ;EAOI,uDAAA;AlBm6DZ;;AkB16DQ;EAOI,sDAAA;AlBu6DZ;;AkB96DQ;EAOI,qDAAA;AlB26DZ;;AkBl7DQ;EAOI,+CAAA;AlB+6DZ;;AkBt7DQ;EAOI,mCAAA;UAAA,2BAAA;AlBm7DZ;;AkB17DQ;EAOI,oCAAA;UAAA,4BAAA;AlBu7DZ;;AkB97DQ;EAOI,oCAAA;UAAA,4BAAA;AlB27DZ;;AkBl8DQ;EAOI,+BAAA;AlB+7DZ;;AkBt8DQ;EAOI,+BAAA;AlBm8DZ;;AkB18DQ;EAOI,iDAAA;AlBu8DZ;;AkB98DQ;EAOI,2BAAA;AlB28DZ;;AkBl9DQ;EAOI,oDAAA;AlB+8DZ;;AkBt9DQ;EAOI,iDAAA;AlBm9DZ;;AkB19DQ;EAOI,oDAAA;AlBu9DZ;;AkB99DQ;EAOI,oDAAA;AlB29DZ;;AkBl+DQ;EAOI,qDAAA;AlB+9DZ;;AkBt+DQ;EAOI,6BAAA;AlBm+DZ;;AkB1+DQ;EAOI,sDAAA;AlBu+DZ;;AkB9+DQ;EAOI,0DAAA;EAAA,2DAAA;AlB4+DZ;;AkBn/DQ;EAOI,oCAAA;EAAA,qCAAA;AlBi/DZ;;AkBx/DQ;EAOI,6DAAA;EAAA,8DAAA;AlBs/DZ;;AkB7/DQ;EAOI,0DAAA;EAAA,2DAAA;AlB2/DZ;;AkBlgEQ;EAOI,6DAAA;EAAA,8DAAA;AlBggEZ;;AkBvgEQ;EAOI,6DAAA;EAAA,8DAAA;AlBqgEZ;;AkB5gEQ;EAOI,8DAAA;EAAA,+DAAA;AlB0gEZ;;AkBjhEQ;EAOI,sCAAA;EAAA,uCAAA;AlB+gEZ;;AkBthEQ;EAOI,+DAAA;EAAA,gEAAA;AlBohEZ;;AkB3hEQ;EAOI,2DAAA;EAAA,8DAAA;AlByhEZ;;AkBhiEQ;EAOI,qCAAA;EAAA,wCAAA;AlB8hEZ;;AkBriEQ;EAOI,8DAAA;EAAA,iEAAA;AlBmiEZ;;AkB1iEQ;EAOI,2DAAA;EAAA,8DAAA;AlBwiEZ;;AkB/iEQ;EAOI,8DAAA;EAAA,iEAAA;AlB6iEZ;;AkBpjEQ;EAOI,8DAAA;EAAA,iEAAA;AlBkjEZ;;AkBzjEQ;EAOI,+DAAA;EAAA,kEAAA;AlBujEZ;;AkB9jEQ;EAOI,uCAAA;EAAA,0CAAA;AlB4jEZ;;AkBnkEQ;EAOI,gEAAA;EAAA,mEAAA;AlBikEZ;;AkBxkEQ;EAOI,8DAAA;EAAA,6DAAA;AlBskEZ;;AkB7kEQ;EAOI,wCAAA;EAAA,uCAAA;AlB2kEZ;;AkBllEQ;EAOI,iEAAA;EAAA,gEAAA;AlBglEZ;;AkBvlEQ;EAOI,8DAAA;EAAA,6DAAA;AlBqlEZ;;AkB5lEQ;EAOI,iEAAA;EAAA,gEAAA;AlB0lEZ;;AkBjmEQ;EAOI,iEAAA;EAAA,gEAAA;AlB+lEZ;;AkBtmEQ;EAOI,kEAAA;EAAA,iEAAA;AlBomEZ;;AkB3mEQ;EAOI,0CAAA;EAAA,yCAAA;AlBymEZ;;AkBhnEQ;EAOI,mEAAA;EAAA,kEAAA;AlB8mEZ;;AkBrnEQ;EAOI,6DAAA;EAAA,0DAAA;AlBmnEZ;;AkB1nEQ;EAOI,uCAAA;EAAA,oCAAA;AlBwnEZ;;AkB/nEQ;EAOI,gEAAA;EAAA,6DAAA;AlB6nEZ;;AkBpoEQ;EAOI,6DAAA;EAAA,0DAAA;AlBkoEZ;;AkBzoEQ;EAOI,gEAAA;EAAA,6DAAA;AlBuoEZ;;AkB9oEQ;EAOI,gEAAA;EAAA,6DAAA;AlB4oEZ;;AkBnpEQ;EAOI,iEAAA;EAAA,8DAAA;AlBipEZ;;AkBxpEQ;EAOI,yCAAA;EAAA,sCAAA;AlBspEZ;;AkB7pEQ;EAOI,kEAAA;EAAA,+DAAA;AlB2pEZ;;AkBlqEQ;EAOI,8BAAA;AlB+pEZ;;AkBtqEQ;EAOI,6BAAA;AlBmqEZ;;AkB1qEQ;EAOI,sBAAA;AlBuqEZ;;AkB9qEQ;EAOI,qBAAA;AlB2qEZ;;AkBlrEQ;EAOI,qBAAA;AlB+qEZ;;AkBtrEQ;EAOI,qBAAA;AlBmrEZ;;AkB1rEQ;EAOI,qBAAA;AlBurEZ;;AUjsEI;EQGI;IAOI,sBAAA;ElB4rEV;EkBnsEM;IAOI,uBAAA;ElB+rEV;EkBtsEM;IAOI,sBAAA;ElBksEV;EkBzsEM;IAOI,8BAAA;ElBqsEV;EkB5sEM;IAOI,4BAAA;ElBwsEV;EkB/sEM;IAOI,2BAAA;ElB2sEV;EkBltEM;IAOI,iCAAA;ElB8sEV;EkBrtEM;IAOI,2BAAA;ElBitEV;EkBxtEM;IAOI,0BAAA;ElBotEV;EkB3tEM;IAOI,gCAAA;ElButEV;EkB9tEM;IAOI,yBAAA;ElB0tEV;EkBjuEM;IAOI,wBAAA;ElB6tEV;EkBpuEM;IAOI,+BAAA;ElBguEV;EkBvuEM;IAOI,yBAAA;ElBmuEV;EkB1uEM;IAOI,6BAAA;ElBsuEV;EkB7uEM;IAOI,8BAAA;ElByuEV;EkBhvEM;IAOI,wBAAA;ElB4uEV;EkBnvEM;IAOI,+BAAA;ElB+uEV;EkBtvEM;IAOI,wBAAA;ElBkvEV;EkBzvEM;IAOI,yBAAA;ElBqvEV;EkB5vEM;IAOI,8BAAA;ElBwvEV;EkB/vEM;IAOI,iCAAA;ElB2vEV;EkBlwEM;IAOI,sCAAA;ElB8vEV;EkBrwEM;IAOI,yCAAA;ElBiwEV;EkBxwEM;IAOI,uBAAA;ElBowEV;EkB3wEM;IAOI,uBAAA;ElBuwEV;EkB9wEM;IAOI,yBAAA;ElB0wEV;EkBjxEM;IAOI,yBAAA;ElB6wEV;EkBpxEM;IAOI,0BAAA;ElBgxEV;EkBvxEM;IAOI,4BAAA;ElBmxEV;EkB1xEM;IAOI,kCAAA;ElBsxEV;EkB7xEM;IAOI,sCAAA;ElByxEV;EkBhyEM;IAOI,oCAAA;ElB4xEV;EkBnyEM;IAOI,kCAAA;ElB+xEV;EkBtyEM;IAOI,yCAAA;ElBkyEV;EkBzyEM;IAOI,wCAAA;ElBqyEV;EkB5yEM;IAOI,wCAAA;ElBwyEV;EkB/yEM;IAOI,kCAAA;ElB2yEV;EkBlzEM;IAOI,gCAAA;ElB8yEV;EkBrzEM;IAOI,8BAAA;ElBizEV;EkBxzEM;IAOI,gCAAA;ElBozEV;EkB3zEM;IAOI,+BAAA;ElBuzEV;EkB9zEM;IAOI,oCAAA;ElB0zEV;EkBj0EM;IAOI,kCAAA;ElB6zEV;EkBp0EM;IAOI,gCAAA;ElBg0EV;EkBv0EM;IAOI,uCAAA;ElBm0EV;EkB10EM;IAOI,sCAAA;ElBs0EV;EkB70EM;IAOI,iCAAA;ElBy0EV;EkBh1EM;IAOI,2BAAA;ElB40EV;EkBn1EM;IAOI,iCAAA;ElB+0EV;EkBt1EM;IAOI,+BAAA;ElBk1EV;EkBz1EM;IAOI,6BAAA;ElBq1EV;EkB51EM;IAOI,+BAAA;ElBw1EV;EkB/1EM;IAOI,8BAAA;ElB21EV;EkBl2EM;IAOI,oBAAA;ElB81EV;EkBr2EM;IAOI,mBAAA;ElBi2EV;EkBx2EM;IAOI,mBAAA;ElBo2EV;EkB32EM;IAOI,mBAAA;ElBu2EV;EkB92EM;IAOI,mBAAA;ElB02EV;EkBj3EM;IAOI,mBAAA;ElB62EV;EkBp3EM;IAOI,mBAAA;ElBg3EV;EkBv3EM;IAOI,mBAAA;ElBm3EV;EkB13EM;IAOI,oBAAA;ElBs3EV;EkB73EM;IAOI,0BAAA;ElBy3EV;EkBh4EM;IAOI,yBAAA;ElB43EV;EkBn4EM;IAOI,uBAAA;ElB+3EV;EkBt4EM;IAOI,yBAAA;ElBk4EV;EkBz4EM;IAOI,uBAAA;ElBq4EV;EkB54EM;IAOI,uBAAA;ElBw4EV;EkB/4EM;IAOI,0BAAA;IAAA,yBAAA;ElB44EV;EkBn5EM;IAOI,gCAAA;IAAA,+BAAA;ElBg5EV;EkBv5EM;IAOI,+BAAA;IAAA,8BAAA;ElBo5EV;EkB35EM;IAOI,6BAAA;IAAA,4BAAA;ElBw5EV;EkB/5EM;IAOI,+BAAA;IAAA,8BAAA;ElB45EV;EkBn6EM;IAOI,6BAAA;IAAA,4BAAA;ElBg6EV;EkBv6EM;IAOI,6BAAA;IAAA,4BAAA;ElBo6EV;EkB36EM;IAOI,wBAAA;IAAA,2BAAA;ElBw6EV;EkB/6EM;IAOI,8BAAA;IAAA,iCAAA;ElB46EV;EkBn7EM;IAOI,6BAAA;IAAA,gCAAA;ElBg7EV;EkBv7EM;IAOI,2BAAA;IAAA,8BAAA;ElBo7EV;EkB37EM;IAOI,6BAAA;IAAA,gCAAA;ElBw7EV;EkB/7EM;IAOI,2BAAA;IAAA,8BAAA;ElB47EV;EkBn8EM;IAOI,2BAAA;IAAA,8BAAA;ElBg8EV;EkBv8EM;IAOI,wBAAA;ElBm8EV;EkB18EM;IAOI,8BAAA;ElBs8EV;EkB78EM;IAOI,6BAAA;ElBy8EV;EkBh9EM;IAOI,2BAAA;ElB48EV;EkBn9EM;IAOI,6BAAA;ElB+8EV;EkBt9EM;IAOI,2BAAA;ElBk9EV;EkBz9EM;IAOI,2BAAA;ElBq9EV;EkB59EM;IAOI,0BAAA;ElBw9EV;EkB/9EM;IAOI,gCAAA;ElB29EV;EkBl+EM;IAOI,+BAAA;ElB89EV;EkBr+EM;IAOI,6BAAA;ElBi+EV;EkBx+EM;IAOI,+BAAA;ElBo+EV;EkB3+EM;IAOI,6BAAA;ElBu+EV;EkB9+EM;IAOI,6BAAA;ElB0+EV;EkBj/EM;IAOI,2BAAA;ElB6+EV;EkBp/EM;IAOI,iCAAA;ElBg/EV;EkBv/EM;IAOI,gCAAA;ElBm/EV;EkB1/EM;IAOI,8BAAA;ElBs/EV;EkB7/EM;IAOI,gCAAA;ElBy/EV;EkBhgFM;IAOI,8BAAA;ElB4/EV;EkBngFM;IAOI,8BAAA;ElB+/EV;EkBtgFM;IAOI,yBAAA;ElBkgFV;EkBzgFM;IAOI,+BAAA;ElBqgFV;EkB5gFM;IAOI,8BAAA;ElBwgFV;EkB/gFM;IAOI,4BAAA;ElB2gFV;EkBlhFM;IAOI,8BAAA;ElB8gFV;EkBrhFM;IAOI,4BAAA;ElBihFV;EkBxhFM;IAOI,4BAAA;ElBohFV;EkB3hFM;IAOI,qBAAA;ElBuhFV;EkB9hFM;IAOI,2BAAA;ElB0hFV;EkBjiFM;IAOI,0BAAA;ElB6hFV;EkBpiFM;IAOI,wBAAA;ElBgiFV;EkBviFM;IAOI,0BAAA;ElBmiFV;EkB1iFM;IAOI,wBAAA;ElBsiFV;EkB7iFM;IAOI,2BAAA;IAAA,0BAAA;ElB0iFV;EkBjjFM;IAOI,iCAAA;IAAA,gCAAA;ElB8iFV;EkBrjFM;IAOI,gCAAA;IAAA,+BAAA;ElBkjFV;EkBzjFM;IAOI,8BAAA;IAAA,6BAAA;ElBsjFV;EkB7jFM;IAOI,gCAAA;IAAA,+BAAA;ElB0jFV;EkBjkFM;IAOI,8BAAA;IAAA,6BAAA;ElB8jFV;EkBrkFM;IAOI,yBAAA;IAAA,4BAAA;ElBkkFV;EkBzkFM;IAOI,+BAAA;IAAA,kCAAA;ElBskFV;EkB7kFM;IAOI,8BAAA;IAAA,iCAAA;ElB0kFV;EkBjlFM;IAOI,4BAAA;IAAA,+BAAA;ElB8kFV;EkBrlFM;IAOI,8BAAA;IAAA,iCAAA;ElBklFV;EkBzlFM;IAOI,4BAAA;IAAA,+BAAA;ElBslFV;EkB7lFM;IAOI,yBAAA;ElBylFV;EkBhmFM;IAOI,+BAAA;ElB4lFV;EkBnmFM;IAOI,8BAAA;ElB+lFV;EkBtmFM;IAOI,4BAAA;ElBkmFV;EkBzmFM;IAOI,8BAAA;ElBqmFV;EkB5mFM;IAOI,4BAAA;ElBwmFV;EkB/mFM;IAOI,2BAAA;ElB2mFV;EkBlnFM;IAOI,iCAAA;ElB8mFV;EkBrnFM;IAOI,gCAAA;ElBinFV;EkBxnFM;IAOI,8BAAA;ElBonFV;EkB3nFM;IAOI,gCAAA;ElBunFV;EkB9nFM;IAOI,8BAAA;ElB0nFV;EkBjoFM;IAOI,4BAAA;ElB6nFV;EkBpoFM;IAOI,kCAAA;ElBgoFV;EkBvoFM;IAOI,iCAAA;ElBmoFV;EkB1oFM;IAOI,+BAAA;ElBsoFV;EkB7oFM;IAOI,iCAAA;ElByoFV;EkBhpFM;IAOI,+BAAA;ElB4oFV;EkBnpFM;IAOI,0BAAA;ElB+oFV;EkBtpFM;IAOI,gCAAA;ElBkpFV;EkBzpFM;IAOI,+BAAA;ElBqpFV;EkB5pFM;IAOI,6BAAA;ElBwpFV;EkB/pFM;IAOI,+BAAA;ElB2pFV;EkBlqFM;IAOI,6BAAA;ElB8pFV;EkBrqFM;IAOI,iBAAA;ElBiqFV;EkBxqFM;IAOI,uBAAA;ElBoqFV;EkB3qFM;IAOI,sBAAA;ElBuqFV;EkB9qFM;IAOI,oBAAA;ElB0qFV;EkBjrFM;IAOI,sBAAA;ElB6qFV;EkBprFM;IAOI,oBAAA;ElBgrFV;EkBvrFM;IAOI,qBAAA;ElBmrFV;EkB1rFM;IAOI,2BAAA;ElBsrFV;EkB7rFM;IAOI,0BAAA;ElByrFV;EkBhsFM;IAOI,wBAAA;ElB4rFV;EkBnsFM;IAOI,0BAAA;ElB+rFV;EkBtsFM;IAOI,wBAAA;ElBksFV;EkBzsFM;IAOI,wBAAA;ElBqsFV;EkB5sFM;IAOI,8BAAA;ElBwsFV;EkB/sFM;IAOI,6BAAA;ElB2sFV;EkBltFM;IAOI,2BAAA;ElB8sFV;EkBrtFM;IAOI,6BAAA;ElBitFV;EkBxtFM;IAOI,2BAAA;ElBotFV;EkB3tFM;IAOI,2BAAA;ElButFV;EkB9tFM;IAOI,4BAAA;ElB0tFV;EkBjuFM;IAOI,6BAAA;ElB6tFV;AACF;AUxuFI;EQGI;IAOI,sBAAA;ElBkuFV;EkBzuFM;IAOI,uBAAA;ElBquFV;EkB5uFM;IAOI,sBAAA;ElBwuFV;EkB/uFM;IAOI,8BAAA;ElB2uFV;EkBlvFM;IAOI,4BAAA;ElB8uFV;EkBrvFM;IAOI,2BAAA;ElBivFV;EkBxvFM;IAOI,iCAAA;ElBovFV;EkB3vFM;IAOI,2BAAA;ElBuvFV;EkB9vFM;IAOI,0BAAA;ElB0vFV;EkBjwFM;IAOI,gCAAA;ElB6vFV;EkBpwFM;IAOI,yBAAA;ElBgwFV;EkBvwFM;IAOI,wBAAA;ElBmwFV;EkB1wFM;IAOI,+BAAA;ElBswFV;EkB7wFM;IAOI,yBAAA;ElBywFV;EkBhxFM;IAOI,6BAAA;ElB4wFV;EkBnxFM;IAOI,8BAAA;ElB+wFV;EkBtxFM;IAOI,wBAAA;ElBkxFV;EkBzxFM;IAOI,+BAAA;ElBqxFV;EkB5xFM;IAOI,wBAAA;ElBwxFV;EkB/xFM;IAOI,yBAAA;ElB2xFV;EkBlyFM;IAOI,8BAAA;ElB8xFV;EkBryFM;IAOI,iCAAA;ElBiyFV;EkBxyFM;IAOI,sCAAA;ElBoyFV;EkB3yFM;IAOI,yCAAA;ElBuyFV;EkB9yFM;IAOI,uBAAA;ElB0yFV;EkBjzFM;IAOI,uBAAA;ElB6yFV;EkBpzFM;IAOI,yBAAA;ElBgzFV;EkBvzFM;IAOI,yBAAA;ElBmzFV;EkB1zFM;IAOI,0BAAA;ElBszFV;EkB7zFM;IAOI,4BAAA;ElByzFV;EkBh0FM;IAOI,kCAAA;ElB4zFV;EkBn0FM;IAOI,sCAAA;ElB+zFV;EkBt0FM;IAOI,oCAAA;ElBk0FV;EkBz0FM;IAOI,kCAAA;ElBq0FV;EkB50FM;IAOI,yCAAA;ElBw0FV;EkB/0FM;IAOI,wCAAA;ElB20FV;EkBl1FM;IAOI,wCAAA;ElB80FV;EkBr1FM;IAOI,kCAAA;ElBi1FV;EkBx1FM;IAOI,gCAAA;ElBo1FV;EkB31FM;IAOI,8BAAA;ElBu1FV;EkB91FM;IAOI,gCAAA;ElB01FV;EkBj2FM;IAOI,+BAAA;ElB61FV;EkBp2FM;IAOI,oCAAA;ElBg2FV;EkBv2FM;IAOI,kCAAA;ElBm2FV;EkB12FM;IAOI,gCAAA;ElBs2FV;EkB72FM;IAOI,uCAAA;ElBy2FV;EkBh3FM;IAOI,sCAAA;ElB42FV;EkBn3FM;IAOI,iCAAA;ElB+2FV;EkBt3FM;IAOI,2BAAA;ElBk3FV;EkBz3FM;IAOI,iCAAA;ElBq3FV;EkB53FM;IAOI,+BAAA;ElBw3FV;EkB/3FM;IAOI,6BAAA;ElB23FV;EkBl4FM;IAOI,+BAAA;ElB83FV;EkBr4FM;IAOI,8BAAA;ElBi4FV;EkBx4FM;IAOI,oBAAA;ElBo4FV;EkB34FM;IAOI,mBAAA;ElBu4FV;EkB94FM;IAOI,mBAAA;ElB04FV;EkBj5FM;IAOI,mBAAA;ElB64FV;EkBp5FM;IAOI,mBAAA;ElBg5FV;EkBv5FM;IAOI,mBAAA;ElBm5FV;EkB15FM;IAOI,mBAAA;ElBs5FV;EkB75FM;IAOI,mBAAA;ElBy5FV;EkBh6FM;IAOI,oBAAA;ElB45FV;EkBn6FM;IAOI,0BAAA;ElB+5FV;EkBt6FM;IAOI,yBAAA;ElBk6FV;EkBz6FM;IAOI,uBAAA;ElBq6FV;EkB56FM;IAOI,yBAAA;ElBw6FV;EkB/6FM;IAOI,uBAAA;ElB26FV;EkBl7FM;IAOI,uBAAA;ElB86FV;EkBr7FM;IAOI,0BAAA;IAAA,yBAAA;ElBk7FV;EkBz7FM;IAOI,gCAAA;IAAA,+BAAA;ElBs7FV;EkB77FM;IAOI,+BAAA;IAAA,8BAAA;ElB07FV;EkBj8FM;IAOI,6BAAA;IAAA,4BAAA;ElB87FV;EkBr8FM;IAOI,+BAAA;IAAA,8BAAA;ElBk8FV;EkBz8FM;IAOI,6BAAA;IAAA,4BAAA;ElBs8FV;EkB78FM;IAOI,6BAAA;IAAA,4BAAA;ElB08FV;EkBj9FM;IAOI,wBAAA;IAAA,2BAAA;ElB88FV;EkBr9FM;IAOI,8BAAA;IAAA,iCAAA;ElBk9FV;EkBz9FM;IAOI,6BAAA;IAAA,gCAAA;ElBs9FV;EkB79FM;IAOI,2BAAA;IAAA,8BAAA;ElB09FV;EkBj+FM;IAOI,6BAAA;IAAA,gCAAA;ElB89FV;EkBr+FM;IAOI,2BAAA;IAAA,8BAAA;ElBk+FV;EkBz+FM;IAOI,2BAAA;IAAA,8BAAA;ElBs+FV;EkB7+FM;IAOI,wBAAA;ElBy+FV;EkBh/FM;IAOI,8BAAA;ElB4+FV;EkBn/FM;IAOI,6BAAA;ElB++FV;EkBt/FM;IAOI,2BAAA;ElBk/FV;EkBz/FM;IAOI,6BAAA;ElBq/FV;EkB5/FM;IAOI,2BAAA;ElBw/FV;EkB//FM;IAOI,2BAAA;ElB2/FV;EkBlgGM;IAOI,0BAAA;ElB8/FV;EkBrgGM;IAOI,gCAAA;ElBigGV;EkBxgGM;IAOI,+BAAA;ElBogGV;EkB3gGM;IAOI,6BAAA;ElBugGV;EkB9gGM;IAOI,+BAAA;ElB0gGV;EkBjhGM;IAOI,6BAAA;ElB6gGV;EkBphGM;IAOI,6BAAA;ElBghGV;EkBvhGM;IAOI,2BAAA;ElBmhGV;EkB1hGM;IAOI,iCAAA;ElBshGV;EkB7hGM;IAOI,gCAAA;ElByhGV;EkBhiGM;IAOI,8BAAA;ElB4hGV;EkBniGM;IAOI,gCAAA;ElB+hGV;EkBtiGM;IAOI,8BAAA;ElBkiGV;EkBziGM;IAOI,8BAAA;ElBqiGV;EkB5iGM;IAOI,yBAAA;ElBwiGV;EkB/iGM;IAOI,+BAAA;ElB2iGV;EkBljGM;IAOI,8BAAA;ElB8iGV;EkBrjGM;IAOI,4BAAA;ElBijGV;EkBxjGM;IAOI,8BAAA;ElBojGV;EkB3jGM;IAOI,4BAAA;ElBujGV;EkB9jGM;IAOI,4BAAA;ElB0jGV;EkBjkGM;IAOI,qBAAA;ElB6jGV;EkBpkGM;IAOI,2BAAA;ElBgkGV;EkBvkGM;IAOI,0BAAA;ElBmkGV;EkB1kGM;IAOI,wBAAA;ElBskGV;EkB7kGM;IAOI,0BAAA;ElBykGV;EkBhlGM;IAOI,wBAAA;ElB4kGV;EkBnlGM;IAOI,2BAAA;IAAA,0BAAA;ElBglGV;EkBvlGM;IAOI,iCAAA;IAAA,gCAAA;ElBolGV;EkB3lGM;IAOI,gCAAA;IAAA,+BAAA;ElBwlGV;EkB/lGM;IAOI,8BAAA;IAAA,6BAAA;ElB4lGV;EkBnmGM;IAOI,gCAAA;IAAA,+BAAA;ElBgmGV;EkBvmGM;IAOI,8BAAA;IAAA,6BAAA;ElBomGV;EkB3mGM;IAOI,yBAAA;IAAA,4BAAA;ElBwmGV;EkB/mGM;IAOI,+BAAA;IAAA,kCAAA;ElB4mGV;EkBnnGM;IAOI,8BAAA;IAAA,iCAAA;ElBgnGV;EkBvnGM;IAOI,4BAAA;IAAA,+BAAA;ElBonGV;EkB3nGM;IAOI,8BAAA;IAAA,iCAAA;ElBwnGV;EkB/nGM;IAOI,4BAAA;IAAA,+BAAA;ElB4nGV;EkBnoGM;IAOI,yBAAA;ElB+nGV;EkBtoGM;IAOI,+BAAA;ElBkoGV;EkBzoGM;IAOI,8BAAA;ElBqoGV;EkB5oGM;IAOI,4BAAA;ElBwoGV;EkB/oGM;IAOI,8BAAA;ElB2oGV;EkBlpGM;IAOI,4BAAA;ElB8oGV;EkBrpGM;IAOI,2BAAA;ElBipGV;EkBxpGM;IAOI,iCAAA;ElBopGV;EkB3pGM;IAOI,gCAAA;ElBupGV;EkB9pGM;IAOI,8BAAA;ElB0pGV;EkBjqGM;IAOI,gCAAA;ElB6pGV;EkBpqGM;IAOI,8BAAA;ElBgqGV;EkBvqGM;IAOI,4BAAA;ElBmqGV;EkB1qGM;IAOI,kCAAA;ElBsqGV;EkB7qGM;IAOI,iCAAA;ElByqGV;EkBhrGM;IAOI,+BAAA;ElB4qGV;EkBnrGM;IAOI,iCAAA;ElB+qGV;EkBtrGM;IAOI,+BAAA;ElBkrGV;EkBzrGM;IAOI,0BAAA;ElBqrGV;EkB5rGM;IAOI,gCAAA;ElBwrGV;EkB/rGM;IAOI,+BAAA;ElB2rGV;EkBlsGM;IAOI,6BAAA;ElB8rGV;EkBrsGM;IAOI,+BAAA;ElBisGV;EkBxsGM;IAOI,6BAAA;ElBosGV;EkB3sGM;IAOI,iBAAA;ElBusGV;EkB9sGM;IAOI,uBAAA;ElB0sGV;EkBjtGM;IAOI,sBAAA;ElB6sGV;EkBptGM;IAOI,oBAAA;ElBgtGV;EkBvtGM;IAOI,sBAAA;ElBmtGV;EkB1tGM;IAOI,oBAAA;ElBstGV;EkB7tGM;IAOI,qBAAA;ElBytGV;EkBhuGM;IAOI,2BAAA;ElB4tGV;EkBnuGM;IAOI,0BAAA;ElB+tGV;EkBtuGM;IAOI,wBAAA;ElBkuGV;EkBzuGM;IAOI,0BAAA;ElBquGV;EkB5uGM;IAOI,wBAAA;ElBwuGV;EkB/uGM;IAOI,wBAAA;ElB2uGV;EkBlvGM;IAOI,8BAAA;ElB8uGV;EkBrvGM;IAOI,6BAAA;ElBivGV;EkBxvGM;IAOI,2BAAA;ElBovGV;EkB3vGM;IAOI,6BAAA;ElBuvGV;EkB9vGM;IAOI,2BAAA;ElB0vGV;EkBjwGM;IAOI,2BAAA;ElB6vGV;EkBpwGM;IAOI,4BAAA;ElBgwGV;EkBvwGM;IAOI,6BAAA;ElBmwGV;AACF;AU9wGI;EQGI;IAOI,sBAAA;ElBwwGV;EkB/wGM;IAOI,uBAAA;ElB2wGV;EkBlxGM;IAOI,sBAAA;ElB8wGV;EkBrxGM;IAOI,8BAAA;ElBixGV;EkBxxGM;IAOI,4BAAA;ElBoxGV;EkB3xGM;IAOI,2BAAA;ElBuxGV;EkB9xGM;IAOI,iCAAA;ElB0xGV;EkBjyGM;IAOI,2BAAA;ElB6xGV;EkBpyGM;IAOI,0BAAA;ElBgyGV;EkBvyGM;IAOI,gCAAA;ElBmyGV;EkB1yGM;IAOI,yBAAA;ElBsyGV;EkB7yGM;IAOI,wBAAA;ElByyGV;EkBhzGM;IAOI,+BAAA;ElB4yGV;EkBnzGM;IAOI,yBAAA;ElB+yGV;EkBtzGM;IAOI,6BAAA;ElBkzGV;EkBzzGM;IAOI,8BAAA;ElBqzGV;EkB5zGM;IAOI,wBAAA;ElBwzGV;EkB/zGM;IAOI,+BAAA;ElB2zGV;EkBl0GM;IAOI,wBAAA;ElB8zGV;EkBr0GM;IAOI,yBAAA;ElBi0GV;EkBx0GM;IAOI,8BAAA;ElBo0GV;EkB30GM;IAOI,iCAAA;ElBu0GV;EkB90GM;IAOI,sCAAA;ElB00GV;EkBj1GM;IAOI,yCAAA;ElB60GV;EkBp1GM;IAOI,uBAAA;ElBg1GV;EkBv1GM;IAOI,uBAAA;ElBm1GV;EkB11GM;IAOI,yBAAA;ElBs1GV;EkB71GM;IAOI,yBAAA;ElBy1GV;EkBh2GM;IAOI,0BAAA;ElB41GV;EkBn2GM;IAOI,4BAAA;ElB+1GV;EkBt2GM;IAOI,kCAAA;ElBk2GV;EkBz2GM;IAOI,sCAAA;ElBq2GV;EkB52GM;IAOI,oCAAA;ElBw2GV;EkB/2GM;IAOI,kCAAA;ElB22GV;EkBl3GM;IAOI,yCAAA;ElB82GV;EkBr3GM;IAOI,wCAAA;ElBi3GV;EkBx3GM;IAOI,wCAAA;ElBo3GV;EkB33GM;IAOI,kCAAA;ElBu3GV;EkB93GM;IAOI,gCAAA;ElB03GV;EkBj4GM;IAOI,8BAAA;ElB63GV;EkBp4GM;IAOI,gCAAA;ElBg4GV;EkBv4GM;IAOI,+BAAA;ElBm4GV;EkB14GM;IAOI,oCAAA;ElBs4GV;EkB74GM;IAOI,kCAAA;ElBy4GV;EkBh5GM;IAOI,gCAAA;ElB44GV;EkBn5GM;IAOI,uCAAA;ElB+4GV;EkBt5GM;IAOI,sCAAA;ElBk5GV;EkBz5GM;IAOI,iCAAA;ElBq5GV;EkB55GM;IAOI,2BAAA;ElBw5GV;EkB/5GM;IAOI,iCAAA;ElB25GV;EkBl6GM;IAOI,+BAAA;ElB85GV;EkBr6GM;IAOI,6BAAA;ElBi6GV;EkBx6GM;IAOI,+BAAA;ElBo6GV;EkB36GM;IAOI,8BAAA;ElBu6GV;EkB96GM;IAOI,oBAAA;ElB06GV;EkBj7GM;IAOI,mBAAA;ElB66GV;EkBp7GM;IAOI,mBAAA;ElBg7GV;EkBv7GM;IAOI,mBAAA;ElBm7GV;EkB17GM;IAOI,mBAAA;ElBs7GV;EkB77GM;IAOI,mBAAA;ElBy7GV;EkBh8GM;IAOI,mBAAA;ElB47GV;EkBn8GM;IAOI,mBAAA;ElB+7GV;EkBt8GM;IAOI,oBAAA;ElBk8GV;EkBz8GM;IAOI,0BAAA;ElBq8GV;EkB58GM;IAOI,yBAAA;ElBw8GV;EkB/8GM;IAOI,uBAAA;ElB28GV;EkBl9GM;IAOI,yBAAA;ElB88GV;EkBr9GM;IAOI,uBAAA;ElBi9GV;EkBx9GM;IAOI,uBAAA;ElBo9GV;EkB39GM;IAOI,0BAAA;IAAA,yBAAA;ElBw9GV;EkB/9GM;IAOI,gCAAA;IAAA,+BAAA;ElB49GV;EkBn+GM;IAOI,+BAAA;IAAA,8BAAA;ElBg+GV;EkBv+GM;IAOI,6BAAA;IAAA,4BAAA;ElBo+GV;EkB3+GM;IAOI,+BAAA;IAAA,8BAAA;ElBw+GV;EkB/+GM;IAOI,6BAAA;IAAA,4BAAA;ElB4+GV;EkBn/GM;IAOI,6BAAA;IAAA,4BAAA;ElBg/GV;EkBv/GM;IAOI,wBAAA;IAAA,2BAAA;ElBo/GV;EkB3/GM;IAOI,8BAAA;IAAA,iCAAA;ElBw/GV;EkB//GM;IAOI,6BAAA;IAAA,gCAAA;ElB4/GV;EkBngHM;IAOI,2BAAA;IAAA,8BAAA;ElBggHV;EkBvgHM;IAOI,6BAAA;IAAA,gCAAA;ElBogHV;EkB3gHM;IAOI,2BAAA;IAAA,8BAAA;ElBwgHV;EkB/gHM;IAOI,2BAAA;IAAA,8BAAA;ElB4gHV;EkBnhHM;IAOI,wBAAA;ElB+gHV;EkBthHM;IAOI,8BAAA;ElBkhHV;EkBzhHM;IAOI,6BAAA;ElBqhHV;EkB5hHM;IAOI,2BAAA;ElBwhHV;EkB/hHM;IAOI,6BAAA;ElB2hHV;EkBliHM;IAOI,2BAAA;ElB8hHV;EkBriHM;IAOI,2BAAA;ElBiiHV;EkBxiHM;IAOI,0BAAA;ElBoiHV;EkB3iHM;IAOI,gCAAA;ElBuiHV;EkB9iHM;IAOI,+BAAA;ElB0iHV;EkBjjHM;IAOI,6BAAA;ElB6iHV;EkBpjHM;IAOI,+BAAA;ElBgjHV;EkBvjHM;IAOI,6BAAA;ElBmjHV;EkB1jHM;IAOI,6BAAA;ElBsjHV;EkB7jHM;IAOI,2BAAA;ElByjHV;EkBhkHM;IAOI,iCAAA;ElB4jHV;EkBnkHM;IAOI,gCAAA;ElB+jHV;EkBtkHM;IAOI,8BAAA;ElBkkHV;EkBzkHM;IAOI,gCAAA;ElBqkHV;EkB5kHM;IAOI,8BAAA;ElBwkHV;EkB/kHM;IAOI,8BAAA;ElB2kHV;EkBllHM;IAOI,yBAAA;ElB8kHV;EkBrlHM;IAOI,+BAAA;ElBilHV;EkBxlHM;IAOI,8BAAA;ElBolHV;EkB3lHM;IAOI,4BAAA;ElBulHV;EkB9lHM;IAOI,8BAAA;ElB0lHV;EkBjmHM;IAOI,4BAAA;ElB6lHV;EkBpmHM;IAOI,4BAAA;ElBgmHV;EkBvmHM;IAOI,qBAAA;ElBmmHV;EkB1mHM;IAOI,2BAAA;ElBsmHV;EkB7mHM;IAOI,0BAAA;ElBymHV;EkBhnHM;IAOI,wBAAA;ElB4mHV;EkBnnHM;IAOI,0BAAA;ElB+mHV;EkBtnHM;IAOI,wBAAA;ElBknHV;EkBznHM;IAOI,2BAAA;IAAA,0BAAA;ElBsnHV;EkB7nHM;IAOI,iCAAA;IAAA,gCAAA;ElB0nHV;EkBjoHM;IAOI,gCAAA;IAAA,+BAAA;ElB8nHV;EkBroHM;IAOI,8BAAA;IAAA,6BAAA;ElBkoHV;EkBzoHM;IAOI,gCAAA;IAAA,+BAAA;ElBsoHV;EkB7oHM;IAOI,8BAAA;IAAA,6BAAA;ElB0oHV;EkBjpHM;IAOI,yBAAA;IAAA,4BAAA;ElB8oHV;EkBrpHM;IAOI,+BAAA;IAAA,kCAAA;ElBkpHV;EkBzpHM;IAOI,8BAAA;IAAA,iCAAA;ElBspHV;EkB7pHM;IAOI,4BAAA;IAAA,+BAAA;ElB0pHV;EkBjqHM;IAOI,8BAAA;IAAA,iCAAA;ElB8pHV;EkBrqHM;IAOI,4BAAA;IAAA,+BAAA;ElBkqHV;EkBzqHM;IAOI,yBAAA;ElBqqHV;EkB5qHM;IAOI,+BAAA;ElBwqHV;EkB/qHM;IAOI,8BAAA;ElB2qHV;EkBlrHM;IAOI,4BAAA;ElB8qHV;EkBrrHM;IAOI,8BAAA;ElBirHV;EkBxrHM;IAOI,4BAAA;ElBorHV;EkB3rHM;IAOI,2BAAA;ElBurHV;EkB9rHM;IAOI,iCAAA;ElB0rHV;EkBjsHM;IAOI,gCAAA;ElB6rHV;EkBpsHM;IAOI,8BAAA;ElBgsHV;EkBvsHM;IAOI,gCAAA;ElBmsHV;EkB1sHM;IAOI,8BAAA;ElBssHV;EkB7sHM;IAOI,4BAAA;ElBysHV;EkBhtHM;IAOI,kCAAA;ElB4sHV;EkBntHM;IAOI,iCAAA;ElB+sHV;EkBttHM;IAOI,+BAAA;ElBktHV;EkBztHM;IAOI,iCAAA;ElBqtHV;EkB5tHM;IAOI,+BAAA;ElBwtHV;EkB/tHM;IAOI,0BAAA;ElB2tHV;EkBluHM;IAOI,gCAAA;ElB8tHV;EkBruHM;IAOI,+BAAA;ElBiuHV;EkBxuHM;IAOI,6BAAA;ElBouHV;EkB3uHM;IAOI,+BAAA;ElBuuHV;EkB9uHM;IAOI,6BAAA;ElB0uHV;EkBjvHM;IAOI,iBAAA;ElB6uHV;EkBpvHM;IAOI,uBAAA;ElBgvHV;EkBvvHM;IAOI,sBAAA;ElBmvHV;EkB1vHM;IAOI,oBAAA;ElBsvHV;EkB7vHM;IAOI,sBAAA;ElByvHV;EkBhwHM;IAOI,oBAAA;ElB4vHV;EkBnwHM;IAOI,qBAAA;ElB+vHV;EkBtwHM;IAOI,2BAAA;ElBkwHV;EkBzwHM;IAOI,0BAAA;ElBqwHV;EkB5wHM;IAOI,wBAAA;ElBwwHV;EkB/wHM;IAOI,0BAAA;ElB2wHV;EkBlxHM;IAOI,wBAAA;ElB8wHV;EkBrxHM;IAOI,wBAAA;ElBixHV;EkBxxHM;IAOI,8BAAA;ElBoxHV;EkB3xHM;IAOI,6BAAA;ElBuxHV;EkB9xHM;IAOI,2BAAA;ElB0xHV;EkBjyHM;IAOI,6BAAA;ElB6xHV;EkBpyHM;IAOI,2BAAA;ElBgyHV;EkBvyHM;IAOI,2BAAA;ElBmyHV;EkB1yHM;IAOI,4BAAA;ElBsyHV;EkB7yHM;IAOI,6BAAA;ElByyHV;AACF;AUpzHI;EQGI;IAOI,sBAAA;ElB8yHV;EkBrzHM;IAOI,uBAAA;ElBizHV;EkBxzHM;IAOI,sBAAA;ElBozHV;EkB3zHM;IAOI,8BAAA;ElBuzHV;EkB9zHM;IAOI,4BAAA;ElB0zHV;EkBj0HM;IAOI,2BAAA;ElB6zHV;EkBp0HM;IAOI,iCAAA;ElBg0HV;EkBv0HM;IAOI,2BAAA;ElBm0HV;EkB10HM;IAOI,0BAAA;ElBs0HV;EkB70HM;IAOI,gCAAA;ElBy0HV;EkBh1HM;IAOI,yBAAA;ElB40HV;EkBn1HM;IAOI,wBAAA;ElB+0HV;EkBt1HM;IAOI,+BAAA;ElBk1HV;EkBz1HM;IAOI,yBAAA;ElBq1HV;EkB51HM;IAOI,6BAAA;ElBw1HV;EkB/1HM;IAOI,8BAAA;ElB21HV;EkBl2HM;IAOI,wBAAA;ElB81HV;EkBr2HM;IAOI,+BAAA;ElBi2HV;EkBx2HM;IAOI,wBAAA;ElBo2HV;EkB32HM;IAOI,yBAAA;ElBu2HV;EkB92HM;IAOI,8BAAA;ElB02HV;EkBj3HM;IAOI,iCAAA;ElB62HV;EkBp3HM;IAOI,sCAAA;ElBg3HV;EkBv3HM;IAOI,yCAAA;ElBm3HV;EkB13HM;IAOI,uBAAA;ElBs3HV;EkB73HM;IAOI,uBAAA;ElBy3HV;EkBh4HM;IAOI,yBAAA;ElB43HV;EkBn4HM;IAOI,yBAAA;ElB+3HV;EkBt4HM;IAOI,0BAAA;ElBk4HV;EkBz4HM;IAOI,4BAAA;ElBq4HV;EkB54HM;IAOI,kCAAA;ElBw4HV;EkB/4HM;IAOI,sCAAA;ElB24HV;EkBl5HM;IAOI,oCAAA;ElB84HV;EkBr5HM;IAOI,kCAAA;ElBi5HV;EkBx5HM;IAOI,yCAAA;ElBo5HV;EkB35HM;IAOI,wCAAA;ElBu5HV;EkB95HM;IAOI,wCAAA;ElB05HV;EkBj6HM;IAOI,kCAAA;ElB65HV;EkBp6HM;IAOI,gCAAA;ElBg6HV;EkBv6HM;IAOI,8BAAA;ElBm6HV;EkB16HM;IAOI,gCAAA;ElBs6HV;EkB76HM;IAOI,+BAAA;ElBy6HV;EkBh7HM;IAOI,oCAAA;ElB46HV;EkBn7HM;IAOI,kCAAA;ElB+6HV;EkBt7HM;IAOI,gCAAA;ElBk7HV;EkBz7HM;IAOI,uCAAA;ElBq7HV;EkB57HM;IAOI,sCAAA;ElBw7HV;EkB/7HM;IAOI,iCAAA;ElB27HV;EkBl8HM;IAOI,2BAAA;ElB87HV;EkBr8HM;IAOI,iCAAA;ElBi8HV;EkBx8HM;IAOI,+BAAA;ElBo8HV;EkB38HM;IAOI,6BAAA;ElBu8HV;EkB98HM;IAOI,+BAAA;ElB08HV;EkBj9HM;IAOI,8BAAA;ElB68HV;EkBp9HM;IAOI,oBAAA;ElBg9HV;EkBv9HM;IAOI,mBAAA;ElBm9HV;EkB19HM;IAOI,mBAAA;ElBs9HV;EkB79HM;IAOI,mBAAA;ElBy9HV;EkBh+HM;IAOI,mBAAA;ElB49HV;EkBn+HM;IAOI,mBAAA;ElB+9HV;EkBt+HM;IAOI,mBAAA;ElBk+HV;EkBz+HM;IAOI,mBAAA;ElBq+HV;EkB5+HM;IAOI,oBAAA;ElBw+HV;EkB/+HM;IAOI,0BAAA;ElB2+HV;EkBl/HM;IAOI,yBAAA;ElB8+HV;EkBr/HM;IAOI,uBAAA;ElBi/HV;EkBx/HM;IAOI,yBAAA;ElBo/HV;EkB3/HM;IAOI,uBAAA;ElBu/HV;EkB9/HM;IAOI,uBAAA;ElB0/HV;EkBjgIM;IAOI,0BAAA;IAAA,yBAAA;ElB8/HV;EkBrgIM;IAOI,gCAAA;IAAA,+BAAA;ElBkgIV;EkBzgIM;IAOI,+BAAA;IAAA,8BAAA;ElBsgIV;EkB7gIM;IAOI,6BAAA;IAAA,4BAAA;ElB0gIV;EkBjhIM;IAOI,+BAAA;IAAA,8BAAA;ElB8gIV;EkBrhIM;IAOI,6BAAA;IAAA,4BAAA;ElBkhIV;EkBzhIM;IAOI,6BAAA;IAAA,4BAAA;ElBshIV;EkB7hIM;IAOI,wBAAA;IAAA,2BAAA;ElB0hIV;EkBjiIM;IAOI,8BAAA;IAAA,iCAAA;ElB8hIV;EkBriIM;IAOI,6BAAA;IAAA,gCAAA;ElBkiIV;EkBziIM;IAOI,2BAAA;IAAA,8BAAA;ElBsiIV;EkB7iIM;IAOI,6BAAA;IAAA,gCAAA;ElB0iIV;EkBjjIM;IAOI,2BAAA;IAAA,8BAAA;ElB8iIV;EkBrjIM;IAOI,2BAAA;IAAA,8BAAA;ElBkjIV;EkBzjIM;IAOI,wBAAA;ElBqjIV;EkB5jIM;IAOI,8BAAA;ElBwjIV;EkB/jIM;IAOI,6BAAA;ElB2jIV;EkBlkIM;IAOI,2BAAA;ElB8jIV;EkBrkIM;IAOI,6BAAA;ElBikIV;EkBxkIM;IAOI,2BAAA;ElBokIV;EkB3kIM;IAOI,2BAAA;ElBukIV;EkB9kIM;IAOI,0BAAA;ElB0kIV;EkBjlIM;IAOI,gCAAA;ElB6kIV;EkBplIM;IAOI,+BAAA;ElBglIV;EkBvlIM;IAOI,6BAAA;ElBmlIV;EkB1lIM;IAOI,+BAAA;ElBslIV;EkB7lIM;IAOI,6BAAA;ElBylIV;EkBhmIM;IAOI,6BAAA;ElB4lIV;EkBnmIM;IAOI,2BAAA;ElB+lIV;EkBtmIM;IAOI,iCAAA;ElBkmIV;EkBzmIM;IAOI,gCAAA;ElBqmIV;EkB5mIM;IAOI,8BAAA;ElBwmIV;EkB/mIM;IAOI,gCAAA;ElB2mIV;EkBlnIM;IAOI,8BAAA;ElB8mIV;EkBrnIM;IAOI,8BAAA;ElBinIV;EkBxnIM;IAOI,yBAAA;ElBonIV;EkB3nIM;IAOI,+BAAA;ElBunIV;EkB9nIM;IAOI,8BAAA;ElB0nIV;EkBjoIM;IAOI,4BAAA;ElB6nIV;EkBpoIM;IAOI,8BAAA;ElBgoIV;EkBvoIM;IAOI,4BAAA;ElBmoIV;EkB1oIM;IAOI,4BAAA;ElBsoIV;EkB7oIM;IAOI,qBAAA;ElByoIV;EkBhpIM;IAOI,2BAAA;ElB4oIV;EkBnpIM;IAOI,0BAAA;ElB+oIV;EkBtpIM;IAOI,wBAAA;ElBkpIV;EkBzpIM;IAOI,0BAAA;ElBqpIV;EkB5pIM;IAOI,wBAAA;ElBwpIV;EkB/pIM;IAOI,2BAAA;IAAA,0BAAA;ElB4pIV;EkBnqIM;IAOI,iCAAA;IAAA,gCAAA;ElBgqIV;EkBvqIM;IAOI,gCAAA;IAAA,+BAAA;ElBoqIV;EkB3qIM;IAOI,8BAAA;IAAA,6BAAA;ElBwqIV;EkB/qIM;IAOI,gCAAA;IAAA,+BAAA;ElB4qIV;EkBnrIM;IAOI,8BAAA;IAAA,6BAAA;ElBgrIV;EkBvrIM;IAOI,yBAAA;IAAA,4BAAA;ElBorIV;EkB3rIM;IAOI,+BAAA;IAAA,kCAAA;ElBwrIV;EkB/rIM;IAOI,8BAAA;IAAA,iCAAA;ElB4rIV;EkBnsIM;IAOI,4BAAA;IAAA,+BAAA;ElBgsIV;EkBvsIM;IAOI,8BAAA;IAAA,iCAAA;ElBosIV;EkB3sIM;IAOI,4BAAA;IAAA,+BAAA;ElBwsIV;EkB/sIM;IAOI,yBAAA;ElB2sIV;EkBltIM;IAOI,+BAAA;ElB8sIV;EkBrtIM;IAOI,8BAAA;ElBitIV;EkBxtIM;IAOI,4BAAA;ElBotIV;EkB3tIM;IAOI,8BAAA;ElButIV;EkB9tIM;IAOI,4BAAA;ElB0tIV;EkBjuIM;IAOI,2BAAA;ElB6tIV;EkBpuIM;IAOI,iCAAA;ElBguIV;EkBvuIM;IAOI,gCAAA;ElBmuIV;EkB1uIM;IAOI,8BAAA;ElBsuIV;EkB7uIM;IAOI,gCAAA;ElByuIV;EkBhvIM;IAOI,8BAAA;ElB4uIV;EkBnvIM;IAOI,4BAAA;ElB+uIV;EkBtvIM;IAOI,kCAAA;ElBkvIV;EkBzvIM;IAOI,iCAAA;ElBqvIV;EkB5vIM;IAOI,+BAAA;ElBwvIV;EkB/vIM;IAOI,iCAAA;ElB2vIV;EkBlwIM;IAOI,+BAAA;ElB8vIV;EkBrwIM;IAOI,0BAAA;ElBiwIV;EkBxwIM;IAOI,gCAAA;ElBowIV;EkB3wIM;IAOI,+BAAA;ElBuwIV;EkB9wIM;IAOI,6BAAA;ElB0wIV;EkBjxIM;IAOI,+BAAA;ElB6wIV;EkBpxIM;IAOI,6BAAA;ElBgxIV;EkBvxIM;IAOI,iBAAA;ElBmxIV;EkB1xIM;IAOI,uBAAA;ElBsxIV;EkB7xIM;IAOI,sBAAA;ElByxIV;EkBhyIM;IAOI,oBAAA;ElB4xIV;EkBnyIM;IAOI,sBAAA;ElB+xIV;EkBtyIM;IAOI,oBAAA;ElBkyIV;EkBzyIM;IAOI,qBAAA;ElBqyIV;EkB5yIM;IAOI,2BAAA;ElBwyIV;EkB/yIM;IAOI,0BAAA;ElB2yIV;EkBlzIM;IAOI,wBAAA;ElB8yIV;EkBrzIM;IAOI,0BAAA;ElBizIV;EkBxzIM;IAOI,wBAAA;ElBozIV;EkB3zIM;IAOI,wBAAA;ElBuzIV;EkB9zIM;IAOI,8BAAA;ElB0zIV;EkBj0IM;IAOI,6BAAA;ElB6zIV;EkBp0IM;IAOI,2BAAA;ElBg0IV;EkBv0IM;IAOI,6BAAA;ElBm0IV;EkB10IM;IAOI,2BAAA;ElBs0IV;EkB70IM;IAOI,2BAAA;ElBy0IV;EkBh1IM;IAOI,4BAAA;ElB40IV;EkBn1IM;IAOI,6BAAA;ElB+0IV;AACF;AU11II;EQGI;IAOI,sBAAA;ElBo1IV;EkB31IM;IAOI,uBAAA;ElBu1IV;EkB91IM;IAOI,sBAAA;ElB01IV;EkBj2IM;IAOI,8BAAA;ElB61IV;EkBp2IM;IAOI,4BAAA;ElBg2IV;EkBv2IM;IAOI,2BAAA;ElBm2IV;EkB12IM;IAOI,iCAAA;ElBs2IV;EkB72IM;IAOI,2BAAA;ElBy2IV;EkBh3IM;IAOI,0BAAA;ElB42IV;EkBn3IM;IAOI,gCAAA;ElB+2IV;EkBt3IM;IAOI,yBAAA;ElBk3IV;EkBz3IM;IAOI,wBAAA;ElBq3IV;EkB53IM;IAOI,+BAAA;ElBw3IV;EkB/3IM;IAOI,yBAAA;ElB23IV;EkBl4IM;IAOI,6BAAA;ElB83IV;EkBr4IM;IAOI,8BAAA;ElBi4IV;EkBx4IM;IAOI,wBAAA;ElBo4IV;EkB34IM;IAOI,+BAAA;ElBu4IV;EkB94IM;IAOI,wBAAA;ElB04IV;EkBj5IM;IAOI,yBAAA;ElB64IV;EkBp5IM;IAOI,8BAAA;ElBg5IV;EkBv5IM;IAOI,iCAAA;ElBm5IV;EkB15IM;IAOI,sCAAA;ElBs5IV;EkB75IM;IAOI,yCAAA;ElBy5IV;EkBh6IM;IAOI,uBAAA;ElB45IV;EkBn6IM;IAOI,uBAAA;ElB+5IV;EkBt6IM;IAOI,yBAAA;ElBk6IV;EkBz6IM;IAOI,yBAAA;ElBq6IV;EkB56IM;IAOI,0BAAA;ElBw6IV;EkB/6IM;IAOI,4BAAA;ElB26IV;EkBl7IM;IAOI,kCAAA;ElB86IV;EkBr7IM;IAOI,sCAAA;ElBi7IV;EkBx7IM;IAOI,oCAAA;ElBo7IV;EkB37IM;IAOI,kCAAA;ElBu7IV;EkB97IM;IAOI,yCAAA;ElB07IV;EkBj8IM;IAOI,wCAAA;ElB67IV;EkBp8IM;IAOI,wCAAA;ElBg8IV;EkBv8IM;IAOI,kCAAA;ElBm8IV;EkB18IM;IAOI,gCAAA;ElBs8IV;EkB78IM;IAOI,8BAAA;ElBy8IV;EkBh9IM;IAOI,gCAAA;ElB48IV;EkBn9IM;IAOI,+BAAA;ElB+8IV;EkBt9IM;IAOI,oCAAA;ElBk9IV;EkBz9IM;IAOI,kCAAA;ElBq9IV;EkB59IM;IAOI,gCAAA;ElBw9IV;EkB/9IM;IAOI,uCAAA;ElB29IV;EkBl+IM;IAOI,sCAAA;ElB89IV;EkBr+IM;IAOI,iCAAA;ElBi+IV;EkBx+IM;IAOI,2BAAA;ElBo+IV;EkB3+IM;IAOI,iCAAA;ElBu+IV;EkB9+IM;IAOI,+BAAA;ElB0+IV;EkBj/IM;IAOI,6BAAA;ElB6+IV;EkBp/IM;IAOI,+BAAA;ElBg/IV;EkBv/IM;IAOI,8BAAA;ElBm/IV;EkB1/IM;IAOI,oBAAA;ElBs/IV;EkB7/IM;IAOI,mBAAA;ElBy/IV;EkBhgJM;IAOI,mBAAA;ElB4/IV;EkBngJM;IAOI,mBAAA;ElB+/IV;EkBtgJM;IAOI,mBAAA;ElBkgJV;EkBzgJM;IAOI,mBAAA;ElBqgJV;EkB5gJM;IAOI,mBAAA;ElBwgJV;EkB/gJM;IAOI,mBAAA;ElB2gJV;EkBlhJM;IAOI,oBAAA;ElB8gJV;EkBrhJM;IAOI,0BAAA;ElBihJV;EkBxhJM;IAOI,yBAAA;ElBohJV;EkB3hJM;IAOI,uBAAA;ElBuhJV;EkB9hJM;IAOI,yBAAA;ElB0hJV;EkBjiJM;IAOI,uBAAA;ElB6hJV;EkBpiJM;IAOI,uBAAA;ElBgiJV;EkBviJM;IAOI,0BAAA;IAAA,yBAAA;ElBoiJV;EkB3iJM;IAOI,gCAAA;IAAA,+BAAA;ElBwiJV;EkB/iJM;IAOI,+BAAA;IAAA,8BAAA;ElB4iJV;EkBnjJM;IAOI,6BAAA;IAAA,4BAAA;ElBgjJV;EkBvjJM;IAOI,+BAAA;IAAA,8BAAA;ElBojJV;EkB3jJM;IAOI,6BAAA;IAAA,4BAAA;ElBwjJV;EkB/jJM;IAOI,6BAAA;IAAA,4BAAA;ElB4jJV;EkBnkJM;IAOI,wBAAA;IAAA,2BAAA;ElBgkJV;EkBvkJM;IAOI,8BAAA;IAAA,iCAAA;ElBokJV;EkB3kJM;IAOI,6BAAA;IAAA,gCAAA;ElBwkJV;EkB/kJM;IAOI,2BAAA;IAAA,8BAAA;ElB4kJV;EkBnlJM;IAOI,6BAAA;IAAA,gCAAA;ElBglJV;EkBvlJM;IAOI,2BAAA;IAAA,8BAAA;ElBolJV;EkB3lJM;IAOI,2BAAA;IAAA,8BAAA;ElBwlJV;EkB/lJM;IAOI,wBAAA;ElB2lJV;EkBlmJM;IAOI,8BAAA;ElB8lJV;EkBrmJM;IAOI,6BAAA;ElBimJV;EkBxmJM;IAOI,2BAAA;ElBomJV;EkB3mJM;IAOI,6BAAA;ElBumJV;EkB9mJM;IAOI,2BAAA;ElB0mJV;EkBjnJM;IAOI,2BAAA;ElB6mJV;EkBpnJM;IAOI,0BAAA;ElBgnJV;EkBvnJM;IAOI,gCAAA;ElBmnJV;EkB1nJM;IAOI,+BAAA;ElBsnJV;EkB7nJM;IAOI,6BAAA;ElBynJV;EkBhoJM;IAOI,+BAAA;ElB4nJV;EkBnoJM;IAOI,6BAAA;ElB+nJV;EkBtoJM;IAOI,6BAAA;ElBkoJV;EkBzoJM;IAOI,2BAAA;ElBqoJV;EkB5oJM;IAOI,iCAAA;ElBwoJV;EkB/oJM;IAOI,gCAAA;ElB2oJV;EkBlpJM;IAOI,8BAAA;ElB8oJV;EkBrpJM;IAOI,gCAAA;ElBipJV;EkBxpJM;IAOI,8BAAA;ElBopJV;EkB3pJM;IAOI,8BAAA;ElBupJV;EkB9pJM;IAOI,yBAAA;ElB0pJV;EkBjqJM;IAOI,+BAAA;ElB6pJV;EkBpqJM;IAOI,8BAAA;ElBgqJV;EkBvqJM;IAOI,4BAAA;ElBmqJV;EkB1qJM;IAOI,8BAAA;ElBsqJV;EkB7qJM;IAOI,4BAAA;ElByqJV;EkBhrJM;IAOI,4BAAA;ElB4qJV;EkBnrJM;IAOI,qBAAA;ElB+qJV;EkBtrJM;IAOI,2BAAA;ElBkrJV;EkBzrJM;IAOI,0BAAA;ElBqrJV;EkB5rJM;IAOI,wBAAA;ElBwrJV;EkB/rJM;IAOI,0BAAA;ElB2rJV;EkBlsJM;IAOI,wBAAA;ElB8rJV;EkBrsJM;IAOI,2BAAA;IAAA,0BAAA;ElBksJV;EkBzsJM;IAOI,iCAAA;IAAA,gCAAA;ElBssJV;EkB7sJM;IAOI,gCAAA;IAAA,+BAAA;ElB0sJV;EkBjtJM;IAOI,8BAAA;IAAA,6BAAA;ElB8sJV;EkBrtJM;IAOI,gCAAA;IAAA,+BAAA;ElBktJV;EkBztJM;IAOI,8BAAA;IAAA,6BAAA;ElBstJV;EkB7tJM;IAOI,yBAAA;IAAA,4BAAA;ElB0tJV;EkBjuJM;IAOI,+BAAA;IAAA,kCAAA;ElB8tJV;EkBruJM;IAOI,8BAAA;IAAA,iCAAA;ElBkuJV;EkBzuJM;IAOI,4BAAA;IAAA,+BAAA;ElBsuJV;EkB7uJM;IAOI,8BAAA;IAAA,iCAAA;ElB0uJV;EkBjvJM;IAOI,4BAAA;IAAA,+BAAA;ElB8uJV;EkBrvJM;IAOI,yBAAA;ElBivJV;EkBxvJM;IAOI,+BAAA;ElBovJV;EkB3vJM;IAOI,8BAAA;ElBuvJV;EkB9vJM;IAOI,4BAAA;ElB0vJV;EkBjwJM;IAOI,8BAAA;ElB6vJV;EkBpwJM;IAOI,4BAAA;ElBgwJV;EkBvwJM;IAOI,2BAAA;ElBmwJV;EkB1wJM;IAOI,iCAAA;ElBswJV;EkB7wJM;IAOI,gCAAA;ElBywJV;EkBhxJM;IAOI,8BAAA;ElB4wJV;EkBnxJM;IAOI,gCAAA;ElB+wJV;EkBtxJM;IAOI,8BAAA;ElBkxJV;EkBzxJM;IAOI,4BAAA;ElBqxJV;EkB5xJM;IAOI,kCAAA;ElBwxJV;EkB/xJM;IAOI,iCAAA;ElB2xJV;EkBlyJM;IAOI,+BAAA;ElB8xJV;EkBryJM;IAOI,iCAAA;ElBiyJV;EkBxyJM;IAOI,+BAAA;ElBoyJV;EkB3yJM;IAOI,0BAAA;ElBuyJV;EkB9yJM;IAOI,gCAAA;ElB0yJV;EkBjzJM;IAOI,+BAAA;ElB6yJV;EkBpzJM;IAOI,6BAAA;ElBgzJV;EkBvzJM;IAOI,+BAAA;ElBmzJV;EkB1zJM;IAOI,6BAAA;ElBszJV;EkB7zJM;IAOI,iBAAA;ElByzJV;EkBh0JM;IAOI,uBAAA;ElB4zJV;EkBn0JM;IAOI,sBAAA;ElB+zJV;EkBt0JM;IAOI,oBAAA;ElBk0JV;EkBz0JM;IAOI,sBAAA;ElBq0JV;EkB50JM;IAOI,oBAAA;ElBw0JV;EkB/0JM;IAOI,qBAAA;ElB20JV;EkBl1JM;IAOI,2BAAA;ElB80JV;EkBr1JM;IAOI,0BAAA;ElBi1JV;EkBx1JM;IAOI,wBAAA;ElBo1JV;EkB31JM;IAOI,0BAAA;ElBu1JV;EkB91JM;IAOI,wBAAA;ElB01JV;EkBj2JM;IAOI,wBAAA;ElB61JV;EkBp2JM;IAOI,8BAAA;ElBg2JV;EkBv2JM;IAOI,6BAAA;ElBm2JV;EkB12JM;IAOI,2BAAA;ElBs2JV;EkB72JM;IAOI,6BAAA;ElBy2JV;EkBh3JM;IAOI,2BAAA;ElB42JV;EkBn3JM;IAOI,2BAAA;ElB+2JV;EkBt3JM;IAOI,4BAAA;ElBk3JV;EkBz3JM;IAOI,6BAAA;ElBq3JV;AACF;AmB56JA;ED+CQ;IAOI,4BAAA;ElB03JV;EkBj4JM;IAOI,0BAAA;ElB63JV;EkBp4JM;IAOI,6BAAA;ElBg4JV;EkBv4JM;IAOI,4BAAA;ElBm4JV;AACF;AmBv6JA;ED4BQ;IAOI,0BAAA;ElBw4JV;EkB/4JM;IAOI,gCAAA;ElB24JV;EkBl5JM;IAOI,yBAAA;ElB84JV;EkBr5JM;IAOI,wBAAA;ElBi5JV;EkBx5JM;IAOI,+BAAA;ElBo5JV;EkB35JM;IAOI,yBAAA;ElBu5JV;EkB95JM;IAOI,6BAAA;ElB05JV;EkBj6JM;IAOI,8BAAA;ElB65JV;EkBp6JM;IAOI,wBAAA;ElBg6JV;EkBv6JM;IAOI,+BAAA;ElBm6JV;EkB16JM;IAOI,wBAAA;ElBs6JV;AACF;AoBh/JA,oBAAA;AAEA,qBAAA;AAEA;EACE,sBAAA;EACA,iFAAA;ApBg/JF;AoB7+JA;EACE,+BAAA;EACA,iFAAA;ApB++JF;AoB5+JA;EACE,6BAAA;EACA,iFAAA;ApB8+JF;AoB3+JA;EACE,2BAAA;EACA,iFAAA;ApB6+JF;AoBl+JA,oBAAA;AAEA,qBAAA;AAuCA,oBAAA;AAEA,qBAAA;AAIA,oBAAA;AAEA,qBAAA;AAKA,oBAAA;AAEA,qBAAA;AAgBA,oBAAA;AAEA,qBAAA;AAGA,oBAAA;AAEA,qBAAA;AAmCA;EACE,kBAAA;EACA,YAAA;ApB83JF;;AoB33JA;EACE,8FAAA;ApB83JF;;AoB33JA;EACE,iGAAA;ApB83JF;;AoB33JA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;ApB83JF;;AoB33JA;EACE,WAAA;EACA,WAAA;ApB83JF;;AoB33JA,iBAAA;AACA;EACE,YAAA;EACA,mBAAA;EACA,iDAAA;ApB83JF;;AoB13JA;EACE,6BAAA;ApB63JF;;AoB13JA;;EAEE,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;ApB63JF;;AoB13JA;EACE,gBAAA;EACA,cAAA;ApB63JF;;AoB33JA;EACE,UAAA;EACA,WAAA;ApB83JF;;AoB33JA,UAAA;AACA;EAGE,mBAAA;ApB43JF;;AoBz3JA,WAAA;AACA;EAEE,mBAAA;ApB23JF;;AoBx3JA,oBAAA;AAKA;EACE,aAAA;EACA,8BAAA;ApBu3JF;;AoBn3JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ApBs3JF;;AoBn3JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,gBAAA;ApBq3JF;;AoBl3JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;ApBq3JF;;AoBl3JA;EACE,cAAA;ApBq3JF;;AoBl3JA;EACE,cAAA;ApBq3JF;;AoBl3JA,uBAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ApBq3JF;;AoBl3JA;EACE,0CAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;ApBq3JF;;AoBl3JA;EACE,0CAAA;EACA,uBAAA;ApBq3JF;;AoBl3JA;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,0BAAA;EACA,WAAA;ApBq3JF;;AoBl3JA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,iCAAA;ApBq3JF;;AoBl3JA;EACE,cAAA;ApBq3JF;;AoBl3JA;EACE,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;ApBq3JF;;AoBl3JA;;EAEE,yBAAA;EACA,WAAA;ApBq3JF;;AoBl3JA;EACE,yBAAA;ApBq3JF;;AoBl3JA;EACE,oCAAA;EACA,aAAA;EACA,eAAA;ApBq3JF;;AoBl3JA;EACE,kBAAA;ApBq3JF;;AoBl3JA;EACE,oCAAA;EACA,gCAAA;ApBq3JF;;AoBl3JA;EACE,gBAAA;ApBq3JF;;AoBl3JA;EACE,gBAAA;ApBq3JF;;AoBl3JA;EACE,sBAAA;ApBq3JF;;AoBl3JA;EACE,gFA1OoB;ApB+lKtB;;AoBl3JA;EACE,kEAjPY;ApBsmKd;;AoBl3JA;EACE,8BAAA;ApBq3JF;;AoBl3JA;EACE,6BAAA;ApBq3JF;;AoBl3JA;EACE,eAAA;ApBq3JF;;AoBl3JA;EACE,+DAAA;ApBq3JF;;AoBl3JA;EAEE,8BAAA;ApBo3JF;;AoBj3JA;EACE,6BAAA;ApBo3JF;;AoBj3JA;EACE,+BAAA;ApBo3JF;;AoBj3JA;EACE,2BAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;EACA,iBAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,mBAAA;ApBo3JF;;AoBj3JA;EACE,YAAA;ApBo3JF;;AoBj3JA;EACE,cAlUa;ApBsrKf;;AoBj3JA;EACE,yBArUkB;ApByrKpB;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,cAAA;ApBo3JF;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,cAAA;ApBo3JF;;AoBj3JA;EACE,cAjWY;ApBqtKd;;AoBj3JA;EACE,cA5VU;ApBgtKZ;;AoBj3JA;EACE,cA9VU;ApBktKZ;;AoBj3JA;EACE,cAjWc;ApBqtKhB;;AoBj3JA;EACE,cApWc;EAqWd,YAAA;ApBo3JF;;AoBj3JA;EACE,cAAA;ApBo3JF;;AoBj3JA;EACE,yBA1XY;ApB8uKd;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,yBAjYa;ApBqvKf;;AoBj3JA;EACE,yBAlcS;ApBszKX;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,yBArYU;ApByvKZ;;AoBj3JA;EACE,yBAvYU;ApB2vKZ;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,yBAxZY;ApB4wKd;;AoBj3JA;EACE,yBAAA;ApBo3JF;;AoBj3JA;EACE,oCAAA;EACA,gCAAA;ApBo3JF;;AoBj3JA;EACE,oCAAA;ApBo3JF;;AoBj3JA;EACE,mBAAA;ApBo3JF;;AoBj3JA;EACE,0BAAA;ApBo3JF;;AoBj3JA;EACE,2BAAA;ApBo3JF;;AoBj3JA;EACE,eAAA;ApBo3JF;;AoBj3JA;EACE,oCAAA;ApBo3JF;;AoBj3JA;EACE,yBA5aa;ApBgyKf;;AoBh3JA;EACE,oBAAA;ApBm3JF;;AoBh3JA,aAAA;AACA;EACE,oBAAA;EACA,sBAAA;ApBm3JF;;AoBh3JA;EACE,WAAA;EACA,qBAAA;EACA,8CAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ApBm3JF;;AoBh3JA;EACE,WAAA;EACA,qBAAA;EACA,8CAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ApBm3JF;;AoBh3JA;EACE,uBAAA;ApBm3JF;;AoBz2JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ApB42JF;;AoBz2JA;EACE,aAAA;EACA,yBAtea;EAueb,mEApekB;EAqelB,mBApeU;EAqeV,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;ApB42JF;;AoBx2JA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ApB22JF;;AoBx2JA;EACE,SAAA;EACA,cAngBU;ApB82KZ;;AoBx2JA;EACE,eAAA;EACA,cAxgBU;EAygBV,+BAlnBqB;EAmnBrB,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,cA5hBM;EA6hBN,sBA3nBuB;EA4nBvB,yBA7hBY;EA8hBZ,iBAAA;EACA,kBAAA;ApB22JF;;AoBx2JA;EACE,cA1hBU;EA2hBV,eAAA;EACA,iBAAA;EACA,cAAA;ApB22JF;;AoBx2JA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,cA/iBM;EAgjBN,yBA/iBY;EAgjBZ,YAAA;ApB22JF;;AoBx2JA;EACE,gBAAA;ApB22JF;;AoBx2JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;ApB22JF;;AoBx2JA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8DAAA;EACA,yBArkBM;EAskBN,cAAA;EACA,cAnjBa;EAojBb,kBAAA;EACA,iBAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,iBAAA;EACA,cArkBU;ApBg7KZ;;AoBx2JA;EACE,SAAA;EACA,cAAA;EACA,eAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,cA1lBM;EA2lBN,sBAAA;EACA,yBA3lBY;EA4lBZ,gBAAA;EACA,kBAAA;EACA,gBAAA;ApB22JF;;AoBx2JA;EACE,SAAA;EACA,eAAA;ApB22JF;;AoBx2JA;EACE,sBAAA;EACA,UAAA;ApB22JF;;AoBx2JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;ApB22JF;;AoBx2JA;EACE,UAAA;EACA,uBAAA;ApB22JF;;AoBx2JA;EACE,UAAA;ApB22JF;;AoBx2JA;EACE,mEAxmBkB;EAymBlB,yBA5mBa;EA6mBb,mBAzmBU;EA0mBV,sBAAA;ApB22JF;;AoBx2JA;EACE,SAAA;EACA,cA7nBU;EA8nBV,eAAA;EACA,+BAxuBqB;ApBmlLvB;;AoBx2JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;ApB22JF;;AoBx2JA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;ApB22JF;;AoBx2JA;EACE,SAAA;ApB22JF;;AoBx2JA;EACE,UAAA;EACA,qBAAA;ApB22JF;;AoBx2JA;EACE,UAAA;ApB22JF;;AoBx2JA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;ApB22JF;;AoBx2JA;EACE,eAAA;ApB22JF;;AoBx2JA;EACE,sBAAA;EACA,cAprBM;ApB+hLR;;AoBx2JA;EACE,mEAjqBkB;EAkqBlB,yBArqBa;EAsqBb,mBAlqBU;EAmqBV,sBAAA;ApB22JF;;AoBx2JA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,cA5rBU;EA6rBV,SAAA;ApB22JF;;AoBx2JA;EACE,sBAAA;EACA,eAAA;EACA,cA7sBM;ApBwjLR;;AoBx2JA;EACE,eAAA;EACA,iBAAA;EACA,cA/rBa;EAgsBb,yBAptBM;EAqtBN,kBAAA;EACA,sBAAA;EACA,iBAAA;ApB22JF;;AoBx2JA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;EACA,eAAA;EACA,iBAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,cA3tBU;EA4tBV,gBAAA;EACA,cAAA;ApB22JF;;AoBx2JA;EACE,eAAA;EACA,cAluBU;EAmuBV,gBAAA;EACA,cAAA;ApB22JF;;AoBx2JA;;;;;;EAME,oBAAA;ApB22JF;;AoBx2JA;EACE,oCAAA;EACA,6BAAA;EACA,8BAAA;ApB22JF;;AoBx2JA;EACE,YAAA;EACA,aAAA;EACA,SAAA;ApB22JF;;AoBx2JA;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;ApB22JF;;AoBx2JA;EACE,UAAA;ApB22JF;;AoBx2JA;EACE,UAAA;ApB22JF;;AoBx2JA;EACE,WAAA;EACA,WAAA;EACA,aAAA;ApB22JF;;AoBx2JA;EACE,sBAAA;ApB22JF;;AoBx2JA;EACE,YAAA;ApB22JF;;AoBx2JA;EACE,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;ApB22JF;;AoBx2JA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;ApB22JF;;AoBx2JA;EACE,UAAA;ApB22JF;;AoBx2JA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;ApB22JF;;AoBx2JA;EACE,aAjzBU;EAkzBV,cAAA;ApB22JF;;AoBx2JA;EACE,eAAA;ApB22JF;;AoBx2JA;EACE,aA1zBU;ApBqqLZ;;AoBx2JA;EACE,kBAAA;ApB22JF;;AoBx2JA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAn1BM;ApB8rLR;;AoBx2JA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBA91BM;ApBysLR;;AoBx2JA;EACE,kCAAA;EACA,YAAA;ApB22JF;;AoBx2JA,mBAAA;AACA;EACE,6BAAA;EACA,qBAAA;ApB22JF;AoBz2JE;EACE,cAl2BQ;EAm2BR,eAAA;EACA,qBAAA;EACA,gBAAA;ApB22JJ;AoBx2JE;EACE,YAAA;EACA,mBAAA;ApB02JJ;;AoBr2JA;EACE,cA92BU;EA+2BV,eAAA;EACA,UAAA;ApBw2JF;;AoBr2JA;EACE,mBAx2BU;EAy2BV,+DAAA;ApBw2JF;;AoBr2JA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;ApBw2JF;;AoBp2JE;EACE,eAAA;EACA,iBAAA;EACA,2BAz+BU;ApBg1Ld;AoBp2JE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cA74BQ;ApBmvLZ;AoBn2JE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;ApBq2JJ;AoBn2JI;EACE,qBAAA;EAEA,SAAA;EACA,kBAAA;EACA,mBAAA;ApBo2JN;AoBj2JI;EACE,SAAA;EACA,eAAA;ApBm2JN;AoBh2JI;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAt6BM;EAu6BN,qBAAA;ApBk2JN;AoB/1JI;EACE,qBAAA;EACA,iBAAA;ApBi2JN;;AoB31JA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAh8BM;EAi8BN,yBAh8BY;EAi8BZ,qBAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;ApB61JF;;AoB11JA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAt8BY;EAu8BZ,SAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;ApB61JF;;AoB11JA;EACE,aAAA;ApB61JF;;AoB11JA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kEAj9BY;EAk9BZ,SAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ApB61JF;;AoB11JA;EACE,6EAAA;EACA,mBAt9BqB;ApBmzLvB;;AoB11JA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EAEA,SAAA;EAEA,WAAA;EACA,eAAA;ApB21JF;;AoBx1JA;EACE,eAAA;ApB21JF;;AoBv1JA;EACE,yCAAA;EACA,gBAAA;EACA,6DAAA;ApB01JF;;AoBt1JA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kEA1/BY;EA2/BZ,SAAA;EACA,WAAA;ApBy1JF;;AoBt1JA;EACE,uBAAA;EACA,yBAtgCU;ApB+1LZ;;AoBt1JA;EACE;IACE,mBAAA;IACA,YAAA;EpBy1JF;EoBt1JA;IACE,mBAAA;IACA,UAAA;EpBw1JF;AACF;AoBr1JA,gBAAA;AACA;EACE,yBA/hCa;EAgiCb,kBAAA;ApBu1JF;AoBr1JE;EACE,kBAAA;ApBu1JJ;;AoBn1JA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;ApBs1JF;;AoBn1JA;EACE,yBAAA;ApBs1JF;;AoBn1JA;EACE,kBAAA;EACA,sBdpqCS;EcqqCT,wCAAA;EACA,gBAAA;ApBs1JF;AoBp1JE;EACE,uBAAA;EACA,eAAA;ApBs1JJ;AoBn1JE;EACE,SAAA;EACA,qBAAA;EACA,kBAAA;ApBq1JJ;AoBl1JE;EACE,cArkCI;EAskCJ,qBAAA;ApBo1JJ;AoBj1JE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,4DAAA;ApBm1JJ;AoBh1JE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;ApBk1JJ;;AoB70JA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;ApBg1JF;AoB90JE;EACE,SAAA;EACA,6BAAA;ApBg1JJ;;AoB50JA;EACE,aAAA;EACA,SAAA;ApB+0JF;AoB70JE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;ApB+0JJ;AoB50JE;EACE,yBAhnCU;EAinCV,cAxnCQ;ApBs8LZ;AoB30JE;EACE,yBApnCU;EAqnCV,cApnCW;ApBi8Lf;;AoBz0JA;EACE,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;ApB40JF;;AoBz0JA;EACE,WdvvCS;ANmkMX;;AoBz0JA;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;ApB40JF;;AoBz0JA;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;ApB40JF;;AoBx0JE;EACE,UAAA;EACA,SAAA;ApB20JJ;AoBx0JE;EACE,qBAAA;EACA,iBAAA;ApB00JJ;AoBv0JE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;ApBy0JJ;AoBt0JE;EACE,yBAAA;EACA,WAAA;ApBw0JJ;;AoBp0JA,oBAAA;AACA;EACE,mBAAA;EACA,+DAAA;EACA,sBdpyCS;EcqyCT,iBAAA;EACA,WAAA;EACA,WAAA;ApBu0JF;;AoBp0JA;EACE,mBApqCU;EAqqCV,oEAAA;EACA,yBAxqCY;ApB++Ld;AoBr0JE;EACE,mBAzqCQ;EA0qCR,aAAA;EACA,iBAAA;EACA,WAAA;ApBu0JJ;;AoBn0JA;EACE,WAAA;EACA,WAAA;ApBs0JF;AoBp0JE;EACE,UAAA;ApBs0JJ;AoBp0JI;EACE,eAAA;EACA,iBAAA;EACA,cAltCE;EAmtCF,SAAA;ApBs0JN;AoBl0JI;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;ApBo0JN;AoBj0JI;EACE,cArtCM;EAstCN,eAAA;EACA,qBAAA;ApBm0JN;AoBh0JI;EACE,kBAAA;EACA,eAAA;ApBk0JN;AoB/zJI;EACE,UAAA;EACA,kBAAA;ApBi0JN;;AoB1zJE;EACE,eAAA;EACA,iBAAA;EACA,cA3uCQ;EA4uCR,2BAh1CU;ApB6oMd;AoB1zJE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAnvCQ;EAovCR,eAAA;ApB4zJJ;;AoBxzJA;EACE,6BAAA;ApB2zJF;;AoBxzJA;EACE,iBAAA;ApB2zJF;AoBzzJE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;ApB2zJJ;AoBxzJE;EACE,kBAAA;ApB0zJJ;AoBxzJI;EACE,sBdr4CK;AN+rMX;AoBvzJI;EACE,WAAA;EACA,qBAAA;EACA,8CAAA;EACA,sBd54CK;Ec64CL,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;ApByzJN;;AoBnzJA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iEAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;ApBszJF;AoBpzJE;EACE,eAAA;EACA,iBAAA;EACA,cA1yCQ;EA2yCR,qBAAA;EACA,cAAA;EACA,gBAAA;ApBszJJ;AoBnzJE;EACE,cAjzCQ;EAkzCR,qBAAA;ApBqzJJ;AoBlzJE;EACE,WAAA;EACA,qBAAA;EACA,8CAAA;EACA,sBdl7CO;Ecm7CP,WAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;ApBozJJ;;AoBhzJA;EACE,gBAAA;ApBmzJF;;AoBhzJA;EACE,WAAA;EACA,uBAAA;ApBmzJF;;AoBhzJA,qBAAA;AAEA;EACE,mBAh0CU;EAi0CV,+DAAA;EACA,sBdz8CS;AN2vMX;;AoB/yJA;EACE,YAAA;ApBkzJF;;AoB/yJA;EACE,YAAA;EACA,gBAAA;ApBkzJF;;AoB/yJA;EACE,YAAA;ApBkzJF;;AoB/yJA;EACE,YAAA;ApBkzJF;;AoB/yJA;EACE,6BA38CY;ApB6vMd;;AoB/yJA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kEAx2CY;EAy2CZ,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;ApBkzJF;;AoB/yJA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;ApBkzJF;;AoB/yJA;EACE,YAAA;EACA,mBAAA;ApBkzJF;;AoB/yJA,2BAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,mBAx3CU;EAy3CV,oEAAA;EACA,yBA53CY;ApB8qMd;;AoB/yJA;EACE,oCAAA;ApBkzJF;;AoB/yJA;EACE,gCAAA;ApBkzJF;;AoB/yJA;EACE,aAAA;EACA,iBAAA;ApBkzJF;;AoB/yJA;EACE,aAAA;EACA,iBAAA;ApBkzJF;;AoB/yJA;EACE,gBAAA;ApBkzJF;AoBhzJE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;ApBkzJJ;;AoB3yJE;EACE,oBAAA;EACA,eAAA;ApB8yJJ;;AoBzyJA;EACE,eAAA;ApB4yJF;;AoBzyJA;EACE,yBAAA;ApB4yJF;;AoBzyJA;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;ApB4yJF;;AoBzyJA;EACE,kEAAA;ApB4yJF;;AoBzyJA;EACE,oBAAA;EAEA,eAAA;EACA,yBAAA;EACA,mBAAA;ApB2yJF;;AoBxyJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,gBAAA;ApB2yJF;;AoBxyJA;EACE,iBAAA;ApB2yJF;;AoBxyJA;EACE,yBAAA;ApB2yJF;AoBzyJE;EACE,cA/9CQ;ApB0wMZ;;AoBvyJA;EACE,kBAAA;ApB0yJF;;AoBvyJA;EACE,mBAAA;EAEA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ApByyJF;;AoBtyJA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;ApByyJF;;AoBtyJA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;ApByyJF;;AoBtyJA;EACE,yBAAA;ApByyJF;;AoBtyJA;EACE,kBAAA;ApByyJF;;AoBtyJA;EAGE,yBAAA;EACA,aAAA;EACA,8BAAA;ApBuyJF;;AoBlyJA;EACE,kBAAA;EACA,qBAAA;EAEA,UAAA;EACA,mBAAA;ApBoyJF;;AoBjyJA;EAEE,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;ApBmyJF;;AoBhyJA;EACE,yBAAA;ApBmyJF;;AoBhyJA;EACE,aAAA;EACA,iBAAA;ApBmyJF;;AoBhyJA,mBAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,SAAA;ApBmyJF;;AoBhyJA;EACE,yBA/jDU;ApBk2MZ;;AoBhyJA;;EAEE,yBAzoDS;ApB46MX;;AoBhyJA;EAEE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cA5kDU;EA6kDV,6BAAA;ApBkyJF;;AoB/xJA;EACE,qBAAA;ApBkyJF;;AoB/xJA;EACE,cArlDU;EAslDV,eAAA;EACA,iBAAA;ApBkyJF;;AoB9xJA;EACE,mBAAA;ApBiyJF;;AoB9xJA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;ApBiyJF;;AoB9xJA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAnrDS;EAorDT,eAAA;EACA,iBAAA;ApBiyJF;;AoB9xJA;EACE,oBAAA;ApBiyJF;;AoB9xJA;;;EAGE,qBAAA;ApBiyJF;;AoB9xJA;;;EAGE,qBAAA;ApBiyJF;;AoB9xJA;;;EAGE,qBAAA;ApBiyJF;;AoB9xJA;;EAEE,yBAhtDS;EAitDT,WAAA;ApBiyJF;;AoB9xJA;EACE,mBArtDS;EAstDT,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;ApBiyJF;;AoB9xJA;EACE,mBA7tDS;EA8tDT,sBAAA;ApBiyJF;;AoB9xJA;EACE,eAAA;ApBiyJF;;AoB9xJA;EACE,mBAAA;ApBiyJF;;AoB9xJA;;EAEE,oCAAA;EACA,WdhyDS;ANikNX;;AoB9xJA;EACE,mBAprDY;EAqrDZ,yBAAA;ApBiyJF;;AoB9xJA;;EAEE,mBAjrDU;ApBk9MZ;;AoB9xJA;;EAEE,mBA3vDS;EA4vDT,yBAAA;ApBiyJF;;AoB9xJA;;;EAGE,gCAAA;ApBiyJF;;AoB9xJA;EACE,iCAAA;EACA,YAAA;ApBiyJF;;AoB9xJA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;ApBiyJF;AoB/xJE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;ApBiyJJ;;AoB7xJA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;ApBgyJF;;AoB7xJA;EACE,kBAAA;EACA,YAAA;ApBgyJF;;AoB7xJA;EACE,yBAAA;ApBgyJF;;AoB7xJA;EACE,uBAAA;ApBgyJF;;AoB7xJA;EACE,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;ApBgyJF;;AoB7xJA;EACE,uBAAA;ApBgyJF;;AoB7xJA;EACE,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;ApBgyJF;;AoB7xJA;EACE,uBAAA;ApBgyJF;;AoB7xJA;EACE,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;ApBgyJF;;AoB7xJA;EACE,uBAAA;ApBgyJF;;AoB7xJA;EACE,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;ApBgyJF;;AoB5xJE;EACE,kBAAA;EACA,sBdj5DO;Eck5DP,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAvyDQ;EAwyDR,gBAAA;EACA,kBAAA;ApB+xJJ;AoB5xJE;EACE,yBA7yDQ;EA8yDR,Wd55DO;AN0rNX;;AoB1xJA;EACE,sBAAA;ApB6xJF;;AoB1xJA;EACE,SAAA;ApB6xJF;;AoB1xJA;EACE,mBAAA;EACA,iBAAA;ApB6xJF;;AoB1xJA,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ApB6xJF;;AoB1xJA;EACE,yBAr0Da;EAs0Db,gBAAA;ApB6xJF;;AoB1xJA;EACE,oCAAA;ApB6xJF;;AoB1xJA;EACE,oCAAA;ApB6xJF;;AoB1xJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAl5DS;EAm5DT,iBAAA;EACA,eAAA;ApB6xJF;;AoB1xJA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ApB6xJF;;AoB1xJA;EACE,eAAA;ApB6xJF;;AoB1xJA;EACE,kBAAA;EACA,wCAAA;ApB6xJF;;AoB1xJA;EACE,kBAAA;EACA,uCAAA;ApB6xJF;;AoB1xJA;EACE,gBAAA;ApB6xJF;;AoB1xJA;EACE,YAAA;EACA,kBAAA;ApB6xJF;;AoB1xJA;EACE,YAAA;EACA,kBAAA;ApB6xJF;;AoBxxJA;EACE,cAAA;EACA,kBAAA;ApB2xJF;;AoBxxJA,UAAA;AACA;EACE,UAAA;EACA,WAAA;ApB2xJF;;AoBxxJA,UAAA;AACA;EACE,uBAAA;EACA,mBAAA;ApB2xJF;;AoBvxJA,WAAA;AACA;EACE,mBAn5Da;ApB6qNf;;AoBvxJA,oBAAA;AACA;EACE,mBAz5DY;ApBmrNd;;AoBvxJA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBA34DY;EA44DZ,iBAAA;ApB0xJF;;AoBvxJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAn5DY;EAo5DZ,iBAAA;ApB0xJF;;AoBvxJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sBAAA;EACA,WAAA;EACA,uBAAA;ApByxJF;;AoBtxJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sBAAA;EACA,WAAA;EACA,uBAAA;ApBwxJF;;AoBrxJA;EACE,sBAAA;ApBwxJF;;AoBrxJA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBAn7DY;ApB2sNd;;AoBrxJA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,yBA17DY;EA27DZ,qBAAA;ApBwxJF;;AoBrxJA;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,cA98DU;EA+8DV,mBAAA;ApBwxJF;;AoBrxJA;EACE,SAAA;ApBwxJF;;AoBrxJA;EACE,aAAA;ApBwxJF;;AoBpxJE;EACE,yBAh9DU;ApBuuNd;AoBpxJE;EACE,sBdzlEO;Ec0lEP,cA3+DI;ApBiwNR;;AoBlxJA;EACE,aAAA;EACA,kBAAA;ApBqxJF;;AoBlxJA;EACE,kEAt+DY;EAu+DZ,gBAAA;ApBqxJF;;AoBlxJA;EACE,aAAA;EACA,kBAAA;ApBqxJF;;AoBlxJA;EAEE,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;ApBqxJF;;AoBlxJA;EACE,oCAAA;EACA,yBAAA;ApBqxJF;;AoBlxJA;EAEE,wBAAA;EACA,oBAAA;ApBoxJF;;AoBjxJA;EACE,YAAA;EACA,cAAA;ApBoxJF;;AoBjxJA;EACE,oCAAA;EACA,cAxhEM;ApB4yNR;;AoBjxJA;EAEE,cA7hEM;ApBgzNR;;AoBhxJA;EACE,oCAAA;ApBmxJF;;AoBhxJA;EACE,oCAAA;EACA,YAAA;EACA,WAAA;ApBmxJF;;AoBhxJA;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;ApBmxJF;;AoBhxJA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;ApBmxJF;;AoBhxJA;EACE,UAAA;EACA,QAAA;EACA,SAAA;ApBmxJF;;AoBhxJA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;ApBmxJF;;AoBhxJA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;ApBmxJF;;AoBhxJA;EACE,yBAAA;ApBmxJF;;AoBhxJA;EACE,2BAAA;ApBmxJF;;AoBhxJA;EAGE,2BAAA;EACA,yBAAA;ApBmxJF;;AoBhxJA,oBAAA;AACA;EACE,mBAAA;ApBmxJF;;AoBhxJA;EACE,kBAAA;ApBmxJF;;AoB/wJE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;ApBkxJJ;AoB/wJE;EACE,yBAAA;EACA,gBAAA;ApBixJJ;;AoB7wJA;EACE,qCAAA;ApBgxJF;;AoB7wJA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ApBgxJF;AoB9wJE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,+DAAA;EACA,yBAAA;EACA,iBAAA;ApBgxJJ;;AoB5wJA,oBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,qBAAA;ApB+wJF;;AoB5wJA;EACE,eAAA;ApB+wJF;;AoB5wJA;EACE,iBAAA;ApB+wJF;;AoB5wJA,oBAAA;AACA;EACE,iBAAA;ApB+wJF;;AoB5wJA;EACE,yBAAA;ApB+wJF;;AoB5wJA;EACE,SAAA;EACA,gCAAA;EACA,aAAA;ApB+wJF;;AoB5wJA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gEAAA;EACA,YAAA;EACA,SAAA;ApB+wJF;;AoB5wJA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;ApB+wJF;;AoB5wJA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ApB+wJF;;AoB5wJA;EACE,oCAAA;ApB+wJF;;AoB5wJA;EACE,WAAA;ApB+wJF;;AoB5wJA;EACE,sBdl0ES;Ecm0ET,cA1sEU;EA2sEV,eAAA;ApB+wJF;;AoB5wJA;EACE,6BAAA;EAEA,qBAAA;EACA,6BAAA;ApB8wJF;;AoB3wJA;EACE,mBA/tEY;EAguEZ,cAvtEU;ApBq+NZ;;AoB3wJA;;EAEE,8BAAA;EACA,yBAAA;ApB8wJF;;AoB3wJA;EACE,mBA3uEM;EA4uEN,Wd31ES;Ec41ET,mBAAA;ApB8wJF;;AoB3wJA;;EAEE,mBAlvEM;ApBggOR;;AoB3wJA;;EAEE,8BAAA;ApB8wJF;;AoB3wJA;;EAEE,8BAAA;EACA,sBAAA;ApB8wJF;;AoB3wJA;EACE,8BAAA;EACA,mBAAA;ApB8wJF;;AoB3wJA;;;EAGE,kBAAA;ApB8wJF;;AoB3wJA;EACE,sBAAA;EACA,+DAAA;ApB8wJF;;AoB3wJA;EACE,cAAA;ApB8wJF;;AoB3wJA,wBAAA;AACA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;ApB8wJF;;AoB3wJA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;ApB8wJF;;AoB3wJA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;ApB8wJF;;AoB3wJA;EACE,eAAA;ApB8wJF;;AoB3wJA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ApB8wJF;;AoB3wJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBdj7ES;Eck7ET,yBAAA;EACA,UAAA;EACA,eAAA;ApB8wJF;;AoB3wJA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,UAAA;EACA,cAh1EU;EAi1EV,iBAAA;ApB8wJF;;AoB3wJA;EACE,cAr1EU;ApBmmOZ;;AoB3wJA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,yBAAA;ApB8wJF;;AoB3wJA;EACE,yBAAA;ApB8wJF;;AoBhwJA;EACE,mBAAA;EACA,gBAAA;ApBmwJF;;AoBhwJA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;ApBmwJF;;AoBhwJA,yBAAA;AACS;EACP,aAAA;EACA,iBAAA;ApBmwJF;;AoBhwJA;EACE,aAAA;EACA,iBAAA;ApBmwJF;;AoBhwJA;EACE,cAAA;ApBmwJF;;AoBhwJA;EACE,iBAAA;ApBmwJF;;AoBhwJA;EACE,UAAA;ApBmwJF;;AoBhwJA,mBAAA;AACA;EACE;IACE,0BAAA;IACA,0CAAA;EpBmwJF;EoBhwJA;IACE,MAAA;IACA,gBAAA;EpBkwJF;EoB/vJA;IACE,UAAA;EpBiwJF;EoB9vJA;IACE,eAAA;EpBgwJF;EoB7vJA;IACE,eAAA;EpB+vJF;EoB5vJA;IACE,UAAA;EpB8vJF;EoB3vJA;IACE,eAAA;IACA,eAAA;EpB6vJF;EoB1vJA;IACE,mBAAA;EpB4vJF;EoBzvJA;IACE,UAAA;EpB2vJF;EoBxvJA;IACE,gBAAA;IACA,iBAAA;EpB0vJF;EoBvvJA;IACE,gBAAA;EpByvJF;EoBtvJA;IACE,YAAA;IACA,YAAA;EpBwvJF;EoBrvJA;IACE,aAAA;IACA,kBAAA;EpBuvJF;EoBpvJA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;EpBsvJF;EoBnvJA;IACE,uBAAA;EpBqvJF;EoBlvJA;IACE,aAAA;IACA,kBAAA;EpBovJF;EoBjvJA;IACE,aAAA;IACA,kBAAA;EpBmvJF;AACF;AoB9uJA;EACE;IACE,4BAAA;IACA,6BAAA;EpBgvJF;EoB7uJA;IACE,eAAA;EpB+uJF;EoB5uJA;IACE,gBAAA;EpB8uJF;EoB3uJA;IACE,gBAAA;EpB6uJF;EoB1uJA;;IAEE,eAAA;EpB4uJF;EoBzuJA;IACE,mBAAA;EpB2uJF;EoBxuJA;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EpB0uJF;EoBvuJA;IACE,eAAA;IACA,eAAA;EpByuJF;EoBtuJA;IAEE,QAAA;IACA,SAAA;EpBuuJF;EoBpuJA;IACE,gBAAA;EpBsuJF;EoBnuJA;IACE,gBAAA;IACA,WAAA;IACA,wBAAA;IACA,eAAA;EpBquJF;EoBluJA;IACE,gBAAA;IACA,WAAA;EpBouJF;EoBjuJA;IACE,gBAAA;IACA,WAAA;EpBmuJF;EoBhuJA;IACE,eAAA;EpBkuJF;EoB/tJA;IACE,aAAA;EpBiuJF;EoB9tJA;IACE,WAAA;EpBguJF;EoB7tJA;IACE,kBAAA;IACA,WAAA;IACA,qBAAA;IACA,iBAAA;EpB+tJF;EoB5tJA;IACE,0BAAA;EpB8tJF;EoB3tJA;IACE,0BAAA;EpB6tJF;EoB1tJA;IACE,aAAA;EpB4tJF;EoBztJA;IACE,WAAA;IACA,aAAA;EpB2tJF;EoBxtJA;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,eAAA;EpB0tJF;EoBvtJA;IACE,yBAAA;EpBytJF;EoBttJA;IACE,yBAAA;EpBwtJF;EoBrtJA;IACE,wBAAA;EpButJF;EoBptJA;IACE,kBAAA;IACA,aAAA;IACA,OAAA;EpBstJF;EoBntJA;IACE,eAAA;IACA,eAAA;EpBqtJF;EoBltJA;IACE,4BAAA;EpBotJF;EoBjtJA;IACE,qBAAA;EpBmtJF;EoBhtJA;IACE,yCAAA;EpBktJF;EoB/sJA;IACE,6BAAA;IACA,8BAAA;EpBitJF;EoB9sJA;;IAEE,2BAAA;EpBgtJF;EoB7sJA;IACE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;EpB+sJF;EoB5sJA;IACE,kBAAA;EpB8sJF;EoB3sJA;IACE,aAAA;EpB6sJF;EoB1sJA;IACE,cAAA;IACA,uBAAA;IACA,8BAAA;EpB4sJF;EoBzsJA;IACE,WAAA;IACA,kBAAA;EpB2sJF;EoBxsJA;IACE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,YAAA;IACA,WAAA;EpB0sJF;EoBvsJA;IACE,kBAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,WAAA;EpBysJF;EoBtsJA;IACE,oBAAA;EpBwsJF;EoBrsJA;IACE,2BAAA;EpBusJF;EoBpsJA;IACE,eAAA;IACA,YAAA;EpBssJF;EoBnsJA;IACE,0BAAA;IACA,YAAA;EpBqsJF;EoBlsJA;IACE,wBAAA;EpBosJF;EoBjsJA;IACE,eAAA;EpBmsJF;EoBhsJA;IACE,wBAAA;IACA,8BAAA;EpBksJF;EoB/rJA;IACE,eAAA;EpBisJF;EoB9rJA;IACE,eAAA;EpBgsJF;EoB7rJA;IACE,sBAAA;EpB+rJF;EoB5rJA;IACE,cAAA;IACA,uBAAA;IACA,8BAAA;EpB8rJF;EoB3rJA;IACE,eAAA;EpB6rJF;EoB1rJA;IACE,0BAAA;EpB4rJF;EoBzrJA;IACE,eAAA;EpB2rJF;AACF;AoBxrJA;EACE;IACE,cAAA;IACA,WAAA;IACA,WAAA;EpB0rJF;EoBvrJA;IACE,6BAAA;IACA,aAAA;IACA,SAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,QAAA;IACA,cAAA;EpByrJF;AACF;AoBtrJA;EACE;IACE,YAAA;EpBwrJF;AACF;AqB1iPE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,+BAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AtB8iPF;;AwB9pPI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AtB8iPJ;;AyBttPA;;;EAGE,sBAAA;AzBytPF;;AyB1sPI;EANJ;IAOM,uBAAA;EzB8sPJ;AACF;;AyBjsPA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AzBosPF;;AyB3rPA;EACE,cAAA;EACA,cnBmnB4B;EmBlnB5B,SAAA;EACA,wCAAA;EACA,anBynB4B;ANqkO9B;;AyBprPA;EACE,aAAA;EACA,qBnBwjB4B;EmBrjB5B,gBnBwjB4B;EmBvjB5B,gBnBwjB4B;EmBvjB5B,8BAAA;AzBqrPF;;AyBlrPA;EFuMQ,iCAAA;AvB++OR;AuB3oPI;EE3CJ;IF8MQ,iBAAA;EvB4+ON;AACF;;AyBtrPA;EFkMQ,iCAAA;AvBw/OR;AuBppPI;EEtCJ;IFyMQ,eAAA;EvBq/ON;AACF;;AyB1rPA;EF6LQ,+BAAA;AvBigPR;AuB7pPI;EEjCJ;IFoMQ,kBAAA;EvB8/ON;AACF;;AyB9rPA;EFwLQ,iCAAA;AvB0gPR;AuBtqPI;EE5BJ;IF+LQ,iBAAA;EvBugPN;AACF;;AyBlsPA;EF+KM,kBALI;AvB4hPV;;AyBjsPA;EF0KM,eALI;AvBgiPV;;AyB1rPA;EACE,aAAA;EACA,mBnBwV0B;ANq2O5B;;AyBnrPA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AzBsrPF;;AyBhrPA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AzBmrPF;;AyB7qPA;;EAEE,kBAAA;AzBgrPF;;AyB7qPA;;;EAGE,aAAA;EACA,mBAAA;AzBgrPF;;AyB7qPA;;;;EAIE,gBAAA;AzBgrPF;;AyB7qPA;EACE,gBnB6b4B;ANmvO9B;;AyB3qPA;EACE,qBAAA;EACA,cAAA;AzB8qPF;;AyBxqPA;EACE,gBAAA;AzB2qPF;;AyBnqPA;;EAEE,mBnBsa4B;ANgwO9B;;AyB9pPA;EF6EM,kBALI;AvB0lPV;;AyB3pPA;EACE,iBnBqf4B;EmBpf5B,gCAAA;EACA,wCAAA;AzB8pPF;;AyBrpPA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AzBwpPF;;AyBrpPA;EAAM,eAAA;AzBypPN;;AyBxpPA;EAAM,WAAA;AzB4pPN;;AyBvpPA;EACE,gEAAA;EACA,0BnBgNwC;AN08O1C;AyBxpPE;EACE,mDAAA;AzB0pPJ;;AyB/oPE;EAEE,cAAA;EACA,qBAAA;AzBipPJ;;AyB1oPA;;;;EAIE,qCnBgV4B;EiBlUxB,cALI;AvBqoPV;;AyBtoPA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AvB6oPV;AyBroPE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AzBuoPJ;;AyBnoPA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AzBsoPF;AyBnoPE;EACE,cAAA;AzBqoPJ;;AyBjoPA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBnBy5CkC;EmBx5ClC,sCnBy5CkC;EoB9rDhC,sBAAA;A1B06PJ;AyBloPE;EACE,UAAA;EF7BE,cALI;AvBuqPV;;AyB1nPA;EACE,gBAAA;AzB6nPF;;AyBvnPA;;EAEE,sBAAA;AzB0nPF;;AyBlnPA;EACE,oBAAA;EACA,yBAAA;AzBqnPF;;AyBlnPA;EACE,mBnB4X4B;EmB3X5B,sBnB2X4B;EmB1X5B,gCnB4Z4B;EmB3Z5B,gBAAA;AzBqnPF;;AyB9mPA;EAEE,mBAAA;EACA,gCAAA;AzBgnPF;;AyB7mPA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AzBgnPF;;AyBxmPA;EACE,qBAAA;AzB2mPF;;AyBrmPA;EAEE,gBAAA;AzBumPF;;AyB/lPA;EACE,UAAA;AzBkmPF;;AyB7lPA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AzBgmPF;;AyB5lPA;;EAEE,oBAAA;AzB+lPF;;AyB1lPA;EACE,eAAA;AzB6lPF;;AyB1lPA;EAGE,iBAAA;AzB2lPF;AyBxlPE;EACE,UAAA;AzB0lPJ;;AyBnlPA;EACE,wBAAA;AzBslPF;;AyB9kPA;;;;EAIE,0BAAA;AzBilPF;AyB9kPI;;;;EACE,eAAA;AzBmlPN;;AyB5kPA;EACE,UAAA;EACA,kBAAA;AzB+kPF;;AyB1kPA;EACE,gBAAA;AzB6kPF;;AyBnkPA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AzBskPF;;AyB9jPA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBnBmN4B;EiBpatB,iCAAA;EEoNN,oBAAA;AzBgkPF;AuBh7PI;EEyWJ;IFtMQ,iBAAA;EvBixPN;AACF;AyBnkPE;EACE,WAAA;AzBqkPJ;;AyB9jPA;;;;;;;EAOE,UAAA;AzBikPF;;AyB9jPA;EACE,YAAA;AzBikPF;;AyBxjPA;EACE,6BAAA;EACA,oBAAA;AzB2jPF;;AyBnjPA;;;;;;;CAAA;AAWA;EACE,wBAAA;AzBmjPF;;AyB9iPA;EACE,UAAA;AzBijPF;;AyB1iPA;EACE,aAAA;EACA,0BAAA;AzB6iPF;;AyBxiPA;EACE,qBAAA;AzB2iPF;;AyBtiPA;EACE,SAAA;AzByiPF;;AyBliPA;EACE,kBAAA;EACA,eAAA;AzBqiPF;;AyB7hPA;EACE,wBAAA;AzBgiPF;;AyBxhPA;EACE,wBAAA;AzB2hPF;;A2BhmQA;EJmQM,kBALI;EI5PR,gBrBwoB4B;AN29O9B;;A2B9lQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;ANu/O9B;AuBhgQI;EIpGF;IJuQM,eAAA;EvBi2PN;AACF;;A2BzmQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;ANkgP9B;AuB3gQI;EIpGF;IJuQM,iBAAA;EvB42PN;AACF;;A2BpnQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;AN6gP9B;AuBthQI;EIpGF;IJuQM,eAAA;EvBu3PN;AACF;;A2B/nQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;ANwhP9B;AuBjiQI;EIpGF;IJuQM,iBAAA;EvBk4PN;AACF;;A2B1oQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;ANmiP9B;AuB5iQI;EIpGF;IJuQM,eAAA;EvB64PN;AACF;;A2BrpQE;EJgQM,iCAAA;EI5PJ,gBrBynBkB;EqBxnBlB,gBrBwmB0B;AN8iP9B;AuBvjQI;EIpGF;IJuQM,iBAAA;EvBw5PN;AACF;;A2BxoQA;ECvDE,eAAA;EACA,gBAAA;A5BmsQF;;A2BxoQA;EC5DE,eAAA;EACA,gBAAA;A5BwsQF;;A2B1oQA;EACE,qBAAA;A3B6oQF;A2B3oQE;EACE,oBrBsoB0B;ANugP9B;;A2BnoQA;EJ8MM,kBALI;EIvMR,yBAAA;A3BsoQF;;A2BloQA;EACE,mBrBiUO;EiB1HH,kBALI;AvBo8PV;A2BnoQE;EACE,gBAAA;A3BqoQJ;;A2BjoQA;EACE,iBAAA;EACA,mBrBuTO;EiB1HH,kBALI;EItLR,crBtFS;AN0tQX;A2BloQE;EACE,aAAA;A3BooQJ;;A6BpuQA;ECIE,eAAA;EAGA,YAAA;A9BkuQF;;A6BnuQA;EACE,gBvB+jDkC;EuB9jDlC,mCvB+jDkC;EuB9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;A9B2uQF;;A6B7tQA;EAEE,qBAAA;A7B+tQF;;A6B5tQA;EACE,qBAAA;EACA,cAAA;A7B+tQF;;A6B5tQA;ENyPM,kBALI;EMlPR,gCvBkjDkC;AN6qNpC;;A+BjwQE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AhC8wQF;;AUxtQI;EqB5CE;IACE,gBzBkee;ENsyPrB;AACF;AU9tQI;EqB5CE;IACE,gBzBkee;EN2yPrB;AACF;AUnuQI;EqB5CE;IACE,gBzBkee;ENgzPrB;AACF;AUxuQI;EqB5CE;IACE,iBzBkee;ENqzPrB;AACF;AU7uQI;EqB5CE;IACE,iBzBkee;EN0zPrB;AACF;AiC7yQA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AjCmzQJ;;AiC9yQE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AlCuzQF;AiCrzQI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AlCizQF;;AkClwQM;EACE,SAAA;AlCqwQR;;AkClwQM;EApCJ,cAAA;EACA,WAAA;AlC0yQF;;AkC5xQE;EACE,cAAA;EACA,WAAA;AlC+xQJ;;AkCjyQE;EACE,cAAA;EACA,UAAA;AlCoyQJ;;AkCtyQE;EACE,cAAA;EACA,mBAAA;AlCyyQJ;;AkC3yQE;EACE,cAAA;EACA,UAAA;AlC8yQJ;;AkChzQE;EACE,cAAA;EACA,UAAA;AlCmzQJ;;AkCrzQE;EACE,cAAA;EACA,mBAAA;AlCwzQJ;;AkCzxQM;EAhDJ,cAAA;EACA,WAAA;AlC60QF;;AkCxxQU;EAhEN,cAAA;EACA,kBAAA;AlC41QJ;;AkC7xQU;EAhEN,cAAA;EACA,mBAAA;AlCi2QJ;;AkClyQU;EAhEN,cAAA;EACA,UAAA;AlCs2QJ;;AkCvyQU;EAhEN,cAAA;EACA,mBAAA;AlC22QJ;;AkC5yQU;EAhEN,cAAA;EACA,mBAAA;AlCg3QJ;;AkCjzQU;EAhEN,cAAA;EACA,UAAA;AlCq3QJ;;AkCtzQU;EAhEN,cAAA;EACA,mBAAA;AlC03QJ;;AkC3zQU;EAhEN,cAAA;EACA,mBAAA;AlC+3QJ;;AkCh0QU;EAhEN,cAAA;EACA,UAAA;AlCo4QJ;;AkCr0QU;EAhEN,cAAA;EACA,mBAAA;AlCy4QJ;;AkC10QU;EAhEN,cAAA;EACA,mBAAA;AlC84QJ;;AkC/0QU;EAhEN,cAAA;EACA,WAAA;AlCm5QJ;;AkC50QY;EAxDV,wBAAA;AlCw4QF;;AkCh1QY;EAxDV,yBAAA;AlC44QF;;AkCp1QY;EAxDV,gBAAA;AlCg5QF;;AkCx1QY;EAxDV,yBAAA;AlCo5QF;;AkC51QY;EAxDV,yBAAA;AlCw5QF;;AkCh2QY;EAxDV,gBAAA;AlC45QF;;AkCp2QY;EAxDV,yBAAA;AlCg6QF;;AkCx2QY;EAxDV,yBAAA;AlCo6QF;;AkC52QY;EAxDV,gBAAA;AlCw6QF;;AkCh3QY;EAxDV,yBAAA;AlC46QF;;AkCp3QY;EAxDV,yBAAA;AlCg7QF;;AkC72QQ;;EAEE,gBAAA;AlCg3QV;;AkC72QQ;;EAEE,gBAAA;AlCg3QV;;AkCv3QQ;;EAEE,sBAAA;AlC03QV;;AkCv3QQ;;EAEE,sBAAA;AlC03QV;;AkCj4QQ;;EAEE,qBAAA;AlCo4QV;;AkCj4QQ;;EAEE,qBAAA;AlCo4QV;;AkC34QQ;;EAEE,mBAAA;AlC84QV;;AkC34QQ;;EAEE,mBAAA;AlC84QV;;AkCr5QQ;;EAEE,qBAAA;AlCw5QV;;AkCr5QQ;;EAEE,qBAAA;AlCw5QV;;AkC/5QQ;;EAEE,mBAAA;AlCk6QV;;AkC/5QQ;;EAEE,mBAAA;AlCk6QV;;AU59QI;EwBUE;IACE,SAAA;ElCs9QN;EkCn9QI;IApCJ,cAAA;IACA,WAAA;ElC0/QA;EkC5+QA;IACE,cAAA;IACA,WAAA;ElC8+QF;EkCh/QA;IACE,cAAA;IACA,UAAA;ElCk/QF;EkCp/QA;IACE,cAAA;IACA,mBAAA;ElCs/QF;EkCx/QA;IACE,cAAA;IACA,UAAA;ElC0/QF;EkC5/QA;IACE,cAAA;IACA,UAAA;ElC8/QF;EkChgRA;IACE,cAAA;IACA,mBAAA;ElCkgRF;EkCn+QI;IAhDJ,cAAA;IACA,WAAA;ElCshRA;EkCj+QQ;IAhEN,cAAA;IACA,kBAAA;ElCoiRF;EkCr+QQ;IAhEN,cAAA;IACA,mBAAA;ElCwiRF;EkCz+QQ;IAhEN,cAAA;IACA,UAAA;ElC4iRF;EkC7+QQ;IAhEN,cAAA;IACA,mBAAA;ElCgjRF;EkCj/QQ;IAhEN,cAAA;IACA,mBAAA;ElCojRF;EkCr/QQ;IAhEN,cAAA;IACA,UAAA;ElCwjRF;EkCz/QQ;IAhEN,cAAA;IACA,mBAAA;ElC4jRF;EkC7/QQ;IAhEN,cAAA;IACA,mBAAA;ElCgkRF;EkCjgRQ;IAhEN,cAAA;IACA,UAAA;ElCokRF;EkCrgRQ;IAhEN,cAAA;IACA,mBAAA;ElCwkRF;EkCzgRQ;IAhEN,cAAA;IACA,mBAAA;ElC4kRF;EkC7gRQ;IAhEN,cAAA;IACA,WAAA;ElCglRF;EkCzgRU;IAxDV,cAAA;ElCokRA;EkC5gRU;IAxDV,wBAAA;ElCukRA;EkC/gRU;IAxDV,yBAAA;ElC0kRA;EkClhRU;IAxDV,gBAAA;ElC6kRA;EkCrhRU;IAxDV,yBAAA;ElCglRA;EkCxhRU;IAxDV,yBAAA;ElCmlRA;EkC3hRU;IAxDV,gBAAA;ElCslRA;EkC9hRU;IAxDV,yBAAA;ElCylRA;EkCjiRU;IAxDV,yBAAA;ElC4lRA;EkCpiRU;IAxDV,gBAAA;ElC+lRA;EkCviRU;IAxDV,yBAAA;ElCkmRA;EkC1iRU;IAxDV,yBAAA;ElCqmRA;EkCliRM;;IAEE,gBAAA;ElCoiRR;EkCjiRM;;IAEE,gBAAA;ElCmiRR;EkC1iRM;;IAEE,sBAAA;ElC4iRR;EkCziRM;;IAEE,sBAAA;ElC2iRR;EkCljRM;;IAEE,qBAAA;ElCojRR;EkCjjRM;;IAEE,qBAAA;ElCmjRR;EkC1jRM;;IAEE,mBAAA;ElC4jRR;EkCzjRM;;IAEE,mBAAA;ElC2jRR;EkClkRM;;IAEE,qBAAA;ElCokRR;EkCjkRM;;IAEE,qBAAA;ElCmkRR;EkC1kRM;;IAEE,mBAAA;ElC4kRR;EkCzkRM;;IAEE,mBAAA;ElC2kRR;AACF;AUtoRI;EwBUE;IACE,SAAA;ElC+nRN;EkC5nRI;IApCJ,cAAA;IACA,WAAA;ElCmqRA;EkCrpRA;IACE,cAAA;IACA,WAAA;ElCupRF;EkCzpRA;IACE,cAAA;IACA,UAAA;ElC2pRF;EkC7pRA;IACE,cAAA;IACA,mBAAA;ElC+pRF;EkCjqRA;IACE,cAAA;IACA,UAAA;ElCmqRF;EkCrqRA;IACE,cAAA;IACA,UAAA;ElCuqRF;EkCzqRA;IACE,cAAA;IACA,mBAAA;ElC2qRF;EkC5oRI;IAhDJ,cAAA;IACA,WAAA;ElC+rRA;EkC1oRQ;IAhEN,cAAA;IACA,kBAAA;ElC6sRF;EkC9oRQ;IAhEN,cAAA;IACA,mBAAA;ElCitRF;EkClpRQ;IAhEN,cAAA;IACA,UAAA;ElCqtRF;EkCtpRQ;IAhEN,cAAA;IACA,mBAAA;ElCytRF;EkC1pRQ;IAhEN,cAAA;IACA,mBAAA;ElC6tRF;EkC9pRQ;IAhEN,cAAA;IACA,UAAA;ElCiuRF;EkClqRQ;IAhEN,cAAA;IACA,mBAAA;ElCquRF;EkCtqRQ;IAhEN,cAAA;IACA,mBAAA;ElCyuRF;EkC1qRQ;IAhEN,cAAA;IACA,UAAA;ElC6uRF;EkC9qRQ;IAhEN,cAAA;IACA,mBAAA;ElCivRF;EkClrRQ;IAhEN,cAAA;IACA,mBAAA;ElCqvRF;EkCtrRQ;IAhEN,cAAA;IACA,WAAA;ElCyvRF;EkClrRU;IAxDV,cAAA;ElC6uRA;EkCrrRU;IAxDV,wBAAA;ElCgvRA;EkCxrRU;IAxDV,yBAAA;ElCmvRA;EkC3rRU;IAxDV,gBAAA;ElCsvRA;EkC9rRU;IAxDV,yBAAA;ElCyvRA;EkCjsRU;IAxDV,yBAAA;ElC4vRA;EkCpsRU;IAxDV,gBAAA;ElC+vRA;EkCvsRU;IAxDV,yBAAA;ElCkwRA;EkC1sRU;IAxDV,yBAAA;ElCqwRA;EkC7sRU;IAxDV,gBAAA;ElCwwRA;EkChtRU;IAxDV,yBAAA;ElC2wRA;EkCntRU;IAxDV,yBAAA;ElC8wRA;EkC3sRM;;IAEE,gBAAA;ElC6sRR;EkC1sRM;;IAEE,gBAAA;ElC4sRR;EkCntRM;;IAEE,sBAAA;ElCqtRR;EkCltRM;;IAEE,sBAAA;ElCotRR;EkC3tRM;;IAEE,qBAAA;ElC6tRR;EkC1tRM;;IAEE,qBAAA;ElC4tRR;EkCnuRM;;IAEE,mBAAA;ElCquRR;EkCluRM;;IAEE,mBAAA;ElCouRR;EkC3uRM;;IAEE,qBAAA;ElC6uRR;EkC1uRM;;IAEE,qBAAA;ElC4uRR;EkCnvRM;;IAEE,mBAAA;ElCqvRR;EkClvRM;;IAEE,mBAAA;ElCovRR;AACF;AU/yRI;EwBUE;IACE,SAAA;ElCwyRN;EkCryRI;IApCJ,cAAA;IACA,WAAA;ElC40RA;EkC9zRA;IACE,cAAA;IACA,WAAA;ElCg0RF;EkCl0RA;IACE,cAAA;IACA,UAAA;ElCo0RF;EkCt0RA;IACE,cAAA;IACA,mBAAA;ElCw0RF;EkC10RA;IACE,cAAA;IACA,UAAA;ElC40RF;EkC90RA;IACE,cAAA;IACA,UAAA;ElCg1RF;EkCl1RA;IACE,cAAA;IACA,mBAAA;ElCo1RF;EkCrzRI;IAhDJ,cAAA;IACA,WAAA;ElCw2RA;EkCnzRQ;IAhEN,cAAA;IACA,kBAAA;ElCs3RF;EkCvzRQ;IAhEN,cAAA;IACA,mBAAA;ElC03RF;EkC3zRQ;IAhEN,cAAA;IACA,UAAA;ElC83RF;EkC/zRQ;IAhEN,cAAA;IACA,mBAAA;ElCk4RF;EkCn0RQ;IAhEN,cAAA;IACA,mBAAA;ElCs4RF;EkCv0RQ;IAhEN,cAAA;IACA,UAAA;ElC04RF;EkC30RQ;IAhEN,cAAA;IACA,mBAAA;ElC84RF;EkC/0RQ;IAhEN,cAAA;IACA,mBAAA;ElCk5RF;EkCn1RQ;IAhEN,cAAA;IACA,UAAA;ElCs5RF;EkCv1RQ;IAhEN,cAAA;IACA,mBAAA;ElC05RF;EkC31RQ;IAhEN,cAAA;IACA,mBAAA;ElC85RF;EkC/1RQ;IAhEN,cAAA;IACA,WAAA;ElCk6RF;EkC31RU;IAxDV,cAAA;ElCs5RA;EkC91RU;IAxDV,wBAAA;ElCy5RA;EkCj2RU;IAxDV,yBAAA;ElC45RA;EkCp2RU;IAxDV,gBAAA;ElC+5RA;EkCv2RU;IAxDV,yBAAA;ElCk6RA;EkC12RU;IAxDV,yBAAA;ElCq6RA;EkC72RU;IAxDV,gBAAA;ElCw6RA;EkCh3RU;IAxDV,yBAAA;ElC26RA;EkCn3RU;IAxDV,yBAAA;ElC86RA;EkCt3RU;IAxDV,gBAAA;ElCi7RA;EkCz3RU;IAxDV,yBAAA;ElCo7RA;EkC53RU;IAxDV,yBAAA;ElCu7RA;EkCp3RM;;IAEE,gBAAA;ElCs3RR;EkCn3RM;;IAEE,gBAAA;ElCq3RR;EkC53RM;;IAEE,sBAAA;ElC83RR;EkC33RM;;IAEE,sBAAA;ElC63RR;EkCp4RM;;IAEE,qBAAA;ElCs4RR;EkCn4RM;;IAEE,qBAAA;ElCq4RR;EkC54RM;;IAEE,mBAAA;ElC84RR;EkC34RM;;IAEE,mBAAA;ElC64RR;EkCp5RM;;IAEE,qBAAA;ElCs5RR;EkCn5RM;;IAEE,qBAAA;ElCq5RR;EkC55RM;;IAEE,mBAAA;ElC85RR;EkC35RM;;IAEE,mBAAA;ElC65RR;AACF;AUx9RI;EwBUE;IACE,SAAA;ElCi9RN;EkC98RI;IApCJ,cAAA;IACA,WAAA;ElCq/RA;EkCv+RA;IACE,cAAA;IACA,WAAA;ElCy+RF;EkC3+RA;IACE,cAAA;IACA,UAAA;ElC6+RF;EkC/+RA;IACE,cAAA;IACA,mBAAA;ElCi/RF;EkCn/RA;IACE,cAAA;IACA,UAAA;ElCq/RF;EkCv/RA;IACE,cAAA;IACA,UAAA;ElCy/RF;EkC3/RA;IACE,cAAA;IACA,mBAAA;ElC6/RF;EkC99RI;IAhDJ,cAAA;IACA,WAAA;ElCihSA;EkC59RQ;IAhEN,cAAA;IACA,kBAAA;ElC+hSF;EkCh+RQ;IAhEN,cAAA;IACA,mBAAA;ElCmiSF;EkCp+RQ;IAhEN,cAAA;IACA,UAAA;ElCuiSF;EkCx+RQ;IAhEN,cAAA;IACA,mBAAA;ElC2iSF;EkC5+RQ;IAhEN,cAAA;IACA,mBAAA;ElC+iSF;EkCh/RQ;IAhEN,cAAA;IACA,UAAA;ElCmjSF;EkCp/RQ;IAhEN,cAAA;IACA,mBAAA;ElCujSF;EkCx/RQ;IAhEN,cAAA;IACA,mBAAA;ElC2jSF;EkC5/RQ;IAhEN,cAAA;IACA,UAAA;ElC+jSF;EkChgSQ;IAhEN,cAAA;IACA,mBAAA;ElCmkSF;EkCpgSQ;IAhEN,cAAA;IACA,mBAAA;ElCukSF;EkCxgSQ;IAhEN,cAAA;IACA,WAAA;ElC2kSF;EkCpgSU;IAxDV,cAAA;ElC+jSA;EkCvgSU;IAxDV,wBAAA;ElCkkSA;EkC1gSU;IAxDV,yBAAA;ElCqkSA;EkC7gSU;IAxDV,gBAAA;ElCwkSA;EkChhSU;IAxDV,yBAAA;ElC2kSA;EkCnhSU;IAxDV,yBAAA;ElC8kSA;EkCthSU;IAxDV,gBAAA;ElCilSA;EkCzhSU;IAxDV,yBAAA;ElColSA;EkC5hSU;IAxDV,yBAAA;ElCulSA;EkC/hSU;IAxDV,gBAAA;ElC0lSA;EkCliSU;IAxDV,yBAAA;ElC6lSA;EkCriSU;IAxDV,yBAAA;ElCgmSA;EkC7hSM;;IAEE,gBAAA;ElC+hSR;EkC5hSM;;IAEE,gBAAA;ElC8hSR;EkCriSM;;IAEE,sBAAA;ElCuiSR;EkCpiSM;;IAEE,sBAAA;ElCsiSR;EkC7iSM;;IAEE,qBAAA;ElC+iSR;EkC5iSM;;IAEE,qBAAA;ElC8iSR;EkCrjSM;;IAEE,mBAAA;ElCujSR;EkCpjSM;;IAEE,mBAAA;ElCsjSR;EkC7jSM;;IAEE,qBAAA;ElC+jSR;EkC5jSM;;IAEE,qBAAA;ElC8jSR;EkCrkSM;;IAEE,mBAAA;ElCukSR;EkCpkSM;;IAEE,mBAAA;ElCskSR;AACF;AUjoSI;EwBUE;IACE,SAAA;ElC0nSN;EkCvnSI;IApCJ,cAAA;IACA,WAAA;ElC8pSA;EkChpSA;IACE,cAAA;IACA,WAAA;ElCkpSF;EkCppSA;IACE,cAAA;IACA,UAAA;ElCspSF;EkCxpSA;IACE,cAAA;IACA,mBAAA;ElC0pSF;EkC5pSA;IACE,cAAA;IACA,UAAA;ElC8pSF;EkChqSA;IACE,cAAA;IACA,UAAA;ElCkqSF;EkCpqSA;IACE,cAAA;IACA,mBAAA;ElCsqSF;EkCvoSI;IAhDJ,cAAA;IACA,WAAA;ElC0rSA;EkCroSQ;IAhEN,cAAA;IACA,kBAAA;ElCwsSF;EkCzoSQ;IAhEN,cAAA;IACA,mBAAA;ElC4sSF;EkC7oSQ;IAhEN,cAAA;IACA,UAAA;ElCgtSF;EkCjpSQ;IAhEN,cAAA;IACA,mBAAA;ElCotSF;EkCrpSQ;IAhEN,cAAA;IACA,mBAAA;ElCwtSF;EkCzpSQ;IAhEN,cAAA;IACA,UAAA;ElC4tSF;EkC7pSQ;IAhEN,cAAA;IACA,mBAAA;ElCguSF;EkCjqSQ;IAhEN,cAAA;IACA,mBAAA;ElCouSF;EkCrqSQ;IAhEN,cAAA;IACA,UAAA;ElCwuSF;EkCzqSQ;IAhEN,cAAA;IACA,mBAAA;ElC4uSF;EkC7qSQ;IAhEN,cAAA;IACA,mBAAA;ElCgvSF;EkCjrSQ;IAhEN,cAAA;IACA,WAAA;ElCovSF;EkC7qSU;IAxDV,cAAA;ElCwuSA;EkChrSU;IAxDV,wBAAA;ElC2uSA;EkCnrSU;IAxDV,yBAAA;ElC8uSA;EkCtrSU;IAxDV,gBAAA;ElCivSA;EkCzrSU;IAxDV,yBAAA;ElCovSA;EkC5rSU;IAxDV,yBAAA;ElCuvSA;EkC/rSU;IAxDV,gBAAA;ElC0vSA;EkClsSU;IAxDV,yBAAA;ElC6vSA;EkCrsSU;IAxDV,yBAAA;ElCgwSA;EkCxsSU;IAxDV,gBAAA;ElCmwSA;EkC3sSU;IAxDV,yBAAA;ElCswSA;EkC9sSU;IAxDV,yBAAA;ElCywSA;EkCtsSM;;IAEE,gBAAA;ElCwsSR;EkCrsSM;;IAEE,gBAAA;ElCusSR;EkC9sSM;;IAEE,sBAAA;ElCgtSR;EkC7sSM;;IAEE,sBAAA;ElC+sSR;EkCttSM;;IAEE,qBAAA;ElCwtSR;EkCrtSM;;IAEE,qBAAA;ElCutSR;EkC9tSM;;IAEE,mBAAA;ElCguSR;EkC7tSM;;IAEE,mBAAA;ElC+tSR;EkCtuSM;;IAEE,qBAAA;ElCwuSR;EkCruSM;;IAEE,qBAAA;ElCuuSR;EkC9uSM;;IAEE,mBAAA;ElCgvSR;EkC7uSM;;IAEE,mBAAA;ElC+uSR;AACF;AmCr2SA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mB7BkYO;E6BjYP,mB7BusB4B;E6BtsB5B,0CAAA;AnCo2SF;AmC71SE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2C7B+sB0B;E6B9sB1B,2GAAA;AnC81SJ;AmC31SE;EACE,uBAAA;AnC61SJ;AmC11SE;EACE,sBAAA;AnC41SJ;;AmCx1SA;EACE,+DAAA;AnC21SF;;AmCp1SA;EACE,iBAAA;AnCu1SF;;AmC70SE;EACE,wBAAA;AnCg1SJ;;AmCj0SE;EACE,sCAAA;AnCo0SJ;AmCj0SI;EACE,sCAAA;AnCm0SN;;AmC5zSE;EACE,sBAAA;AnC+zSJ;AmC5zSE;EACE,mBAAA;AnC8zSJ;;AmCpzSE;EACE,oDAAA;EACA,8CAAA;AnCuzSJ;;AmCjzSE;EACE,oDAAA;EACA,8CAAA;AnCozSJ;;AmC5ySA;EACE,oDAAA;EACA,8CAAA;AnC+ySF;;AmCvySE;EACE,mDAAA;EACA,6CAAA;AnC0ySJ;;AoCt7SE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCk7SJ;;AoCp8SE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCg8SJ;;AoCl9SE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC88SJ;;AoCh+SE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC49SJ;;AoC9+SE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC0+SJ;;AoC5/SE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCw/SJ;;AoC1gTE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCsgTJ;;AoCxhTE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCohTJ;;AmCn4SI;EACE,gBAAA;EACA,iCAAA;AnCs4SN;;AUj+SI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnC44SJ;AACF;AUx+SI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCk5SJ;AACF;AU9+SI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCw5SJ;AACF;AUp/SI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnC85SJ;AACF;AU1/SI;EyByFA;IACE,gBAAA;IACA,iCAAA;EnCo6SJ;AACF;AqCxkTA;EACE,qB/Bu2BsC;ANmuRxC;;AqCjkTA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;Ed8QI,kBALI;EcrQR,gB/B+lB4B;ANm+R9B;;AqC9jTA;EACE,kDAAA;EACA,qDAAA;EdoQI,kBALI;AvBm0SV;;AqC9jTA;EACE,mDAAA;EACA,sDAAA;Ed8PI,mBALI;AvBy0SV;;AsC/lTA;EACE,mBhC+1BsC;EiBrkBlC,kBALI;EejRR,gChC+1BsC;ANiwRxC;;AuCrmTA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EhBwRI,eALI;EgBhRR,gBjCkmB4B;EiCjmB5B,gBjCymB4B;EiCxmB5B,2BjC43BsC;EiC33BtC,gBAAA;EACA,mCjCq3BsC;EiCp3BtC,4BAAA;EACA,2DAAA;EbGE,sCAAA;EnBHE,wEgCMJ;AvCmmTF;AOrmTM;EgChBN;IhCiBQ,gBAAA;EPwmTN;AACF;AuCtmTE;EACE,gBAAA;AvCwmTJ;AuCtmTI;EACE,eAAA;AvCwmTN;AuCnmTE;EACE,2BjCs2BoC;EiCr2BpC,mCjCg2BoC;EiC/1BpC,kCjC82BoC;EiC72BpC,UAAA;EAKE,kDjCkhBkB;AN+kSxB;AuC7lTE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvCilTJ;AuC5kTE;EACE,cAAA;EACA,UAAA;AvC8kTJ;AuC1kTE;EACE,gCjC40BoC;EiC10BpC,UAAA;AvC2kTJ;AuCnkTE;EAEE,wCjC8yBoC;EiC3yBpC,UAAA;AvCkkTJ;AuC9jTE;EACE,yBAAA;EACA,0BAAA;EACA,0BjCorB0B;EiCnrB1B,2BjCsyBoC;EkCp4BtC,uClCqiCgC;EiCr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CjCgsB0B;EiC/rB1B,gBAAA;EhCzFE,qIgC0FF;AvCgkTJ;AOtpTM;EgC0EJ;IhCzEM,gBAAA;EPypTN;AACF;AuClkTE;EACE,wCjC47B8B;ANwoRlC;;AuC3jTA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBjCwf4B;EiCvf5B,2BjC2xBsC;EiC1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AvC8jTF;AuC5jTE;EACE,UAAA;AvC8jTJ;AuC3jTE;EAEE,gBAAA;EACA,eAAA;AvC4jTJ;;AuCjjTA;EACE,mEjC4wBsC;EiC3wBtC,uBAAA;EhByII,mBALI;EGvQN,yCAAA;A1ByrTJ;AuCljTE;EACE,uBAAA;EACA,wBAAA;EACA,yBjCooB0B;ANg7R9B;;AuChjTA;EACE,iEjCgwBsC;EiC/vBtC,oBAAA;EhB4HI,kBALI;EGvQN,yCAAA;A1BqsTJ;AuCjjTE;EACE,oBAAA;EACA,qBAAA;EACA,uBjC2nB0B;ANw7R9B;;AuC3iTE;EACE,oEjC6uBoC;ANi0RxC;AuC3iTE;EACE,mEjC0uBoC;ANm0RxC;AuC1iTE;EACE,iEjCuuBoC;ANq0RxC;;AuCviTA;EACE,WjCquBsC;EiCpuBtC,gEjC8tBsC;EiC7tBtC,iBjCilB4B;ANy9R9B;AuCxiTE;EACE,eAAA;AvC0iTJ;AuCviTE;EACE,oBAAA;EbvLA,sCAAA;A1BiuTJ;AuCtiTE;EACE,oBAAA;Eb5LA,sCAAA;A1BquTJ;AuCriTE;EAAoB,+DjC8sBkB;AN01RxC;AuCviTE;EAAoB,6DjC8sBkB;AN41RxC;;AyCzvTA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ElBqRI,eALI;EkB7QR,gBnC+lB4B;EmC9lB5B,gBnCsmB4B;EmCrmB5B,2BnCy3BsC;EmCx3BtC,gBAAA;EACA,mCnCk3BsC;EmCj3BtC,mFAAA;EACA,4BAAA;EACA,yCnC+9BkC;EmC99BlC,0BnC+9BkC;EmC99BlC,2DAAA;EfHE,sCAAA;EnBHE,wEkCSJ;AzCyvTF;AO9vTM;EkCfN;IlCgBQ,gBAAA;EPiwTN;AACF;AyC5vTE;EACE,kCnCs3BoC;EmCr3BpC,UAAA;EAKE,kDnCi+B4B;ANyxRlC;AyCtvTE;EAEE,sBnC6uB0B;EmC5uB1B,sBAAA;AzCuvTJ;AyCpvTE;EAEE,wCnCu1BoC;AN85RxC;AyChvTE;EACE,kBAAA;EACA,uCAAA;AzCkvTJ;;AyC9uTA;EACE,oBnCsuB4B;EmCruB5B,uBnCquB4B;EmCpuB5B,oBnCquB4B;EiBlgBxB,mBALI;EGvQN,yCAAA;A1B4xTJ;;AyC9uTA;EACE,mBnCkuB4B;EmCjuB5B,sBnCiuB4B;EmChuB5B,kBnCiuB4B;EiBtgBxB,kBALI;EGvQN,yCAAA;A1BoyTJ;;AyC5uTI;EACE,gEAAA;AzC+uTN;;A0CvzTA;EACE,cAAA;EACA,kBpCq6BwC;EoCp6BxC,mBpCq6BwC;EoCp6BxC,uBpCq6BwC;ANq5R1C;A0CxzTE;EACE,WAAA;EACA,mBAAA;A1C0zTJ;;A0CtzTA;EACE,oBpC25BwC;EoC15BxC,eAAA;EACA,iBAAA;A1CyzTF;A0CvzTE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A1CyzTJ;;A0CrzTA;EACE,qCAAA;EAEA,cAAA;EACA,UpC04BwC;EoCz4BxC,WpCy4BwC;EoCx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DpC24BwC;EoC14BxC,iCAAA;UAAA,yBAAA;A1CuzTF;A0CpzTE;EhB3BE,qBAAA;A1Bk1TJ;A0CnzTE;EAEE,kBpCm4BsC;ANi7R1C;A0CjzTE;EACE,uBpC03BsC;ANy7R1C;A0ChzTE;EACE,kCpCs1BoC;EoCr1BpC,UAAA;EACA,kDpC8foB;ANozSxB;A0C/yTE;EACE,yBpC5BM;EoC6BN,qBpC7BM;AN80TV;A0C/yTI;EAII,iEAAA;A1C8yTR;A0C1yTI;EAII,iEAAA;A1CyyTR;A0CpyTE;EACE,yBpCjDM;EoCkDN,qBpClDM;EoCuDJ,iEAAA;A1CkyTN;A0C9xTE;EACE,oBAAA;EACA,YAAA;EACA,YpCk2BuC;AN87R3C;A0CzxTI;EACE,eAAA;EACA,YpCy1BqC;ANk8R3C;;A0C7wTA;EACE,mBpCo1BgC;AN47RlC;A0C9wTE;EACE,4DAAA;EAEA,UpC80B8B;EoC70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;EhBjHA,kBAAA;EnBHE,iDmCsHF;A1C+wTJ;AOj4TM;EmC0GJ;InCzGM,gBAAA;EPo4TN;AACF;A0ClxTI;EACE,6DAAA;A1CoxTN;A0CjxTI;EACE,iCpC60B4B;EoCx0B1B,6DAAA;A1C+wTR;A0C1wTE;EACE,oBpCwzB8B;EoCvzB9B,eAAA;A1C4wTJ;A0C1wTI;EACE,oBAAA;EACA,cAAA;A1C4wTN;;A0CvwTA;EACE,qBAAA;EACA,kBpCsyBgC;ANo+RlC;;A0CvwTA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1C0wTF;A0CtwTI;EACE,oBAAA;EACA,YAAA;EACA,apCspBwB;ANknS9B;;A0CjwTI;EACE,6DAAA;A1CowTN;;A2Cv7TA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3C07TF;A2Cx7TE;EACE,UAAA;A3C07TJ;A2Ct7TI;EAA0B,kErC8gCa;AN26R3C;A2Cx7TI;EAA0B,kErC6gCa;AN86R3C;A2Cx7TE;EACE,SAAA;A3C07TJ;A2Cv7TE;EACE,WrC+/BuC;EqC9/BvC,YrC8/BuC;EqC7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBlCkCQ;EqCNN,SrC6/BuC;EoB1gCvC,mBAAA;EnBHE,oHoCmBF;EpCnBE,4GoCmBF;A3Cw7TJ;AOv8TM;EoCMJ;IpCLM,wBAAA;IAAA,gBAAA;EP08TN;AACF;A2C37TI;EHjCF,0ClC8hCyC;ANi8R3C;A2Cz7TE;EACE,WrCw+B8B;EqCv+B9B,crCw+B8B;EqCv+B9B,kBAAA;EACA,erCu+B8B;EqCt+B9B,wCrCu+B8B;EqCt+B9B,yBAAA;EjB7BA,mBAAA;A1By9TJ;A2Cv7TE;EACE,WrCo+BuC;EqCn+BvC,YrCm+BuC;EqCl+BvC,gBAAA;EHpDF,yBlCkCQ;EqCoBN,SrCm+BuC;EoB1gCvC,mBAAA;EnBHE,iHoC6CF;EpC7CE,4GoC6CF;A3Cw7TJ;AOj+TM;EoCiCJ;IpChCM,qBAAA;IAAA,gBAAA;EPo+TN;AACF;A2C37TI;EH3DF,0ClC8hCyC;AN29R3C;A2Cz7TE;EACE,WrC88B8B;EqC78B9B,crC88B8B;EqC78B9B,kBAAA;EACA,erC68B8B;EqC58B9B,wCrC68B8B;EqC58B9B,yBAAA;EjBvDA,mBAAA;A1Bm/TJ;A2Cv7TE;EACE,oBAAA;A3Cy7TJ;A2Cv7TI;EACE,2CrCg9BqC;ANy+R3C;A2Ct7TI;EACE,2CrC48BqC;AN4+R3C;;A4C/gUA;EACE,kBAAA;A5CkhUF;A4ChhUE;;;EAGE,uDtCwiCoC;EsCviCpC,2DtCuiCoC;EsCtiCpC,iBtCuiCoC;AN2+RxC;A4C/gUE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ErCRE,gEqCSF;A5CihUJ;AOthUM;EqCTJ;IrCUM,gBAAA;EPyhUN;AACF;A4CnhUE;;EAEE,qBAAA;A5CqhUJ;A4CnhUI;;EACE,kBAAA;A5CshUN;A4CnhUI;;;EAEE,qBtC4gCkC;EsC3gClC,wBtC4gCkC;AN0gSxC;A4CnhUI;;EACE,qBtCugCkC;EsCtgClC,wBtCugCkC;AN+gSxC;A4ClhUE;EACE,qBtCigCoC;EsChgCpC,wBtCigCoC;ANmhSxC;A4C7gUI;;;;EACE,2CAAA;EACA,8DtC2/BkC;ANuhSxC;A4ChhUM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,atCm/BgC;EsCl/BhC,WAAA;EACA,mCtCg0BgC;EoBh3BpC,sCAAA;A1BskUJ;A4C/gUI;EACE,2CAAA;EACA,8DtC0+BkC;ANuiSxC;A4C5gUI;EACE,sCAAA;A5C8gUN;A4C1gUE;;EAEE,ctC1EO;ANslUX;A4C1gUI;;EACE,wCtC0yBkC;ANmuSxC;;A6CpmUA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7CumUF;A6CrmUE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7CumUJ;A6CnmUE;;;EAGE,UAAA;A7CqmUJ;A6C/lUE;EACE,kBAAA;EACA,UAAA;A7CimUJ;A6C/lUI;EACE,UAAA;A7CimUN;;A6CtlUA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EtB8OI,eALI;EsBvOR,gBvCyjB4B;EuCxjB5B,gBvCgkB4B;EuC/jB5B,2BvCm1BsC;EuCl1BtC,kBAAA;EACA,mBAAA;EACA,uCvC06BsC;EuCz6BtC,2DAAA;EnBtCE,sCAAA;A1BgoUJ;;A6ChlUA;;;;EAIE,oBAAA;EtBwNI,kBALI;EGvQN,yCAAA;A1ByoUJ;;A6ChlUA;;;;EAIE,uBAAA;EtB+MI,mBALI;EGvQN,yCAAA;A1BkpUJ;;A6ChlUA;;EAEE,mBAAA;A7CmlUF;;A6CtkUI;;;;EnBjEA,0BAAA;EACA,6BAAA;A1B8oUJ;A6CrkUI;;;;EnB1EA,0BAAA;EACA,6BAAA;A1BqpUJ;A6C/jUE;EACE,8CAAA;EnB1EA,yBAAA;EACA,4BAAA;A1B4oUJ;A6C/jUE;;EnB9EE,yBAAA;EACA,4BAAA;A1BipUJ;;A8CzqUE;EACE,aAAA;EACA,WAAA;EACA,mBxCu0BoC;EiBrkBlC,kBALI;EuB1PN,iCxCkjCqB;ANynSzB;;A8CxqUE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvBqPE,mBALI;EuB7ON,WxCqiCqB;EwCpiCrB,mCxCoiCqB;EoB/jCrB,sCAAA;A1BssUJ;;A8CtqUI;;;;EAEE,cAAA;A9C2qUN;;A8C1tUI;EAqDE,+CxCuhCmB;EwCphCjB,oCxC81BgC;EwC71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9CuqUR;A8CpqUM;EACE,+CxC4gCiB;EwCvgCf,2DxCugCe;AN2pSzB;;A8CvuUI;EA+EI,oCxCu0BgC;EwCt0BhC,kFAAA;A9C4pUR;;A8C5uUI;EAuFE,+CxCq/BmB;ANoqSzB;A8CtpUQ;EAEE,kEAAA;EACA,uBxCq5B8B;EwCp5B9B,+DAAA;EACA,2EAAA;A9CupUV;A8CnpUM;EACE,+CxCw+BiB;EwCn+Bf,2DxCm+Be;AN8qSzB;;A8C1vUI;EAkHI,yCAAA;A9C4oUR;;A8C9vUI;EAyHE,+CxCm9BmB;ANsrSzB;A8CvoUM;EACE,4CxCg9BiB;ANyrSzB;A8CtoUM;EACE,2DxC48BiB;AN4rSzB;A8CroUM;EACE,iCxCw8BiB;AN+rSzB;;A8CloUI;EACE,kBAAA;A9CqoUN;;A8C/wUI;;;;;EAoJM,UAAA;A9CmoUV;;A8CnwUE;EACE,aAAA;EACA,WAAA;EACA,mBxCu0BoC;EiBrkBlC,kBALI;EuB1PN,mCxCkjCqB;ANmtSzB;;A8ClwUE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvBqPE,mBALI;EuB7ON,WxCqiCqB;EwCpiCrB,kCxCoiCqB;EoB/jCrB,sCAAA;A1BgyUJ;;A8ChwUI;;;;EAEE,cAAA;A9CqwUN;;A8CpzUI;EAqDE,iDxCuhCmB;EwCphCjB,oCxC81BgC;EwC71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9CiwUR;A8C9vUM;EACE,iDxC4gCiB;EwCvgCf,0DxCugCe;ANqvSzB;;A8Cj0UI;EA+EI,oCxCu0BgC;EwCt0BhC,kFAAA;A9CsvUR;;A8Ct0UI;EAuFE,iDxCq/BmB;AN8vSzB;A8ChvUQ;EAEE,kEAAA;EACA,uBxCq5B8B;EwCp5B9B,+DAAA;EACA,2EAAA;A9CivUV;A8C7uUM;EACE,iDxCw+BiB;EwCn+Bf,0DxCm+Be;ANwwSzB;;A8Cp1UI;EAkHI,yCAAA;A9CsuUR;;A8Cx1UI;EAyHE,iDxCm9BmB;ANgxSzB;A8CjuUM;EACE,8CxCg9BiB;ANmxSzB;A8ChuUM;EACE,0DxC48BiB;ANsxSzB;A8C/tUM;EACE,mCxCw8BiB;ANyxSzB;;A8C5tUI;EACE,kBAAA;A9C+tUN;;A8Cz2UI;;;;;EAsJM,UAAA;A9C2tUV;;A+Cn3UA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;ExBuRI,wBALI;EwBhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,6EAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;ExBsQI,kCALI;EwB/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ErBjBE,0CAAA;EcfF,kCOkCqB;ExCtBjB,qIwCwBJ;A/Ci3UF;AOr4UM;EwChBN;IxCiBQ,gBAAA;EPw4UN;AACF;A+Cp3UE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/Cq3UJ;A+Cl3UE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/Cm3UJ;A+Ch3UE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/C82UN;A+C12UE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/Cw2UN;A+Cp2UE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/Cg2UJ;A+C71UI;EAKI,0CAAA;A/C21UR;A+Ct1UE;EAKI,0CAAA;A/Co1UN;A+Ch1UE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/C+0UJ;;A+Cn0UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDs7UF;;A+Cp1UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDu8UF;;A+Cr2UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDw9UF;;A+Ct3UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDy+UF;;A+Cv4UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD0/UF;;A+Cx5UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD2gVF;;A+Cz6UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD4hVF;;A+C17UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD6iVF;;A+C38UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD8jVF;;A+C59UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhD+kVF;;A+C7+UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDgmVF;;A+C9/UE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDinVF;;A+C/gVE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhDkoVF;;A+CtgVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD0nVF;;A+CvhVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD2oVF;;A+CxiVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD4pVF;;A+CzjVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD6qVF;;A+C1kVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD8rVF;;A+C3lVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhD+sVF;;A+C5mVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDguVF;;A+C7nVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDivVF;;A+C9oVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDkwVF;;A+C/pVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDmxVF;;A+ChrVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDoyVF;;A+CjsVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDqzVF;;A+CltVE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhDs0VF;;A+CvtVA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BzC8QwC;AN28U1C;A+C/sVE;EACE,0BAAA;A/CitVJ;A+C9sVE;EACE,gCAAA;A/CgtVJ;;A+CrsVA;ECjJE,0BAAA;EACA,wBAAA;EzB8NI,2BALI;EyBvNR,kDAAA;AhD01VF;;A+CxsVA;ECrJE,2BAAA;EACA,0BAAA;EzB8NI,4BALI;EyBvNR,kDAAA;AhDi2VF;;AiDp6VA;E1CgBM,gC0CfJ;AjDu6VF;AOp5VM;E0CpBN;I1CqBQ,gBAAA;EPu5VN;AACF;AiD16VE;EACE,UAAA;AjD46VJ;;AiDt6VE;EACE,aAAA;AjDy6VJ;;AiDr6VA;EACE,SAAA;EACA,gBAAA;E1CDI,6B0CEJ;AjDw6VF;AOt6VM;E0CLN;I1CMQ,gBAAA;EPy6VN;AACF;AiD36VE;EACE,QAAA;EACA,YAAA;E1CNE,4B0COF;AjD66VJ;AOh7VM;E0CAJ;I1CCM,gBAAA;EPm7VN;AACF;;AkDx8VA;;;;;;EAME,kBAAA;AlD28VF;;AkDx8VA;EACE,mBAAA;AlD28VF;AmDn7VI;EACE,qBAAA;EACA,oB7C6hBwB;E6C5hBxB,uB7C2hBwB;E6C1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnD29VF;AmDj6VI;EACE,cAAA;AnDm6VN;;AkDj9VA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E3BuQI,6BALI;E2BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E3B0OI,uCALI;E2BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;ExBzCE,+CAAA;A1B2/VJ;AkD98VE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlDg9VJ;;AkDx7VI;EACE,oBAAA;AlD27VN;AkDz7VM;EACE,WAAA;EACA,OAAA;AlD27VR;;AkDv7VI;EACE,kBAAA;AlD07VN;AkDx7VM;EACE,QAAA;EACA,UAAA;AlD07VR;;AUp+VI;EwC4BA;IACE,oBAAA;ElD48VJ;EkD18VI;IACE,WAAA;IACA,OAAA;ElD48VN;EkDx8VE;IACE,kBAAA;ElD08VJ;EkDx8VI;IACE,QAAA;IACA,UAAA;ElD08VN;AACF;AUr/VI;EwC4BA;IACE,oBAAA;ElD49VJ;EkD19VI;IACE,WAAA;IACA,OAAA;ElD49VN;EkDx9VE;IACE,kBAAA;ElD09VJ;EkDx9VI;IACE,QAAA;IACA,UAAA;ElD09VN;AACF;AUrgWI;EwC4BA;IACE,oBAAA;ElD4+VJ;EkD1+VI;IACE,WAAA;IACA,OAAA;ElD4+VN;EkDx+VE;IACE,kBAAA;ElD0+VJ;EkDx+VI;IACE,QAAA;IACA,UAAA;ElD0+VN;AACF;AUrhWI;EwC4BA;IACE,oBAAA;ElD4/VJ;EkD1/VI;IACE,WAAA;IACA,OAAA;ElD4/VN;EkDx/VE;IACE,kBAAA;ElD0/VJ;EkDx/VI;IACE,QAAA;IACA,UAAA;ElD0/VN;AACF;AUriWI;EwC4BA;IACE,oBAAA;ElD4gWJ;EkD1gWI;IACE,WAAA;IACA,OAAA;ElD4gWN;EkDxgWE;IACE,kBAAA;ElD0gWJ;EkDxgWI;IACE,QAAA;IACA,UAAA;ElD0gWN;AACF;AkDjgWE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlDmgWJ;AmDvlWI;EACE,qBAAA;EACA,oB7C6hBwB;E6C5hBxB,uB7C2hBwB;E6C1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnDwnWF;AmDrkWI;EACE,cAAA;AnDukWN;;AkDvgWE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlD0gWJ;AmD5mWI;EACE,qBAAA;EACA,oB7C6hBwB;E6C5hBxB,uB7C2hBwB;E6C1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnDsoWF;AmD1lWI;EACE,cAAA;AnD4lWN;AkDlhWI;EACE,iBAAA;AlDohWN;;AkD9gWE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlDihWJ;AmDpoWI;EACE,qBAAA;EACA,oB7C6hBwB;E6C5hBxB,uB7C2hBwB;E6C1hBxB,WAAA;AnDsoWN;AmD3nWM;EACE,aAAA;AnD6nWR;AmD1nWM;EACE,qBAAA;EACA,qB7C0gBsB;E6CzgBtB,uB7CwgBsB;E6CvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnDgqWF;AmD1nWI;EACE,cAAA;AnD4nWN;AkDjiWI;EACE,iBAAA;AlDmiWN;;AkD5hWA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlD+hWF;;AkDzhWA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5Cyb4B;E4Cxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;ExBtKE,uDAAA;A1BmsWJ;AkD1hWE;EAEE,0CAAA;EV1LF,kDU4LuB;AlD0hWzB;AkDvhWE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlDwhWzB;AkDrhWE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlDshWJ;;AkDhhWA;EACE,cAAA;AlDmhWF;;AkD/gWA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E3BmEI,mBALI;E2B5DR,sCAAA;EACA,mBAAA;AlDkhWF;;AkD9gWA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlDihWF;;AkD7gWA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlD+gWF;;AoDrwWA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApDwwWF;AoDtwWE;;EACE,kBAAA;EACA,cAAA;ApDywWJ;AoDpwWE;;;;;;;;;;;;EAME,UAAA;ApD4wWJ;;AoDvwWA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApD0wWF;AoDxwWE;EACE,WAAA;ApD0wWJ;;AoDtwWA;E1BhBI,sCAAA;A1B0xWJ;AoDtwWE;;EAEE,8CAAA;ApDwwWJ;AoDpwWE;;;E1BVE,0BAAA;EACA,6BAAA;A1BmxWJ;AoDhwWE;;;E1BNE,yBAAA;EACA,4BAAA;A1B2wWJ;;AoDnvWA;EACE,wBAAA;EACA,uBAAA;ApDsvWF;AoDpvWE;EAGE,cAAA;ApDovWJ;AoDjvWE;EACE,eAAA;ApDmvWJ;;AoD/uWA;EACE,uBAAA;EACA,sBAAA;ApDkvWF;;AoD/uWA;EACE,sBAAA;EACA,qBAAA;ApDkvWF;;AoD9tWA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApDiuWF;AoD/tWE;;EAEE,WAAA;ApDiuWJ;AoD9tWE;;EAEE,6CAAA;ApDguWJ;AoD5tWE;;E1B1FE,6BAAA;EACA,4BAAA;A1B0zWJ;AoD5tWE;;E1B7GE,yBAAA;EACA,0BAAA;A1B60WJ;;AqDr2WA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArDo2WF;;AqDj2WA;EACE,cAAA;EACA,kEAAA;E9BsQI,uCALI;E8B/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;E9CfI,uG8CgBJ;ArDo2WF;AOh3WM;E8CGN;I9CFQ,gBAAA;EPm3WN;AACF;AqDv2WE;EAEE,qCAAA;ArDw2WJ;AqDp2WE;EACE,UAAA;EACA,kD/CkhBoB;ANo1VxB;AqDl2WE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArDm2WJ;;AqD31WA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ArD21WF;AqDz1WE;EACE,yDAAA;EACA,yDAAA;E3B7CA,wDAAA;EACA,yDAAA;A1By4WJ;AqD11WI;EAGE,kBAAA;EACA,wDAAA;ArD01WN;AqDt1WE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArDw1WJ;AqDr1WE;EAEE,sDAAA;E3BjEA,yBAAA;EACA,0BAAA;A1Bw5WJ;;AqD70WA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ArD+0WF;AqD50WE;E3B5FE,gDAAA;A1B26WJ;AqD30WE;;EAEE,4CAAA;EbjHF,oDakHuB;ArD60WzB;;AqDp0WA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArDo0WF;AqDl0WE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArDo0WJ;AqDl0WI;EAEE,iCAAA;ArDm0WN;AqD/zWE;;EAEE,gB/C0d0B;E+Czd1B,gDAAA;EACA,iCAAA;ArDi0WJ;;AqDvzWE;;EAEE,cAAA;EACA,kBAAA;ArD0zWJ;;AqDrzWE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArDwzWJ;;AqDlzWE;;EACE,WAAA;ArDszWJ;;AqD5yWE;EACE,aAAA;ArD+yWJ;AqD7yWE;EACE,cAAA;ArD+yWJ;;AsD5+WA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtD4+WF;AsDt+WE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtD8+WJ;AsD19WA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;E/B4NI,2CALI;E+BrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AtD49WF;AsD19WE;EAEE,yCAAA;AtD29WJ;;AsDj9WA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtDg9WF;AsD78WI;EAEE,oCAAA;AtD88WN;AsD18WE;EACE,gBAAA;AtD48WJ;;AsDn8WA;EACE,mBhD8gCkC;EgD7gClC,sBhD6gCkC;EgD5gClC,6BAAA;AtDs8WF;AsDp8WE;;;EAGE,oCAAA;AtDs8WJ;;AsDz7WA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtD07WF;;AsDt7WA;EACE,8EAAA;E/ByII,6CALI;E+BlIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E5BxIE,qDAAA;EnBHE,+C+C6IJ;AtDy7WF;AOlkXM;E+CiIN;I/ChIQ,gBAAA;EPqkXN;AACF;AsD57WE;EACE,qBAAA;AtD87WJ;AsD37WE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtD67WJ;;AsDv7WA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtD07WF;;AsDv7WA;EACE,yCAAA;EACA,gBAAA;AtD07WF;;AUpjXI;E4CsIA;IAEI,iBAAA;IACA,2BAAA;EtDi7WN;EsD/6WM;IACE,mBAAA;EtDi7WR;EsD/6WQ;IACE,kBAAA;EtDi7WV;EsD96WQ;IACE,kDAAA;IACA,iDAAA;EtDg7WV;EsD56WM;IACE,iBAAA;EtD86WR;EsD36WM;IACE,wBAAA;IACA,gBAAA;EtD66WR;EsD16WM;IACE,aAAA;EtD46WR;EsDz6WM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I/C9NJ,gB+CgOI;EtDy6WR;EsDt6WQ;IACE,aAAA;EtDw6WV;EsDr6WQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtDu6WV;AACF;AUpmXI;E4CsIA;IAEI,iBAAA;IACA,2BAAA;EtDg+WN;EsD99WM;IACE,mBAAA;EtDg+WR;EsD99WQ;IACE,kBAAA;EtDg+WV;EsD79WQ;IACE,kDAAA;IACA,iDAAA;EtD+9WV;EsD39WM;IACE,iBAAA;EtD69WR;EsD19WM;IACE,wBAAA;IACA,gBAAA;EtD49WR;EsDz9WM;IACE,aAAA;EtD29WR;EsDx9WM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I/C9NJ,gB+CgOI;EtDw9WR;EsDr9WQ;IACE,aAAA;EtDu9WV;EsDp9WQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtDs9WV;AACF;AUnpXI;E4CsIA;IAEI,iBAAA;IACA,2BAAA;EtD+gXN;EsD7gXM;IACE,mBAAA;EtD+gXR;EsD7gXQ;IACE,kBAAA;EtD+gXV;EsD5gXQ;IACE,kDAAA;IACA,iDAAA;EtD8gXV;EsD1gXM;IACE,iBAAA;EtD4gXR;EsDzgXM;IACE,wBAAA;IACA,gBAAA;EtD2gXR;EsDxgXM;IACE,aAAA;EtD0gXR;EsDvgXM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I/C9NJ,gB+CgOI;EtDugXR;EsDpgXQ;IACE,aAAA;EtDsgXV;EsDngXQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtDqgXV;AACF;AUlsXI;E4CsIA;IAEI,iBAAA;IACA,2BAAA;EtD8jXN;EsD5jXM;IACE,mBAAA;EtD8jXR;EsD5jXQ;IACE,kBAAA;EtD8jXV;EsD3jXQ;IACE,kDAAA;IACA,iDAAA;EtD6jXV;EsDzjXM;IACE,iBAAA;EtD2jXR;EsDxjXM;IACE,wBAAA;IACA,gBAAA;EtD0jXR;EsDvjXM;IACE,aAAA;EtDyjXR;EsDtjXM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I/C9NJ,gB+CgOI;EtDsjXR;EsDnjXQ;IACE,aAAA;EtDqjXV;EsDljXQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtDojXV;AACF;AUjvXI;E4CsIA;IAEI,iBAAA;IACA,2BAAA;EtD6mXN;EsD3mXM;IACE,mBAAA;EtD6mXR;EsD3mXQ;IACE,kBAAA;EtD6mXV;EsD1mXQ;IACE,kDAAA;IACA,iDAAA;EtD4mXV;EsDxmXM;IACE,iBAAA;EtD0mXR;EsDvmXM;IACE,wBAAA;IACA,gBAAA;EtDymXR;EsDtmXM;IACE,aAAA;EtDwmXR;EsDrmXM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I/C9NJ,gB+CgOI;EtDqmXR;EsDlmXQ;IACE,aAAA;EtDomXV;EsDjmXQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtDmmXV;AACF;AsD1pXI;EAEI,iBAAA;EACA,2BAAA;AtD2pXR;AsDzpXQ;EACE,mBAAA;AtD2pXV;AsDzpXU;EACE,kBAAA;AtD2pXZ;AsDxpXU;EACE,kDAAA;EACA,iDAAA;AtD0pXZ;AsDtpXQ;EACE,iBAAA;AtDwpXV;AsDrpXQ;EACE,wBAAA;EACA,gBAAA;AtDupXV;AsDppXQ;EACE,aAAA;AtDspXV;AsDnpXQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;E/C9NJ,gB+CgOI;AtDmpXV;AsDhpXU;EACE,aAAA;AtDkpXZ;AsD/oXU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtDipXZ;;AsDhoXA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AtDkoXF;;AsD5nXI;EACE,qEAAA;AtD+nXN;;AuDx5XA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,uDAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E7BjBE,2CAAA;A1B06XJ;AuDr5XE;EACE,eAAA;EACA,cAAA;AvDu5XJ;AuDp5XE;EACE,mBAAA;EACA,sBAAA;AvDs5XJ;AuDp5XI;EACE,mBAAA;E7BtBF,0DAAA;EACA,2DAAA;A1B66XJ;AuDp5XI;EACE,sBAAA;E7BbF,8DAAA;EACA,6DAAA;A1Bo6XJ;AuDj5XE;;EAEE,aAAA;AvDm5XJ;;AuD/4XA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvDg5XF;;AuD74XA;EACE,4CAAA;EACA,iCAAA;AvDg5XF;;AuD74XA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvDg5XF;;AuD74XA;EACE,gBAAA;AvDg5XF;;AuDx4XE;EACE,oCAAA;AvD24XJ;;AuDn4XA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvDs4XF;AuDp4XE;E7B7FE,wFAAA;A1Bo+XJ;;AuDl4XA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvDq4XF;AuDn4XE;E7BxGE,wFAAA;A1B8+XJ;;AuD53XA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvD+3XF;AuD73XE;EACE,mCAAA;EACA,sCAAA;AvD+3XJ;;AuD33XA;EACE,uDAAA;EACA,sDAAA;AvD83XF;;AuD13XA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E7B1IE,iDAAA;A1BwgYJ;;AuD13XA;;;EAGE,WAAA;AvD63XF;;AuD13XA;;E7B3II,0DAAA;EACA,2DAAA;A1B0gYJ;;AuD33XA;;E7BlII,8DAAA;EACA,6DAAA;A1BkgYJ;;AuDp3XE;EACE,0CAAA;AvDu3XJ;AUl/XI;E6CuHJ;IAQI,aAAA;IACA,mBAAA;EvDu3XF;EuDp3XE;IAEE,SAAA;IACA,gBAAA;EvDq3XJ;EuDn3XI;IACE,cAAA;IACA,cAAA;EvDq3XN;EuDh3XM;I7B3KJ,0BAAA;IACA,6BAAA;E1B8hYF;EuDj3XQ;;IAGE,0BAAA;EvDk3XV;EuDh3XQ;;IAGE,6BAAA;EvDi3XV;EuD72XM;I7B5KJ,yBAAA;IACA,4BAAA;E1B4hYF;EuD92XQ;;IAGE,yBAAA;EvD+2XV;EuD72XQ;;IAGE,4BAAA;EvD82XV;AACF;;AwDnlYA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AxDqlYF;;AwDjlYA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EjC4PI,eALI;EiCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;E9BrBE,gBAAA;E8BuBF,qBAAA;EjD1BI,0CiD2BJ;AxDolYF;AO3mYM;EiDUN;IjDTQ,gBAAA;EP8mYN;AACF;AwDvlYE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxDylYJ;AwDvlYI;EACE,qDAAA;EACA,iDAAA;AxDylYN;AwDplYE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjDjDE,mDiDkDF;AxDslYJ;AOpoYM;EiDqCJ;IjDpCM,gBAAA;EPuoYN;AACF;AwDxlYE;EACE,UAAA;AxD0lYJ;AwDvlYE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AxDylYJ;;AwDrlYA;EACE,gBAAA;AxDwlYF;;AwDrlYA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxDwlYF;AwDtlYE;E9B7DE,yDAAA;EACA,0DAAA;A1BspYJ;AwDvlYI;E9BhEA,+DAAA;EACA,gEAAA;A1B0pYJ;AwDtlYE;EACE,aAAA;AxDwlYJ;AwDplYE;E9B5DE,6DAAA;EACA,4DAAA;A1BmpYJ;AwDplYM;E9BhEF,mEAAA;EACA,kEAAA;A1BupYJ;AwDnlYI;E9BrEA,6DAAA;EACA,4DAAA;A1B2pYJ;;AwDjlYA;EACE,8EAAA;AxDolYF;;AwD3kYE;EACE,eAAA;EACA,cAAA;E9B9GA,gBAAA;A1B6rYJ;AwD5kYI;EAAgB,aAAA;AxD+kYpB;AwD9kYI;EAAe,gBAAA;AxDilYnB;AwD7kYM;E9BtHF,gBAAA;A1BssYJ;AwDzkYI;E9B7HA,gBAAA;A1BysYJ;;AwDpkYI;EACE,iEAAA;EACA,wEAAA;AxDukYN;;AyDjuYA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ElC+QI,yCALI;EkCxQR,gBAAA;EACA,yCAAA;E/BAE,iDAAA;A1BiuYJ;;AyD3tYE;EACE,iDAAA;AzD8tYJ;AyD5tYI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AzD8tYN;AyD1tYE;EACE,6CAAA;AzD4tYJ;;A0DjwYA;EAEE,kCAAA;EACA,mCAAA;EnC4RI,+BALI;EmCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;E9BpBA,eAAA;EACA,gBAAA;A5BsxYF;;A0D/vYA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EnCgQI,yCALI;EmCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnDpBI,qImDqBJ;A1DkwYF;AOnxYM;EmDQN;InDPQ,gBAAA;EPsxYN;AACF;A0DrwYE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1DswYJ;A0DnwYE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UpD2uCgC;EoD1uChC,iDAAA;A1DqwYJ;A0DlwYE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1DmwYJ;A0DhwYE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1DiwYJ;;A0D5vYE;EACE,8CpD8sCgC;ANijWpC;A0D1vYM;EhC9BF,0DAAA;EACA,6DAAA;A1B2xYJ;A0DxvYM;EhClDF,2DAAA;EACA,8DAAA;A1B6yYJ;;A0D3uYA;EClGE,iCAAA;EACA,kCAAA;EpC0RI,kCALI;EoCnRR,yDAAA;A3Di1YF;;A0D9uYA;ECtGE,iCAAA;EACA,kCAAA;EpC0RI,mCALI;EoCnRR,yDAAA;A3Dw1YF;;A4D11YA;EAEE,4BAAA;EACA,4BAAA;ErCuRI,4BALI;EqChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ErC+QI,oCALI;EqCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ElCJE,4CAAA;A1B+1YJ;A4Dt1YE;EACE,aAAA;A5Dw1YJ;;A4Dn1YA;EACE,kBAAA;EACA,SAAA;A5Ds1YF;;A6Dt3YA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EnCHE,4CAAA;A1B03YJ;;A6Dl3YA;EAEE,cAAA;A7Do3YF;;A6Dh3YA;EACE,gBvD6kB4B;EuD5kB5B,iCAAA;A7Dm3YF;;A6D32YA;EACE,mBvDs+C8B;ANw4VhC;A6D32YE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A7D62YJ;;A6Dr2YE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Dw2YJ;;A6D52YE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7D+2YJ;;A6Dn3YE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Ds3YJ;;A6D13YE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7D63YJ;;A6Dj4YE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Do4YJ;;A6Dx4YE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7D24YJ;;A6D/4YE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7Dk5YJ;;A6Dt5YE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7Dy5YJ;;A6D75YE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;A7Dg6YJ;;A6Dp6YE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;A7Du6YJ;;A6D36YE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A7D86YJ;;A6Dl7YE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;A7Dq7YJ;;A6Dz7YE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,2DAAA;A7D47YJ;;A8Dx/YE;EACE;IAAK,2BxDyhD2B;ENm+VlC;AACF;A8Dx/YA;;EAGE,0BAAA;EvCkRI,gCALI;EuC3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EvCsQI,uCALI;EuC/PR,uCAAA;EpCRE,+CAAA;A1BggZJ;;A8Dn/YA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvDxBI,6CuDyBJ;A9Ds/YF;AO3gZM;EuDYN;IvDXQ,gBAAA;EP8gZN;AACF;;A8Dx/YA;EtBAE,qMAAA;EsBEA,oEAAA;A9D2/YF;;A8Dx/YA;EACE,iBAAA;A9D2/YF;;A8Dx/YA;EACE,WAAA;A9D2/YF;;A8Dv/YE;EACE,kDAAA;A9D0/YJ;A8Dv/YM;EAJJ;IAKM,eAAA;E9D0/YN;AACF;;A+DtjZA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ErCXE,iDAAA;A1BgkZJ;;A+DjjZA;EACE,qBAAA;EACA,sBAAA;A/DojZF;A+DljZE;EAEE,oCAAA;EACA,0BAAA;A/DmjZJ;;A+D1iZA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/D6iZF;A+D1iZE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/D2iZJ;A+DxiZE;EACE,+CAAA;EACA,uDAAA;A/D0iZJ;;A+DliZA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A/DqiZF;A+DniZE;ErCvDE,+BAAA;EACA,gCAAA;A1B6lZJ;A+DniZE;ErC7CE,mCAAA;EACA,kCAAA;A1BmlZJ;A+DniZE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/DoiZJ;A+DhiZE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/DkiZJ;A+D9hZE;EACE,mBAAA;A/DgiZJ;A+D9hZI;EACE,wDAAA;EACA,mDAAA;A/DgiZN;;A+DnhZI;EACE,mBAAA;A/DshZN;A+DnhZQ;ErCvDJ,6DAAA;EAZA,0BAAA;A1B0lZJ;A+DlhZQ;ErCxEJ,2DAAA;EAYA,4BAAA;A1BklZJ;A+DjhZQ;EACE,aAAA;A/DmhZV;A+DhhZQ;EACE,mDAAA;EACA,oBAAA;A/DkhZV;A+DhhZU;EACE,yDAAA;EACA,oDAAA;A/DkhZZ;;AUxmZI;EqD8DA;IACE,mBAAA;E/D8iZJ;E+D3iZM;IrCvDJ,6DAAA;IAZA,0BAAA;E1BknZF;E+D1iZM;IrCxEJ,2DAAA;IAYA,4BAAA;E1B0mZF;E+DziZM;IACE,aAAA;E/D2iZR;E+DxiZM;IACE,mDAAA;IACA,oBAAA;E/D0iZR;E+DxiZQ;IACE,yDAAA;IACA,oDAAA;E/D0iZV;AACF;AUjoZI;EqD8DA;IACE,mBAAA;E/DskZJ;E+DnkZM;IrCvDJ,6DAAA;IAZA,0BAAA;E1B0oZF;E+DlkZM;IrCxEJ,2DAAA;IAYA,4BAAA;E1BkoZF;E+DjkZM;IACE,aAAA;E/DmkZR;E+DhkZM;IACE,mDAAA;IACA,oBAAA;E/DkkZR;E+DhkZQ;IACE,yDAAA;IACA,oDAAA;E/DkkZV;AACF;AUzpZI;EqD8DA;IACE,mBAAA;E/D8lZJ;E+D3lZM;IrCvDJ,6DAAA;IAZA,0BAAA;E1BkqZF;E+D1lZM;IrCxEJ,2DAAA;IAYA,4BAAA;E1B0pZF;E+DzlZM;IACE,aAAA;E/D2lZR;E+DxlZM;IACE,mDAAA;IACA,oBAAA;E/D0lZR;E+DxlZQ;IACE,yDAAA;IACA,oDAAA;E/D0lZV;AACF;AUjrZI;EqD8DA;IACE,mBAAA;E/DsnZJ;E+DnnZM;IrCvDJ,6DAAA;IAZA,0BAAA;E1B0rZF;E+DlnZM;IrCxEJ,2DAAA;IAYA,4BAAA;E1BkrZF;E+DjnZM;IACE,aAAA;E/DmnZR;E+DhnZM;IACE,mDAAA;IACA,oBAAA;E/DknZR;E+DhnZQ;IACE,yDAAA;IACA,oDAAA;E/DknZV;AACF;AUzsZI;EqD8DA;IACE,mBAAA;E/D8oZJ;E+D3oZM;IrCvDJ,6DAAA;IAZA,0BAAA;E1BktZF;E+D1oZM;IrCxEJ,2DAAA;IAYA,4BAAA;E1B0sZF;E+DzoZM;IACE,aAAA;E/D2oZR;E+DxoZM;IACE,mDAAA;IACA,oBAAA;E/D0oZR;E+DxoZQ;IACE,yDAAA;IACA,oDAAA;E/D0oZV;AACF;A+D7nZA;ErChJI,gBAAA;A1BgxZJ;A+D7nZE;EACE,mDAAA;A/D+nZJ;A+D7nZI;EACE,sBAAA;A/D+nZN;;A+DlnZE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/DqnZJ;;A+D/nZE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/DkoZJ;;A+D5oZE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/D+oZJ;;A+DzpZE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/D4pZJ;;A+DtqZE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/DyqZJ;;A+DnrZE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/DsrZJ;;A+DhsZE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/DmsZJ;;A+D7sZE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/DgtZJ;;A+D1tZE;EACE,4DAAA;EACA,qDAAA;EACA,mEAAA;EACA,4DAAA;EACA,sEAAA;EACA,6DAAA;EACA,uEAAA;EACA,+DAAA;EACA,gEAAA;EACA,0EAAA;A/D6tZJ;;A+DvuZE;EACE,4DAAA;EACA,qDAAA;EACA,mEAAA;EACA,4DAAA;EACA,sEAAA;EACA,6DAAA;EACA,uEAAA;EACA,+DAAA;EACA,gEAAA;EACA,0EAAA;A/D0uZJ;;A+DpvZE;EACE,yDAAA;EACA,kDAAA;EACA,gEAAA;EACA,4DAAA;EACA,mEAAA;EACA,6DAAA;EACA,oEAAA;EACA,4DAAA;EACA,6DAAA;EACA,uEAAA;A/DuvZJ;;A+DjwZE;EACE,4DAAA;EACA,qDAAA;EACA,mEAAA;EACA,4DAAA;EACA,sEAAA;EACA,6DAAA;EACA,uEAAA;EACA,+DAAA;EACA,gEAAA;EACA,0EAAA;A/DowZJ;;A+D9wZE;EACE,2DAAA;EACA,oDAAA;EACA,kEAAA;EACA,4DAAA;EACA,qEAAA;EACA,6DAAA;EACA,sEAAA;EACA,8DAAA;EACA,+DAAA;EACA,yEAAA;A/DixZJ;;AgE78ZA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U1DqpD2B;E0DppD3B,W1DopD2B;E0DnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EtCJE,uBAAA;EsCMF,oCAAA;AhE68ZF;AgE18ZE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhE48ZJ;AgEz8ZE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhE28ZJ;AgEx8ZE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AhEy8ZJ;;AgEj8ZA;EAHE,wCAAA;AhEw8ZF;;AgE/7ZI;EATF,wCAAA;AhE48ZF;;AiE7/ZA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E1CyRI,8BALI;E0ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E1C2QI,oCALI;E0CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EvCRE,4CAAA;A1BsgaJ;AiE3/ZE;EACE,UAAA;AjE6/ZJ;AiE1/ZE;EACE,aAAA;AjE4/ZJ;;AiEx/ZA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjE0/ZF;AiEx/ZE;EACE,sCAAA;AjE0/ZJ;;AiEt/ZA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EvChCE,0FAAA;EACA,2FAAA;A1B0haJ;AiEx/ZE;EACE,oDAAA;EACA,sCAAA;AjE0/ZJ;;AiEt/ZA;EACE,kCAAA;EACA,qBAAA;AjEy/ZF;;AkEvjaA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlEqjaF;;AkE9iaA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlEgjaF;AkE7iaE;E3D5CI,mC2D6CF;EACA,8B5Dk8CgC;AN6mXpC;AOzlaM;E2DwCJ;I3DvCM,gBAAA;EP4laN;AACF;AkEljaE;EACE,e5Dg8CgC;ANonXpC;AkEhjaE;EACE,sB5D67CgC;ANqnXpC;;AkE9iaA;EACE,+CAAA;AlEijaF;AkE/iaE;EACE,gBAAA;EACA,gBAAA;AlEijaJ;AkE9iaE;EACE,gBAAA;AlEgjaJ;;AkE5iaA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlE+iaF;;AkE3iaA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;ExCrFE,4CAAA;EwCyFF,UAAA;AlE2iaF;;AkEviaA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlE6ia9D;AmEzpaE;EAAS,UAAA;AnE4paX;AmE3paE;EAAS,mCD2GiF;AlEmja5F;;AkE9iaA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;ExCrGE,2DAAA;EACA,4DAAA;A1BupaJ;AkEhjaE;EACE,kGAAA;EACA,sJAAA;AlEkjaJ;;AkE7iaA;EACE,gBAAA;EACA,8CAAA;AlEgjaF;;AkE3iaA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlE4iaF;;AkExiaA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;ExCzHE,+DAAA;EACA,8DAAA;A1BqqaJ;AkEviaE;EACE,8CAAA;AlEyiaJ;;AUppaI;EwDiHF;IACE,0BAAA;IACA,2CAAA;ElEuiaF;EkEniaA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElEqiaF;EkEliaA;IACE,uBAAA;ElEoiaF;AACF;AUnqaI;EwDmIF;;IAEE,uBAAA;ElEmiaF;AACF;AUzqaI;EwD0IF;IACE,wBAAA;ElEkiaF;AACF;AkEzhaI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlE2haN;AkEzhaM;EACE,YAAA;EACA,SAAA;ExCzMJ,gBAAA;A1BquaJ;AkExhaM;;ExC7MF,gBAAA;A1ByuaJ;AkEvhaM;EACE,gBAAA;AlEyhaR;;AUnraI;EwDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElE+iaJ;EkE7iaI;IACE,YAAA;IACA,SAAA;IxCzMJ,gBAAA;E1ByvaF;EkE5iaI;;IxC7MF,gBAAA;E1B6vaF;EkE3iaI;IACE,gBAAA;ElE6iaN;AACF;AUxsaI;EwDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElEmkaJ;EkEjkaI;IACE,YAAA;IACA,SAAA;IxCzMJ,gBAAA;E1B6waF;EkEhkaI;;IxC7MF,gBAAA;E1BixaF;EkE/jaI;IACE,gBAAA;ElEikaN;AACF;AU5taI;EwDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElEulaJ;EkErlaI;IACE,YAAA;IACA,SAAA;IxCzMJ,gBAAA;E1BiyaF;EkEplaI;;IxC7MF,gBAAA;E1BqyaF;EkEnlaI;IACE,gBAAA;ElEqlaN;AACF;AUhvaI;EwDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElE2maJ;EkEzmaI;IACE,YAAA;IACA,SAAA;IxCzMJ,gBAAA;E1BqzaF;EkExmaI;;IxC7MF,gBAAA;E1ByzaF;EkEvmaI;IACE,gBAAA;ElEymaN;AACF;AUpwaI;EwDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElE+naJ;EkE7naI;IACE,YAAA;IACA,SAAA;IxCzMJ,gBAAA;E1By0aF;EkE5naI;;IxC7MF,gBAAA;E1B60aF;EkE3naI;IACE,gBAAA;ElE6naN;AACF;AoEn2aA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;E7CwRI,gCALI;E6CjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC/D+lB4B;E+D7lB5B,kBAAA;EACA,gB/DwmB4B;E+DvmB5B,gB/D+mB4B;E+D9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CgRI,sCALI;E6ChQR,qBAAA;EACA,UAAA;ApE22aF;AoEz2aE;EAAS,kCAAA;ApE42aX;AoE12aE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApE42aJ;AoE12aI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApE42aN;;AoEv2aA;EACE,iDAAA;ApE02aF;AoEx2aE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApE02aJ;;AoEt2aA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApEy2aF;AoEv2aE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApEy2aJ;;AoEr2aA,mBAAA;AAEA;EACE,8CAAA;ApEu2aF;AoEr2aE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApEu2aJ;;AoEn2aA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApEs2aF;AoEp2aE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApEs2aJ;;AoEl2aA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E1CjGE,8CAAA;A1Bs7aJ;;AsEz8aA;EAEE,yBAAA;EACA,6BAAA;E/C4RI,gCALI;E+CrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;E/CmRI,mCALI;E+C5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC/D+lB4B;E+D7lB5B,kBAAA;EACA,gB/DwmB4B;E+DvmB5B,gB/D+mB4B;E+D9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CgRI,sCALI;E+C1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E5ChBE,8CAAA;A1Bo+aJ;AsEh9aE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtEk9aJ;AsEh9aI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtEi9aN;;AsE38aE;EACE,oFAAA;AtE88aJ;AsE58aI;EAEE,wFAAA;AtE68aN;AsE18aI;EACE,SAAA;EACA,gDAAA;AtE48aN;AsEz8aI;EACE,sCAAA;EACA,sCAAA;AtE28aN;;AsEt8aA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtEw8aJ;AsEt8aI;EAEE,kIAAA;AtEu8aN;AsEp8aI;EACE,OAAA;EACA,kDAAA;AtEs8aN;AsEn8aI;EACE,oCAAA;EACA,wCAAA;AtEq8aN;;AsEh8aA,mBAAA;AAGE;EACE,iFAAA;AtEi8aJ;AsE/7aI;EAEE,wFAAA;AtEg8aN;AsE77aI;EACE,MAAA;EACA,mDAAA;AtE+7aN;AsE57aI;EACE,mCAAA;EACA,yCAAA;AtE87aN;AsEz7aE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtE27aJ;;AsEv7aA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtEy7aJ;AsEv7aI;EAEE,kIAAA;AtEw7aN;AsEr7aI;EACE,QAAA;EACA,iDAAA;AtEu7aN;AsEp7aI;EACE,qCAAA;EACA,uCAAA;AtEs7aN;;AsEj7aA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;E/C2GI,6CALI;E+CpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E5C5JE,6DAAA;EACA,8DAAA;A1BgkbJ;AsEl6aE;EACE,aAAA;AtEo6aJ;;AsEh6aA;EACE,0EAAA;EACA,mCAAA;AtEm6aF;;AuExlbA;EACE,kBAAA;AvE2lbF;;AuExlbA;EACE,mBAAA;AvE2lbF;;AuExlbA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvE2lbF;ACjnbE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ADmnbJ;;AuE5lbA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhElBI,sCgEmBJ;AvE+lbF;AO9mbM;EgEQN;IhEPQ,gBAAA;EPinbN;AACF;;AuEjmbA;;;EAGE,cAAA;AvEombF;;AuEjmbA;;EAEE,2BAAA;AvEombF;;AuEjmbA;;EAEE,4BAAA;AvEombF;;AuE3lbE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvE8lbJ;AuE3lbE;;;EAGE,UAAA;EACA,UAAA;AvE6lbJ;AuE1lbE;;EAEE,UAAA;EACA,UAAA;EhE5DE,2BgE6DF;AvE4lbJ;AOrpbM;EgEqDJ;;IhEpDM,gBAAA;EPypbN;AACF;;AuEzlbA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjEkhDmC;EiEjhDnC,UAAA;EACA,WjE1FS;EiE2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjE6gDmC;ECnmD/B,8BgEuFJ;AvE2lbF;AO9qbM;EgEkEN;;IhEjEQ,gBAAA;EPkrbN;AACF;AuE9lbE;;;EAEE,WjEpGO;EiEqGP,qBAAA;EACA,UAAA;EACA,YjEqgDiC;AN4lYrC;;AuE9lbA;EACE,OAAA;AvEimbF;;AuE9lbA;EACE,QAAA;AvEimbF;;AuE5lbA;;EAEE,qBAAA;EACA,WjEsgDmC;EiErgDnC,YjEqgDmC;EiEpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvE+lbF;;AuE5lbA;EACE,2TAAA;AvE+lbF;;AuE7lbA;EACE,0TAAA;AvEgmbF;;AuExlbA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjEs9CmC;EiEr9CnC,mBAAA;EACA,gBjEo9CmC;ANsoYrC;AuExlbE;EACE,uBAAA;EACA,cAAA;EACA,WjEo9CiC;EiEn9CjC,WjEo9CiC;EiEn9CjC,UAAA;EACA,iBjEo9CiC;EiEn9CjC,gBjEm9CiC;EiEl9CjC,mBAAA;EACA,eAAA;EACA,sBjElKO;EiEmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjE28CiC;EC3mD/B,6BgEiKF;AvEylbJ;AOtvbM;EgE4IJ;IhE3IM,gBAAA;EPyvbN;AACF;AuE3lbE;EACE,UjEw8CiC;ANqpYrC;;AuEplbA;EACE,kBAAA;EACA,UAAA;EACA,ejEk8CmC;EiEj8CnC,SAAA;EACA,oBjE+7CmC;EiE97CnC,uBjE87CmC;EiE77CnC,WjE7LS;EiE8LT,kBAAA;AvEulbF;;AuEjlbE;;EAEE,gCjEm8CiC;ANipYrC;AuEjlbE;EACE,sBjEhMO;ANmxbX;AuEhlbE;EACE,WjEpMO;ANsxbX;;AuE5lbE;;;EAEE,gCjEm8CiC;AN6pYrC;AuE7lbE;EACE,sBjEhMO;AN+xbX;AuE5lbE;EACE,WjEpMO;ANkybX;;AwEhzbA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxEkzbF;;AwE9ybA;EACE;IAAK,0CAAA;ExEkzbL;AACF;AwE/ybA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxE8ybF;;AwE3ybA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxE6ybF;;AwEpybA;EACE;IACE,mBAAA;ExEuybF;EwErybA;IACE,UAAA;IACA,eAAA;ExEuybF;AACF;AwEnybA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxEkybF;;AwE/xbA;EACE,wBAAA;EACA,yBAAA;AxEkybF;;AwE9xbE;EACE;;IAEE,kCAAA;ExEiybJ;AACF;AyEj3bA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzEk3bF;;AUrzbI;E+D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlE5BA,0CkE8BA;EzEm2bJ;AACF;AO93bM;EkEYJ;IlEXM,gBAAA;EPi4bN;AACF;AU30bI;E+D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzE02bN;EyEv2bI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEy2bN;EyEt2bI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEw2bN;EyEr2bI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEu2bN;EyEp2bI;IAEE,eAAA;EzEq2bN;EyEl2bI;IAGE,mBAAA;EzEk2bN;AACF;AU/3bI;E+D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzEi2bN;EyE/1bM;IACE,aAAA;EzEi2bR;EyE91bM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE+1bR;AACF;;AUn4bI;E+D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlE5BA,0CkE8BA;EzEi7bJ;AACF;AO58bM;EkEYJ;IlEXM,gBAAA;EP+8bN;AACF;AUz5bI;E+D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEw7bN;EyEr7bI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEu7bN;EyEp7bI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEs7bN;EyEn7bI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEq7bN;EyEl7bI;IAEE,eAAA;EzEm7bN;EyEh7bI;IAGE,mBAAA;EzEg7bN;AACF;AU78bI;E+D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE+6bN;EyE76bM;IACE,aAAA;EzE+6bR;EyE56bM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE66bR;AACF;;AUj9bI;E+D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlE5BA,0CkE8BA;EzE+/bJ;AACF;AO1hcM;EkEYJ;IlEXM,gBAAA;EP6hcN;AACF;AUv+bI;E+D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEsgcN;EyEngcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEqgcN;EyElgcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEogcN;EyEjgcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEmgcN;EyEhgcI;IAEE,eAAA;EzEigcN;EyE9/bI;IAGE,mBAAA;EzE8/bN;AACF;AU3hcI;E+D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE6/bN;EyE3/bM;IACE,aAAA;EzE6/bR;EyE1/bM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzE2/bR;AACF;;AU/hcI;E+D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlE5BA,0CkE8BA;EzE6kcJ;AACF;AOxmcM;EkEYJ;IlEXM,gBAAA;EP2mcN;AACF;AUrjcI;E+D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEolcN;EyEjlcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEmlcN;EyEhlcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEklcN;EyE/kcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzEilcN;EyE9kcI;IAEE,eAAA;EzE+kcN;EyE5kcI;IAGE,mBAAA;EzE4kcN;AACF;AUzmcI;E+D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzE2kcN;EyEzkcM;IACE,aAAA;EzE2kcR;EyExkcM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzEykcR;AACF;;AU7mcI;E+D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IlE5BA,0CkE8BA;EzE2pcJ;AACF;AOtrcM;EkEYJ;IlEXM,gBAAA;EPyrcN;AACF;AUnocI;E+D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzEkqcN;EyE/pcI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzEiqcN;EyE9pcI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzEgqcN;EyE7pcI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzE+pcN;EyE5pcI;IAEE,eAAA;EzE6pcN;EyE1pcI;IAGE,mBAAA;EzE0pcN;AACF;AUvrcI;E+D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzEypcN;EyEvpcM;IACE,aAAA;EzEypcR;EyEtpcM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzEupcR;AACF;;AyEvucE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;ElE5BA,0CkE8BA;AzEwucN;AOlwcM;EkEYJ;IlEXM,gBAAA;EPqwcN;AACF;AyE3ucM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzE6ucR;AyE1ucM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzE4ucR;AyEzucM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzE2ucR;AyExucM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzE0ucR;AyEvucM;EAEE,eAAA;AzEwucR;AyErucM;EAGE,mBAAA;AzEqucR;;AyE1scA;ENpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7D0mCkC;E6DzmClC,YAAA;EACA,aAAA;EACA,sB7DUS;ANwzcX;AmE/zcE;EAAS,UAAA;AnEk0cX;AmEj0cE;EAAS,Y7Dm+CyB;ANi2ZpC;;AyEttcA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzEytcF;AyEvtcE;EACE,4FAAA;EACA,6IAAA;AzEytcJ;;AyErtcA;EACE,gBAAA;EACA,kDAAA;AzEwtcF;;AyErtcA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzEwtcF;;A0Er2cA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpEgzCkC;ANwjapC;A0Et2cE;EACE,qBAAA;EACA,WAAA;A1Ew2cJ;;A0En2cA;EACE,iBAAA;A1Es2cF;;A0En2cA;EACE,iBAAA;A1Es2cF;;A0En2cA;EACE,iBAAA;A1Es2cF;;A0Ej2cE;EACE,mDAAA;A1Eo2cJ;;A0Eh2cA;EACE;IACE,YpEmxCgC;ENglalC;AACF;A0Eh2cA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1Ek2cF;;A0E/1cA;EACE;IACE,uBAAA;E1Ek2cF;AACF;ACj5cE;EACE,cAAA;EACA,WAAA;EACA,WAAA;ADm5cJ;;AEt5cE;EACE,sBAAA;EACA,iFAAA;AFy5cJ;;AE35cE;EACE,sBAAA;EACA,mFAAA;AF85cJ;;AEh6cE;EACE,sBAAA;EACA,iFAAA;AFm6cJ;;AEr6cE;EACE,sBAAA;EACA,8EAAA;AFw6cJ;;AE16cE;EACE,sBAAA;EACA,iFAAA;AF66cJ;;AE/6cE;EACE,sBAAA;EACA,gFAAA;AFk7cJ;;AEp7cE;EACE,sBAAA;EACA,+EAAA;AFu7cJ;;AEz7cE;EACE,sBAAA;EACA,8EAAA;AF47cJ;;AE97cE;EACE,sBAAA;EACA,uFAAA;AFi8cJ;;AEn8cE;EACE,sBAAA;EACA,uFAAA;AFs8cJ;;AEx8cE;EACE,sBAAA;EACA,oFAAA;AF28cJ;;AE78cE;EACE,sBAAA;EACA,uFAAA;AFg9cJ;;AEl9cE;EACE,sBAAA;EACA,sFAAA;AFq9cJ;;AGv9cE;EACE,wEAAA;EACA,kGAAA;AH09cJ;AGv9cM;EAGE,8DAAA;EACA,wFAAA;AHu9cR;;AGh+cE;EACE,0EAAA;EACA,oGAAA;AHm+cJ;AGh+cM;EAGE,6DAAA;EACA,uFAAA;AHg+cR;;AGz+cE;EACE,wEAAA;EACA,kGAAA;AH4+cJ;AGz+cM;EAGE,8DAAA;EACA,wFAAA;AHy+cR;;AGl/cE;EACE,qEAAA;EACA,+FAAA;AHq/cJ;AGl/cM;EAGE,+DAAA;EACA,yFAAA;AHk/cR;;AG3/cE;EACE,wEAAA;EACA,kGAAA;AH8/cJ;AG3/cM;EAGE,8DAAA;EACA,wFAAA;AH2/cR;;AGpgdE;EACE,uEAAA;EACA,iGAAA;AHugdJ;AGpgdM;EAGE,8DAAA;EACA,wFAAA;AHogdR;;AG7gdE;EACE,sEAAA;EACA,gGAAA;AHghdJ;AG7gdM;EAGE,gEAAA;EACA,0FAAA;AH6gdR;;AGthdE;EACE,qEAAA;EACA,+FAAA;AHyhdJ;AGthdM;EAGE,6DAAA;EACA,uFAAA;AHshdR;;AG/hdE;EACE,8EAAA;EACA,wGAAA;AHkidJ;AG/hdM;EAGE,gEAAA;EACA,0FAAA;AH+hdR;;AGxidE;EACE,8EAAA;EACA,wGAAA;AH2idJ;AGxidM;EAGE,gEAAA;EACA,0FAAA;AHwidR;;AGjjdE;EACE,2EAAA;EACA,qGAAA;AHojdJ;AGjjdM;EAGE,gEAAA;EACA,0FAAA;AHijdR;;AG1jdE;EACE,8EAAA;EACA,wGAAA;AH6jdJ;AG1jdM;EAGE,gEAAA;EACA,0FAAA;AH0jdR;;AGnkdE;EACE,6EAAA;EACA,uGAAA;AHskdJ;AGnkdM;EAGE,gEAAA;EACA,0FAAA;AHmkdR;;AG5jdA;EACE,+EAAA;EACA,yGAAA;AH+jdF;AG5jdI;EAEE,kFAAA;EACA,4GAAA;AH6jdN;;AIvldA;EACE,UAAA;EAEA,kJAAA;AJyldF;;AK5ldA;EACE,oBAAA;EACA,aC6c4B;ED5c5B,mBAAA;EACA,kFAAA;EACA,6BC2c4B;ED1c5B,2BAAA;AL+ldF;AK7ldE;EACE,cAAA;EACA,UCuc0B;EDtc1B,WCsc0B;EDrc1B,kBAAA;EEIE,sCFHF;AL+ldJ;AOxldM;EFZJ;IEaM,gBAAA;EP2ldN;AACF;;AK7ldI;EACE,mEAAA;ALgmdN;;AQnndA;EACE,kBAAA;EACA,WAAA;ARsndF;AQpndE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;ARsndJ;AQnndE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ARqndJ;;AQhndE;EACE,uBAAA;ARmndJ;;AQpndE;EACE,sBAAA;ARundJ;;AQxndE;EACE,yBAAA;AR2ndJ;;AQ5ndE;EACE,iCAAA;AR+ndJ;;ASppdA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aHumCkC;ANgjbpC;;ASppdA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aH+lCkC;ANwjbpC;;AS/odI;EACE,gBAAA;EACA,MAAA;EACA,aHmlC8B;AN+jbpC;;AS/odI;EACE,gBAAA;EACA,SAAA;EACA,aH6kC8B;ANqkbpC;;AUnndI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN4kblC;ES5pdE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENilblC;AACF;AUhodI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENwlblC;ESxqdE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;EN6lblC;AACF;AU5odI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENomblC;ESprdE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENymblC;AACF;AUxpdI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;ENgnblC;EShsdE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENqnblC;AACF;AUpqdI;EDxCA;IACE,gBAAA;IACA,MAAA;IACA,aHmlC8B;EN4nblC;ES5sdE;IACE,gBAAA;IACA,SAAA;IACA,aH6kC8B;ENioblC;AACF;AW9udA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AXgvdF;;AW7udA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AXgvdF;;AYxvdA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AbyvdF;AatvdE;;EACE,6BAAA;AbyvdJ;;AcvwdE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,URgcsC;EQ/btC,WAAA;Ad0wdJ;;AelxdA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AhBsxdF;;AiB5xdA;EACE,qBAAA;EACA,mBAAA;EACA,6BXisB4B;EWhsB5B,eAAA;EACA,8BAAA;EACA,aX2rB4B;ANomc9B;;AkBnudQ;EAOI,mCAAA;AlBgudZ;;AkBvudQ;EAOI,8BAAA;AlBoudZ;;AkB3udQ;EAOI,iCAAA;AlBwudZ;;AkB/udQ;EAOI,iCAAA;AlB4udZ;;AkBnvdQ;EAOI,sCAAA;AlBgvdZ;;AkBvvdQ;EAOI,mCAAA;AlBovdZ;;AkB3vdQ;EAOI,sBAAA;AlBwvdZ;;AkB/vdQ;EAOI,uBAAA;AlB4vdZ;;AkBnwdQ;EAOI,sBAAA;AlBgwdZ;;AkBvwdQ;EAOI,8BAAA;AlBowdZ;;AkB3wdQ;EAOI,4BAAA;AlBwwdZ;;AkB/wdQ;EAOI,2BAAA;AlB4wdZ;;AkBnxdQ;EAOI,iCAAA;AlBgxdZ;;AkBvxdQ;EAOI,2BAAA;AlBoxdZ;;AkB3xdQ;EAOI,qBAAA;AlBwxdZ;;AkB/xdQ;EAOI,wBAAA;AlB4xdZ;;AkBnydQ;EAOI,uBAAA;AlBgydZ;;AkBvydQ;EAOI,wBAAA;AlBoydZ;;AkB3ydQ;EAOI,qBAAA;AlBwydZ;;AkB/ydQ;EAOI,yBAAA;AlB4ydZ;;AkBnzdQ;EAOI,2BAAA;AlBgzdZ;;AkBvzdQ;EAOI,4BAAA;AlBozdZ;;AkB3zdQ;EAOI,2BAAA;AlBwzdZ;;AkB/zdQ;EAOI,2BAAA;AlB4zdZ;;AkBn0dQ;EAOI,6BAAA;AlBg0dZ;;AkBv0dQ;EAOI,8BAAA;AlBo0dZ;;AkB30dQ;EAOI,6BAAA;AlBw0dZ;;AkB/0dQ;EAOI,2BAAA;AlB40dZ;;AkBn1dQ;EAOI,6BAAA;AlBg1dZ;;AkBv1dQ;EAOI,8BAAA;AlBo1dZ;;AkB31dQ;EAOI,6BAAA;AlBw1dZ;;AkB/1dQ;EAOI,0BAAA;AlB41dZ;;AkBn2dQ;EAOI,gCAAA;AlBg2dZ;;AkBv2dQ;EAOI,yBAAA;AlBo2dZ;;AkB32dQ;EAOI,wBAAA;AlBw2dZ;;AkB/2dQ;EAOI,+BAAA;AlB42dZ;;AkBn3dQ;EAOI,yBAAA;AlBg3dZ;;AkBv3dQ;EAOI,6BAAA;AlBo3dZ;;AkB33dQ;EAOI,8BAAA;AlBw3dZ;;AkB/3dQ;EAOI,wBAAA;AlB43dZ;;AkBn4dQ;EAOI,+BAAA;AlBg4dZ;;AkBv4dQ;EAOI,wBAAA;AlBo4dZ;;AkB34dQ;EAOI,2CAAA;AlBw4dZ;;AkB/4dQ;EAOI,8CAAA;AlB44dZ;;AkBn5dQ;EAOI,8CAAA;AlBg5dZ;;AkBv5dQ;EAOI,2BAAA;AlBo5dZ;;AkBr6dQ;EACE,gFAAA;AlBw6dV;;AkBz6dQ;EACE,kFAAA;AlB46dV;;AkB76dQ;EACE,gFAAA;AlBg7dV;;AkBj7dQ;EACE,6EAAA;AlBo7dV;;AkBr7dQ;EACE,gFAAA;AlBw7dV;;AkBz7dQ;EACE,+EAAA;AlB47dV;;AkB77dQ;EACE,8EAAA;AlBg8dV;;AkBj8dQ;EACE,6EAAA;AlBo8dV;;AkB37dQ;EAOI,2BAAA;AlBw7dZ;;AkB/7dQ;EAOI,6BAAA;AlB47dZ;;AkBn8dQ;EAOI,6BAAA;AlBg8dZ;;AkBv8dQ;EAOI,0BAAA;AlBo8dZ;;AkB38dQ;EAOI,2BAAA;AlBw8dZ;;AkB/8dQ;EAOI,iBAAA;AlB48dZ;;AkBn9dQ;EAOI,mBAAA;AlBg9dZ;;AkBv9dQ;EAOI,oBAAA;AlBo9dZ;;AkB39dQ;EAOI,oBAAA;AlBw9dZ;;AkB/9dQ;EAOI,sBAAA;AlB49dZ;;AkBn+dQ;EAOI,uBAAA;AlBg+dZ;;AkBv+dQ;EAOI,kBAAA;AlBo+dZ;;AkB3+dQ;EAOI,oBAAA;AlBw+dZ;;AkB/+dQ;EAOI,qBAAA;AlB4+dZ;;AkBn/dQ;EAOI,mBAAA;AlBg/dZ;;AkBv/dQ;EAOI,qBAAA;AlBo/dZ;;AkB3/dQ;EAOI,sBAAA;AlBw/dZ;;AkB//dQ;EAOI,2CAAA;AlB4/dZ;;AkBngeQ;EAOI,sCAAA;AlBggeZ;;AkBvgeQ;EAOI,sCAAA;AlBogeZ;;AkB3geQ;EAOI,uFAAA;AlBwgeZ;;AkB/geQ;EAOI,oBAAA;AlB4geZ;;AkBnheQ;EAOI,2FAAA;AlBgheZ;;AkBvheQ;EAOI,wBAAA;AlBoheZ;;AkB3heQ;EAOI,6FAAA;AlBwheZ;;AkB/heQ;EAOI,0BAAA;AlB4heZ;;AkBnieQ;EAOI,8FAAA;AlBgieZ;;AkBvieQ;EAOI,2BAAA;AlBoieZ;;AkB3ieQ;EAOI,4FAAA;AlBwieZ;;AkB/ieQ;EAOI,yBAAA;AlB4ieZ;;AkBnjeQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBijeZ;;AkBxjeQ;EAIQ,sBAAA;EAGJ,gFAAA;AlBsjeZ;;AkB7jeQ;EAIQ,sBAAA;EAGJ,8EAAA;AlB2jeZ;;AkBlkeQ;EAIQ,sBAAA;EAGJ,2EAAA;AlBgkeZ;;AkBvkeQ;EAIQ,sBAAA;EAGJ,8EAAA;AlBqkeZ;;AkB5keQ;EAIQ,sBAAA;EAGJ,6EAAA;AlB0keZ;;AkBjleQ;EAIQ,sBAAA;EAGJ,4EAAA;AlB+keZ;;AkBtleQ;EAIQ,sBAAA;EAGJ,2EAAA;AlBoleZ;;AkB3leQ;EAIQ,sBAAA;EAGJ,4EAAA;AlByleZ;;AkBhmeQ;EAIQ,sBAAA;EAGJ,4EAAA;AlB8leZ;;AkBrmeQ;EAOI,wDAAA;AlBkmeZ;;AkBzmeQ;EAOI,0DAAA;AlBsmeZ;;AkB7meQ;EAOI,wDAAA;AlB0meZ;;AkBjneQ;EAOI,qDAAA;AlB8meZ;;AkBrneQ;EAOI,wDAAA;AlBkneZ;;AkBzneQ;EAOI,uDAAA;AlBsneZ;;AkB7neQ;EAOI,sDAAA;AlB0neZ;;AkBjoeQ;EAOI,qDAAA;AlB8neZ;;AkBroeQ;EAOI,4BAAA;AlBkoeZ;;AkBzoeQ;EAOI,4BAAA;AlBsoeZ;;AkB7oeQ;EAOI,4BAAA;AlB0oeZ;;AkBjpeQ;EAOI,4BAAA;AlB8oeZ;;AkBrpeQ;EAOI,4BAAA;AlBkpeZ;;AkBnqeQ;EACE,wBAAA;AlBsqeV;;AkBvqeQ;EACE,yBAAA;AlB0qeV;;AkB3qeQ;EACE,wBAAA;AlB8qeV;;AkB/qeQ;EACE,yBAAA;AlBkreV;;AkBnreQ;EACE,sBAAA;AlBsreV;;AkB7qeQ;EAOI,qBAAA;AlB0qeZ;;AkBjreQ;EAOI,qBAAA;AlB8qeZ;;AkBrreQ;EAOI,qBAAA;AlBkreZ;;AkBzreQ;EAOI,sBAAA;AlBsreZ;;AkB7reQ;EAOI,sBAAA;AlB0reZ;;AkBjseQ;EAOI,0BAAA;AlB8reZ;;AkBrseQ;EAOI,uBAAA;AlBkseZ;;AkBzseQ;EAOI,2BAAA;AlBsseZ;;AkB7seQ;EAOI,sBAAA;AlB0seZ;;AkBjteQ;EAOI,sBAAA;AlB8seZ;;AkBrteQ;EAOI,sBAAA;AlBkteZ;;AkBzteQ;EAOI,uBAAA;AlBsteZ;;AkB7teQ;EAOI,uBAAA;AlB0teZ;;AkBjueQ;EAOI,2BAAA;AlB8teZ;;AkBrueQ;EAOI,wBAAA;AlBkueZ;;AkBzueQ;EAOI,4BAAA;AlBsueZ;;AkB7ueQ;EAOI,yBAAA;AlB0ueZ;;AkBjveQ;EAOI,8BAAA;AlB8ueZ;;AkBrveQ;EAOI,iCAAA;AlBkveZ;;AkBzveQ;EAOI,sCAAA;AlBsveZ;;AkB7veQ;EAOI,yCAAA;AlB0veZ;;AkBjweQ;EAOI,uBAAA;AlB8veZ;;AkBrweQ;EAOI,uBAAA;AlBkweZ;;AkBzweQ;EAOI,yBAAA;AlBsweZ;;AkB7weQ;EAOI,yBAAA;AlB0weZ;;AkBjxeQ;EAOI,0BAAA;AlB8weZ;;AkBrxeQ;EAOI,4BAAA;AlBkxeZ;;AkBzxeQ;EAOI,kCAAA;AlBsxeZ;;AkB7xeQ;EAOI,sCAAA;AlB0xeZ;;AkBjyeQ;EAOI,oCAAA;AlB8xeZ;;AkBryeQ;EAOI,kCAAA;AlBkyeZ;;AkBzyeQ;EAOI,yCAAA;AlBsyeZ;;AkB7yeQ;EAOI,wCAAA;AlB0yeZ;;AkBjzeQ;EAOI,wCAAA;AlB8yeZ;;AkBrzeQ;EAOI,kCAAA;AlBkzeZ;;AkBzzeQ;EAOI,gCAAA;AlBszeZ;;AkB7zeQ;EAOI,8BAAA;AlB0zeZ;;AkBj0eQ;EAOI,gCAAA;AlB8zeZ;;AkBr0eQ;EAOI,+BAAA;AlBk0eZ;;AkBz0eQ;EAOI,oCAAA;AlBs0eZ;;AkB70eQ;EAOI,kCAAA;AlB00eZ;;AkBj1eQ;EAOI,gCAAA;AlB80eZ;;AkBr1eQ;EAOI,uCAAA;AlBk1eZ;;AkBz1eQ;EAOI,sCAAA;AlBs1eZ;;AkB71eQ;EAOI,iCAAA;AlB01eZ;;AkBj2eQ;EAOI,2BAAA;AlB81eZ;;AkBr2eQ;EAOI,iCAAA;AlBk2eZ;;AkBz2eQ;EAOI,+BAAA;AlBs2eZ;;AkB72eQ;EAOI,6BAAA;AlB02eZ;;AkBj3eQ;EAOI,+BAAA;AlB82eZ;;AkBr3eQ;EAOI,8BAAA;AlBk3eZ;;AkBz3eQ;EAOI,oBAAA;AlBs3eZ;;AkB73eQ;EAOI,mBAAA;AlB03eZ;;AkBj4eQ;EAOI,mBAAA;AlB83eZ;;AkBr4eQ;EAOI,mBAAA;AlBk4eZ;;AkBz4eQ;EAOI,mBAAA;AlBs4eZ;;AkB74eQ;EAOI,mBAAA;AlB04eZ;;AkBj5eQ;EAOI,mBAAA;AlB84eZ;;AkBr5eQ;EAOI,mBAAA;AlBk5eZ;;AkBz5eQ;EAOI,oBAAA;AlBs5eZ;;AkB75eQ;EAOI,0BAAA;AlB05eZ;;AkBj6eQ;EAOI,yBAAA;AlB85eZ;;AkBr6eQ;EAOI,uBAAA;AlBk6eZ;;AkBz6eQ;EAOI,yBAAA;AlBs6eZ;;AkB76eQ;EAOI,uBAAA;AlB06eZ;;AkBj7eQ;EAOI,uBAAA;AlB86eZ;;AkBr7eQ;EAOI,0BAAA;EAAA,yBAAA;AlBm7eZ;;AkB17eQ;EAOI,gCAAA;EAAA,+BAAA;AlBw7eZ;;AkB/7eQ;EAOI,+BAAA;EAAA,8BAAA;AlB67eZ;;AkBp8eQ;EAOI,6BAAA;EAAA,4BAAA;AlBk8eZ;;AkBz8eQ;EAOI,+BAAA;EAAA,8BAAA;AlBu8eZ;;AkB98eQ;EAOI,6BAAA;EAAA,4BAAA;AlB48eZ;;AkBn9eQ;EAOI,6BAAA;EAAA,4BAAA;AlBi9eZ;;AkBx9eQ;EAOI,wBAAA;EAAA,2BAAA;AlBs9eZ;;AkB79eQ;EAOI,8BAAA;EAAA,iCAAA;AlB29eZ;;AkBl+eQ;EAOI,6BAAA;EAAA,gCAAA;AlBg+eZ;;AkBv+eQ;EAOI,2BAAA;EAAA,8BAAA;AlBq+eZ;;AkB5+eQ;EAOI,6BAAA;EAAA,gCAAA;AlB0+eZ;;AkBj/eQ;EAOI,2BAAA;EAAA,8BAAA;AlB++eZ;;AkBt/eQ;EAOI,2BAAA;EAAA,8BAAA;AlBo/eZ;;AkB3/eQ;EAOI,wBAAA;AlBw/eZ;;AkB//eQ;EAOI,8BAAA;AlB4/eZ;;AkBngfQ;EAOI,6BAAA;AlBggfZ;;AkBvgfQ;EAOI,2BAAA;AlBogfZ;;AkB3gfQ;EAOI,6BAAA;AlBwgfZ;;AkB/gfQ;EAOI,2BAAA;AlB4gfZ;;AkBnhfQ;EAOI,2BAAA;AlBghfZ;;AkBvhfQ;EAOI,0BAAA;AlBohfZ;;AkB3hfQ;EAOI,gCAAA;AlBwhfZ;;AkB/hfQ;EAOI,+BAAA;AlB4hfZ;;AkBnifQ;EAOI,6BAAA;AlBgifZ;;AkBvifQ;EAOI,+BAAA;AlBoifZ;;AkB3ifQ;EAOI,6BAAA;AlBwifZ;;AkB/ifQ;EAOI,6BAAA;AlB4ifZ;;AkBnjfQ;EAOI,2BAAA;AlBgjfZ;;AkBvjfQ;EAOI,iCAAA;AlBojfZ;;AkB3jfQ;EAOI,gCAAA;AlBwjfZ;;AkB/jfQ;EAOI,8BAAA;AlB4jfZ;;AkBnkfQ;EAOI,gCAAA;AlBgkfZ;;AkBvkfQ;EAOI,8BAAA;AlBokfZ;;AkB3kfQ;EAOI,8BAAA;AlBwkfZ;;AkB/kfQ;EAOI,yBAAA;AlB4kfZ;;AkBnlfQ;EAOI,+BAAA;AlBglfZ;;AkBvlfQ;EAOI,8BAAA;AlBolfZ;;AkB3lfQ;EAOI,4BAAA;AlBwlfZ;;AkB/lfQ;EAOI,8BAAA;AlB4lfZ;;AkBnmfQ;EAOI,4BAAA;AlBgmfZ;;AkBvmfQ;EAOI,4BAAA;AlBomfZ;;AkB3mfQ;EAOI,qBAAA;AlBwmfZ;;AkB/mfQ;EAOI,2BAAA;AlB4mfZ;;AkBnnfQ;EAOI,0BAAA;AlBgnfZ;;AkBvnfQ;EAOI,wBAAA;AlBonfZ;;AkB3nfQ;EAOI,0BAAA;AlBwnfZ;;AkB/nfQ;EAOI,wBAAA;AlB4nfZ;;AkBnofQ;EAOI,2BAAA;EAAA,0BAAA;AlBiofZ;;AkBxofQ;EAOI,iCAAA;EAAA,gCAAA;AlBsofZ;;AkB7ofQ;EAOI,gCAAA;EAAA,+BAAA;AlB2ofZ;;AkBlpfQ;EAOI,8BAAA;EAAA,6BAAA;AlBgpfZ;;AkBvpfQ;EAOI,gCAAA;EAAA,+BAAA;AlBqpfZ;;AkB5pfQ;EAOI,8BAAA;EAAA,6BAAA;AlB0pfZ;;AkBjqfQ;EAOI,yBAAA;EAAA,4BAAA;AlB+pfZ;;AkBtqfQ;EAOI,+BAAA;EAAA,kCAAA;AlBoqfZ;;AkB3qfQ;EAOI,8BAAA;EAAA,iCAAA;AlByqfZ;;AkBhrfQ;EAOI,4BAAA;EAAA,+BAAA;AlB8qfZ;;AkBrrfQ;EAOI,8BAAA;EAAA,iCAAA;AlBmrfZ;;AkB1rfQ;EAOI,4BAAA;EAAA,+BAAA;AlBwrfZ;;AkB/rfQ;EAOI,yBAAA;AlB4rfZ;;AkBnsfQ;EAOI,+BAAA;AlBgsfZ;;AkBvsfQ;EAOI,8BAAA;AlBosfZ;;AkB3sfQ;EAOI,4BAAA;AlBwsfZ;;AkB/sfQ;EAOI,8BAAA;AlB4sfZ;;AkBntfQ;EAOI,4BAAA;AlBgtfZ;;AkBvtfQ;EAOI,2BAAA;AlBotfZ;;AkB3tfQ;EAOI,iCAAA;AlBwtfZ;;AkB/tfQ;EAOI,gCAAA;AlB4tfZ;;AkBnufQ;EAOI,8BAAA;AlBgufZ;;AkBvufQ;EAOI,gCAAA;AlBoufZ;;AkB3ufQ;EAOI,8BAAA;AlBwufZ;;AkB/ufQ;EAOI,4BAAA;AlB4ufZ;;AkBnvfQ;EAOI,kCAAA;AlBgvfZ;;AkBvvfQ;EAOI,iCAAA;AlBovfZ;;AkB3vfQ;EAOI,+BAAA;AlBwvfZ;;AkB/vfQ;EAOI,iCAAA;AlB4vfZ;;AkBnwfQ;EAOI,+BAAA;AlBgwfZ;;AkBvwfQ;EAOI,0BAAA;AlBowfZ;;AkB3wfQ;EAOI,gCAAA;AlBwwfZ;;AkB/wfQ;EAOI,+BAAA;AlB4wfZ;;AkBnxfQ;EAOI,6BAAA;AlBgxfZ;;AkBvxfQ;EAOI,+BAAA;AlBoxfZ;;AkB3xfQ;EAOI,6BAAA;AlBwxfZ;;AkB/xfQ;EAOI,iBAAA;AlB4xfZ;;AkBnyfQ;EAOI,uBAAA;AlBgyfZ;;AkBvyfQ;EAOI,sBAAA;AlBoyfZ;;AkB3yfQ;EAOI,oBAAA;AlBwyfZ;;AkB/yfQ;EAOI,sBAAA;AlB4yfZ;;AkBnzfQ;EAOI,oBAAA;AlBgzfZ;;AkBvzfQ;EAOI,qBAAA;AlBozfZ;;AkB3zfQ;EAOI,2BAAA;AlBwzfZ;;AkB/zfQ;EAOI,0BAAA;AlB4zfZ;;AkBn0fQ;EAOI,wBAAA;AlBg0fZ;;AkBv0fQ;EAOI,0BAAA;AlBo0fZ;;AkB30fQ;EAOI,wBAAA;AlBw0fZ;;AkB/0fQ;EAOI,wBAAA;AlB40fZ;;AkBn1fQ;EAOI,8BAAA;AlBg1fZ;;AkBv1fQ;EAOI,6BAAA;AlBo1fZ;;AkB31fQ;EAOI,2BAAA;AlBw1fZ;;AkB/1fQ;EAOI,6BAAA;AlB41fZ;;AkBn2fQ;EAOI,2BAAA;AlBg2fZ;;AkBv2fQ;EAOI,gDAAA;AlBo2fZ;;AkB32fQ;EAOI,4CAAA;AlBw2fZ;;AkB/2fQ;EAOI,4CAAA;AlB42fZ;;AkBn3fQ;EAOI,0CAAA;AlBg3fZ;;AkBv3fQ;EAOI,4CAAA;AlBo3fZ;;AkB33fQ;EAOI,6BAAA;AlBw3fZ;;AkB/3fQ;EAOI,0BAAA;AlB43fZ;;AkBn4fQ;EAOI,6BAAA;AlBg4fZ;;AkBv4fQ;EAOI,6BAAA;AlBo4fZ;;AkB34fQ;EAOI,+BAAA;AlBw4fZ;;AkB/4fQ;EAOI,2BAAA;AlB44fZ;;AkBn5fQ;EAOI,2BAAA;AlBg5fZ;;AkBv5fQ;EAOI,2BAAA;AlBo5fZ;;AkB35fQ;EAOI,2BAAA;AlBw5fZ;;AkB/5fQ;EAOI,2BAAA;AlB45fZ;;AkBn6fQ;EAOI,8BAAA;AlBg6fZ;;AkBv6fQ;EAOI,yBAAA;AlBo6fZ;;AkB36fQ;EAOI,4BAAA;AlBw6fZ;;AkB/6fQ;EAOI,2BAAA;AlB46fZ;;AkBn7fQ;EAOI,yBAAA;AlBg7fZ;;AkBv7fQ;EAOI,2BAAA;AlBo7fZ;;AkB37fQ;EAOI,4BAAA;AlBw7fZ;;AkB/7fQ;EAOI,6BAAA;AlB47fZ;;AkBn8fQ;EAOI,gCAAA;AlBg8fZ;;AkBv8fQ;EAOI,qCAAA;AlBo8fZ;;AkB38fQ;EAOI,wCAAA;AlBw8fZ;;AkB/8fQ;EAOI,oCAAA;AlB48fZ;;AkBn9fQ;EAOI,oCAAA;AlBg9fZ;;AkBv9fQ;EAOI,qCAAA;AlBo9fZ;;AkB39fQ;EAOI,8BAAA;AlBw9fZ;;AkB/9fQ;EAOI,8BAAA;AlB49fZ;;AkBj/fQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AlBk+fZ;;AkB/8fQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AlBw+fZ;;AkB/+fQ;EAIQ,oBAAA;EAGJ,uEAAA;AlB6+fZ;;AkBp/fQ;EAIQ,oBAAA;EAGJ,qEAAA;AlBk/fZ;;AkBz/fQ;EAIQ,oBAAA;EAGJ,kEAAA;AlBu/fZ;;AkB9/fQ;EAIQ,oBAAA;EAGJ,qEAAA;AlB4/fZ;;AkBnggBQ;EAIQ,oBAAA;EAGJ,oEAAA;AlBiggBZ;;AkBxggBQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBsggBZ;;AkB7ggBQ;EAIQ,oBAAA;EAGJ,kEAAA;AlB2ggBZ;;AkBlhgBQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBghgBZ;;AkBvhgBQ;EAIQ,oBAAA;EAGJ,mEAAA;AlBqhgBZ;;AkB5hgBQ;EAIQ,oBAAA;EAGJ,wEAAA;AlB0hgBZ;;AkBjigBQ;EAIQ,oBAAA;EAGJ,2CAAA;AlB+hgBZ;;AkBtigBQ;EAIQ,oBAAA;EAGJ,oCAAA;AlBoigBZ;;AkB3igBQ;EAIQ,oBAAA;EAGJ,0CAAA;AlByigBZ;;AkBhjgBQ;EAIQ,oBAAA;EAGJ,2CAAA;AlB8igBZ;;AkBrjgBQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBmjgBZ;;AkB1jgBQ;EAIQ,oBAAA;EAGJ,0CAAA;AlBwjgBZ;;AkB/jgBQ;EAIQ,oBAAA;EAGJ,yBAAA;AlB6jgBZ;;AkB9kgBQ;EACE,uBAAA;AlBilgBV;;AkBllgBQ;EACE,sBAAA;AlBqlgBV;;AkBtlgBQ;EACE,uBAAA;AlBylgBV;;AkB1lgBQ;EACE,oBAAA;AlB6lgBV;;AkBplgBQ;EAOI,iDAAA;AlBilgBZ;;AkBxlgBQ;EAOI,mDAAA;AlBqlgBZ;;AkB5lgBQ;EAOI,iDAAA;AlBylgBZ;;AkBhmgBQ;EAOI,8CAAA;AlB6lgBZ;;AkBpmgBQ;EAOI,iDAAA;AlBimgBZ;;AkBxmgBQ;EAOI,gDAAA;AlBqmgBZ;;AkB5mgBQ;EAOI,+CAAA;AlBymgBZ;;AkBhngBQ;EAOI,8CAAA;AlB6mgBZ;;AkB9ngBQ;EACE,sBAAA;AlBiogBV;;AkB7ngBU;EACE,sBAAA;AlBgogBZ;;AkBtogBQ;EACE,uBAAA;AlByogBV;;AkBrogBU;EACE,uBAAA;AlBwogBZ;;AkB9ogBQ;EACE,sBAAA;AlBipgBV;;AkB7ogBU;EACE,sBAAA;AlBgpgBZ;;AkBtpgBQ;EACE,uBAAA;AlBypgBV;;AkBrpgBU;EACE,uBAAA;AlBwpgBZ;;AkB9pgBQ;EACE,oBAAA;AlBiqgBV;;AkB7pgBU;EACE,oBAAA;AlBgqgBZ;;AkB5pgBQ;EAOI,yCAAA;AlBypgBZ;;AkBppgBU;EAOI,yCAAA;AlBipgBd;;AkBpqgBQ;EAOI,wCAAA;AlBiqgBZ;;AkB5pgBU;EAOI,wCAAA;AlBypgBd;;AkB5qgBQ;EAOI,yCAAA;AlByqgBZ;;AkBpqgBU;EAOI,yCAAA;AlBiqgBd;;AkBprgBQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBkrgBZ;;AkBzrgBQ;EAIQ,8BAAA;EAGJ,iGAAA;AlBurgBZ;;AkB9rgBQ;EAIQ,8BAAA;EAGJ,+FAAA;AlB4rgBZ;;AkBnsgBQ;EAIQ,8BAAA;EAGJ,4FAAA;AlBisgBZ;;AkBxsgBQ;EAIQ,8BAAA;EAGJ,+FAAA;AlBssgBZ;;AkB7sgBQ;EAIQ,8BAAA;EAGJ,8FAAA;AlB2sgBZ;;AkBltgBQ;EAIQ,8BAAA;EAGJ,6FAAA;AlBgtgBZ;;AkBvtgBQ;EAIQ,8BAAA;EAGJ,4FAAA;AlBqtgBZ;;AkB5tgBQ;EAIQ,8BAAA;EAGJ,qGAAA;AlB0tgBZ;;AkB3ugBQ;EACE,8BAAA;AlB8ugBV;;AkB1ugBU;EACE,8BAAA;AlB6ugBZ;;AkBnvgBQ;EACE,gCAAA;AlBsvgBV;;AkBlvgBU;EACE,gCAAA;AlBqvgBZ;;AkB3vgBQ;EACE,iCAAA;AlB8vgBV;;AkB1vgBU;EACE,iCAAA;AlB6vgBZ;;AkBnwgBQ;EACE,gCAAA;AlBswgBV;;AkBlwgBU;EACE,gCAAA;AlBqwgBZ;;AkB3wgBQ;EACE,iCAAA;AlB8wgBV;;AkB1wgBU;EACE,iCAAA;AlB6wgBZ;;AkBnxgBQ;EACE,8BAAA;AlBsxgBV;;AkBlxgBU;EACE,8BAAA;AlBqxgBZ;;AkBjxgBQ;EAIQ,kBAAA;EAGJ,8EAAA;AlB+wgBZ;;AkBtxgBQ;EAIQ,kBAAA;EAGJ,gFAAA;AlBoxgBZ;;AkB3xgBQ;EAIQ,kBAAA;EAGJ,8EAAA;AlByxgBZ;;AkBhygBQ;EAIQ,kBAAA;EAGJ,2EAAA;AlB8xgBZ;;AkBrygBQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBmygBZ;;AkB1ygBQ;EAIQ,kBAAA;EAGJ,6EAAA;AlBwygBZ;;AkB/ygBQ;EAIQ,kBAAA;EAGJ,4EAAA;AlB6ygBZ;;AkBpzgBQ;EAIQ,kBAAA;EAGJ,2EAAA;AlBkzgBZ;;AkBzzgBQ;EAIQ,kBAAA;EAGJ,4EAAA;AlBuzgBZ;;AkB9zgBQ;EAIQ,kBAAA;EAGJ,4EAAA;AlB4zgBZ;;AkBn0gBQ;EAIQ,kBAAA;EAGJ,8EAAA;AlBi0gBZ;;AkBx0gBQ;EAIQ,kBAAA;EAGJ,wCAAA;AlBs0gBZ;;AkB70gBQ;EAIQ,kBAAA;EAGJ,mFAAA;AlB20gBZ;;AkBl1gBQ;EAIQ,kBAAA;EAGJ,kFAAA;AlBg1gBZ;;AkBj2gBQ;EACE,oBAAA;AlBo2gBV;;AkBr2gBQ;EACE,qBAAA;AlBw2gBV;;AkBz2gBQ;EACE,oBAAA;AlB42gBV;;AkB72gBQ;EACE,qBAAA;AlBg3gBV;;AkBj3gBQ;EACE,kBAAA;AlBo3gBV;;AkB32gBQ;EAOI,wDAAA;AlBw2gBZ;;AkB/2gBQ;EAOI,0DAAA;AlB42gBZ;;AkBn3gBQ;EAOI,wDAAA;AlBg3gBZ;;AkBv3gBQ;EAOI,qDAAA;AlBo3gBZ;;AkB33gBQ;EAOI,wDAAA;AlBw3gBZ;;AkB/3gBQ;EAOI,uDAAA;AlB43gBZ;;AkBn4gBQ;EAOI,sDAAA;AlBg4gBZ;;AkBv4gBQ;EAOI,qDAAA;AlBo4gBZ;;AkB34gBQ;EAOI,+CAAA;AlBw4gBZ;;AkB/4gBQ;EAOI,mCAAA;UAAA,2BAAA;AlB44gBZ;;AkBn5gBQ;EAOI,oCAAA;UAAA,4BAAA;AlBg5gBZ;;AkBv5gBQ;EAOI,oCAAA;UAAA,4BAAA;AlBo5gBZ;;AkB35gBQ;EAOI,+BAAA;AlBw5gBZ;;AkB/5gBQ;EAOI,+BAAA;AlB45gBZ;;AkBn6gBQ;EAOI,iDAAA;AlBg6gBZ;;AkBv6gBQ;EAOI,2BAAA;AlBo6gBZ;;AkB36gBQ;EAOI,oDAAA;AlBw6gBZ;;AkB/6gBQ;EAOI,iDAAA;AlB46gBZ;;AkBn7gBQ;EAOI,oDAAA;AlBg7gBZ;;AkBv7gBQ;EAOI,oDAAA;AlBo7gBZ;;AkB37gBQ;EAOI,qDAAA;AlBw7gBZ;;AkB/7gBQ;EAOI,6BAAA;AlB47gBZ;;AkBn8gBQ;EAOI,sDAAA;AlBg8gBZ;;AkBv8gBQ;EAOI,0DAAA;EAAA,2DAAA;AlBq8gBZ;;AkB58gBQ;EAOI,oCAAA;EAAA,qCAAA;AlB08gBZ;;AkBj9gBQ;EAOI,6DAAA;EAAA,8DAAA;AlB+8gBZ;;AkBt9gBQ;EAOI,0DAAA;EAAA,2DAAA;AlBo9gBZ;;AkB39gBQ;EAOI,6DAAA;EAAA,8DAAA;AlBy9gBZ;;AkBh+gBQ;EAOI,6DAAA;EAAA,8DAAA;AlB89gBZ;;AkBr+gBQ;EAOI,8DAAA;EAAA,+DAAA;AlBm+gBZ;;AkB1+gBQ;EAOI,sCAAA;EAAA,uCAAA;AlBw+gBZ;;AkB/+gBQ;EAOI,+DAAA;EAAA,gEAAA;AlB6+gBZ;;AkBp/gBQ;EAOI,2DAAA;EAAA,8DAAA;AlBk/gBZ;;AkBz/gBQ;EAOI,qCAAA;EAAA,wCAAA;AlBu/gBZ;;AkB9/gBQ;EAOI,8DAAA;EAAA,iEAAA;AlB4/gBZ;;AkBnghBQ;EAOI,2DAAA;EAAA,8DAAA;AlBighBZ;;AkBxghBQ;EAOI,8DAAA;EAAA,iEAAA;AlBsghBZ;;AkB7ghBQ;EAOI,8DAAA;EAAA,iEAAA;AlB2ghBZ;;AkBlhhBQ;EAOI,+DAAA;EAAA,kEAAA;AlBghhBZ;;AkBvhhBQ;EAOI,uCAAA;EAAA,0CAAA;AlBqhhBZ;;AkB5hhBQ;EAOI,gEAAA;EAAA,mEAAA;AlB0hhBZ;;AkBjihBQ;EAOI,8DAAA;EAAA,6DAAA;AlB+hhBZ;;AkBtihBQ;EAOI,wCAAA;EAAA,uCAAA;AlBoihBZ;;AkB3ihBQ;EAOI,iEAAA;EAAA,gEAAA;AlByihBZ;;AkBhjhBQ;EAOI,8DAAA;EAAA,6DAAA;AlB8ihBZ;;AkBrjhBQ;EAOI,iEAAA;EAAA,gEAAA;AlBmjhBZ;;AkB1jhBQ;EAOI,iEAAA;EAAA,gEAAA;AlBwjhBZ;;AkB/jhBQ;EAOI,kEAAA;EAAA,iEAAA;AlB6jhBZ;;AkBpkhBQ;EAOI,0CAAA;EAAA,yCAAA;AlBkkhBZ;;AkBzkhBQ;EAOI,mEAAA;EAAA,kEAAA;AlBukhBZ;;AkB9khBQ;EAOI,6DAAA;EAAA,0DAAA;AlB4khBZ;;AkBnlhBQ;EAOI,uCAAA;EAAA,oCAAA;AlBilhBZ;;AkBxlhBQ;EAOI,gEAAA;EAAA,6DAAA;AlBslhBZ;;AkB7lhBQ;EAOI,6DAAA;EAAA,0DAAA;AlB2lhBZ;;AkBlmhBQ;EAOI,gEAAA;EAAA,6DAAA;AlBgmhBZ;;AkBvmhBQ;EAOI,gEAAA;EAAA,6DAAA;AlBqmhBZ;;AkB5mhBQ;EAOI,iEAAA;EAAA,8DAAA;AlB0mhBZ;;AkBjnhBQ;EAOI,yCAAA;EAAA,sCAAA;AlB+mhBZ;;AkBtnhBQ;EAOI,kEAAA;EAAA,+DAAA;AlBonhBZ;;AkB3nhBQ;EAOI,8BAAA;AlBwnhBZ;;AkB/nhBQ;EAOI,6BAAA;AlB4nhBZ;;AkBnohBQ;EAOI,sBAAA;AlBgohBZ;;AkBvohBQ;EAOI,qBAAA;AlBoohBZ;;AkB3ohBQ;EAOI,qBAAA;AlBwohBZ;;AkB/ohBQ;EAOI,qBAAA;AlB4ohBZ;;AkBnphBQ;EAOI,qBAAA;AlBgphBZ;;AU1phBI;EQGI;IAOI,sBAAA;ElBqphBV;EkB5phBM;IAOI,uBAAA;ElBwphBV;EkB/phBM;IAOI,sBAAA;ElB2phBV;EkBlqhBM;IAOI,8BAAA;ElB8phBV;EkBrqhBM;IAOI,4BAAA;ElBiqhBV;EkBxqhBM;IAOI,2BAAA;ElBoqhBV;EkB3qhBM;IAOI,iCAAA;ElBuqhBV;EkB9qhBM;IAOI,2BAAA;ElB0qhBV;EkBjrhBM;IAOI,0BAAA;ElB6qhBV;EkBprhBM;IAOI,gCAAA;ElBgrhBV;EkBvrhBM;IAOI,yBAAA;ElBmrhBV;EkB1rhBM;IAOI,wBAAA;ElBsrhBV;EkB7rhBM;IAOI,+BAAA;ElByrhBV;EkBhshBM;IAOI,yBAAA;ElB4rhBV;EkBnshBM;IAOI,6BAAA;ElB+rhBV;EkBtshBM;IAOI,8BAAA;ElBkshBV;EkBzshBM;IAOI,wBAAA;ElBqshBV;EkB5shBM;IAOI,+BAAA;ElBwshBV;EkB/shBM;IAOI,wBAAA;ElB2shBV;EkBlthBM;IAOI,yBAAA;ElB8shBV;EkBrthBM;IAOI,8BAAA;ElBithBV;EkBxthBM;IAOI,iCAAA;ElBothBV;EkB3thBM;IAOI,sCAAA;ElButhBV;EkB9thBM;IAOI,yCAAA;ElB0thBV;EkBjuhBM;IAOI,uBAAA;ElB6thBV;EkBpuhBM;IAOI,uBAAA;ElBguhBV;EkBvuhBM;IAOI,yBAAA;ElBmuhBV;EkB1uhBM;IAOI,yBAAA;ElBsuhBV;EkB7uhBM;IAOI,0BAAA;ElByuhBV;EkBhvhBM;IAOI,4BAAA;ElB4uhBV;EkBnvhBM;IAOI,kCAAA;ElB+uhBV;EkBtvhBM;IAOI,sCAAA;ElBkvhBV;EkBzvhBM;IAOI,oCAAA;ElBqvhBV;EkB5vhBM;IAOI,kCAAA;ElBwvhBV;EkB/vhBM;IAOI,yCAAA;ElB2vhBV;EkBlwhBM;IAOI,wCAAA;ElB8vhBV;EkBrwhBM;IAOI,wCAAA;ElBiwhBV;EkBxwhBM;IAOI,kCAAA;ElBowhBV;EkB3whBM;IAOI,gCAAA;ElBuwhBV;EkB9whBM;IAOI,8BAAA;ElB0whBV;EkBjxhBM;IAOI,gCAAA;ElB6whBV;EkBpxhBM;IAOI,+BAAA;ElBgxhBV;EkBvxhBM;IAOI,oCAAA;ElBmxhBV;EkB1xhBM;IAOI,kCAAA;ElBsxhBV;EkB7xhBM;IAOI,gCAAA;ElByxhBV;EkBhyhBM;IAOI,uCAAA;ElB4xhBV;EkBnyhBM;IAOI,sCAAA;ElB+xhBV;EkBtyhBM;IAOI,iCAAA;ElBkyhBV;EkBzyhBM;IAOI,2BAAA;ElBqyhBV;EkB5yhBM;IAOI,iCAAA;ElBwyhBV;EkB/yhBM;IAOI,+BAAA;ElB2yhBV;EkBlzhBM;IAOI,6BAAA;ElB8yhBV;EkBrzhBM;IAOI,+BAAA;ElBizhBV;EkBxzhBM;IAOI,8BAAA;ElBozhBV;EkB3zhBM;IAOI,oBAAA;ElBuzhBV;EkB9zhBM;IAOI,mBAAA;ElB0zhBV;EkBj0hBM;IAOI,mBAAA;ElB6zhBV;EkBp0hBM;IAOI,mBAAA;ElBg0hBV;EkBv0hBM;IAOI,mBAAA;ElBm0hBV;EkB10hBM;IAOI,mBAAA;ElBs0hBV;EkB70hBM;IAOI,mBAAA;ElBy0hBV;EkBh1hBM;IAOI,mBAAA;ElB40hBV;EkBn1hBM;IAOI,oBAAA;ElB+0hBV;EkBt1hBM;IAOI,0BAAA;ElBk1hBV;EkBz1hBM;IAOI,yBAAA;ElBq1hBV;EkB51hBM;IAOI,uBAAA;ElBw1hBV;EkB/1hBM;IAOI,yBAAA;ElB21hBV;EkBl2hBM;IAOI,uBAAA;ElB81hBV;EkBr2hBM;IAOI,uBAAA;ElBi2hBV;EkBx2hBM;IAOI,0BAAA;IAAA,yBAAA;ElBq2hBV;EkB52hBM;IAOI,gCAAA;IAAA,+BAAA;ElBy2hBV;EkBh3hBM;IAOI,+BAAA;IAAA,8BAAA;ElB62hBV;EkBp3hBM;IAOI,6BAAA;IAAA,4BAAA;ElBi3hBV;EkBx3hBM;IAOI,+BAAA;IAAA,8BAAA;ElBq3hBV;EkB53hBM;IAOI,6BAAA;IAAA,4BAAA;ElBy3hBV;EkBh4hBM;IAOI,6BAAA;IAAA,4BAAA;ElB63hBV;EkBp4hBM;IAOI,wBAAA;IAAA,2BAAA;ElBi4hBV;EkBx4hBM;IAOI,8BAAA;IAAA,iCAAA;ElBq4hBV;EkB54hBM;IAOI,6BAAA;IAAA,gCAAA;ElBy4hBV;EkBh5hBM;IAOI,2BAAA;IAAA,8BAAA;ElB64hBV;EkBp5hBM;IAOI,6BAAA;IAAA,gCAAA;ElBi5hBV;EkBx5hBM;IAOI,2BAAA;IAAA,8BAAA;ElBq5hBV;EkB55hBM;IAOI,2BAAA;IAAA,8BAAA;ElBy5hBV;EkBh6hBM;IAOI,wBAAA;ElB45hBV;EkBn6hBM;IAOI,8BAAA;ElB+5hBV;EkBt6hBM;IAOI,6BAAA;ElBk6hBV;EkBz6hBM;IAOI,2BAAA;ElBq6hBV;EkB56hBM;IAOI,6BAAA;ElBw6hBV;EkB/6hBM;IAOI,2BAAA;ElB26hBV;EkBl7hBM;IAOI,2BAAA;ElB86hBV;EkBr7hBM;IAOI,0BAAA;ElBi7hBV;EkBx7hBM;IAOI,gCAAA;ElBo7hBV;EkB37hBM;IAOI,+BAAA;ElBu7hBV;EkB97hBM;IAOI,6BAAA;ElB07hBV;EkBj8hBM;IAOI,+BAAA;ElB67hBV;EkBp8hBM;IAOI,6BAAA;ElBg8hBV;EkBv8hBM;IAOI,6BAAA;ElBm8hBV;EkB18hBM;IAOI,2BAAA;ElBs8hBV;EkB78hBM;IAOI,iCAAA;ElBy8hBV;EkBh9hBM;IAOI,gCAAA;ElB48hBV;EkBn9hBM;IAOI,8BAAA;ElB+8hBV;EkBt9hBM;IAOI,gCAAA;ElBk9hBV;EkBz9hBM;IAOI,8BAAA;ElBq9hBV;EkB59hBM;IAOI,8BAAA;ElBw9hBV;EkB/9hBM;IAOI,yBAAA;ElB29hBV;EkBl+hBM;IAOI,+BAAA;ElB89hBV;EkBr+hBM;IAOI,8BAAA;ElBi+hBV;EkBx+hBM;IAOI,4BAAA;ElBo+hBV;EkB3+hBM;IAOI,8BAAA;ElBu+hBV;EkB9+hBM;IAOI,4BAAA;ElB0+hBV;EkBj/hBM;IAOI,4BAAA;ElB6+hBV;EkBp/hBM;IAOI,qBAAA;ElBg/hBV;EkBv/hBM;IAOI,2BAAA;ElBm/hBV;EkB1/hBM;IAOI,0BAAA;ElBs/hBV;EkB7/hBM;IAOI,wBAAA;ElBy/hBV;EkBhgiBM;IAOI,0BAAA;ElB4/hBV;EkBngiBM;IAOI,wBAAA;ElB+/hBV;EkBtgiBM;IAOI,2BAAA;IAAA,0BAAA;ElBmgiBV;EkB1giBM;IAOI,iCAAA;IAAA,gCAAA;ElBugiBV;EkB9giBM;IAOI,gCAAA;IAAA,+BAAA;ElB2giBV;EkBlhiBM;IAOI,8BAAA;IAAA,6BAAA;ElB+giBV;EkBthiBM;IAOI,gCAAA;IAAA,+BAAA;ElBmhiBV;EkB1hiBM;IAOI,8BAAA;IAAA,6BAAA;ElBuhiBV;EkB9hiBM;IAOI,yBAAA;IAAA,4BAAA;ElB2hiBV;EkBliiBM;IAOI,+BAAA;IAAA,kCAAA;ElB+hiBV;EkBtiiBM;IAOI,8BAAA;IAAA,iCAAA;ElBmiiBV;EkB1iiBM;IAOI,4BAAA;IAAA,+BAAA;ElBuiiBV;EkB9iiBM;IAOI,8BAAA;IAAA,iCAAA;ElB2iiBV;EkBljiBM;IAOI,4BAAA;IAAA,+BAAA;ElB+iiBV;EkBtjiBM;IAOI,yBAAA;ElBkjiBV;EkBzjiBM;IAOI,+BAAA;ElBqjiBV;EkB5jiBM;IAOI,8BAAA;ElBwjiBV;EkB/jiBM;IAOI,4BAAA;ElB2jiBV;EkBlkiBM;IAOI,8BAAA;ElB8jiBV;EkBrkiBM;IAOI,4BAAA;ElBikiBV;EkBxkiBM;IAOI,2BAAA;ElBokiBV;EkB3kiBM;IAOI,iCAAA;ElBukiBV;EkB9kiBM;IAOI,gCAAA;ElB0kiBV;EkBjliBM;IAOI,8BAAA;ElB6kiBV;EkBpliBM;IAOI,gCAAA;ElBgliBV;EkBvliBM;IAOI,8BAAA;ElBmliBV;EkB1liBM;IAOI,4BAAA;ElBsliBV;EkB7liBM;IAOI,kCAAA;ElByliBV;EkBhmiBM;IAOI,iCAAA;ElB4liBV;EkBnmiBM;IAOI,+BAAA;ElB+liBV;EkBtmiBM;IAOI,iCAAA;ElBkmiBV;EkBzmiBM;IAOI,+BAAA;ElBqmiBV;EkB5miBM;IAOI,0BAAA;ElBwmiBV;EkB/miBM;IAOI,gCAAA;ElB2miBV;EkBlniBM;IAOI,+BAAA;ElB8miBV;EkBrniBM;IAOI,6BAAA;ElBiniBV;EkBxniBM;IAOI,+BAAA;ElBoniBV;EkB3niBM;IAOI,6BAAA;ElBuniBV;EkB9niBM;IAOI,iBAAA;ElB0niBV;EkBjoiBM;IAOI,uBAAA;ElB6niBV;EkBpoiBM;IAOI,sBAAA;ElBgoiBV;EkBvoiBM;IAOI,oBAAA;ElBmoiBV;EkB1oiBM;IAOI,sBAAA;ElBsoiBV;EkB7oiBM;IAOI,oBAAA;ElByoiBV;EkBhpiBM;IAOI,qBAAA;ElB4oiBV;EkBnpiBM;IAOI,2BAAA;ElB+oiBV;EkBtpiBM;IAOI,0BAAA;ElBkpiBV;EkBzpiBM;IAOI,wBAAA;ElBqpiBV;EkB5piBM;IAOI,0BAAA;ElBwpiBV;EkB/piBM;IAOI,wBAAA;ElB2piBV;EkBlqiBM;IAOI,wBAAA;ElB8piBV;EkBrqiBM;IAOI,8BAAA;ElBiqiBV;EkBxqiBM;IAOI,6BAAA;ElBoqiBV;EkB3qiBM;IAOI,2BAAA;ElBuqiBV;EkB9qiBM;IAOI,6BAAA;ElB0qiBV;EkBjriBM;IAOI,2BAAA;ElB6qiBV;EkBpriBM;IAOI,2BAAA;ElBgriBV;EkBvriBM;IAOI,4BAAA;ElBmriBV;EkB1riBM;IAOI,6BAAA;ElBsriBV;AACF;AUjsiBI;EQGI;IAOI,sBAAA;ElB2riBV;EkBlsiBM;IAOI,uBAAA;ElB8riBV;EkBrsiBM;IAOI,sBAAA;ElBisiBV;EkBxsiBM;IAOI,8BAAA;ElBosiBV;EkB3siBM;IAOI,4BAAA;ElBusiBV;EkB9siBM;IAOI,2BAAA;ElB0siBV;EkBjtiBM;IAOI,iCAAA;ElB6siBV;EkBptiBM;IAOI,2BAAA;ElBgtiBV;EkBvtiBM;IAOI,0BAAA;ElBmtiBV;EkB1tiBM;IAOI,gCAAA;ElBstiBV;EkB7tiBM;IAOI,yBAAA;ElBytiBV;EkBhuiBM;IAOI,wBAAA;ElB4tiBV;EkBnuiBM;IAOI,+BAAA;ElB+tiBV;EkBtuiBM;IAOI,yBAAA;ElBkuiBV;EkBzuiBM;IAOI,6BAAA;ElBquiBV;EkB5uiBM;IAOI,8BAAA;ElBwuiBV;EkB/uiBM;IAOI,wBAAA;ElB2uiBV;EkBlviBM;IAOI,+BAAA;ElB8uiBV;EkBrviBM;IAOI,wBAAA;ElBiviBV;EkBxviBM;IAOI,yBAAA;ElBoviBV;EkB3viBM;IAOI,8BAAA;ElBuviBV;EkB9viBM;IAOI,iCAAA;ElB0viBV;EkBjwiBM;IAOI,sCAAA;ElB6viBV;EkBpwiBM;IAOI,yCAAA;ElBgwiBV;EkBvwiBM;IAOI,uBAAA;ElBmwiBV;EkB1wiBM;IAOI,uBAAA;ElBswiBV;EkB7wiBM;IAOI,yBAAA;ElBywiBV;EkBhxiBM;IAOI,yBAAA;ElB4wiBV;EkBnxiBM;IAOI,0BAAA;ElB+wiBV;EkBtxiBM;IAOI,4BAAA;ElBkxiBV;EkBzxiBM;IAOI,kCAAA;ElBqxiBV;EkB5xiBM;IAOI,sCAAA;ElBwxiBV;EkB/xiBM;IAOI,oCAAA;ElB2xiBV;EkBlyiBM;IAOI,kCAAA;ElB8xiBV;EkBryiBM;IAOI,yCAAA;ElBiyiBV;EkBxyiBM;IAOI,wCAAA;ElBoyiBV;EkB3yiBM;IAOI,wCAAA;ElBuyiBV;EkB9yiBM;IAOI,kCAAA;ElB0yiBV;EkBjziBM;IAOI,gCAAA;ElB6yiBV;EkBpziBM;IAOI,8BAAA;ElBgziBV;EkBvziBM;IAOI,gCAAA;ElBmziBV;EkB1ziBM;IAOI,+BAAA;ElBsziBV;EkB7ziBM;IAOI,oCAAA;ElByziBV;EkBh0iBM;IAOI,kCAAA;ElB4ziBV;EkBn0iBM;IAOI,gCAAA;ElB+ziBV;EkBt0iBM;IAOI,uCAAA;ElBk0iBV;EkBz0iBM;IAOI,sCAAA;ElBq0iBV;EkB50iBM;IAOI,iCAAA;ElBw0iBV;EkB/0iBM;IAOI,2BAAA;ElB20iBV;EkBl1iBM;IAOI,iCAAA;ElB80iBV;EkBr1iBM;IAOI,+BAAA;ElBi1iBV;EkBx1iBM;IAOI,6BAAA;ElBo1iBV;EkB31iBM;IAOI,+BAAA;ElBu1iBV;EkB91iBM;IAOI,8BAAA;ElB01iBV;EkBj2iBM;IAOI,oBAAA;ElB61iBV;EkBp2iBM;IAOI,mBAAA;ElBg2iBV;EkBv2iBM;IAOI,mBAAA;ElBm2iBV;EkB12iBM;IAOI,mBAAA;ElBs2iBV;EkB72iBM;IAOI,mBAAA;ElBy2iBV;EkBh3iBM;IAOI,mBAAA;ElB42iBV;EkBn3iBM;IAOI,mBAAA;ElB+2iBV;EkBt3iBM;IAOI,mBAAA;ElBk3iBV;EkBz3iBM;IAOI,oBAAA;ElBq3iBV;EkB53iBM;IAOI,0BAAA;ElBw3iBV;EkB/3iBM;IAOI,yBAAA;ElB23iBV;EkBl4iBM;IAOI,uBAAA;ElB83iBV;EkBr4iBM;IAOI,yBAAA;ElBi4iBV;EkBx4iBM;IAOI,uBAAA;ElBo4iBV;EkB34iBM;IAOI,uBAAA;ElBu4iBV;EkB94iBM;IAOI,0BAAA;IAAA,yBAAA;ElB24iBV;EkBl5iBM;IAOI,gCAAA;IAAA,+BAAA;ElB+4iBV;EkBt5iBM;IAOI,+BAAA;IAAA,8BAAA;ElBm5iBV;EkB15iBM;IAOI,6BAAA;IAAA,4BAAA;ElBu5iBV;EkB95iBM;IAOI,+BAAA;IAAA,8BAAA;ElB25iBV;EkBl6iBM;IAOI,6BAAA;IAAA,4BAAA;ElB+5iBV;EkBt6iBM;IAOI,6BAAA;IAAA,4BAAA;ElBm6iBV;EkB16iBM;IAOI,wBAAA;IAAA,2BAAA;ElBu6iBV;EkB96iBM;IAOI,8BAAA;IAAA,iCAAA;ElB26iBV;EkBl7iBM;IAOI,6BAAA;IAAA,gCAAA;ElB+6iBV;EkBt7iBM;IAOI,2BAAA;IAAA,8BAAA;ElBm7iBV;EkB17iBM;IAOI,6BAAA;IAAA,gCAAA;ElBu7iBV;EkB97iBM;IAOI,2BAAA;IAAA,8BAAA;ElB27iBV;EkBl8iBM;IAOI,2BAAA;IAAA,8BAAA;ElB+7iBV;EkBt8iBM;IAOI,wBAAA;ElBk8iBV;EkBz8iBM;IAOI,8BAAA;ElBq8iBV;EkB58iBM;IAOI,6BAAA;ElBw8iBV;EkB/8iBM;IAOI,2BAAA;ElB28iBV;EkBl9iBM;IAOI,6BAAA;ElB88iBV;EkBr9iBM;IAOI,2BAAA;ElBi9iBV;EkBx9iBM;IAOI,2BAAA;ElBo9iBV;EkB39iBM;IAOI,0BAAA;ElBu9iBV;EkB99iBM;IAOI,gCAAA;ElB09iBV;EkBj+iBM;IAOI,+BAAA;ElB69iBV;EkBp+iBM;IAOI,6BAAA;ElBg+iBV;EkBv+iBM;IAOI,+BAAA;ElBm+iBV;EkB1+iBM;IAOI,6BAAA;ElBs+iBV;EkB7+iBM;IAOI,6BAAA;ElBy+iBV;EkBh/iBM;IAOI,2BAAA;ElB4+iBV;EkBn/iBM;IAOI,iCAAA;ElB++iBV;EkBt/iBM;IAOI,gCAAA;ElBk/iBV;EkBz/iBM;IAOI,8BAAA;ElBq/iBV;EkB5/iBM;IAOI,gCAAA;ElBw/iBV;EkB//iBM;IAOI,8BAAA;ElB2/iBV;EkBlgjBM;IAOI,8BAAA;ElB8/iBV;EkBrgjBM;IAOI,yBAAA;ElBigjBV;EkBxgjBM;IAOI,+BAAA;ElBogjBV;EkB3gjBM;IAOI,8BAAA;ElBugjBV;EkB9gjBM;IAOI,4BAAA;ElB0gjBV;EkBjhjBM;IAOI,8BAAA;ElB6gjBV;EkBphjBM;IAOI,4BAAA;ElBghjBV;EkBvhjBM;IAOI,4BAAA;ElBmhjBV;EkB1hjBM;IAOI,qBAAA;ElBshjBV;EkB7hjBM;IAOI,2BAAA;ElByhjBV;EkBhijBM;IAOI,0BAAA;ElB4hjBV;EkBnijBM;IAOI,wBAAA;ElB+hjBV;EkBtijBM;IAOI,0BAAA;ElBkijBV;EkBzijBM;IAOI,wBAAA;ElBqijBV;EkB5ijBM;IAOI,2BAAA;IAAA,0BAAA;ElByijBV;EkBhjjBM;IAOI,iCAAA;IAAA,gCAAA;ElB6ijBV;EkBpjjBM;IAOI,gCAAA;IAAA,+BAAA;ElBijjBV;EkBxjjBM;IAOI,8BAAA;IAAA,6BAAA;ElBqjjBV;EkB5jjBM;IAOI,gCAAA;IAAA,+BAAA;ElByjjBV;EkBhkjBM;IAOI,8BAAA;IAAA,6BAAA;ElB6jjBV;EkBpkjBM;IAOI,yBAAA;IAAA,4BAAA;ElBikjBV;EkBxkjBM;IAOI,+BAAA;IAAA,kCAAA;ElBqkjBV;EkB5kjBM;IAOI,8BAAA;IAAA,iCAAA;ElBykjBV;EkBhljBM;IAOI,4BAAA;IAAA,+BAAA;ElB6kjBV;EkBpljBM;IAOI,8BAAA;IAAA,iCAAA;ElBiljBV;EkBxljBM;IAOI,4BAAA;IAAA,+BAAA;ElBqljBV;EkB5ljBM;IAOI,yBAAA;ElBwljBV;EkB/ljBM;IAOI,+BAAA;ElB2ljBV;EkBlmjBM;IAOI,8BAAA;ElB8ljBV;EkBrmjBM;IAOI,4BAAA;ElBimjBV;EkBxmjBM;IAOI,8BAAA;ElBomjBV;EkB3mjBM;IAOI,4BAAA;ElBumjBV;EkB9mjBM;IAOI,2BAAA;ElB0mjBV;EkBjnjBM;IAOI,iCAAA;ElB6mjBV;EkBpnjBM;IAOI,gCAAA;ElBgnjBV;EkBvnjBM;IAOI,8BAAA;ElBmnjBV;EkB1njBM;IAOI,gCAAA;ElBsnjBV;EkB7njBM;IAOI,8BAAA;ElBynjBV;EkBhojBM;IAOI,4BAAA;ElB4njBV;EkBnojBM;IAOI,kCAAA;ElB+njBV;EkBtojBM;IAOI,iCAAA;ElBkojBV;EkBzojBM;IAOI,+BAAA;ElBqojBV;EkB5ojBM;IAOI,iCAAA;ElBwojBV;EkB/ojBM;IAOI,+BAAA;ElB2ojBV;EkBlpjBM;IAOI,0BAAA;ElB8ojBV;EkBrpjBM;IAOI,gCAAA;ElBipjBV;EkBxpjBM;IAOI,+BAAA;ElBopjBV;EkB3pjBM;IAOI,6BAAA;ElBupjBV;EkB9pjBM;IAOI,+BAAA;ElB0pjBV;EkBjqjBM;IAOI,6BAAA;ElB6pjBV;EkBpqjBM;IAOI,iBAAA;ElBgqjBV;EkBvqjBM;IAOI,uBAAA;ElBmqjBV;EkB1qjBM;IAOI,sBAAA;ElBsqjBV;EkB7qjBM;IAOI,oBAAA;ElByqjBV;EkBhrjBM;IAOI,sBAAA;ElB4qjBV;EkBnrjBM;IAOI,oBAAA;ElB+qjBV;EkBtrjBM;IAOI,qBAAA;ElBkrjBV;EkBzrjBM;IAOI,2BAAA;ElBqrjBV;EkB5rjBM;IAOI,0BAAA;ElBwrjBV;EkB/rjBM;IAOI,wBAAA;ElB2rjBV;EkBlsjBM;IAOI,0BAAA;ElB8rjBV;EkBrsjBM;IAOI,wBAAA;ElBisjBV;EkBxsjBM;IAOI,wBAAA;ElBosjBV;EkB3sjBM;IAOI,8BAAA;ElBusjBV;EkB9sjBM;IAOI,6BAAA;ElB0sjBV;EkBjtjBM;IAOI,2BAAA;ElB6sjBV;EkBptjBM;IAOI,6BAAA;ElBgtjBV;EkBvtjBM;IAOI,2BAAA;ElBmtjBV;EkB1tjBM;IAOI,2BAAA;ElBstjBV;EkB7tjBM;IAOI,4BAAA;ElBytjBV;EkBhujBM;IAOI,6BAAA;ElB4tjBV;AACF;AUvujBI;EQGI;IAOI,sBAAA;ElBiujBV;EkBxujBM;IAOI,uBAAA;ElBoujBV;EkB3ujBM;IAOI,sBAAA;ElBuujBV;EkB9ujBM;IAOI,8BAAA;ElB0ujBV;EkBjvjBM;IAOI,4BAAA;ElB6ujBV;EkBpvjBM;IAOI,2BAAA;ElBgvjBV;EkBvvjBM;IAOI,iCAAA;ElBmvjBV;EkB1vjBM;IAOI,2BAAA;ElBsvjBV;EkB7vjBM;IAOI,0BAAA;ElByvjBV;EkBhwjBM;IAOI,gCAAA;ElB4vjBV;EkBnwjBM;IAOI,yBAAA;ElB+vjBV;EkBtwjBM;IAOI,wBAAA;ElBkwjBV;EkBzwjBM;IAOI,+BAAA;ElBqwjBV;EkB5wjBM;IAOI,yBAAA;ElBwwjBV;EkB/wjBM;IAOI,6BAAA;ElB2wjBV;EkBlxjBM;IAOI,8BAAA;ElB8wjBV;EkBrxjBM;IAOI,wBAAA;ElBixjBV;EkBxxjBM;IAOI,+BAAA;ElBoxjBV;EkB3xjBM;IAOI,wBAAA;ElBuxjBV;EkB9xjBM;IAOI,yBAAA;ElB0xjBV;EkBjyjBM;IAOI,8BAAA;ElB6xjBV;EkBpyjBM;IAOI,iCAAA;ElBgyjBV;EkBvyjBM;IAOI,sCAAA;ElBmyjBV;EkB1yjBM;IAOI,yCAAA;ElBsyjBV;EkB7yjBM;IAOI,uBAAA;ElByyjBV;EkBhzjBM;IAOI,uBAAA;ElB4yjBV;EkBnzjBM;IAOI,yBAAA;ElB+yjBV;EkBtzjBM;IAOI,yBAAA;ElBkzjBV;EkBzzjBM;IAOI,0BAAA;ElBqzjBV;EkB5zjBM;IAOI,4BAAA;ElBwzjBV;EkB/zjBM;IAOI,kCAAA;ElB2zjBV;EkBl0jBM;IAOI,sCAAA;ElB8zjBV;EkBr0jBM;IAOI,oCAAA;ElBi0jBV;EkBx0jBM;IAOI,kCAAA;ElBo0jBV;EkB30jBM;IAOI,yCAAA;ElBu0jBV;EkB90jBM;IAOI,wCAAA;ElB00jBV;EkBj1jBM;IAOI,wCAAA;ElB60jBV;EkBp1jBM;IAOI,kCAAA;ElBg1jBV;EkBv1jBM;IAOI,gCAAA;ElBm1jBV;EkB11jBM;IAOI,8BAAA;ElBs1jBV;EkB71jBM;IAOI,gCAAA;ElBy1jBV;EkBh2jBM;IAOI,+BAAA;ElB41jBV;EkBn2jBM;IAOI,oCAAA;ElB+1jBV;EkBt2jBM;IAOI,kCAAA;ElBk2jBV;EkBz2jBM;IAOI,gCAAA;ElBq2jBV;EkB52jBM;IAOI,uCAAA;ElBw2jBV;EkB/2jBM;IAOI,sCAAA;ElB22jBV;EkBl3jBM;IAOI,iCAAA;ElB82jBV;EkBr3jBM;IAOI,2BAAA;ElBi3jBV;EkBx3jBM;IAOI,iCAAA;ElBo3jBV;EkB33jBM;IAOI,+BAAA;ElBu3jBV;EkB93jBM;IAOI,6BAAA;ElB03jBV;EkBj4jBM;IAOI,+BAAA;ElB63jBV;EkBp4jBM;IAOI,8BAAA;ElBg4jBV;EkBv4jBM;IAOI,oBAAA;ElBm4jBV;EkB14jBM;IAOI,mBAAA;ElBs4jBV;EkB74jBM;IAOI,mBAAA;ElBy4jBV;EkBh5jBM;IAOI,mBAAA;ElB44jBV;EkBn5jBM;IAOI,mBAAA;ElB+4jBV;EkBt5jBM;IAOI,mBAAA;ElBk5jBV;EkBz5jBM;IAOI,mBAAA;ElBq5jBV;EkB55jBM;IAOI,mBAAA;ElBw5jBV;EkB/5jBM;IAOI,oBAAA;ElB25jBV;EkBl6jBM;IAOI,0BAAA;ElB85jBV;EkBr6jBM;IAOI,yBAAA;ElBi6jBV;EkBx6jBM;IAOI,uBAAA;ElBo6jBV;EkB36jBM;IAOI,yBAAA;ElBu6jBV;EkB96jBM;IAOI,uBAAA;ElB06jBV;EkBj7jBM;IAOI,uBAAA;ElB66jBV;EkBp7jBM;IAOI,0BAAA;IAAA,yBAAA;ElBi7jBV;EkBx7jBM;IAOI,gCAAA;IAAA,+BAAA;ElBq7jBV;EkB57jBM;IAOI,+BAAA;IAAA,8BAAA;ElBy7jBV;EkBh8jBM;IAOI,6BAAA;IAAA,4BAAA;ElB67jBV;EkBp8jBM;IAOI,+BAAA;IAAA,8BAAA;ElBi8jBV;EkBx8jBM;IAOI,6BAAA;IAAA,4BAAA;ElBq8jBV;EkB58jBM;IAOI,6BAAA;IAAA,4BAAA;ElBy8jBV;EkBh9jBM;IAOI,wBAAA;IAAA,2BAAA;ElB68jBV;EkBp9jBM;IAOI,8BAAA;IAAA,iCAAA;ElBi9jBV;EkBx9jBM;IAOI,6BAAA;IAAA,gCAAA;ElBq9jBV;EkB59jBM;IAOI,2BAAA;IAAA,8BAAA;ElBy9jBV;EkBh+jBM;IAOI,6BAAA;IAAA,gCAAA;ElB69jBV;EkBp+jBM;IAOI,2BAAA;IAAA,8BAAA;ElBi+jBV;EkBx+jBM;IAOI,2BAAA;IAAA,8BAAA;ElBq+jBV;EkB5+jBM;IAOI,wBAAA;ElBw+jBV;EkB/+jBM;IAOI,8BAAA;ElB2+jBV;EkBl/jBM;IAOI,6BAAA;ElB8+jBV;EkBr/jBM;IAOI,2BAAA;ElBi/jBV;EkBx/jBM;IAOI,6BAAA;ElBo/jBV;EkB3/jBM;IAOI,2BAAA;ElBu/jBV;EkB9/jBM;IAOI,2BAAA;ElB0/jBV;EkBjgkBM;IAOI,0BAAA;ElB6/jBV;EkBpgkBM;IAOI,gCAAA;ElBggkBV;EkBvgkBM;IAOI,+BAAA;ElBmgkBV;EkB1gkBM;IAOI,6BAAA;ElBsgkBV;EkB7gkBM;IAOI,+BAAA;ElBygkBV;EkBhhkBM;IAOI,6BAAA;ElB4gkBV;EkBnhkBM;IAOI,6BAAA;ElB+gkBV;EkBthkBM;IAOI,2BAAA;ElBkhkBV;EkBzhkBM;IAOI,iCAAA;ElBqhkBV;EkB5hkBM;IAOI,gCAAA;ElBwhkBV;EkB/hkBM;IAOI,8BAAA;ElB2hkBV;EkBlikBM;IAOI,gCAAA;ElB8hkBV;EkBrikBM;IAOI,8BAAA;ElBiikBV;EkBxikBM;IAOI,8BAAA;ElBoikBV;EkB3ikBM;IAOI,yBAAA;ElBuikBV;EkB9ikBM;IAOI,+BAAA;ElB0ikBV;EkBjjkBM;IAOI,8BAAA;ElB6ikBV;EkBpjkBM;IAOI,4BAAA;ElBgjkBV;EkBvjkBM;IAOI,8BAAA;ElBmjkBV;EkB1jkBM;IAOI,4BAAA;ElBsjkBV;EkB7jkBM;IAOI,4BAAA;ElByjkBV;EkBhkkBM;IAOI,qBAAA;ElB4jkBV;EkBnkkBM;IAOI,2BAAA;ElB+jkBV;EkBtkkBM;IAOI,0BAAA;ElBkkkBV;EkBzkkBM;IAOI,wBAAA;ElBqkkBV;EkB5kkBM;IAOI,0BAAA;ElBwkkBV;EkB/kkBM;IAOI,wBAAA;ElB2kkBV;EkBllkBM;IAOI,2BAAA;IAAA,0BAAA;ElB+kkBV;EkBtlkBM;IAOI,iCAAA;IAAA,gCAAA;ElBmlkBV;EkB1lkBM;IAOI,gCAAA;IAAA,+BAAA;ElBulkBV;EkB9lkBM;IAOI,8BAAA;IAAA,6BAAA;ElB2lkBV;EkBlmkBM;IAOI,gCAAA;IAAA,+BAAA;ElB+lkBV;EkBtmkBM;IAOI,8BAAA;IAAA,6BAAA;ElBmmkBV;EkB1mkBM;IAOI,yBAAA;IAAA,4BAAA;ElBumkBV;EkB9mkBM;IAOI,+BAAA;IAAA,kCAAA;ElB2mkBV;EkBlnkBM;IAOI,8BAAA;IAAA,iCAAA;ElB+mkBV;EkBtnkBM;IAOI,4BAAA;IAAA,+BAAA;ElBmnkBV;EkB1nkBM;IAOI,8BAAA;IAAA,iCAAA;ElBunkBV;EkB9nkBM;IAOI,4BAAA;IAAA,+BAAA;ElB2nkBV;EkBlokBM;IAOI,yBAAA;ElB8nkBV;EkBrokBM;IAOI,+BAAA;ElBiokBV;EkBxokBM;IAOI,8BAAA;ElBookBV;EkB3okBM;IAOI,4BAAA;ElBuokBV;EkB9okBM;IAOI,8BAAA;ElB0okBV;EkBjpkBM;IAOI,4BAAA;ElB6okBV;EkBppkBM;IAOI,2BAAA;ElBgpkBV;EkBvpkBM;IAOI,iCAAA;ElBmpkBV;EkB1pkBM;IAOI,gCAAA;ElBspkBV;EkB7pkBM;IAOI,8BAAA;ElBypkBV;EkBhqkBM;IAOI,gCAAA;ElB4pkBV;EkBnqkBM;IAOI,8BAAA;ElB+pkBV;EkBtqkBM;IAOI,4BAAA;ElBkqkBV;EkBzqkBM;IAOI,kCAAA;ElBqqkBV;EkB5qkBM;IAOI,iCAAA;ElBwqkBV;EkB/qkBM;IAOI,+BAAA;ElB2qkBV;EkBlrkBM;IAOI,iCAAA;ElB8qkBV;EkBrrkBM;IAOI,+BAAA;ElBirkBV;EkBxrkBM;IAOI,0BAAA;ElBorkBV;EkB3rkBM;IAOI,gCAAA;ElBurkBV;EkB9rkBM;IAOI,+BAAA;ElB0rkBV;EkBjskBM;IAOI,6BAAA;ElB6rkBV;EkBpskBM;IAOI,+BAAA;ElBgskBV;EkBvskBM;IAOI,6BAAA;ElBmskBV;EkB1skBM;IAOI,iBAAA;ElBsskBV;EkB7skBM;IAOI,uBAAA;ElByskBV;EkBhtkBM;IAOI,sBAAA;ElB4skBV;EkBntkBM;IAOI,oBAAA;ElB+skBV;EkBttkBM;IAOI,sBAAA;ElBktkBV;EkBztkBM;IAOI,oBAAA;ElBqtkBV;EkB5tkBM;IAOI,qBAAA;ElBwtkBV;EkB/tkBM;IAOI,2BAAA;ElB2tkBV;EkBlukBM;IAOI,0BAAA;ElB8tkBV;EkBrukBM;IAOI,wBAAA;ElBiukBV;EkBxukBM;IAOI,0BAAA;ElBoukBV;EkB3ukBM;IAOI,wBAAA;ElBuukBV;EkB9ukBM;IAOI,wBAAA;ElB0ukBV;EkBjvkBM;IAOI,8BAAA;ElB6ukBV;EkBpvkBM;IAOI,6BAAA;ElBgvkBV;EkBvvkBM;IAOI,2BAAA;ElBmvkBV;EkB1vkBM;IAOI,6BAAA;ElBsvkBV;EkB7vkBM;IAOI,2BAAA;ElByvkBV;EkBhwkBM;IAOI,2BAAA;ElB4vkBV;EkBnwkBM;IAOI,4BAAA;ElB+vkBV;EkBtwkBM;IAOI,6BAAA;ElBkwkBV;AACF;AU7wkBI;EQGI;IAOI,sBAAA;ElBuwkBV;EkB9wkBM;IAOI,uBAAA;ElB0wkBV;EkBjxkBM;IAOI,sBAAA;ElB6wkBV;EkBpxkBM;IAOI,8BAAA;ElBgxkBV;EkBvxkBM;IAOI,4BAAA;ElBmxkBV;EkB1xkBM;IAOI,2BAAA;ElBsxkBV;EkB7xkBM;IAOI,iCAAA;ElByxkBV;EkBhykBM;IAOI,2BAAA;ElB4xkBV;EkBnykBM;IAOI,0BAAA;ElB+xkBV;EkBtykBM;IAOI,gCAAA;ElBkykBV;EkBzykBM;IAOI,yBAAA;ElBqykBV;EkB5ykBM;IAOI,wBAAA;ElBwykBV;EkB/ykBM;IAOI,+BAAA;ElB2ykBV;EkBlzkBM;IAOI,yBAAA;ElB8ykBV;EkBrzkBM;IAOI,6BAAA;ElBizkBV;EkBxzkBM;IAOI,8BAAA;ElBozkBV;EkB3zkBM;IAOI,wBAAA;ElBuzkBV;EkB9zkBM;IAOI,+BAAA;ElB0zkBV;EkBj0kBM;IAOI,wBAAA;ElB6zkBV;EkBp0kBM;IAOI,yBAAA;ElBg0kBV;EkBv0kBM;IAOI,8BAAA;ElBm0kBV;EkB10kBM;IAOI,iCAAA;ElBs0kBV;EkB70kBM;IAOI,sCAAA;ElBy0kBV;EkBh1kBM;IAOI,yCAAA;ElB40kBV;EkBn1kBM;IAOI,uBAAA;ElB+0kBV;EkBt1kBM;IAOI,uBAAA;ElBk1kBV;EkBz1kBM;IAOI,yBAAA;ElBq1kBV;EkB51kBM;IAOI,yBAAA;ElBw1kBV;EkB/1kBM;IAOI,0BAAA;ElB21kBV;EkBl2kBM;IAOI,4BAAA;ElB81kBV;EkBr2kBM;IAOI,kCAAA;ElBi2kBV;EkBx2kBM;IAOI,sCAAA;ElBo2kBV;EkB32kBM;IAOI,oCAAA;ElBu2kBV;EkB92kBM;IAOI,kCAAA;ElB02kBV;EkBj3kBM;IAOI,yCAAA;ElB62kBV;EkBp3kBM;IAOI,wCAAA;ElBg3kBV;EkBv3kBM;IAOI,wCAAA;ElBm3kBV;EkB13kBM;IAOI,kCAAA;ElBs3kBV;EkB73kBM;IAOI,gCAAA;ElBy3kBV;EkBh4kBM;IAOI,8BAAA;ElB43kBV;EkBn4kBM;IAOI,gCAAA;ElB+3kBV;EkBt4kBM;IAOI,+BAAA;ElBk4kBV;EkBz4kBM;IAOI,oCAAA;ElBq4kBV;EkB54kBM;IAOI,kCAAA;ElBw4kBV;EkB/4kBM;IAOI,gCAAA;ElB24kBV;EkBl5kBM;IAOI,uCAAA;ElB84kBV;EkBr5kBM;IAOI,sCAAA;ElBi5kBV;EkBx5kBM;IAOI,iCAAA;ElBo5kBV;EkB35kBM;IAOI,2BAAA;ElBu5kBV;EkB95kBM;IAOI,iCAAA;ElB05kBV;EkBj6kBM;IAOI,+BAAA;ElB65kBV;EkBp6kBM;IAOI,6BAAA;ElBg6kBV;EkBv6kBM;IAOI,+BAAA;ElBm6kBV;EkB16kBM;IAOI,8BAAA;ElBs6kBV;EkB76kBM;IAOI,oBAAA;ElBy6kBV;EkBh7kBM;IAOI,mBAAA;ElB46kBV;EkBn7kBM;IAOI,mBAAA;ElB+6kBV;EkBt7kBM;IAOI,mBAAA;ElBk7kBV;EkBz7kBM;IAOI,mBAAA;ElBq7kBV;EkB57kBM;IAOI,mBAAA;ElBw7kBV;EkB/7kBM;IAOI,mBAAA;ElB27kBV;EkBl8kBM;IAOI,mBAAA;ElB87kBV;EkBr8kBM;IAOI,oBAAA;ElBi8kBV;EkBx8kBM;IAOI,0BAAA;ElBo8kBV;EkB38kBM;IAOI,yBAAA;ElBu8kBV;EkB98kBM;IAOI,uBAAA;ElB08kBV;EkBj9kBM;IAOI,yBAAA;ElB68kBV;EkBp9kBM;IAOI,uBAAA;ElBg9kBV;EkBv9kBM;IAOI,uBAAA;ElBm9kBV;EkB19kBM;IAOI,0BAAA;IAAA,yBAAA;ElBu9kBV;EkB99kBM;IAOI,gCAAA;IAAA,+BAAA;ElB29kBV;EkBl+kBM;IAOI,+BAAA;IAAA,8BAAA;ElB+9kBV;EkBt+kBM;IAOI,6BAAA;IAAA,4BAAA;ElBm+kBV;EkB1+kBM;IAOI,+BAAA;IAAA,8BAAA;ElBu+kBV;EkB9+kBM;IAOI,6BAAA;IAAA,4BAAA;ElB2+kBV;EkBl/kBM;IAOI,6BAAA;IAAA,4BAAA;ElB++kBV;EkBt/kBM;IAOI,wBAAA;IAAA,2BAAA;ElBm/kBV;EkB1/kBM;IAOI,8BAAA;IAAA,iCAAA;ElBu/kBV;EkB9/kBM;IAOI,6BAAA;IAAA,gCAAA;ElB2/kBV;EkBlglBM;IAOI,2BAAA;IAAA,8BAAA;ElB+/kBV;EkBtglBM;IAOI,6BAAA;IAAA,gCAAA;ElBmglBV;EkB1glBM;IAOI,2BAAA;IAAA,8BAAA;ElBuglBV;EkB9glBM;IAOI,2BAAA;IAAA,8BAAA;ElB2glBV;EkBlhlBM;IAOI,wBAAA;ElB8glBV;EkBrhlBM;IAOI,8BAAA;ElBihlBV;EkBxhlBM;IAOI,6BAAA;ElBohlBV;EkB3hlBM;IAOI,2BAAA;ElBuhlBV;EkB9hlBM;IAOI,6BAAA;ElB0hlBV;EkBjilBM;IAOI,2BAAA;ElB6hlBV;EkBpilBM;IAOI,2BAAA;ElBgilBV;EkBvilBM;IAOI,0BAAA;ElBmilBV;EkB1ilBM;IAOI,gCAAA;ElBsilBV;EkB7ilBM;IAOI,+BAAA;ElByilBV;EkBhjlBM;IAOI,6BAAA;ElB4ilBV;EkBnjlBM;IAOI,+BAAA;ElB+ilBV;EkBtjlBM;IAOI,6BAAA;ElBkjlBV;EkBzjlBM;IAOI,6BAAA;ElBqjlBV;EkB5jlBM;IAOI,2BAAA;ElBwjlBV;EkB/jlBM;IAOI,iCAAA;ElB2jlBV;EkBlklBM;IAOI,gCAAA;ElB8jlBV;EkBrklBM;IAOI,8BAAA;ElBiklBV;EkBxklBM;IAOI,gCAAA;ElBoklBV;EkB3klBM;IAOI,8BAAA;ElBuklBV;EkB9klBM;IAOI,8BAAA;ElB0klBV;EkBjllBM;IAOI,yBAAA;ElB6klBV;EkBpllBM;IAOI,+BAAA;ElBgllBV;EkBvllBM;IAOI,8BAAA;ElBmllBV;EkB1llBM;IAOI,4BAAA;ElBsllBV;EkB7llBM;IAOI,8BAAA;ElByllBV;EkBhmlBM;IAOI,4BAAA;ElB4llBV;EkBnmlBM;IAOI,4BAAA;ElB+llBV;EkBtmlBM;IAOI,qBAAA;ElBkmlBV;EkBzmlBM;IAOI,2BAAA;ElBqmlBV;EkB5mlBM;IAOI,0BAAA;ElBwmlBV;EkB/mlBM;IAOI,wBAAA;ElB2mlBV;EkBlnlBM;IAOI,0BAAA;ElB8mlBV;EkBrnlBM;IAOI,wBAAA;ElBinlBV;EkBxnlBM;IAOI,2BAAA;IAAA,0BAAA;ElBqnlBV;EkB5nlBM;IAOI,iCAAA;IAAA,gCAAA;ElBynlBV;EkBholBM;IAOI,gCAAA;IAAA,+BAAA;ElB6nlBV;EkBpolBM;IAOI,8BAAA;IAAA,6BAAA;ElBiolBV;EkBxolBM;IAOI,gCAAA;IAAA,+BAAA;ElBqolBV;EkB5olBM;IAOI,8BAAA;IAAA,6BAAA;ElByolBV;EkBhplBM;IAOI,yBAAA;IAAA,4BAAA;ElB6olBV;EkBpplBM;IAOI,+BAAA;IAAA,kCAAA;ElBiplBV;EkBxplBM;IAOI,8BAAA;IAAA,iCAAA;ElBqplBV;EkB5plBM;IAOI,4BAAA;IAAA,+BAAA;ElByplBV;EkBhqlBM;IAOI,8BAAA;IAAA,iCAAA;ElB6plBV;EkBpqlBM;IAOI,4BAAA;IAAA,+BAAA;ElBiqlBV;EkBxqlBM;IAOI,yBAAA;ElBoqlBV;EkB3qlBM;IAOI,+BAAA;ElBuqlBV;EkB9qlBM;IAOI,8BAAA;ElB0qlBV;EkBjrlBM;IAOI,4BAAA;ElB6qlBV;EkBprlBM;IAOI,8BAAA;ElBgrlBV;EkBvrlBM;IAOI,4BAAA;ElBmrlBV;EkB1rlBM;IAOI,2BAAA;ElBsrlBV;EkB7rlBM;IAOI,iCAAA;ElByrlBV;EkBhslBM;IAOI,gCAAA;ElB4rlBV;EkBnslBM;IAOI,8BAAA;ElB+rlBV;EkBtslBM;IAOI,gCAAA;ElBkslBV;EkBzslBM;IAOI,8BAAA;ElBqslBV;EkB5slBM;IAOI,4BAAA;ElBwslBV;EkB/slBM;IAOI,kCAAA;ElB2slBV;EkBltlBM;IAOI,iCAAA;ElB8slBV;EkBrtlBM;IAOI,+BAAA;ElBitlBV;EkBxtlBM;IAOI,iCAAA;ElBotlBV;EkB3tlBM;IAOI,+BAAA;ElButlBV;EkB9tlBM;IAOI,0BAAA;ElB0tlBV;EkBjulBM;IAOI,gCAAA;ElB6tlBV;EkBpulBM;IAOI,+BAAA;ElBgulBV;EkBvulBM;IAOI,6BAAA;ElBmulBV;EkB1ulBM;IAOI,+BAAA;ElBsulBV;EkB7ulBM;IAOI,6BAAA;ElByulBV;EkBhvlBM;IAOI,iBAAA;ElB4ulBV;EkBnvlBM;IAOI,uBAAA;ElB+ulBV;EkBtvlBM;IAOI,sBAAA;ElBkvlBV;EkBzvlBM;IAOI,oBAAA;ElBqvlBV;EkB5vlBM;IAOI,sBAAA;ElBwvlBV;EkB/vlBM;IAOI,oBAAA;ElB2vlBV;EkBlwlBM;IAOI,qBAAA;ElB8vlBV;EkBrwlBM;IAOI,2BAAA;ElBiwlBV;EkBxwlBM;IAOI,0BAAA;ElBowlBV;EkB3wlBM;IAOI,wBAAA;ElBuwlBV;EkB9wlBM;IAOI,0BAAA;ElB0wlBV;EkBjxlBM;IAOI,wBAAA;ElB6wlBV;EkBpxlBM;IAOI,wBAAA;ElBgxlBV;EkBvxlBM;IAOI,8BAAA;ElBmxlBV;EkB1xlBM;IAOI,6BAAA;ElBsxlBV;EkB7xlBM;IAOI,2BAAA;ElByxlBV;EkBhylBM;IAOI,6BAAA;ElB4xlBV;EkBnylBM;IAOI,2BAAA;ElB+xlBV;EkBtylBM;IAOI,2BAAA;ElBkylBV;EkBzylBM;IAOI,4BAAA;ElBqylBV;EkB5ylBM;IAOI,6BAAA;ElBwylBV;AACF;AUnzlBI;EQGI;IAOI,sBAAA;ElB6ylBV;EkBpzlBM;IAOI,uBAAA;ElBgzlBV;EkBvzlBM;IAOI,sBAAA;ElBmzlBV;EkB1zlBM;IAOI,8BAAA;ElBszlBV;EkB7zlBM;IAOI,4BAAA;ElByzlBV;EkBh0lBM;IAOI,2BAAA;ElB4zlBV;EkBn0lBM;IAOI,iCAAA;ElB+zlBV;EkBt0lBM;IAOI,2BAAA;ElBk0lBV;EkBz0lBM;IAOI,0BAAA;ElBq0lBV;EkB50lBM;IAOI,gCAAA;ElBw0lBV;EkB/0lBM;IAOI,yBAAA;ElB20lBV;EkBl1lBM;IAOI,wBAAA;ElB80lBV;EkBr1lBM;IAOI,+BAAA;ElBi1lBV;EkBx1lBM;IAOI,yBAAA;ElBo1lBV;EkB31lBM;IAOI,6BAAA;ElBu1lBV;EkB91lBM;IAOI,8BAAA;ElB01lBV;EkBj2lBM;IAOI,wBAAA;ElB61lBV;EkBp2lBM;IAOI,+BAAA;ElBg2lBV;EkBv2lBM;IAOI,wBAAA;ElBm2lBV;EkB12lBM;IAOI,yBAAA;ElBs2lBV;EkB72lBM;IAOI,8BAAA;ElBy2lBV;EkBh3lBM;IAOI,iCAAA;ElB42lBV;EkBn3lBM;IAOI,sCAAA;ElB+2lBV;EkBt3lBM;IAOI,yCAAA;ElBk3lBV;EkBz3lBM;IAOI,uBAAA;ElBq3lBV;EkB53lBM;IAOI,uBAAA;ElBw3lBV;EkB/3lBM;IAOI,yBAAA;ElB23lBV;EkBl4lBM;IAOI,yBAAA;ElB83lBV;EkBr4lBM;IAOI,0BAAA;ElBi4lBV;EkBx4lBM;IAOI,4BAAA;ElBo4lBV;EkB34lBM;IAOI,kCAAA;ElBu4lBV;EkB94lBM;IAOI,sCAAA;ElB04lBV;EkBj5lBM;IAOI,oCAAA;ElB64lBV;EkBp5lBM;IAOI,kCAAA;ElBg5lBV;EkBv5lBM;IAOI,yCAAA;ElBm5lBV;EkB15lBM;IAOI,wCAAA;ElBs5lBV;EkB75lBM;IAOI,wCAAA;ElBy5lBV;EkBh6lBM;IAOI,kCAAA;ElB45lBV;EkBn6lBM;IAOI,gCAAA;ElB+5lBV;EkBt6lBM;IAOI,8BAAA;ElBk6lBV;EkBz6lBM;IAOI,gCAAA;ElBq6lBV;EkB56lBM;IAOI,+BAAA;ElBw6lBV;EkB/6lBM;IAOI,oCAAA;ElB26lBV;EkBl7lBM;IAOI,kCAAA;ElB86lBV;EkBr7lBM;IAOI,gCAAA;ElBi7lBV;EkBx7lBM;IAOI,uCAAA;ElBo7lBV;EkB37lBM;IAOI,sCAAA;ElBu7lBV;EkB97lBM;IAOI,iCAAA;ElB07lBV;EkBj8lBM;IAOI,2BAAA;ElB67lBV;EkBp8lBM;IAOI,iCAAA;ElBg8lBV;EkBv8lBM;IAOI,+BAAA;ElBm8lBV;EkB18lBM;IAOI,6BAAA;ElBs8lBV;EkB78lBM;IAOI,+BAAA;ElBy8lBV;EkBh9lBM;IAOI,8BAAA;ElB48lBV;EkBn9lBM;IAOI,oBAAA;ElB+8lBV;EkBt9lBM;IAOI,mBAAA;ElBk9lBV;EkBz9lBM;IAOI,mBAAA;ElBq9lBV;EkB59lBM;IAOI,mBAAA;ElBw9lBV;EkB/9lBM;IAOI,mBAAA;ElB29lBV;EkBl+lBM;IAOI,mBAAA;ElB89lBV;EkBr+lBM;IAOI,mBAAA;ElBi+lBV;EkBx+lBM;IAOI,mBAAA;ElBo+lBV;EkB3+lBM;IAOI,oBAAA;ElBu+lBV;EkB9+lBM;IAOI,0BAAA;ElB0+lBV;EkBj/lBM;IAOI,yBAAA;ElB6+lBV;EkBp/lBM;IAOI,uBAAA;ElBg/lBV;EkBv/lBM;IAOI,yBAAA;ElBm/lBV;EkB1/lBM;IAOI,uBAAA;ElBs/lBV;EkB7/lBM;IAOI,uBAAA;ElBy/lBV;EkBhgmBM;IAOI,0BAAA;IAAA,yBAAA;ElB6/lBV;EkBpgmBM;IAOI,gCAAA;IAAA,+BAAA;ElBigmBV;EkBxgmBM;IAOI,+BAAA;IAAA,8BAAA;ElBqgmBV;EkB5gmBM;IAOI,6BAAA;IAAA,4BAAA;ElBygmBV;EkBhhmBM;IAOI,+BAAA;IAAA,8BAAA;ElB6gmBV;EkBphmBM;IAOI,6BAAA;IAAA,4BAAA;ElBihmBV;EkBxhmBM;IAOI,6BAAA;IAAA,4BAAA;ElBqhmBV;EkB5hmBM;IAOI,wBAAA;IAAA,2BAAA;ElByhmBV;EkBhimBM;IAOI,8BAAA;IAAA,iCAAA;ElB6hmBV;EkBpimBM;IAOI,6BAAA;IAAA,gCAAA;ElBiimBV;EkBximBM;IAOI,2BAAA;IAAA,8BAAA;ElBqimBV;EkB5imBM;IAOI,6BAAA;IAAA,gCAAA;ElByimBV;EkBhjmBM;IAOI,2BAAA;IAAA,8BAAA;ElB6imBV;EkBpjmBM;IAOI,2BAAA;IAAA,8BAAA;ElBijmBV;EkBxjmBM;IAOI,wBAAA;ElBojmBV;EkB3jmBM;IAOI,8BAAA;ElBujmBV;EkB9jmBM;IAOI,6BAAA;ElB0jmBV;EkBjkmBM;IAOI,2BAAA;ElB6jmBV;EkBpkmBM;IAOI,6BAAA;ElBgkmBV;EkBvkmBM;IAOI,2BAAA;ElBmkmBV;EkB1kmBM;IAOI,2BAAA;ElBskmBV;EkB7kmBM;IAOI,0BAAA;ElBykmBV;EkBhlmBM;IAOI,gCAAA;ElB4kmBV;EkBnlmBM;IAOI,+BAAA;ElB+kmBV;EkBtlmBM;IAOI,6BAAA;ElBklmBV;EkBzlmBM;IAOI,+BAAA;ElBqlmBV;EkB5lmBM;IAOI,6BAAA;ElBwlmBV;EkB/lmBM;IAOI,6BAAA;ElB2lmBV;EkBlmmBM;IAOI,2BAAA;ElB8lmBV;EkBrmmBM;IAOI,iCAAA;ElBimmBV;EkBxmmBM;IAOI,gCAAA;ElBommBV;EkB3mmBM;IAOI,8BAAA;ElBummBV;EkB9mmBM;IAOI,gCAAA;ElB0mmBV;EkBjnmBM;IAOI,8BAAA;ElB6mmBV;EkBpnmBM;IAOI,8BAAA;ElBgnmBV;EkBvnmBM;IAOI,yBAAA;ElBmnmBV;EkB1nmBM;IAOI,+BAAA;ElBsnmBV;EkB7nmBM;IAOI,8BAAA;ElBynmBV;EkBhomBM;IAOI,4BAAA;ElB4nmBV;EkBnomBM;IAOI,8BAAA;ElB+nmBV;EkBtomBM;IAOI,4BAAA;ElBkomBV;EkBzomBM;IAOI,4BAAA;ElBqomBV;EkB5omBM;IAOI,qBAAA;ElBwomBV;EkB/omBM;IAOI,2BAAA;ElB2omBV;EkBlpmBM;IAOI,0BAAA;ElB8omBV;EkBrpmBM;IAOI,wBAAA;ElBipmBV;EkBxpmBM;IAOI,0BAAA;ElBopmBV;EkB3pmBM;IAOI,wBAAA;ElBupmBV;EkB9pmBM;IAOI,2BAAA;IAAA,0BAAA;ElB2pmBV;EkBlqmBM;IAOI,iCAAA;IAAA,gCAAA;ElB+pmBV;EkBtqmBM;IAOI,gCAAA;IAAA,+BAAA;ElBmqmBV;EkB1qmBM;IAOI,8BAAA;IAAA,6BAAA;ElBuqmBV;EkB9qmBM;IAOI,gCAAA;IAAA,+BAAA;ElB2qmBV;EkBlrmBM;IAOI,8BAAA;IAAA,6BAAA;ElB+qmBV;EkBtrmBM;IAOI,yBAAA;IAAA,4BAAA;ElBmrmBV;EkB1rmBM;IAOI,+BAAA;IAAA,kCAAA;ElBurmBV;EkB9rmBM;IAOI,8BAAA;IAAA,iCAAA;ElB2rmBV;EkBlsmBM;IAOI,4BAAA;IAAA,+BAAA;ElB+rmBV;EkBtsmBM;IAOI,8BAAA;IAAA,iCAAA;ElBmsmBV;EkB1smBM;IAOI,4BAAA;IAAA,+BAAA;ElBusmBV;EkB9smBM;IAOI,yBAAA;ElB0smBV;EkBjtmBM;IAOI,+BAAA;ElB6smBV;EkBptmBM;IAOI,8BAAA;ElBgtmBV;EkBvtmBM;IAOI,4BAAA;ElBmtmBV;EkB1tmBM;IAOI,8BAAA;ElBstmBV;EkB7tmBM;IAOI,4BAAA;ElBytmBV;EkBhumBM;IAOI,2BAAA;ElB4tmBV;EkBnumBM;IAOI,iCAAA;ElB+tmBV;EkBtumBM;IAOI,gCAAA;ElBkumBV;EkBzumBM;IAOI,8BAAA;ElBqumBV;EkB5umBM;IAOI,gCAAA;ElBwumBV;EkB/umBM;IAOI,8BAAA;ElB2umBV;EkBlvmBM;IAOI,4BAAA;ElB8umBV;EkBrvmBM;IAOI,kCAAA;ElBivmBV;EkBxvmBM;IAOI,iCAAA;ElBovmBV;EkB3vmBM;IAOI,+BAAA;ElBuvmBV;EkB9vmBM;IAOI,iCAAA;ElB0vmBV;EkBjwmBM;IAOI,+BAAA;ElB6vmBV;EkBpwmBM;IAOI,0BAAA;ElBgwmBV;EkBvwmBM;IAOI,gCAAA;ElBmwmBV;EkB1wmBM;IAOI,+BAAA;ElBswmBV;EkB7wmBM;IAOI,6BAAA;ElBywmBV;EkBhxmBM;IAOI,+BAAA;ElB4wmBV;EkBnxmBM;IAOI,6BAAA;ElB+wmBV;EkBtxmBM;IAOI,iBAAA;ElBkxmBV;EkBzxmBM;IAOI,uBAAA;ElBqxmBV;EkB5xmBM;IAOI,sBAAA;ElBwxmBV;EkB/xmBM;IAOI,oBAAA;ElB2xmBV;EkBlymBM;IAOI,sBAAA;ElB8xmBV;EkBrymBM;IAOI,oBAAA;ElBiymBV;EkBxymBM;IAOI,qBAAA;ElBoymBV;EkB3ymBM;IAOI,2BAAA;ElBuymBV;EkB9ymBM;IAOI,0BAAA;ElB0ymBV;EkBjzmBM;IAOI,wBAAA;ElB6ymBV;EkBpzmBM;IAOI,0BAAA;ElBgzmBV;EkBvzmBM;IAOI,wBAAA;ElBmzmBV;EkB1zmBM;IAOI,wBAAA;ElBszmBV;EkB7zmBM;IAOI,8BAAA;ElByzmBV;EkBh0mBM;IAOI,6BAAA;ElB4zmBV;EkBn0mBM;IAOI,2BAAA;ElB+zmBV;EkBt0mBM;IAOI,6BAAA;ElBk0mBV;EkBz0mBM;IAOI,2BAAA;ElBq0mBV;EkB50mBM;IAOI,2BAAA;ElBw0mBV;EkB/0mBM;IAOI,4BAAA;ElB20mBV;EkBl1mBM;IAOI,6BAAA;ElB80mBV;AACF;AmBr4mBA;ED+CQ;IAOI,4BAAA;ElBm1mBV;EkB11mBM;IAOI,0BAAA;ElBs1mBV;EkB71mBM;IAOI,6BAAA;ElBy1mBV;EkBh2mBM;IAOI,4BAAA;ElB41mBV;AACF;AmBh4mBA;ED4BQ;IAOI,0BAAA;ElBi2mBV;EkBx2mBM;IAOI,gCAAA;ElBo2mBV;EkB32mBM;IAOI,yBAAA;ElBu2mBV;EkB92mBM;IAOI,wBAAA;ElB02mBV;EkBj3mBM;IAOI,+BAAA;ElB62mBV;EkBp3mBM;IAOI,yBAAA;ElBg3mBV;EkBv3mBM;IAOI,6BAAA;ElBm3mBV;EkB13mBM;IAOI,8BAAA;ElBs3mBV;EkB73mBM;IAOI,wBAAA;ElBy3mBV;EkBh4mBM;IAOI,+BAAA;ElB43mBV;EkBn4mBM;IAOI,wBAAA;ElB+3mBV;AACF;A2Ez8mBA;;;;EAAA;AAaA;EACE,mBAAA;EACA,8BATqB;EAUrB,sHANyB;A3Ey8mB3B;A2Eh8mBA;;;EAGE,qBAAA;EACA,yCAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;A3Ek8mBF;;A2Ez7iBE;EAAuB,gBAtgEH;A3Em8mBtB;;A2E77iBE;EAAuB,gBAtgEH;A3Eu8mBtB;;A2Ej8iBE;EAAuB,gBAtgEH;A3E28mBtB;;A2Er8iBE;EAAuB,gBAtgEH;A3E+8mBtB;;A2Ez8iBE;EAAuB,gBAtgEH;A3Em9mBtB;;A2E78iBE;EAAuB,gBAtgEH;A3Eu9mBtB;;A2Ej9iBE;EAAuB,gBAtgEH;A3E29mBtB;;A2Er9iBE;EAAuB,gBAtgEH;A3E+9mBtB;;A2Ez9iBE;EAAuB,gBAtgEH;A3Em+mBtB;;A2E79iBE;EAAuB,gBAtgEH;A3Eu+mBtB;;A2Ej+iBE;EAAuB,gBAtgEH;A3E2+mBtB;;A2Er+iBE;EAAuB,gBAtgEH;A3E++mBtB;;A2Ez+iBE;EAAuB,gBAtgEH;A3Em/mBtB;;A2E7+iBE;EAAuB,gBAtgEH;A3Eu/mBtB;;A2Ej/iBE;EAAuB,gBAtgEH;A3E2/mBtB;;A2Er/iBE;EAAuB,gBAtgEH;A3E+/mBtB;;A2Ez/iBE;EAAuB,gBAtgEH;A3EmgnBtB;;A2E7/iBE;EAAuB,gBAtgEH;A3EugnBtB;;A2EjgjBE;EAAuB,gBAtgEH;A3E2gnBtB;;A2ErgjBE;EAAuB,gBAtgEH;A3E+gnBtB;;A2EzgjBE;EAAuB,gBAtgEH;A3EmhnBtB;;A2E7gjBE;EAAuB,gBAtgEH;A3EuhnBtB;;A2EjhjBE;EAAuB,gBAtgEH;A3E2hnBtB;;A2ErhjBE;EAAuB,gBAtgEH;A3E+hnBtB;;A2EzhjBE;EAAuB,gBAtgEH;A3EminBtB;;A2E7hjBE;EAAuB,gBAtgEH;A3EuinBtB;;A2EjijBE;EAAuB,gBAtgEH;A3E2inBtB;;A2ErijBE;EAAuB,gBAtgEH;A3E+inBtB;;A2EzijBE;EAAuB,gBAtgEH;A3EmjnBtB;;A2E7ijBE;EAAuB,gBAtgEH;A3EujnBtB;;A2EjjjBE;EAAuB,gBAtgEH;A3E2jnBtB;;A2ErjjBE;EAAuB,gBAtgEH;A3E+jnBtB;;A2EzjjBE;EAAuB,gBAtgEH;A3EmknBtB;;A2E7jjBE;EAAuB,gBAtgEH;A3EuknBtB;;A2EjkjBE;EAAuB,gBAtgEH;A3E2knBtB;;A2ErkjBE;EAAuB,gBAtgEH;A3E+knBtB;;A2EzkjBE;EAAuB,gBAtgEH;A3EmlnBtB;;A2E7kjBE;EAAuB,gBAtgEH;A3EulnBtB;;A2EjljBE;EAAuB,gBAtgEH;A3E2lnBtB;;A2ErljBE;EAAuB,gBAtgEH;A3E+lnBtB;;A2EzljBE;EAAuB,gBAtgEH;A3EmmnBtB;;A2E7ljBE;EAAuB,gBAtgEH;A3EumnBtB;;A2EjmjBE;EAAuB,gBAtgEH;A3E2mnBtB;;A2ErmjBE;EAAuB,gBAtgEH;A3E+mnBtB;;A2EzmjBE;EAAuB,gBAtgEH;A3EmnnBtB;;A2E7mjBE;EAAuB,gBAtgEH;A3EunnBtB;;A2EjnjBE;EAAuB,gBAtgEH;A3E2nnBtB;;A2ErnjBE;EAAuB,gBAtgEH;A3E+nnBtB;;A2EznjBE;EAAuB,gBAtgEH;A3EmonBtB;;A2E7njBE;EAAuB,gBAtgEH;A3EuonBtB;;A2EjojBE;EAAuB,gBAtgEH;A3E2onBtB;;A2ErojBE;EAAuB,gBAtgEH;A3E+onBtB;;A2EzojBE;EAAuB,gBAtgEH;A3EmpnBtB;;A2E7ojBE;EAAuB,gBAtgEH;A3EupnBtB;;A2EjpjBE;EAAuB,gBAtgEH;A3E2pnBtB;;A2ErpjBE;EAAuB,gBAtgEH;A3E+pnBtB;;A2EzpjBE;EAAuB,gBAtgEH;A3EmqnBtB;;A2E7pjBE;EAAuB,gBAtgEH;A3EuqnBtB;;A2EjqjBE;EAAuB,gBAtgEH;A3E2qnBtB;;A2ErqjBE;EAAuB,gBAtgEH;A3E+qnBtB;;A2EzqjBE;EAAuB,gBAtgEH;A3EmrnBtB;;A2E7qjBE;EAAuB,gBAtgEH;A3EurnBtB;;A2EjrjBE;EAAuB,gBAtgEH;A3E2rnBtB;;A2ErrjBE;EAAuB,gBAtgEH;A3E+rnBtB;;A2EzrjBE;EAAuB,gBAtgEH;A3EmsnBtB;;A2E7rjBE;EAAuB,gBAtgEH;A3EusnBtB;;A2EjsjBE;EAAuB,gBAtgEH;A3E2snBtB;;A2ErsjBE;EAAuB,gBAtgEH;A3E+snBtB;;A2EzsjBE;EAAuB,gBAtgEH;A3EmtnBtB;;A2E7sjBE;EAAuB,gBAtgEH;A3EutnBtB;;A2EjtjBE;EAAuB,gBAtgEH;A3E2tnBtB;;A2ErtjBE;EAAuB,gBAtgEH;A3E+tnBtB;;A2EztjBE;EAAuB,gBAtgEH;A3EmunBtB;;A2E7tjBE;EAAuB,gBAtgEH;A3EuunBtB;;A2EjujBE;EAAuB,gBAtgEH;A3E2unBtB;;A2ErujBE;EAAuB,gBAtgEH;A3E+unBtB;;A2EzujBE;EAAuB,gBAtgEH;A3EmvnBtB;;A2E7ujBE;EAAuB,gBAtgEH;A3EuvnBtB;;A2EjvjBE;EAAuB,gBAtgEH;A3E2vnBtB;;A2ErvjBE;EAAuB,gBAtgEH;A3E+vnBtB;;A2EzvjBE;EAAuB,gBAtgEH;A3EmwnBtB;;A2E7vjBE;EAAuB,gBAtgEH;A3EuwnBtB;;A2EjwjBE;EAAuB,gBAtgEH;A3E2wnBtB;;A2ErwjBE;EAAuB,gBAtgEH;A3E+wnBtB;;A2EzwjBE;EAAuB,gBAtgEH;A3EmxnBtB;;A2E7wjBE;EAAuB,gBAtgEH;A3EuxnBtB;;A2EjxjBE;EAAuB,gBAtgEH;A3E2xnBtB;;A2ErxjBE;EAAuB,gBAtgEH;A3E+xnBtB;;A2EzxjBE;EAAuB,gBAtgEH;A3EmynBtB;;A2E7xjBE;EAAuB,gBAtgEH;A3EuynBtB;;A2EjyjBE;EAAuB,gBAtgEH;A3E2ynBtB;;A2EryjBE;EAAuB,gBAtgEH;A3E+ynBtB;;A2EzyjBE;EAAuB,gBAtgEH;A3EmznBtB;;A2E7yjBE;EAAuB,gBAtgEH;A3EuznBtB;;A2EjzjBE;EAAuB,gBAtgEH;A3E2znBtB;;A2ErzjBE;EAAuB,gBAtgEH;A3E+znBtB;;A2EzzjBE;EAAuB,gBAtgEH;A3Em0nBtB;;A2E7zjBE;EAAuB,gBAtgEH;A3Eu0nBtB;;A2Ej0jBE;EAAuB,gBAtgEH;A3E20nBtB;;A2Er0jBE;EAAuB,gBAtgEH;A3E+0nBtB;;A2Ez0jBE;EAAuB,gBAtgEH;A3Em1nBtB;;A2E70jBE;EAAuB,gBAtgEH;A3Eu1nBtB;;A2Ej1jBE;EAAuB,gBAtgEH;A3E21nBtB;;A2Er1jBE;EAAuB,gBAtgEH;A3E+1nBtB;;A2Ez1jBE;EAAuB,gBAtgEH;A3Em2nBtB;;A2E71jBE;EAAuB,gBAtgEH;A3Eu2nBtB;;A2Ej2jBE;EAAuB,gBAtgEH;A3E22nBtB;;A2Er2jBE;EAAuB,gBAtgEH;A3E+2nBtB;;A2Ez2jBE;EAAuB,gBAtgEH;A3Em3nBtB;;A2E72jBE;EAAuB,gBAtgEH;A3Eu3nBtB;;A2Ej3jBE;EAAuB,gBAtgEH;A3E23nBtB;;A2Er3jBE;EAAuB,gBAtgEH;A3E+3nBtB;;A2Ez3jBE;EAAuB,gBAtgEH;A3Em4nBtB;;A2E73jBE;EAAuB,gBAtgEH;A3Eu4nBtB;;A2Ej4jBE;EAAuB,gBAtgEH;A3E24nBtB;;A2Er4jBE;EAAuB,gBAtgEH;A3E+4nBtB;;A2Ez4jBE;EAAuB,gBAtgEH;A3Em5nBtB;;A2E74jBE;EAAuB,gBAtgEH;A3Eu5nBtB;;A2Ej5jBE;EAAuB,gBAtgEH;A3E25nBtB;;A2Er5jBE;EAAuB,gBAtgEH;A3E+5nBtB;;A2Ez5jBE;EAAuB,gBAtgEH;A3Em6nBtB;;A2E75jBE;EAAuB,gBAtgEH;A3Eu6nBtB;;A2Ej6jBE;EAAuB,gBAtgEH;A3E26nBtB;;A2Er6jBE;EAAuB,gBAtgEH;A3E+6nBtB;;A2Ez6jBE;EAAuB,gBAtgEH;A3Em7nBtB;;A2E76jBE;EAAuB,gBAtgEH;A3Eu7nBtB;;A2Ej7jBE;EAAuB,gBAtgEH;A3E27nBtB;;A2Er7jBE;EAAuB,gBAtgEH;A3E+7nBtB;;A2Ez7jBE;EAAuB,gBAtgEH;A3Em8nBtB;;A2E77jBE;EAAuB,gBAtgEH;A3Eu8nBtB;;A2Ej8jBE;EAAuB,gBAtgEH;A3E28nBtB;;A2Er8jBE;EAAuB,gBAtgEH;A3E+8nBtB;;A2Ez8jBE;EAAuB,gBAtgEH;A3Em9nBtB;;A2E78jBE;EAAuB,gBAtgEH;A3Eu9nBtB;;A2Ej9jBE;EAAuB,gBAtgEH;A3E29nBtB;;A2Er9jBE;EAAuB,gBAtgEH;A3E+9nBtB;;A2Ez9jBE;EAAuB,gBAtgEH;A3Em+nBtB;;A2E79jBE;EAAuB,gBAtgEH;A3Eu+nBtB;;A2Ej+jBE;EAAuB,gBAtgEH;A3E2+nBtB;;A2Er+jBE;EAAuB,gBAtgEH;A3E++nBtB;;A2Ez+jBE;EAAuB,gBAtgEH;A3Em/nBtB;;A2E7+jBE;EAAuB,gBAtgEH;A3Eu/nBtB;;A2Ej/jBE;EAAuB,gBAtgEH;A3E2/nBtB;;A2Er/jBE;EAAuB,gBAtgEH;A3E+/nBtB;;A2Ez/jBE;EAAuB,gBAtgEH;A3EmgoBtB;;A2E7/jBE;EAAuB,gBAtgEH;A3EugoBtB;;A2EjgkBE;EAAuB,gBAtgEH;A3E2goBtB;;A2ErgkBE;EAAuB,gBAtgEH;A3E+goBtB;;A2EzgkBE;EAAuB,gBAtgEH;A3EmhoBtB;;A2E7gkBE;EAAuB,gBAtgEH;A3EuhoBtB;;A2EjhkBE;EAAuB,gBAtgEH;A3E2hoBtB;;A2ErhkBE;EAAuB,gBAtgEH;A3E+hoBtB;;A2EzhkBE;EAAuB,gBAtgEH;A3EmioBtB;;A2E7hkBE;EAAuB,gBAtgEH;A3EuioBtB;;A2EjikBE;EAAuB,gBAtgEH;A3E2ioBtB;;A2ErikBE;EAAuB,gBAtgEH;A3E+ioBtB;;A2EzikBE;EAAuB,gBAtgEH;A3EmjoBtB;;A2E7ikBE;EAAuB,gBAtgEH;A3EujoBtB;;A2EjjkBE;EAAuB,gBAtgEH;A3E2joBtB;;A2ErjkBE;EAAuB,gBAtgEH;A3E+joBtB;;A2EzjkBE;EAAuB,gBAtgEH;A3EmkoBtB;;A2E7jkBE;EAAuB,gBAtgEH;A3EukoBtB;;A2EjkkBE;EAAuB,gBAtgEH;A3E2koBtB;;A2ErkkBE;EAAuB,gBAtgEH;A3E+koBtB;;A2EzkkBE;EAAuB,gBAtgEH;A3EmloBtB;;A2E7kkBE;EAAuB,gBAtgEH;A3EuloBtB;;A2EjlkBE;EAAuB,gBAtgEH;A3E2loBtB;;A2ErlkBE;EAAuB,gBAtgEH;A3E+loBtB;;A2EzlkBE;EAAuB,gBAtgEH;A3EmmoBtB;;A2E7lkBE;EAAuB,gBAtgEH;A3EumoBtB;;A2EjmkBE;EAAuB,gBAtgEH;A3E2moBtB;;A2ErmkBE;EAAuB,gBAtgEH;A3E+moBtB;;A2EzmkBE;EAAuB,gBAtgEH;A3EmnoBtB;;A2E7mkBE;EAAuB,gBAtgEH;A3EunoBtB;;A2EjnkBE;EAAuB,gBAtgEH;A3E2noBtB;;A2ErnkBE;EAAuB,gBAtgEH;A3E+noBtB;;A2EznkBE;EAAuB,gBAtgEH;A3EmooBtB;;A2E7nkBE;EAAuB,gBAtgEH;A3EuooBtB;;A2EjokBE;EAAuB,gBAtgEH;A3E2ooBtB;;A2ErokBE;EAAuB,gBAtgEH;A3E+ooBtB;;A2EzokBE;EAAuB,gBAtgEH;A3EmpoBtB;;A2E7okBE;EAAuB,gBAtgEH;A3EupoBtB;;A2EjpkBE;EAAuB,gBAtgEH;A3E2poBtB;;A2ErpkBE;EAAuB,gBAtgEH;A3E+poBtB;;A2EzpkBE;EAAuB,gBAtgEH;A3EmqoBtB;;A2E7pkBE;EAAuB,gBAtgEH;A3EuqoBtB;;A2EjqkBE;EAAuB,gBAtgEH;A3E2qoBtB;;A2ErqkBE;EAAuB,gBAtgEH;A3E+qoBtB;;A2EzqkBE;EAAuB,gBAtgEH;A3EmroBtB;;A2E7qkBE;EAAuB,gBAtgEH;A3EuroBtB;;A2EjrkBE;EAAuB,gBAtgEH;A3E2roBtB;;A2ErrkBE;EAAuB,gBAtgEH;A3E+roBtB;;A2EzrkBE;EAAuB,gBAtgEH;A3EmsoBtB;;A2E7rkBE;EAAuB,gBAtgEH;A3EusoBtB;;A2EjskBE;EAAuB,gBAtgEH;A3E2soBtB;;A2ErskBE;EAAuB,gBAtgEH;A3E+soBtB;;A2EzskBE;EAAuB,gBAtgEH;A3EmtoBtB;;A2E7skBE;EAAuB,gBAtgEH;A3EutoBtB;;A2EjtkBE;EAAuB,gBAtgEH;A3E2toBtB;;A2ErtkBE;EAAuB,gBAtgEH;A3E+toBtB;;A2EztkBE;EAAuB,gBAtgEH;A3EmuoBtB;;A2E7tkBE;EAAuB,gBAtgEH;A3EuuoBtB;;A2EjukBE;EAAuB,gBAtgEH;A3E2uoBtB;;A2ErukBE;EAAuB,gBAtgEH;A3E+uoBtB;;A2EzukBE;EAAuB,gBAtgEH;A3EmvoBtB;;A2E7ukBE;EAAuB,gBAtgEH;A3EuvoBtB;;A2EjvkBE;EAAuB,gBAtgEH;A3E2voBtB;;A2ErvkBE;EAAuB,gBAtgEH;A3E+voBtB;;A2EzvkBE;EAAuB,gBAtgEH;A3EmwoBtB;;A2E7vkBE;EAAuB,gBAtgEH;A3EuwoBtB;;A2EjwkBE;EAAuB,gBAtgEH;A3E2woBtB;;A2ErwkBE;EAAuB,gBAtgEH;A3E+woBtB;;A2EzwkBE;EAAuB,gBAtgEH;A3EmxoBtB;;A2E7wkBE;EAAuB,gBAtgEH;A3EuxoBtB;;A2EjxkBE;EAAuB,gBAtgEH;A3E2xoBtB;;A2ErxkBE;EAAuB,gBAtgEH;A3E+xoBtB;;A2EzxkBE;EAAuB,gBAtgEH;A3EmyoBtB;;A2E7xkBE;EAAuB,gBAtgEH;A3EuyoBtB;;A2EjykBE;EAAuB,gBAtgEH;A3E2yoBtB;;A2ErykBE;EAAuB,gBAtgEH;A3E+yoBtB;;A2EzykBE;EAAuB,gBAtgEH;A3EmzoBtB;;A2E7ykBE;EAAuB,gBAtgEH;A3EuzoBtB;;A2EjzkBE;EAAuB,gBAtgEH;A3E2zoBtB;;A2ErzkBE;EAAuB,gBAtgEH;A3E+zoBtB;;A2EzzkBE;EAAuB,gBAtgEH;A3Em0oBtB;;A2E7zkBE;EAAuB,gBAtgEH;A3Eu0oBtB;;A2Ej0kBE;EAAuB,gBAtgEH;A3E20oBtB;;A2Er0kBE;EAAuB,gBAtgEH;A3E+0oBtB;;A2Ez0kBE;EAAuB,gBAtgEH;A3Em1oBtB;;A2E70kBE;EAAuB,gBAtgEH;A3Eu1oBtB;;A2Ej1kBE;EAAuB,gBAtgEH;A3E21oBtB;;A2Er1kBE;EAAuB,gBAtgEH;A3E+1oBtB;;A2Ez1kBE;EAAuB,gBAtgEH;A3Em2oBtB;;A2E71kBE;EAAuB,gBAtgEH;A3Eu2oBtB;;A2Ej2kBE;EAAuB,gBAtgEH;A3E22oBtB;;A2Er2kBE;EAAuB,gBAtgEH;A3E+2oBtB;;A2Ez2kBE;EAAuB,gBAtgEH;A3Em3oBtB;;A2E72kBE;EAAuB,gBAtgEH;A3Eu3oBtB;;A2Ej3kBE;EAAuB,gBAtgEH;A3E23oBtB;;A2Er3kBE;EAAuB,gBAtgEH;A3E+3oBtB;;A2Ez3kBE;EAAuB,gBAtgEH;A3Em4oBtB;;A2E73kBE;EAAuB,gBAtgEH;A3Eu4oBtB;;A2Ej4kBE;EAAuB,gBAtgEH;A3E24oBtB;;A2Er4kBE;EAAuB,gBAtgEH;A3E+4oBtB;;A2Ez4kBE;EAAuB,gBAtgEH;A3Em5oBtB;;A2E74kBE;EAAuB,gBAtgEH;A3Eu5oBtB;;A2Ej5kBE;EAAuB,gBAtgEH;A3E25oBtB;;A2Er5kBE;EAAuB,gBAtgEH;A3E+5oBtB;;A2Ez5kBE;EAAuB,gBAtgEH;A3Em6oBtB;;A2E75kBE;EAAuB,gBAtgEH;A3Eu6oBtB;;A2Ej6kBE;EAAuB,gBAtgEH;A3E26oBtB;;A2Er6kBE;EAAuB,gBAtgEH;A3E+6oBtB;;A2Ez6kBE;EAAuB,gBAtgEH;A3Em7oBtB;;A2E76kBE;EAAuB,gBAtgEH;A3Eu7oBtB;;A2Ej7kBE;EAAuB,gBAtgEH;A3E27oBtB;;A2Er7kBE;EAAuB,gBAtgEH;A3E+7oBtB;;A2Ez7kBE;EAAuB,gBAtgEH;A3Em8oBtB;;A2E77kBE;EAAuB,gBAtgEH;A3Eu8oBtB;;A2Ej8kBE;EAAuB,gBAtgEH;A3E28oBtB;;A2Er8kBE;EAAuB,gBAtgEH;A3E+8oBtB;;A2Ez8kBE;EAAuB,gBAtgEH;A3Em9oBtB;;A2E78kBE;EAAuB,gBAtgEH;A3Eu9oBtB;;A2Ej9kBE;EAAuB,gBAtgEH;A3E29oBtB;;A2Er9kBE;EAAuB,gBAtgEH;A3E+9oBtB;;A2Ez9kBE;EAAuB,gBAtgEH;A3Em+oBtB;;A2E79kBE;EAAuB,gBAtgEH;A3Eu+oBtB;;A2Ej+kBE;EAAuB,gBAtgEH;A3E2+oBtB;;A2Er+kBE;EAAuB,gBAtgEH;A3E++oBtB;;A2Ez+kBE;EAAuB,gBAtgEH;A3Em/oBtB;;A2E7+kBE;EAAuB,gBAtgEH;A3Eu/oBtB;;A2Ej/kBE;EAAuB,gBAtgEH;A3E2/oBtB;;A2Er/kBE;EAAuB,gBAtgEH;A3E+/oBtB;;A2Ez/kBE;EAAuB,gBAtgEH;A3EmgpBtB;;A2E7/kBE;EAAuB,gBAtgEH;A3EugpBtB;;A2EjglBE;EAAuB,gBAtgEH;A3E2gpBtB;;A2ErglBE;EAAuB,gBAtgEH;A3E+gpBtB;;A2EzglBE;EAAuB,gBAtgEH;A3EmhpBtB;;A2E7glBE;EAAuB,gBAtgEH;A3EuhpBtB;;A2EjhlBE;EAAuB,gBAtgEH;A3E2hpBtB;;A2ErhlBE;EAAuB,gBAtgEH;A3E+hpBtB;;A2EzhlBE;EAAuB,gBAtgEH;A3EmipBtB;;A2E7hlBE;EAAuB,gBAtgEH;A3EuipBtB;;A2EjilBE;EAAuB,gBAtgEH;A3E2ipBtB;;A2ErilBE;EAAuB,gBAtgEH;A3E+ipBtB;;A2EzilBE;EAAuB,gBAtgEH;A3EmjpBtB;;A2E7ilBE;EAAuB,gBAtgEH;A3EujpBtB;;A2EjjlBE;EAAuB,gBAtgEH;A3E2jpBtB;;A2ErjlBE;EAAuB,gBAtgEH;A3E+jpBtB;;A2EzjlBE;EAAuB,gBAtgEH;A3EmkpBtB;;A2E7jlBE;EAAuB,gBAtgEH;A3EukpBtB;;A2EjklBE;EAAuB,gBAtgEH;A3E2kpBtB;;A2ErklBE;EAAuB,gBAtgEH;A3E+kpBtB;;A2EzklBE;EAAuB,gBAtgEH;A3EmlpBtB;;A2E7klBE;EAAuB,gBAtgEH;A3EulpBtB;;A2EjllBE;EAAuB,gBAtgEH;A3E2lpBtB;;A2ErllBE;EAAuB,gBAtgEH;A3E+lpBtB;;A2EzllBE;EAAuB,gBAtgEH;A3EmmpBtB;;A2E7llBE;EAAuB,gBAtgEH;A3EumpBtB;;A2EjmlBE;EAAuB,gBAtgEH;A3E2mpBtB;;A2ErmlBE;EAAuB,gBAtgEH;A3E+mpBtB;;A2EzmlBE;EAAuB,gBAtgEH;A3EmnpBtB;;A2E7mlBE;EAAuB,gBAtgEH;A3EunpBtB;;A2EjnlBE;EAAuB,gBAtgEH;A3E2npBtB;;A2ErnlBE;EAAuB,gBAtgEH;A3E+npBtB;;A2EznlBE;EAAuB,gBAtgEH;A3EmopBtB;;A2E7nlBE;EAAuB,gBAtgEH;A3EuopBtB;;A2EjolBE;EAAuB,gBAtgEH;A3E2opBtB;;A2ErolBE;EAAuB,gBAtgEH;A3E+opBtB;;A2EzolBE;EAAuB,gBAtgEH;A3EmppBtB;;A2E7olBE;EAAuB,gBAtgEH;A3EuppBtB;;A2EjplBE;EAAuB,gBAtgEH;A3E2ppBtB;;A2ErplBE;EAAuB,gBAtgEH;A3E+ppBtB;;A2EzplBE;EAAuB,gBAtgEH;A3EmqpBtB;;A2E7plBE;EAAuB,gBAtgEH;A3EuqpBtB;;A2EjqlBE;EAAuB,gBAtgEH;A3E2qpBtB;;A2ErqlBE;EAAuB,gBAtgEH;A3E+qpBtB;;A2EzqlBE;EAAuB,gBAtgEH;A3EmrpBtB;;A2E7qlBE;EAAuB,gBAtgEH;A3EurpBtB;;A2EjrlBE;EAAuB,gBAtgEH;A3E2rpBtB;;A2ErrlBE;EAAuB,gBAtgEH;A3E+rpBtB;;A2EzrlBE;EAAuB,gBAtgEH;A3EmspBtB;;A2E7rlBE;EAAuB,gBAtgEH;A3EuspBtB;;A2EjslBE;EAAuB,gBAtgEH;A3E2spBtB;;A2ErslBE;EAAuB,gBAtgEH;A3E+spBtB;;A2EzslBE;EAAuB,gBAtgEH;A3EmtpBtB;;A2E7slBE;EAAuB,gBAtgEH;A3EutpBtB;;A2EjtlBE;EAAuB,gBAtgEH;A3E2tpBtB;;A2ErtlBE;EAAuB,gBAtgEH;A3E+tpBtB;;A2EztlBE;EAAuB,gBAtgEH;A3EmupBtB;;A2E7tlBE;EAAuB,gBAtgEH;A3EuupBtB;;A2EjulBE;EAAuB,gBAtgEH;A3E2upBtB;;A2ErulBE;EAAuB,gBAtgEH;A3E+upBtB;;A2EzulBE;EAAuB,gBAtgEH;A3EmvpBtB;;A2E7ulBE;EAAuB,gBAtgEH;A3EuvpBtB;;A2EjvlBE;EAAuB,gBAtgEH;A3E2vpBtB;;A2ErvlBE;EAAuB,gBAtgEH;A3E+vpBtB;;A2EzvlBE;EAAuB,gBAtgEH;A3EmwpBtB;;A2E7vlBE;EAAuB,gBAtgEH;A3EuwpBtB;;A2EjwlBE;EAAuB,gBAtgEH;A3E2wpBtB;;A2ErwlBE;EAAuB,gBAtgEH;A3E+wpBtB;;A2EzwlBE;EAAuB,gBAtgEH;A3EmxpBtB;;A2E7wlBE;EAAuB,gBAtgEH;A3EuxpBtB;;A2EjxlBE;EAAuB,gBAtgEH;A3E2xpBtB;;A2ErxlBE;EAAuB,gBAtgEH;A3E+xpBtB;;A2EzxlBE;EAAuB,gBAtgEH;A3EmypBtB;;A2E7xlBE;EAAuB,gBAtgEH;A3EuypBtB;;A2EjylBE;EAAuB,gBAtgEH;A3E2ypBtB;;A2ErylBE;EAAuB,gBAtgEH;A3E+ypBtB;;A2EzylBE;EAAuB,gBAtgEH;A3EmzpBtB;;A2E7ylBE;EAAuB,gBAtgEH;A3EuzpBtB;;A2EjzlBE;EAAuB,gBAtgEH;A3E2zpBtB;;A2ErzlBE;EAAuB,gBAtgEH;A3E+zpBtB;;A2EzzlBE;EAAuB,gBAtgEH;A3Em0pBtB;;A2E7zlBE;EAAuB,gBAtgEH;A3Eu0pBtB;;A2Ej0lBE;EAAuB,gBAtgEH;A3E20pBtB;;A2Er0lBE;EAAuB,gBAtgEH;A3E+0pBtB;;A2Ez0lBE;EAAuB,gBAtgEH;A3Em1pBtB;;A2E70lBE;EAAuB,gBAtgEH;A3Eu1pBtB;;A2Ej1lBE;EAAuB,gBAtgEH;A3E21pBtB;;A2Er1lBE;EAAuB,gBAtgEH;A3E+1pBtB;;A2Ez1lBE;EAAuB,gBAtgEH;A3Em2pBtB;;A2E71lBE;EAAuB,gBAtgEH;A3Eu2pBtB;;A2Ej2lBE;EAAuB,gBAtgEH;A3E22pBtB;;A2Er2lBE;EAAuB,gBAtgEH;A3E+2pBtB;;A2Ez2lBE;EAAuB,gBAtgEH;A3Em3pBtB;;A2E72lBE;EAAuB,gBAtgEH;A3Eu3pBtB;;A2Ej3lBE;EAAuB,gBAtgEH;A3E23pBtB;;A2Er3lBE;EAAuB,gBAtgEH;A3E+3pBtB;;A2Ez3lBE;EAAuB,gBAtgEH;A3Em4pBtB;;A2E73lBE;EAAuB,gBAtgEH;A3Eu4pBtB;;A2Ej4lBE;EAAuB,gBAtgEH;A3E24pBtB;;A2Er4lBE;EAAuB,gBAtgEH;A3E+4pBtB;;A2Ez4lBE;EAAuB,gBAtgEH;A3Em5pBtB;;A2E74lBE;EAAuB,gBAtgEH;A3Eu5pBtB;;A2Ej5lBE;EAAuB,gBAtgEH;A3E25pBtB;;A2Er5lBE;EAAuB,gBAtgEH;A3E+5pBtB;;A2Ez5lBE;EAAuB,gBAtgEH;A3Em6pBtB;;A2E75lBE;EAAuB,gBAtgEH;A3Eu6pBtB;;A2Ej6lBE;EAAuB,gBAtgEH;A3E26pBtB;;A2Er6lBE;EAAuB,gBAtgEH;A3E+6pBtB;;A2Ez6lBE;EAAuB,gBAtgEH;A3Em7pBtB;;A2E76lBE;EAAuB,gBAtgEH;A3Eu7pBtB;;A2Ej7lBE;EAAuB,gBAtgEH;A3E27pBtB;;A2Er7lBE;EAAuB,gBAtgEH;A3E+7pBtB;;A2Ez7lBE;EAAuB,gBAtgEH;A3Em8pBtB;;A2E77lBE;EAAuB,gBAtgEH;A3Eu8pBtB;;A2Ej8lBE;EAAuB,gBAtgEH;A3E28pBtB;;A2Er8lBE;EAAuB,gBAtgEH;A3E+8pBtB;;A2Ez8lBE;EAAuB,gBAtgEH;A3Em9pBtB;;A2E78lBE;EAAuB,gBAtgEH;A3Eu9pBtB;;A2Ej9lBE;EAAuB,gBAtgEH;A3E29pBtB;;A2Er9lBE;EAAuB,gBAtgEH;A3E+9pBtB;;A2Ez9lBE;EAAuB,gBAtgEH;A3Em+pBtB;;A2E79lBE;EAAuB,gBAtgEH;A3Eu+pBtB;;A2Ej+lBE;EAAuB,gBAtgEH;A3E2+pBtB;;A2Er+lBE;EAAuB,gBAtgEH;A3E++pBtB;;A2Ez+lBE;EAAuB,gBAtgEH;A3Em/pBtB;;A2E7+lBE;EAAuB,gBAtgEH;A3Eu/pBtB;;A2Ej/lBE;EAAuB,gBAtgEH;A3E2/pBtB;;A2Er/lBE;EAAuB,gBAtgEH;A3E+/pBtB;;A2Ez/lBE;EAAuB,gBAtgEH;A3EmgqBtB;;A2E7/lBE;EAAuB,gBAtgEH;A3EugqBtB;;A2EjgmBE;EAAuB,gBAtgEH;A3E2gqBtB;;A2ErgmBE;EAAuB,gBAtgEH;A3E+gqBtB;;A2EzgmBE;EAAuB,gBAtgEH;A3EmhqBtB;;A2E7gmBE;EAAuB,gBAtgEH;A3EuhqBtB;;A2EjhmBE;EAAuB,gBAtgEH;A3E2hqBtB;;A2ErhmBE;EAAuB,gBAtgEH;A3E+hqBtB;;A2EzhmBE;EAAuB,gBAtgEH;A3EmiqBtB;;A2E7hmBE;EAAuB,gBAtgEH;A3EuiqBtB;;A2EjimBE;EAAuB,gBAtgEH;A3E2iqBtB;;A2ErimBE;EAAuB,gBAtgEH;A3E+iqBtB;;A2EzimBE;EAAuB,gBAtgEH;A3EmjqBtB;;A2E7imBE;EAAuB,gBAtgEH;A3EujqBtB;;A2EjjmBE;EAAuB,gBAtgEH;A3E2jqBtB;;A2ErjmBE;EAAuB,gBAtgEH;A3E+jqBtB;;A2EzjmBE;EAAuB,gBAtgEH;A3EmkqBtB;;A2E7jmBE;EAAuB,gBAtgEH;A3EukqBtB;;A2EjkmBE;EAAuB,gBAtgEH;A3E2kqBtB;;A2ErkmBE;EAAuB,gBAtgEH;A3E+kqBtB;;A2EzkmBE;EAAuB,gBAtgEH;A3EmlqBtB;;A2E7kmBE;EAAuB,gBAtgEH;A3EulqBtB;;A2EjlmBE;EAAuB,gBAtgEH;A3E2lqBtB;;A2ErlmBE;EAAuB,gBAtgEH;A3E+lqBtB;;A2EzlmBE;EAAuB,gBAtgEH;A3EmmqBtB;;A2E7lmBE;EAAuB,gBAtgEH;A3EumqBtB;;A2EjmmBE;EAAuB,gBAtgEH;A3E2mqBtB;;A2ErmmBE;EAAuB,gBAtgEH;A3E+mqBtB;;A2EzmmBE;EAAuB,gBAtgEH;A3EmnqBtB;;A2E7mmBE;EAAuB,gBAtgEH;A3EunqBtB;;A2EjnmBE;EAAuB,gBAtgEH;A3E2nqBtB;;A2ErnmBE;EAAuB,gBAtgEH;A3E+nqBtB;;A2EznmBE;EAAuB,gBAtgEH;A3EmoqBtB;;A2E7nmBE;EAAuB,gBAtgEH;A3EuoqBtB;;A2EjomBE;EAAuB,gBAtgEH;A3E2oqBtB;;A2EromBE;EAAuB,gBAtgEH;A3E+oqBtB;;A2EzomBE;EAAuB,gBAtgEH;A3EmpqBtB;;A2E7omBE;EAAuB,gBAtgEH;A3EupqBtB;;A2EjpmBE;EAAuB,gBAtgEH;A3E2pqBtB;;A2ErpmBE;EAAuB,gBAtgEH;A3E+pqBtB;;A2EzpmBE;EAAuB,gBAtgEH;A3EmqqBtB;;A2E7pmBE;EAAuB,gBAtgEH;A3EuqqBtB;;A2EjqmBE;EAAuB,gBAtgEH;A3E2qqBtB;;A2ErqmBE;EAAuB,gBAtgEH;A3E+qqBtB;;A2EzqmBE;EAAuB,gBAtgEH;A3EmrqBtB;;A2E7qmBE;EAAuB,gBAtgEH;A3EurqBtB;;A2EjrmBE;EAAuB,gBAtgEH;A3E2rqBtB;;A2ErrmBE;EAAuB,gBAtgEH;A3E+rqBtB;;A2EzrmBE;EAAuB,gBAtgEH;A3EmsqBtB;;A2E7rmBE;EAAuB,gBAtgEH;A3EusqBtB;;A2EjsmBE;EAAuB,gBAtgEH;A3E2sqBtB;;A2ErsmBE;EAAuB,gBAtgEH;A3E+sqBtB;;A2EzsmBE;EAAuB,gBAtgEH;A3EmtqBtB;;A2E7smBE;EAAuB,gBAtgEH;A3EutqBtB;;A2EjtmBE;EAAuB,gBAtgEH;A3E2tqBtB;;A2ErtmBE;EAAuB,gBAtgEH;A3E+tqBtB;;A2EztmBE;EAAuB,gBAtgEH;A3EmuqBtB;;A2E7tmBE;EAAuB,gBAtgEH;A3EuuqBtB;;A2EjumBE;EAAuB,gBAtgEH;A3E2uqBtB;;A2ErumBE;EAAuB,gBAtgEH;A3E+uqBtB;;A2EzumBE;EAAuB,gBAtgEH;A3EmvqBtB;;A2E7umBE;EAAuB,gBAtgEH;A3EuvqBtB;;A2EjvmBE;EAAuB,gBAtgEH;A3E2vqBtB;;A2ErvmBE;EAAuB,gBAtgEH;A3E+vqBtB;;A2EzvmBE;EAAuB,gBAtgEH;A3EmwqBtB;;A2E7vmBE;EAAuB,gBAtgEH;A3EuwqBtB;;A2EjwmBE;EAAuB,gBAtgEH;A3E2wqBtB;;A2ErwmBE;EAAuB,gBAtgEH;A3E+wqBtB;;A2EzwmBE;EAAuB,gBAtgEH;A3EmxqBtB;;A2E7wmBE;EAAuB,gBAtgEH;A3EuxqBtB;;A2EjxmBE;EAAuB,gBAtgEH;A3E2xqBtB;;A2ErxmBE;EAAuB,gBAtgEH;A3E+xqBtB;;A2EzxmBE;EAAuB,gBAtgEH;A3EmyqBtB;;A2E7xmBE;EAAuB,gBAtgEH;A3EuyqBtB;;A2EjymBE;EAAuB,gBAtgEH;A3E2yqBtB;;A2ErymBE;EAAuB,gBAtgEH;A3E+yqBtB;;A2EzymBE;EAAuB,gBAtgEH;A3EmzqBtB;;A2E7ymBE;EAAuB,gBAtgEH;A3EuzqBtB;;A2EjzmBE;EAAuB,gBAtgEH;A3E2zqBtB;;A2ErzmBE;EAAuB,gBAtgEH;A3E+zqBtB;;A2EzzmBE;EAAuB,gBAtgEH;A3Em0qBtB;;A2E7zmBE;EAAuB,gBAtgEH;A3Eu0qBtB;;A2Ej0mBE;EAAuB,gBAtgEH;A3E20qBtB;;A2Er0mBE;EAAuB,gBAtgEH;A3E+0qBtB;;A2Ez0mBE;EAAuB,gBAtgEH;A3Em1qBtB;;A2E70mBE;EAAuB,gBAtgEH;A3Eu1qBtB;;A2Ej1mBE;EAAuB,gBAtgEH;A3E21qBtB;;A2Er1mBE;EAAuB,gBAtgEH;A3E+1qBtB;;A2Ez1mBE;EAAuB,gBAtgEH;A3Em2qBtB;;A2E71mBE;EAAuB,gBAtgEH;A3Eu2qBtB;;A2Ej2mBE;EAAuB,gBAtgEH;A3E22qBtB;;A2Er2mBE;EAAuB,gBAtgEH;A3E+2qBtB;;A2Ez2mBE;EAAuB,gBAtgEH;A3Em3qBtB;;A2E72mBE;EAAuB,gBAtgEH;A3Eu3qBtB;;A2Ej3mBE;EAAuB,gBAtgEH;A3E23qBtB;;A2Er3mBE;EAAuB,gBAtgEH;A3E+3qBtB;;A2Ez3mBE;EAAuB,gBAtgEH;A3Em4qBtB;;A2E73mBE;EAAuB,gBAtgEH;A3Eu4qBtB;;A2Ej4mBE;EAAuB,gBAtgEH;A3E24qBtB;;A2Er4mBE;EAAuB,gBAtgEH;A3E+4qBtB;;A2Ez4mBE;EAAuB,gBAtgEH;A3Em5qBtB;;A2E74mBE;EAAuB,gBAtgEH;A3Eu5qBtB;;A2Ej5mBE;EAAuB,gBAtgEH;A3E25qBtB;;A2Er5mBE;EAAuB,gBAtgEH;A3E+5qBtB;;A2Ez5mBE;EAAuB,gBAtgEH;A3Em6qBtB;;A2E75mBE;EAAuB,gBAtgEH;A3Eu6qBtB;;A2Ej6mBE;EAAuB,gBAtgEH;A3E26qBtB;;A2Er6mBE;EAAuB,gBAtgEH;A3E+6qBtB;;A2Ez6mBE;EAAuB,gBAtgEH;A3Em7qBtB;;A2E76mBE;EAAuB,gBAtgEH;A3Eu7qBtB;;A2Ej7mBE;EAAuB,gBAtgEH;A3E27qBtB;;A2Er7mBE;EAAuB,gBAtgEH;A3E+7qBtB;;A2Ez7mBE;EAAuB,gBAtgEH;A3Em8qBtB;;A2E77mBE;EAAuB,gBAtgEH;A3Eu8qBtB;;A2Ej8mBE;EAAuB,gBAtgEH;A3E28qBtB;;A2Er8mBE;EAAuB,gBAtgEH;A3E+8qBtB;;A2Ez8mBE;EAAuB,gBAtgEH;A3Em9qBtB;;A2E78mBE;EAAuB,gBAtgEH;A3Eu9qBtB;;A2Ej9mBE;EAAuB,gBAtgEH;A3E29qBtB;;A2Er9mBE;EAAuB,gBAtgEH;A3E+9qBtB;;A2Ez9mBE;EAAuB,gBAtgEH;A3Em+qBtB;;A2E79mBE;EAAuB,gBAtgEH;A3Eu+qBtB;;A2Ej+mBE;EAAuB,gBAtgEH;A3E2+qBtB;;A2Er+mBE;EAAuB,gBAtgEH;A3E++qBtB;;A2Ez+mBE;EAAuB,gBAtgEH;A3Em/qBtB;;A2E7+mBE;EAAuB,gBAtgEH;A3Eu/qBtB;;A2Ej/mBE;EAAuB,gBAtgEH;A3E2/qBtB;;A2Er/mBE;EAAuB,gBAtgEH;A3E+/qBtB;;A2Ez/mBE;EAAuB,gBAtgEH;A3EmgrBtB;;A2E7/mBE;EAAuB,gBAtgEH;A3EugrBtB;;A2EjgnBE;EAAuB,gBAtgEH;A3E2grBtB;;A2ErgnBE;EAAuB,gBAtgEH;A3E+grBtB;;A2EzgnBE;EAAuB,gBAtgEH;A3EmhrBtB;;A2E7gnBE;EAAuB,gBAtgEH;A3EuhrBtB;;A2EjhnBE;EAAuB,gBAtgEH;A3E2hrBtB;;A2ErhnBE;EAAuB,gBAtgEH;A3E+hrBtB;;A2EzhnBE;EAAuB,gBAtgEH;A3EmirBtB;;A2E7hnBE;EAAuB,gBAtgEH;A3EuirBtB;;A2EjinBE;EAAuB,gBAtgEH;A3E2irBtB;;A2ErinBE;EAAuB,gBAtgEH;A3E+irBtB;;A2EzinBE;EAAuB,gBAtgEH;A3EmjrBtB;;A2E7inBE;EAAuB,gBAtgEH;A3EujrBtB;;A2EjjnBE;EAAuB,gBAtgEH;A3E2jrBtB;;A2ErjnBE;EAAuB,gBAtgEH;A3E+jrBtB;;A2EzjnBE;EAAuB,gBAtgEH;A3EmkrBtB;;A2E7jnBE;EAAuB,gBAtgEH;A3EukrBtB;;A2EjknBE;EAAuB,gBAtgEH;A3E2krBtB;;A2ErknBE;EAAuB,gBAtgEH;A3E+krBtB;;A2EzknBE;EAAuB,gBAtgEH;A3EmlrBtB;;A2E7knBE;EAAuB,gBAtgEH;A3EulrBtB;;A2EjlnBE;EAAuB,gBAtgEH;A3E2lrBtB;;A2ErlnBE;EAAuB,gBAtgEH;A3E+lrBtB;;A2EzlnBE;EAAuB,gBAtgEH;A3EmmrBtB;;A2E7lnBE;EAAuB,gBAtgEH;A3EumrBtB;;A2EjmnBE;EAAuB,gBAtgEH;A3E2mrBtB;;A2ErmnBE;EAAuB,gBAtgEH;A3E+mrBtB;;A2EzmnBE;EAAuB,gBAtgEH;A3EmnrBtB;;A2E7mnBE;EAAuB,gBAtgEH;A3EunrBtB;;A2EjnnBE;EAAuB,gBAtgEH;A3E2nrBtB;;A2ErnnBE;EAAuB,gBAtgEH;A3E+nrBtB;;A2EznnBE;EAAuB,gBAtgEH;A3EmorBtB;;A2E7nnBE;EAAuB,gBAtgEH;A3EuorBtB;;A2EjonBE;EAAuB,gBAtgEH;A3E2orBtB;;A2EronBE;EAAuB,gBAtgEH;A3E+orBtB;;A2EzonBE;EAAuB,gBAtgEH;A3EmprBtB;;A2E7onBE;EAAuB,gBAtgEH;A3EuprBtB;;A2EjpnBE;EAAuB,gBAtgEH;A3E2prBtB;;A2ErpnBE;EAAuB,gBAtgEH;A3E+prBtB;;A2EzpnBE;EAAuB,gBAtgEH;A3EmqrBtB;;A2E7pnBE;EAAuB,gBAtgEH;A3EuqrBtB;;A2EjqnBE;EAAuB,gBAtgEH;A3E2qrBtB;;A2ErqnBE;EAAuB,gBAtgEH;A3E+qrBtB;;A2EzqnBE;EAAuB,gBAtgEH;A3EmrrBtB;;A2E7qnBE;EAAuB,gBAtgEH;A3EurrBtB;;A2EjrnBE;EAAuB,gBAtgEH;A3E2rrBtB;;A2ErrnBE;EAAuB,gBAtgEH;A3E+rrBtB;;A2EzrnBE;EAAuB,gBAtgEH;A3EmsrBtB;;A2E7rnBE;EAAuB,gBAtgEH;A3EusrBtB;;A2EjsnBE;EAAuB,gBAtgEH;A3E2srBtB;;A2ErsnBE;EAAuB,gBAtgEH;A3E+srBtB;;A2EzsnBE;EAAuB,gBAtgEH;A3EmtrBtB;;A2E7snBE;EAAuB,gBAtgEH;A3EutrBtB;;A2EjtnBE;EAAuB,gBAtgEH;A3E2trBtB;;A2ErtnBE;EAAuB,gBAtgEH;A3E+trBtB;;A2EztnBE;EAAuB,gBAtgEH;A3EmurBtB;;A2E7tnBE;EAAuB,gBAtgEH;A3EuurBtB;;A2EjunBE;EAAuB,gBAtgEH;A3E2urBtB;;A2ErunBE;EAAuB,gBAtgEH;A3E+urBtB;;A2EzunBE;EAAuB,gBAtgEH;A3EmvrBtB;;A2E7unBE;EAAuB,gBAtgEH;A3EuvrBtB;;A2EjvnBE;EAAuB,gBAtgEH;A3E2vrBtB;;A2ErvnBE;EAAuB,gBAtgEH;A3E+vrBtB;;A2EzvnBE;EAAuB,gBAtgEH;A3EmwrBtB;;A2E7vnBE;EAAuB,gBAtgEH;A3EuwrBtB;;A2EjwnBE;EAAuB,gBAtgEH;A3E2wrBtB;;A2ErwnBE;EAAuB,gBAtgEH;A3E+wrBtB;;A2EzwnBE;EAAuB,gBAtgEH;A3EmxrBtB;;A2E7wnBE;EAAuB,gBAtgEH;A3EuxrBtB;;A2EjxnBE;EAAuB,gBAtgEH;A3E2xrBtB;;A2ErxnBE;EAAuB,gBAtgEH;A3E+xrBtB;;A2EzxnBE;EAAuB,gBAtgEH;A3EmyrBtB;;A2E7xnBE;EAAuB,gBAtgEH;A3EuyrBtB;;A2EjynBE;EAAuB,gBAtgEH;A3E2yrBtB;;A2ErynBE;EAAuB,gBAtgEH;A3E+yrBtB;;A2EzynBE;EAAuB,gBAtgEH;A3EmzrBtB;;A2E7ynBE;EAAuB,gBAtgEH;A3EuzrBtB;;A2EjznBE;EAAuB,gBAtgEH;A3E2zrBtB;;A2ErznBE;EAAuB,gBAtgEH;A3E+zrBtB;;A2EzznBE;EAAuB,gBAtgEH;A3Em0rBtB;;A2E7znBE;EAAuB,gBAtgEH;A3Eu0rBtB;;A2Ej0nBE;EAAuB,gBAtgEH;A3E20rBtB;;A2Er0nBE;EAAuB,gBAtgEH;A3E+0rBtB;;A2Ez0nBE;EAAuB,gBAtgEH;A3Em1rBtB;;A2E70nBE;EAAuB,gBAtgEH;A3Eu1rBtB;;A2Ej1nBE;EAAuB,gBAtgEH;A3E21rBtB;;A2Er1nBE;EAAuB,gBAtgEH;A3E+1rBtB;;A2Ez1nBE;EAAuB,gBAtgEH;A3Em2rBtB;;A2E71nBE;EAAuB,gBAtgEH;A3Eu2rBtB;;A2Ej2nBE;EAAuB,gBAtgEH;A3E22rBtB;;A2Er2nBE;EAAuB,gBAtgEH;A3E+2rBtB;;A2Ez2nBE;EAAuB,gBAtgEH;A3Em3rBtB;;A2E72nBE;EAAuB,gBAtgEH;A3Eu3rBtB;;A2Ej3nBE;EAAuB,gBAtgEH;A3E23rBtB;;A2Er3nBE;EAAuB,gBAtgEH;A3E+3rBtB;;A2Ez3nBE;EAAuB,gBAtgEH;A3Em4rBtB;;A2E73nBE;EAAuB,gBAtgEH;A3Eu4rBtB;;A2Ej4nBE;EAAuB,gBAtgEH;A3E24rBtB;;A2Er4nBE;EAAuB,gBAtgEH;A3E+4rBtB;;A2Ez4nBE;EAAuB,gBAtgEH;A3Em5rBtB;;A2E74nBE;EAAuB,gBAtgEH;A3Eu5rBtB;;A2Ej5nBE;EAAuB,gBAtgEH;A3E25rBtB;;A2Er5nBE;EAAuB,gBAtgEH;A3E+5rBtB;;A2Ez5nBE;EAAuB,gBAtgEH;A3Em6rBtB;;A2E75nBE;EAAuB,gBAtgEH;A3Eu6rBtB;;A2Ej6nBE;EAAuB,gBAtgEH;A3E26rBtB;;A2Er6nBE;EAAuB,gBAtgEH;A3E+6rBtB;;A2Ez6nBE;EAAuB,gBAtgEH;A3Em7rBtB;;A2E76nBE;EAAuB,gBAtgEH;A3Eu7rBtB;;A2Ej7nBE;EAAuB,gBAtgEH;A3E27rBtB;;A2Er7nBE;EAAuB,gBAtgEH;A3E+7rBtB;;A2Ez7nBE;EAAuB,gBAtgEH;A3Em8rBtB;;A2E77nBE;EAAuB,gBAtgEH;A3Eu8rBtB;;A2Ej8nBE;EAAuB,gBAtgEH;A3E28rBtB;;A2Er8nBE;EAAuB,gBAtgEH;A3E+8rBtB;;A2Ez8nBE;EAAuB,gBAtgEH;A3Em9rBtB;;A2E78nBE;EAAuB,gBAtgEH;A3Eu9rBtB;;A2Ej9nBE;EAAuB,gBAtgEH;A3E29rBtB;;A2Er9nBE;EAAuB,gBAtgEH;A3E+9rBtB;;A2Ez9nBE;EAAuB,gBAtgEH;A3Em+rBtB;;A2E79nBE;EAAuB,gBAtgEH;A3Eu+rBtB;;A2Ej+nBE;EAAuB,gBAtgEH;A3E2+rBtB;;A2Er+nBE;EAAuB,gBAtgEH;A3E++rBtB;;A2Ez+nBE;EAAuB,gBAtgEH;A3Em/rBtB;;A2E7+nBE;EAAuB,gBAtgEH;A3Eu/rBtB;;A2Ej/nBE;EAAuB,gBAtgEH;A3E2/rBtB;;A2Er/nBE;EAAuB,gBAtgEH;A3E+/rBtB;;A2Ez/nBE;EAAuB,gBAtgEH;A3EmgsBtB;;A2E7/nBE;EAAuB,gBAtgEH;A3EugsBtB;;A2EjgoBE;EAAuB,gBAtgEH;A3E2gsBtB;;A2ErgoBE;EAAuB,gBAtgEH;A3E+gsBtB;;A2EzgoBE;EAAuB,gBAtgEH;A3EmhsBtB;;A2E7goBE;EAAuB,gBAtgEH;A3EuhsBtB;;A2EjhoBE;EAAuB,gBAtgEH;A3E2hsBtB;;A2ErhoBE;EAAuB,gBAtgEH;A3E+hsBtB;;A2EzhoBE;EAAuB,gBAtgEH;A3EmisBtB;;A2E7hoBE;EAAuB,gBAtgEH;A3EuisBtB;;A2EjioBE;EAAuB,gBAtgEH;A3E2isBtB;;A2ErioBE;EAAuB,gBAtgEH;A3E+isBtB;;A2EzioBE;EAAuB,gBAtgEH;A3EmjsBtB;;A2E7ioBE;EAAuB,gBAtgEH;A3EujsBtB;;A2EjjoBE;EAAuB,gBAtgEH;A3E2jsBtB;;A2ErjoBE;EAAuB,gBAtgEH;A3E+jsBtB;;A2EzjoBE;EAAuB,gBAtgEH;A3EmksBtB;;A2E7joBE;EAAuB,gBAtgEH;A3EuksBtB;;A2EjkoBE;EAAuB,gBAtgEH;A3E2ksBtB;;A2ErkoBE;EAAuB,gBAtgEH;A3E+ksBtB;;A2EzkoBE;EAAuB,gBAtgEH;A3EmlsBtB;;A2E7koBE;EAAuB,gBAtgEH;A3EulsBtB;;A2EjloBE;EAAuB,gBAtgEH;A3E2lsBtB;;A2ErloBE;EAAuB,gBAtgEH;A3E+lsBtB;;A2EzloBE;EAAuB,gBAtgEH;A3EmmsBtB;;A2E7loBE;EAAuB,gBAtgEH;A3EumsBtB;;A2EjmoBE;EAAuB,gBAtgEH;A3E2msBtB;;A2ErmoBE;EAAuB,gBAtgEH;A3E+msBtB;;A2EzmoBE;EAAuB,gBAtgEH;A3EmnsBtB;;A2E7moBE;EAAuB,gBAtgEH;A3EunsBtB;;A2EjnoBE;EAAuB,gBAtgEH;A3E2nsBtB;;A2ErnoBE;EAAuB,gBAtgEH;A3E+nsBtB;;A2EznoBE;EAAuB,gBAtgEH;A3EmosBtB;;A2E7noBE;EAAuB,gBAtgEH;A3EuosBtB;;A2EjooBE;EAAuB,gBAtgEH;A3E2osBtB;;A2ErooBE;EAAuB,gBAtgEH;A3E+osBtB;;A2EzooBE;EAAuB,gBAtgEH;A3EmpsBtB;;A2E7ooBE;EAAuB,gBAtgEH;A3EupsBtB;;A2EjpoBE;EAAuB,gBAtgEH;A3E2psBtB;;A2ErpoBE;EAAuB,gBAtgEH;A3E+psBtB;;A2EzpoBE;EAAuB,gBAtgEH;A3EmqsBtB;;A2E7poBE;EAAuB,gBAtgEH;A3EuqsBtB;;A2EjqoBE;EAAuB,gBAtgEH;A3E2qsBtB;;A2ErqoBE;EAAuB,gBAtgEH;A3E+qsBtB;;A2EzqoBE;EAAuB,gBAtgEH;A3EmrsBtB;;A2E7qoBE;EAAuB,gBAtgEH;A3EursBtB;;A2EjroBE;EAAuB,gBAtgEH;A3E2rsBtB;;A2ErroBE;EAAuB,gBAtgEH;A3E+rsBtB;;A2EzroBE;EAAuB,gBAtgEH;A3EmssBtB;;A2E7roBE;EAAuB,gBAtgEH;A3EussBtB;;A2EjsoBE;EAAuB,gBAtgEH;A3E2ssBtB;;A2ErsoBE;EAAuB,gBAtgEH;A3E+ssBtB;;A2EzsoBE;EAAuB,gBAtgEH;A3EmtsBtB;;A2E7soBE;EAAuB,gBAtgEH;A3EutsBtB;;A2EjtoBE;EAAuB,gBAtgEH;A3E2tsBtB;;A2ErtoBE;EAAuB,gBAtgEH;A3E+tsBtB;;A2EztoBE;EAAuB,gBAtgEH;A3EmusBtB;;A2E7toBE;EAAuB,gBAtgEH;A3EuusBtB;;A2EjuoBE;EAAuB,gBAtgEH;A3E2usBtB;;A2EruoBE;EAAuB,gBAtgEH;A3E+usBtB;;A2EzuoBE;EAAuB,gBAtgEH;A3EmvsBtB;;A2E7uoBE;EAAuB,gBAtgEH;A3EuvsBtB;;A2EjvoBE;EAAuB,gBAtgEH;A3E2vsBtB;;A2ErvoBE;EAAuB,gBAtgEH;A3E+vsBtB;;A2EzvoBE;EAAuB,gBAtgEH;A3EmwsBtB;;A2E7voBE;EAAuB,gBAtgEH;A3EuwsBtB;;A2EjwoBE;EAAuB,gBAtgEH;A3E2wsBtB;;A2ErwoBE;EAAuB,gBAtgEH;A3E+wsBtB;;A2EzwoBE;EAAuB,gBAtgEH;A3EmxsBtB;;A2E7woBE;EAAuB,gBAtgEH;A3EuxsBtB;;A2EjxoBE;EAAuB,gBAtgEH;A3E2xsBtB;;A2ErxoBE;EAAuB,gBAtgEH;A3E+xsBtB;;A2EzxoBE;EAAuB,gBAtgEH;A3EmysBtB;;A2E7xoBE;EAAuB,gBAtgEH;A3EuysBtB;;A2EjyoBE;EAAuB,gBAtgEH;A3E2ysBtB;;A2EryoBE;EAAuB,gBAtgEH;A3E+ysBtB;;A2EzyoBE;EAAuB,gBAtgEH;A3EmzsBtB;;A2E7yoBE;EAAuB,gBAtgEH;A3EuzsBtB;;A2EjzoBE;EAAuB,gBAtgEH;A3E2zsBtB;;A2ErzoBE;EAAuB,gBAtgEH;A3E+zsBtB;;A2EzzoBE;EAAuB,gBAtgEH;A3Em0sBtB;;A2E7zoBE;EAAuB,gBAtgEH;A3Eu0sBtB;;A2Ej0oBE;EAAuB,gBAtgEH;A3E20sBtB;;A2Er0oBE;EAAuB,gBAtgEH;A3E+0sBtB;;A2Ez0oBE;EAAuB,gBAtgEH;A3Em1sBtB;;A2E70oBE;EAAuB,gBAtgEH;A3Eu1sBtB;;A2Ej1oBE;EAAuB,gBAtgEH;A3E21sBtB;;A2Er1oBE;EAAuB,gBAtgEH;A3E+1sBtB;;A2Ez1oBE;EAAuB,gBAtgEH;A3Em2sBtB;;A2E71oBE;EAAuB,gBAtgEH;A3Eu2sBtB;;A2Ej2oBE;EAAuB,gBAtgEH;A3E22sBtB;;A2Er2oBE;EAAuB,gBAtgEH;A3E+2sBtB;;A2Ez2oBE;EAAuB,gBAtgEH;A3Em3sBtB;;A2E72oBE;EAAuB,gBAtgEH;A3Eu3sBtB;;A2Ej3oBE;EAAuB,gBAtgEH;A3E23sBtB;;A2Er3oBE;EAAuB,gBAtgEH;A3E+3sBtB;;A2Ez3oBE;EAAuB,gBAtgEH;A3Em4sBtB;;A2E73oBE;EAAuB,gBAtgEH;A3Eu4sBtB;;A2Ej4oBE;EAAuB,gBAtgEH;A3E24sBtB;;A2Er4oBE;EAAuB,gBAtgEH;A3E+4sBtB;;A2Ez4oBE;EAAuB,gBAtgEH;A3Em5sBtB;;A2E74oBE;EAAuB,gBAtgEH;A3Eu5sBtB;;A2Ej5oBE;EAAuB,gBAtgEH;A3E25sBtB;;A2Er5oBE;EAAuB,gBAtgEH;A3E+5sBtB;;A2Ez5oBE;EAAuB,gBAtgEH;A3Em6sBtB;;A2E75oBE;EAAuB,gBAtgEH;A3Eu6sBtB;;A2Ej6oBE;EAAuB,gBAtgEH;A3E26sBtB;;A2Er6oBE;EAAuB,gBAtgEH;A3E+6sBtB;;A2Ez6oBE;EAAuB,gBAtgEH;A3Em7sBtB;;A2E76oBE;EAAuB,gBAtgEH;A3Eu7sBtB;;A2Ej7oBE;EAAuB,gBAtgEH;A3E27sBtB;;A2Er7oBE;EAAuB,gBAtgEH;A3E+7sBtB;;A2Ez7oBE;EAAuB,gBAtgEH;A3Em8sBtB;;A2E77oBE;EAAuB,gBAtgEH;A3Eu8sBtB;;A2Ej8oBE;EAAuB,gBAtgEH;A3E28sBtB;;A2Er8oBE;EAAuB,gBAtgEH;A3E+8sBtB;;A2Ez8oBE;EAAuB,gBAtgEH;A3Em9sBtB;;A2E78oBE;EAAuB,gBAtgEH;A3Eu9sBtB;;A2Ej9oBE;EAAuB,gBAtgEH;A3E29sBtB;;A2Er9oBE;EAAuB,gBAtgEH;A3E+9sBtB;;A2Ez9oBE;EAAuB,gBAtgEH;A3Em+sBtB;;A2E79oBE;EAAuB,gBAtgEH;A3Eu+sBtB;;A2Ej+oBE;EAAuB,gBAtgEH;A3E2+sBtB;;A2Er+oBE;EAAuB,gBAtgEH;A3E++sBtB;;A2Ez+oBE;EAAuB,gBAtgEH;A3Em/sBtB;;A2E7+oBE;EAAuB,gBAtgEH;A3Eu/sBtB;;A2Ej/oBE;EAAuB,gBAtgEH;A3E2/sBtB;;A2Er/oBE;EAAuB,gBAtgEH;A3E+/sBtB;;A2Ez/oBE;EAAuB,gBAtgEH;A3EmgtBtB;;A2E7/oBE;EAAuB,gBAtgEH;A3EugtBtB;;A2EjgpBE;EAAuB,gBAtgEH;A3E2gtBtB;;A2ErgpBE;EAAuB,gBAtgEH;A3E+gtBtB;;A2EzgpBE;EAAuB,gBAtgEH;A3EmhtBtB;;A2E7gpBE;EAAuB,gBAtgEH;A3EuhtBtB;;A2EjhpBE;EAAuB,gBAtgEH;A3E2htBtB;;A2ErhpBE;EAAuB,gBAtgEH;A3E+htBtB;;A2EzhpBE;EAAuB,gBAtgEH;A3EmitBtB;;A2E7hpBE;EAAuB,gBAtgEH;A3EuitBtB;;A2EjipBE;EAAuB,gBAtgEH;A3E2itBtB;;A2EripBE;EAAuB,gBAtgEH;A3E+itBtB;;A2EzipBE;EAAuB,gBAtgEH;A3EmjtBtB;;A2E7ipBE;EAAuB,gBAtgEH;A3EujtBtB;;A2EjjpBE;EAAuB,gBAtgEH;A3E2jtBtB;;A2ErjpBE;EAAuB,gBAtgEH;A3E+jtBtB;;A2EzjpBE;EAAuB,gBAtgEH;A3EmktBtB;;A2E7jpBE;EAAuB,gBAtgEH;A3EuktBtB;;A2EjkpBE;EAAuB,gBAtgEH;A3E2ktBtB;;A2ErkpBE;EAAuB,gBAtgEH;A3E+ktBtB;;A2EzkpBE;EAAuB,gBAtgEH;A3EmltBtB;;A2E7kpBE;EAAuB,gBAtgEH;A3EultBtB;;A2EjlpBE;EAAuB,gBAtgEH;A3E2ltBtB;;A2ErlpBE;EAAuB,gBAtgEH;A3E+ltBtB;;A2EzlpBE;EAAuB,gBAtgEH;A3EmmtBtB;;A2E7lpBE;EAAuB,gBAtgEH;A3EumtBtB;;A2EjmpBE;EAAuB,gBAtgEH;A3E2mtBtB;;A2ErmpBE;EAAuB,gBAtgEH;A3E+mtBtB;;A2EzmpBE;EAAuB,gBAtgEH;A3EmntBtB;;A2E7mpBE;EAAuB,gBAtgEH;A3EuntBtB;;A2EjnpBE;EAAuB,gBAtgEH;A3E2ntBtB;;A2ErnpBE;EAAuB,gBAtgEH;A3E+ntBtB;;A2EznpBE;EAAuB,gBAtgEH;A3EmotBtB;;A2E7npBE;EAAuB,gBAtgEH;A3EuotBtB;;A2EjopBE;EAAuB,gBAtgEH;A3E2otBtB;;A2EropBE;EAAuB,gBAtgEH;A3E+otBtB;;A2EzopBE;EAAuB,gBAtgEH;A3EmptBtB;;A2E7opBE;EAAuB,gBAtgEH;A3EuptBtB;;A2EjppBE;EAAuB,gBAtgEH;A3E2ptBtB;;A2ErppBE;EAAuB,gBAtgEH;A3E+ptBtB;;A2EzppBE;EAAuB,gBAtgEH;A3EmqtBtB;;A2E7ppBE;EAAuB,gBAtgEH;A3EuqtBtB;;A2EjqpBE;EAAuB,gBAtgEH;A3E2qtBtB;;A2ErqpBE;EAAuB,gBAtgEH;A3E+qtBtB;;A2EzqpBE;EAAuB,gBAtgEH;A3EmrtBtB;;A2E7qpBE;EAAuB,gBAtgEH;A3EurtBtB;;A2EjrpBE;EAAuB,gBAtgEH;A3E2rtBtB;;A2ErrpBE;EAAuB,gBAtgEH;A3E+rtBtB;;A2EzrpBE;EAAuB,gBAtgEH;A3EmstBtB;;A2E7rpBE;EAAuB,gBAtgEH;A3EustBtB;;A2EjspBE;EAAuB,gBAtgEH;A3E2stBtB;;A2ErspBE;EAAuB,gBAtgEH;A3E+stBtB;;A2EzspBE;EAAuB,gBAtgEH;A3EmttBtB;;A2E7spBE;EAAuB,gBAtgEH;A3EuttBtB;;A2EjtpBE;EAAuB,gBAtgEH;A3E2ttBtB;;A2ErtpBE;EAAuB,gBAtgEH;A3E+ttBtB;;A2EztpBE;EAAuB,gBAtgEH;A3EmutBtB;;A2E7tpBE;EAAuB,gBAtgEH;A3EuutBtB;;A2EjupBE;EAAuB,gBAtgEH;A3E2utBtB;;A2ErupBE;EAAuB,gBAtgEH;A3E+utBtB;;A2EzupBE;EAAuB,gBAtgEH;A3EmvtBtB;;A2E7upBE;EAAuB,gBAtgEH;A3EuvtBtB;;A2EjvpBE;EAAuB,gBAtgEH;A3E2vtBtB;;A2ErvpBE;EAAuB,gBAtgEH;A3E+vtBtB;;A2EzvpBE;EAAuB,gBAtgEH;A3EmwtBtB;;A2E7vpBE;EAAuB,gBAtgEH;A3EuwtBtB;;A2EjwpBE;EAAuB,gBAtgEH;A3E2wtBtB;;A2ErwpBE;EAAuB,gBAtgEH;A3E+wtBtB;;A2EzwpBE;EAAuB,gBAtgEH;A3EmxtBtB;;A2E7wpBE;EAAuB,gBAtgEH;A3EuxtBtB;;A2EjxpBE;EAAuB,gBAtgEH;A3E2xtBtB;;A2ErxpBE;EAAuB,gBAtgEH;A3E+xtBtB;;A2EzxpBE;EAAuB,gBAtgEH;A3EmytBtB;;A2E7xpBE;EAAuB,gBAtgEH;A3EuytBtB;;A2EjypBE;EAAuB,gBAtgEH;A3E2ytBtB;;A2ErypBE;EAAuB,gBAtgEH;A3E+ytBtB;;A2EzypBE;EAAuB,gBAtgEH;A3EmztBtB;;A2E7ypBE;EAAuB,gBAtgEH;A3EuztBtB;;A2EjzpBE;EAAuB,gBAtgEH;A3E2ztBtB;;A2ErzpBE;EAAuB,gBAtgEH;A3E+ztBtB;;A2EzzpBE;EAAuB,gBAtgEH;A3Em0tBtB;;A2E7zpBE;EAAuB,gBAtgEH;A3Eu0tBtB;;A2Ej0pBE;EAAuB,gBAtgEH;A3E20tBtB;;A2Er0pBE;EAAuB,gBAtgEH;A3E+0tBtB;;A2Ez0pBE;EAAuB,gBAtgEH;A3Em1tBtB;;A2E70pBE;EAAuB,gBAtgEH;A3Eu1tBtB;;A2Ej1pBE;EAAuB,gBAtgEH;A3E21tBtB;;A2Er1pBE;EAAuB,gBAtgEH;A3E+1tBtB;;A2Ez1pBE;EAAuB,gBAtgEH;A3Em2tBtB;;A2E71pBE;EAAuB,gBAtgEH;A3Eu2tBtB;;A2Ej2pBE;EAAuB,gBAtgEH;A3E22tBtB;;A2Er2pBE;EAAuB,gBAtgEH;A3E+2tBtB;;A2Ez2pBE;EAAuB,gBAtgEH;A3Em3tBtB;;A2E72pBE;EAAuB,gBAtgEH;A3Eu3tBtB;;A2Ej3pBE;EAAuB,gBAtgEH;A3E23tBtB;;A2Er3pBE;EAAuB,gBAtgEH;A3E+3tBtB;;A2Ez3pBE;EAAuB,gBAtgEH;A3Em4tBtB;;A2E73pBE;EAAuB,gBAtgEH;A3Eu4tBtB;;A2Ej4pBE;EAAuB,gBAtgEH;A3E24tBtB;;A2Er4pBE;EAAuB,gBAtgEH;A3E+4tBtB;;A2Ez4pBE;EAAuB,gBAtgEH;A3Em5tBtB;;A2E74pBE;EAAuB,gBAtgEH;A3Eu5tBtB;;A2Ej5pBE;EAAuB,gBAtgEH;A3E25tBtB;;A2Er5pBE;EAAuB,gBAtgEH;A3E+5tBtB;;A2Ez5pBE;EAAuB,gBAtgEH;A3Em6tBtB;;A2E75pBE;EAAuB,gBAtgEH;A3Eu6tBtB;;A2Ej6pBE;EAAuB,gBAtgEH;A3E26tBtB;;A2Er6pBE;EAAuB,gBAtgEH;A3E+6tBtB;;A2Ez6pBE;EAAuB,gBAtgEH;A3Em7tBtB;;A2E76pBE;EAAuB,gBAtgEH;A3Eu7tBtB;;A2Ej7pBE;EAAuB,gBAtgEH;A3E27tBtB;;A2Er7pBE;EAAuB,gBAtgEH;A3E+7tBtB;;A2Ez7pBE;EAAuB,gBAtgEH;A3Em8tBtB;;A2E77pBE;EAAuB,gBAtgEH;A3Eu8tBtB;;A2Ej8pBE;EAAuB,gBAtgEH;A3E28tBtB;;A2Er8pBE;EAAuB,gBAtgEH;A3E+8tBtB;;A2Ez8pBE;EAAuB,gBAtgEH;A3Em9tBtB;;A2E78pBE;EAAuB,gBAtgEH;A3Eu9tBtB;;A2Ej9pBE;EAAuB,gBAtgEH;A3E29tBtB;;A2Er9pBE;EAAuB,gBAtgEH;A3E+9tBtB;;A2Ez9pBE;EAAuB,gBAtgEH;A3Em+tBtB;;A2E79pBE;EAAuB,gBAtgEH;A3Eu+tBtB;;A2Ej+pBE;EAAuB,gBAtgEH;A3E2+tBtB;;A2Er+pBE;EAAuB,gBAtgEH;A3E++tBtB;;A2Ez+pBE;EAAuB,gBAtgEH;A3Em/tBtB;;A2E7+pBE;EAAuB,gBAtgEH;A3Eu/tBtB;;A2Ej/pBE;EAAuB,gBAtgEH;A3E2/tBtB;;A2Er/pBE;EAAuB,gBAtgEH;A3E+/tBtB;;A2Ez/pBE;EAAuB,gBAtgEH;A3EmguBtB;;A2E7/pBE;EAAuB,gBAtgEH;A3EuguBtB;;A2EjgqBE;EAAuB,gBAtgEH;A3E2guBtB;;A2ErgqBE;EAAuB,gBAtgEH;A3E+guBtB;;A2EzgqBE;EAAuB,gBAtgEH;A3EmhuBtB;;A2E7gqBE;EAAuB,gBAtgEH;A3EuhuBtB;;A2EjhqBE;EAAuB,gBAtgEH;A3E2huBtB;;A2ErhqBE;EAAuB,gBAtgEH;A3E+huBtB;;A2EzhqBE;EAAuB,gBAtgEH;A3EmiuBtB;;A2E7hqBE;EAAuB,gBAtgEH;A3EuiuBtB;;A2EjiqBE;EAAuB,gBAtgEH;A3E2iuBtB;;A2EriqBE;EAAuB,gBAtgEH;A3E+iuBtB;;A2EziqBE;EAAuB,gBAtgEH;A3EmjuBtB;;A2E7iqBE;EAAuB,gBAtgEH;A3EujuBtB;;A2EjjqBE;EAAuB,gBAtgEH;A3E2juBtB;;A2ErjqBE;EAAuB,gBAtgEH;A3E+juBtB;;A2EzjqBE;EAAuB,gBAtgEH;A3EmkuBtB;;A2E7jqBE;EAAuB,gBAtgEH;A3EukuBtB;;A2EjkqBE;EAAuB,gBAtgEH;A3E2kuBtB;;A2ErkqBE;EAAuB,gBAtgEH;A3E+kuBtB;;A2EzkqBE;EAAuB,gBAtgEH;A3EmluBtB;;A2E7kqBE;EAAuB,gBAtgEH;A3EuluBtB;;A2EjlqBE;EAAuB,gBAtgEH;A3E2luBtB;;A2ErlqBE;EAAuB,gBAtgEH;A3E+luBtB;;A2EzlqBE;EAAuB,gBAtgEH;A3EmmuBtB;;A2E7lqBE;EAAuB,gBAtgEH;A3EumuBtB;;A2EjmqBE;EAAuB,gBAtgEH;A3E2muBtB;;A2ErmqBE;EAAuB,gBAtgEH;A3E+muBtB;;A2EzmqBE;EAAuB,gBAtgEH;A3EmnuBtB;;A2E7mqBE;EAAuB,gBAtgEH;A3EunuBtB;;A2EjnqBE;EAAuB,gBAtgEH;A3E2nuBtB;;A2ErnqBE;EAAuB,gBAtgEH;A3E+nuBtB;;A2EznqBE;EAAuB,gBAtgEH;A3EmouBtB;;A2E7nqBE;EAAuB,gBAtgEH;A3EuouBtB;;A2EjoqBE;EAAuB,gBAtgEH;A3E2ouBtB;;A2EroqBE;EAAuB,gBAtgEH;A3E+ouBtB;;A2EzoqBE;EAAuB,gBAtgEH;A3EmpuBtB;;A2E7oqBE;EAAuB,gBAtgEH;A3EupuBtB;;A2EjpqBE;EAAuB,gBAtgEH;A3E2puBtB;;A2ErpqBE;EAAuB,gBAtgEH;A3E+puBtB;;A2EzpqBE;EAAuB,gBAtgEH;A3EmquBtB;;A2E7pqBE;EAAuB,gBAtgEH;A3EuquBtB;;A2EjqqBE;EAAuB,gBAtgEH;A3E2quBtB;;A2ErqqBE;EAAuB,gBAtgEH;A3E+quBtB;;A2EzqqBE;EAAuB,gBAtgEH;A3EmruBtB;;A2E7qqBE;EAAuB,gBAtgEH;A3EuruBtB;;A2EjrqBE;EAAuB,gBAtgEH;A3E2ruBtB;;A2ErrqBE;EAAuB,gBAtgEH;A3E+ruBtB;;A2EzrqBE;EAAuB,gBAtgEH;A3EmsuBtB;;A2E7rqBE;EAAuB,gBAtgEH;A3EusuBtB;;A2EjsqBE;EAAuB,gBAtgEH;A3E2suBtB;;A2ErsqBE;EAAuB,gBAtgEH;A3E+suBtB;;A2EzsqBE;EAAuB,gBAtgEH;A3EmtuBtB;;A2E7sqBE;EAAuB,gBAtgEH;A3EutuBtB;;A2EjtqBE;EAAuB,gBAtgEH;A3E2tuBtB;;A2ErtqBE;EAAuB,gBAtgEH;A3E+tuBtB;;A2EztqBE;EAAuB,gBAtgEH;A3EmuuBtB;;A2E7tqBE;EAAuB,gBAtgEH;A3EuuuBtB;;A2EjuqBE;EAAuB,gBAtgEH;A3E2uuBtB;;A2EruqBE;EAAuB,gBAtgEH;A3E+uuBtB;;A2EzuqBE;EAAuB,gBAtgEH;A3EmvuBtB;;A2E7uqBE;EAAuB,gBAtgEH;A3EuvuBtB;;A2EjvqBE;EAAuB,gBAtgEH;A3E2vuBtB;;A2ErvqBE;EAAuB,gBAtgEH;A3E+vuBtB;;A2EzvqBE;EAAuB,gBAtgEH;A3EmwuBtB;;A2E7vqBE;EAAuB,gBAtgEH;A3EuwuBtB;;A2EjwqBE;EAAuB,gBAtgEH;A3E2wuBtB;;A2ErwqBE;EAAuB,gBAtgEH;A3E+wuBtB;;A2EzwqBE;EAAuB,gBAtgEH;A3EmxuBtB;;A2E7wqBE;EAAuB,gBAtgEH;A3EuxuBtB;;A2EjxqBE;EAAuB,gBAtgEH;A3E2xuBtB;;A2ErxqBE;EAAuB,gBAtgEH;A3E+xuBtB;;A2EzxqBE;EAAuB,gBAtgEH;A3EmyuBtB;;A2E7xqBE;EAAuB,gBAtgEH;A3EuyuBtB;;A2EjyqBE;EAAuB,gBAtgEH;A3E2yuBtB;;A2EryqBE;EAAuB,gBAtgEH;A3E+yuBtB;;A2EzyqBE;EAAuB,gBAtgEH;A3EmzuBtB;;A2E7yqBE;EAAuB,gBAtgEH;A3EuzuBtB;;A2EjzqBE;EAAuB,gBAtgEH;A3E2zuBtB;;A2ErzqBE;EAAuB,gBAtgEH;A3E+zuBtB;;A2EzzqBE;EAAuB,gBAtgEH;A3Em0uBtB;;A2E7zqBE;EAAuB,gBAtgEH;A3Eu0uBtB;;A2Ej0qBE;EAAuB,gBAtgEH;A3E20uBtB;;A2Er0qBE;EAAuB,gBAtgEH;A3E+0uBtB;;A2Ez0qBE;EAAuB,gBAtgEH;A3Em1uBtB;;A2E70qBE;EAAuB,gBAtgEH;A3Eu1uBtB;;A2Ej1qBE;EAAuB,gBAtgEH;A3E21uBtB;;A2Er1qBE;EAAuB,gBAtgEH;A3E+1uBtB;;A2Ez1qBE;EAAuB,gBAtgEH;A3Em2uBtB;;A2E71qBE;EAAuB,gBAtgEH;A3Eu2uBtB;;A2Ej2qBE;EAAuB,gBAtgEH;A3E22uBtB;;A2Er2qBE;EAAuB,gBAtgEH;A3E+2uBtB;;A2Ez2qBE;EAAuB,gBAtgEH;A3Em3uBtB;;A2E72qBE;EAAuB,gBAtgEH;A3Eu3uBtB;;A2Ej3qBE;EAAuB,gBAtgEH;A3E23uBtB;;A2Er3qBE;EAAuB,gBAtgEH;A3E+3uBtB;;A2Ez3qBE;EAAuB,gBAtgEH;A3Em4uBtB;;A2E73qBE;EAAuB,gBAtgEH;A3Eu4uBtB;;A2Ej4qBE;EAAuB,gBAtgEH;A3E24uBtB;;A2Er4qBE;EAAuB,gBAtgEH;A3E+4uBtB;;A2Ez4qBE;EAAuB,gBAtgEH;A3Em5uBtB;;A2E74qBE;EAAuB,gBAtgEH;A3Eu5uBtB;;A2Ej5qBE;EAAuB,gBAtgEH;A3E25uBtB;;A2Er5qBE;EAAuB,gBAtgEH;A3E+5uBtB;;A2Ez5qBE;EAAuB,gBAtgEH;A3Em6uBtB;;A2E75qBE;EAAuB,gBAtgEH;A3Eu6uBtB;;A2Ej6qBE;EAAuB,gBAtgEH;A3E26uBtB;;A2Er6qBE;EAAuB,gBAtgEH;A3E+6uBtB;;A2Ez6qBE;EAAuB,gBAtgEH;A3Em7uBtB;;A2E76qBE;EAAuB,gBAtgEH;A3Eu7uBtB;;A2Ej7qBE;EAAuB,gBAtgEH;A3E27uBtB;;A2Er7qBE;EAAuB,gBAtgEH;A3E+7uBtB;;A2Ez7qBE;EAAuB,gBAtgEH;A3Em8uBtB;;A2E77qBE;EAAuB,gBAtgEH;A3Eu8uBtB;;A2Ej8qBE;EAAuB,gBAtgEH;A3E28uBtB;;A2Er8qBE;EAAuB,gBAtgEH;A3E+8uBtB;;A2Ez8qBE;EAAuB,gBAtgEH;A3Em9uBtB;;A2E78qBE;EAAuB,gBAtgEH;A3Eu9uBtB;;A2Ej9qBE;EAAuB,gBAtgEH;A3E29uBtB;;A2Er9qBE;EAAuB,gBAtgEH;A3E+9uBtB;;A2Ez9qBE;EAAuB,gBAtgEH;A3Em+uBtB;;A2E79qBE;EAAuB,gBAtgEH;A3Eu+uBtB;;A2Ej+qBE;EAAuB,gBAtgEH;A3E2+uBtB;;A2Er+qBE;EAAuB,gBAtgEH;A3E++uBtB;;A2Ez+qBE;EAAuB,gBAtgEH;A3Em/uBtB;;A2E7+qBE;EAAuB,gBAtgEH;A3Eu/uBtB;;A2Ej/qBE;EAAuB,gBAtgEH;A3E2/uBtB;;A2Er/qBE;EAAuB,gBAtgEH;A3E+/uBtB;;A2Ez/qBE;EAAuB,gBAtgEH;A3EmgvBtB;;A2E7/qBE;EAAuB,gBAtgEH;A3EugvBtB;;A2EjgrBE;EAAuB,gBAtgEH;A3E2gvBtB;;A2ErgrBE;EAAuB,gBAtgEH;A3E+gvBtB;;A2EzgrBE;EAAuB,gBAtgEH;A3EmhvBtB;;A2E7grBE;EAAuB,gBAtgEH;A3EuhvBtB;;A2EjhrBE;EAAuB,gBAtgEH;A3E2hvBtB;;A2ErhrBE;EAAuB,gBAtgEH;A3E+hvBtB;;A2EzhrBE;EAAuB,gBAtgEH;A3EmivBtB;;A2E7hrBE;EAAuB,gBAtgEH;A3EuivBtB;;A2EjirBE;EAAuB,gBAtgEH;A3E2ivBtB;;A2ErirBE;EAAuB,gBAtgEH;A3E+ivBtB;;A2EzirBE;EAAuB,gBAtgEH;A3EmjvBtB;;A2E7irBE;EAAuB,gBAtgEH;A3EujvBtB;;A2EjjrBE;EAAuB,gBAtgEH;A3E2jvBtB;;A2ErjrBE;EAAuB,gBAtgEH;A3E+jvBtB;;A2EzjrBE;EAAuB,gBAtgEH;A3EmkvBtB;;A2E7jrBE;EAAuB,gBAtgEH;A3EukvBtB;;A2EjkrBE;EAAuB,gBAtgEH;A3E2kvBtB;;A2ErkrBE;EAAuB,gBAtgEH;A3E+kvBtB;;A2EzkrBE;EAAuB,gBAtgEH;A3EmlvBtB;;A2E7krBE;EAAuB,gBAtgEH;A3EulvBtB;;A2EjlrBE;EAAuB,gBAtgEH;A3E2lvBtB;;A2ErlrBE;EAAuB,gBAtgEH;A3E+lvBtB;;A2EzlrBE;EAAuB,gBAtgEH;A3EmmvBtB;;A2E7lrBE;EAAuB,gBAtgEH;A3EumvBtB;;A2EjmrBE;EAAuB,gBAtgEH;A3E2mvBtB;;A2ErmrBE;EAAuB,gBAtgEH;A3E+mvBtB;;A2EzmrBE;EAAuB,gBAtgEH;A3EmnvBtB;;A2E7mrBE;EAAuB,gBAtgEH;A3EunvBtB;;A2EjnrBE;EAAuB,gBAtgEH;A3E2nvBtB;;A2ErnrBE;EAAuB,gBAtgEH;A3E+nvBtB;;A2EznrBE;EAAuB,gBAtgEH;A3EmovBtB;;A2E7nrBE;EAAuB,gBAtgEH;A3EuovBtB;;A2EjorBE;EAAuB,gBAtgEH;A3E2ovBtB;;A2ErorBE;EAAuB,gBAtgEH;A3E+ovBtB;;A2EzorBE;EAAuB,gBAtgEH;A3EmpvBtB;;A2E7orBE;EAAuB,gBAtgEH;A3EupvBtB;;A2EjprBE;EAAuB,gBAtgEH;A3E2pvBtB;;A2ErprBE;EAAuB,gBAtgEH;A3E+pvBtB;;A2EzprBE;EAAuB,gBAtgEH;A3EmqvBtB;;A2E7prBE;EAAuB,gBAtgEH;A3EuqvBtB;;A2EjqrBE;EAAuB,gBAtgEH;A3E2qvBtB;;A2ErqrBE;EAAuB,gBAtgEH;A3E+qvBtB;;A2EzqrBE;EAAuB,gBAtgEH;A3EmrvBtB;;A2E7qrBE;EAAuB,gBAtgEH;A3EurvBtB;;A2EjrrBE;EAAuB,gBAtgEH;A3E2rvBtB;;A2ErrrBE;EAAuB,gBAtgEH;A3E+rvBtB;;A2EzrrBE;EAAuB,gBAtgEH;A3EmsvBtB;;A2E7rrBE;EAAuB,gBAtgEH;A3EusvBtB;;A2EjsrBE;EAAuB,gBAtgEH;A3E2svBtB;;A2ErsrBE;EAAuB,gBAtgEH;A3E+svBtB;;A2EzsrBE;EAAuB,gBAtgEH;A3EmtvBtB;;A2E7srBE;EAAuB,gBAtgEH;A3EutvBtB;;A2EjtrBE;EAAuB,gBAtgEH;A3E2tvBtB;;A2ErtrBE;EAAuB,gBAtgEH;A3E+tvBtB;;A2EztrBE;EAAuB,gBAtgEH;A3EmuvBtB;;A2E7trBE;EAAuB,gBAtgEH;A3EuuvBtB;;A2EjurBE;EAAuB,gBAtgEH;A3E2uvBtB;;A2ErurBE;EAAuB,gBAtgEH;A3E+uvBtB;;A2EzurBE;EAAuB,gBAtgEH;A3EmvvBtB;;A2E7urBE;EAAuB,gBAtgEH;A3EuvvBtB;;A2EjvrBE;EAAuB,gBAtgEH;A3E2vvBtB;;A2ErvrBE;EAAuB,gBAtgEH;A3E+vvBtB;;A2EzvrBE;EAAuB,gBAtgEH;A3EmwvBtB;;A2E7vrBE;EAAuB,gBAtgEH;A3EuwvBtB;;A2EjwrBE;EAAuB,gBAtgEH;A3E2wvBtB;;A2ErwrBE;EAAuB,gBAtgEH;A3E+wvBtB;;A2EzwrBE;EAAuB,gBAtgEH;A3EmxvBtB;;A2E7wrBE;EAAuB,gBAtgEH;A3EuxvBtB;;A2EjxrBE;EAAuB,gBAtgEH;A3E2xvBtB;;A2ErxrBE;EAAuB,gBAtgEH;A3E+xvBtB;;A2EzxrBE;EAAuB,gBAtgEH;A3EmyvBtB;;A2E7xrBE;EAAuB,gBAtgEH;A3EuyvBtB;;A2EjyrBE;EAAuB,gBAtgEH;A3E2yvBtB;;A2EryrBE;EAAuB,gBAtgEH;A3E+yvBtB;;A2EzyrBE;EAAuB,gBAtgEH;A3EmzvBtB;;A2E7yrBE;EAAuB,gBAtgEH;A3EuzvBtB;;A2EjzrBE;EAAuB,gBAtgEH;A3E2zvBtB;;A2ErzrBE;EAAuB,gBAtgEH;A3E+zvBtB;;A2EzzrBE;EAAuB,gBAtgEH;A3Em0vBtB;;A2E7zrBE;EAAuB,gBAtgEH;A3Eu0vBtB;;A2Ej0rBE;EAAuB,gBAtgEH;A3E20vBtB;;A2Er0rBE;EAAuB,gBAtgEH;A3E+0vBtB;;A2Ez0rBE;EAAuB,gBAtgEH;A3Em1vBtB;;A2E70rBE;EAAuB,gBAtgEH;A3Eu1vBtB;;A2Ej1rBE;EAAuB,gBAtgEH;A3E21vBtB;;A2Er1rBE;EAAuB,gBAtgEH;A3E+1vBtB;;A2Ez1rBE;EAAuB,gBAtgEH;A3Em2vBtB;;A2E71rBE;EAAuB,gBAtgEH;A3Eu2vBtB;;A2Ej2rBE;EAAuB,gBAtgEH;A3E22vBtB;;A2Er2rBE;EAAuB,gBAtgEH;A3E+2vBtB;;A2Ez2rBE;EAAuB,gBAtgEH;A3Em3vBtB;;A2E72rBE;EAAuB,gBAtgEH;A3Eu3vBtB;;A2Ej3rBE;EAAuB,gBAtgEH;A3E23vBtB;;A2Er3rBE;EAAuB,gBAtgEH;A3E+3vBtB;;A2Ez3rBE;EAAuB,gBAtgEH;A3Em4vBtB;;A2E73rBE;EAAuB,gBAtgEH;A3Eu4vBtB;;A2Ej4rBE;EAAuB,gBAtgEH;A3E24vBtB;;A2Er4rBE;EAAuB,gBAtgEH;A3E+4vBtB;;A2Ez4rBE;EAAuB,gBAtgEH;A3Em5vBtB;;A2E74rBE;EAAuB,gBAtgEH;A3Eu5vBtB;;A2Ej5rBE;EAAuB,gBAtgEH;A3E25vBtB;;A2Er5rBE;EAAuB,gBAtgEH;A3E+5vBtB;;A2Ez5rBE;EAAuB,gBAtgEH;A3Em6vBtB;;A2E75rBE;EAAuB,gBAtgEH;A3Eu6vBtB;;A2Ej6rBE;EAAuB,gBAtgEH;A3E26vBtB;;A2Er6rBE;EAAuB,gBAtgEH;A3E+6vBtB;;A2Ez6rBE;EAAuB,gBAtgEH;A3Em7vBtB;;A2E76rBE;EAAuB,gBAtgEH;A3Eu7vBtB;;A2Ej7rBE;EAAuB,gBAtgEH;A3E27vBtB;;A2Er7rBE;EAAuB,gBAtgEH;A3E+7vBtB;;A2Ez7rBE;EAAuB,gBAtgEH;A3Em8vBtB;;A2E77rBE;EAAuB,gBAtgEH;A3Eu8vBtB;;A2Ej8rBE;EAAuB,gBAtgEH;A3E28vBtB;;A2Er8rBE;EAAuB,gBAtgEH;A3E+8vBtB;;A2Ez8rBE;EAAuB,gBAtgEH;A3Em9vBtB;;A2E78rBE;EAAuB,gBAtgEH;A3Eu9vBtB;;A2Ej9rBE;EAAuB,gBAtgEH;A3E29vBtB;;A2Er9rBE;EAAuB,gBAtgEH;A3E+9vBtB;;A2Ez9rBE;EAAuB,gBAtgEH;A3Em+vBtB;;A2E79rBE;EAAuB,gBAtgEH;A3Eu+vBtB;;A2Ej+rBE;EAAuB,gBAtgEH;A3E2+vBtB;;A2Er+rBE;EAAuB,gBAtgEH;A3E++vBtB;;A2Ez+rBE;EAAuB,gBAtgEH;A3Em/vBtB;;A2E7+rBE;EAAuB,gBAtgEH;A3Eu/vBtB;;A2Ej/rBE;EAAuB,gBAtgEH;A3E2/vBtB;;A2Er/rBE;EAAuB,gBAtgEH;A3E+/vBtB;;A2Ez/rBE;EAAuB,gBAtgEH;A3EmgwBtB;;A2E7/rBE;EAAuB,gBAtgEH;A3EugwBtB;;A2EjgsBE;EAAuB,gBAtgEH;A3E2gwBtB;;A2ErgsBE;EAAuB,gBAtgEH;A3E+gwBtB;;A2EzgsBE;EAAuB,gBAtgEH;A3EmhwBtB;;A2E7gsBE;EAAuB,gBAtgEH;A3EuhwBtB;;A2EjhsBE;EAAuB,gBAtgEH;A3E2hwBtB;;A2ErhsBE;EAAuB,gBAtgEH;A3E+hwBtB;;A2EzhsBE;EAAuB,gBAtgEH;A3EmiwBtB;;A2E7hsBE;EAAuB,gBAtgEH;A3EuiwBtB;;A2EjisBE;EAAuB,gBAtgEH;A3E2iwBtB;;A2ErisBE;EAAuB,gBAtgEH;A3E+iwBtB;;A2EzisBE;EAAuB,gBAtgEH;A3EmjwBtB;;A2E7isBE;EAAuB,gBAtgEH;A3EujwBtB;;A2EjjsBE;EAAuB,gBAtgEH;A3E2jwBtB;;A2ErjsBE;EAAuB,gBAtgEH;A3E+jwBtB;;A2EzjsBE;EAAuB,gBAtgEH;A3EmkwBtB;;A2E7jsBE;EAAuB,gBAtgEH;A3EukwBtB;;A2EjksBE;EAAuB,gBAtgEH;A3E2kwBtB;;A2ErksBE;EAAuB,gBAtgEH;A3E+kwBtB;;A2EzksBE;EAAuB,gBAtgEH;A3EmlwBtB;;A2E7ksBE;EAAuB,gBAtgEH;A3EulwBtB;;A2EjlsBE;EAAuB,gBAtgEH;A3E2lwBtB;;A2ErlsBE;EAAuB,gBAtgEH;A3E+lwBtB;;A2EzlsBE;EAAuB,gBAtgEH;A3EmmwBtB;;A2E7lsBE;EAAuB,gBAtgEH;A3EumwBtB;;A2EjmsBE;EAAuB,gBAtgEH;A3E2mwBtB;;A2ErmsBE;EAAuB,gBAtgEH;A3E+mwBtB;;A2EzmsBE;EAAuB,gBAtgEH;A3EmnwBtB;;A2E7msBE;EAAuB,gBAtgEH;A3EunwBtB;;A2EjnsBE;EAAuB,gBAtgEH;A3E2nwBtB;;A2ErnsBE;EAAuB,gBAtgEH;A3E+nwBtB;;A2EznsBE;EAAuB,gBAtgEH;A3EmowBtB;;A2E7nsBE;EAAuB,gBAtgEH;A3EuowBtB;;A2EjosBE;EAAuB,gBAtgEH;A3E2owBtB;;A2ErosBE;EAAuB,gBAtgEH;A3E+owBtB;;A2EzosBE;EAAuB,gBAtgEH;A3EmpwBtB;;A2E7osBE;EAAuB,gBAtgEH;A3EupwBtB;;A2EjpsBE;EAAuB,gBAtgEH;A3E2pwBtB;;A2ErpsBE;EAAuB,gBAtgEH;A3E+pwBtB;;A2EzpsBE;EAAuB,gBAtgEH;A3EmqwBtB;;A2E7psBE;EAAuB,gBAtgEH;A3EuqwBtB;;A2EjqsBE;EAAuB,gBAtgEH;A3E2qwBtB;;A2ErqsBE;EAAuB,gBAtgEH;A3E+qwBtB;;A2EzqsBE;EAAuB,gBAtgEH;A3EmrwBtB;;A2E7qsBE;EAAuB,gBAtgEH;A3EurwBtB;;A2EjrsBE;EAAuB,gBAtgEH;A3E2rwBtB;;A2ErrsBE;EAAuB,gBAtgEH;A3E+rwBtB;;A2EzrsBE;EAAuB,gBAtgEH;A3EmswBtB;;A2E7rsBE;EAAuB,gBAtgEH;A3EuswBtB;;A2EjssBE;EAAuB,gBAtgEH;A3E2swBtB;;A2ErssBE;EAAuB,gBAtgEH;A3E+swBtB;;A2EzssBE;EAAuB,gBAtgEH;A3EmtwBtB;;A2E7ssBE;EAAuB,gBAtgEH;A3EutwBtB;;A2EjtsBE;EAAuB,gBAtgEH;A3E2twBtB;;A2ErtsBE;EAAuB,gBAtgEH;A3E+twBtB;;A2EztsBE;EAAuB,gBAtgEH;A3EmuwBtB;;A2E7tsBE;EAAuB,gBAtgEH;A3EuuwBtB;;A2EjusBE;EAAuB,gBAtgEH;A3E2uwBtB;;A2ErusBE;EAAuB,gBAtgEH;A3E+uwBtB;;A2EzusBE;EAAuB,gBAtgEH;A3EmvwBtB;;A2E7usBE;EAAuB,gBAtgEH;A3EuvwBtB;;A2EjvsBE;EAAuB,gBAtgEH;A3E2vwBtB;;A2ErvsBE;EAAuB,gBAtgEH;A3E+vwBtB;;A2EzvsBE;EAAuB,gBAtgEH;A3EmwwBtB;;A2E7vsBE;EAAuB,gBAtgEH;A3EuwwBtB;;A2EjwsBE;EAAuB,gBAtgEH;A3E2wwBtB;;A2ErwsBE;EAAuB,gBAtgEH;A3E+wwBtB;;A2EzwsBE;EAAuB,gBAtgEH;A3EmxwBtB;;A2E7wsBE;EAAuB,gBAtgEH;A3EuxwBtB;;A2EjxsBE;EAAuB,gBAtgEH;A3E2xwBtB;;A2ErxsBE;EAAuB,gBAtgEH;A3E+xwBtB;;A2EzxsBE;EAAuB,gBAtgEH;A3EmywBtB;;A2E7xsBE;EAAuB,gBAtgEH;A3EuywBtB;;A2EjysBE;EAAuB,gBAtgEH;A3E2ywBtB;;A2ErysBE;EAAuB,gBAtgEH;A3E+ywBtB;;A2EzysBE;EAAuB,gBAtgEH;A3EmzwBtB;;A2E7ysBE;EAAuB,gBAtgEH;A3EuzwBtB;;A2EjzsBE;EAAuB,gBAtgEH;A3E2zwBtB;;A2ErzsBE;EAAuB,gBAtgEH;A3E+zwBtB;;A2EzzsBE;EAAuB,gBAtgEH;A3Em0wBtB;;A2E7zsBE;EAAuB,gBAtgEH;A3Eu0wBtB;;A2Ej0sBE;EAAuB,gBAtgEH;A3E20wBtB;;A2Er0sBE;EAAuB,gBAtgEH;A3E+0wBtB;;A2Ez0sBE;EAAuB,gBAtgEH;A3Em1wBtB;;A2E70sBE;EAAuB,gBAtgEH;A3Eu1wBtB;;A2Ej1sBE;EAAuB,gBAtgEH;A3E21wBtB;;A2Er1sBE;EAAuB,gBAtgEH;A3E+1wBtB;;A2Ez1sBE;EAAuB,gBAtgEH;A3Em2wBtB;;A2E71sBE;EAAuB,gBAtgEH;A3Eu2wBtB;;A2Ej2sBE;EAAuB,gBAtgEH;A3E22wBtB;;A2Er2sBE;EAAuB,gBAtgEH;A3E+2wBtB;;A2Ez2sBE;EAAuB,gBAtgEH;A3Em3wBtB;;A2E72sBE;EAAuB,gBAtgEH;A3Eu3wBtB;;A2Ej3sBE;EAAuB,gBAtgEH;A3E23wBtB;;A2Er3sBE;EAAuB,gBAtgEH;A3E+3wBtB;;A2Ez3sBE;EAAuB,gBAtgEH;A3Em4wBtB;;A2E73sBE;EAAuB,gBAtgEH;A3Eu4wBtB;;A2Ej4sBE;EAAuB,gBAtgEH;A3E24wBtB;;A2Er4sBE;EAAuB,gBAtgEH;A3E+4wBtB;;A2Ez4sBE;EAAuB,gBAtgEH;A3Em5wBtB;;A2E74sBE;EAAuB,gBAtgEH;A3Eu5wBtB;;A2Ej5sBE;EAAuB,gBAtgEH;A3E25wBtB;;A2Er5sBE;EAAuB,gBAtgEH;A3E+5wBtB;;A2Ez5sBE;EAAuB,gBAtgEH;A3Em6wBtB;;A2E75sBE;EAAuB,gBAtgEH;A3Eu6wBtB;;A2Ej6sBE;EAAuB,gBAtgEH;A3E26wBtB;;A2Er6sBE;EAAuB,gBAtgEH;A3E+6wBtB;;A2Ez6sBE;EAAuB,gBAtgEH;A3Em7wBtB;;A2E76sBE;EAAuB,gBAtgEH;A3Eu7wBtB;;A2Ej7sBE;EAAuB,gBAtgEH;A3E27wBtB;;A2Er7sBE;EAAuB,gBAtgEH;A3E+7wBtB;;A2Ez7sBE;EAAuB,gBAtgEH;A3Em8wBtB;;A2E77sBE;EAAuB,gBAtgEH;A3Eu8wBtB;;A2Ej8sBE;EAAuB,gBAtgEH;A3E28wBtB;;A2Er8sBE;EAAuB,gBAtgEH;A3E+8wBtB;;A2Ez8sBE;EAAuB,gBAtgEH;A3Em9wBtB;;A2E78sBE;EAAuB,gBAtgEH;A3Eu9wBtB;;A2Ej9sBE;EAAuB,gBAtgEH;A3E29wBtB;;A2Er9sBE;EAAuB,gBAtgEH;A3E+9wBtB;;A2Ez9sBE;EAAuB,gBAtgEH;A3Em+wBtB;;A2E79sBE;EAAuB,gBAtgEH;A3Eu+wBtB;;A2Ej+sBE;EAAuB,gBAtgEH;A3E2+wBtB;;A2Er+sBE;EAAuB,gBAtgEH;A3E++wBtB;;A2Ez+sBE;EAAuB,gBAtgEH;A3Em/wBtB;;A2E7+sBE;EAAuB,gBAtgEH;A3Eu/wBtB;;A2Ej/sBE;EAAuB,gBAtgEH;A3E2/wBtB;;A2Er/sBE;EAAuB,gBAtgEH;A3E+/wBtB;;A2Ez/sBE;EAAuB,gBAtgEH;A3EmgxBtB;;A2E7/sBE;EAAuB,gBAtgEH;A3EugxBtB;;A2EjgtBE;EAAuB,gBAtgEH;A3E2gxBtB;;A2ErgtBE;EAAuB,gBAtgEH;A3E+gxBtB;;A2EzgtBE;EAAuB,gBAtgEH;A3EmhxBtB;;A2E7gtBE;EAAuB,gBAtgEH;A3EuhxBtB;;A2EjhtBE;EAAuB,gBAtgEH;A3E2hxBtB;;A2ErhtBE;EAAuB,gBAtgEH;A3E+hxBtB;;A2EzhtBE;EAAuB,gBAtgEH;A3EmixBtB;;A2E7htBE;EAAuB,gBAtgEH;A3EuixBtB;;A2EjitBE;EAAuB,gBAtgEH;A3E2ixBtB;;A2EritBE;EAAuB,gBAtgEH;A3E+ixBtB;;A2EzitBE;EAAuB,gBAtgEH;A3EmjxBtB;;A2E7itBE;EAAuB,gBAtgEH;A3EujxBtB;;A2EjjtBE;EAAuB,gBAtgEH;A3E2jxBtB;;A2ErjtBE;EAAuB,gBAtgEH;A3E+jxBtB;;A2EzjtBE;EAAuB,gBAtgEH;A3EmkxBtB;;A2E7jtBE;EAAuB,gBAtgEH;A3EukxBtB;;A2EjktBE;EAAuB,gBAtgEH;A3E2kxBtB;;A2ErktBE;EAAuB,gBAtgEH;A3E+kxBtB;;A2EzktBE;EAAuB,gBAtgEH;A3EmlxBtB;;A2E7ktBE;EAAuB,gBAtgEH;A3EulxBtB;;A2EjltBE;EAAuB,gBAtgEH;A3E2lxBtB;;A2ErltBE;EAAuB,gBAtgEH;A3E+lxBtB;;A2EzltBE;EAAuB,gBAtgEH;A3EmmxBtB;;A2E7ltBE;EAAuB,gBAtgEH;A3EumxBtB;;A2EjmtBE;EAAuB,gBAtgEH;A3E2mxBtB;;A2ErmtBE;EAAuB,gBAtgEH;A3E+mxBtB;;A2EzmtBE;EAAuB,gBAtgEH;A3EmnxBtB;;A2E7mtBE;EAAuB,gBAtgEH;A3EunxBtB;;A2EjntBE;EAAuB,gBAtgEH;A3E2nxBtB;;A2ErntBE;EAAuB,gBAtgEH;A3E+nxBtB;;A2EzntBE;EAAuB,gBAtgEH;A3EmoxBtB;;A2E7ntBE;EAAuB,gBAtgEH;A3EuoxBtB;;A2EjotBE;EAAuB,gBAtgEH;A3E2oxBtB;;A2ErotBE;EAAuB,gBAtgEH;A3E+oxBtB;;A2EzotBE;EAAuB,gBAtgEH;A3EmpxBtB;;A2E7otBE;EAAuB,gBAtgEH;A3EupxBtB;;A2EjptBE;EAAuB,gBAtgEH;A3E2pxBtB;;A2ErptBE;EAAuB,gBAtgEH;A3E+pxBtB;;A2EzptBE;EAAuB,gBAtgEH;A3EmqxBtB;;A2E7ptBE;EAAuB,gBAtgEH;A3EuqxBtB;;A2EjqtBE;EAAuB,gBAtgEH;A3E2qxBtB;;A2ErqtBE;EAAuB,gBAtgEH;A3E+qxBtB;;A2EzqtBE;EAAuB,gBAtgEH;A3EmrxBtB;;A2E7qtBE;EAAuB,gBAtgEH;A3EurxBtB;;A2EjrtBE;EAAuB,gBAtgEH;A3E2rxBtB;;A2ErrtBE;EAAuB,gBAtgEH;A3E+rxBtB;;A2EzrtBE;EAAuB,gBAtgEH;A3EmsxBtB;;A2E7rtBE;EAAuB,gBAtgEH;A3EusxBtB;;A2EjstBE;EAAuB,gBAtgEH;A3E2sxBtB;;A2ErstBE;EAAuB,gBAtgEH;A3E+sxBtB;;A2EzstBE;EAAuB,gBAtgEH;A3EmtxBtB;;A2E7stBE;EAAuB,gBAtgEH;A3EutxBtB;;A2EjttBE;EAAuB,gBAtgEH;A3E2txBtB;;A2ErttBE;EAAuB,gBAtgEH;A3E+txBtB;;A2EzttBE;EAAuB,gBAtgEH;A3EmuxBtB;;A2E7ttBE;EAAuB,gBAtgEH;A3EuuxBtB;;A2EjutBE;EAAuB,gBAtgEH;A3E2uxBtB;;A2ErutBE;EAAuB,gBAtgEH;A3E+uxBtB;;A2EzutBE;EAAuB,gBAtgEH;A3EmvxBtB;;A2E7utBE;EAAuB,gBAtgEH;A3EuvxBtB;;A2EjvtBE;EAAuB,gBAtgEH;A3E2vxBtB;;A2ErvtBE;EAAuB,gBAtgEH;A3E+vxBtB;;A2EzvtBE;EAAuB,gBAtgEH;A3EmwxBtB;;A2E7vtBE;EAAuB,gBAtgEH;A3EuwxBtB;;A2EjwtBE;EAAuB,gBAtgEH;A3E2wxBtB;;A2ErwtBE;EAAuB,gBAtgEH;A3E+wxBtB;;A2EzwtBE;EAAuB,gBAtgEH;A3EmxxBtB;;A2E7wtBE;EAAuB,gBAtgEH;A3EuxxBtB;;A2EjxtBE;EAAuB,gBAtgEH;A3E2xxBtB;;A2ErxtBE;EAAuB,gBAtgEH;A3E+xxBtB;;A2EzxtBE;EAAuB,gBAtgEH;A3EmyxBtB;;A2E7xtBE;EAAuB,gBAtgEH;A3EuyxBtB;;A2EjytBE;EAAuB,gBAtgEH;A3E2yxBtB;;A2ErytBE;EAAuB,gBAtgEH;A3E+yxBtB;;A2EzytBE;EAAuB,gBAtgEH;A3EmzxBtB;;A2E7ytBE;EAAuB,gBAtgEH;A3EuzxBtB;;A2EjztBE;EAAuB,gBAtgEH;A3E2zxBtB;;A2ErztBE;EAAuB,gBAtgEH;A3E+zxBtB;;A2EzztBE;EAAuB,gBAtgEH;A3Em0xBtB;;A2E7ztBE;EAAuB,gBAtgEH;A3Eu0xBtB;;A2Ej0tBE;EAAuB,gBAtgEH;A3E20xBtB;;A2Er0tBE;EAAuB,gBAtgEH;A3E+0xBtB;;A2Ez0tBE;EAAuB,gBAtgEH;A3Em1xBtB;;A2E70tBE;EAAuB,gBAtgEH;A3Eu1xBtB;;A2Ej1tBE;EAAuB,gBAtgEH;A3E21xBtB;;A2Er1tBE;EAAuB,gBAtgEH;A3E+1xBtB;;A2Ez1tBE;EAAuB,gBAtgEH;A3Em2xBtB;;A2E71tBE;EAAuB,gBAtgEH;A3Eu2xBtB;;A2Ej2tBE;EAAuB,gBAtgEH;A3E22xBtB;;A2Er2tBE;EAAuB,gBAtgEH;A3E+2xBtB;;A2Ez2tBE;EAAuB,gBAtgEH;A3Em3xBtB;;A2E72tBE;EAAuB,gBAtgEH;A3Eu3xBtB;;A2Ej3tBE;EAAuB,gBAtgEH;A3E23xBtB;;A2Er3tBE;EAAuB,gBAtgEH;A3E+3xBtB;;A2Ez3tBE;EAAuB,gBAtgEH;A3Em4xBtB;;A2E73tBE;EAAuB,gBAtgEH;A3Eu4xBtB;;A2Ej4tBE;EAAuB,gBAtgEH;A3E24xBtB;;A2Er4tBE;EAAuB,gBAtgEH;A3E+4xBtB;;A2Ez4tBE;EAAuB,gBAtgEH;A3Em5xBtB;;A2E74tBE;EAAuB,gBAtgEH;A3Eu5xBtB;;A2Ej5tBE;EAAuB,gBAtgEH;A3E25xBtB;;A2Er5tBE;EAAuB,gBAtgEH;A3E+5xBtB;;A2Ez5tBE;EAAuB,gBAtgEH;A3Em6xBtB;;A2E75tBE;EAAuB,gBAtgEH;A3Eu6xBtB;;A2Ej6tBE;EAAuB,gBAtgEH;A3E26xBtB;;A2Er6tBE;EAAuB,gBAtgEH;A3E+6xBtB;;A2Ez6tBE;EAAuB,gBAtgEH;A3Em7xBtB;;A2E76tBE;EAAuB,gBAtgEH;A3Eu7xBtB;;A2Ej7tBE;EAAuB,gBAtgEH;A3E27xBtB;;A2Er7tBE;EAAuB,gBAtgEH;A3E+7xBtB;;A2Ez7tBE;EAAuB,gBAtgEH;A3Em8xBtB;;A2E77tBE;EAAuB,gBAtgEH;A3Eu8xBtB;;A2Ej8tBE;EAAuB,gBAtgEH;A3E28xBtB;;A2Er8tBE;EAAuB,gBAtgEH;A3E+8xBtB;;A2Ez8tBE;EAAuB,gBAtgEH;A3Em9xBtB;;A2E78tBE;EAAuB,gBAtgEH;A3Eu9xBtB;;A2Ej9tBE;EAAuB,gBAtgEH;A3E29xBtB;;A2Er9tBE;EAAuB,gBAtgEH;A3E+9xBtB;;A2Ez9tBE;EAAuB,gBAtgEH;A3Em+xBtB;;A2E79tBE;EAAuB,gBAtgEH;A3Eu+xBtB;;A2Ej+tBE;EAAuB,gBAtgEH;A3E2+xBtB;;A2Er+tBE;EAAuB,gBAtgEH;A3E++xBtB;;A2Ez+tBE;EAAuB,gBAtgEH;A3Em/xBtB;;A2E7+tBE;EAAuB,gBAtgEH;A3Eu/xBtB;;A2Ej/tBE;EAAuB,gBAtgEH;A3E2/xBtB;;A2Er/tBE;EAAuB,gBAtgEH;A3E+/xBtB;;A2Ez/tBE;EAAuB,gBAtgEH;A3EmgyBtB;;A2E7/tBE;EAAuB,gBAtgEH;A3EugyBtB;;A2EjguBE;EAAuB,gBAtgEH;A3E2gyBtB;;A2ErguBE;EAAuB,gBAtgEH;A3E+gyBtB;;A2EzguBE;EAAuB,gBAtgEH;A3EmhyBtB;;A2E7guBE;EAAuB,gBAtgEH;A3EuhyBtB;;A2EjhuBE;EAAuB,gBAtgEH;A3E2hyBtB;;A2ErhuBE;EAAuB,gBAtgEH;A3E+hyBtB;;A2EzhuBE;EAAuB,gBAtgEH;A3EmiyBtB;;A2E7huBE;EAAuB,gBAtgEH;A3EuiyBtB;;A2EjiuBE;EAAuB,gBAtgEH;A3E2iyBtB;;A2EriuBE;EAAuB,gBAtgEH;A3E+iyBtB;;A2EziuBE;EAAuB,gBAtgEH;A3EmjyBtB;;A2E7iuBE;EAAuB,gBAtgEH;A3EujyBtB;;A2EjjuBE;EAAuB,gBAtgEH;A3E2jyBtB;;A2ErjuBE;EAAuB,gBAtgEH;A3E+jyBtB;;A2EzjuBE;EAAuB,gBAtgEH;A3EmkyBtB;;A2E7juBE;EAAuB,gBAtgEH;A3EukyBtB;;A2EjkuBE;EAAuB,gBAtgEH;A3E2kyBtB;;A2ErkuBE;EAAuB,gBAtgEH;A3E+kyBtB;;A2EzkuBE;EAAuB,gBAtgEH;A3EmlyBtB;;A2E7kuBE;EAAuB,gBAtgEH;A3EulyBtB;;A2EjluBE;EAAuB,gBAtgEH;A3E2lyBtB;;A2ErluBE;EAAuB,gBAtgEH;A3E+lyBtB;;A2EzluBE;EAAuB,gBAtgEH;A3EmmyBtB;;A2E7luBE;EAAuB,gBAtgEH;A3EumyBtB;;A2EjmuBE;EAAuB,gBAtgEH;A3E2myBtB;;A2ErmuBE;EAAuB,gBAtgEH;A3E+myBtB;;A2EzmuBE;EAAuB,gBAtgEH;A3EmnyBtB;;A2E7muBE;EAAuB,gBAtgEH;A3EunyBtB;;A2EjnuBE;EAAuB,gBAtgEH;A3E2nyBtB;;A2ErnuBE;EAAuB,gBAtgEH;A3E+nyBtB;;A2EznuBE;EAAuB,gBAtgEH;A3EmoyBtB;;A2E7nuBE;EAAuB,gBAtgEH;A3EuoyBtB;;A2EjouBE;EAAuB,gBAtgEH;A3E2oyBtB;;A2ErouBE;EAAuB,gBAtgEH;A3E+oyBtB;;A2EzouBE;EAAuB,gBAtgEH;A3EmpyBtB;;A2E7ouBE;EAAuB,gBAtgEH;A3EupyBtB;;A2EjpuBE;EAAuB,gBAtgEH;A3E2pyBtB;;A2ErpuBE;EAAuB,gBAtgEH;A3E+pyBtB;;A2EzpuBE;EAAuB,gBAtgEH;A3EmqyBtB;;A2E7puBE;EAAuB,gBAtgEH;A3EuqyBtB;;A2EjquBE;EAAuB,gBAtgEH;A3E2qyBtB;;A2ErquBE;EAAuB,gBAtgEH;A3E+qyBtB;;A2EzquBE;EAAuB,gBAtgEH;A3EmryBtB;;A2E7quBE;EAAuB,gBAtgEH;A3EuryBtB;;A2EjruBE;EAAuB,gBAtgEH;A3E2ryBtB;;A2ErruBE;EAAuB,gBAtgEH;A3E+ryBtB;;A2EzruBE;EAAuB,gBAtgEH;A3EmsyBtB;;A2E7ruBE;EAAuB,gBAtgEH;A3EusyBtB;;A2EjsuBE;EAAuB,gBAtgEH;A3E2syBtB;;A2ErsuBE;EAAuB,gBAtgEH;A3E+syBtB;;A2EzsuBE;EAAuB,gBAtgEH;A3EmtyBtB;;A2E7suBE;EAAuB,gBAtgEH;A3EutyBtB;;A2EjtuBE;EAAuB,gBAtgEH;A3E2tyBtB;;A2ErtuBE;EAAuB,gBAtgEH;A3E+tyBtB;;A2EztuBE;EAAuB,gBAtgEH;A3EmuyBtB;;A2E7tuBE;EAAuB,gBAtgEH;A3EuuyBtB;;A2EjuuBE;EAAuB,gBAtgEH;A3E2uyBtB;;A2EruuBE;EAAuB,gBAtgEH;A3E+uyBtB;;A2EzuuBE;EAAuB,gBAtgEH;A3EmvyBtB;;A2E7uuBE;EAAuB,gBAtgEH;A3EuvyBtB;;A2EjvuBE;EAAuB,gBAtgEH;A3E2vyBtB;;A2ErvuBE;EAAuB,gBAtgEH;A3E+vyBtB;;A2EzvuBE;EAAuB,gBAtgEH;A3EmwyBtB;;A2E7vuBE;EAAuB,gBAtgEH;A3EuwyBtB;;A2EjwuBE;EAAuB,gBAtgEH;A3E2wyBtB;;A2ErwuBE;EAAuB,gBAtgEH;A3E+wyBtB;;A2EzwuBE;EAAuB,gBAtgEH;A3EmxyBtB;;A2E7wuBE;EAAuB,gBAtgEH;A3EuxyBtB;;A2EjxuBE;EAAuB,gBAtgEH;A3E2xyBtB;;A2ErxuBE;EAAuB,gBAtgEH;A3E+xyBtB;;A2EzxuBE;EAAuB,gBAtgEH;A3EmyyBtB;;A2E7xuBE;EAAuB,gBAtgEH;A3EuyyBtB;;A2EjyuBE;EAAuB,gBAtgEH;A3E2yyBtB;;A2EryuBE;EAAuB,gBAtgEH;A3E+yyBtB;;A2EzyuBE;EAAuB,gBAtgEH;A3EmzyBtB;;A2E7yuBE;EAAuB,gBAtgEH;A3EuzyBtB;;A2EjzuBE;EAAuB,gBAtgEH;A3E2zyBtB;;A2ErzuBE;EAAuB,gBAtgEH;A3E+zyBtB;;A2EzzuBE;EAAuB,gBAtgEH;A3Em0yBtB;;A2E7zuBE;EAAuB,gBAtgEH;A3Eu0yBtB;;A2Ej0uBE;EAAuB,gBAtgEH;A3E20yBtB;;A2Er0uBE;EAAuB,gBAtgEH;A3E+0yBtB;;A2Ez0uBE;EAAuB,gBAtgEH;A3Em1yBtB;;A2E70uBE;EAAuB,gBAtgEH;A3Eu1yBtB;;A2Ej1uBE;EAAuB,gBAtgEH;A3E21yBtB;;A2Er1uBE;EAAuB,gBAtgEH;A3E+1yBtB;;A2Ez1uBE;EAAuB,gBAtgEH;A3Em2yBtB;;A2E71uBE;EAAuB,gBAtgEH;A3Eu2yBtB;;A2Ej2uBE;EAAuB,gBAtgEH;A3E22yBtB;;A2Er2uBE;EAAuB,gBAtgEH;A3E+2yBtB;;A2Ez2uBE;EAAuB,gBAtgEH;A3Em3yBtB;;A2E72uBE;EAAuB,gBAtgEH;A3Eu3yBtB;;A2Ej3uBE;EAAuB,gBAtgEH;A3E23yBtB;;A2Er3uBE;EAAuB,gBAtgEH;A3E+3yBtB;;A2Ez3uBE;EAAuB,gBAtgEH;A3Em4yBtB;;A2E73uBE;EAAuB,gBAtgEH;A3Eu4yBtB;;A2Ej4uBE;EAAuB,gBAtgEH;A3E24yBtB;;A2Er4uBE;EAAuB,gBAtgEH;A3E+4yBtB;;A2Ez4uBE;EAAuB,gBAtgEH;A3Em5yBtB;;A2E74uBE;EAAuB,gBAtgEH;A3Eu5yBtB;;A2Ej5uBE;EAAuB,gBAtgEH;A3E25yBtB;;A2Er5uBE;EAAuB,gBAtgEH;A3E+5yBtB;;A2Ez5uBE;EAAuB,gBAtgEH;A3Em6yBtB;;A2E75uBE;EAAuB,gBAtgEH;A3Eu6yBtB;;A2Ej6uBE;EAAuB,gBAtgEH;A3E26yBtB;;A2Er6uBE;EAAuB,gBAtgEH;A3E+6yBtB;;A2Ez6uBE;EAAuB,gBAtgEH;A3Em7yBtB;;A2E76uBE;EAAuB,gBAtgEH;A3Eu7yBtB;;A2Ej7uBE;EAAuB,gBAtgEH;A3E27yBtB;;A2Er7uBE;EAAuB,gBAtgEH;A3E+7yBtB;;A2Ez7uBE;EAAuB,gBAtgEH;A3Em8yBtB;;A2E77uBE;EAAuB,gBAtgEH;A3Eu8yBtB;;A2Ej8uBE;EAAuB,gBAtgEH;A3E28yBtB;;A2Er8uBE;EAAuB,gBAtgEH;A3E+8yBtB;;A2Ez8uBE;EAAuB,gBAtgEH;A3Em9yBtB;;A2E78uBE;EAAuB,gBAtgEH;A3Eu9yBtB;;A2Ej9uBE;EAAuB,gBAtgEH;A3E29yBtB;;A2Er9uBE;EAAuB,gBAtgEH;A3E+9yBtB;;A2Ez9uBE;EAAuB,gBAtgEH;A3Em+yBtB;;A2E79uBE;EAAuB,gBAtgEH;A3Eu+yBtB;;A2Ej+uBE;EAAuB,gBAtgEH;A3E2+yBtB;;A2Er+uBE;EAAuB,gBAtgEH;A3E++yBtB;;A2Ez+uBE;EAAuB,gBAtgEH;A3Em/yBtB;;A2E7+uBE;EAAuB,gBAtgEH;A3Eu/yBtB;;A2Ej/uBE;EAAuB,gBAtgEH;A3E2/yBtB;;A2Er/uBE;EAAuB,gBAtgEH;A3E+/yBtB;;A2Ez/uBE;EAAuB,gBAtgEH;A3EmgzBtB;;A2E7/uBE;EAAuB,gBAtgEH;A3EugzBtB;;A2EjgvBE;EAAuB,gBAtgEH;A3E2gzBtB;;A2ErgvBE;EAAuB,gBAtgEH;A3E+gzBtB;;A2EzgvBE;EAAuB,gBAtgEH;A3EmhzBtB;;A2E7gvBE;EAAuB,gBAtgEH;A3EuhzBtB;;A2EjhvBE;EAAuB,gBAtgEH;A3E2hzBtB;;A2ErhvBE;EAAuB,gBAtgEH;A3E+hzBtB;;A2EzhvBE;EAAuB,gBAtgEH;A3EmizBtB;;A2E7hvBE;EAAuB,gBAtgEH;A3EuizBtB;;A2EjivBE;EAAuB,gBAtgEH;A3E2izBtB;;A2ErivBE;EAAuB,gBAtgEH;A3E+izBtB;;A2EzivBE;EAAuB,gBAtgEH;A3EmjzBtB;;A2E7ivBE;EAAuB,gBAtgEH;A3EujzBtB;;A2EjjvBE;EAAuB,gBAtgEH;A3E2jzBtB;;A2ErjvBE;EAAuB,gBAtgEH;A3E+jzBtB;;A2EzjvBE;EAAuB,gBAtgEH;A3EmkzBtB;;A2E7jvBE;EAAuB,gBAtgEH;A3EukzBtB;;A2EjkvBE;EAAuB,gBAtgEH;A3E2kzBtB;;A2ErkvBE;EAAuB,gBAtgEH;A3E+kzBtB;;A2EzkvBE;EAAuB,gBAtgEH;A3EmlzBtB;;A2E7kvBE;EAAuB,gBAtgEH;A3EulzBtB;;A2EjlvBE;EAAuB,gBAtgEH;A3E2lzBtB;;A2ErlvBE;EAAuB,gBAtgEH;A3E+lzBtB;;A2EzlvBE;EAAuB,gBAtgEH;A3EmmzBtB;;A2E7lvBE;EAAuB,gBAtgEH;A3EumzBtB;;A2EjmvBE;EAAuB,gBAtgEH;A3E2mzBtB;;A2ErmvBE;EAAuB,gBAtgEH;A3E+mzBtB;;A2EzmvBE;EAAuB,gBAtgEH;A3EmnzBtB;;A2E7mvBE;EAAuB,gBAtgEH;A3EunzBtB;;A2EjnvBE;EAAuB,gBAtgEH;A3E2nzBtB;;A2ErnvBE;EAAuB,gBAtgEH;A3E+nzBtB;;A2EznvBE;EAAuB,gBAtgEH;A3EmozBtB;;A2E7nvBE;EAAuB,gBAtgEH;A3EuozBtB;;A2EjovBE;EAAuB,gBAtgEH;A3E2ozBtB;;A2ErovBE;EAAuB,gBAtgEH;A3E+ozBtB;;A2EzovBE;EAAuB,gBAtgEH;A3EmpzBtB;;A2E7ovBE;EAAuB,gBAtgEH;A3EupzBtB;;A2EjpvBE;EAAuB,gBAtgEH;A3E2pzBtB;;A2ErpvBE;EAAuB,gBAtgEH;A3E+pzBtB;;A2EzpvBE;EAAuB,gBAtgEH;A3EmqzBtB;;A2E7pvBE;EAAuB,gBAtgEH;A3EuqzBtB;;A2EjqvBE;EAAuB,gBAtgEH;A3E2qzBtB;;A2ErqvBE;EAAuB,gBAtgEH;A3E+qzBtB;;A2EzqvBE;EAAuB,gBAtgEH;A3EmrzBtB;;A2E7qvBE;EAAuB,gBAtgEH;A3EurzBtB;;A2EjrvBE;EAAuB,gBAtgEH;A3E2rzBtB;;A2ErrvBE;EAAuB,gBAtgEH;A3E+rzBtB;;A2EzrvBE;EAAuB,gBAtgEH;A3EmszBtB;;A2E7rvBE;EAAuB,gBAtgEH;A3EuszBtB;;A2EjsvBE;EAAuB,gBAtgEH;A3E2szBtB;;A2ErsvBE;EAAuB,gBAtgEH;A3E+szBtB;;A2EzsvBE;EAAuB,gBAtgEH;A3EmtzBtB;;A2E7svBE;EAAuB,gBAtgEH;A3EutzBtB;;A2EjtvBE;EAAuB,gBAtgEH;A3E2tzBtB;;A2ErtvBE;EAAuB,gBAtgEH;A3E+tzBtB;;A2EztvBE;EAAuB,gBAtgEH;A3EmuzBtB;;A2E7tvBE;EAAuB,gBAtgEH;A3EuuzBtB;;A2EjuvBE;EAAuB,gBAtgEH;A3E2uzBtB;;A2EruvBE;EAAuB,gBAtgEH;A3E+uzBtB;;A2EzuvBE;EAAuB,gBAtgEH;A3EmvzBtB;;A2E7uvBE;EAAuB,gBAtgEH;A3EuvzBtB;;A2EjvvBE;EAAuB,gBAtgEH;A3E2vzBtB;;A2ErvvBE;EAAuB,gBAtgEH;A3E+vzBtB;;A2EzvvBE;EAAuB,gBAtgEH;A3EmwzBtB;;A2E7vvBE;EAAuB,gBAtgEH;A3EuwzBtB;;A2EjwvBE;EAAuB,gBAtgEH;A3E2wzBtB;;A2ErwvBE;EAAuB,gBAtgEH;A3E+wzBtB;;A2EzwvBE;EAAuB,gBAtgEH;A3EmxzBtB;;A2E7wvBE;EAAuB,gBAtgEH;A3EuxzBtB;;A2EjxvBE;EAAuB,gBAtgEH;A3E2xzBtB;;A2ErxvBE;EAAuB,gBAtgEH;A3E+xzBtB;;A2EzxvBE;EAAuB,gBAtgEH;A3EmyzBtB;;A2E7xvBE;EAAuB,gBAtgEH;A3EuyzBtB;;A2EjyvBE;EAAuB,gBAtgEH;A3E2yzBtB;;A2EryvBE;EAAuB,gBAtgEH;A3E+yzBtB;;A2EzyvBE;EAAuB,gBAtgEH;A3EmzzBtB;;A2E7yvBE;EAAuB,gBAtgEH;A3EuzzBtB;;A2EjzvBE;EAAuB,gBAtgEH;A3E2zzBtB;;A2ErzvBE;EAAuB,gBAtgEH;A3E+zzBtB;;A2EzzvBE;EAAuB,gBAtgEH;A3Em0zBtB;;A2E7zvBE;EAAuB,gBAtgEH;A3Eu0zBtB;;A2Ej0vBE;EAAuB,gBAtgEH;A3E20zBtB;;A2Er0vBE;EAAuB,gBAtgEH;A3E+0zBtB;;A2Ez0vBE;EAAuB,gBAtgEH;A3Em1zBtB;;A2E70vBE;EAAuB,gBAtgEH;A3Eu1zBtB;;A2Ej1vBE;EAAuB,gBAtgEH;A3E21zBtB;;A2Er1vBE;EAAuB,gBAtgEH;A3E+1zBtB;;A2Ez1vBE;EAAuB,gBAtgEH;A3Em2zBtB;;A2E71vBE;EAAuB,gBAtgEH;A3Eu2zBtB;;A2Ej2vBE;EAAuB,gBAtgEH;A3E22zBtB;;A2Er2vBE;EAAuB,gBAtgEH;A3E+2zBtB;;A2Ez2vBE;EAAuB,gBAtgEH;A3Em3zBtB;;A2E72vBE;EAAuB,gBAtgEH;A3Eu3zBtB;;A2Ej3vBE;EAAuB,gBAtgEH;A3E23zBtB;;A2Er3vBE;EAAuB,gBAtgEH;A3E+3zBtB;;A2Ez3vBE;EAAuB,gBAtgEH;A3Em4zBtB;;A2E73vBE;EAAuB,gBAtgEH;A3Eu4zBtB;;A2Ej4vBE;EAAuB,gBAtgEH;A3E24zBtB;;A2Er4vBE;EAAuB,gBAtgEH;A3E+4zBtB;;A2Ez4vBE;EAAuB,gBAtgEH;A3Em5zBtB;;A2E74vBE;EAAuB,gBAtgEH;A3Eu5zBtB;;A2Ej5vBE;EAAuB,gBAtgEH;A3E25zBtB;;A2Er5vBE;EAAuB,gBAtgEH;A3E+5zBtB;;A2Ez5vBE;EAAuB,gBAtgEH;A3Em6zBtB;;A2E75vBE;EAAuB,gBAtgEH;A3Eu6zBtB;;A2Ej6vBE;EAAuB,gBAtgEH;A3E26zBtB;;A2Er6vBE;EAAuB,gBAtgEH;A3E+6zBtB;;A2Ez6vBE;EAAuB,gBAtgEH;A3Em7zBtB;;A2E76vBE;EAAuB,gBAtgEH;A3Eu7zBtB;;A2Ej7vBE;EAAuB,gBAtgEH;A3E27zBtB;;A2Er7vBE;EAAuB,gBAtgEH;A3E+7zBtB;;A2Ez7vBE;EAAuB,gBAtgEH;A3Em8zBtB;;A2E77vBE;EAAuB,gBAtgEH;A3Eu8zBtB;;A2Ej8vBE;EAAuB,gBAtgEH;A3E28zBtB;;A2Er8vBE;EAAuB,gBAtgEH;A3E+8zBtB;;A2Ez8vBE;EAAuB,gBAtgEH;A3Em9zBtB;;A2E78vBE;EAAuB,gBAtgEH;A3Eu9zBtB;;A2Ej9vBE;EAAuB,gBAtgEH;A3E29zBtB;;A2Er9vBE;EAAuB,gBAtgEH;A3E+9zBtB;;A2Ez9vBE;EAAuB,gBAtgEH;A3Em+zBtB;;A2E79vBE;EAAuB,gBAtgEH;A3Eu+zBtB;;A2Ej+vBE;EAAuB,gBAtgEH;A3E2+zBtB;;A2Er+vBE;EAAuB,gBAtgEH;A3E++zBtB;;A2Ez+vBE;EAAuB,gBAtgEH;A3Em/zBtB;;A2E7+vBE;EAAuB,gBAtgEH;A3Eu/zBtB;;A2Ej/vBE;EAAuB,gBAtgEH;A3E2/zBtB;;A2Er/vBE;EAAuB,gBAtgEH;A3E+/zBtB;;A2Ez/vBE;EAAuB,gBAtgEH;A3Emg0BtB;;A2E7/vBE;EAAuB,gBAtgEH;A3Eug0BtB;;A2EjgwBE;EAAuB,gBAtgEH;A3E2g0BtB;;A2ErgwBE;EAAuB,gBAtgEH;A3E+g0BtB;;A2EzgwBE;EAAuB,gBAtgEH;A3Emh0BtB;;A2E7gwBE;EAAuB,gBAtgEH;A3Euh0BtB;;A2EjhwBE;EAAuB,gBAtgEH;A3E2h0BtB;;A2ErhwBE;EAAuB,gBAtgEH;A3E+h0BtB;;A2EzhwBE;EAAuB,gBAtgEH;A3Emi0BtB;;A2E7hwBE;EAAuB,gBAtgEH;A3Eui0BtB;;A2EjiwBE;EAAuB,gBAtgEH;A3E2i0BtB;;A2EriwBE;EAAuB,gBAtgEH;A3E+i0BtB;;A2EziwBE;EAAuB,gBAtgEH;A3Emj0BtB;;A2E7iwBE;EAAuB,gBAtgEH;A3Euj0BtB;;A2EjjwBE;EAAuB,gBAtgEH;A3E2j0BtB;;A2ErjwBE;EAAuB,gBAtgEH;A3E+j0BtB;;A2EzjwBE;EAAuB,gBAtgEH;A3Emk0BtB;;A2E7jwBE;EAAuB,gBAtgEH;A3Euk0BtB;;A2EjkwBE;EAAuB,gBAtgEH;A3E2k0BtB;;A2ErkwBE;EAAuB,gBAtgEH;A3E+k0BtB;;A2EzkwBE;EAAuB,gBAtgEH;A3Eml0BtB;;A2E7kwBE;EAAuB,gBAtgEH;A3Eul0BtB;;A2EjlwBE;EAAuB,gBAtgEH;A3E2l0BtB;;A2ErlwBE;EAAuB,gBAtgEH;A3E+l0BtB;;A2EzlwBE;EAAuB,gBAtgEH;A3Emm0BtB;;A2E7lwBE;EAAuB,gBAtgEH;A3Eum0BtB;;A2EjmwBE;EAAuB,gBAtgEH;A3E2m0BtB;;A2ErmwBE;EAAuB,gBAtgEH;A3E+m0BtB;;A2EzmwBE;EAAuB,gBAtgEH;A3Emn0BtB;;A2E7mwBE;EAAuB,gBAtgEH;A3Eun0BtB;;A2EjnwBE;EAAuB,gBAtgEH;A3E2n0BtB;;A2ErnwBE;EAAuB,gBAtgEH;A3E+n0BtB;;A2EznwBE;EAAuB,gBAtgEH;A3Emo0BtB;;A2E7nwBE;EAAuB,gBAtgEH;A3Euo0BtB;;A2EjowBE;EAAuB,gBAtgEH;A3E2o0BtB;;A2ErowBE;EAAuB,gBAtgEH;A3E+o0BtB;;A2EzowBE;EAAuB,gBAtgEH;A3Emp0BtB;;A2E7owBE;EAAuB,gBAtgEH;A3Eup0BtB;;A2EjpwBE;EAAuB,gBAtgEH;A3E2p0BtB;;A2ErpwBE;EAAuB,gBAtgEH;A3E+p0BtB;;A2EzpwBE;EAAuB,gBAtgEH;A3Emq0BtB;;A2E7pwBE;EAAuB,gBAtgEH;A3Euq0BtB;;A2EjqwBE;EAAuB,gBAtgEH;A3E2q0BtB;;A2ErqwBE;EAAuB,gBAtgEH;A3E+q0BtB;;A2EzqwBE;EAAuB,gBAtgEH;A3Emr0BtB;;A2E7qwBE;EAAuB,gBAtgEH;A3Eur0BtB;;A2EjrwBE;EAAuB,gBAtgEH;A3E2r0BtB;;A2ErrwBE;EAAuB,gBAtgEH;A3E+r0BtB;;A2EzrwBE;EAAuB,gBAtgEH;A3Ems0BtB;;A2E7rwBE;EAAuB,gBAtgEH;A3Eus0BtB;;A2EjswBE;EAAuB,gBAtgEH;A3E2s0BtB;;A2ErswBE;EAAuB,gBAtgEH;A3E+s0BtB;;A2EzswBE;EAAuB,gBAtgEH;A3Emt0BtB;;A2E7swBE;EAAuB,gBAtgEH;A3Eut0BtB;;A2EjtwBE;EAAuB,gBAtgEH;A3E2t0BtB;;A2ErtwBE;EAAuB,gBAtgEH;A3E+t0BtB;;A2EztwBE;EAAuB,gBAtgEH;A3Emu0BtB;;A2E7twBE;EAAuB,gBAtgEH;A3Euu0BtB;;A2EjuwBE;EAAuB,gBAtgEH;A3E2u0BtB;;A2EruwBE;EAAuB,gBAtgEH;A3E+u0BtB;;A2EzuwBE;EAAuB,gBAtgEH;A3Emv0BtB;;A2E7uwBE;EAAuB,gBAtgEH;A3Euv0BtB;;A2EjvwBE;EAAuB,gBAtgEH;A3E2v0BtB;;A2ErvwBE;EAAuB,gBAtgEH;A3E+v0BtB;;A2EzvwBE;EAAuB,gBAtgEH;A3Emw0BtB;;A2E7vwBE;EAAuB,gBAtgEH;A3Euw0BtB;;A2EjwwBE;EAAuB,gBAtgEH;A3E2w0BtB;;A2ErwwBE;EAAuB,gBAtgEH;A3E+w0BtB;;A2EzwwBE;EAAuB,gBAtgEH;A3Emx0BtB;;A2E7wwBE;EAAuB,gBAtgEH;A3Eux0BtB;;A2EjxwBE;EAAuB,gBAtgEH;A3E2x0BtB;;A2ErxwBE;EAAuB,gBAtgEH;A3E+x0BtB;;A2EzxwBE;EAAuB,gBAtgEH;A3Emy0BtB;;A2E7xwBE;EAAuB,gBAtgEH;A3Euy0BtB;;A2EjywBE;EAAuB,gBAtgEH;A3E2y0BtB;;A2ErywBE;EAAuB,gBAtgEH;A3E+y0BtB;;A2EzywBE;EAAuB,gBAtgEH;A3Emz0BtB;;A2E7ywBE;EAAuB,gBAtgEH;A3Euz0BtB;;A2EjzwBE;EAAuB,gBAtgEH;A3E2z0BtB;;A2ErzwBE;EAAuB,gBAtgEH;A3E+z0BtB;;A2EzzwBE;EAAuB,gBAtgEH;A3Em00BtB;;A2E7zwBE;EAAuB,gBAtgEH;A3Eu00BtB;;A2Ej0wBE;EAAuB,gBAtgEH;A3E200BtB;;A2Er0wBE;EAAuB,gBAtgEH;A3E+00BtB;;A2Ez0wBE;EAAuB,gBAtgEH;A3Em10BtB;;A2E70wBE;EAAuB,gBAtgEH;A3Eu10BtB;;A2Ej1wBE;EAAuB,gBAtgEH;A3E210BtB;;A2Er1wBE;EAAuB,gBAtgEH;A3E+10BtB;;A2Ez1wBE;EAAuB,gBAtgEH;A3Em20BtB;;A2E71wBE;EAAuB,gBAtgEH;A3Eu20BtB;;A2Ej2wBE;EAAuB,gBAtgEH;A3E220BtB;;A2Er2wBE;EAAuB,gBAtgEH;A3E+20BtB;;A2Ez2wBE;EAAuB,gBAtgEH;A3Em30BtB;;A2E72wBE;EAAuB,gBAtgEH;A3Eu30BtB;;A2Ej3wBE;EAAuB,gBAtgEH;A3E230BtB;;A2Er3wBE;EAAuB,gBAtgEH;A3E+30BtB;;A2Ez3wBE;EAAuB,gBAtgEH;A3Em40BtB;;A2E73wBE;EAAuB,gBAtgEH;A3Eu40BtB;;A2Ej4wBE;EAAuB,gBAtgEH;A3E240BtB;;A2Er4wBE;EAAuB,gBAtgEH;A3E+40BtB;;A2Ez4wBE;EAAuB,gBAtgEH;A3Em50BtB;;A2E74wBE;EAAuB,gBAtgEH;A3Eu50BtB;;A2Ej5wBE;EAAuB,gBAtgEH;A3E250BtB;;A2Er5wBE;EAAuB,gBAtgEH;A3E+50BtB;;A2Ez5wBE;EAAuB,gBAtgEH;A3Em60BtB;;A2E75wBE;EAAuB,gBAtgEH;A3Eu60BtB;;A2Ej6wBE;EAAuB,gBAtgEH;A3E260BtB;;A2Er6wBE;EAAuB,gBAtgEH;A3E+60BtB;;A2Ez6wBE;EAAuB,gBAtgEH;A3Em70BtB;;A2E76wBE;EAAuB,gBAtgEH;A3Eu70BtB;;A2Ej7wBE;EAAuB,gBAtgEH;A3E270BtB;;A2Er7wBE;EAAuB,gBAtgEH;A3E+70BtB;;A2Ez7wBE;EAAuB,gBAtgEH;A3Em80BtB;;A2E77wBE;EAAuB,gBAtgEH;A3Eu80BtB;;A2Ej8wBE;EAAuB,gBAtgEH;A3E280BtB;;A2Er8wBE;EAAuB,gBAtgEH;A3E+80BtB;;A2Ez8wBE;EAAuB,gBAtgEH;A3Em90BtB;;A2E78wBE;EAAuB,gBAtgEH;A3Eu90BtB;;A2Ej9wBE;EAAuB,gBAtgEH;A3E290BtB;;A2Er9wBE;EAAuB,gBAtgEH;A3E+90BtB;;A2Ez9wBE;EAAuB,gBAtgEH;A3Em+0BtB;;A2E79wBE;EAAuB,gBAtgEH;A3Eu+0BtB;;A2Ej+wBE;EAAuB,gBAtgEH;A3E2+0BtB;;A2Er+wBE;EAAuB,gBAtgEH;A3E++0BtB;;A2Ez+wBE;EAAuB,gBAtgEH;A3Em/0BtB;;A2E7+wBE;EAAuB,gBAtgEH;A3Eu/0BtB;;A2Ej/wBE;EAAuB,gBAtgEH;A3E2/0BtB;;A2Er/wBE;EAAuB,gBAtgEH;A3E+/0BtB;;A2Ez/wBE;EAAuB,gBAtgEH;A3Emg1BtB;;A2E7/wBE;EAAuB,gBAtgEH;A3Eug1BtB;;A2EjgxBE;EAAuB,gBAtgEH;A3E2g1BtB;;A2ErgxBE;EAAuB,gBAtgEH;A3E+g1BtB;;A2EzgxBE;EAAuB,gBAtgEH;A3Emh1BtB;;A2E7gxBE;EAAuB,gBAtgEH;A3Euh1BtB;;A2EjhxBE;EAAuB,gBAtgEH;A3E2h1BtB;;A2ErhxBE;EAAuB,gBAtgEH;A3E+h1BtB;;A2EzhxBE;EAAuB,gBAtgEH;A3Emi1BtB;;A2E7hxBE;EAAuB,gBAtgEH;A3Eui1BtB;;A2EjixBE;EAAuB,gBAtgEH;A3E2i1BtB;;A2ErixBE;EAAuB,gBAtgEH;A3E+i1BtB;;A2EzixBE;EAAuB,gBAtgEH;A3Emj1BtB;;A2E7ixBE;EAAuB,gBAtgEH;A3Euj1BtB;;A2EjjxBE;EAAuB,gBAtgEH;A3E2j1BtB;;A2ErjxBE;EAAuB,gBAtgEH;A3E+j1BtB;;A2EzjxBE;EAAuB,gBAtgEH;A3Emk1BtB;;A2E7jxBE;EAAuB,gBAtgEH;A3Euk1BtB;;A2EjkxBE;EAAuB,gBAtgEH;A3E2k1BtB;;A2ErkxBE;EAAuB,gBAtgEH;A3E+k1BtB;;A2EzkxBE;EAAuB,gBAtgEH;A3Eml1BtB;;A2E7kxBE;EAAuB,gBAtgEH;A3Eul1BtB;;A2EjlxBE;EAAuB,gBAtgEH;A3E2l1BtB;;A2ErlxBE;EAAuB,gBAtgEH;A3E+l1BtB;;A2EzlxBE;EAAuB,gBAtgEH;A3Emm1BtB;;A2E7lxBE;EAAuB,gBAtgEH;A3Eum1BtB;;A2EjmxBE;EAAuB,gBAtgEH;A3E2m1BtB;;A2ErmxBE;EAAuB,gBAtgEH;A3E+m1BtB;;A2EzmxBE;EAAuB,gBAtgEH;A3Emn1BtB;;A2E7mxBE;EAAuB,gBAtgEH;A3Eun1BtB;;A2EjnxBE;EAAuB,gBAtgEH;A3E2n1BtB;;A2ErnxBE;EAAuB,gBAtgEH;A3E+n1BtB;;A2EznxBE;EAAuB,gBAtgEH;A3Emo1BtB;;A2E7nxBE;EAAuB,gBAtgEH;A3Euo1BtB;;A2EjoxBE;EAAuB,gBAtgEH;A3E2o1BtB;;A2EroxBE;EAAuB,gBAtgEH;A3E+o1BtB;;A2EzoxBE;EAAuB,gBAtgEH;A3Emp1BtB;;A2E7oxBE;EAAuB,gBAtgEH;A3Eup1BtB;;A2EjpxBE;EAAuB,gBAtgEH;A3E2p1BtB;;A2ErpxBE;EAAuB,gBAtgEH;A3E+p1BtB;;A2EzpxBE;EAAuB,gBAtgEH;A3Emq1BtB;;A2E7pxBE;EAAuB,gBAtgEH;A3Euq1BtB;;A2EjqxBE;EAAuB,gBAtgEH;A3E2q1BtB;;A2ErqxBE;EAAuB,gBAtgEH;A3E+q1BtB;;A2EzqxBE;EAAuB,gBAtgEH;A3Emr1BtB;;A2E7qxBE;EAAuB,gBAtgEH;A3Eur1BtB;;A2EjrxBE;EAAuB,gBAtgEH;A3E2r1BtB;;A2ErrxBE;EAAuB,gBAtgEH;A3E+r1BtB;;A2EzrxBE;EAAuB,gBAtgEH;A3Ems1BtB;;A2E7rxBE;EAAuB,gBAtgEH;A3Eus1BtB;;A2EjsxBE;EAAuB,gBAtgEH;A3E2s1BtB;;A2ErsxBE;EAAuB,gBAtgEH;A3E+s1BtB;;A2EzsxBE;EAAuB,gBAtgEH;A3Emt1BtB;;A2E7sxBE;EAAuB,gBAtgEH;A3Eut1BtB;;A2EjtxBE;EAAuB,gBAtgEH;A3E2t1BtB;;A2ErtxBE;EAAuB,gBAtgEH;A3E+t1BtB;;A2EztxBE;EAAuB,gBAtgEH;A3Emu1BtB;;A2E7txBE;EAAuB,gBAtgEH;A3Euu1BtB;;A2EjuxBE;EAAuB,gBAtgEH;A3E2u1BtB;;A2EruxBE;EAAuB,gBAtgEH;A3E+u1BtB;;A2EzuxBE;EAAuB,gBAtgEH;A3Emv1BtB;;A2E7uxBE;EAAuB,gBAtgEH;A3Euv1BtB;;A2EjvxBE;EAAuB,gBAtgEH;A3E2v1BtB;;A2ErvxBE;EAAuB,gBAtgEH;A3E+v1BtB;;A2EzvxBE;EAAuB,gBAtgEH;A3Emw1BtB;;A2E7vxBE;EAAuB,gBAtgEH;A3Euw1BtB;;A2EjwxBE;EAAuB,gBAtgEH;A3E2w1BtB;;A2ErwxBE;EAAuB,gBAtgEH;A3E+w1BtB;;A2EzwxBE;EAAuB,gBAtgEH;A3Emx1BtB;;A2E7wxBE;EAAuB,gBAtgEH;A3Eux1BtB;;A2EjxxBE;EAAuB,gBAtgEH;A3E2x1BtB;;A2ErxxBE;EAAuB,gBAtgEH;A3E+x1BtB;;A2EzxxBE;EAAuB,gBAtgEH;A3Emy1BtB;;A2E7xxBE;EAAuB,gBAtgEH;A3Euy1BtB;;A2EjyxBE;EAAuB,gBAtgEH;A3E2y1BtB;;A2EryxBE;EAAuB,gBAtgEH;A3E+y1BtB;;A2EzyxBE;EAAuB,gBAtgEH;A3Emz1BtB;;A2E7yxBE;EAAuB,gBAtgEH;A3Euz1BtB;;A2EjzxBE;EAAuB,gBAtgEH;A3E2z1BtB;;A2ErzxBE;EAAuB,gBAtgEH;A3E+z1BtB;;A2EzzxBE;EAAuB,gBAtgEH;A3Em01BtB;;A2E7zxBE;EAAuB,gBAtgEH;A3Eu01BtB;;A2Ej0xBE;EAAuB,gBAtgEH;A3E201BtB;;A2Er0xBE;EAAuB,gBAtgEH;A3E+01BtB;;A2Ez0xBE;EAAuB,gBAtgEH;A3Em11BtB;;A2E70xBE;EAAuB,gBAtgEH;A3Eu11BtB;;A2Ej1xBE;EAAuB,gBAtgEH;A3E211BtB;;A2Er1xBE;EAAuB,gBAtgEH;A3E+11BtB;;A2Ez1xBE;EAAuB,gBAtgEH;A3Em21BtB;;A2E71xBE;EAAuB,gBAtgEH;A3Eu21BtB;;A2Ej2xBE;EAAuB,gBAtgEH;A3E221BtB;;A2Er2xBE;EAAuB,gBAtgEH;A3E+21BtB;;A2Ez2xBE;EAAuB,gBAtgEH;A3Em31BtB;;A2E72xBE;EAAuB,gBAtgEH;A3Eu31BtB;;A2Ej3xBE;EAAuB,gBAtgEH;A3E231BtB;;A2Er3xBE;EAAuB,gBAtgEH;A3E+31BtB;;A2Ez3xBE;EAAuB,gBAtgEH;A3Em41BtB;;A2E73xBE;EAAuB,gBAtgEH;A3Eu41BtB;;A2Ej4xBE;EAAuB,gBAtgEH;A3E241BtB;;A2Er4xBE;EAAuB,gBAtgEH;A3E+41BtB;;A2Ez4xBE;EAAuB,gBAtgEH;A3Em51BtB;;A2E74xBE;EAAuB,gBAtgEH;A3Eu51BtB;;A2Ej5xBE;EAAuB,gBAtgEH;A3E251BtB;;A2Er5xBE;EAAuB,gBAtgEH;A3E+51BtB;;A2Ez5xBE;EAAuB,gBAtgEH;A3Em61BtB;;A2E75xBE;EAAuB,gBAtgEH;A3Eu61BtB;;A2Ej6xBE;EAAuB,gBAtgEH;A3E261BtB;;A2Er6xBE;EAAuB,gBAtgEH;A3E+61BtB;;A2Ez6xBE;EAAuB,gBAtgEH;A3Em71BtB;;A2E76xBE;EAAuB,gBAtgEH;A3Eu71BtB;;A2Ej7xBE;EAAuB,gBAtgEH;A3E271BtB;;A2Er7xBE;EAAuB,gBAtgEH;A3E+71BtB;;A2Ez7xBE;EAAuB,gBAtgEH;A3Em81BtB;;A2E77xBE;EAAuB,gBAtgEH;A3Eu81BtB;;A2Ej8xBE;EAAuB,gBAtgEH;A3E281BtB;;A2Er8xBE;EAAuB,gBAtgEH;A3E+81BtB;;A2Ez8xBE;EAAuB,gBAtgEH;A3Em91BtB;;A2E78xBE;EAAuB,gBAtgEH;A3Eu91BtB;;A2Ej9xBE;EAAuB,gBAtgEH;A3E291BtB;;A2Er9xBE;EAAuB,gBAtgEH;A3E+91BtB;;A2Ez9xBE;EAAuB,gBAtgEH;A3Em+1BtB;;A2E79xBE;EAAuB,gBAtgEH;A3Eu+1BtB;;A2Ej+xBE;EAAuB,gBAtgEH;A3E2+1BtB;;A2Er+xBE;EAAuB,gBAtgEH;A3E++1BtB;;A2Ez+xBE;EAAuB,gBAtgEH;A3Em/1BtB;;A2E7+xBE;EAAuB,gBAtgEH;A3Eu/1BtB;;A2Ej/xBE;EAAuB,gBAtgEH;A3E2/1BtB;;A2Er/xBE;EAAuB,gBAtgEH;A3E+/1BtB;;A2Ez/xBE;EAAuB,gBAtgEH;A3Emg2BtB;;A2E7/xBE;EAAuB,gBAtgEH;A3Eug2BtB;;A2EjgyBE;EAAuB,gBAtgEH;A3E2g2BtB;;A2ErgyBE;EAAuB,gBAtgEH;A3E+g2BtB;;A2EzgyBE;EAAuB,gBAtgEH;A3Emh2BtB;;A2E7gyBE;EAAuB,gBAtgEH;A3Euh2BtB;;A2EjhyBE;EAAuB,gBAtgEH;A3E2h2BtB;;A2ErhyBE;EAAuB,gBAtgEH;A3E+h2BtB;;A2EzhyBE;EAAuB,gBAtgEH;A3Emi2BtB;;A2E7hyBE;EAAuB,gBAtgEH;A3Eui2BtB;;A2EjiyBE;EAAuB,gBAtgEH;A3E2i2BtB;;A2EriyBE;EAAuB,gBAtgEH;A3E+i2BtB;;A2EziyBE;EAAuB,gBAtgEH;A3Emj2BtB;;A2E7iyBE;EAAuB,gBAtgEH;A3Euj2BtB;;A2EjjyBE;EAAuB,gBAtgEH;A3E2j2BtB;;A2ErjyBE;EAAuB,gBAtgEH;A3E+j2BtB;;A2EzjyBE;EAAuB,gBAtgEH;A3Emk2BtB;;A2E7jyBE;EAAuB,gBAtgEH;A3Euk2BtB;;A2EjkyBE;EAAuB,gBAtgEH;A3E2k2BtB;;A2ErkyBE;EAAuB,gBAtgEH;A3E+k2BtB;;A2EzkyBE;EAAuB,gBAtgEH;A3Eml2BtB;;A2E7kyBE;EAAuB,gBAtgEH;A3Eul2BtB;;A2EjlyBE;EAAuB,gBAtgEH;A3E2l2BtB;;A2ErlyBE;EAAuB,gBAtgEH;A3E+l2BtB;;A2EzlyBE;EAAuB,gBAtgEH;A3Emm2BtB;;A2E7lyBE;EAAuB,gBAtgEH;A3Eum2BtB;;A2EjmyBE;EAAuB,gBAtgEH;A3E2m2BtB;;A2ErmyBE;EAAuB,gBAtgEH;A3E+m2BtB;;A2EzmyBE;EAAuB,gBAtgEH;A3Emn2BtB;;A2E7myBE;EAAuB,gBAtgEH;A3Eun2BtB;;A2EjnyBE;EAAuB,gBAtgEH;A3E2n2BtB;;A2ErnyBE;EAAuB,gBAtgEH;A3E+n2BtB;;A2EznyBE;EAAuB,gBAtgEH;A3Emo2BtB;;A2E7nyBE;EAAuB,gBAtgEH;A3Euo2BtB;;A2EjoyBE;EAAuB,gBAtgEH;A3E2o2BtB;;A2EroyBE;EAAuB,gBAtgEH;A3E+o2BtB;;A2EzoyBE;EAAuB,gBAtgEH;A3Emp2BtB;;A2E7oyBE;EAAuB,gBAtgEH;A3Eup2BtB;;A2EjpyBE;EAAuB,gBAtgEH;A3E2p2BtB;;A2ErpyBE;EAAuB,gBAtgEH;A3E+p2BtB;;A2EzpyBE;EAAuB,gBAtgEH;A3Emq2BtB;;A2E7pyBE;EAAuB,gBAtgEH;A3Euq2BtB;;A2EjqyBE;EAAuB,gBAtgEH;A3E2q2BtB;;A2ErqyBE;EAAuB,gBAtgEH;A3E+q2BtB;;A2EzqyBE;EAAuB,gBAtgEH;A3Emr2BtB;;A2E7qyBE;EAAuB,gBAtgEH;A3Eur2BtB;;A2EjryBE;EAAuB,gBAtgEH;A3E2r2BtB;;A2ErryBE;EAAuB,gBAtgEH;A3E+r2BtB;;A2EzryBE;EAAuB,gBAtgEH;A3Ems2BtB;;A2E7ryBE;EAAuB,gBAtgEH;A3Eus2BtB;;A2EjsyBE;EAAuB,gBAtgEH;A3E2s2BtB;;A2ErsyBE;EAAuB,gBAtgEH;A3E+s2BtB;;A2EzsyBE;EAAuB,gBAtgEH;A3Emt2BtB;;A2E7syBE;EAAuB,gBAtgEH;A3Eut2BtB;;A2EjtyBE;EAAuB,gBAtgEH;A3E2t2BtB;;A2ErtyBE;EAAuB,gBAtgEH;A3E+t2BtB;;A2EztyBE;EAAuB,gBAtgEH;A3Emu2BtB;;A2E7tyBE;EAAuB,gBAtgEH;A3Euu2BtB;;A2EjuyBE;EAAuB,gBAtgEH;A3E2u2BtB;;A2EruyBE;EAAuB,gBAtgEH;A3E+u2BtB;;A2EzuyBE;EAAuB,gBAtgEH;A3Emv2BtB;;A2E7uyBE;EAAuB,gBAtgEH;A3Euv2BtB;;A2EjvyBE;EAAuB,gBAtgEH;A3E2v2BtB;;A2ErvyBE;EAAuB,gBAtgEH;A3E+v2BtB;;A2EzvyBE;EAAuB,gBAtgEH;A3Emw2BtB;;A2E7vyBE;EAAuB,gBAtgEH;A3Euw2BtB;;A2EjwyBE;EAAuB,gBAtgEH;A3E2w2BtB;;A2ErwyBE;EAAuB,gBAtgEH;A3E+w2BtB;;A2EzwyBE;EAAuB,gBAtgEH;A3Emx2BtB;;A2E7wyBE;EAAuB,gBAtgEH;A3Eux2BtB;;A2EjxyBE;EAAuB,gBAtgEH;A3E2x2BtB;;A2ErxyBE;EAAuB,gBAtgEH;A3E+x2BtB;;A2EzxyBE;EAAuB,gBAtgEH;A3Emy2BtB;;A2E7xyBE;EAAuB,gBAtgEH;A3Euy2BtB;;A2EjyyBE;EAAuB,gBAtgEH;A3E2y2BtB;;A2EryyBE;EAAuB,gBAtgEH;A3E+y2BtB;;A2EzyyBE;EAAuB,gBAtgEH;A3Emz2BtB;;A2E7yyBE;EAAuB,gBAtgEH;A3Euz2BtB;;A2EjzyBE;EAAuB,gBAtgEH;A3E2z2BtB;;A2ErzyBE;EAAuB,gBAtgEH;A3E+z2BtB;;A2EzzyBE;EAAuB,gBAtgEH;A3Em02BtB;;A2E7zyBE;EAAuB,gBAtgEH;A3Eu02BtB;;A2Ej0yBE;EAAuB,gBAtgEH;A3E202BtB;;A2Er0yBE;EAAuB,gBAtgEH;A3E+02BtB;;A2Ez0yBE;EAAuB,gBAtgEH;A3Em12BtB;;A2E70yBE;EAAuB,gBAtgEH;A3Eu12BtB;;A2Ej1yBE;EAAuB,gBAtgEH;A3E212BtB;;A2Er1yBE;EAAuB,gBAtgEH;A3E+12BtB;;A2Ez1yBE;EAAuB,gBAtgEH;A3Em22BtB;;A2E71yBE;EAAuB,gBAtgEH;A3Eu22BtB;;A2Ej2yBE;EAAuB,gBAtgEH;A3E222BtB;;A2Er2yBE;EAAuB,gBAtgEH;A3E+22BtB;;A2Ez2yBE;EAAuB,gBAtgEH;A3Em32BtB;;A2E72yBE;EAAuB,gBAtgEH;A3Eu32BtB;;A2Ej3yBE;EAAuB,gBAtgEH;A3E232BtB;;A2Er3yBE;EAAuB,gBAtgEH;A3E+32BtB;;A2Ez3yBE;EAAuB,gBAtgEH;A3Em42BtB;;A2E73yBE;EAAuB,gBAtgEH;A3Eu42BtB;;A2Ej4yBE;EAAuB,gBAtgEH;A3E242BtB;;A2Er4yBE;EAAuB,gBAtgEH;A3E+42BtB;;A2Ez4yBE;EAAuB,gBAtgEH;A3Em52BtB;;A2E74yBE;EAAuB,gBAtgEH;A3Eu52BtB;;A2Ej5yBE;EAAuB,gBAtgEH;A3E252BtB;;A2Er5yBE;EAAuB,gBAtgEH;A3E+52BtB;;A2Ez5yBE;EAAuB,gBAtgEH;A3Em62BtB;;A2E75yBE;EAAuB,gBAtgEH;A3Eu62BtB;;A2Ej6yBE;EAAuB,gBAtgEH;A3E262BtB;;A2Er6yBE;EAAuB,gBAtgEH;A3E+62BtB;;A2Ez6yBE;EAAuB,gBAtgEH;A3Em72BtB;;A2E76yBE;EAAuB,gBAtgEH;A3Eu72BtB;;A2Ej7yBE;EAAuB,YAtgEH;A3E272BtB;;A2Er7yBE;EAAuB,YAtgEH;A3E+72BtB;;A2Ez7yBE;EAAuB,YAtgEH;A3Em82BtB;;A2E77yBE;EAAuB,YAtgEH;A3Eu82BtB;;A4Ez+2BA;EACE,cAAA;EACA,YxDwIqB;EwDvIrB,sBtEKS;EsEJT,mExD0IkB;EwDzIlB,kBAAA;EACA,UAAA;A5E4+2BF;A4E3+2BE;EACE,yBtECO;EsEAP,mBxDmImB;ApB022BvB;A4E3+2BE;EACE,8BAAA;A5E6+2BJ;;AU762BI;EkE3DF;IACE,eAAA;IACA,YAAA;IACA,cAAA;IACA,UAAA;IACA,mBAAA;IACA,wBAAA;E5E4+2BF;E4E3+2BE;IACE,gBAAA;E5E6+2BJ;AACF;A6Evg3BA;EACE,iBAAA;A7Eyg3BF;;A6Evg3BA;EACE,YAAA;A7E0g3BF;;A6Exg3BA;EACE,iBAAA;EACA,cAAA;A7E2g3BF;;A6Ezg3BA;EACE,6CzD+EW;EyD9EX,mBAAA;A7E4g3BF;;A6Ezg3BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;A7E4g3BF;A6E3g3BE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;A7E6g3BJ;;A6E1g3BA;EACE,WAAA;A7E6g3BF;;A6E1g3BA;EACE,qBAAA;A7E6g3BF;;A6E3g3BA;EACE,mBAAA;A7E8g3BF","sourcesContent":["@charset \"UTF-8\";\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .fs-2 {\n    font-size: 2rem !important;\n  }\n  .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n/*******************/\n/********************/\n@font-face {\n  font-family: \"Poppins\";\n  src: local(\"Poppins\"), url(\"../fonts/Poppins-Regular.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"Poppins-SemiBold\";\n  src: local(\"Poppins\"), url(\"../fonts/Poppins-SemiBold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"Poppins-Medium\";\n  src: local(\"Poppins\"), url(\"../fonts/Poppins-Medium.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"Poppins-Bold\";\n  src: local(\"Poppins\"), url(\"../fonts/Poppins-Bold.ttf\") format(\"truetype\");\n}\n/*******************/\n/********************/\n/*******************/\n/********************/\n/*******************/\n/********************/\n/*******************/\n/********************/\n/*******************/\n/********************/\n/*******************/\n/********************/\n.strong-text {\n  position: relative;\n  bottom: 10px;\n}\n\n.blue-image img {\n  filter: invert(44%) sepia(17%) saturate(226%) hue-rotate(166deg) brightness(99%) contrast(94%);\n}\n\n.white-image img {\n  filter: invert(100%) sepia(0%) saturate(3524%) hue-rotate(261deg) brightness(122%) contrast(109%);\n}\n\n.file-icons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.file-icon {\n  width: 20px;\n  margin: 5px;\n}\n\n/* Phone number */\n.register_phone .PhoneInputInput {\n  height: 47px;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 146, 159, 0.1490196078);\n}\n\n.password-eye {\n  position: relative !important;\n}\n\n.password-eye .bi.bi-eye,\n.password-eye .bi.bi-eye-slash {\n  position: absolute !important;\n  right: 10px !important;\n  z-index: 1 !important;\n  bottom: 10px !important;\n}\n\n.to-address {\n  max-width: 100px;\n  overflow: auto;\n}\n\n.to-address::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n/* Track */\n.to-address::-webkit-scrollbar-track {\n  border-radius: 10px;\n}\n\n/* Handle */\n.to-address::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n.transaction_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.trans_history {\n  padding: 15px;\n  flex-direction: row;\n  justify-content: space-between;\n  border-width: 1px;\n  border-color: #739cab;\n  border-radius: 10px;\n  background-color: #e5f1f6;\n  margin-top: 30px;\n}\n\n.trans_history2 {\n  padding: 15px;\n  flex-direction: row;\n  justify-content: space-between;\n  border-width: 1px;\n  border-color: #f3d3c2;\n  border-radius: 10px;\n  background-color: #f7e9db;\n  margin-top: 30px;\n}\n\n.trans_history3 {\n  padding: 15px;\n  flex-direction: row;\n  justify-content: space-between;\n  border-width: 1px;\n  border-color: #ca8d98;\n  border-radius: 10px;\n  background-color: #f5dbdc;\n  margin-top: 30px;\n}\n\n.sell {\n  color: #cc8487;\n}\n\n.buy {\n  color: #83a189;\n}\n\n/* Searchable Dropdown*/\n.dropdown {\n  position: relative;\n  color: #333;\n  cursor: default;\n}\n\n.dropdown .arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 0;\n  content: \" \";\n  display: block;\n  height: 0;\n  margin-top: 0.3rem;\n  position: absolute;\n  right: 10px;\n  top: 14px;\n  width: 0;\n}\n\n.dropdown .arrow.open {\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n\n.dropdown .selected-value input {\n  line-height: 1.5;\n  font-size: 1rem;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  box-sizing: border-box;\n  cursor: default;\n  outline: none;\n  padding: 8px 52px 8px 10px;\n  transition: all 200ms ease;\n  width: 100%;\n}\n\n.dropdown .options {\n  display: none;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dropdown .options.open {\n  display: block;\n}\n\n.dropdown .option {\n  box-sizing: border-box;\n  color: rgba(51, 51, 51, 0.8);\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n\n.dropdown .option.selected,\n.dropdown .option:hover {\n  background-color: #f2f9fc;\n  color: #333;\n}\n\n.app-border {\n  border: 1px solid #00929f;\n}\n\n.payment-method {\n  background-color: rgb(242, 237, 255);\n  padding: 60px;\n  cursor: pointer;\n}\n\n.table-responsive {\n  overflow-y: hidden;\n}\n\n.form-check-input[type=checkbox]:checked {\n  background-color: #00929f !important;\n  border-color: #00929f !important;\n}\n\n.chat_box_animation {\n  transition: 0.2s;\n}\n\n.otp-animation {\n  transition: 0.8s;\n}\n\n.width_100 {\n  width: 100% !important;\n}\n\n.dashboard_box_biling {\n  background-image: linear-gradient(92deg, #354959 0%, #335539 100%, #3c7546 100%);\n}\n\n.bg_gradiant {\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n}\n\n.border-r {\n  border-right: 1.8px solid #ccc;\n}\n\n.border-l {\n  border-left: 1.8px solid #ccc;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.box_shadow {\n  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\n}\n\n.poppins-400 {\n  font-family: \"Poppins-Regular\";\n}\n\n.poppins-500 {\n  font-family: \"Poppins-Medium\";\n}\n\n.poppins-600 {\n  font-family: \"Poppins-SemiBold\";\n}\n\n.poppins-700 {\n  font-family: \"Poppins-Bold\";\n}\n\n.text_sm {\n  font-size: 13px;\n}\n\n.text_xs {\n  font-size: 12px;\n}\n\n.text_15 {\n  font-size: 15px;\n  line-height: 28px;\n}\n\n.text_14 {\n  font-size: 14px;\n}\n\n.text_18 {\n  font-size: 18px;\n}\n\n.text_base {\n  font-size: 16px;\n}\n\n.radius_15 {\n  border-radius: 15px;\n}\n\n.textgreen {\n  color: black;\n}\n\n.text-pending {\n  color: #7a8892;\n}\n\n.text-pending-back {\n  background-color: #ebecee;\n}\n\n.online-bubble {\n  background-color: #00ebbd;\n}\n\n.idle-bubble {\n  background-color: #ffa200;\n}\n\n.idle-text {\n  color: #ffa200;\n}\n\n.offline-bubble {\n  background-color: #b9b9b9;\n}\n\n.offline-text {\n  color: #b9b9b9;\n}\n\n.light_green {\n  color: #cce9ec;\n}\n\n.dark_blue {\n  color: #354959;\n}\n\n.text_gray {\n  color: #939ea8;\n}\n\n.text_gray_700 {\n  color: #333333;\n}\n\n.text_gray_500 {\n  color: #354959;\n  opacity: 0.8;\n}\n\n.text_gray_light {\n  color: #eaecee;\n}\n\n.bg_light_green {\n  background-color: #cce9ec;\n}\n\n.bg_light_green_500 {\n  background-color: #f0f9f9;\n}\n\n.bg_green_table {\n  background-color: #e5f5ec;\n}\n\n.bg_green {\n  background-color: #00929f;\n}\n\n.bg_green_500 {\n  background-color: #008b89;\n}\n\n.bg_dark_blue {\n  background-color: #354959;\n}\n\n.bg_gray {\n  background-color: #939ea8;\n}\n\n.bg_gray_500 {\n  background-color: #f2f3f7;\n}\n\n.bg_gray_700 {\n  background-color: #e5f5ec;\n}\n\n.bg_gray_light {\n  background-color: #eaecee;\n}\n\n.nav_green {\n  background-color: #00929f !important;\n  border-color: #00929f !important;\n}\n\n.border-green {\n  border: 1px solid #3c7546 !important;\n}\n\n.table-responsive {\n  border-radius: 16px;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\nimg {\n  max-width: 100%;\n}\n\nbody {\n  background-color: #f2f3f7 !important;\n}\n\n.navbar-dark {\n  background-color: #ffffff;\n}\n\n.navbar-collapse {\n  justify-content: end;\n}\n\n/*Clear chat*/\n.drop_chat {\n  top: 60px !important;\n  right: 15px !important;\n}\n\n.drop_chat:after {\n  content: \"\";\n  display: inline-block;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #fff;\n  width: 10px;\n  height: 9px;\n  position: absolute;\n  right: 19px;\n  top: -8px;\n}\n\n.chat_more:after {\n  content: \"\";\n  display: inline-block;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #fff;\n  width: 10px;\n  height: 9px;\n  position: absolute;\n  right: 19px;\n  top: -8px;\n}\n\n.react-time-picker__wrapper {\n  border: none !important;\n}\n\n.admin_name {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.billing_sec {\n  height: 240px;\n  background-color: #ffffff;\n  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));\n  border-radius: 15px;\n  padding: 15px 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  justify-content: space-evenly;\n}\n\n.billing_sec_top {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.billing_sec .billing_sec_top p {\n  margin: 0;\n  color: #354959;\n}\n\n.billing_sec strong {\n  font-size: 40px;\n  color: #354959;\n  font-family: \"Poppins-SemiBold\";\n  font-weight: 100;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.billing_sec strong span {\n  font-size: 14px;\n  color: #3c7546;\n  font-family: \"Poppins\";\n  background-color: #cce9ec;\n  padding: 3px 10px;\n  border-radius: 5px;\n}\n\n.billing_sec p {\n  color: #354959;\n  font-size: 13px;\n  line-height: 17px;\n  margin: 10px 0;\n}\n\n.billing_sec a {\n  text-align: center;\n  text-decoration: unset;\n  font-size: 14px;\n  border-radius: 5px;\n  color: #3c7546;\n  background-color: #cce9ec;\n  padding: 5px;\n}\n\n.billing_sec a svg {\n  margin-top: -3px;\n}\n\n.recentappoint_part {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 5px 14px;\n}\n\n.recentappoint_part h4, .recentappoint_part .h4 {\n  margin: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 19px;\n  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));\n  background-color: #3c7546;\n  display: block;\n  color: #ffffff;\n  text-align: center;\n  line-height: 38px;\n}\n\n.billing_sec .recentappoint_name strong {\n  font-size: 14px;\n  line-height: 22px;\n  color: #354959;\n}\n\n.billing_sec .recentappoint_name p {\n  margin: 0;\n  opacity: 0.502;\n  font-size: 12px;\n}\n\n.recentappoint_part span {\n  font-size: 12px;\n  color: #3c7546;\n  font-family: \"Poppins\";\n  background-color: #cce9ec;\n  padding: 3px 5px;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n.billing_sec .recentappoint_sec p {\n  margin: 0;\n  font-size: 15px;\n}\n\n.billing_sec.two {\n  justify-content: unset;\n  padding: 0;\n}\n\n.recentappoint_sec {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border-bottom: 2px solid #eaecee;\n}\n\n.billing_sec .recentappoint_sec a {\n  padding: 0;\n  background-color: unset;\n}\n\n.recentappoint_name.mes {\n  width: 70%;\n}\n\n.douctorlist_sec {\n  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));\n  background-color: #ffffff;\n  border-radius: 15px;\n  padding: 30px 30px 5px;\n}\n\n.douctorlist_head h4, .douctorlist_head .h4 {\n  margin: 0;\n  color: #354959;\n  font-size: 20px;\n  font-family: \"Poppins-SemiBold\";\n}\n\n.douctorlist_head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5em;\n}\n\n.douctorlist_part span img {\n  width: 58px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 29px;\n}\n\n.douctorlist_name p {\n  margin: 0;\n}\n\n.douctorlist_part span {\n  width: 15%;\n  display: inline-block;\n}\n\n.douctorlist_name {\n  width: 65%;\n}\n\n.douctorlist_part {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 18px 0;\n}\n\n.douctorlist_part svg {\n  font-size: 25px;\n}\n\n.douctorlist_head a {\n  text-decoration: unset;\n  color: #3c7546;\n}\n\n.patientsname_sec {\n  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));\n  background-color: #ffffff;\n  border-radius: 15px;\n  padding: 30px 30px 5px;\n}\n\n.patientsname_top {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1em;\n}\n\n.patientsname_top_left h2, .patientsname_top_left .h2 {\n  font-size: 20px;\n  color: #354959;\n  margin: 0;\n}\n\n.patientsname_top_left a {\n  text-decoration: unset;\n  font-size: 13px;\n  color: #3c7546;\n}\n\n.patientsname_top_right a {\n  font-size: 13px;\n  line-height: 17px;\n  color: #ffffff;\n  background-color: #3c7546;\n  border-radius: 5px;\n  text-decoration: unset;\n  padding: 8px 20px;\n}\n\n.patientsearch_form input[type=text] {\n  outline: unset;\n  height: 34px;\n  border-radius: 5px;\n  border: 1px solid rgba(53, 73, 89, 0.0705882353);\n  font-size: 13px;\n  padding-left: 2em;\n}\n\n.patientstable_sec tr th {\n  font-size: 13px;\n  color: #354959;\n  font-weight: 100;\n  opacity: 0.502;\n}\n\n.patientstable_sec tr td {\n  font-size: 13px;\n  color: #354959;\n  font-weight: 100;\n  opacity: 0.502;\n}\n\n.patientstable_sec thead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border: 0 !important;\n}\n\n.patientstable_sec thead {\n  border: 2px solid #eaecee !important;\n  border-left: unset !important;\n  border-right: unset !important;\n}\n\n.patientstable_sec tbody tr td:last-child {\n  padding: 5px;\n  display: flex;\n  gap: 10px;\n}\n\n.patientstable_sec tbody tr td:last-child button {\n  border: 1px solid #354959;\n  border-radius: 5px;\n  background-color: unset;\n}\n\n.dashpatient_wrap {\n  width: 65%;\n}\n\n.dashdoctor_wrap {\n  width: 35%;\n}\n\n.dashbottom_wrap {\n  float: left;\n  width: 100%;\n  display: flex;\n}\n\n.patientstable_sec thead tr th {\n  padding: 0.8rem 0.5rem;\n}\n\n.hospital-drop {\n  width: 250px;\n}\n\n.headersearch_section input[type=text] {\n  width: 70%;\n  border: unset;\n  font-size: 18px;\n  outline: unset;\n}\n\n.headersearch_section {\n  width: 100%;\n  padding-left: 3em;\n  position: relative;\n}\n\n.headersearch_wrap {\n  width: 78%;\n}\n\n.headersearch_section svg {\n  position: absolute;\n  left: 10px;\n  top: -2px;\n  font-size: 30px;\n}\n\n.headersearch_section svg {\n  fill: #354959;\n  opacity: 0.702;\n}\n\n.headernotify_section svg {\n  font-size: 40px;\n}\n\n.headernotify_section path {\n  fill: #354959;\n}\n\n.headernotify_section {\n  position: relative;\n}\n\n.headernotify_section:after {\n  content: \"\";\n  position: absolute;\n  top: 1px;\n  right: 5px;\n  width: 0.75em;\n  height: 0.75em;\n  border-radius: 50%;\n  background-color: #3c7546;\n}\n\n.headernotify_section:before {\n  content: \"\";\n  position: absolute;\n  top: 1px;\n  right: 5px;\n  width: 0.75em;\n  height: 0.75em;\n  border-radius: 50%;\n  background-color: #3c7546;\n}\n\n.headernotify_section::before {\n  animation: ping 1.7s ease infinite;\n  opacity: 0.7;\n}\n\n/****doctorpage****/\n.panel_top_section {\n  border-bottom: 2px solid #eee;\n  padding-bottom: 1.3em;\n}\n.panel_top_section h1, .panel_top_section .h1 {\n  color: #354959;\n  font-size: 28px;\n  display: inline-block;\n  padding-top: 4px;\n}\n.panel_top_section .btn_gradian {\n  height: 43px;\n  border-radius: 10px;\n}\n\n.grid_list_icons span {\n  color: #939ea8;\n  cursor: pointer;\n  padding: 0;\n}\n\n.docotr_innder_section {\n  border-radius: 15px;\n  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\n}\n\n.doctor_image img {\n  width: 116px;\n  height: 116px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.doctor_detail h4, .doctor_detail .h4 {\n  font-size: 18px;\n  line-height: 31px;\n  font-family: \"Poppins-Bold\";\n}\n.doctor_detail p {\n  font-size: 12px;\n  letter-spacing: 0px;\n  line-height: 17px;\n  margin-bottom: 10px;\n  color: #354959;\n}\n.doctor_detail ul {\n  padding: 0 1em;\n  text-align: left;\n  margin-bottom: 10px;\n}\n.doctor_detail ul li {\n  list-style-type: none;\n  gap: 15px;\n  padding: 5px 0 5px;\n  align-items: center;\n}\n.doctor_detail ul P {\n  margin: 0;\n  display: inline;\n}\n.doctor_detail ul a {\n  font-size: 12px;\n  letter-spacing: 0px;\n  line-height: 17px;\n  color: #354959;\n  text-decoration: none;\n}\n.doctor_detail ul span {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.profossional span {\n  min-width: 156px;\n  height: 27px;\n  border-radius: 5px;\n  color: #3c7546;\n  background-color: #cce9ec;\n  display: inline-block;\n  font-size: 15px;\n  line-height: 29px;\n  font-family: \"Poppins\";\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  padding: 0 10px;\n}\n\n.delete_btn {\n  min-width: 153px;\n  height: 36px;\n  border-radius: 5px;\n  background-color: #b8bfc5;\n  border: 0;\n  color: #fff;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.card_bottom {\n  display: flex;\n}\n\n.btn_gradian {\n  min-width: 153px;\n  height: 36px;\n  border-radius: 5px;\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n  border: 0;\n  color: #fff;\n  margin: 5px;\n  cursor: pointer;\n  padding: 0 15px;\n  transition: 0.5s;\n}\n\n.sidebar-active {\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%) !important;\n  border-radius: 3rem;\n}\n\n.btn_gradian_disabled {\n  min-width: 153px;\n  height: 36px;\n  border-radius: 5px;\n  border: 0;\n  margin: 5px;\n  padding: 0 15px;\n}\n\n.notification-body {\n  font-size: 13px;\n}\n\n.btn_gradian:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  transition: 0.5s;\n  background-image: linear-gradient(to right, #335539, #3c7546);\n}\n\n.delet_patiens {\n  min-width: 50px;\n  height: 42px;\n  border-radius: 7px;\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n  border: 0;\n  color: #fff;\n}\n\n.dark_btn {\n  background-image: unset;\n  background-color: #354959;\n}\n\n@keyframes ping {\n  0% {\n    transform: scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n/****listpage***/\n.list_head {\n  background-color: #e5f5ec;\n  text-align: center;\n}\n.list_head th {\n  padding: 1.5em 1em;\n}\n\ntr.list_detail:hover {\n  background-color: #e5f5ec;\n  cursor: pointer;\n  transition: 0.5s;\n}\n\ntr.list_detail.active {\n  background-color: #e5f5ec;\n}\n\n.list_detail {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid #eee !important;\n  transition: 0.5s;\n}\n.list_detail td {\n  padding: 15px 10px 15px;\n  font-size: 15px;\n}\n.list_detail p {\n  margin: 0;\n  display: inline-block;\n  padding-left: 15px;\n}\n.list_detail a {\n  color: #3c7546;\n  text-decoration: none;\n}\n.list_detail td span img {\n  width: 63px;\n  height: 63px;\n  object-fit: cover;\n  border-radius: 31px;\n  filter: drop-shadow(9.962px 0.872px 9px rgba(0, 0, 0, 0.11));\n}\n.list_detail .dost_btn {\n  width: 37px;\n  height: 36px;\n  background-color: #eaecee;\n  display: inline-block;\n  line-height: 37px;\n  border-radius: 50%;\n}\n\n.action {\n  width: 112px;\n  height: 36px;\n  background-color: #eaecee;\n  display: inline-block;\n  line-height: 37px;\n  border-radius: 18px;\n  text-align: center;\n}\n.action button {\n  border: 0;\n  background-color: transparent;\n}\n\n.refill-action {\n  display: flex;\n  gap: 10px;\n}\n.refill-action button {\n  border-radius: 5px;\n  border: none;\n  font-size: 18px;\n}\n.refill-action .accept-btn {\n  background-color: #d9eff1;\n  color: #3c7546;\n}\n.refill-action .reject-btn {\n  background-color: #e0e4e7;\n  color: #677782;\n}\n\n.drop_list {\n  transform: scale(0.1);\n  opacity: 0;\n  transition: 0.5s;\n  top: 100%;\n}\n\n.toast-header .btn-close {\n  color: #fff;\n}\n\n.three_dots:hover .drop_list {\n  transform: scale(1);\n  opacity: 1;\n  transition: 0.5s;\n}\n\n.exclamation_btn:hover .drop_list {\n  transform: scale(1);\n  opacity: 1;\n  transition: 0.5s;\n}\n\n.pagination_list ul {\n  padding: 0;\n  margin: 0;\n}\n.pagination_list li {\n  display: inline-block;\n  padding: 10px 5px;\n}\n.pagination_list a {\n  width: 31px;\n  height: 31px;\n  border-radius: 16px;\n  display: inline-block;\n  line-height: 31px;\n  color: #000;\n}\n.pagination_list .active a {\n  background-color: #059fac;\n  color: #fff;\n}\n\n/***doctor-detail***/\n.doctore_detail_wrap {\n  border-radius: 17px;\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\n  background-color: #fff;\n  margin: 2em 0 2em;\n  float: left;\n  width: 100%;\n}\n\n.doctor_detail_image {\n  border-radius: 15px;\n  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));\n  background-color: #f2f3f7;\n}\n.doctor_detail_image img {\n  border-radius: 15px;\n  height: 277px;\n  object-fit: cover;\n  width: 100%;\n}\n\n.doctor_detail_page {\n  float: left;\n  width: 100%;\n}\n.doctor_detail_page ul {\n  padding: 0;\n}\n.doctor_detail_page ul h5, .doctor_detail_page ul .h5 {\n  font-size: 15px;\n  line-height: 20px;\n  color: #3c7546;\n  margin: 0;\n}\n.doctor_detail_page ul li {\n  list-style-type: none;\n  float: left;\n  width: 100%;\n  padding: 5px 0 5px;\n}\n.doctor_detail_page ul a {\n  color: #354959;\n  font-size: 12px;\n  text-decoration: none;\n}\n.doctor_detail_page ul P {\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n.doctor_detail_page ul .right_box {\n  width: 75%;\n  padding-left: 10px;\n}\n\n.doctor_right_block h1, .doctor_right_block .h1 {\n  font-size: 25px;\n  line-height: 31px;\n  color: #354959;\n  font-family: \"Poppins-Bold\";\n}\n.doctor_right_block p {\n  font-size: 15px;\n  letter-spacing: 0px;\n  line-height: 28px;\n  color: #354959;\n  margin-top: 1em;\n}\n\n.doctor_right_top {\n  border-bottom: 1px solid #ccc;\n}\n\n.col-right {\n  text-align: right;\n}\n.col-right button {\n  border: 0;\n  width: 40px;\n  height: 40px;\n  margin-left: 10px;\n  border-radius: 20px;\n  margin-top: 5px;\n}\n.col-right .dots_btn {\n  position: relative;\n}\n.col-right .dots_btn button {\n  background-color: #fff;\n}\n.col-right .dots_btn :after {\n  content: \"\";\n  display: inline-block;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #fff;\n  width: 10px;\n  height: 9px;\n  position: absolute;\n  right: 15px;\n  top: -8px;\n}\n\n.drop_list {\n  position: absolute;\n  right: 0px;\n  top: 43px;\n  filter: drop-shadow(4.532px 2.113px 6.5px rgba(53, 73, 89, 0.19));\n  border-radius: 4px;\n  min-width: 70px;\n  z-index: 1;\n}\n.drop_list li {\n  font-size: 14px;\n  line-height: 22px;\n  color: #354959;\n  list-style-type: none;\n  display: block;\n  text-align: left;\n}\n.drop_list a {\n  color: #354959;\n  text-decoration: none;\n}\n.drop_list :after {\n  content: \"\";\n  display: inline-block;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #fff;\n  width: 10px;\n  height: 9px;\n  position: absolute;\n  right: 0px;\n  top: -8px;\n}\n\n.add_pdf {\n  min-width: 200px;\n}\n\n.sigCanvas {\n  width: 100%;\n  border: 1px solid black;\n}\n\n/***add-docor-page***/\n.card_box {\n  border-radius: 15px;\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\n  background-color: #fff;\n}\n\n.form-control {\n  height: 44px;\n}\n\n.form-control.multiple_choose {\n  height: auto;\n  min-height: 64px;\n}\n\n.textarea_input.form-control {\n  height: 63px;\n}\n\n.form-select {\n  height: 44px;\n}\n\n.add_doctor_fom p {\n  font-family: \"Poppins-Medium\";\n}\n\n.upload_btn {\n  display: inline-block;\n  width: 170px;\n  height: 47px;\n  border-radius: 10px;\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n  font-size: 18px;\n  letter-spacing: 0px;\n  color: #ffffff;\n  text-align: center;\n  line-height: 47px;\n}\n\n.up_arrow {\n  font-size: 44px;\n  padding-top: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n\n.form_bottom_btn button {\n  height: 43px;\n  border-radius: 10px;\n}\n\n/****patient_detail_page***/\n.pateint_profile img {\n  width: 113px;\n  height: 100px;\n  border-radius: 15px;\n  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));\n  background-color: #f2f3f7;\n}\n\n.tab_navigation li {\n  border-bottom: 1px solid transparent;\n}\n\n.tab_navigation li.active {\n  border-bottom: 1px solid #00929f;\n}\n\n.location_map img {\n  height: 200px;\n  object-fit: cover;\n}\n\n.location_map_image img {\n  height: 412px;\n  object-fit: cover;\n}\n\n.list_head.billing_head {\n  text-align: left;\n}\n.list_head.billing_head th {\n  padding: 1.5em 0.5em;\n  font-size: 14px;\n  text-align: left;\n}\n\n.list_detail.billing_detail td {\n  padding: 1.5em 0.5em;\n  font-size: 14px;\n}\n\n.po_pending {\n  min-width: 90px;\n}\n\n.percentage {\n  background-color: #33a8b2;\n}\n\n.demo_card {\n  position: relative;\n  top: -5em;\n  margin-bottom: -4em;\n}\n\n.payment_request {\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n}\n\n.payment_button button {\n  padding: 12px 0 12px;\n  font-size: 20px;\n  text-transform: uppercase;\n  border-radius: 10px;\n}\n\n.card_details {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 1em 3em;\n}\n\n.card_type {\n  text-align: right;\n}\n\n.select_drop_down {\n  color: #939ea8 !important;\n}\n.select_drop_down option {\n  color: #354959;\n}\n\n.payment_tab {\n  margin-bottom: 2em;\n}\n\n.payment_tab ul {\n  border-radius: 34px;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 6px;\n}\n\n.payment_tab ul li {\n  text-align: center;\n  display: inline-block;\n  float: left;\n  width: 48%;\n  border-radius: 40px;\n}\n\n.payment_tab ul li .nav-link {\n  font-size: 20px;\n  text-transform: uppercase;\n  color: #ffffff;\n  font-weight: 600;\n  display: flex;\n  height: 65px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 35px;\n  background-color: #00929f;\n}\n\n.payment_tab ul li .nav-link.active {\n  background-color: #354959;\n}\n\n.service_tab {\n  margin-bottom: 1em;\n}\n\n.service_tab ul {\n  background-color: #ffffff;\n  display: flex;\n  align-items: center !important;\n}\n\n.service_tab ul li {\n  text-align: center;\n  display: inline-block;\n  width: 48%;\n  border-radius: 40px;\n}\n\n.service_tab ul li .nav-link {\n  /* text-transform: uppercase; */\n  color: #ffffff;\n  font-weight: 600;\n  display: flex;\n  /* height: 65px; */\n  align-items: center;\n  justify-content: center;\n  border-radius: 35px;\n  background-color: #00929f;\n  padding: 5px;\n}\n\n.service_tab ul li .nav-link.active {\n  background-color: #354959;\n}\n\n.chat-users {\n  height: 400px;\n  max-height: 400px;\n}\n\n/***calend-style***/\n.calender_block .react-calendar {\n  width: 100%;\n  border-radius: 15px;\n  border: 0;\n}\n\n.calender_block .react-calendar__navigation {\n  background-color: #354959;\n}\n\n.calender_block .react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #00929f;\n}\n\n.calender_block .react-calendar__month-view__weekdays__weekday {\n  font-size: 17px;\n  letter-spacing: 0px;\n  line-height: 17px;\n  color: #354959;\n  font-family: \"Poppins-Medium\";\n}\n\n.calender_block .react-calendar__month-view__weekdays__weekday abbr[title] {\n  text-decoration: none;\n}\n\n.calender_block .react-calendar button {\n  color: #354959;\n  font-size: 16px;\n  line-height: 20px;\n}\n\n.calender_block.doctor_calender .react-calendar button {\n  border-radius: 36px;\n}\n\n.calender_block.doctor_calender .react-calendar button {\n  font-size: 17px;\n  line-height: 32px;\n  overflow: unset !important;\n  position: relative;\n}\n\n.cal_count {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 18px;\n  color: #ffffff;\n  background-color: #00929f;\n  font-size: 11px;\n  line-height: 18px;\n}\n\n.calender_block .react-calendar__month-view {\n  padding-bottom: 10px;\n}\n\n.calender_block .react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 1.28em 0.5em;\n}\n\n.calender_block .react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 1.28em 0.5em;\n}\n\n.calender_block .react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 1.28em 0.5em;\n}\n\n.calender_block .react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: #00929f;\n  color: #fff;\n}\n\n.calender_block .react-calendar__tile--now {\n  background: #00929f;\n  color: #fff !important;\n  background: unset;\n  color: #000 !important;\n  border: 1px solid #00929f;\n}\n\n.calender_block .react-calendar__tile--active {\n  background: #00929f;\n  color: #fff !important;\n}\n\n.calender_block .react-calendar__viewContainer {\n  padding: 0 20px;\n}\n\n.calender_block .react-calendar button {\n  border-radius: 20px;\n}\n\n.calender_block .react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #00929f !important;\n  color: #fff;\n}\n\n.calender_block .react-calendar__tile--hasActive {\n  background: #cce9ec;\n  color: #354959 !important;\n}\n\n.calender_block .react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #354959;\n}\n\n.calender_block .react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background: #00929f;\n  color: #ffffff !important;\n}\n\n.calender_block .react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 1.28em 0.5em !important;\n}\n\n.react-calendar__tile:disabled {\n  background-color: #fff !important;\n  opacity: 0.5;\n}\n\n.calender_block .react-calendar__navigation {\n  display: flex;\n  height: 65px;\n  margin-bottom: 1em;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  overflow: hidden;\n}\n.calender_block .react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n  font-size: 20px;\n  letter-spacing: 0px;\n  line-height: 17px;\n  color: #ffffff;\n  font-family: \"Poppins\";\n  border-radius: 0 !important;\n}\n\n.local-participant {\n  position: absolute;\n  z-index: 1;\n  bottom: 10px;\n  right: 20px;\n}\n\n.participants {\n  position: relative;\n  width: 640px;\n}\n\n.call_attend {\n  transform: rotate(135deg);\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button {\n  font-size: 0 !important;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button:after {\n  content: \"\\f284\";\n  font-family: bootstrap-icons !important;\n  font-size: 17px;\n  line-height: 33px;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button {\n  font-size: 0 !important;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button:after {\n  content: \"\\f285\";\n  font-family: bootstrap-icons !important;\n  font-size: 17px;\n  line-height: 33px;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button {\n  font-size: 0 !important;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button:after {\n  content: \"\\f280\";\n  font-family: bootstrap-icons !important;\n  font-size: 17px;\n  line-height: 33px;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button {\n  font-size: 0 !important;\n}\n\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button:after {\n  content: \"\\f27f\";\n  font-family: bootstrap-icons !important;\n  font-size: 17px;\n  line-height: 33px;\n}\n\n.date_btn button {\n  border-radius: 5px;\n  background-color: #fff;\n  border: 2px solid #3c7546;\n  padding: 7px 10px;\n  margin: 5px 7px;\n  color: #3c7546;\n  min-width: 125px;\n  text-align: center;\n}\n.date_btn .active {\n  background-color: #3c7546;\n  color: #fff;\n}\n\n.attachment span {\n  vertical-align: middle;\n}\n\n.app_content p {\n  margin: 0;\n}\n\n.treatment p {\n  text-align: justify;\n  line-height: 23px;\n}\n\n/***message***/\n.user_chat_img img {\n  width: 65px;\n  height: 65px;\n  border-radius: 5px;\n  object-fit: cover;\n}\n\n.user_chat:hover {\n  background-color: #e5f5ec;\n  transition: 0.5s;\n}\n\n.user_chat:hover .chat_group {\n  border-color: transparent !important;\n}\n\n.user_chat:last-child .chat_group {\n  border-color: transparent !important;\n}\n\n.count {\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  background-color: #00929f;\n  line-height: 20px;\n  font-size: 12px;\n}\n\n.col-right.chat_tools button {\n  width: 27px;\n  height: 27px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.chat_send {\n  border-radius: 8px;\n  border-bottom-right-radius: 0 !important;\n}\n\n.chat_receive {\n  border-radius: 8px;\n  border-bottom-left-radius: 0 !important;\n}\n\n.message_box .inner_location {\n  min-height: 100%;\n}\n\n.chat_message.custom_scroll {\n  height: 17vw;\n  overflow-y: scroll;\n}\n\n.chat_height.custom_scroll {\n  height: 21vw;\n  overflow-y: scroll;\n}\n\n.left_user.custom_scroll {\n  height: 23.4vw;\n  overflow-y: scroll;\n}\n\n/* width */\n.custom_scroll::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n/* Track */\n.custom_scroll::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 10px;\n}\n\n/* Handle */\n.custom_scroll::-webkit-scrollbar-thumb {\n  background: #e5f5ec;\n}\n\n/* Handle on hover */\n.custom_scroll::-webkit-scrollbar-thumb:hover {\n  background: #cce9ec;\n}\n\n.patient_info_profile img {\n  width: 155px;\n  height: 145px;\n  border-radius: 5px;\n  background-color: #f2f3f7;\n  object-fit: cover;\n}\n\n.post_image img {\n  width: 88px;\n  height: 88px;\n  border-radius: 5px;\n  background-color: #f2f3f7;\n  object-fit: cover;\n}\n\n.online {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  border: 1px solid #fff;\n  right: 30px;\n  bottom: -5px !important;\n}\n\n.online1 {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  border: 1px solid #fff;\n  right: -5px;\n  bottom: -5px !important;\n}\n\n.post_pdf span {\n  vertical-align: middle;\n}\n\n.user_chat_img.chat_detail_img img {\n  width: 30px;\n  height: 28px;\n  border-radius: 50% !important;\n  background-color: #f2f3f7;\n}\n\n.user_chat_img.chat_detail_img span {\n  width: 30px;\n  height: 28px;\n  border-radius: 50% !important;\n  background-color: #f2f3f7;\n  display: inline-block;\n}\n\n.chat_msg_content p {\n  font-size: 15px;\n  letter-spacing: 0px;\n  line-height: 28px;\n  color: #354959;\n  margin-bottom: 20px;\n}\n\n.regards p {\n  margin: 0;\n}\n\n.chat_message.chat_msg_content.custom_scroll {\n  height: 610px;\n}\n\n.chat_tab button {\n  background-color: #f2f3f7;\n}\n.chat_tab .active {\n  background-color: #fff;\n  color: #3c7546;\n}\n\n.tele_messgage {\n  height: 365px;\n  overflow-y: scroll;\n}\n\n.user_chat:hover .send_btn {\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\n  transition: 0.5s;\n}\n\n.left_refil {\n  height: 512px;\n  overflow-y: scroll;\n}\n\n.map {\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n  -ms-filter: grayscale(100%);\n  -o-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n\n.select_pharmacy {\n  border: 1px solid #3c7546 !important;\n  color: #939ea8 !important;\n}\n\n.user_ {\n  outline: none !important;\n  border: 0 !important;\n}\n\n.sidebar_left span {\n  opacity: 0.8;\n  color: #333333;\n}\n\n.sidebar_left .active {\n  background-color: #cce9ec !important;\n  color: #3c7546;\n}\n\n.sidebar_left .active i {\n  color: #3c7546;\n}\n\n.switch_toggle .form-switch .form-check-input:checked {\n  background-color: #cce9ec !important;\n}\n\n.switch_toggle .form-switch .form-check-inputt {\n  background-color: #c2c8cd !important;\n  height: 22px;\n  width: 52px;\n}\n\n.switch_toggle .form-check-input:focus {\n  border-color: #b2dee2;\n  outline: 0;\n  box-shadow: unset;\n}\n\n.switch {\n  position: absolute;\n  display: inline-block;\n  width: 54px;\n  height: 22px;\n  left: -30px;\n  top: 6px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #c2c8cd;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 30px;\n  width: 30px;\n  left: -1px;\n  bottom: -4px;\n  background-color: white;\n  transition: 0.4s;\n  border: 1px solid #c2c8cd;\n}\n\ninput:checked + .slider {\n  background-color: #b2dee2;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #b2dee2;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n  background-color: #00929f;\n}\n\n/* Rounded sliders */\n.slider.round_toggle {\n  border-radius: 34px;\n}\n\n.slider.round_toggle:before {\n  border-radius: 50%;\n}\n\n.vidoe_button button {\n  width: 42px;\n  height: 42px;\n  border-radius: 21px;\n  background-color: rgba(0, 0, 0, 0.38);\n  border: 0;\n  margin: 0 10px;\n  color: #fff;\n  font-size: 21px;\n  transition: 0.5s;\n}\n.vidoe_button button:hover {\n  background-color: #008b89;\n  transition: 0.5s;\n}\n\n.time_record {\n  background-color: rgba(0, 0, 0, 0.46);\n}\n\n.small_video {\n  position: absolute;\n  bottom: 20px;\n  right: 23px;\n}\n.small_video img {\n  width: 136px;\n  height: 154px;\n  border-radius: 15px;\n  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\n  background-color: #ffffff;\n  object-fit: cover;\n}\n\n/** File Renderer **/\n.file-details-container {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.name-container .file-size {\n  font-size: 11px;\n}\n\n.download-btn {\n  margin-left: auto;\n}\n\n/***admin-setting***/\n.admin_setting .inner_location {\n  min-height: 785px;\n}\n\n.type_check_box {\n  border: 2px solid #00929f;\n}\n\n.type_check_box .form-type_control {\n  border: 0;\n  border-bottom: 2px solid #00929f;\n  outline: none;\n}\n\n.admin_input .edit_btn {\n  width: 40px;\n  height: 128px;\n  border-radius: 21px;\n  filter: drop-shadow(4.532px 2.113px 12px rgba(53, 73, 89, 0.24));\n  right: -38px;\n  top: -4px;\n}\n\n.switch.check_switch_box {\n  left: auto;\n  right: 0;\n  width: 40px;\n  height: 15px;\n}\n\n.check_switch_box .slider:before {\n  height: 20px;\n  width: 20px;\n  bottom: -2px;\n  left: -4px;\n}\n\n.type_check_box input[type=date] {\n  border: 1px solid #00929f !important;\n}\n\n.admin_calender .react-calendar {\n  width: 100%;\n}\n\n.admin_calender .react-calendar__navigation {\n  background-color: #fff;\n  color: #354959;\n  font-size: 15px;\n}\n\n.admin_calender abbr[title] {\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  font-family: \"Poppins-Medium\";\n}\n\n.admin_calender .react-calendar__tile--active {\n  background: #cce9ec;\n  color: #354959;\n}\n\n.admin_calender .react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #cce9ec !important;\n  color: #354959 !important;\n}\n\n.admin_calender .react-calendar__tile--now {\n  background: #3c7546;\n  color: #fff;\n  border-radius: 26px;\n}\n\n.admin_calender .react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background: #3c7546;\n}\n\n.admin_calender .react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n  background: #3c7546 !important;\n}\n\n.admin_calender .react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background: #3c7546 !important;\n  color: #fff !important;\n}\n\n.admin_calender .react-calendar__tile {\n  font-family: \"Poppins-Regular\";\n  border-radius: 26px;\n}\n\n.admin_calender .react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 1em 0.5em;\n}\n\n.admin_calender .react-calendar {\n  border: 1px solid #eee;\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\n}\n\n.react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n}\n\n/******doctor-level*****/\n.recentappoint_doctor span {\n  display: inline-block;\n  width: 23px;\n  height: 23px;\n  border-radius: 12px;\n  text-align: center;\n  font-size: 11px;\n  line-height: 26px;\n  color: #354959;\n  background-color: #b8bfc5;\n  text-transform: uppercase;\n}\n\n.billing_sec .recentappoint_doctor {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  justify-content: space-between;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.billing_sec .recentappoint_doctor .recentappoint_name p {\n  font-size: 13px;\n  line-height: 31px;\n  color: #354959;\n  opacity: 1;\n  display: inline-block;\n}\n\n.billing_sec .recentappoint_doctor .recentappoint_name strong {\n  font-size: 13px;\n}\n\n.billing_sec .recentappoint_doctor .recentappoint_name {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.close_btn {\n  opacity: 0.502;\n  width: 21px;\n  height: 20px;\n  border-radius: 5px;\n  background-color: #fff;\n  border: 1px solid #343a40;\n  padding: 0;\n  font-size: 14px;\n}\n\n.check_btn {\n  width: 21px;\n  height: 20px;\n  border-radius: 5px;\n  background-color: #ffffff;\n  border: 1px solid #3c7546;\n  padding: 0;\n  color: #3c7546;\n  line-height: 20px;\n}\n\n.user_chat:hover .user_chat_detail span {\n  color: #3c7546;\n}\n\n.user_chat_img.patient_chat_img img {\n  width: 101px;\n  height: 101px;\n  border-radius: 51px;\n  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));\n  background-color: #333333;\n}\n\n.patient_enquiery button {\n  border: 1px solid #00929f;\n}\n\n.dost_btn:hover .show_option {\n  transform: scale(1);\n  transition: 0.5s;\n}\n\n.vidoe_large_img img {\n  height: 535px;\n  object-fit: cover;\n  width: 100%;\n}\n\n/****staff-dashoboard****/\n.staff_graph img {\n  height: 280px;\n  object-fit: cover;\n}\n\n.location_map_staff img {\n  height: 230px;\n  object-fit: cover;\n}\n\n.filter_blur {\n  opacity: 0.502;\n}\n\n.filter_right {\n  filter: blur(3px);\n}\n\n.requested_access {\n  z-index: 2;\n}\n\n/***break-poinst***/\n@media (max-width: 1200px) {\n  .border-r {\n    border-right: 0 !important;\n    border-bottom: 1.8px solid #ccc !important;\n  }\n  .demo_card {\n    top: 0;\n    margin-bottom: 0;\n  }\n  .headersearch_wrap {\n    width: 75%;\n  }\n  .headernotify_section svg {\n    font-size: 30px;\n  }\n  .login_img {\n    max-width: 40px;\n  }\n  .headersearch_wrap {\n    width: 68%;\n  }\n  .headersearch_section svg {\n    font-size: 20px;\n    margin-top: 6px;\n  }\n  .headersearch_section {\n    padding-left: 2.5em;\n  }\n  .headersearch_section input[type=text] {\n    width: 80%;\n  }\n  .user_login {\n    padding-right: 0;\n    gap: 0 !important;\n  }\n  .admin_setting .inner_location {\n    min-height: auto;\n  }\n  .user_chat_img.patient_chat_img img {\n    height: 75px;\n    width: 100px;\n  }\n  .left_user.custom_scroll {\n    height: 400px;\n    overflow-y: scroll;\n  }\n  .user_chat_img img {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n    object-fit: cover;\n    margin-bottom: 10px;\n  }\n  .online1 {\n    bottom: 10px !important;\n  }\n  .chat_message.custom_scroll {\n    height: 400px;\n    overflow-y: scroll;\n  }\n  .chat_height.custom_scroll {\n    height: 380px;\n    overflow-y: scroll;\n  }\n}\n@media (max-width: 576px) {\n  .wrapper.container-fluid, .wrapper.container-xxl, .wrapper.container-xl, .wrapper.container-lg, .wrapper.container-md, .wrapper.container-sm {\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n  }\n  .headersearch_section svg {\n    font-size: 20px;\n  }\n  .delete_btn {\n    min-width: 115px;\n  }\n  .btn_gradian {\n    min-width: 115px;\n  }\n  .panel_top_section h1,\n  .panel_top_section .h1 {\n    font-size: 26px;\n  }\n  .sidebarArea {\n    margin-left: -324px;\n  }\n  .list_detail p {\n    padding-left: 0;\n    font-size: 14px;\n    padding-top: 10px;\n  }\n  .panel_top_section .btn_gradian {\n    min-width: auto;\n    font-size: 14px;\n  }\n  .icons_patients {\n    right: 0;\n    top: -5px;\n  }\n  .list_head th {\n    min-width: 150px;\n  }\n  .appointment_table table tr td {\n    min-width: 118px;\n    width: 100%;\n    padding: 10px !important;\n    font-size: 14px;\n  }\n  .list_detail_new td {\n    min-width: 118px;\n    width: 100%;\n  }\n  .list_detail_new th {\n    min-width: 118px;\n    width: 100%;\n  }\n  .record_img a img {\n    max-width: 20px;\n  }\n  .record_img {\n    display: flex;\n  }\n  .full_width {\n    width: 100%;\n  }\n  .upload_delete {\n    position: absolute;\n    right: 10px;\n    left: auto !important;\n    text-align: right;\n  }\n  .user_chat_detail p {\n    font-size: 14px !important;\n  }\n  .user_chat_detail span {\n    font-size: 14px !important;\n  }\n  .vidoe_large_img img {\n    height: 300px;\n  }\n  .small_video img {\n    width: 80px;\n    height: 100px;\n  }\n  .vidoe_button button {\n    width: 35px;\n    height: 33px;\n    border: 0;\n    font-size: 16px;\n  }\n  .mobile-search-icon.d-none {\n    display: block !important;\n  }\n  .mobile-logo.d-none {\n    display: block !important;\n  }\n  .headersearch_section {\n    display: none !important;\n  }\n  .mobile-search-icon.d-none input {\n    position: absolute;\n    bottom: -45px;\n    left: 0;\n  }\n  .mobile-search-icon.d-none svg {\n    font-size: 28px;\n    cursor: pointer;\n  }\n  .header-nav .container-fluid, .header-nav .container-xxl, .header-nav .container-xl, .header-nav .container-lg, .header-nav .container-md, .header-nav .container-sm {\n    flex-wrap: nowrap !important;\n  }\n  .header-nav button.user_login {\n    padding: 0 !important;\n  }\n  .header-nav .align-items-center {\n    justify-content: space-between !important;\n  }\n  nav.header-nav {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n  .table-responsive,\n  .table-responsive.m-0 {\n    margin-top: 35px !important;\n  }\n  input#search_input {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -30px;\n  }\n  .panel_top_section {\n    position: relative;\n  }\n  .header-profile {\n    display: none;\n  }\n  .grid_icons.float-end {\n    margin: 0 auto;\n    float: unset !important;\n    justify-content: space-between;\n  }\n  .headersearch_wrap {\n    width: 100%;\n    padding-left: 15px;\n  }\n  .billing-container input#search_input {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -2em;\n    width: 100%;\n  }\n  .appointment-container input#search_input {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -17em;\n    width: 100%;\n  }\n  .appointment-container {\n    padding-bottom: 10px;\n  }\n  .table-responsive.m-0.appoint {\n    margin-top: 50px !important;\n  }\n  .payment_tab ul li .nav-link {\n    font-size: 13px;\n    height: 45px;\n  }\n  .service_tab ul li .nav-link {\n    font-size: 13px !important;\n    height: 45px;\n  }\n  .payment-method {\n    padding: 30px !important;\n  }\n  .order-number {\n    font-size: 13px;\n  }\n  .pat_group.py-2.d-flex {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr;\n  }\n  .d-flex.justify-content-between.mt-2 {\n    font-size: 15px;\n  }\n  .btn_gradian {\n    font-size: 12px;\n  }\n  .popup {\n    width: 100% !important;\n  }\n  .grid_icons.float-end.billing-filter {\n    margin: 0 auto;\n    float: right !important;\n    justify-content: space-between;\n  }\n  .patient-ques {\n    font-size: 14px;\n  }\n  .ques-title {\n    font-size: 20px !important;\n  }\n  .invoice-header-text {\n    font-size: 14px;\n  }\n}\n@media (max-width: 767px) {\n  .dropdown-menu.show {\n    display: block;\n    width: 100%;\n    float: left;\n  }\n  .header-dropdown {\n    position: absolute !important;\n    bottom: -45px;\n    left: 5px;\n    /* z-index: 1; */\n    width: 100%;\n    float: left;\n    right: 0;\n    margin: 0 auto;\n  }\n}\n@media (max-width: 992px) {\n  .hospital-drop {\n    width: 300px;\n  }\n}\n/*!\n * Bootstrap  v5.3.3 (https://getbootstrap.com/)\n * Copyright 2011-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #2962ff;\n  --bs-secondary: #35363b;\n  --bs-success: #0bb7af;\n  --bs-info: #3699ff;\n  --bs-warning: #ee9d01;\n  --bs-danger: #f64e60;\n  --bs-light: #eaf2fb;\n  --bs-dark: #343a40;\n  --bs-light-primary: #d6e4f3;\n  --bs-light-success: #d5f3f2;\n  --bs-light-info: #d3edfa;\n  --bs-light-warning: #f8ecdc;\n  --bs-light-danger: #f8dddd;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 25, 135, 84;\n  --bs-info-rgb: 13, 202, 240;\n  --bs-warning-rgb: 255, 193, 7;\n  --bs-danger-rgb: 220, 53, 69;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 33, 37, 41;\n  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);\n  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);\n  --bs-success-text-emphasis: rgb(10, 54, 33.6);\n  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);\n  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);\n  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);\n  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);\n  --bs-success-bg-subtle: rgb(209, 231, 220.8);\n  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);\n  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);\n  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);\n  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);\n  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);\n  --bs-success-border-subtle: rgb(163, 207, 186.6);\n  --bs-info-border-subtle: rgb(158.2, 233.8, 249);\n  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);\n  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: \"Poppins\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg: #fff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(33, 37, 41, 0.75);\n  --bs-secondary-color-rgb: 33, 37, 41;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n  --bs-tertiary-color-rgb: 33, 37, 41;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0d6efd;\n  --bs-link-color-rgb: 13, 110, 253;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgb(10.4, 88, 202.4);\n  --bs-link-hover-color-rgb: 10, 88, 202;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: rgb(255, 242.6, 205.4);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);\n  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);\n  --bs-success-text-emphasis: rgb(117, 183, 152.4);\n  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);\n  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);\n  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);\n  --bs-light-text-emphasis: #f8f9fa;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);\n  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);\n  --bs-success-bg-subtle: rgb(5, 27, 16.8);\n  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);\n  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);\n  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);\n  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);\n  --bs-success-border-subtle: rgb(15, 81, 50.4);\n  --bs-info-border-subtle: rgb(7.8, 121.2, 144);\n  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);\n  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(109.8, 168, 253.8);\n  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);\n  --bs-link-color-rgb: 110, 168, 254;\n  --bs-link-hover-color-rgb: 139, 185, 254;\n  --bs-code-color: rgb(230.4, 132.6, 181.2);\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: rgb(102, 77.2, 2.8);\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(117, 183, 152.4);\n  --bs-form-valid-border-color: rgb(117, 183, 152.4);\n  --bs-form-invalid-color: rgb(234, 133.8, 143.4);\n  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.5rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.325rem + 0.9vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 2rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.75rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.5rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(206.6, 226, 254.6);\n  --bs-table-border-color: rgb(165.28, 180.8, 203.68);\n  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(225.6, 227.4, 229);\n  --bs-table-border-color: rgb(180.48, 181.92, 183.2);\n  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(209, 231, 220.8);\n  --bs-table-border-color: rgb(167.2, 184.8, 176.64);\n  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(206.6, 244.4, 252);\n  --bs-table-border-color: rgb(165.28, 195.52, 201.6);\n  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(255, 242.6, 205.4);\n  --bs-table-border-color: rgb(204, 194.08, 164.32);\n  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(248, 214.6, 217.8);\n  --bs-table-border-color: rgb(198.4, 171.68, 174.24);\n  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: rgb(198.4, 199.2, 200);\n  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(223.2, 224.1, 225);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: rgb(77.4, 80.6, 83.8);\n  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: rgb(134, 182.5, 254);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-secondary-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: rgb(134, 182.5, 254);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgb(134, 182.5, 254);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28134, 182.5, 254%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(182.4, 211.5, 254.4);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(182.4, 211.5, 254.4);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-secondary-bg);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0px rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #2962ff;\n  --bs-btn-border-color: #2962ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(34.85, 83.3, 216.75);\n  --bs-btn-hover-border-color: rgb(32.8, 78.4, 204);\n  --bs-btn-focus-shadow-rgb: 73, 122, 255;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(32.8, 78.4, 204);\n  --bs-btn-active-border-color: rgb(30.75, 73.5, 191.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #2962ff;\n  --bs-btn-disabled-border-color: #2962ff;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #35363b;\n  --bs-btn-border-color: #35363b;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(45.05, 45.9, 50.15);\n  --bs-btn-hover-border-color: rgb(42.4, 43.2, 47.2);\n  --bs-btn-focus-shadow-rgb: 83, 84, 88;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(42.4, 43.2, 47.2);\n  --bs-btn-active-border-color: rgb(39.75, 40.5, 44.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #35363b;\n  --bs-btn-disabled-border-color: #35363b;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0bb7af;\n  --bs-btn-border-color: #0bb7af;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(9.35, 155.55, 148.75);\n  --bs-btn-hover-border-color: rgb(8.8, 146.4, 140);\n  --bs-btn-focus-shadow-rgb: 48, 194, 187;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(8.8, 146.4, 140);\n  --bs-btn-active-border-color: rgb(8.25, 137.25, 131.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0bb7af;\n  --bs-btn-disabled-border-color: #0bb7af;\n}\n\n.btn-info {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #3699ff;\n  --bs-btn-border-color: #3699ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(45.9, 130.05, 216.75);\n  --bs-btn-hover-border-color: rgb(43.2, 122.4, 204);\n  --bs-btn-focus-shadow-rgb: 84, 168, 255;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(43.2, 122.4, 204);\n  --bs-btn-active-border-color: rgb(40.5, 114.75, 191.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #3699ff;\n  --bs-btn-disabled-border-color: #3699ff;\n}\n\n.btn-warning {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #ee9d01;\n  --bs-btn-border-color: #ee9d01;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(202.3, 133.45, 0.85);\n  --bs-btn-hover-border-color: rgb(190.4, 125.6, 0.8);\n  --bs-btn-focus-shadow-rgb: 241, 172, 39;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(190.4, 125.6, 0.8);\n  --bs-btn-active-border-color: rgb(178.5, 117.75, 0.75);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #ee9d01;\n  --bs-btn-disabled-border-color: #ee9d01;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #f64e60;\n  --bs-btn-border-color: #f64e60;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(209.1, 66.3, 81.6);\n  --bs-btn-hover-border-color: rgb(196.8, 62.4, 76.8);\n  --bs-btn-focus-shadow-rgb: 247, 105, 120;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(196.8, 62.4, 76.8);\n  --bs-btn-active-border-color: rgb(184.5, 58.5, 72);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #f64e60;\n  --bs-btn-disabled-border-color: #f64e60;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #eaf2fb;\n  --bs-btn-border-color: #eaf2fb;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(198.9, 205.7, 213.35);\n  --bs-btn-hover-border-color: rgb(187.2, 193.6, 200.8);\n  --bs-btn-focus-shadow-rgb: 199, 206, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(187.2, 193.6, 200.8);\n  --bs-btn-active-border-color: rgb(175.5, 181.5, 188.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #eaf2fb;\n  --bs-btn-disabled-border-color: #eaf2fb;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #343a40;\n  --bs-btn-border-color: #343a40;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(82.45, 87.55, 92.65);\n  --bs-btn-hover-border-color: rgb(72.3, 77.7, 83.1);\n  --bs-btn-focus-shadow-rgb: 82, 88, 93;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(92.6, 97.4, 102.2);\n  --bs-btn-active-border-color: rgb(72.3, 77.7, 83.1);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #343a40;\n  --bs-btn-disabled-border-color: #343a40;\n}\n\n.btn-light-primary {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d6e4f3;\n  --bs-btn-border-color: #d6e4f3;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(220.15, 232.05, 244.8);\n  --bs-btn-hover-border-color: rgb(218.1, 230.7, 244.2);\n  --bs-btn-focus-shadow-rgb: 182, 194, 207;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(222.2, 233.4, 245.4);\n  --bs-btn-active-border-color: rgb(218.1, 230.7, 244.2);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d6e4f3;\n  --bs-btn-disabled-border-color: #d6e4f3;\n}\n\n.btn-light-success {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d5f3f2;\n  --bs-btn-border-color: #d5f3f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(219.3, 244.8, 243.95);\n  --bs-btn-hover-border-color: rgb(217.2, 244.2, 243.3);\n  --bs-btn-focus-shadow-rgb: 181, 207, 206;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(221.4, 245.4, 244.6);\n  --bs-btn-active-border-color: rgb(217.2, 244.2, 243.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d5f3f2;\n  --bs-btn-disabled-border-color: #d5f3f2;\n}\n\n.btn-light-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d3edfa;\n  --bs-btn-border-color: #d3edfa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(217.6, 239.7, 250.75);\n  --bs-btn-hover-border-color: rgb(215.4, 238.8, 250.5);\n  --bs-btn-focus-shadow-rgb: 179, 201, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(219.8, 240.6, 251);\n  --bs-btn-active-border-color: rgb(215.4, 238.8, 250.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d3edfa;\n  --bs-btn-disabled-border-color: #d3edfa;\n}\n\n.btn-light-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8ecdc;\n  --bs-btn-border-color: #f8ecdc;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(249.05, 238.85, 225.25);\n  --bs-btn-hover-border-color: rgb(248.7, 237.9, 223.5);\n  --bs-btn-focus-shadow-rgb: 211, 201, 187;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(249.4, 239.8, 227);\n  --bs-btn-active-border-color: rgb(248.7, 237.9, 223.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8ecdc;\n  --bs-btn-disabled-border-color: #f8ecdc;\n}\n\n.btn-light-danger {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8dddd;\n  --bs-btn-border-color: #f8dddd;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(249.05, 226.1, 226.1);\n  --bs-btn-hover-border-color: rgb(248.7, 224.4, 224.4);\n  --bs-btn-focus-shadow-rgb: 211, 188, 188;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(249.4, 227.8, 227.8);\n  --bs-btn-active-border-color: rgb(248.7, 224.4, 224.4);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8dddd;\n  --bs-btn-disabled-border-color: #f8dddd;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #2962ff;\n  --bs-btn-border-color: #2962ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #2962ff;\n  --bs-btn-hover-border-color: #2962ff;\n  --bs-btn-focus-shadow-rgb: 41, 98, 255;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #2962ff;\n  --bs-btn-active-border-color: #2962ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #2962ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #2962ff;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #35363b;\n  --bs-btn-border-color: #35363b;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #35363b;\n  --bs-btn-hover-border-color: #35363b;\n  --bs-btn-focus-shadow-rgb: 53, 54, 59;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #35363b;\n  --bs-btn-active-border-color: #35363b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #35363b;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #35363b;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #0bb7af;\n  --bs-btn-border-color: #0bb7af;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0bb7af;\n  --bs-btn-hover-border-color: #0bb7af;\n  --bs-btn-focus-shadow-rgb: 11, 183, 175;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0bb7af;\n  --bs-btn-active-border-color: #0bb7af;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0bb7af;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0bb7af;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #3699ff;\n  --bs-btn-border-color: #3699ff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #3699ff;\n  --bs-btn-hover-border-color: #3699ff;\n  --bs-btn-focus-shadow-rgb: 54, 153, 255;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #3699ff;\n  --bs-btn-active-border-color: #3699ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3699ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3699ff;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ee9d01;\n  --bs-btn-border-color: #ee9d01;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #ee9d01;\n  --bs-btn-hover-border-color: #ee9d01;\n  --bs-btn-focus-shadow-rgb: 238, 157, 1;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #ee9d01;\n  --bs-btn-active-border-color: #ee9d01;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ee9d01;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ee9d01;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #f64e60;\n  --bs-btn-border-color: #f64e60;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #f64e60;\n  --bs-btn-hover-border-color: #f64e60;\n  --bs-btn-focus-shadow-rgb: 246, 78, 96;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #f64e60;\n  --bs-btn-active-border-color: #f64e60;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f64e60;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f64e60;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #eaf2fb;\n  --bs-btn-border-color: #eaf2fb;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #eaf2fb;\n  --bs-btn-hover-border-color: #eaf2fb;\n  --bs-btn-focus-shadow-rgb: 234, 242, 251;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #eaf2fb;\n  --bs-btn-active-border-color: #eaf2fb;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #eaf2fb;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #eaf2fb;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #343a40;\n  --bs-btn-border-color: #343a40;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #343a40;\n  --bs-btn-hover-border-color: #343a40;\n  --bs-btn-focus-shadow-rgb: 52, 58, 64;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #343a40;\n  --bs-btn-active-border-color: #343a40;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #343a40;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #343a40;\n  --bs-gradient: none;\n}\n\n.btn-outline-light-primary {\n  --bs-btn-color: #d6e4f3;\n  --bs-btn-border-color: #d6e4f3;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d6e4f3;\n  --bs-btn-hover-border-color: #d6e4f3;\n  --bs-btn-focus-shadow-rgb: 214, 228, 243;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d6e4f3;\n  --bs-btn-active-border-color: #d6e4f3;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d6e4f3;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d6e4f3;\n  --bs-gradient: none;\n}\n\n.btn-outline-light-success {\n  --bs-btn-color: #d5f3f2;\n  --bs-btn-border-color: #d5f3f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d5f3f2;\n  --bs-btn-hover-border-color: #d5f3f2;\n  --bs-btn-focus-shadow-rgb: 213, 243, 242;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d5f3f2;\n  --bs-btn-active-border-color: #d5f3f2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d5f3f2;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d5f3f2;\n  --bs-gradient: none;\n}\n\n.btn-outline-light-info {\n  --bs-btn-color: #d3edfa;\n  --bs-btn-border-color: #d3edfa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d3edfa;\n  --bs-btn-hover-border-color: #d3edfa;\n  --bs-btn-focus-shadow-rgb: 211, 237, 250;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d3edfa;\n  --bs-btn-active-border-color: #d3edfa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d3edfa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d3edfa;\n  --bs-gradient: none;\n}\n\n.btn-outline-light-warning {\n  --bs-btn-color: #f8ecdc;\n  --bs-btn-border-color: #f8ecdc;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8ecdc;\n  --bs-btn-hover-border-color: #f8ecdc;\n  --bs-btn-focus-shadow-rgb: 248, 236, 220;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8ecdc;\n  --bs-btn-active-border-color: #f8ecdc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8ecdc;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8ecdc;\n  --bs-gradient: none;\n}\n\n.btn-outline-light-danger {\n  --bs-btn-color: #f8dddd;\n  --bs-btn-border-color: #f8dddd;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8dddd;\n  --bs-btn-hover-border-color: #f8dddd;\n  --bs-btn-focus-shadow-rgb: 248, 221, 221;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8dddd;\n  --bs-btn-active-border-color: #f8dddd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8dddd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8dddd;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: var(--bs-border-radius);\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--bs-border-radius);\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--bs-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.3125rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: #fff;\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23212529' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%285.2, 44, 101.2%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28109.8, 168, 253.8%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28109.8, 168, 253.8%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n.alert-light-primary {\n  --bs-alert-color: var(--bs-light-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-light-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-light-primary-text-emphasis);\n}\n\n.alert-light-success {\n  --bs-alert-color: var(--bs-light-success-text-emphasis);\n  --bs-alert-bg: var(--bs-light-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-success-border-subtle);\n  --bs-alert-link-color: var(--bs-light-success-text-emphasis);\n}\n\n.alert-light-info {\n  --bs-alert-color: var(--bs-light-info-text-emphasis);\n  --bs-alert-bg: var(--bs-light-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-info-border-subtle);\n  --bs-alert-link-color: var(--bs-light-info-text-emphasis);\n}\n\n.alert-light-warning {\n  --bs-alert-color: var(--bs-light-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-light-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-light-warning-text-emphasis);\n}\n\n.alert-light-danger {\n  --bs-alert-color: var(--bs-light-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-light-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-light-danger-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0d6efd;\n  --bs-list-group-active-border-color: #0d6efd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.list-group-item-light-primary {\n  --bs-list-group-color: var(--bs-light-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-primary-text-emphasis);\n}\n\n.list-group-item-light-success {\n  --bs-list-group-color: var(--bs-light-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-success-text-emphasis);\n}\n\n.list-group-item-light-info {\n  --bs-list-group-color: var(--bs-light-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-info-text-emphasis);\n}\n\n.list-group-item-light-warning {\n  --bs-list-group-color: var(--bs-light-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-warning-text-emphasis);\n}\n\n.list-group-item-light-danger {\n  --bs-list-group-color: var(--bs-light-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-danger-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.875rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light-primary {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light-success {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light-danger {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(33, 78, 204, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(33, 78, 204, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(42, 43, 47, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(42, 43, 47, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(9, 146, 140, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(9, 146, 140, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(43, 122, 204, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(43, 122, 204, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(190, 126, 1, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(190, 126, 1, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(197, 62, 77, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(197, 62, 77, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(238, 245, 252, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(238, 245, 252, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(42, 46, 51, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(42, 46, 51, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light-primary {\n  color: RGBA(var(--bs-light-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light-primary:hover, .link-light-primary:focus {\n  color: RGBA(222, 233, 245, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(222, 233, 245, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light-success {\n  color: RGBA(var(--bs-light-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light-success:hover, .link-light-success:focus {\n  color: RGBA(221, 245, 245, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(221, 245, 245, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light-info {\n  color: RGBA(var(--bs-light-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light-info:hover, .link-light-info:focus {\n  color: RGBA(220, 241, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(220, 241, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light-warning {\n  color: RGBA(var(--bs-light-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light-warning:hover, .link-light-warning:focus {\n  color: RGBA(249, 240, 227, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 240, 227, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light-danger {\n  color: RGBA(var(--bs-light-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light-danger:hover, .link-light-danger:focus {\n  color: RGBA(249, 228, 228, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 228, 228, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .fs-2 {\n    font-size: 2rem !important;\n  }\n  .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n/*!\n * Bootstrap Icons v1.11.3 (https://icons.getbootstrap.com/)\n * Copyright 2019-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/icons/blob/main/LICENSE)\n */\n@font-face {\n  font-display: block;\n  font-family: \"bootstrap-icons\";\n  src: url(\"./fonts/bootstrap-icons.woff2?24e3eb84d0bcaf83d77f904c78ac1f47\") format(\"woff2\"), url(\"./fonts/bootstrap-icons.woff?24e3eb84d0bcaf83d77f904c78ac1f47\") format(\"woff\");\n}\n.bi::before,\n[class^=bi-]::before,\n[class*=\" bi-\"]::before {\n  display: inline-block;\n  font-family: \"bootstrap-icons\" !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.bi-123::before {\n  content: \"\\f67f\";\n}\n\n.bi-alarm-fill::before {\n  content: \"\\f101\";\n}\n\n.bi-alarm::before {\n  content: \"\\f102\";\n}\n\n.bi-align-bottom::before {\n  content: \"\\f103\";\n}\n\n.bi-align-center::before {\n  content: \"\\f104\";\n}\n\n.bi-align-end::before {\n  content: \"\\f105\";\n}\n\n.bi-align-middle::before {\n  content: \"\\f106\";\n}\n\n.bi-align-start::before {\n  content: \"\\f107\";\n}\n\n.bi-align-top::before {\n  content: \"\\f108\";\n}\n\n.bi-alt::before {\n  content: \"\\f109\";\n}\n\n.bi-app-indicator::before {\n  content: \"\\f10a\";\n}\n\n.bi-app::before {\n  content: \"\\f10b\";\n}\n\n.bi-archive-fill::before {\n  content: \"\\f10c\";\n}\n\n.bi-archive::before {\n  content: \"\\f10d\";\n}\n\n.bi-arrow-90deg-down::before {\n  content: \"\\f10e\";\n}\n\n.bi-arrow-90deg-left::before {\n  content: \"\\f10f\";\n}\n\n.bi-arrow-90deg-right::before {\n  content: \"\\f110\";\n}\n\n.bi-arrow-90deg-up::before {\n  content: \"\\f111\";\n}\n\n.bi-arrow-bar-down::before {\n  content: \"\\f112\";\n}\n\n.bi-arrow-bar-left::before {\n  content: \"\\f113\";\n}\n\n.bi-arrow-bar-right::before {\n  content: \"\\f114\";\n}\n\n.bi-arrow-bar-up::before {\n  content: \"\\f115\";\n}\n\n.bi-arrow-clockwise::before {\n  content: \"\\f116\";\n}\n\n.bi-arrow-counterclockwise::before {\n  content: \"\\f117\";\n}\n\n.bi-arrow-down-circle-fill::before {\n  content: \"\\f118\";\n}\n\n.bi-arrow-down-circle::before {\n  content: \"\\f119\";\n}\n\n.bi-arrow-down-left-circle-fill::before {\n  content: \"\\f11a\";\n}\n\n.bi-arrow-down-left-circle::before {\n  content: \"\\f11b\";\n}\n\n.bi-arrow-down-left-square-fill::before {\n  content: \"\\f11c\";\n}\n\n.bi-arrow-down-left-square::before {\n  content: \"\\f11d\";\n}\n\n.bi-arrow-down-left::before {\n  content: \"\\f11e\";\n}\n\n.bi-arrow-down-right-circle-fill::before {\n  content: \"\\f11f\";\n}\n\n.bi-arrow-down-right-circle::before {\n  content: \"\\f120\";\n}\n\n.bi-arrow-down-right-square-fill::before {\n  content: \"\\f121\";\n}\n\n.bi-arrow-down-right-square::before {\n  content: \"\\f122\";\n}\n\n.bi-arrow-down-right::before {\n  content: \"\\f123\";\n}\n\n.bi-arrow-down-short::before {\n  content: \"\\f124\";\n}\n\n.bi-arrow-down-square-fill::before {\n  content: \"\\f125\";\n}\n\n.bi-arrow-down-square::before {\n  content: \"\\f126\";\n}\n\n.bi-arrow-down-up::before {\n  content: \"\\f127\";\n}\n\n.bi-arrow-down::before {\n  content: \"\\f128\";\n}\n\n.bi-arrow-left-circle-fill::before {\n  content: \"\\f129\";\n}\n\n.bi-arrow-left-circle::before {\n  content: \"\\f12a\";\n}\n\n.bi-arrow-left-right::before {\n  content: \"\\f12b\";\n}\n\n.bi-arrow-left-short::before {\n  content: \"\\f12c\";\n}\n\n.bi-arrow-left-square-fill::before {\n  content: \"\\f12d\";\n}\n\n.bi-arrow-left-square::before {\n  content: \"\\f12e\";\n}\n\n.bi-arrow-left::before {\n  content: \"\\f12f\";\n}\n\n.bi-arrow-repeat::before {\n  content: \"\\f130\";\n}\n\n.bi-arrow-return-left::before {\n  content: \"\\f131\";\n}\n\n.bi-arrow-return-right::before {\n  content: \"\\f132\";\n}\n\n.bi-arrow-right-circle-fill::before {\n  content: \"\\f133\";\n}\n\n.bi-arrow-right-circle::before {\n  content: \"\\f134\";\n}\n\n.bi-arrow-right-short::before {\n  content: \"\\f135\";\n}\n\n.bi-arrow-right-square-fill::before {\n  content: \"\\f136\";\n}\n\n.bi-arrow-right-square::before {\n  content: \"\\f137\";\n}\n\n.bi-arrow-right::before {\n  content: \"\\f138\";\n}\n\n.bi-arrow-up-circle-fill::before {\n  content: \"\\f139\";\n}\n\n.bi-arrow-up-circle::before {\n  content: \"\\f13a\";\n}\n\n.bi-arrow-up-left-circle-fill::before {\n  content: \"\\f13b\";\n}\n\n.bi-arrow-up-left-circle::before {\n  content: \"\\f13c\";\n}\n\n.bi-arrow-up-left-square-fill::before {\n  content: \"\\f13d\";\n}\n\n.bi-arrow-up-left-square::before {\n  content: \"\\f13e\";\n}\n\n.bi-arrow-up-left::before {\n  content: \"\\f13f\";\n}\n\n.bi-arrow-up-right-circle-fill::before {\n  content: \"\\f140\";\n}\n\n.bi-arrow-up-right-circle::before {\n  content: \"\\f141\";\n}\n\n.bi-arrow-up-right-square-fill::before {\n  content: \"\\f142\";\n}\n\n.bi-arrow-up-right-square::before {\n  content: \"\\f143\";\n}\n\n.bi-arrow-up-right::before {\n  content: \"\\f144\";\n}\n\n.bi-arrow-up-short::before {\n  content: \"\\f145\";\n}\n\n.bi-arrow-up-square-fill::before {\n  content: \"\\f146\";\n}\n\n.bi-arrow-up-square::before {\n  content: \"\\f147\";\n}\n\n.bi-arrow-up::before {\n  content: \"\\f148\";\n}\n\n.bi-arrows-angle-contract::before {\n  content: \"\\f149\";\n}\n\n.bi-arrows-angle-expand::before {\n  content: \"\\f14a\";\n}\n\n.bi-arrows-collapse::before {\n  content: \"\\f14b\";\n}\n\n.bi-arrows-expand::before {\n  content: \"\\f14c\";\n}\n\n.bi-arrows-fullscreen::before {\n  content: \"\\f14d\";\n}\n\n.bi-arrows-move::before {\n  content: \"\\f14e\";\n}\n\n.bi-aspect-ratio-fill::before {\n  content: \"\\f14f\";\n}\n\n.bi-aspect-ratio::before {\n  content: \"\\f150\";\n}\n\n.bi-asterisk::before {\n  content: \"\\f151\";\n}\n\n.bi-at::before {\n  content: \"\\f152\";\n}\n\n.bi-award-fill::before {\n  content: \"\\f153\";\n}\n\n.bi-award::before {\n  content: \"\\f154\";\n}\n\n.bi-back::before {\n  content: \"\\f155\";\n}\n\n.bi-backspace-fill::before {\n  content: \"\\f156\";\n}\n\n.bi-backspace-reverse-fill::before {\n  content: \"\\f157\";\n}\n\n.bi-backspace-reverse::before {\n  content: \"\\f158\";\n}\n\n.bi-backspace::before {\n  content: \"\\f159\";\n}\n\n.bi-badge-3d-fill::before {\n  content: \"\\f15a\";\n}\n\n.bi-badge-3d::before {\n  content: \"\\f15b\";\n}\n\n.bi-badge-4k-fill::before {\n  content: \"\\f15c\";\n}\n\n.bi-badge-4k::before {\n  content: \"\\f15d\";\n}\n\n.bi-badge-8k-fill::before {\n  content: \"\\f15e\";\n}\n\n.bi-badge-8k::before {\n  content: \"\\f15f\";\n}\n\n.bi-badge-ad-fill::before {\n  content: \"\\f160\";\n}\n\n.bi-badge-ad::before {\n  content: \"\\f161\";\n}\n\n.bi-badge-ar-fill::before {\n  content: \"\\f162\";\n}\n\n.bi-badge-ar::before {\n  content: \"\\f163\";\n}\n\n.bi-badge-cc-fill::before {\n  content: \"\\f164\";\n}\n\n.bi-badge-cc::before {\n  content: \"\\f165\";\n}\n\n.bi-badge-hd-fill::before {\n  content: \"\\f166\";\n}\n\n.bi-badge-hd::before {\n  content: \"\\f167\";\n}\n\n.bi-badge-tm-fill::before {\n  content: \"\\f168\";\n}\n\n.bi-badge-tm::before {\n  content: \"\\f169\";\n}\n\n.bi-badge-vo-fill::before {\n  content: \"\\f16a\";\n}\n\n.bi-badge-vo::before {\n  content: \"\\f16b\";\n}\n\n.bi-badge-vr-fill::before {\n  content: \"\\f16c\";\n}\n\n.bi-badge-vr::before {\n  content: \"\\f16d\";\n}\n\n.bi-badge-wc-fill::before {\n  content: \"\\f16e\";\n}\n\n.bi-badge-wc::before {\n  content: \"\\f16f\";\n}\n\n.bi-bag-check-fill::before {\n  content: \"\\f170\";\n}\n\n.bi-bag-check::before {\n  content: \"\\f171\";\n}\n\n.bi-bag-dash-fill::before {\n  content: \"\\f172\";\n}\n\n.bi-bag-dash::before {\n  content: \"\\f173\";\n}\n\n.bi-bag-fill::before {\n  content: \"\\f174\";\n}\n\n.bi-bag-plus-fill::before {\n  content: \"\\f175\";\n}\n\n.bi-bag-plus::before {\n  content: \"\\f176\";\n}\n\n.bi-bag-x-fill::before {\n  content: \"\\f177\";\n}\n\n.bi-bag-x::before {\n  content: \"\\f178\";\n}\n\n.bi-bag::before {\n  content: \"\\f179\";\n}\n\n.bi-bar-chart-fill::before {\n  content: \"\\f17a\";\n}\n\n.bi-bar-chart-line-fill::before {\n  content: \"\\f17b\";\n}\n\n.bi-bar-chart-line::before {\n  content: \"\\f17c\";\n}\n\n.bi-bar-chart-steps::before {\n  content: \"\\f17d\";\n}\n\n.bi-bar-chart::before {\n  content: \"\\f17e\";\n}\n\n.bi-basket-fill::before {\n  content: \"\\f17f\";\n}\n\n.bi-basket::before {\n  content: \"\\f180\";\n}\n\n.bi-basket2-fill::before {\n  content: \"\\f181\";\n}\n\n.bi-basket2::before {\n  content: \"\\f182\";\n}\n\n.bi-basket3-fill::before {\n  content: \"\\f183\";\n}\n\n.bi-basket3::before {\n  content: \"\\f184\";\n}\n\n.bi-battery-charging::before {\n  content: \"\\f185\";\n}\n\n.bi-battery-full::before {\n  content: \"\\f186\";\n}\n\n.bi-battery-half::before {\n  content: \"\\f187\";\n}\n\n.bi-battery::before {\n  content: \"\\f188\";\n}\n\n.bi-bell-fill::before {\n  content: \"\\f189\";\n}\n\n.bi-bell::before {\n  content: \"\\f18a\";\n}\n\n.bi-bezier::before {\n  content: \"\\f18b\";\n}\n\n.bi-bezier2::before {\n  content: \"\\f18c\";\n}\n\n.bi-bicycle::before {\n  content: \"\\f18d\";\n}\n\n.bi-binoculars-fill::before {\n  content: \"\\f18e\";\n}\n\n.bi-binoculars::before {\n  content: \"\\f18f\";\n}\n\n.bi-blockquote-left::before {\n  content: \"\\f190\";\n}\n\n.bi-blockquote-right::before {\n  content: \"\\f191\";\n}\n\n.bi-book-fill::before {\n  content: \"\\f192\";\n}\n\n.bi-book-half::before {\n  content: \"\\f193\";\n}\n\n.bi-book::before {\n  content: \"\\f194\";\n}\n\n.bi-bookmark-check-fill::before {\n  content: \"\\f195\";\n}\n\n.bi-bookmark-check::before {\n  content: \"\\f196\";\n}\n\n.bi-bookmark-dash-fill::before {\n  content: \"\\f197\";\n}\n\n.bi-bookmark-dash::before {\n  content: \"\\f198\";\n}\n\n.bi-bookmark-fill::before {\n  content: \"\\f199\";\n}\n\n.bi-bookmark-heart-fill::before {\n  content: \"\\f19a\";\n}\n\n.bi-bookmark-heart::before {\n  content: \"\\f19b\";\n}\n\n.bi-bookmark-plus-fill::before {\n  content: \"\\f19c\";\n}\n\n.bi-bookmark-plus::before {\n  content: \"\\f19d\";\n}\n\n.bi-bookmark-star-fill::before {\n  content: \"\\f19e\";\n}\n\n.bi-bookmark-star::before {\n  content: \"\\f19f\";\n}\n\n.bi-bookmark-x-fill::before {\n  content: \"\\f1a0\";\n}\n\n.bi-bookmark-x::before {\n  content: \"\\f1a1\";\n}\n\n.bi-bookmark::before {\n  content: \"\\f1a2\";\n}\n\n.bi-bookmarks-fill::before {\n  content: \"\\f1a3\";\n}\n\n.bi-bookmarks::before {\n  content: \"\\f1a4\";\n}\n\n.bi-bookshelf::before {\n  content: \"\\f1a5\";\n}\n\n.bi-bootstrap-fill::before {\n  content: \"\\f1a6\";\n}\n\n.bi-bootstrap-reboot::before {\n  content: \"\\f1a7\";\n}\n\n.bi-bootstrap::before {\n  content: \"\\f1a8\";\n}\n\n.bi-border-all::before {\n  content: \"\\f1a9\";\n}\n\n.bi-border-bottom::before {\n  content: \"\\f1aa\";\n}\n\n.bi-border-center::before {\n  content: \"\\f1ab\";\n}\n\n.bi-border-inner::before {\n  content: \"\\f1ac\";\n}\n\n.bi-border-left::before {\n  content: \"\\f1ad\";\n}\n\n.bi-border-middle::before {\n  content: \"\\f1ae\";\n}\n\n.bi-border-outer::before {\n  content: \"\\f1af\";\n}\n\n.bi-border-right::before {\n  content: \"\\f1b0\";\n}\n\n.bi-border-style::before {\n  content: \"\\f1b1\";\n}\n\n.bi-border-top::before {\n  content: \"\\f1b2\";\n}\n\n.bi-border-width::before {\n  content: \"\\f1b3\";\n}\n\n.bi-border::before {\n  content: \"\\f1b4\";\n}\n\n.bi-bounding-box-circles::before {\n  content: \"\\f1b5\";\n}\n\n.bi-bounding-box::before {\n  content: \"\\f1b6\";\n}\n\n.bi-box-arrow-down-left::before {\n  content: \"\\f1b7\";\n}\n\n.bi-box-arrow-down-right::before {\n  content: \"\\f1b8\";\n}\n\n.bi-box-arrow-down::before {\n  content: \"\\f1b9\";\n}\n\n.bi-box-arrow-in-down-left::before {\n  content: \"\\f1ba\";\n}\n\n.bi-box-arrow-in-down-right::before {\n  content: \"\\f1bb\";\n}\n\n.bi-box-arrow-in-down::before {\n  content: \"\\f1bc\";\n}\n\n.bi-box-arrow-in-left::before {\n  content: \"\\f1bd\";\n}\n\n.bi-box-arrow-in-right::before {\n  content: \"\\f1be\";\n}\n\n.bi-box-arrow-in-up-left::before {\n  content: \"\\f1bf\";\n}\n\n.bi-box-arrow-in-up-right::before {\n  content: \"\\f1c0\";\n}\n\n.bi-box-arrow-in-up::before {\n  content: \"\\f1c1\";\n}\n\n.bi-box-arrow-left::before {\n  content: \"\\f1c2\";\n}\n\n.bi-box-arrow-right::before {\n  content: \"\\f1c3\";\n}\n\n.bi-box-arrow-up-left::before {\n  content: \"\\f1c4\";\n}\n\n.bi-box-arrow-up-right::before {\n  content: \"\\f1c5\";\n}\n\n.bi-box-arrow-up::before {\n  content: \"\\f1c6\";\n}\n\n.bi-box-seam::before {\n  content: \"\\f1c7\";\n}\n\n.bi-box::before {\n  content: \"\\f1c8\";\n}\n\n.bi-braces::before {\n  content: \"\\f1c9\";\n}\n\n.bi-bricks::before {\n  content: \"\\f1ca\";\n}\n\n.bi-briefcase-fill::before {\n  content: \"\\f1cb\";\n}\n\n.bi-briefcase::before {\n  content: \"\\f1cc\";\n}\n\n.bi-brightness-alt-high-fill::before {\n  content: \"\\f1cd\";\n}\n\n.bi-brightness-alt-high::before {\n  content: \"\\f1ce\";\n}\n\n.bi-brightness-alt-low-fill::before {\n  content: \"\\f1cf\";\n}\n\n.bi-brightness-alt-low::before {\n  content: \"\\f1d0\";\n}\n\n.bi-brightness-high-fill::before {\n  content: \"\\f1d1\";\n}\n\n.bi-brightness-high::before {\n  content: \"\\f1d2\";\n}\n\n.bi-brightness-low-fill::before {\n  content: \"\\f1d3\";\n}\n\n.bi-brightness-low::before {\n  content: \"\\f1d4\";\n}\n\n.bi-broadcast-pin::before {\n  content: \"\\f1d5\";\n}\n\n.bi-broadcast::before {\n  content: \"\\f1d6\";\n}\n\n.bi-brush-fill::before {\n  content: \"\\f1d7\";\n}\n\n.bi-brush::before {\n  content: \"\\f1d8\";\n}\n\n.bi-bucket-fill::before {\n  content: \"\\f1d9\";\n}\n\n.bi-bucket::before {\n  content: \"\\f1da\";\n}\n\n.bi-bug-fill::before {\n  content: \"\\f1db\";\n}\n\n.bi-bug::before {\n  content: \"\\f1dc\";\n}\n\n.bi-building::before {\n  content: \"\\f1dd\";\n}\n\n.bi-bullseye::before {\n  content: \"\\f1de\";\n}\n\n.bi-calculator-fill::before {\n  content: \"\\f1df\";\n}\n\n.bi-calculator::before {\n  content: \"\\f1e0\";\n}\n\n.bi-calendar-check-fill::before {\n  content: \"\\f1e1\";\n}\n\n.bi-calendar-check::before {\n  content: \"\\f1e2\";\n}\n\n.bi-calendar-date-fill::before {\n  content: \"\\f1e3\";\n}\n\n.bi-calendar-date::before {\n  content: \"\\f1e4\";\n}\n\n.bi-calendar-day-fill::before {\n  content: \"\\f1e5\";\n}\n\n.bi-calendar-day::before {\n  content: \"\\f1e6\";\n}\n\n.bi-calendar-event-fill::before {\n  content: \"\\f1e7\";\n}\n\n.bi-calendar-event::before {\n  content: \"\\f1e8\";\n}\n\n.bi-calendar-fill::before {\n  content: \"\\f1e9\";\n}\n\n.bi-calendar-minus-fill::before {\n  content: \"\\f1ea\";\n}\n\n.bi-calendar-minus::before {\n  content: \"\\f1eb\";\n}\n\n.bi-calendar-month-fill::before {\n  content: \"\\f1ec\";\n}\n\n.bi-calendar-month::before {\n  content: \"\\f1ed\";\n}\n\n.bi-calendar-plus-fill::before {\n  content: \"\\f1ee\";\n}\n\n.bi-calendar-plus::before {\n  content: \"\\f1ef\";\n}\n\n.bi-calendar-range-fill::before {\n  content: \"\\f1f0\";\n}\n\n.bi-calendar-range::before {\n  content: \"\\f1f1\";\n}\n\n.bi-calendar-week-fill::before {\n  content: \"\\f1f2\";\n}\n\n.bi-calendar-week::before {\n  content: \"\\f1f3\";\n}\n\n.bi-calendar-x-fill::before {\n  content: \"\\f1f4\";\n}\n\n.bi-calendar-x::before {\n  content: \"\\f1f5\";\n}\n\n.bi-calendar::before {\n  content: \"\\f1f6\";\n}\n\n.bi-calendar2-check-fill::before {\n  content: \"\\f1f7\";\n}\n\n.bi-calendar2-check::before {\n  content: \"\\f1f8\";\n}\n\n.bi-calendar2-date-fill::before {\n  content: \"\\f1f9\";\n}\n\n.bi-calendar2-date::before {\n  content: \"\\f1fa\";\n}\n\n.bi-calendar2-day-fill::before {\n  content: \"\\f1fb\";\n}\n\n.bi-calendar2-day::before {\n  content: \"\\f1fc\";\n}\n\n.bi-calendar2-event-fill::before {\n  content: \"\\f1fd\";\n}\n\n.bi-calendar2-event::before {\n  content: \"\\f1fe\";\n}\n\n.bi-calendar2-fill::before {\n  content: \"\\f1ff\";\n}\n\n.bi-calendar2-minus-fill::before {\n  content: \"\\f200\";\n}\n\n.bi-calendar2-minus::before {\n  content: \"\\f201\";\n}\n\n.bi-calendar2-month-fill::before {\n  content: \"\\f202\";\n}\n\n.bi-calendar2-month::before {\n  content: \"\\f203\";\n}\n\n.bi-calendar2-plus-fill::before {\n  content: \"\\f204\";\n}\n\n.bi-calendar2-plus::before {\n  content: \"\\f205\";\n}\n\n.bi-calendar2-range-fill::before {\n  content: \"\\f206\";\n}\n\n.bi-calendar2-range::before {\n  content: \"\\f207\";\n}\n\n.bi-calendar2-week-fill::before {\n  content: \"\\f208\";\n}\n\n.bi-calendar2-week::before {\n  content: \"\\f209\";\n}\n\n.bi-calendar2-x-fill::before {\n  content: \"\\f20a\";\n}\n\n.bi-calendar2-x::before {\n  content: \"\\f20b\";\n}\n\n.bi-calendar2::before {\n  content: \"\\f20c\";\n}\n\n.bi-calendar3-event-fill::before {\n  content: \"\\f20d\";\n}\n\n.bi-calendar3-event::before {\n  content: \"\\f20e\";\n}\n\n.bi-calendar3-fill::before {\n  content: \"\\f20f\";\n}\n\n.bi-calendar3-range-fill::before {\n  content: \"\\f210\";\n}\n\n.bi-calendar3-range::before {\n  content: \"\\f211\";\n}\n\n.bi-calendar3-week-fill::before {\n  content: \"\\f212\";\n}\n\n.bi-calendar3-week::before {\n  content: \"\\f213\";\n}\n\n.bi-calendar3::before {\n  content: \"\\f214\";\n}\n\n.bi-calendar4-event::before {\n  content: \"\\f215\";\n}\n\n.bi-calendar4-range::before {\n  content: \"\\f216\";\n}\n\n.bi-calendar4-week::before {\n  content: \"\\f217\";\n}\n\n.bi-calendar4::before {\n  content: \"\\f218\";\n}\n\n.bi-camera-fill::before {\n  content: \"\\f219\";\n}\n\n.bi-camera-reels-fill::before {\n  content: \"\\f21a\";\n}\n\n.bi-camera-reels::before {\n  content: \"\\f21b\";\n}\n\n.bi-camera-video-fill::before {\n  content: \"\\f21c\";\n}\n\n.bi-camera-video-off-fill::before {\n  content: \"\\f21d\";\n}\n\n.bi-camera-video-off::before {\n  content: \"\\f21e\";\n}\n\n.bi-camera-video::before {\n  content: \"\\f21f\";\n}\n\n.bi-camera::before {\n  content: \"\\f220\";\n}\n\n.bi-camera2::before {\n  content: \"\\f221\";\n}\n\n.bi-capslock-fill::before {\n  content: \"\\f222\";\n}\n\n.bi-capslock::before {\n  content: \"\\f223\";\n}\n\n.bi-card-checklist::before {\n  content: \"\\f224\";\n}\n\n.bi-card-heading::before {\n  content: \"\\f225\";\n}\n\n.bi-card-image::before {\n  content: \"\\f226\";\n}\n\n.bi-card-list::before {\n  content: \"\\f227\";\n}\n\n.bi-card-text::before {\n  content: \"\\f228\";\n}\n\n.bi-caret-down-fill::before {\n  content: \"\\f229\";\n}\n\n.bi-caret-down-square-fill::before {\n  content: \"\\f22a\";\n}\n\n.bi-caret-down-square::before {\n  content: \"\\f22b\";\n}\n\n.bi-caret-down::before {\n  content: \"\\f22c\";\n}\n\n.bi-caret-left-fill::before {\n  content: \"\\f22d\";\n}\n\n.bi-caret-left-square-fill::before {\n  content: \"\\f22e\";\n}\n\n.bi-caret-left-square::before {\n  content: \"\\f22f\";\n}\n\n.bi-caret-left::before {\n  content: \"\\f230\";\n}\n\n.bi-caret-right-fill::before {\n  content: \"\\f231\";\n}\n\n.bi-caret-right-square-fill::before {\n  content: \"\\f232\";\n}\n\n.bi-caret-right-square::before {\n  content: \"\\f233\";\n}\n\n.bi-caret-right::before {\n  content: \"\\f234\";\n}\n\n.bi-caret-up-fill::before {\n  content: \"\\f235\";\n}\n\n.bi-caret-up-square-fill::before {\n  content: \"\\f236\";\n}\n\n.bi-caret-up-square::before {\n  content: \"\\f237\";\n}\n\n.bi-caret-up::before {\n  content: \"\\f238\";\n}\n\n.bi-cart-check-fill::before {\n  content: \"\\f239\";\n}\n\n.bi-cart-check::before {\n  content: \"\\f23a\";\n}\n\n.bi-cart-dash-fill::before {\n  content: \"\\f23b\";\n}\n\n.bi-cart-dash::before {\n  content: \"\\f23c\";\n}\n\n.bi-cart-fill::before {\n  content: \"\\f23d\";\n}\n\n.bi-cart-plus-fill::before {\n  content: \"\\f23e\";\n}\n\n.bi-cart-plus::before {\n  content: \"\\f23f\";\n}\n\n.bi-cart-x-fill::before {\n  content: \"\\f240\";\n}\n\n.bi-cart-x::before {\n  content: \"\\f241\";\n}\n\n.bi-cart::before {\n  content: \"\\f242\";\n}\n\n.bi-cart2::before {\n  content: \"\\f243\";\n}\n\n.bi-cart3::before {\n  content: \"\\f244\";\n}\n\n.bi-cart4::before {\n  content: \"\\f245\";\n}\n\n.bi-cash-stack::before {\n  content: \"\\f246\";\n}\n\n.bi-cash::before {\n  content: \"\\f247\";\n}\n\n.bi-cast::before {\n  content: \"\\f248\";\n}\n\n.bi-chat-dots-fill::before {\n  content: \"\\f249\";\n}\n\n.bi-chat-dots::before {\n  content: \"\\f24a\";\n}\n\n.bi-chat-fill::before {\n  content: \"\\f24b\";\n}\n\n.bi-chat-left-dots-fill::before {\n  content: \"\\f24c\";\n}\n\n.bi-chat-left-dots::before {\n  content: \"\\f24d\";\n}\n\n.bi-chat-left-fill::before {\n  content: \"\\f24e\";\n}\n\n.bi-chat-left-quote-fill::before {\n  content: \"\\f24f\";\n}\n\n.bi-chat-left-quote::before {\n  content: \"\\f250\";\n}\n\n.bi-chat-left-text-fill::before {\n  content: \"\\f251\";\n}\n\n.bi-chat-left-text::before {\n  content: \"\\f252\";\n}\n\n.bi-chat-left::before {\n  content: \"\\f253\";\n}\n\n.bi-chat-quote-fill::before {\n  content: \"\\f254\";\n}\n\n.bi-chat-quote::before {\n  content: \"\\f255\";\n}\n\n.bi-chat-right-dots-fill::before {\n  content: \"\\f256\";\n}\n\n.bi-chat-right-dots::before {\n  content: \"\\f257\";\n}\n\n.bi-chat-right-fill::before {\n  content: \"\\f258\";\n}\n\n.bi-chat-right-quote-fill::before {\n  content: \"\\f259\";\n}\n\n.bi-chat-right-quote::before {\n  content: \"\\f25a\";\n}\n\n.bi-chat-right-text-fill::before {\n  content: \"\\f25b\";\n}\n\n.bi-chat-right-text::before {\n  content: \"\\f25c\";\n}\n\n.bi-chat-right::before {\n  content: \"\\f25d\";\n}\n\n.bi-chat-square-dots-fill::before {\n  content: \"\\f25e\";\n}\n\n.bi-chat-square-dots::before {\n  content: \"\\f25f\";\n}\n\n.bi-chat-square-fill::before {\n  content: \"\\f260\";\n}\n\n.bi-chat-square-quote-fill::before {\n  content: \"\\f261\";\n}\n\n.bi-chat-square-quote::before {\n  content: \"\\f262\";\n}\n\n.bi-chat-square-text-fill::before {\n  content: \"\\f263\";\n}\n\n.bi-chat-square-text::before {\n  content: \"\\f264\";\n}\n\n.bi-chat-square::before {\n  content: \"\\f265\";\n}\n\n.bi-chat-text-fill::before {\n  content: \"\\f266\";\n}\n\n.bi-chat-text::before {\n  content: \"\\f267\";\n}\n\n.bi-chat::before {\n  content: \"\\f268\";\n}\n\n.bi-check-all::before {\n  content: \"\\f269\";\n}\n\n.bi-check-circle-fill::before {\n  content: \"\\f26a\";\n}\n\n.bi-check-circle::before {\n  content: \"\\f26b\";\n}\n\n.bi-check-square-fill::before {\n  content: \"\\f26c\";\n}\n\n.bi-check-square::before {\n  content: \"\\f26d\";\n}\n\n.bi-check::before {\n  content: \"\\f26e\";\n}\n\n.bi-check2-all::before {\n  content: \"\\f26f\";\n}\n\n.bi-check2-circle::before {\n  content: \"\\f270\";\n}\n\n.bi-check2-square::before {\n  content: \"\\f271\";\n}\n\n.bi-check2::before {\n  content: \"\\f272\";\n}\n\n.bi-chevron-bar-contract::before {\n  content: \"\\f273\";\n}\n\n.bi-chevron-bar-down::before {\n  content: \"\\f274\";\n}\n\n.bi-chevron-bar-expand::before {\n  content: \"\\f275\";\n}\n\n.bi-chevron-bar-left::before {\n  content: \"\\f276\";\n}\n\n.bi-chevron-bar-right::before {\n  content: \"\\f277\";\n}\n\n.bi-chevron-bar-up::before {\n  content: \"\\f278\";\n}\n\n.bi-chevron-compact-down::before {\n  content: \"\\f279\";\n}\n\n.bi-chevron-compact-left::before {\n  content: \"\\f27a\";\n}\n\n.bi-chevron-compact-right::before {\n  content: \"\\f27b\";\n}\n\n.bi-chevron-compact-up::before {\n  content: \"\\f27c\";\n}\n\n.bi-chevron-contract::before {\n  content: \"\\f27d\";\n}\n\n.bi-chevron-double-down::before {\n  content: \"\\f27e\";\n}\n\n.bi-chevron-double-left::before {\n  content: \"\\f27f\";\n}\n\n.bi-chevron-double-right::before {\n  content: \"\\f280\";\n}\n\n.bi-chevron-double-up::before {\n  content: \"\\f281\";\n}\n\n.bi-chevron-down::before {\n  content: \"\\f282\";\n}\n\n.bi-chevron-expand::before {\n  content: \"\\f283\";\n}\n\n.bi-chevron-left::before {\n  content: \"\\f284\";\n}\n\n.bi-chevron-right::before {\n  content: \"\\f285\";\n}\n\n.bi-chevron-up::before {\n  content: \"\\f286\";\n}\n\n.bi-circle-fill::before {\n  content: \"\\f287\";\n}\n\n.bi-circle-half::before {\n  content: \"\\f288\";\n}\n\n.bi-circle-square::before {\n  content: \"\\f289\";\n}\n\n.bi-circle::before {\n  content: \"\\f28a\";\n}\n\n.bi-clipboard-check::before {\n  content: \"\\f28b\";\n}\n\n.bi-clipboard-data::before {\n  content: \"\\f28c\";\n}\n\n.bi-clipboard-minus::before {\n  content: \"\\f28d\";\n}\n\n.bi-clipboard-plus::before {\n  content: \"\\f28e\";\n}\n\n.bi-clipboard-x::before {\n  content: \"\\f28f\";\n}\n\n.bi-clipboard::before {\n  content: \"\\f290\";\n}\n\n.bi-clock-fill::before {\n  content: \"\\f291\";\n}\n\n.bi-clock-history::before {\n  content: \"\\f292\";\n}\n\n.bi-clock::before {\n  content: \"\\f293\";\n}\n\n.bi-cloud-arrow-down-fill::before {\n  content: \"\\f294\";\n}\n\n.bi-cloud-arrow-down::before {\n  content: \"\\f295\";\n}\n\n.bi-cloud-arrow-up-fill::before {\n  content: \"\\f296\";\n}\n\n.bi-cloud-arrow-up::before {\n  content: \"\\f297\";\n}\n\n.bi-cloud-check-fill::before {\n  content: \"\\f298\";\n}\n\n.bi-cloud-check::before {\n  content: \"\\f299\";\n}\n\n.bi-cloud-download-fill::before {\n  content: \"\\f29a\";\n}\n\n.bi-cloud-download::before {\n  content: \"\\f29b\";\n}\n\n.bi-cloud-drizzle-fill::before {\n  content: \"\\f29c\";\n}\n\n.bi-cloud-drizzle::before {\n  content: \"\\f29d\";\n}\n\n.bi-cloud-fill::before {\n  content: \"\\f29e\";\n}\n\n.bi-cloud-fog-fill::before {\n  content: \"\\f29f\";\n}\n\n.bi-cloud-fog::before {\n  content: \"\\f2a0\";\n}\n\n.bi-cloud-fog2-fill::before {\n  content: \"\\f2a1\";\n}\n\n.bi-cloud-fog2::before {\n  content: \"\\f2a2\";\n}\n\n.bi-cloud-hail-fill::before {\n  content: \"\\f2a3\";\n}\n\n.bi-cloud-hail::before {\n  content: \"\\f2a4\";\n}\n\n.bi-cloud-haze-fill::before {\n  content: \"\\f2a6\";\n}\n\n.bi-cloud-haze::before {\n  content: \"\\f2a7\";\n}\n\n.bi-cloud-haze2-fill::before {\n  content: \"\\f2a8\";\n}\n\n.bi-cloud-lightning-fill::before {\n  content: \"\\f2a9\";\n}\n\n.bi-cloud-lightning-rain-fill::before {\n  content: \"\\f2aa\";\n}\n\n.bi-cloud-lightning-rain::before {\n  content: \"\\f2ab\";\n}\n\n.bi-cloud-lightning::before {\n  content: \"\\f2ac\";\n}\n\n.bi-cloud-minus-fill::before {\n  content: \"\\f2ad\";\n}\n\n.bi-cloud-minus::before {\n  content: \"\\f2ae\";\n}\n\n.bi-cloud-moon-fill::before {\n  content: \"\\f2af\";\n}\n\n.bi-cloud-moon::before {\n  content: \"\\f2b0\";\n}\n\n.bi-cloud-plus-fill::before {\n  content: \"\\f2b1\";\n}\n\n.bi-cloud-plus::before {\n  content: \"\\f2b2\";\n}\n\n.bi-cloud-rain-fill::before {\n  content: \"\\f2b3\";\n}\n\n.bi-cloud-rain-heavy-fill::before {\n  content: \"\\f2b4\";\n}\n\n.bi-cloud-rain-heavy::before {\n  content: \"\\f2b5\";\n}\n\n.bi-cloud-rain::before {\n  content: \"\\f2b6\";\n}\n\n.bi-cloud-slash-fill::before {\n  content: \"\\f2b7\";\n}\n\n.bi-cloud-slash::before {\n  content: \"\\f2b8\";\n}\n\n.bi-cloud-sleet-fill::before {\n  content: \"\\f2b9\";\n}\n\n.bi-cloud-sleet::before {\n  content: \"\\f2ba\";\n}\n\n.bi-cloud-snow-fill::before {\n  content: \"\\f2bb\";\n}\n\n.bi-cloud-snow::before {\n  content: \"\\f2bc\";\n}\n\n.bi-cloud-sun-fill::before {\n  content: \"\\f2bd\";\n}\n\n.bi-cloud-sun::before {\n  content: \"\\f2be\";\n}\n\n.bi-cloud-upload-fill::before {\n  content: \"\\f2bf\";\n}\n\n.bi-cloud-upload::before {\n  content: \"\\f2c0\";\n}\n\n.bi-cloud::before {\n  content: \"\\f2c1\";\n}\n\n.bi-clouds-fill::before {\n  content: \"\\f2c2\";\n}\n\n.bi-clouds::before {\n  content: \"\\f2c3\";\n}\n\n.bi-cloudy-fill::before {\n  content: \"\\f2c4\";\n}\n\n.bi-cloudy::before {\n  content: \"\\f2c5\";\n}\n\n.bi-code-slash::before {\n  content: \"\\f2c6\";\n}\n\n.bi-code-square::before {\n  content: \"\\f2c7\";\n}\n\n.bi-code::before {\n  content: \"\\f2c8\";\n}\n\n.bi-collection-fill::before {\n  content: \"\\f2c9\";\n}\n\n.bi-collection-play-fill::before {\n  content: \"\\f2ca\";\n}\n\n.bi-collection-play::before {\n  content: \"\\f2cb\";\n}\n\n.bi-collection::before {\n  content: \"\\f2cc\";\n}\n\n.bi-columns-gap::before {\n  content: \"\\f2cd\";\n}\n\n.bi-columns::before {\n  content: \"\\f2ce\";\n}\n\n.bi-command::before {\n  content: \"\\f2cf\";\n}\n\n.bi-compass-fill::before {\n  content: \"\\f2d0\";\n}\n\n.bi-compass::before {\n  content: \"\\f2d1\";\n}\n\n.bi-cone-striped::before {\n  content: \"\\f2d2\";\n}\n\n.bi-cone::before {\n  content: \"\\f2d3\";\n}\n\n.bi-controller::before {\n  content: \"\\f2d4\";\n}\n\n.bi-cpu-fill::before {\n  content: \"\\f2d5\";\n}\n\n.bi-cpu::before {\n  content: \"\\f2d6\";\n}\n\n.bi-credit-card-2-back-fill::before {\n  content: \"\\f2d7\";\n}\n\n.bi-credit-card-2-back::before {\n  content: \"\\f2d8\";\n}\n\n.bi-credit-card-2-front-fill::before {\n  content: \"\\f2d9\";\n}\n\n.bi-credit-card-2-front::before {\n  content: \"\\f2da\";\n}\n\n.bi-credit-card-fill::before {\n  content: \"\\f2db\";\n}\n\n.bi-credit-card::before {\n  content: \"\\f2dc\";\n}\n\n.bi-crop::before {\n  content: \"\\f2dd\";\n}\n\n.bi-cup-fill::before {\n  content: \"\\f2de\";\n}\n\n.bi-cup-straw::before {\n  content: \"\\f2df\";\n}\n\n.bi-cup::before {\n  content: \"\\f2e0\";\n}\n\n.bi-cursor-fill::before {\n  content: \"\\f2e1\";\n}\n\n.bi-cursor-text::before {\n  content: \"\\f2e2\";\n}\n\n.bi-cursor::before {\n  content: \"\\f2e3\";\n}\n\n.bi-dash-circle-dotted::before {\n  content: \"\\f2e4\";\n}\n\n.bi-dash-circle-fill::before {\n  content: \"\\f2e5\";\n}\n\n.bi-dash-circle::before {\n  content: \"\\f2e6\";\n}\n\n.bi-dash-square-dotted::before {\n  content: \"\\f2e7\";\n}\n\n.bi-dash-square-fill::before {\n  content: \"\\f2e8\";\n}\n\n.bi-dash-square::before {\n  content: \"\\f2e9\";\n}\n\n.bi-dash::before {\n  content: \"\\f2ea\";\n}\n\n.bi-diagram-2-fill::before {\n  content: \"\\f2eb\";\n}\n\n.bi-diagram-2::before {\n  content: \"\\f2ec\";\n}\n\n.bi-diagram-3-fill::before {\n  content: \"\\f2ed\";\n}\n\n.bi-diagram-3::before {\n  content: \"\\f2ee\";\n}\n\n.bi-diamond-fill::before {\n  content: \"\\f2ef\";\n}\n\n.bi-diamond-half::before {\n  content: \"\\f2f0\";\n}\n\n.bi-diamond::before {\n  content: \"\\f2f1\";\n}\n\n.bi-dice-1-fill::before {\n  content: \"\\f2f2\";\n}\n\n.bi-dice-1::before {\n  content: \"\\f2f3\";\n}\n\n.bi-dice-2-fill::before {\n  content: \"\\f2f4\";\n}\n\n.bi-dice-2::before {\n  content: \"\\f2f5\";\n}\n\n.bi-dice-3-fill::before {\n  content: \"\\f2f6\";\n}\n\n.bi-dice-3::before {\n  content: \"\\f2f7\";\n}\n\n.bi-dice-4-fill::before {\n  content: \"\\f2f8\";\n}\n\n.bi-dice-4::before {\n  content: \"\\f2f9\";\n}\n\n.bi-dice-5-fill::before {\n  content: \"\\f2fa\";\n}\n\n.bi-dice-5::before {\n  content: \"\\f2fb\";\n}\n\n.bi-dice-6-fill::before {\n  content: \"\\f2fc\";\n}\n\n.bi-dice-6::before {\n  content: \"\\f2fd\";\n}\n\n.bi-disc-fill::before {\n  content: \"\\f2fe\";\n}\n\n.bi-disc::before {\n  content: \"\\f2ff\";\n}\n\n.bi-discord::before {\n  content: \"\\f300\";\n}\n\n.bi-display-fill::before {\n  content: \"\\f301\";\n}\n\n.bi-display::before {\n  content: \"\\f302\";\n}\n\n.bi-distribute-horizontal::before {\n  content: \"\\f303\";\n}\n\n.bi-distribute-vertical::before {\n  content: \"\\f304\";\n}\n\n.bi-door-closed-fill::before {\n  content: \"\\f305\";\n}\n\n.bi-door-closed::before {\n  content: \"\\f306\";\n}\n\n.bi-door-open-fill::before {\n  content: \"\\f307\";\n}\n\n.bi-door-open::before {\n  content: \"\\f308\";\n}\n\n.bi-dot::before {\n  content: \"\\f309\";\n}\n\n.bi-download::before {\n  content: \"\\f30a\";\n}\n\n.bi-droplet-fill::before {\n  content: \"\\f30b\";\n}\n\n.bi-droplet-half::before {\n  content: \"\\f30c\";\n}\n\n.bi-droplet::before {\n  content: \"\\f30d\";\n}\n\n.bi-earbuds::before {\n  content: \"\\f30e\";\n}\n\n.bi-easel-fill::before {\n  content: \"\\f30f\";\n}\n\n.bi-easel::before {\n  content: \"\\f310\";\n}\n\n.bi-egg-fill::before {\n  content: \"\\f311\";\n}\n\n.bi-egg-fried::before {\n  content: \"\\f312\";\n}\n\n.bi-egg::before {\n  content: \"\\f313\";\n}\n\n.bi-eject-fill::before {\n  content: \"\\f314\";\n}\n\n.bi-eject::before {\n  content: \"\\f315\";\n}\n\n.bi-emoji-angry-fill::before {\n  content: \"\\f316\";\n}\n\n.bi-emoji-angry::before {\n  content: \"\\f317\";\n}\n\n.bi-emoji-dizzy-fill::before {\n  content: \"\\f318\";\n}\n\n.bi-emoji-dizzy::before {\n  content: \"\\f319\";\n}\n\n.bi-emoji-expressionless-fill::before {\n  content: \"\\f31a\";\n}\n\n.bi-emoji-expressionless::before {\n  content: \"\\f31b\";\n}\n\n.bi-emoji-frown-fill::before {\n  content: \"\\f31c\";\n}\n\n.bi-emoji-frown::before {\n  content: \"\\f31d\";\n}\n\n.bi-emoji-heart-eyes-fill::before {\n  content: \"\\f31e\";\n}\n\n.bi-emoji-heart-eyes::before {\n  content: \"\\f31f\";\n}\n\n.bi-emoji-laughing-fill::before {\n  content: \"\\f320\";\n}\n\n.bi-emoji-laughing::before {\n  content: \"\\f321\";\n}\n\n.bi-emoji-neutral-fill::before {\n  content: \"\\f322\";\n}\n\n.bi-emoji-neutral::before {\n  content: \"\\f323\";\n}\n\n.bi-emoji-smile-fill::before {\n  content: \"\\f324\";\n}\n\n.bi-emoji-smile-upside-down-fill::before {\n  content: \"\\f325\";\n}\n\n.bi-emoji-smile-upside-down::before {\n  content: \"\\f326\";\n}\n\n.bi-emoji-smile::before {\n  content: \"\\f327\";\n}\n\n.bi-emoji-sunglasses-fill::before {\n  content: \"\\f328\";\n}\n\n.bi-emoji-sunglasses::before {\n  content: \"\\f329\";\n}\n\n.bi-emoji-wink-fill::before {\n  content: \"\\f32a\";\n}\n\n.bi-emoji-wink::before {\n  content: \"\\f32b\";\n}\n\n.bi-envelope-fill::before {\n  content: \"\\f32c\";\n}\n\n.bi-envelope-open-fill::before {\n  content: \"\\f32d\";\n}\n\n.bi-envelope-open::before {\n  content: \"\\f32e\";\n}\n\n.bi-envelope::before {\n  content: \"\\f32f\";\n}\n\n.bi-eraser-fill::before {\n  content: \"\\f330\";\n}\n\n.bi-eraser::before {\n  content: \"\\f331\";\n}\n\n.bi-exclamation-circle-fill::before {\n  content: \"\\f332\";\n}\n\n.bi-exclamation-circle::before {\n  content: \"\\f333\";\n}\n\n.bi-exclamation-diamond-fill::before {\n  content: \"\\f334\";\n}\n\n.bi-exclamation-diamond::before {\n  content: \"\\f335\";\n}\n\n.bi-exclamation-octagon-fill::before {\n  content: \"\\f336\";\n}\n\n.bi-exclamation-octagon::before {\n  content: \"\\f337\";\n}\n\n.bi-exclamation-square-fill::before {\n  content: \"\\f338\";\n}\n\n.bi-exclamation-square::before {\n  content: \"\\f339\";\n}\n\n.bi-exclamation-triangle-fill::before {\n  content: \"\\f33a\";\n}\n\n.bi-exclamation-triangle::before {\n  content: \"\\f33b\";\n}\n\n.bi-exclamation::before {\n  content: \"\\f33c\";\n}\n\n.bi-exclude::before {\n  content: \"\\f33d\";\n}\n\n.bi-eye-fill::before {\n  content: \"\\f33e\";\n}\n\n.bi-eye-slash-fill::before {\n  content: \"\\f33f\";\n}\n\n.bi-eye-slash::before {\n  content: \"\\f340\";\n}\n\n.bi-eye::before {\n  content: \"\\f341\";\n}\n\n.bi-eyedropper::before {\n  content: \"\\f342\";\n}\n\n.bi-eyeglasses::before {\n  content: \"\\f343\";\n}\n\n.bi-facebook::before {\n  content: \"\\f344\";\n}\n\n.bi-file-arrow-down-fill::before {\n  content: \"\\f345\";\n}\n\n.bi-file-arrow-down::before {\n  content: \"\\f346\";\n}\n\n.bi-file-arrow-up-fill::before {\n  content: \"\\f347\";\n}\n\n.bi-file-arrow-up::before {\n  content: \"\\f348\";\n}\n\n.bi-file-bar-graph-fill::before {\n  content: \"\\f349\";\n}\n\n.bi-file-bar-graph::before {\n  content: \"\\f34a\";\n}\n\n.bi-file-binary-fill::before {\n  content: \"\\f34b\";\n}\n\n.bi-file-binary::before {\n  content: \"\\f34c\";\n}\n\n.bi-file-break-fill::before {\n  content: \"\\f34d\";\n}\n\n.bi-file-break::before {\n  content: \"\\f34e\";\n}\n\n.bi-file-check-fill::before {\n  content: \"\\f34f\";\n}\n\n.bi-file-check::before {\n  content: \"\\f350\";\n}\n\n.bi-file-code-fill::before {\n  content: \"\\f351\";\n}\n\n.bi-file-code::before {\n  content: \"\\f352\";\n}\n\n.bi-file-diff-fill::before {\n  content: \"\\f353\";\n}\n\n.bi-file-diff::before {\n  content: \"\\f354\";\n}\n\n.bi-file-earmark-arrow-down-fill::before {\n  content: \"\\f355\";\n}\n\n.bi-file-earmark-arrow-down::before {\n  content: \"\\f356\";\n}\n\n.bi-file-earmark-arrow-up-fill::before {\n  content: \"\\f357\";\n}\n\n.bi-file-earmark-arrow-up::before {\n  content: \"\\f358\";\n}\n\n.bi-file-earmark-bar-graph-fill::before {\n  content: \"\\f359\";\n}\n\n.bi-file-earmark-bar-graph::before {\n  content: \"\\f35a\";\n}\n\n.bi-file-earmark-binary-fill::before {\n  content: \"\\f35b\";\n}\n\n.bi-file-earmark-binary::before {\n  content: \"\\f35c\";\n}\n\n.bi-file-earmark-break-fill::before {\n  content: \"\\f35d\";\n}\n\n.bi-file-earmark-break::before {\n  content: \"\\f35e\";\n}\n\n.bi-file-earmark-check-fill::before {\n  content: \"\\f35f\";\n}\n\n.bi-file-earmark-check::before {\n  content: \"\\f360\";\n}\n\n.bi-file-earmark-code-fill::before {\n  content: \"\\f361\";\n}\n\n.bi-file-earmark-code::before {\n  content: \"\\f362\";\n}\n\n.bi-file-earmark-diff-fill::before {\n  content: \"\\f363\";\n}\n\n.bi-file-earmark-diff::before {\n  content: \"\\f364\";\n}\n\n.bi-file-earmark-easel-fill::before {\n  content: \"\\f365\";\n}\n\n.bi-file-earmark-easel::before {\n  content: \"\\f366\";\n}\n\n.bi-file-earmark-excel-fill::before {\n  content: \"\\f367\";\n}\n\n.bi-file-earmark-excel::before {\n  content: \"\\f368\";\n}\n\n.bi-file-earmark-fill::before {\n  content: \"\\f369\";\n}\n\n.bi-file-earmark-font-fill::before {\n  content: \"\\f36a\";\n}\n\n.bi-file-earmark-font::before {\n  content: \"\\f36b\";\n}\n\n.bi-file-earmark-image-fill::before {\n  content: \"\\f36c\";\n}\n\n.bi-file-earmark-image::before {\n  content: \"\\f36d\";\n}\n\n.bi-file-earmark-lock-fill::before {\n  content: \"\\f36e\";\n}\n\n.bi-file-earmark-lock::before {\n  content: \"\\f36f\";\n}\n\n.bi-file-earmark-lock2-fill::before {\n  content: \"\\f370\";\n}\n\n.bi-file-earmark-lock2::before {\n  content: \"\\f371\";\n}\n\n.bi-file-earmark-medical-fill::before {\n  content: \"\\f372\";\n}\n\n.bi-file-earmark-medical::before {\n  content: \"\\f373\";\n}\n\n.bi-file-earmark-minus-fill::before {\n  content: \"\\f374\";\n}\n\n.bi-file-earmark-minus::before {\n  content: \"\\f375\";\n}\n\n.bi-file-earmark-music-fill::before {\n  content: \"\\f376\";\n}\n\n.bi-file-earmark-music::before {\n  content: \"\\f377\";\n}\n\n.bi-file-earmark-person-fill::before {\n  content: \"\\f378\";\n}\n\n.bi-file-earmark-person::before {\n  content: \"\\f379\";\n}\n\n.bi-file-earmark-play-fill::before {\n  content: \"\\f37a\";\n}\n\n.bi-file-earmark-play::before {\n  content: \"\\f37b\";\n}\n\n.bi-file-earmark-plus-fill::before {\n  content: \"\\f37c\";\n}\n\n.bi-file-earmark-plus::before {\n  content: \"\\f37d\";\n}\n\n.bi-file-earmark-post-fill::before {\n  content: \"\\f37e\";\n}\n\n.bi-file-earmark-post::before {\n  content: \"\\f37f\";\n}\n\n.bi-file-earmark-ppt-fill::before {\n  content: \"\\f380\";\n}\n\n.bi-file-earmark-ppt::before {\n  content: \"\\f381\";\n}\n\n.bi-file-earmark-richtext-fill::before {\n  content: \"\\f382\";\n}\n\n.bi-file-earmark-richtext::before {\n  content: \"\\f383\";\n}\n\n.bi-file-earmark-ruled-fill::before {\n  content: \"\\f384\";\n}\n\n.bi-file-earmark-ruled::before {\n  content: \"\\f385\";\n}\n\n.bi-file-earmark-slides-fill::before {\n  content: \"\\f386\";\n}\n\n.bi-file-earmark-slides::before {\n  content: \"\\f387\";\n}\n\n.bi-file-earmark-spreadsheet-fill::before {\n  content: \"\\f388\";\n}\n\n.bi-file-earmark-spreadsheet::before {\n  content: \"\\f389\";\n}\n\n.bi-file-earmark-text-fill::before {\n  content: \"\\f38a\";\n}\n\n.bi-file-earmark-text::before {\n  content: \"\\f38b\";\n}\n\n.bi-file-earmark-word-fill::before {\n  content: \"\\f38c\";\n}\n\n.bi-file-earmark-word::before {\n  content: \"\\f38d\";\n}\n\n.bi-file-earmark-x-fill::before {\n  content: \"\\f38e\";\n}\n\n.bi-file-earmark-x::before {\n  content: \"\\f38f\";\n}\n\n.bi-file-earmark-zip-fill::before {\n  content: \"\\f390\";\n}\n\n.bi-file-earmark-zip::before {\n  content: \"\\f391\";\n}\n\n.bi-file-earmark::before {\n  content: \"\\f392\";\n}\n\n.bi-file-easel-fill::before {\n  content: \"\\f393\";\n}\n\n.bi-file-easel::before {\n  content: \"\\f394\";\n}\n\n.bi-file-excel-fill::before {\n  content: \"\\f395\";\n}\n\n.bi-file-excel::before {\n  content: \"\\f396\";\n}\n\n.bi-file-fill::before {\n  content: \"\\f397\";\n}\n\n.bi-file-font-fill::before {\n  content: \"\\f398\";\n}\n\n.bi-file-font::before {\n  content: \"\\f399\";\n}\n\n.bi-file-image-fill::before {\n  content: \"\\f39a\";\n}\n\n.bi-file-image::before {\n  content: \"\\f39b\";\n}\n\n.bi-file-lock-fill::before {\n  content: \"\\f39c\";\n}\n\n.bi-file-lock::before {\n  content: \"\\f39d\";\n}\n\n.bi-file-lock2-fill::before {\n  content: \"\\f39e\";\n}\n\n.bi-file-lock2::before {\n  content: \"\\f39f\";\n}\n\n.bi-file-medical-fill::before {\n  content: \"\\f3a0\";\n}\n\n.bi-file-medical::before {\n  content: \"\\f3a1\";\n}\n\n.bi-file-minus-fill::before {\n  content: \"\\f3a2\";\n}\n\n.bi-file-minus::before {\n  content: \"\\f3a3\";\n}\n\n.bi-file-music-fill::before {\n  content: \"\\f3a4\";\n}\n\n.bi-file-music::before {\n  content: \"\\f3a5\";\n}\n\n.bi-file-person-fill::before {\n  content: \"\\f3a6\";\n}\n\n.bi-file-person::before {\n  content: \"\\f3a7\";\n}\n\n.bi-file-play-fill::before {\n  content: \"\\f3a8\";\n}\n\n.bi-file-play::before {\n  content: \"\\f3a9\";\n}\n\n.bi-file-plus-fill::before {\n  content: \"\\f3aa\";\n}\n\n.bi-file-plus::before {\n  content: \"\\f3ab\";\n}\n\n.bi-file-post-fill::before {\n  content: \"\\f3ac\";\n}\n\n.bi-file-post::before {\n  content: \"\\f3ad\";\n}\n\n.bi-file-ppt-fill::before {\n  content: \"\\f3ae\";\n}\n\n.bi-file-ppt::before {\n  content: \"\\f3af\";\n}\n\n.bi-file-richtext-fill::before {\n  content: \"\\f3b0\";\n}\n\n.bi-file-richtext::before {\n  content: \"\\f3b1\";\n}\n\n.bi-file-ruled-fill::before {\n  content: \"\\f3b2\";\n}\n\n.bi-file-ruled::before {\n  content: \"\\f3b3\";\n}\n\n.bi-file-slides-fill::before {\n  content: \"\\f3b4\";\n}\n\n.bi-file-slides::before {\n  content: \"\\f3b5\";\n}\n\n.bi-file-spreadsheet-fill::before {\n  content: \"\\f3b6\";\n}\n\n.bi-file-spreadsheet::before {\n  content: \"\\f3b7\";\n}\n\n.bi-file-text-fill::before {\n  content: \"\\f3b8\";\n}\n\n.bi-file-text::before {\n  content: \"\\f3b9\";\n}\n\n.bi-file-word-fill::before {\n  content: \"\\f3ba\";\n}\n\n.bi-file-word::before {\n  content: \"\\f3bb\";\n}\n\n.bi-file-x-fill::before {\n  content: \"\\f3bc\";\n}\n\n.bi-file-x::before {\n  content: \"\\f3bd\";\n}\n\n.bi-file-zip-fill::before {\n  content: \"\\f3be\";\n}\n\n.bi-file-zip::before {\n  content: \"\\f3bf\";\n}\n\n.bi-file::before {\n  content: \"\\f3c0\";\n}\n\n.bi-files-alt::before {\n  content: \"\\f3c1\";\n}\n\n.bi-files::before {\n  content: \"\\f3c2\";\n}\n\n.bi-film::before {\n  content: \"\\f3c3\";\n}\n\n.bi-filter-circle-fill::before {\n  content: \"\\f3c4\";\n}\n\n.bi-filter-circle::before {\n  content: \"\\f3c5\";\n}\n\n.bi-filter-left::before {\n  content: \"\\f3c6\";\n}\n\n.bi-filter-right::before {\n  content: \"\\f3c7\";\n}\n\n.bi-filter-square-fill::before {\n  content: \"\\f3c8\";\n}\n\n.bi-filter-square::before {\n  content: \"\\f3c9\";\n}\n\n.bi-filter::before {\n  content: \"\\f3ca\";\n}\n\n.bi-flag-fill::before {\n  content: \"\\f3cb\";\n}\n\n.bi-flag::before {\n  content: \"\\f3cc\";\n}\n\n.bi-flower1::before {\n  content: \"\\f3cd\";\n}\n\n.bi-flower2::before {\n  content: \"\\f3ce\";\n}\n\n.bi-flower3::before {\n  content: \"\\f3cf\";\n}\n\n.bi-folder-check::before {\n  content: \"\\f3d0\";\n}\n\n.bi-folder-fill::before {\n  content: \"\\f3d1\";\n}\n\n.bi-folder-minus::before {\n  content: \"\\f3d2\";\n}\n\n.bi-folder-plus::before {\n  content: \"\\f3d3\";\n}\n\n.bi-folder-symlink-fill::before {\n  content: \"\\f3d4\";\n}\n\n.bi-folder-symlink::before {\n  content: \"\\f3d5\";\n}\n\n.bi-folder-x::before {\n  content: \"\\f3d6\";\n}\n\n.bi-folder::before {\n  content: \"\\f3d7\";\n}\n\n.bi-folder2-open::before {\n  content: \"\\f3d8\";\n}\n\n.bi-folder2::before {\n  content: \"\\f3d9\";\n}\n\n.bi-fonts::before {\n  content: \"\\f3da\";\n}\n\n.bi-forward-fill::before {\n  content: \"\\f3db\";\n}\n\n.bi-forward::before {\n  content: \"\\f3dc\";\n}\n\n.bi-front::before {\n  content: \"\\f3dd\";\n}\n\n.bi-fullscreen-exit::before {\n  content: \"\\f3de\";\n}\n\n.bi-fullscreen::before {\n  content: \"\\f3df\";\n}\n\n.bi-funnel-fill::before {\n  content: \"\\f3e0\";\n}\n\n.bi-funnel::before {\n  content: \"\\f3e1\";\n}\n\n.bi-gear-fill::before {\n  content: \"\\f3e2\";\n}\n\n.bi-gear-wide-connected::before {\n  content: \"\\f3e3\";\n}\n\n.bi-gear-wide::before {\n  content: \"\\f3e4\";\n}\n\n.bi-gear::before {\n  content: \"\\f3e5\";\n}\n\n.bi-gem::before {\n  content: \"\\f3e6\";\n}\n\n.bi-geo-alt-fill::before {\n  content: \"\\f3e7\";\n}\n\n.bi-geo-alt::before {\n  content: \"\\f3e8\";\n}\n\n.bi-geo-fill::before {\n  content: \"\\f3e9\";\n}\n\n.bi-geo::before {\n  content: \"\\f3ea\";\n}\n\n.bi-gift-fill::before {\n  content: \"\\f3eb\";\n}\n\n.bi-gift::before {\n  content: \"\\f3ec\";\n}\n\n.bi-github::before {\n  content: \"\\f3ed\";\n}\n\n.bi-globe::before {\n  content: \"\\f3ee\";\n}\n\n.bi-globe2::before {\n  content: \"\\f3ef\";\n}\n\n.bi-google::before {\n  content: \"\\f3f0\";\n}\n\n.bi-graph-down::before {\n  content: \"\\f3f1\";\n}\n\n.bi-graph-up::before {\n  content: \"\\f3f2\";\n}\n\n.bi-grid-1x2-fill::before {\n  content: \"\\f3f3\";\n}\n\n.bi-grid-1x2::before {\n  content: \"\\f3f4\";\n}\n\n.bi-grid-3x2-gap-fill::before {\n  content: \"\\f3f5\";\n}\n\n.bi-grid-3x2-gap::before {\n  content: \"\\f3f6\";\n}\n\n.bi-grid-3x2::before {\n  content: \"\\f3f7\";\n}\n\n.bi-grid-3x3-gap-fill::before {\n  content: \"\\f3f8\";\n}\n\n.bi-grid-3x3-gap::before {\n  content: \"\\f3f9\";\n}\n\n.bi-grid-3x3::before {\n  content: \"\\f3fa\";\n}\n\n.bi-grid-fill::before {\n  content: \"\\f3fb\";\n}\n\n.bi-grid::before {\n  content: \"\\f3fc\";\n}\n\n.bi-grip-horizontal::before {\n  content: \"\\f3fd\";\n}\n\n.bi-grip-vertical::before {\n  content: \"\\f3fe\";\n}\n\n.bi-hammer::before {\n  content: \"\\f3ff\";\n}\n\n.bi-hand-index-fill::before {\n  content: \"\\f400\";\n}\n\n.bi-hand-index-thumb-fill::before {\n  content: \"\\f401\";\n}\n\n.bi-hand-index-thumb::before {\n  content: \"\\f402\";\n}\n\n.bi-hand-index::before {\n  content: \"\\f403\";\n}\n\n.bi-hand-thumbs-down-fill::before {\n  content: \"\\f404\";\n}\n\n.bi-hand-thumbs-down::before {\n  content: \"\\f405\";\n}\n\n.bi-hand-thumbs-up-fill::before {\n  content: \"\\f406\";\n}\n\n.bi-hand-thumbs-up::before {\n  content: \"\\f407\";\n}\n\n.bi-handbag-fill::before {\n  content: \"\\f408\";\n}\n\n.bi-handbag::before {\n  content: \"\\f409\";\n}\n\n.bi-hash::before {\n  content: \"\\f40a\";\n}\n\n.bi-hdd-fill::before {\n  content: \"\\f40b\";\n}\n\n.bi-hdd-network-fill::before {\n  content: \"\\f40c\";\n}\n\n.bi-hdd-network::before {\n  content: \"\\f40d\";\n}\n\n.bi-hdd-rack-fill::before {\n  content: \"\\f40e\";\n}\n\n.bi-hdd-rack::before {\n  content: \"\\f40f\";\n}\n\n.bi-hdd-stack-fill::before {\n  content: \"\\f410\";\n}\n\n.bi-hdd-stack::before {\n  content: \"\\f411\";\n}\n\n.bi-hdd::before {\n  content: \"\\f412\";\n}\n\n.bi-headphones::before {\n  content: \"\\f413\";\n}\n\n.bi-headset::before {\n  content: \"\\f414\";\n}\n\n.bi-heart-fill::before {\n  content: \"\\f415\";\n}\n\n.bi-heart-half::before {\n  content: \"\\f416\";\n}\n\n.bi-heart::before {\n  content: \"\\f417\";\n}\n\n.bi-heptagon-fill::before {\n  content: \"\\f418\";\n}\n\n.bi-heptagon-half::before {\n  content: \"\\f419\";\n}\n\n.bi-heptagon::before {\n  content: \"\\f41a\";\n}\n\n.bi-hexagon-fill::before {\n  content: \"\\f41b\";\n}\n\n.bi-hexagon-half::before {\n  content: \"\\f41c\";\n}\n\n.bi-hexagon::before {\n  content: \"\\f41d\";\n}\n\n.bi-hourglass-bottom::before {\n  content: \"\\f41e\";\n}\n\n.bi-hourglass-split::before {\n  content: \"\\f41f\";\n}\n\n.bi-hourglass-top::before {\n  content: \"\\f420\";\n}\n\n.bi-hourglass::before {\n  content: \"\\f421\";\n}\n\n.bi-house-door-fill::before {\n  content: \"\\f422\";\n}\n\n.bi-house-door::before {\n  content: \"\\f423\";\n}\n\n.bi-house-fill::before {\n  content: \"\\f424\";\n}\n\n.bi-house::before {\n  content: \"\\f425\";\n}\n\n.bi-hr::before {\n  content: \"\\f426\";\n}\n\n.bi-hurricane::before {\n  content: \"\\f427\";\n}\n\n.bi-image-alt::before {\n  content: \"\\f428\";\n}\n\n.bi-image-fill::before {\n  content: \"\\f429\";\n}\n\n.bi-image::before {\n  content: \"\\f42a\";\n}\n\n.bi-images::before {\n  content: \"\\f42b\";\n}\n\n.bi-inbox-fill::before {\n  content: \"\\f42c\";\n}\n\n.bi-inbox::before {\n  content: \"\\f42d\";\n}\n\n.bi-inboxes-fill::before {\n  content: \"\\f42e\";\n}\n\n.bi-inboxes::before {\n  content: \"\\f42f\";\n}\n\n.bi-info-circle-fill::before {\n  content: \"\\f430\";\n}\n\n.bi-info-circle::before {\n  content: \"\\f431\";\n}\n\n.bi-info-square-fill::before {\n  content: \"\\f432\";\n}\n\n.bi-info-square::before {\n  content: \"\\f433\";\n}\n\n.bi-info::before {\n  content: \"\\f434\";\n}\n\n.bi-input-cursor-text::before {\n  content: \"\\f435\";\n}\n\n.bi-input-cursor::before {\n  content: \"\\f436\";\n}\n\n.bi-instagram::before {\n  content: \"\\f437\";\n}\n\n.bi-intersect::before {\n  content: \"\\f438\";\n}\n\n.bi-journal-album::before {\n  content: \"\\f439\";\n}\n\n.bi-journal-arrow-down::before {\n  content: \"\\f43a\";\n}\n\n.bi-journal-arrow-up::before {\n  content: \"\\f43b\";\n}\n\n.bi-journal-bookmark-fill::before {\n  content: \"\\f43c\";\n}\n\n.bi-journal-bookmark::before {\n  content: \"\\f43d\";\n}\n\n.bi-journal-check::before {\n  content: \"\\f43e\";\n}\n\n.bi-journal-code::before {\n  content: \"\\f43f\";\n}\n\n.bi-journal-medical::before {\n  content: \"\\f440\";\n}\n\n.bi-journal-minus::before {\n  content: \"\\f441\";\n}\n\n.bi-journal-plus::before {\n  content: \"\\f442\";\n}\n\n.bi-journal-richtext::before {\n  content: \"\\f443\";\n}\n\n.bi-journal-text::before {\n  content: \"\\f444\";\n}\n\n.bi-journal-x::before {\n  content: \"\\f445\";\n}\n\n.bi-journal::before {\n  content: \"\\f446\";\n}\n\n.bi-journals::before {\n  content: \"\\f447\";\n}\n\n.bi-joystick::before {\n  content: \"\\f448\";\n}\n\n.bi-justify-left::before {\n  content: \"\\f449\";\n}\n\n.bi-justify-right::before {\n  content: \"\\f44a\";\n}\n\n.bi-justify::before {\n  content: \"\\f44b\";\n}\n\n.bi-kanban-fill::before {\n  content: \"\\f44c\";\n}\n\n.bi-kanban::before {\n  content: \"\\f44d\";\n}\n\n.bi-key-fill::before {\n  content: \"\\f44e\";\n}\n\n.bi-key::before {\n  content: \"\\f44f\";\n}\n\n.bi-keyboard-fill::before {\n  content: \"\\f450\";\n}\n\n.bi-keyboard::before {\n  content: \"\\f451\";\n}\n\n.bi-ladder::before {\n  content: \"\\f452\";\n}\n\n.bi-lamp-fill::before {\n  content: \"\\f453\";\n}\n\n.bi-lamp::before {\n  content: \"\\f454\";\n}\n\n.bi-laptop-fill::before {\n  content: \"\\f455\";\n}\n\n.bi-laptop::before {\n  content: \"\\f456\";\n}\n\n.bi-layer-backward::before {\n  content: \"\\f457\";\n}\n\n.bi-layer-forward::before {\n  content: \"\\f458\";\n}\n\n.bi-layers-fill::before {\n  content: \"\\f459\";\n}\n\n.bi-layers-half::before {\n  content: \"\\f45a\";\n}\n\n.bi-layers::before {\n  content: \"\\f45b\";\n}\n\n.bi-layout-sidebar-inset-reverse::before {\n  content: \"\\f45c\";\n}\n\n.bi-layout-sidebar-inset::before {\n  content: \"\\f45d\";\n}\n\n.bi-layout-sidebar-reverse::before {\n  content: \"\\f45e\";\n}\n\n.bi-layout-sidebar::before {\n  content: \"\\f45f\";\n}\n\n.bi-layout-split::before {\n  content: \"\\f460\";\n}\n\n.bi-layout-text-sidebar-reverse::before {\n  content: \"\\f461\";\n}\n\n.bi-layout-text-sidebar::before {\n  content: \"\\f462\";\n}\n\n.bi-layout-text-window-reverse::before {\n  content: \"\\f463\";\n}\n\n.bi-layout-text-window::before {\n  content: \"\\f464\";\n}\n\n.bi-layout-three-columns::before {\n  content: \"\\f465\";\n}\n\n.bi-layout-wtf::before {\n  content: \"\\f466\";\n}\n\n.bi-life-preserver::before {\n  content: \"\\f467\";\n}\n\n.bi-lightbulb-fill::before {\n  content: \"\\f468\";\n}\n\n.bi-lightbulb-off-fill::before {\n  content: \"\\f469\";\n}\n\n.bi-lightbulb-off::before {\n  content: \"\\f46a\";\n}\n\n.bi-lightbulb::before {\n  content: \"\\f46b\";\n}\n\n.bi-lightning-charge-fill::before {\n  content: \"\\f46c\";\n}\n\n.bi-lightning-charge::before {\n  content: \"\\f46d\";\n}\n\n.bi-lightning-fill::before {\n  content: \"\\f46e\";\n}\n\n.bi-lightning::before {\n  content: \"\\f46f\";\n}\n\n.bi-link-45deg::before {\n  content: \"\\f470\";\n}\n\n.bi-link::before {\n  content: \"\\f471\";\n}\n\n.bi-linkedin::before {\n  content: \"\\f472\";\n}\n\n.bi-list-check::before {\n  content: \"\\f473\";\n}\n\n.bi-list-nested::before {\n  content: \"\\f474\";\n}\n\n.bi-list-ol::before {\n  content: \"\\f475\";\n}\n\n.bi-list-stars::before {\n  content: \"\\f476\";\n}\n\n.bi-list-task::before {\n  content: \"\\f477\";\n}\n\n.bi-list-ul::before {\n  content: \"\\f478\";\n}\n\n.bi-list::before {\n  content: \"\\f479\";\n}\n\n.bi-lock-fill::before {\n  content: \"\\f47a\";\n}\n\n.bi-lock::before {\n  content: \"\\f47b\";\n}\n\n.bi-mailbox::before {\n  content: \"\\f47c\";\n}\n\n.bi-mailbox2::before {\n  content: \"\\f47d\";\n}\n\n.bi-map-fill::before {\n  content: \"\\f47e\";\n}\n\n.bi-map::before {\n  content: \"\\f47f\";\n}\n\n.bi-markdown-fill::before {\n  content: \"\\f480\";\n}\n\n.bi-markdown::before {\n  content: \"\\f481\";\n}\n\n.bi-mask::before {\n  content: \"\\f482\";\n}\n\n.bi-megaphone-fill::before {\n  content: \"\\f483\";\n}\n\n.bi-megaphone::before {\n  content: \"\\f484\";\n}\n\n.bi-menu-app-fill::before {\n  content: \"\\f485\";\n}\n\n.bi-menu-app::before {\n  content: \"\\f486\";\n}\n\n.bi-menu-button-fill::before {\n  content: \"\\f487\";\n}\n\n.bi-menu-button-wide-fill::before {\n  content: \"\\f488\";\n}\n\n.bi-menu-button-wide::before {\n  content: \"\\f489\";\n}\n\n.bi-menu-button::before {\n  content: \"\\f48a\";\n}\n\n.bi-menu-down::before {\n  content: \"\\f48b\";\n}\n\n.bi-menu-up::before {\n  content: \"\\f48c\";\n}\n\n.bi-mic-fill::before {\n  content: \"\\f48d\";\n}\n\n.bi-mic-mute-fill::before {\n  content: \"\\f48e\";\n}\n\n.bi-mic-mute::before {\n  content: \"\\f48f\";\n}\n\n.bi-mic::before {\n  content: \"\\f490\";\n}\n\n.bi-minecart-loaded::before {\n  content: \"\\f491\";\n}\n\n.bi-minecart::before {\n  content: \"\\f492\";\n}\n\n.bi-moisture::before {\n  content: \"\\f493\";\n}\n\n.bi-moon-fill::before {\n  content: \"\\f494\";\n}\n\n.bi-moon-stars-fill::before {\n  content: \"\\f495\";\n}\n\n.bi-moon-stars::before {\n  content: \"\\f496\";\n}\n\n.bi-moon::before {\n  content: \"\\f497\";\n}\n\n.bi-mouse-fill::before {\n  content: \"\\f498\";\n}\n\n.bi-mouse::before {\n  content: \"\\f499\";\n}\n\n.bi-mouse2-fill::before {\n  content: \"\\f49a\";\n}\n\n.bi-mouse2::before {\n  content: \"\\f49b\";\n}\n\n.bi-mouse3-fill::before {\n  content: \"\\f49c\";\n}\n\n.bi-mouse3::before {\n  content: \"\\f49d\";\n}\n\n.bi-music-note-beamed::before {\n  content: \"\\f49e\";\n}\n\n.bi-music-note-list::before {\n  content: \"\\f49f\";\n}\n\n.bi-music-note::before {\n  content: \"\\f4a0\";\n}\n\n.bi-music-player-fill::before {\n  content: \"\\f4a1\";\n}\n\n.bi-music-player::before {\n  content: \"\\f4a2\";\n}\n\n.bi-newspaper::before {\n  content: \"\\f4a3\";\n}\n\n.bi-node-minus-fill::before {\n  content: \"\\f4a4\";\n}\n\n.bi-node-minus::before {\n  content: \"\\f4a5\";\n}\n\n.bi-node-plus-fill::before {\n  content: \"\\f4a6\";\n}\n\n.bi-node-plus::before {\n  content: \"\\f4a7\";\n}\n\n.bi-nut-fill::before {\n  content: \"\\f4a8\";\n}\n\n.bi-nut::before {\n  content: \"\\f4a9\";\n}\n\n.bi-octagon-fill::before {\n  content: \"\\f4aa\";\n}\n\n.bi-octagon-half::before {\n  content: \"\\f4ab\";\n}\n\n.bi-octagon::before {\n  content: \"\\f4ac\";\n}\n\n.bi-option::before {\n  content: \"\\f4ad\";\n}\n\n.bi-outlet::before {\n  content: \"\\f4ae\";\n}\n\n.bi-paint-bucket::before {\n  content: \"\\f4af\";\n}\n\n.bi-palette-fill::before {\n  content: \"\\f4b0\";\n}\n\n.bi-palette::before {\n  content: \"\\f4b1\";\n}\n\n.bi-palette2::before {\n  content: \"\\f4b2\";\n}\n\n.bi-paperclip::before {\n  content: \"\\f4b3\";\n}\n\n.bi-paragraph::before {\n  content: \"\\f4b4\";\n}\n\n.bi-patch-check-fill::before {\n  content: \"\\f4b5\";\n}\n\n.bi-patch-check::before {\n  content: \"\\f4b6\";\n}\n\n.bi-patch-exclamation-fill::before {\n  content: \"\\f4b7\";\n}\n\n.bi-patch-exclamation::before {\n  content: \"\\f4b8\";\n}\n\n.bi-patch-minus-fill::before {\n  content: \"\\f4b9\";\n}\n\n.bi-patch-minus::before {\n  content: \"\\f4ba\";\n}\n\n.bi-patch-plus-fill::before {\n  content: \"\\f4bb\";\n}\n\n.bi-patch-plus::before {\n  content: \"\\f4bc\";\n}\n\n.bi-patch-question-fill::before {\n  content: \"\\f4bd\";\n}\n\n.bi-patch-question::before {\n  content: \"\\f4be\";\n}\n\n.bi-pause-btn-fill::before {\n  content: \"\\f4bf\";\n}\n\n.bi-pause-btn::before {\n  content: \"\\f4c0\";\n}\n\n.bi-pause-circle-fill::before {\n  content: \"\\f4c1\";\n}\n\n.bi-pause-circle::before {\n  content: \"\\f4c2\";\n}\n\n.bi-pause-fill::before {\n  content: \"\\f4c3\";\n}\n\n.bi-pause::before {\n  content: \"\\f4c4\";\n}\n\n.bi-peace-fill::before {\n  content: \"\\f4c5\";\n}\n\n.bi-peace::before {\n  content: \"\\f4c6\";\n}\n\n.bi-pen-fill::before {\n  content: \"\\f4c7\";\n}\n\n.bi-pen::before {\n  content: \"\\f4c8\";\n}\n\n.bi-pencil-fill::before {\n  content: \"\\f4c9\";\n}\n\n.bi-pencil-square::before {\n  content: \"\\f4ca\";\n}\n\n.bi-pencil::before {\n  content: \"\\f4cb\";\n}\n\n.bi-pentagon-fill::before {\n  content: \"\\f4cc\";\n}\n\n.bi-pentagon-half::before {\n  content: \"\\f4cd\";\n}\n\n.bi-pentagon::before {\n  content: \"\\f4ce\";\n}\n\n.bi-people-fill::before {\n  content: \"\\f4cf\";\n}\n\n.bi-people::before {\n  content: \"\\f4d0\";\n}\n\n.bi-percent::before {\n  content: \"\\f4d1\";\n}\n\n.bi-person-badge-fill::before {\n  content: \"\\f4d2\";\n}\n\n.bi-person-badge::before {\n  content: \"\\f4d3\";\n}\n\n.bi-person-bounding-box::before {\n  content: \"\\f4d4\";\n}\n\n.bi-person-check-fill::before {\n  content: \"\\f4d5\";\n}\n\n.bi-person-check::before {\n  content: \"\\f4d6\";\n}\n\n.bi-person-circle::before {\n  content: \"\\f4d7\";\n}\n\n.bi-person-dash-fill::before {\n  content: \"\\f4d8\";\n}\n\n.bi-person-dash::before {\n  content: \"\\f4d9\";\n}\n\n.bi-person-fill::before {\n  content: \"\\f4da\";\n}\n\n.bi-person-lines-fill::before {\n  content: \"\\f4db\";\n}\n\n.bi-person-plus-fill::before {\n  content: \"\\f4dc\";\n}\n\n.bi-person-plus::before {\n  content: \"\\f4dd\";\n}\n\n.bi-person-square::before {\n  content: \"\\f4de\";\n}\n\n.bi-person-x-fill::before {\n  content: \"\\f4df\";\n}\n\n.bi-person-x::before {\n  content: \"\\f4e0\";\n}\n\n.bi-person::before {\n  content: \"\\f4e1\";\n}\n\n.bi-phone-fill::before {\n  content: \"\\f4e2\";\n}\n\n.bi-phone-landscape-fill::before {\n  content: \"\\f4e3\";\n}\n\n.bi-phone-landscape::before {\n  content: \"\\f4e4\";\n}\n\n.bi-phone-vibrate-fill::before {\n  content: \"\\f4e5\";\n}\n\n.bi-phone-vibrate::before {\n  content: \"\\f4e6\";\n}\n\n.bi-phone::before {\n  content: \"\\f4e7\";\n}\n\n.bi-pie-chart-fill::before {\n  content: \"\\f4e8\";\n}\n\n.bi-pie-chart::before {\n  content: \"\\f4e9\";\n}\n\n.bi-pin-angle-fill::before {\n  content: \"\\f4ea\";\n}\n\n.bi-pin-angle::before {\n  content: \"\\f4eb\";\n}\n\n.bi-pin-fill::before {\n  content: \"\\f4ec\";\n}\n\n.bi-pin::before {\n  content: \"\\f4ed\";\n}\n\n.bi-pip-fill::before {\n  content: \"\\f4ee\";\n}\n\n.bi-pip::before {\n  content: \"\\f4ef\";\n}\n\n.bi-play-btn-fill::before {\n  content: \"\\f4f0\";\n}\n\n.bi-play-btn::before {\n  content: \"\\f4f1\";\n}\n\n.bi-play-circle-fill::before {\n  content: \"\\f4f2\";\n}\n\n.bi-play-circle::before {\n  content: \"\\f4f3\";\n}\n\n.bi-play-fill::before {\n  content: \"\\f4f4\";\n}\n\n.bi-play::before {\n  content: \"\\f4f5\";\n}\n\n.bi-plug-fill::before {\n  content: \"\\f4f6\";\n}\n\n.bi-plug::before {\n  content: \"\\f4f7\";\n}\n\n.bi-plus-circle-dotted::before {\n  content: \"\\f4f8\";\n}\n\n.bi-plus-circle-fill::before {\n  content: \"\\f4f9\";\n}\n\n.bi-plus-circle::before {\n  content: \"\\f4fa\";\n}\n\n.bi-plus-square-dotted::before {\n  content: \"\\f4fb\";\n}\n\n.bi-plus-square-fill::before {\n  content: \"\\f4fc\";\n}\n\n.bi-plus-square::before {\n  content: \"\\f4fd\";\n}\n\n.bi-plus::before {\n  content: \"\\f4fe\";\n}\n\n.bi-power::before {\n  content: \"\\f4ff\";\n}\n\n.bi-printer-fill::before {\n  content: \"\\f500\";\n}\n\n.bi-printer::before {\n  content: \"\\f501\";\n}\n\n.bi-puzzle-fill::before {\n  content: \"\\f502\";\n}\n\n.bi-puzzle::before {\n  content: \"\\f503\";\n}\n\n.bi-question-circle-fill::before {\n  content: \"\\f504\";\n}\n\n.bi-question-circle::before {\n  content: \"\\f505\";\n}\n\n.bi-question-diamond-fill::before {\n  content: \"\\f506\";\n}\n\n.bi-question-diamond::before {\n  content: \"\\f507\";\n}\n\n.bi-question-octagon-fill::before {\n  content: \"\\f508\";\n}\n\n.bi-question-octagon::before {\n  content: \"\\f509\";\n}\n\n.bi-question-square-fill::before {\n  content: \"\\f50a\";\n}\n\n.bi-question-square::before {\n  content: \"\\f50b\";\n}\n\n.bi-question::before {\n  content: \"\\f50c\";\n}\n\n.bi-rainbow::before {\n  content: \"\\f50d\";\n}\n\n.bi-receipt-cutoff::before {\n  content: \"\\f50e\";\n}\n\n.bi-receipt::before {\n  content: \"\\f50f\";\n}\n\n.bi-reception-0::before {\n  content: \"\\f510\";\n}\n\n.bi-reception-1::before {\n  content: \"\\f511\";\n}\n\n.bi-reception-2::before {\n  content: \"\\f512\";\n}\n\n.bi-reception-3::before {\n  content: \"\\f513\";\n}\n\n.bi-reception-4::before {\n  content: \"\\f514\";\n}\n\n.bi-record-btn-fill::before {\n  content: \"\\f515\";\n}\n\n.bi-record-btn::before {\n  content: \"\\f516\";\n}\n\n.bi-record-circle-fill::before {\n  content: \"\\f517\";\n}\n\n.bi-record-circle::before {\n  content: \"\\f518\";\n}\n\n.bi-record-fill::before {\n  content: \"\\f519\";\n}\n\n.bi-record::before {\n  content: \"\\f51a\";\n}\n\n.bi-record2-fill::before {\n  content: \"\\f51b\";\n}\n\n.bi-record2::before {\n  content: \"\\f51c\";\n}\n\n.bi-reply-all-fill::before {\n  content: \"\\f51d\";\n}\n\n.bi-reply-all::before {\n  content: \"\\f51e\";\n}\n\n.bi-reply-fill::before {\n  content: \"\\f51f\";\n}\n\n.bi-reply::before {\n  content: \"\\f520\";\n}\n\n.bi-rss-fill::before {\n  content: \"\\f521\";\n}\n\n.bi-rss::before {\n  content: \"\\f522\";\n}\n\n.bi-rulers::before {\n  content: \"\\f523\";\n}\n\n.bi-save-fill::before {\n  content: \"\\f524\";\n}\n\n.bi-save::before {\n  content: \"\\f525\";\n}\n\n.bi-save2-fill::before {\n  content: \"\\f526\";\n}\n\n.bi-save2::before {\n  content: \"\\f527\";\n}\n\n.bi-scissors::before {\n  content: \"\\f528\";\n}\n\n.bi-screwdriver::before {\n  content: \"\\f529\";\n}\n\n.bi-search::before {\n  content: \"\\f52a\";\n}\n\n.bi-segmented-nav::before {\n  content: \"\\f52b\";\n}\n\n.bi-server::before {\n  content: \"\\f52c\";\n}\n\n.bi-share-fill::before {\n  content: \"\\f52d\";\n}\n\n.bi-share::before {\n  content: \"\\f52e\";\n}\n\n.bi-shield-check::before {\n  content: \"\\f52f\";\n}\n\n.bi-shield-exclamation::before {\n  content: \"\\f530\";\n}\n\n.bi-shield-fill-check::before {\n  content: \"\\f531\";\n}\n\n.bi-shield-fill-exclamation::before {\n  content: \"\\f532\";\n}\n\n.bi-shield-fill-minus::before {\n  content: \"\\f533\";\n}\n\n.bi-shield-fill-plus::before {\n  content: \"\\f534\";\n}\n\n.bi-shield-fill-x::before {\n  content: \"\\f535\";\n}\n\n.bi-shield-fill::before {\n  content: \"\\f536\";\n}\n\n.bi-shield-lock-fill::before {\n  content: \"\\f537\";\n}\n\n.bi-shield-lock::before {\n  content: \"\\f538\";\n}\n\n.bi-shield-minus::before {\n  content: \"\\f539\";\n}\n\n.bi-shield-plus::before {\n  content: \"\\f53a\";\n}\n\n.bi-shield-shaded::before {\n  content: \"\\f53b\";\n}\n\n.bi-shield-slash-fill::before {\n  content: \"\\f53c\";\n}\n\n.bi-shield-slash::before {\n  content: \"\\f53d\";\n}\n\n.bi-shield-x::before {\n  content: \"\\f53e\";\n}\n\n.bi-shield::before {\n  content: \"\\f53f\";\n}\n\n.bi-shift-fill::before {\n  content: \"\\f540\";\n}\n\n.bi-shift::before {\n  content: \"\\f541\";\n}\n\n.bi-shop-window::before {\n  content: \"\\f542\";\n}\n\n.bi-shop::before {\n  content: \"\\f543\";\n}\n\n.bi-shuffle::before {\n  content: \"\\f544\";\n}\n\n.bi-signpost-2-fill::before {\n  content: \"\\f545\";\n}\n\n.bi-signpost-2::before {\n  content: \"\\f546\";\n}\n\n.bi-signpost-fill::before {\n  content: \"\\f547\";\n}\n\n.bi-signpost-split-fill::before {\n  content: \"\\f548\";\n}\n\n.bi-signpost-split::before {\n  content: \"\\f549\";\n}\n\n.bi-signpost::before {\n  content: \"\\f54a\";\n}\n\n.bi-sim-fill::before {\n  content: \"\\f54b\";\n}\n\n.bi-sim::before {\n  content: \"\\f54c\";\n}\n\n.bi-skip-backward-btn-fill::before {\n  content: \"\\f54d\";\n}\n\n.bi-skip-backward-btn::before {\n  content: \"\\f54e\";\n}\n\n.bi-skip-backward-circle-fill::before {\n  content: \"\\f54f\";\n}\n\n.bi-skip-backward-circle::before {\n  content: \"\\f550\";\n}\n\n.bi-skip-backward-fill::before {\n  content: \"\\f551\";\n}\n\n.bi-skip-backward::before {\n  content: \"\\f552\";\n}\n\n.bi-skip-end-btn-fill::before {\n  content: \"\\f553\";\n}\n\n.bi-skip-end-btn::before {\n  content: \"\\f554\";\n}\n\n.bi-skip-end-circle-fill::before {\n  content: \"\\f555\";\n}\n\n.bi-skip-end-circle::before {\n  content: \"\\f556\";\n}\n\n.bi-skip-end-fill::before {\n  content: \"\\f557\";\n}\n\n.bi-skip-end::before {\n  content: \"\\f558\";\n}\n\n.bi-skip-forward-btn-fill::before {\n  content: \"\\f559\";\n}\n\n.bi-skip-forward-btn::before {\n  content: \"\\f55a\";\n}\n\n.bi-skip-forward-circle-fill::before {\n  content: \"\\f55b\";\n}\n\n.bi-skip-forward-circle::before {\n  content: \"\\f55c\";\n}\n\n.bi-skip-forward-fill::before {\n  content: \"\\f55d\";\n}\n\n.bi-skip-forward::before {\n  content: \"\\f55e\";\n}\n\n.bi-skip-start-btn-fill::before {\n  content: \"\\f55f\";\n}\n\n.bi-skip-start-btn::before {\n  content: \"\\f560\";\n}\n\n.bi-skip-start-circle-fill::before {\n  content: \"\\f561\";\n}\n\n.bi-skip-start-circle::before {\n  content: \"\\f562\";\n}\n\n.bi-skip-start-fill::before {\n  content: \"\\f563\";\n}\n\n.bi-skip-start::before {\n  content: \"\\f564\";\n}\n\n.bi-slack::before {\n  content: \"\\f565\";\n}\n\n.bi-slash-circle-fill::before {\n  content: \"\\f566\";\n}\n\n.bi-slash-circle::before {\n  content: \"\\f567\";\n}\n\n.bi-slash-square-fill::before {\n  content: \"\\f568\";\n}\n\n.bi-slash-square::before {\n  content: \"\\f569\";\n}\n\n.bi-slash::before {\n  content: \"\\f56a\";\n}\n\n.bi-sliders::before {\n  content: \"\\f56b\";\n}\n\n.bi-smartwatch::before {\n  content: \"\\f56c\";\n}\n\n.bi-snow::before {\n  content: \"\\f56d\";\n}\n\n.bi-snow2::before {\n  content: \"\\f56e\";\n}\n\n.bi-snow3::before {\n  content: \"\\f56f\";\n}\n\n.bi-sort-alpha-down-alt::before {\n  content: \"\\f570\";\n}\n\n.bi-sort-alpha-down::before {\n  content: \"\\f571\";\n}\n\n.bi-sort-alpha-up-alt::before {\n  content: \"\\f572\";\n}\n\n.bi-sort-alpha-up::before {\n  content: \"\\f573\";\n}\n\n.bi-sort-down-alt::before {\n  content: \"\\f574\";\n}\n\n.bi-sort-down::before {\n  content: \"\\f575\";\n}\n\n.bi-sort-numeric-down-alt::before {\n  content: \"\\f576\";\n}\n\n.bi-sort-numeric-down::before {\n  content: \"\\f577\";\n}\n\n.bi-sort-numeric-up-alt::before {\n  content: \"\\f578\";\n}\n\n.bi-sort-numeric-up::before {\n  content: \"\\f579\";\n}\n\n.bi-sort-up-alt::before {\n  content: \"\\f57a\";\n}\n\n.bi-sort-up::before {\n  content: \"\\f57b\";\n}\n\n.bi-soundwave::before {\n  content: \"\\f57c\";\n}\n\n.bi-speaker-fill::before {\n  content: \"\\f57d\";\n}\n\n.bi-speaker::before {\n  content: \"\\f57e\";\n}\n\n.bi-speedometer::before {\n  content: \"\\f57f\";\n}\n\n.bi-speedometer2::before {\n  content: \"\\f580\";\n}\n\n.bi-spellcheck::before {\n  content: \"\\f581\";\n}\n\n.bi-square-fill::before {\n  content: \"\\f582\";\n}\n\n.bi-square-half::before {\n  content: \"\\f583\";\n}\n\n.bi-square::before {\n  content: \"\\f584\";\n}\n\n.bi-stack::before {\n  content: \"\\f585\";\n}\n\n.bi-star-fill::before {\n  content: \"\\f586\";\n}\n\n.bi-star-half::before {\n  content: \"\\f587\";\n}\n\n.bi-star::before {\n  content: \"\\f588\";\n}\n\n.bi-stars::before {\n  content: \"\\f589\";\n}\n\n.bi-stickies-fill::before {\n  content: \"\\f58a\";\n}\n\n.bi-stickies::before {\n  content: \"\\f58b\";\n}\n\n.bi-sticky-fill::before {\n  content: \"\\f58c\";\n}\n\n.bi-sticky::before {\n  content: \"\\f58d\";\n}\n\n.bi-stop-btn-fill::before {\n  content: \"\\f58e\";\n}\n\n.bi-stop-btn::before {\n  content: \"\\f58f\";\n}\n\n.bi-stop-circle-fill::before {\n  content: \"\\f590\";\n}\n\n.bi-stop-circle::before {\n  content: \"\\f591\";\n}\n\n.bi-stop-fill::before {\n  content: \"\\f592\";\n}\n\n.bi-stop::before {\n  content: \"\\f593\";\n}\n\n.bi-stoplights-fill::before {\n  content: \"\\f594\";\n}\n\n.bi-stoplights::before {\n  content: \"\\f595\";\n}\n\n.bi-stopwatch-fill::before {\n  content: \"\\f596\";\n}\n\n.bi-stopwatch::before {\n  content: \"\\f597\";\n}\n\n.bi-subtract::before {\n  content: \"\\f598\";\n}\n\n.bi-suit-club-fill::before {\n  content: \"\\f599\";\n}\n\n.bi-suit-club::before {\n  content: \"\\f59a\";\n}\n\n.bi-suit-diamond-fill::before {\n  content: \"\\f59b\";\n}\n\n.bi-suit-diamond::before {\n  content: \"\\f59c\";\n}\n\n.bi-suit-heart-fill::before {\n  content: \"\\f59d\";\n}\n\n.bi-suit-heart::before {\n  content: \"\\f59e\";\n}\n\n.bi-suit-spade-fill::before {\n  content: \"\\f59f\";\n}\n\n.bi-suit-spade::before {\n  content: \"\\f5a0\";\n}\n\n.bi-sun-fill::before {\n  content: \"\\f5a1\";\n}\n\n.bi-sun::before {\n  content: \"\\f5a2\";\n}\n\n.bi-sunglasses::before {\n  content: \"\\f5a3\";\n}\n\n.bi-sunrise-fill::before {\n  content: \"\\f5a4\";\n}\n\n.bi-sunrise::before {\n  content: \"\\f5a5\";\n}\n\n.bi-sunset-fill::before {\n  content: \"\\f5a6\";\n}\n\n.bi-sunset::before {\n  content: \"\\f5a7\";\n}\n\n.bi-symmetry-horizontal::before {\n  content: \"\\f5a8\";\n}\n\n.bi-symmetry-vertical::before {\n  content: \"\\f5a9\";\n}\n\n.bi-table::before {\n  content: \"\\f5aa\";\n}\n\n.bi-tablet-fill::before {\n  content: \"\\f5ab\";\n}\n\n.bi-tablet-landscape-fill::before {\n  content: \"\\f5ac\";\n}\n\n.bi-tablet-landscape::before {\n  content: \"\\f5ad\";\n}\n\n.bi-tablet::before {\n  content: \"\\f5ae\";\n}\n\n.bi-tag-fill::before {\n  content: \"\\f5af\";\n}\n\n.bi-tag::before {\n  content: \"\\f5b0\";\n}\n\n.bi-tags-fill::before {\n  content: \"\\f5b1\";\n}\n\n.bi-tags::before {\n  content: \"\\f5b2\";\n}\n\n.bi-telegram::before {\n  content: \"\\f5b3\";\n}\n\n.bi-telephone-fill::before {\n  content: \"\\f5b4\";\n}\n\n.bi-telephone-forward-fill::before {\n  content: \"\\f5b5\";\n}\n\n.bi-telephone-forward::before {\n  content: \"\\f5b6\";\n}\n\n.bi-telephone-inbound-fill::before {\n  content: \"\\f5b7\";\n}\n\n.bi-telephone-inbound::before {\n  content: \"\\f5b8\";\n}\n\n.bi-telephone-minus-fill::before {\n  content: \"\\f5b9\";\n}\n\n.bi-telephone-minus::before {\n  content: \"\\f5ba\";\n}\n\n.bi-telephone-outbound-fill::before {\n  content: \"\\f5bb\";\n}\n\n.bi-telephone-outbound::before {\n  content: \"\\f5bc\";\n}\n\n.bi-telephone-plus-fill::before {\n  content: \"\\f5bd\";\n}\n\n.bi-telephone-plus::before {\n  content: \"\\f5be\";\n}\n\n.bi-telephone-x-fill::before {\n  content: \"\\f5bf\";\n}\n\n.bi-telephone-x::before {\n  content: \"\\f5c0\";\n}\n\n.bi-telephone::before {\n  content: \"\\f5c1\";\n}\n\n.bi-terminal-fill::before {\n  content: \"\\f5c2\";\n}\n\n.bi-terminal::before {\n  content: \"\\f5c3\";\n}\n\n.bi-text-center::before {\n  content: \"\\f5c4\";\n}\n\n.bi-text-indent-left::before {\n  content: \"\\f5c5\";\n}\n\n.bi-text-indent-right::before {\n  content: \"\\f5c6\";\n}\n\n.bi-text-left::before {\n  content: \"\\f5c7\";\n}\n\n.bi-text-paragraph::before {\n  content: \"\\f5c8\";\n}\n\n.bi-text-right::before {\n  content: \"\\f5c9\";\n}\n\n.bi-textarea-resize::before {\n  content: \"\\f5ca\";\n}\n\n.bi-textarea-t::before {\n  content: \"\\f5cb\";\n}\n\n.bi-textarea::before {\n  content: \"\\f5cc\";\n}\n\n.bi-thermometer-half::before {\n  content: \"\\f5cd\";\n}\n\n.bi-thermometer-high::before {\n  content: \"\\f5ce\";\n}\n\n.bi-thermometer-low::before {\n  content: \"\\f5cf\";\n}\n\n.bi-thermometer-snow::before {\n  content: \"\\f5d0\";\n}\n\n.bi-thermometer-sun::before {\n  content: \"\\f5d1\";\n}\n\n.bi-thermometer::before {\n  content: \"\\f5d2\";\n}\n\n.bi-three-dots-vertical::before {\n  content: \"\\f5d3\";\n}\n\n.bi-three-dots::before {\n  content: \"\\f5d4\";\n}\n\n.bi-toggle-off::before {\n  content: \"\\f5d5\";\n}\n\n.bi-toggle-on::before {\n  content: \"\\f5d6\";\n}\n\n.bi-toggle2-off::before {\n  content: \"\\f5d7\";\n}\n\n.bi-toggle2-on::before {\n  content: \"\\f5d8\";\n}\n\n.bi-toggles::before {\n  content: \"\\f5d9\";\n}\n\n.bi-toggles2::before {\n  content: \"\\f5da\";\n}\n\n.bi-tools::before {\n  content: \"\\f5db\";\n}\n\n.bi-tornado::before {\n  content: \"\\f5dc\";\n}\n\n.bi-trash-fill::before {\n  content: \"\\f5dd\";\n}\n\n.bi-trash::before {\n  content: \"\\f5de\";\n}\n\n.bi-trash2-fill::before {\n  content: \"\\f5df\";\n}\n\n.bi-trash2::before {\n  content: \"\\f5e0\";\n}\n\n.bi-tree-fill::before {\n  content: \"\\f5e1\";\n}\n\n.bi-tree::before {\n  content: \"\\f5e2\";\n}\n\n.bi-triangle-fill::before {\n  content: \"\\f5e3\";\n}\n\n.bi-triangle-half::before {\n  content: \"\\f5e4\";\n}\n\n.bi-triangle::before {\n  content: \"\\f5e5\";\n}\n\n.bi-trophy-fill::before {\n  content: \"\\f5e6\";\n}\n\n.bi-trophy::before {\n  content: \"\\f5e7\";\n}\n\n.bi-tropical-storm::before {\n  content: \"\\f5e8\";\n}\n\n.bi-truck-flatbed::before {\n  content: \"\\f5e9\";\n}\n\n.bi-truck::before {\n  content: \"\\f5ea\";\n}\n\n.bi-tsunami::before {\n  content: \"\\f5eb\";\n}\n\n.bi-tv-fill::before {\n  content: \"\\f5ec\";\n}\n\n.bi-tv::before {\n  content: \"\\f5ed\";\n}\n\n.bi-twitch::before {\n  content: \"\\f5ee\";\n}\n\n.bi-twitter::before {\n  content: \"\\f5ef\";\n}\n\n.bi-type-bold::before {\n  content: \"\\f5f0\";\n}\n\n.bi-type-h1::before {\n  content: \"\\f5f1\";\n}\n\n.bi-type-h2::before {\n  content: \"\\f5f2\";\n}\n\n.bi-type-h3::before {\n  content: \"\\f5f3\";\n}\n\n.bi-type-italic::before {\n  content: \"\\f5f4\";\n}\n\n.bi-type-strikethrough::before {\n  content: \"\\f5f5\";\n}\n\n.bi-type-underline::before {\n  content: \"\\f5f6\";\n}\n\n.bi-type::before {\n  content: \"\\f5f7\";\n}\n\n.bi-ui-checks-grid::before {\n  content: \"\\f5f8\";\n}\n\n.bi-ui-checks::before {\n  content: \"\\f5f9\";\n}\n\n.bi-ui-radios-grid::before {\n  content: \"\\f5fa\";\n}\n\n.bi-ui-radios::before {\n  content: \"\\f5fb\";\n}\n\n.bi-umbrella-fill::before {\n  content: \"\\f5fc\";\n}\n\n.bi-umbrella::before {\n  content: \"\\f5fd\";\n}\n\n.bi-union::before {\n  content: \"\\f5fe\";\n}\n\n.bi-unlock-fill::before {\n  content: \"\\f5ff\";\n}\n\n.bi-unlock::before {\n  content: \"\\f600\";\n}\n\n.bi-upc-scan::before {\n  content: \"\\f601\";\n}\n\n.bi-upc::before {\n  content: \"\\f602\";\n}\n\n.bi-upload::before {\n  content: \"\\f603\";\n}\n\n.bi-vector-pen::before {\n  content: \"\\f604\";\n}\n\n.bi-view-list::before {\n  content: \"\\f605\";\n}\n\n.bi-view-stacked::before {\n  content: \"\\f606\";\n}\n\n.bi-vinyl-fill::before {\n  content: \"\\f607\";\n}\n\n.bi-vinyl::before {\n  content: \"\\f608\";\n}\n\n.bi-voicemail::before {\n  content: \"\\f609\";\n}\n\n.bi-volume-down-fill::before {\n  content: \"\\f60a\";\n}\n\n.bi-volume-down::before {\n  content: \"\\f60b\";\n}\n\n.bi-volume-mute-fill::before {\n  content: \"\\f60c\";\n}\n\n.bi-volume-mute::before {\n  content: \"\\f60d\";\n}\n\n.bi-volume-off-fill::before {\n  content: \"\\f60e\";\n}\n\n.bi-volume-off::before {\n  content: \"\\f60f\";\n}\n\n.bi-volume-up-fill::before {\n  content: \"\\f610\";\n}\n\n.bi-volume-up::before {\n  content: \"\\f611\";\n}\n\n.bi-vr::before {\n  content: \"\\f612\";\n}\n\n.bi-wallet-fill::before {\n  content: \"\\f613\";\n}\n\n.bi-wallet::before {\n  content: \"\\f614\";\n}\n\n.bi-wallet2::before {\n  content: \"\\f615\";\n}\n\n.bi-watch::before {\n  content: \"\\f616\";\n}\n\n.bi-water::before {\n  content: \"\\f617\";\n}\n\n.bi-whatsapp::before {\n  content: \"\\f618\";\n}\n\n.bi-wifi-1::before {\n  content: \"\\f619\";\n}\n\n.bi-wifi-2::before {\n  content: \"\\f61a\";\n}\n\n.bi-wifi-off::before {\n  content: \"\\f61b\";\n}\n\n.bi-wifi::before {\n  content: \"\\f61c\";\n}\n\n.bi-wind::before {\n  content: \"\\f61d\";\n}\n\n.bi-window-dock::before {\n  content: \"\\f61e\";\n}\n\n.bi-window-sidebar::before {\n  content: \"\\f61f\";\n}\n\n.bi-window::before {\n  content: \"\\f620\";\n}\n\n.bi-wrench::before {\n  content: \"\\f621\";\n}\n\n.bi-x-circle-fill::before {\n  content: \"\\f622\";\n}\n\n.bi-x-circle::before {\n  content: \"\\f623\";\n}\n\n.bi-x-diamond-fill::before {\n  content: \"\\f624\";\n}\n\n.bi-x-diamond::before {\n  content: \"\\f625\";\n}\n\n.bi-x-octagon-fill::before {\n  content: \"\\f626\";\n}\n\n.bi-x-octagon::before {\n  content: \"\\f627\";\n}\n\n.bi-x-square-fill::before {\n  content: \"\\f628\";\n}\n\n.bi-x-square::before {\n  content: \"\\f629\";\n}\n\n.bi-x::before {\n  content: \"\\f62a\";\n}\n\n.bi-youtube::before {\n  content: \"\\f62b\";\n}\n\n.bi-zoom-in::before {\n  content: \"\\f62c\";\n}\n\n.bi-zoom-out::before {\n  content: \"\\f62d\";\n}\n\n.bi-bank::before {\n  content: \"\\f62e\";\n}\n\n.bi-bank2::before {\n  content: \"\\f62f\";\n}\n\n.bi-bell-slash-fill::before {\n  content: \"\\f630\";\n}\n\n.bi-bell-slash::before {\n  content: \"\\f631\";\n}\n\n.bi-cash-coin::before {\n  content: \"\\f632\";\n}\n\n.bi-check-lg::before {\n  content: \"\\f633\";\n}\n\n.bi-coin::before {\n  content: \"\\f634\";\n}\n\n.bi-currency-bitcoin::before {\n  content: \"\\f635\";\n}\n\n.bi-currency-dollar::before {\n  content: \"\\f636\";\n}\n\n.bi-currency-euro::before {\n  content: \"\\f637\";\n}\n\n.bi-currency-exchange::before {\n  content: \"\\f638\";\n}\n\n.bi-currency-pound::before {\n  content: \"\\f639\";\n}\n\n.bi-currency-yen::before {\n  content: \"\\f63a\";\n}\n\n.bi-dash-lg::before {\n  content: \"\\f63b\";\n}\n\n.bi-exclamation-lg::before {\n  content: \"\\f63c\";\n}\n\n.bi-file-earmark-pdf-fill::before {\n  content: \"\\f63d\";\n}\n\n.bi-file-earmark-pdf::before {\n  content: \"\\f63e\";\n}\n\n.bi-file-pdf-fill::before {\n  content: \"\\f63f\";\n}\n\n.bi-file-pdf::before {\n  content: \"\\f640\";\n}\n\n.bi-gender-ambiguous::before {\n  content: \"\\f641\";\n}\n\n.bi-gender-female::before {\n  content: \"\\f642\";\n}\n\n.bi-gender-male::before {\n  content: \"\\f643\";\n}\n\n.bi-gender-trans::before {\n  content: \"\\f644\";\n}\n\n.bi-headset-vr::before {\n  content: \"\\f645\";\n}\n\n.bi-info-lg::before {\n  content: \"\\f646\";\n}\n\n.bi-mastodon::before {\n  content: \"\\f647\";\n}\n\n.bi-messenger::before {\n  content: \"\\f648\";\n}\n\n.bi-piggy-bank-fill::before {\n  content: \"\\f649\";\n}\n\n.bi-piggy-bank::before {\n  content: \"\\f64a\";\n}\n\n.bi-pin-map-fill::before {\n  content: \"\\f64b\";\n}\n\n.bi-pin-map::before {\n  content: \"\\f64c\";\n}\n\n.bi-plus-lg::before {\n  content: \"\\f64d\";\n}\n\n.bi-question-lg::before {\n  content: \"\\f64e\";\n}\n\n.bi-recycle::before {\n  content: \"\\f64f\";\n}\n\n.bi-reddit::before {\n  content: \"\\f650\";\n}\n\n.bi-safe-fill::before {\n  content: \"\\f651\";\n}\n\n.bi-safe2-fill::before {\n  content: \"\\f652\";\n}\n\n.bi-safe2::before {\n  content: \"\\f653\";\n}\n\n.bi-sd-card-fill::before {\n  content: \"\\f654\";\n}\n\n.bi-sd-card::before {\n  content: \"\\f655\";\n}\n\n.bi-skype::before {\n  content: \"\\f656\";\n}\n\n.bi-slash-lg::before {\n  content: \"\\f657\";\n}\n\n.bi-translate::before {\n  content: \"\\f658\";\n}\n\n.bi-x-lg::before {\n  content: \"\\f659\";\n}\n\n.bi-safe::before {\n  content: \"\\f65a\";\n}\n\n.bi-apple::before {\n  content: \"\\f65b\";\n}\n\n.bi-microsoft::before {\n  content: \"\\f65d\";\n}\n\n.bi-windows::before {\n  content: \"\\f65e\";\n}\n\n.bi-behance::before {\n  content: \"\\f65c\";\n}\n\n.bi-dribbble::before {\n  content: \"\\f65f\";\n}\n\n.bi-line::before {\n  content: \"\\f660\";\n}\n\n.bi-medium::before {\n  content: \"\\f661\";\n}\n\n.bi-paypal::before {\n  content: \"\\f662\";\n}\n\n.bi-pinterest::before {\n  content: \"\\f663\";\n}\n\n.bi-signal::before {\n  content: \"\\f664\";\n}\n\n.bi-snapchat::before {\n  content: \"\\f665\";\n}\n\n.bi-spotify::before {\n  content: \"\\f666\";\n}\n\n.bi-stack-overflow::before {\n  content: \"\\f667\";\n}\n\n.bi-strava::before {\n  content: \"\\f668\";\n}\n\n.bi-wordpress::before {\n  content: \"\\f669\";\n}\n\n.bi-vimeo::before {\n  content: \"\\f66a\";\n}\n\n.bi-activity::before {\n  content: \"\\f66b\";\n}\n\n.bi-easel2-fill::before {\n  content: \"\\f66c\";\n}\n\n.bi-easel2::before {\n  content: \"\\f66d\";\n}\n\n.bi-easel3-fill::before {\n  content: \"\\f66e\";\n}\n\n.bi-easel3::before {\n  content: \"\\f66f\";\n}\n\n.bi-fan::before {\n  content: \"\\f670\";\n}\n\n.bi-fingerprint::before {\n  content: \"\\f671\";\n}\n\n.bi-graph-down-arrow::before {\n  content: \"\\f672\";\n}\n\n.bi-graph-up-arrow::before {\n  content: \"\\f673\";\n}\n\n.bi-hypnotize::before {\n  content: \"\\f674\";\n}\n\n.bi-magic::before {\n  content: \"\\f675\";\n}\n\n.bi-person-rolodex::before {\n  content: \"\\f676\";\n}\n\n.bi-person-video::before {\n  content: \"\\f677\";\n}\n\n.bi-person-video2::before {\n  content: \"\\f678\";\n}\n\n.bi-person-video3::before {\n  content: \"\\f679\";\n}\n\n.bi-person-workspace::before {\n  content: \"\\f67a\";\n}\n\n.bi-radioactive::before {\n  content: \"\\f67b\";\n}\n\n.bi-webcam-fill::before {\n  content: \"\\f67c\";\n}\n\n.bi-webcam::before {\n  content: \"\\f67d\";\n}\n\n.bi-yin-yang::before {\n  content: \"\\f67e\";\n}\n\n.bi-bandaid-fill::before {\n  content: \"\\f680\";\n}\n\n.bi-bandaid::before {\n  content: \"\\f681\";\n}\n\n.bi-bluetooth::before {\n  content: \"\\f682\";\n}\n\n.bi-body-text::before {\n  content: \"\\f683\";\n}\n\n.bi-boombox::before {\n  content: \"\\f684\";\n}\n\n.bi-boxes::before {\n  content: \"\\f685\";\n}\n\n.bi-dpad-fill::before {\n  content: \"\\f686\";\n}\n\n.bi-dpad::before {\n  content: \"\\f687\";\n}\n\n.bi-ear-fill::before {\n  content: \"\\f688\";\n}\n\n.bi-ear::before {\n  content: \"\\f689\";\n}\n\n.bi-envelope-check-fill::before {\n  content: \"\\f68b\";\n}\n\n.bi-envelope-check::before {\n  content: \"\\f68c\";\n}\n\n.bi-envelope-dash-fill::before {\n  content: \"\\f68e\";\n}\n\n.bi-envelope-dash::before {\n  content: \"\\f68f\";\n}\n\n.bi-envelope-exclamation-fill::before {\n  content: \"\\f691\";\n}\n\n.bi-envelope-exclamation::before {\n  content: \"\\f692\";\n}\n\n.bi-envelope-plus-fill::before {\n  content: \"\\f693\";\n}\n\n.bi-envelope-plus::before {\n  content: \"\\f694\";\n}\n\n.bi-envelope-slash-fill::before {\n  content: \"\\f696\";\n}\n\n.bi-envelope-slash::before {\n  content: \"\\f697\";\n}\n\n.bi-envelope-x-fill::before {\n  content: \"\\f699\";\n}\n\n.bi-envelope-x::before {\n  content: \"\\f69a\";\n}\n\n.bi-explicit-fill::before {\n  content: \"\\f69b\";\n}\n\n.bi-explicit::before {\n  content: \"\\f69c\";\n}\n\n.bi-git::before {\n  content: \"\\f69d\";\n}\n\n.bi-infinity::before {\n  content: \"\\f69e\";\n}\n\n.bi-list-columns-reverse::before {\n  content: \"\\f69f\";\n}\n\n.bi-list-columns::before {\n  content: \"\\f6a0\";\n}\n\n.bi-meta::before {\n  content: \"\\f6a1\";\n}\n\n.bi-nintendo-switch::before {\n  content: \"\\f6a4\";\n}\n\n.bi-pc-display-horizontal::before {\n  content: \"\\f6a5\";\n}\n\n.bi-pc-display::before {\n  content: \"\\f6a6\";\n}\n\n.bi-pc-horizontal::before {\n  content: \"\\f6a7\";\n}\n\n.bi-pc::before {\n  content: \"\\f6a8\";\n}\n\n.bi-playstation::before {\n  content: \"\\f6a9\";\n}\n\n.bi-plus-slash-minus::before {\n  content: \"\\f6aa\";\n}\n\n.bi-projector-fill::before {\n  content: \"\\f6ab\";\n}\n\n.bi-projector::before {\n  content: \"\\f6ac\";\n}\n\n.bi-qr-code-scan::before {\n  content: \"\\f6ad\";\n}\n\n.bi-qr-code::before {\n  content: \"\\f6ae\";\n}\n\n.bi-quora::before {\n  content: \"\\f6af\";\n}\n\n.bi-quote::before {\n  content: \"\\f6b0\";\n}\n\n.bi-robot::before {\n  content: \"\\f6b1\";\n}\n\n.bi-send-check-fill::before {\n  content: \"\\f6b2\";\n}\n\n.bi-send-check::before {\n  content: \"\\f6b3\";\n}\n\n.bi-send-dash-fill::before {\n  content: \"\\f6b4\";\n}\n\n.bi-send-dash::before {\n  content: \"\\f6b5\";\n}\n\n.bi-send-exclamation-fill::before {\n  content: \"\\f6b7\";\n}\n\n.bi-send-exclamation::before {\n  content: \"\\f6b8\";\n}\n\n.bi-send-fill::before {\n  content: \"\\f6b9\";\n}\n\n.bi-send-plus-fill::before {\n  content: \"\\f6ba\";\n}\n\n.bi-send-plus::before {\n  content: \"\\f6bb\";\n}\n\n.bi-send-slash-fill::before {\n  content: \"\\f6bc\";\n}\n\n.bi-send-slash::before {\n  content: \"\\f6bd\";\n}\n\n.bi-send-x-fill::before {\n  content: \"\\f6be\";\n}\n\n.bi-send-x::before {\n  content: \"\\f6bf\";\n}\n\n.bi-send::before {\n  content: \"\\f6c0\";\n}\n\n.bi-steam::before {\n  content: \"\\f6c1\";\n}\n\n.bi-terminal-dash::before {\n  content: \"\\f6c3\";\n}\n\n.bi-terminal-plus::before {\n  content: \"\\f6c4\";\n}\n\n.bi-terminal-split::before {\n  content: \"\\f6c5\";\n}\n\n.bi-ticket-detailed-fill::before {\n  content: \"\\f6c6\";\n}\n\n.bi-ticket-detailed::before {\n  content: \"\\f6c7\";\n}\n\n.bi-ticket-fill::before {\n  content: \"\\f6c8\";\n}\n\n.bi-ticket-perforated-fill::before {\n  content: \"\\f6c9\";\n}\n\n.bi-ticket-perforated::before {\n  content: \"\\f6ca\";\n}\n\n.bi-ticket::before {\n  content: \"\\f6cb\";\n}\n\n.bi-tiktok::before {\n  content: \"\\f6cc\";\n}\n\n.bi-window-dash::before {\n  content: \"\\f6cd\";\n}\n\n.bi-window-desktop::before {\n  content: \"\\f6ce\";\n}\n\n.bi-window-fullscreen::before {\n  content: \"\\f6cf\";\n}\n\n.bi-window-plus::before {\n  content: \"\\f6d0\";\n}\n\n.bi-window-split::before {\n  content: \"\\f6d1\";\n}\n\n.bi-window-stack::before {\n  content: \"\\f6d2\";\n}\n\n.bi-window-x::before {\n  content: \"\\f6d3\";\n}\n\n.bi-xbox::before {\n  content: \"\\f6d4\";\n}\n\n.bi-ethernet::before {\n  content: \"\\f6d5\";\n}\n\n.bi-hdmi-fill::before {\n  content: \"\\f6d6\";\n}\n\n.bi-hdmi::before {\n  content: \"\\f6d7\";\n}\n\n.bi-usb-c-fill::before {\n  content: \"\\f6d8\";\n}\n\n.bi-usb-c::before {\n  content: \"\\f6d9\";\n}\n\n.bi-usb-fill::before {\n  content: \"\\f6da\";\n}\n\n.bi-usb-plug-fill::before {\n  content: \"\\f6db\";\n}\n\n.bi-usb-plug::before {\n  content: \"\\f6dc\";\n}\n\n.bi-usb-symbol::before {\n  content: \"\\f6dd\";\n}\n\n.bi-usb::before {\n  content: \"\\f6de\";\n}\n\n.bi-boombox-fill::before {\n  content: \"\\f6df\";\n}\n\n.bi-displayport::before {\n  content: \"\\f6e1\";\n}\n\n.bi-gpu-card::before {\n  content: \"\\f6e2\";\n}\n\n.bi-memory::before {\n  content: \"\\f6e3\";\n}\n\n.bi-modem-fill::before {\n  content: \"\\f6e4\";\n}\n\n.bi-modem::before {\n  content: \"\\f6e5\";\n}\n\n.bi-motherboard-fill::before {\n  content: \"\\f6e6\";\n}\n\n.bi-motherboard::before {\n  content: \"\\f6e7\";\n}\n\n.bi-optical-audio-fill::before {\n  content: \"\\f6e8\";\n}\n\n.bi-optical-audio::before {\n  content: \"\\f6e9\";\n}\n\n.bi-pci-card::before {\n  content: \"\\f6ea\";\n}\n\n.bi-router-fill::before {\n  content: \"\\f6eb\";\n}\n\n.bi-router::before {\n  content: \"\\f6ec\";\n}\n\n.bi-thunderbolt-fill::before {\n  content: \"\\f6ef\";\n}\n\n.bi-thunderbolt::before {\n  content: \"\\f6f0\";\n}\n\n.bi-usb-drive-fill::before {\n  content: \"\\f6f1\";\n}\n\n.bi-usb-drive::before {\n  content: \"\\f6f2\";\n}\n\n.bi-usb-micro-fill::before {\n  content: \"\\f6f3\";\n}\n\n.bi-usb-micro::before {\n  content: \"\\f6f4\";\n}\n\n.bi-usb-mini-fill::before {\n  content: \"\\f6f5\";\n}\n\n.bi-usb-mini::before {\n  content: \"\\f6f6\";\n}\n\n.bi-cloud-haze2::before {\n  content: \"\\f6f7\";\n}\n\n.bi-device-hdd-fill::before {\n  content: \"\\f6f8\";\n}\n\n.bi-device-hdd::before {\n  content: \"\\f6f9\";\n}\n\n.bi-device-ssd-fill::before {\n  content: \"\\f6fa\";\n}\n\n.bi-device-ssd::before {\n  content: \"\\f6fb\";\n}\n\n.bi-displayport-fill::before {\n  content: \"\\f6fc\";\n}\n\n.bi-mortarboard-fill::before {\n  content: \"\\f6fd\";\n}\n\n.bi-mortarboard::before {\n  content: \"\\f6fe\";\n}\n\n.bi-terminal-x::before {\n  content: \"\\f6ff\";\n}\n\n.bi-arrow-through-heart-fill::before {\n  content: \"\\f700\";\n}\n\n.bi-arrow-through-heart::before {\n  content: \"\\f701\";\n}\n\n.bi-badge-sd-fill::before {\n  content: \"\\f702\";\n}\n\n.bi-badge-sd::before {\n  content: \"\\f703\";\n}\n\n.bi-bag-heart-fill::before {\n  content: \"\\f704\";\n}\n\n.bi-bag-heart::before {\n  content: \"\\f705\";\n}\n\n.bi-balloon-fill::before {\n  content: \"\\f706\";\n}\n\n.bi-balloon-heart-fill::before {\n  content: \"\\f707\";\n}\n\n.bi-balloon-heart::before {\n  content: \"\\f708\";\n}\n\n.bi-balloon::before {\n  content: \"\\f709\";\n}\n\n.bi-box2-fill::before {\n  content: \"\\f70a\";\n}\n\n.bi-box2-heart-fill::before {\n  content: \"\\f70b\";\n}\n\n.bi-box2-heart::before {\n  content: \"\\f70c\";\n}\n\n.bi-box2::before {\n  content: \"\\f70d\";\n}\n\n.bi-braces-asterisk::before {\n  content: \"\\f70e\";\n}\n\n.bi-calendar-heart-fill::before {\n  content: \"\\f70f\";\n}\n\n.bi-calendar-heart::before {\n  content: \"\\f710\";\n}\n\n.bi-calendar2-heart-fill::before {\n  content: \"\\f711\";\n}\n\n.bi-calendar2-heart::before {\n  content: \"\\f712\";\n}\n\n.bi-chat-heart-fill::before {\n  content: \"\\f713\";\n}\n\n.bi-chat-heart::before {\n  content: \"\\f714\";\n}\n\n.bi-chat-left-heart-fill::before {\n  content: \"\\f715\";\n}\n\n.bi-chat-left-heart::before {\n  content: \"\\f716\";\n}\n\n.bi-chat-right-heart-fill::before {\n  content: \"\\f717\";\n}\n\n.bi-chat-right-heart::before {\n  content: \"\\f718\";\n}\n\n.bi-chat-square-heart-fill::before {\n  content: \"\\f719\";\n}\n\n.bi-chat-square-heart::before {\n  content: \"\\f71a\";\n}\n\n.bi-clipboard-check-fill::before {\n  content: \"\\f71b\";\n}\n\n.bi-clipboard-data-fill::before {\n  content: \"\\f71c\";\n}\n\n.bi-clipboard-fill::before {\n  content: \"\\f71d\";\n}\n\n.bi-clipboard-heart-fill::before {\n  content: \"\\f71e\";\n}\n\n.bi-clipboard-heart::before {\n  content: \"\\f71f\";\n}\n\n.bi-clipboard-minus-fill::before {\n  content: \"\\f720\";\n}\n\n.bi-clipboard-plus-fill::before {\n  content: \"\\f721\";\n}\n\n.bi-clipboard-pulse::before {\n  content: \"\\f722\";\n}\n\n.bi-clipboard-x-fill::before {\n  content: \"\\f723\";\n}\n\n.bi-clipboard2-check-fill::before {\n  content: \"\\f724\";\n}\n\n.bi-clipboard2-check::before {\n  content: \"\\f725\";\n}\n\n.bi-clipboard2-data-fill::before {\n  content: \"\\f726\";\n}\n\n.bi-clipboard2-data::before {\n  content: \"\\f727\";\n}\n\n.bi-clipboard2-fill::before {\n  content: \"\\f728\";\n}\n\n.bi-clipboard2-heart-fill::before {\n  content: \"\\f729\";\n}\n\n.bi-clipboard2-heart::before {\n  content: \"\\f72a\";\n}\n\n.bi-clipboard2-minus-fill::before {\n  content: \"\\f72b\";\n}\n\n.bi-clipboard2-minus::before {\n  content: \"\\f72c\";\n}\n\n.bi-clipboard2-plus-fill::before {\n  content: \"\\f72d\";\n}\n\n.bi-clipboard2-plus::before {\n  content: \"\\f72e\";\n}\n\n.bi-clipboard2-pulse-fill::before {\n  content: \"\\f72f\";\n}\n\n.bi-clipboard2-pulse::before {\n  content: \"\\f730\";\n}\n\n.bi-clipboard2-x-fill::before {\n  content: \"\\f731\";\n}\n\n.bi-clipboard2-x::before {\n  content: \"\\f732\";\n}\n\n.bi-clipboard2::before {\n  content: \"\\f733\";\n}\n\n.bi-emoji-kiss-fill::before {\n  content: \"\\f734\";\n}\n\n.bi-emoji-kiss::before {\n  content: \"\\f735\";\n}\n\n.bi-envelope-heart-fill::before {\n  content: \"\\f736\";\n}\n\n.bi-envelope-heart::before {\n  content: \"\\f737\";\n}\n\n.bi-envelope-open-heart-fill::before {\n  content: \"\\f738\";\n}\n\n.bi-envelope-open-heart::before {\n  content: \"\\f739\";\n}\n\n.bi-envelope-paper-fill::before {\n  content: \"\\f73a\";\n}\n\n.bi-envelope-paper-heart-fill::before {\n  content: \"\\f73b\";\n}\n\n.bi-envelope-paper-heart::before {\n  content: \"\\f73c\";\n}\n\n.bi-envelope-paper::before {\n  content: \"\\f73d\";\n}\n\n.bi-filetype-aac::before {\n  content: \"\\f73e\";\n}\n\n.bi-filetype-ai::before {\n  content: \"\\f73f\";\n}\n\n.bi-filetype-bmp::before {\n  content: \"\\f740\";\n}\n\n.bi-filetype-cs::before {\n  content: \"\\f741\";\n}\n\n.bi-filetype-css::before {\n  content: \"\\f742\";\n}\n\n.bi-filetype-csv::before {\n  content: \"\\f743\";\n}\n\n.bi-filetype-doc::before {\n  content: \"\\f744\";\n}\n\n.bi-filetype-docx::before {\n  content: \"\\f745\";\n}\n\n.bi-filetype-exe::before {\n  content: \"\\f746\";\n}\n\n.bi-filetype-gif::before {\n  content: \"\\f747\";\n}\n\n.bi-filetype-heic::before {\n  content: \"\\f748\";\n}\n\n.bi-filetype-html::before {\n  content: \"\\f749\";\n}\n\n.bi-filetype-java::before {\n  content: \"\\f74a\";\n}\n\n.bi-filetype-jpg::before {\n  content: \"\\f74b\";\n}\n\n.bi-filetype-js::before {\n  content: \"\\f74c\";\n}\n\n.bi-filetype-jsx::before {\n  content: \"\\f74d\";\n}\n\n.bi-filetype-key::before {\n  content: \"\\f74e\";\n}\n\n.bi-filetype-m4p::before {\n  content: \"\\f74f\";\n}\n\n.bi-filetype-md::before {\n  content: \"\\f750\";\n}\n\n.bi-filetype-mdx::before {\n  content: \"\\f751\";\n}\n\n.bi-filetype-mov::before {\n  content: \"\\f752\";\n}\n\n.bi-filetype-mp3::before {\n  content: \"\\f753\";\n}\n\n.bi-filetype-mp4::before {\n  content: \"\\f754\";\n}\n\n.bi-filetype-otf::before {\n  content: \"\\f755\";\n}\n\n.bi-filetype-pdf::before {\n  content: \"\\f756\";\n}\n\n.bi-filetype-php::before {\n  content: \"\\f757\";\n}\n\n.bi-filetype-png::before {\n  content: \"\\f758\";\n}\n\n.bi-filetype-ppt::before {\n  content: \"\\f75a\";\n}\n\n.bi-filetype-psd::before {\n  content: \"\\f75b\";\n}\n\n.bi-filetype-py::before {\n  content: \"\\f75c\";\n}\n\n.bi-filetype-raw::before {\n  content: \"\\f75d\";\n}\n\n.bi-filetype-rb::before {\n  content: \"\\f75e\";\n}\n\n.bi-filetype-sass::before {\n  content: \"\\f75f\";\n}\n\n.bi-filetype-scss::before {\n  content: \"\\f760\";\n}\n\n.bi-filetype-sh::before {\n  content: \"\\f761\";\n}\n\n.bi-filetype-svg::before {\n  content: \"\\f762\";\n}\n\n.bi-filetype-tiff::before {\n  content: \"\\f763\";\n}\n\n.bi-filetype-tsx::before {\n  content: \"\\f764\";\n}\n\n.bi-filetype-ttf::before {\n  content: \"\\f765\";\n}\n\n.bi-filetype-txt::before {\n  content: \"\\f766\";\n}\n\n.bi-filetype-wav::before {\n  content: \"\\f767\";\n}\n\n.bi-filetype-woff::before {\n  content: \"\\f768\";\n}\n\n.bi-filetype-xls::before {\n  content: \"\\f76a\";\n}\n\n.bi-filetype-xml::before {\n  content: \"\\f76b\";\n}\n\n.bi-filetype-yml::before {\n  content: \"\\f76c\";\n}\n\n.bi-heart-arrow::before {\n  content: \"\\f76d\";\n}\n\n.bi-heart-pulse-fill::before {\n  content: \"\\f76e\";\n}\n\n.bi-heart-pulse::before {\n  content: \"\\f76f\";\n}\n\n.bi-heartbreak-fill::before {\n  content: \"\\f770\";\n}\n\n.bi-heartbreak::before {\n  content: \"\\f771\";\n}\n\n.bi-hearts::before {\n  content: \"\\f772\";\n}\n\n.bi-hospital-fill::before {\n  content: \"\\f773\";\n}\n\n.bi-hospital::before {\n  content: \"\\f774\";\n}\n\n.bi-house-heart-fill::before {\n  content: \"\\f775\";\n}\n\n.bi-house-heart::before {\n  content: \"\\f776\";\n}\n\n.bi-incognito::before {\n  content: \"\\f777\";\n}\n\n.bi-magnet-fill::before {\n  content: \"\\f778\";\n}\n\n.bi-magnet::before {\n  content: \"\\f779\";\n}\n\n.bi-person-heart::before {\n  content: \"\\f77a\";\n}\n\n.bi-person-hearts::before {\n  content: \"\\f77b\";\n}\n\n.bi-phone-flip::before {\n  content: \"\\f77c\";\n}\n\n.bi-plugin::before {\n  content: \"\\f77d\";\n}\n\n.bi-postage-fill::before {\n  content: \"\\f77e\";\n}\n\n.bi-postage-heart-fill::before {\n  content: \"\\f77f\";\n}\n\n.bi-postage-heart::before {\n  content: \"\\f780\";\n}\n\n.bi-postage::before {\n  content: \"\\f781\";\n}\n\n.bi-postcard-fill::before {\n  content: \"\\f782\";\n}\n\n.bi-postcard-heart-fill::before {\n  content: \"\\f783\";\n}\n\n.bi-postcard-heart::before {\n  content: \"\\f784\";\n}\n\n.bi-postcard::before {\n  content: \"\\f785\";\n}\n\n.bi-search-heart-fill::before {\n  content: \"\\f786\";\n}\n\n.bi-search-heart::before {\n  content: \"\\f787\";\n}\n\n.bi-sliders2-vertical::before {\n  content: \"\\f788\";\n}\n\n.bi-sliders2::before {\n  content: \"\\f789\";\n}\n\n.bi-trash3-fill::before {\n  content: \"\\f78a\";\n}\n\n.bi-trash3::before {\n  content: \"\\f78b\";\n}\n\n.bi-valentine::before {\n  content: \"\\f78c\";\n}\n\n.bi-valentine2::before {\n  content: \"\\f78d\";\n}\n\n.bi-wrench-adjustable-circle-fill::before {\n  content: \"\\f78e\";\n}\n\n.bi-wrench-adjustable-circle::before {\n  content: \"\\f78f\";\n}\n\n.bi-wrench-adjustable::before {\n  content: \"\\f790\";\n}\n\n.bi-filetype-json::before {\n  content: \"\\f791\";\n}\n\n.bi-filetype-pptx::before {\n  content: \"\\f792\";\n}\n\n.bi-filetype-xlsx::before {\n  content: \"\\f793\";\n}\n\n.bi-1-circle-fill::before {\n  content: \"\\f796\";\n}\n\n.bi-1-circle::before {\n  content: \"\\f797\";\n}\n\n.bi-1-square-fill::before {\n  content: \"\\f798\";\n}\n\n.bi-1-square::before {\n  content: \"\\f799\";\n}\n\n.bi-2-circle-fill::before {\n  content: \"\\f79c\";\n}\n\n.bi-2-circle::before {\n  content: \"\\f79d\";\n}\n\n.bi-2-square-fill::before {\n  content: \"\\f79e\";\n}\n\n.bi-2-square::before {\n  content: \"\\f79f\";\n}\n\n.bi-3-circle-fill::before {\n  content: \"\\f7a2\";\n}\n\n.bi-3-circle::before {\n  content: \"\\f7a3\";\n}\n\n.bi-3-square-fill::before {\n  content: \"\\f7a4\";\n}\n\n.bi-3-square::before {\n  content: \"\\f7a5\";\n}\n\n.bi-4-circle-fill::before {\n  content: \"\\f7a8\";\n}\n\n.bi-4-circle::before {\n  content: \"\\f7a9\";\n}\n\n.bi-4-square-fill::before {\n  content: \"\\f7aa\";\n}\n\n.bi-4-square::before {\n  content: \"\\f7ab\";\n}\n\n.bi-5-circle-fill::before {\n  content: \"\\f7ae\";\n}\n\n.bi-5-circle::before {\n  content: \"\\f7af\";\n}\n\n.bi-5-square-fill::before {\n  content: \"\\f7b0\";\n}\n\n.bi-5-square::before {\n  content: \"\\f7b1\";\n}\n\n.bi-6-circle-fill::before {\n  content: \"\\f7b4\";\n}\n\n.bi-6-circle::before {\n  content: \"\\f7b5\";\n}\n\n.bi-6-square-fill::before {\n  content: \"\\f7b6\";\n}\n\n.bi-6-square::before {\n  content: \"\\f7b7\";\n}\n\n.bi-7-circle-fill::before {\n  content: \"\\f7ba\";\n}\n\n.bi-7-circle::before {\n  content: \"\\f7bb\";\n}\n\n.bi-7-square-fill::before {\n  content: \"\\f7bc\";\n}\n\n.bi-7-square::before {\n  content: \"\\f7bd\";\n}\n\n.bi-8-circle-fill::before {\n  content: \"\\f7c0\";\n}\n\n.bi-8-circle::before {\n  content: \"\\f7c1\";\n}\n\n.bi-8-square-fill::before {\n  content: \"\\f7c2\";\n}\n\n.bi-8-square::before {\n  content: \"\\f7c3\";\n}\n\n.bi-9-circle-fill::before {\n  content: \"\\f7c6\";\n}\n\n.bi-9-circle::before {\n  content: \"\\f7c7\";\n}\n\n.bi-9-square-fill::before {\n  content: \"\\f7c8\";\n}\n\n.bi-9-square::before {\n  content: \"\\f7c9\";\n}\n\n.bi-airplane-engines-fill::before {\n  content: \"\\f7ca\";\n}\n\n.bi-airplane-engines::before {\n  content: \"\\f7cb\";\n}\n\n.bi-airplane-fill::before {\n  content: \"\\f7cc\";\n}\n\n.bi-airplane::before {\n  content: \"\\f7cd\";\n}\n\n.bi-alexa::before {\n  content: \"\\f7ce\";\n}\n\n.bi-alipay::before {\n  content: \"\\f7cf\";\n}\n\n.bi-android::before {\n  content: \"\\f7d0\";\n}\n\n.bi-android2::before {\n  content: \"\\f7d1\";\n}\n\n.bi-box-fill::before {\n  content: \"\\f7d2\";\n}\n\n.bi-box-seam-fill::before {\n  content: \"\\f7d3\";\n}\n\n.bi-browser-chrome::before {\n  content: \"\\f7d4\";\n}\n\n.bi-browser-edge::before {\n  content: \"\\f7d5\";\n}\n\n.bi-browser-firefox::before {\n  content: \"\\f7d6\";\n}\n\n.bi-browser-safari::before {\n  content: \"\\f7d7\";\n}\n\n.bi-c-circle-fill::before {\n  content: \"\\f7da\";\n}\n\n.bi-c-circle::before {\n  content: \"\\f7db\";\n}\n\n.bi-c-square-fill::before {\n  content: \"\\f7dc\";\n}\n\n.bi-c-square::before {\n  content: \"\\f7dd\";\n}\n\n.bi-capsule-pill::before {\n  content: \"\\f7de\";\n}\n\n.bi-capsule::before {\n  content: \"\\f7df\";\n}\n\n.bi-car-front-fill::before {\n  content: \"\\f7e0\";\n}\n\n.bi-car-front::before {\n  content: \"\\f7e1\";\n}\n\n.bi-cassette-fill::before {\n  content: \"\\f7e2\";\n}\n\n.bi-cassette::before {\n  content: \"\\f7e3\";\n}\n\n.bi-cc-circle-fill::before {\n  content: \"\\f7e6\";\n}\n\n.bi-cc-circle::before {\n  content: \"\\f7e7\";\n}\n\n.bi-cc-square-fill::before {\n  content: \"\\f7e8\";\n}\n\n.bi-cc-square::before {\n  content: \"\\f7e9\";\n}\n\n.bi-cup-hot-fill::before {\n  content: \"\\f7ea\";\n}\n\n.bi-cup-hot::before {\n  content: \"\\f7eb\";\n}\n\n.bi-currency-rupee::before {\n  content: \"\\f7ec\";\n}\n\n.bi-dropbox::before {\n  content: \"\\f7ed\";\n}\n\n.bi-escape::before {\n  content: \"\\f7ee\";\n}\n\n.bi-fast-forward-btn-fill::before {\n  content: \"\\f7ef\";\n}\n\n.bi-fast-forward-btn::before {\n  content: \"\\f7f0\";\n}\n\n.bi-fast-forward-circle-fill::before {\n  content: \"\\f7f1\";\n}\n\n.bi-fast-forward-circle::before {\n  content: \"\\f7f2\";\n}\n\n.bi-fast-forward-fill::before {\n  content: \"\\f7f3\";\n}\n\n.bi-fast-forward::before {\n  content: \"\\f7f4\";\n}\n\n.bi-filetype-sql::before {\n  content: \"\\f7f5\";\n}\n\n.bi-fire::before {\n  content: \"\\f7f6\";\n}\n\n.bi-google-play::before {\n  content: \"\\f7f7\";\n}\n\n.bi-h-circle-fill::before {\n  content: \"\\f7fa\";\n}\n\n.bi-h-circle::before {\n  content: \"\\f7fb\";\n}\n\n.bi-h-square-fill::before {\n  content: \"\\f7fc\";\n}\n\n.bi-h-square::before {\n  content: \"\\f7fd\";\n}\n\n.bi-indent::before {\n  content: \"\\f7fe\";\n}\n\n.bi-lungs-fill::before {\n  content: \"\\f7ff\";\n}\n\n.bi-lungs::before {\n  content: \"\\f800\";\n}\n\n.bi-microsoft-teams::before {\n  content: \"\\f801\";\n}\n\n.bi-p-circle-fill::before {\n  content: \"\\f804\";\n}\n\n.bi-p-circle::before {\n  content: \"\\f805\";\n}\n\n.bi-p-square-fill::before {\n  content: \"\\f806\";\n}\n\n.bi-p-square::before {\n  content: \"\\f807\";\n}\n\n.bi-pass-fill::before {\n  content: \"\\f808\";\n}\n\n.bi-pass::before {\n  content: \"\\f809\";\n}\n\n.bi-prescription::before {\n  content: \"\\f80a\";\n}\n\n.bi-prescription2::before {\n  content: \"\\f80b\";\n}\n\n.bi-r-circle-fill::before {\n  content: \"\\f80e\";\n}\n\n.bi-r-circle::before {\n  content: \"\\f80f\";\n}\n\n.bi-r-square-fill::before {\n  content: \"\\f810\";\n}\n\n.bi-r-square::before {\n  content: \"\\f811\";\n}\n\n.bi-repeat-1::before {\n  content: \"\\f812\";\n}\n\n.bi-repeat::before {\n  content: \"\\f813\";\n}\n\n.bi-rewind-btn-fill::before {\n  content: \"\\f814\";\n}\n\n.bi-rewind-btn::before {\n  content: \"\\f815\";\n}\n\n.bi-rewind-circle-fill::before {\n  content: \"\\f816\";\n}\n\n.bi-rewind-circle::before {\n  content: \"\\f817\";\n}\n\n.bi-rewind-fill::before {\n  content: \"\\f818\";\n}\n\n.bi-rewind::before {\n  content: \"\\f819\";\n}\n\n.bi-train-freight-front-fill::before {\n  content: \"\\f81a\";\n}\n\n.bi-train-freight-front::before {\n  content: \"\\f81b\";\n}\n\n.bi-train-front-fill::before {\n  content: \"\\f81c\";\n}\n\n.bi-train-front::before {\n  content: \"\\f81d\";\n}\n\n.bi-train-lightrail-front-fill::before {\n  content: \"\\f81e\";\n}\n\n.bi-train-lightrail-front::before {\n  content: \"\\f81f\";\n}\n\n.bi-truck-front-fill::before {\n  content: \"\\f820\";\n}\n\n.bi-truck-front::before {\n  content: \"\\f821\";\n}\n\n.bi-ubuntu::before {\n  content: \"\\f822\";\n}\n\n.bi-unindent::before {\n  content: \"\\f823\";\n}\n\n.bi-unity::before {\n  content: \"\\f824\";\n}\n\n.bi-universal-access-circle::before {\n  content: \"\\f825\";\n}\n\n.bi-universal-access::before {\n  content: \"\\f826\";\n}\n\n.bi-virus::before {\n  content: \"\\f827\";\n}\n\n.bi-virus2::before {\n  content: \"\\f828\";\n}\n\n.bi-wechat::before {\n  content: \"\\f829\";\n}\n\n.bi-yelp::before {\n  content: \"\\f82a\";\n}\n\n.bi-sign-stop-fill::before {\n  content: \"\\f82b\";\n}\n\n.bi-sign-stop-lights-fill::before {\n  content: \"\\f82c\";\n}\n\n.bi-sign-stop-lights::before {\n  content: \"\\f82d\";\n}\n\n.bi-sign-stop::before {\n  content: \"\\f82e\";\n}\n\n.bi-sign-turn-left-fill::before {\n  content: \"\\f82f\";\n}\n\n.bi-sign-turn-left::before {\n  content: \"\\f830\";\n}\n\n.bi-sign-turn-right-fill::before {\n  content: \"\\f831\";\n}\n\n.bi-sign-turn-right::before {\n  content: \"\\f832\";\n}\n\n.bi-sign-turn-slight-left-fill::before {\n  content: \"\\f833\";\n}\n\n.bi-sign-turn-slight-left::before {\n  content: \"\\f834\";\n}\n\n.bi-sign-turn-slight-right-fill::before {\n  content: \"\\f835\";\n}\n\n.bi-sign-turn-slight-right::before {\n  content: \"\\f836\";\n}\n\n.bi-sign-yield-fill::before {\n  content: \"\\f837\";\n}\n\n.bi-sign-yield::before {\n  content: \"\\f838\";\n}\n\n.bi-ev-station-fill::before {\n  content: \"\\f839\";\n}\n\n.bi-ev-station::before {\n  content: \"\\f83a\";\n}\n\n.bi-fuel-pump-diesel-fill::before {\n  content: \"\\f83b\";\n}\n\n.bi-fuel-pump-diesel::before {\n  content: \"\\f83c\";\n}\n\n.bi-fuel-pump-fill::before {\n  content: \"\\f83d\";\n}\n\n.bi-fuel-pump::before {\n  content: \"\\f83e\";\n}\n\n.bi-0-circle-fill::before {\n  content: \"\\f83f\";\n}\n\n.bi-0-circle::before {\n  content: \"\\f840\";\n}\n\n.bi-0-square-fill::before {\n  content: \"\\f841\";\n}\n\n.bi-0-square::before {\n  content: \"\\f842\";\n}\n\n.bi-rocket-fill::before {\n  content: \"\\f843\";\n}\n\n.bi-rocket-takeoff-fill::before {\n  content: \"\\f844\";\n}\n\n.bi-rocket-takeoff::before {\n  content: \"\\f845\";\n}\n\n.bi-rocket::before {\n  content: \"\\f846\";\n}\n\n.bi-stripe::before {\n  content: \"\\f847\";\n}\n\n.bi-subscript::before {\n  content: \"\\f848\";\n}\n\n.bi-superscript::before {\n  content: \"\\f849\";\n}\n\n.bi-trello::before {\n  content: \"\\f84a\";\n}\n\n.bi-envelope-at-fill::before {\n  content: \"\\f84b\";\n}\n\n.bi-envelope-at::before {\n  content: \"\\f84c\";\n}\n\n.bi-regex::before {\n  content: \"\\f84d\";\n}\n\n.bi-text-wrap::before {\n  content: \"\\f84e\";\n}\n\n.bi-sign-dead-end-fill::before {\n  content: \"\\f84f\";\n}\n\n.bi-sign-dead-end::before {\n  content: \"\\f850\";\n}\n\n.bi-sign-do-not-enter-fill::before {\n  content: \"\\f851\";\n}\n\n.bi-sign-do-not-enter::before {\n  content: \"\\f852\";\n}\n\n.bi-sign-intersection-fill::before {\n  content: \"\\f853\";\n}\n\n.bi-sign-intersection-side-fill::before {\n  content: \"\\f854\";\n}\n\n.bi-sign-intersection-side::before {\n  content: \"\\f855\";\n}\n\n.bi-sign-intersection-t-fill::before {\n  content: \"\\f856\";\n}\n\n.bi-sign-intersection-t::before {\n  content: \"\\f857\";\n}\n\n.bi-sign-intersection-y-fill::before {\n  content: \"\\f858\";\n}\n\n.bi-sign-intersection-y::before {\n  content: \"\\f859\";\n}\n\n.bi-sign-intersection::before {\n  content: \"\\f85a\";\n}\n\n.bi-sign-merge-left-fill::before {\n  content: \"\\f85b\";\n}\n\n.bi-sign-merge-left::before {\n  content: \"\\f85c\";\n}\n\n.bi-sign-merge-right-fill::before {\n  content: \"\\f85d\";\n}\n\n.bi-sign-merge-right::before {\n  content: \"\\f85e\";\n}\n\n.bi-sign-no-left-turn-fill::before {\n  content: \"\\f85f\";\n}\n\n.bi-sign-no-left-turn::before {\n  content: \"\\f860\";\n}\n\n.bi-sign-no-parking-fill::before {\n  content: \"\\f861\";\n}\n\n.bi-sign-no-parking::before {\n  content: \"\\f862\";\n}\n\n.bi-sign-no-right-turn-fill::before {\n  content: \"\\f863\";\n}\n\n.bi-sign-no-right-turn::before {\n  content: \"\\f864\";\n}\n\n.bi-sign-railroad-fill::before {\n  content: \"\\f865\";\n}\n\n.bi-sign-railroad::before {\n  content: \"\\f866\";\n}\n\n.bi-building-add::before {\n  content: \"\\f867\";\n}\n\n.bi-building-check::before {\n  content: \"\\f868\";\n}\n\n.bi-building-dash::before {\n  content: \"\\f869\";\n}\n\n.bi-building-down::before {\n  content: \"\\f86a\";\n}\n\n.bi-building-exclamation::before {\n  content: \"\\f86b\";\n}\n\n.bi-building-fill-add::before {\n  content: \"\\f86c\";\n}\n\n.bi-building-fill-check::before {\n  content: \"\\f86d\";\n}\n\n.bi-building-fill-dash::before {\n  content: \"\\f86e\";\n}\n\n.bi-building-fill-down::before {\n  content: \"\\f86f\";\n}\n\n.bi-building-fill-exclamation::before {\n  content: \"\\f870\";\n}\n\n.bi-building-fill-gear::before {\n  content: \"\\f871\";\n}\n\n.bi-building-fill-lock::before {\n  content: \"\\f872\";\n}\n\n.bi-building-fill-slash::before {\n  content: \"\\f873\";\n}\n\n.bi-building-fill-up::before {\n  content: \"\\f874\";\n}\n\n.bi-building-fill-x::before {\n  content: \"\\f875\";\n}\n\n.bi-building-fill::before {\n  content: \"\\f876\";\n}\n\n.bi-building-gear::before {\n  content: \"\\f877\";\n}\n\n.bi-building-lock::before {\n  content: \"\\f878\";\n}\n\n.bi-building-slash::before {\n  content: \"\\f879\";\n}\n\n.bi-building-up::before {\n  content: \"\\f87a\";\n}\n\n.bi-building-x::before {\n  content: \"\\f87b\";\n}\n\n.bi-buildings-fill::before {\n  content: \"\\f87c\";\n}\n\n.bi-buildings::before {\n  content: \"\\f87d\";\n}\n\n.bi-bus-front-fill::before {\n  content: \"\\f87e\";\n}\n\n.bi-bus-front::before {\n  content: \"\\f87f\";\n}\n\n.bi-ev-front-fill::before {\n  content: \"\\f880\";\n}\n\n.bi-ev-front::before {\n  content: \"\\f881\";\n}\n\n.bi-globe-americas::before {\n  content: \"\\f882\";\n}\n\n.bi-globe-asia-australia::before {\n  content: \"\\f883\";\n}\n\n.bi-globe-central-south-asia::before {\n  content: \"\\f884\";\n}\n\n.bi-globe-europe-africa::before {\n  content: \"\\f885\";\n}\n\n.bi-house-add-fill::before {\n  content: \"\\f886\";\n}\n\n.bi-house-add::before {\n  content: \"\\f887\";\n}\n\n.bi-house-check-fill::before {\n  content: \"\\f888\";\n}\n\n.bi-house-check::before {\n  content: \"\\f889\";\n}\n\n.bi-house-dash-fill::before {\n  content: \"\\f88a\";\n}\n\n.bi-house-dash::before {\n  content: \"\\f88b\";\n}\n\n.bi-house-down-fill::before {\n  content: \"\\f88c\";\n}\n\n.bi-house-down::before {\n  content: \"\\f88d\";\n}\n\n.bi-house-exclamation-fill::before {\n  content: \"\\f88e\";\n}\n\n.bi-house-exclamation::before {\n  content: \"\\f88f\";\n}\n\n.bi-house-gear-fill::before {\n  content: \"\\f890\";\n}\n\n.bi-house-gear::before {\n  content: \"\\f891\";\n}\n\n.bi-house-lock-fill::before {\n  content: \"\\f892\";\n}\n\n.bi-house-lock::before {\n  content: \"\\f893\";\n}\n\n.bi-house-slash-fill::before {\n  content: \"\\f894\";\n}\n\n.bi-house-slash::before {\n  content: \"\\f895\";\n}\n\n.bi-house-up-fill::before {\n  content: \"\\f896\";\n}\n\n.bi-house-up::before {\n  content: \"\\f897\";\n}\n\n.bi-house-x-fill::before {\n  content: \"\\f898\";\n}\n\n.bi-house-x::before {\n  content: \"\\f899\";\n}\n\n.bi-person-add::before {\n  content: \"\\f89a\";\n}\n\n.bi-person-down::before {\n  content: \"\\f89b\";\n}\n\n.bi-person-exclamation::before {\n  content: \"\\f89c\";\n}\n\n.bi-person-fill-add::before {\n  content: \"\\f89d\";\n}\n\n.bi-person-fill-check::before {\n  content: \"\\f89e\";\n}\n\n.bi-person-fill-dash::before {\n  content: \"\\f89f\";\n}\n\n.bi-person-fill-down::before {\n  content: \"\\f8a0\";\n}\n\n.bi-person-fill-exclamation::before {\n  content: \"\\f8a1\";\n}\n\n.bi-person-fill-gear::before {\n  content: \"\\f8a2\";\n}\n\n.bi-person-fill-lock::before {\n  content: \"\\f8a3\";\n}\n\n.bi-person-fill-slash::before {\n  content: \"\\f8a4\";\n}\n\n.bi-person-fill-up::before {\n  content: \"\\f8a5\";\n}\n\n.bi-person-fill-x::before {\n  content: \"\\f8a6\";\n}\n\n.bi-person-gear::before {\n  content: \"\\f8a7\";\n}\n\n.bi-person-lock::before {\n  content: \"\\f8a8\";\n}\n\n.bi-person-slash::before {\n  content: \"\\f8a9\";\n}\n\n.bi-person-up::before {\n  content: \"\\f8aa\";\n}\n\n.bi-scooter::before {\n  content: \"\\f8ab\";\n}\n\n.bi-taxi-front-fill::before {\n  content: \"\\f8ac\";\n}\n\n.bi-taxi-front::before {\n  content: \"\\f8ad\";\n}\n\n.bi-amd::before {\n  content: \"\\f8ae\";\n}\n\n.bi-database-add::before {\n  content: \"\\f8af\";\n}\n\n.bi-database-check::before {\n  content: \"\\f8b0\";\n}\n\n.bi-database-dash::before {\n  content: \"\\f8b1\";\n}\n\n.bi-database-down::before {\n  content: \"\\f8b2\";\n}\n\n.bi-database-exclamation::before {\n  content: \"\\f8b3\";\n}\n\n.bi-database-fill-add::before {\n  content: \"\\f8b4\";\n}\n\n.bi-database-fill-check::before {\n  content: \"\\f8b5\";\n}\n\n.bi-database-fill-dash::before {\n  content: \"\\f8b6\";\n}\n\n.bi-database-fill-down::before {\n  content: \"\\f8b7\";\n}\n\n.bi-database-fill-exclamation::before {\n  content: \"\\f8b8\";\n}\n\n.bi-database-fill-gear::before {\n  content: \"\\f8b9\";\n}\n\n.bi-database-fill-lock::before {\n  content: \"\\f8ba\";\n}\n\n.bi-database-fill-slash::before {\n  content: \"\\f8bb\";\n}\n\n.bi-database-fill-up::before {\n  content: \"\\f8bc\";\n}\n\n.bi-database-fill-x::before {\n  content: \"\\f8bd\";\n}\n\n.bi-database-fill::before {\n  content: \"\\f8be\";\n}\n\n.bi-database-gear::before {\n  content: \"\\f8bf\";\n}\n\n.bi-database-lock::before {\n  content: \"\\f8c0\";\n}\n\n.bi-database-slash::before {\n  content: \"\\f8c1\";\n}\n\n.bi-database-up::before {\n  content: \"\\f8c2\";\n}\n\n.bi-database-x::before {\n  content: \"\\f8c3\";\n}\n\n.bi-database::before {\n  content: \"\\f8c4\";\n}\n\n.bi-houses-fill::before {\n  content: \"\\f8c5\";\n}\n\n.bi-houses::before {\n  content: \"\\f8c6\";\n}\n\n.bi-nvidia::before {\n  content: \"\\f8c7\";\n}\n\n.bi-person-vcard-fill::before {\n  content: \"\\f8c8\";\n}\n\n.bi-person-vcard::before {\n  content: \"\\f8c9\";\n}\n\n.bi-sina-weibo::before {\n  content: \"\\f8ca\";\n}\n\n.bi-tencent-qq::before {\n  content: \"\\f8cb\";\n}\n\n.bi-wikipedia::before {\n  content: \"\\f8cc\";\n}\n\n.bi-alphabet-uppercase::before {\n  content: \"\\f2a5\";\n}\n\n.bi-alphabet::before {\n  content: \"\\f68a\";\n}\n\n.bi-amazon::before {\n  content: \"\\f68d\";\n}\n\n.bi-arrows-collapse-vertical::before {\n  content: \"\\f690\";\n}\n\n.bi-arrows-expand-vertical::before {\n  content: \"\\f695\";\n}\n\n.bi-arrows-vertical::before {\n  content: \"\\f698\";\n}\n\n.bi-arrows::before {\n  content: \"\\f6a2\";\n}\n\n.bi-ban-fill::before {\n  content: \"\\f6a3\";\n}\n\n.bi-ban::before {\n  content: \"\\f6b6\";\n}\n\n.bi-bing::before {\n  content: \"\\f6c2\";\n}\n\n.bi-cake::before {\n  content: \"\\f6e0\";\n}\n\n.bi-cake2::before {\n  content: \"\\f6ed\";\n}\n\n.bi-cookie::before {\n  content: \"\\f6ee\";\n}\n\n.bi-copy::before {\n  content: \"\\f759\";\n}\n\n.bi-crosshair::before {\n  content: \"\\f769\";\n}\n\n.bi-crosshair2::before {\n  content: \"\\f794\";\n}\n\n.bi-emoji-astonished-fill::before {\n  content: \"\\f795\";\n}\n\n.bi-emoji-astonished::before {\n  content: \"\\f79a\";\n}\n\n.bi-emoji-grimace-fill::before {\n  content: \"\\f79b\";\n}\n\n.bi-emoji-grimace::before {\n  content: \"\\f7a0\";\n}\n\n.bi-emoji-grin-fill::before {\n  content: \"\\f7a1\";\n}\n\n.bi-emoji-grin::before {\n  content: \"\\f7a6\";\n}\n\n.bi-emoji-surprise-fill::before {\n  content: \"\\f7a7\";\n}\n\n.bi-emoji-surprise::before {\n  content: \"\\f7ac\";\n}\n\n.bi-emoji-tear-fill::before {\n  content: \"\\f7ad\";\n}\n\n.bi-emoji-tear::before {\n  content: \"\\f7b2\";\n}\n\n.bi-envelope-arrow-down-fill::before {\n  content: \"\\f7b3\";\n}\n\n.bi-envelope-arrow-down::before {\n  content: \"\\f7b8\";\n}\n\n.bi-envelope-arrow-up-fill::before {\n  content: \"\\f7b9\";\n}\n\n.bi-envelope-arrow-up::before {\n  content: \"\\f7be\";\n}\n\n.bi-feather::before {\n  content: \"\\f7bf\";\n}\n\n.bi-feather2::before {\n  content: \"\\f7c4\";\n}\n\n.bi-floppy-fill::before {\n  content: \"\\f7c5\";\n}\n\n.bi-floppy::before {\n  content: \"\\f7d8\";\n}\n\n.bi-floppy2-fill::before {\n  content: \"\\f7d9\";\n}\n\n.bi-floppy2::before {\n  content: \"\\f7e4\";\n}\n\n.bi-gitlab::before {\n  content: \"\\f7e5\";\n}\n\n.bi-highlighter::before {\n  content: \"\\f7f8\";\n}\n\n.bi-marker-tip::before {\n  content: \"\\f802\";\n}\n\n.bi-nvme-fill::before {\n  content: \"\\f803\";\n}\n\n.bi-nvme::before {\n  content: \"\\f80c\";\n}\n\n.bi-opencollective::before {\n  content: \"\\f80d\";\n}\n\n.bi-pci-card-network::before {\n  content: \"\\f8cd\";\n}\n\n.bi-pci-card-sound::before {\n  content: \"\\f8ce\";\n}\n\n.bi-radar::before {\n  content: \"\\f8cf\";\n}\n\n.bi-send-arrow-down-fill::before {\n  content: \"\\f8d0\";\n}\n\n.bi-send-arrow-down::before {\n  content: \"\\f8d1\";\n}\n\n.bi-send-arrow-up-fill::before {\n  content: \"\\f8d2\";\n}\n\n.bi-send-arrow-up::before {\n  content: \"\\f8d3\";\n}\n\n.bi-sim-slash-fill::before {\n  content: \"\\f8d4\";\n}\n\n.bi-sim-slash::before {\n  content: \"\\f8d5\";\n}\n\n.bi-sourceforge::before {\n  content: \"\\f8d6\";\n}\n\n.bi-substack::before {\n  content: \"\\f8d7\";\n}\n\n.bi-threads-fill::before {\n  content: \"\\f8d8\";\n}\n\n.bi-threads::before {\n  content: \"\\f8d9\";\n}\n\n.bi-transparency::before {\n  content: \"\\f8da\";\n}\n\n.bi-twitter-x::before {\n  content: \"\\f8db\";\n}\n\n.bi-type-h4::before {\n  content: \"\\f8dc\";\n}\n\n.bi-type-h5::before {\n  content: \"\\f8dd\";\n}\n\n.bi-type-h6::before {\n  content: \"\\f8de\";\n}\n\n.bi-backpack-fill::before {\n  content: \"\\f8df\";\n}\n\n.bi-backpack::before {\n  content: \"\\f8e0\";\n}\n\n.bi-backpack2-fill::before {\n  content: \"\\f8e1\";\n}\n\n.bi-backpack2::before {\n  content: \"\\f8e2\";\n}\n\n.bi-backpack3-fill::before {\n  content: \"\\f8e3\";\n}\n\n.bi-backpack3::before {\n  content: \"\\f8e4\";\n}\n\n.bi-backpack4-fill::before {\n  content: \"\\f8e5\";\n}\n\n.bi-backpack4::before {\n  content: \"\\f8e6\";\n}\n\n.bi-brilliance::before {\n  content: \"\\f8e7\";\n}\n\n.bi-cake-fill::before {\n  content: \"\\f8e8\";\n}\n\n.bi-cake2-fill::before {\n  content: \"\\f8e9\";\n}\n\n.bi-duffle-fill::before {\n  content: \"\\f8ea\";\n}\n\n.bi-duffle::before {\n  content: \"\\f8eb\";\n}\n\n.bi-exposure::before {\n  content: \"\\f8ec\";\n}\n\n.bi-gender-neuter::before {\n  content: \"\\f8ed\";\n}\n\n.bi-highlights::before {\n  content: \"\\f8ee\";\n}\n\n.bi-luggage-fill::before {\n  content: \"\\f8ef\";\n}\n\n.bi-luggage::before {\n  content: \"\\f8f0\";\n}\n\n.bi-mailbox-flag::before {\n  content: \"\\f8f1\";\n}\n\n.bi-mailbox2-flag::before {\n  content: \"\\f8f2\";\n}\n\n.bi-noise-reduction::before {\n  content: \"\\f8f3\";\n}\n\n.bi-passport-fill::before {\n  content: \"\\f8f4\";\n}\n\n.bi-passport::before {\n  content: \"\\f8f5\";\n}\n\n.bi-person-arms-up::before {\n  content: \"\\f8f6\";\n}\n\n.bi-person-raised-hand::before {\n  content: \"\\f8f7\";\n}\n\n.bi-person-standing-dress::before {\n  content: \"\\f8f8\";\n}\n\n.bi-person-standing::before {\n  content: \"\\f8f9\";\n}\n\n.bi-person-walking::before {\n  content: \"\\f8fa\";\n}\n\n.bi-person-wheelchair::before {\n  content: \"\\f8fb\";\n}\n\n.bi-shadows::before {\n  content: \"\\f8fc\";\n}\n\n.bi-suitcase-fill::before {\n  content: \"\\f8fd\";\n}\n\n.bi-suitcase-lg-fill::before {\n  content: \"\\f8fe\";\n}\n\n.bi-suitcase-lg::before {\n  content: \"\\f8ff\";\n}\n\n.bi-suitcase::before {\n  content: \"豈\";\n}\n\n.bi-suitcase2-fill::before {\n  content: \"更\";\n}\n\n.bi-suitcase2::before {\n  content: \"車\";\n}\n\n.bi-vignette::before {\n  content: \"賈\";\n}\n\n.sidebarArea {\n  flex-shrink: 0;\n  width: 310px;\n  background-color: #fff;\n  filter: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));\n  position: relative;\n  z-index: 1;\n}\n.sidebarArea .sidenav-bg:hover {\n  background-color: #f8f9fa;\n  border-radius: 3rem;\n}\n.sidebarArea .sidenav-bg:hover a {\n  color: text-primary !important;\n}\n\n@media (max-width: 991.98px) {\n  .sidebarArea {\n    position: fixed;\n    height: 100%;\n    overflow: auto;\n    z-index: 1;\n    margin-left: -320px;\n    transition: 0.2s ease-in;\n  }\n  .sidebarArea.showSidebar {\n    margin-left: 0px;\n  }\n}\n.pageWrapper {\n  min-height: 100vh;\n}\n\n.contentArea {\n  flex-grow: 1;\n}\n\n.wrapper {\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.card {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);\n  margin-bottom: 30px;\n}\n\n.circle-box {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border-radius: 100%;\n}\n.circle-box.lg-box {\n  width: 60px;\n  height: 60px;\n  font-size: 21px;\n  line-height: 60px;\n}\n\n.button-group .btn {\n  margin: 3px;\n}\n\n.table > :not(:first-child) {\n  border-top: 2px solid;\n}\n\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*******************/\r\n// Theme Fonts\r\n/********************/\r\n//@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: 'Poppins';\r\n  src: local('Poppins'), url(\"../fonts/Poppins-Regular.ttf\") format('truetype');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Poppins-SemiBold';\r\n  src: local('Poppins'), url(\"../fonts/Poppins-SemiBold.ttf\") format('truetype');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Poppins-Medium';\r\n  src: local('Poppins'), url(\"../fonts/Poppins-Medium.ttf\") format('truetype');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Poppins-Bold';\r\n  src: local('Poppins'), url(\"../fonts/Poppins-Bold.ttf\") format('truetype');\r\n}\r\n\r\n$iboost-font-semibold: \"Poppins-SemiBold\";\r\n$font-family-sans-serif: \"Poppins\";\r\n$poppins-400: \"Poppins-Regular\";\r\n$poppins-500: \"Poppins-Medium\";\r\n$poppins-600: \"Poppins-SemiBold\";\r\n$poppins-700: \"Poppins-Bold\";\r\n\r\n\r\n/*******************/\r\n// Theme Colors\r\n/********************/\r\n$primary: #2962ff;\r\n$info: #3699ff;\r\n$danger: #f64e60;\r\n$success: #0bb7af;\r\n$warning: #ee9d01;\r\n$dark: #343a40;\r\n$light: #eaf2fb;\r\n$secondary: #35363b;\r\n\r\n$theme-colors: (\r\n  \"primary\": $primary,\r\n  \"secondary\": $secondary,\r\n  \"success\": $success,\r\n  \"info\": $info,\r\n  \"warning\": $warning,\r\n  \"danger\": $danger,\r\n  \"light\": $light,\r\n  \"dark\": $dark,\r\n  \"light-primary\": #d6e4f3,\r\n  \"light-success\": #d5f3f2,\r\n  \"light-info\": #d3edfa,\r\n  \"light-warning\": #f8ecdc,\r\n  \"light-danger\": #f8dddd,\r\n);\r\n// scss-docs-start gray-color-variables\r\n$bg_green: #00929f !default;\r\n$white: #fff !default;\r\n$gray-100: #00929f !default;\r\n$gray-200: #eef5f9 !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #757e85 !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #1e2a35 !default;\r\n$black: #000 !default;\r\n\r\n/*******************/\r\n// Theme Text Contrast\r\n/********************/\r\n$min-contrast-ratio: 2;\r\n\r\n\r\n/*******************/\r\n// Theme body bg & text color\r\n/********************/\r\n$body-bg: $gray-200 !default;\r\n$body-color: $gray-900 !default;\r\n\r\n\r\n/*******************/\r\n// Theme common variable\r\n/********************/\r\n$border-radius: 0.3rem !default;\r\n$box-shadow: 0 0.5rem 1rem rgba($black, 0.05);\r\n$headings-font-weight: 600 !default;\r\n\r\n$card-border-width: 0 !default;\r\n$card-box-shadow: $box-shadow !default;\r\n$grid-gutter-width: 1.85rem !default;\r\n\r\n$input-bg: $white !default;\r\n$card-bg: $white;\r\n$input-bg: $white !default;\r\n$list-group-bg: $white !default;\r\n$table-bg: $white !default;\r\n$dropdown-bg: $white !default;\r\n\r\n/*******************/\r\n// Theme btn\r\n/********************/\r\n$btn-focus-width: 0px;\r\n\r\n/*******************/\r\n// Theme sidebar width\r\n/********************/\r\n$sidebarWidth: 320px;\r\n$sidebarColor: $bg_green;\r\n\r\n// ss-style\r\n\r\n\r\n$textgreen: #3c7546;\r\n$green: #3c7546;\r\n$light_green: #cce9ec;\r\n$bg_green_100: #e5f5ec;\r\n$bg_gray_700: #e5f5ec;\r\n$text_pending: #7a8892;\r\n$text_pending_back: #ebecee;\r\n$accept_back: #d9eff1;\r\n$reject_back: #e0e4e7;\r\n$reject_color: #677782;\r\n\r\n$dark_blue: #354959;\r\n$button_gray: #b8bfc5;\r\n$text_gray: #939ea8;\r\n$text_gray_700: #333333;\r\n$text_gray_500: #354959;\r\n$bg_gradiant: linear-gradient(82deg, #335539 0%,#3c7546  100%);\r\n$bg_gradiant_bg: linear-gradient(82deg, #00919f 0%, #0fb6c5 100%);\r\n\r\n$bg_gradiant_billing: linear-gradient(92deg, #354959 0%, #335539 100%, #3c7546 100%);\r\n$iboost-sidebar-width: 310px;\r\n$iboost-white: #ffffff;\r\n$iboost-border-radius: 3rem;\r\n$iboost-body: #f2f3f7;\r\n$iboost-box-shadow: drop-shadow(11.954px 1.046px 14.5px rgba(53, 73, 89, 0.07));\r\n$radius_15: 15px;\r\n$text_sm: 13px;\r\n\r\n.strong-text {\r\n  position: relative;\r\n  bottom: 10px;\r\n}\r\n\r\n.blue-image img {\r\n  filter: invert(44%) sepia(17%) saturate(226%) hue-rotate(166deg) brightness(99%) contrast(94%);\r\n}\r\n\r\n.white-image img {\r\n  filter: invert(100%) sepia(0%) saturate(3524%) hue-rotate(261deg) brightness(122%) contrast(109%);\r\n}\r\n\r\n.file-icons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.file-icon {\r\n  width: 20px;\r\n  margin: 5px;\r\n}\r\n\r\n/* Phone number */\r\n.register_phone .PhoneInputInput {\r\n  height: 47px;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(0, 146, 159, 0.1490196078);\r\n}\r\n\r\n\r\n.password-eye {\r\n  position: relative !important;\r\n}\r\n\r\n.password-eye .bi.bi-eye,\r\n.password-eye .bi.bi-eye-slash {\r\n  position: absolute !important;\r\n  right: 10px !important;\r\n  z-index: 1 !important;\r\n  bottom: 10px !important;\r\n}\r\n\r\n.to-address {\r\n  max-width: 100px;\r\n  overflow: auto;\r\n}\r\n.to-address::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n/* Track */\r\n.to-address::-webkit-scrollbar-track {\r\n\r\n  // box-shadow: inset 0 0 5px grey; \r\n  border-radius: 10px;\r\n}\r\n \r\n/* Handle */\r\n.to-address::-webkit-scrollbar-thumb {\r\n  // background: black; \r\n  border-radius: 10px;\r\n}\r\n\r\n/* Handle on hover */\r\n// ::-webkit-scrollbar-thumb:hover {\r\n//   background: #b30000; \r\n// }\r\n//  transaction\r\n.transaction_container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n}\r\n\r\n.trans_history {\r\n  padding: 15px;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  border-width: 1px;\r\n  border-color: #739cab;\r\n  border-radius: 10px;\r\n  background-color: #e5f1f6;\r\n  margin-top: 30px;\r\n}\r\n\r\n.trans_history2 {\r\n  padding: 15px;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  border-width: 1px;\r\n  border-color: #f3d3c2;\r\n  border-radius: 10px;\r\n\r\n  background-color: #f7e9db;\r\n  margin-top: 30px;\r\n}\r\n\r\n.trans_history3 {\r\n  padding: 15px;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  border-width: 1px;\r\n  border-color: #ca8d98;\r\n  border-radius: 10px;\r\n  background-color: #f5dbdc;\r\n  margin-top: 30px;\r\n}\r\n\r\n.sell {\r\n  color: #cc8487;\r\n}\r\n\r\n.buy {\r\n  color: #83a189;\r\n}\r\n\r\n/* Searchable Dropdown*/\r\n.dropdown {\r\n  position: relative;\r\n  color: #333;\r\n  cursor: default;\r\n}\r\n\r\n.dropdown .arrow {\r\n  border-color: #999 transparent transparent;\r\n  border-style: solid;\r\n  border-width: 5px 5px 0;\r\n  content: \" \";\r\n  display: block;\r\n  height: 0;\r\n  margin-top: 0.3rem;\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 14px;\r\n  width: 0;\r\n}\r\n\r\n.dropdown .arrow.open {\r\n  border-color: transparent transparent #999;\r\n  border-width: 0 5px 5px;\r\n}\r\n\r\n.dropdown .selected-value input {\r\n  line-height: 1.5;\r\n  font-size: 1rem;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 2px;\r\n  box-sizing: border-box;\r\n  cursor: default;\r\n  outline: none;\r\n  padding: 8px 52px 8px 10px;\r\n  transition: all 200ms ease;\r\n  width: 100%;\r\n}\r\n\r\n.dropdown .options {\r\n  display: none;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\r\n  box-sizing: border-box;\r\n  margin-top: -1px;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  position: absolute;\r\n  top: 100%;\r\n  width: 100%;\r\n  z-index: 1000;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.dropdown .options.open {\r\n  display: block;\r\n}\r\n\r\n.dropdown .option {\r\n  box-sizing: border-box;\r\n  color: rgba(51, 51, 51, 0.8);\r\n  cursor: pointer;\r\n  display: block;\r\n  padding: 8px 10px;\r\n}\r\n\r\n.dropdown .option.selected,\r\n.dropdown .option:hover {\r\n  background-color: #f2f9fc;\r\n  color: #333;\r\n}\r\n\r\n.app-border {\r\n  border: 1px solid#00929f\r\n}\r\n\r\n.payment-method {\r\n  background-color: rgb(242, 237, 255);\r\n  padding: 60px;\r\n  cursor: pointer;\r\n}\r\n\r\n.table-responsive {\r\n  overflow-y: hidden;\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"]:checked {\r\n  background-color: $bg_green !important;\r\n  border-color: $bg_green !important;\r\n}\r\n\r\n.chat_box_animation {\r\n  transition: 0.2s;\r\n}\r\n\r\n.otp-animation {\r\n  transition: 0.8s;\r\n}\r\n\r\n.width_100 {\r\n  width: 100% !important\r\n}\r\n\r\n.dashboard_box_biling {\r\n  background-image: $bg_gradiant_billing;\r\n}\r\n\r\n.bg_gradiant {\r\n  background-image:$bg_gradiant;\r\n}\r\n\r\n.border-r {\r\n  border-right: 1.8px solid #ccc;\r\n}\r\n\r\n.border-l {\r\n  border-left: 1.8px solid #ccc;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.box_shadow {\r\n  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\r\n}\r\n\r\n.poppins-400 {\r\n\r\n  font-family: 'Poppins-Regular';\r\n}\r\n\r\n.poppins-500 {\r\n  font-family: 'Poppins-Medium';\r\n}\r\n\r\n.poppins-600 {\r\n  font-family: 'Poppins-SemiBold';\r\n}\r\n\r\n.poppins-700 {\r\n  font-family: 'Poppins-Bold';\r\n}\r\n\r\n.text_sm {\r\n  font-size: 13px;\r\n}\r\n\r\n.text_xs {\r\n  font-size: 12px;\r\n}\r\n\r\n.text_15 {\r\n  font-size: 15px;\r\n  line-height: 28px;\r\n}\r\n\r\n.text_14 {\r\n  font-size: 14px;\r\n}\r\n\r\n.text_18 {\r\n  font-size: 18px;\r\n}\r\n\r\n.text_base {\r\n  font-size: 16px;\r\n}\r\n\r\n.radius_15 {\r\n  border-radius: 15px;\r\n}\r\n\r\n.textgreen {\r\n  color: black;\r\n}\r\n\r\n.text-pending {\r\n  color: $text_pending;\r\n}\r\n\r\n.text-pending-back {\r\n  background-color: $text_pending_back;\r\n}\r\n\r\n.online-bubble {\r\n  background-color: #00ebbd;\r\n}\r\n\r\n.idle-bubble {\r\n  background-color: #ffa200;\r\n}\r\n\r\n.idle-text {\r\n  color: #ffa200\r\n}\r\n\r\n.offline-bubble {\r\n  background-color: #b9b9b9;\r\n}\r\n\r\n.offline-text {\r\n  color: #b9b9b9;\r\n}\r\n\r\n.light_green {\r\n  color: $light_green;\r\n}\r\n\r\n.dark_blue {\r\n  color: $dark_blue;\r\n}\r\n\r\n.text_gray {\r\n  color: $text_gray;\r\n}\r\n\r\n.text_gray_700 {\r\n  color: $text_gray_700;\r\n}\r\n\r\n.text_gray_500 {\r\n  color: $text_gray_500;\r\n  opacity: 0.800;\r\n}\r\n\r\n.text_gray_light {\r\n  color: #eaecee;\r\n}\r\n\r\n.bg_light_green {\r\n  background-color: $light_green;\r\n}\r\n\r\n.bg_light_green_500 {\r\n  background-color: #f0f9f9;\r\n}\r\n\r\n.bg_green_table {\r\n  background-color: $bg_green_100;\r\n}\r\n\r\n.bg_green {\r\n  background-color: $bg_green;\r\n}\r\n\r\n.bg_green_500 {\r\n  background-color: #008b89;\r\n}\r\n\r\n.bg_dark_blue {\r\n  background-color: $dark_blue;\r\n}\r\n\r\n.bg_gray {\r\n  background-color: $text_gray;\r\n}\r\n\r\n.bg_gray_500 {\r\n  background-color: #f2f3f7;\r\n}\r\n\r\n.bg_gray_700 {\r\n  background-color: $bg_gray_700;\r\n}\r\n\r\n.bg_gray_light {\r\n  background-color: #eaecee;\r\n}\r\n\r\n.nav_green {\r\n  background-color: $bg_green !important;\r\n  border-color: $bg_green !important;\r\n}\r\n\r\n.border-green {\r\n  border: 1px solid $green !important;\r\n}\r\n\r\n.table-responsive {\r\n  border-radius: 16px;\r\n}\r\n\r\n.pl-0 {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.pr-0 {\r\n  padding-right: 0 !important;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n}\r\n\r\nbody {\r\n  background-color: $iboost-body !important;\r\n}\r\n\r\n.navbar-dark {\r\n  background-color: $iboost-white;\r\n  // filter: $iboost-box-shadow;\r\n}\r\n\r\n.navbar-collapse {\r\n  justify-content: end;\r\n}\r\n\r\n/*Clear chat*/\r\n.drop_chat {\r\n  top: 60px !important;\r\n  right: 15px !important;\r\n}\r\n\r\n.drop_chat:after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n  background-color: #fff;\r\n  width: 10px;\r\n  height: 9px;\r\n  position: absolute;\r\n  right: 19px;\r\n  top: -8px;\r\n}\r\n\r\n.chat_more:after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n  background-color: #fff;\r\n  width: 10px;\r\n  height: 9px;\r\n  position: absolute;\r\n  right: 19px;\r\n  top: -8px;\r\n}\r\n\r\n.react-time-picker__wrapper {\r\n  border: none !important;\r\n}\r\n\r\n\r\n// .dropdown button {\r\n//   display: flex;\r\n//   gap: 10px;\r\n//   padding: 1rem 0;\r\n//   align-items: center;\r\n// }\r\n.admin_name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.billing_sec {\r\n  height: 240px;\r\n  background-color: $iboost-white;\r\n  filter: $iboost-box-shadow;\r\n  border-radius: $radius_15;\r\n  padding: 15px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  justify-content: space-evenly;\r\n\r\n}\r\n\r\n.billing_sec_top {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.billing_sec .billing_sec_top p {\r\n  margin: 0;\r\n  color: $dark_blue;\r\n}\r\n\r\n.billing_sec strong {\r\n  font-size: 40px;\r\n  color: $dark_blue;\r\n  font-family: $iboost-font-semibold;\r\n  font-weight: 100;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.billing_sec strong span {\r\n  font-size: 14px;\r\n  color: $green;\r\n  font-family: $font-family-sans-serif;\r\n  background-color: $light_green;\r\n  padding: 3px 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.billing_sec p {\r\n  color: $dark_blue;\r\n  font-size: 13px;\r\n  line-height: 17px;\r\n  margin: 10px 0;\r\n}\r\n\r\n.billing_sec a {\r\n  text-align: center;\r\n  text-decoration: unset;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n  color: $green;\r\n  background-color: $light_green;\r\n  padding: 5px;\r\n}\r\n\r\n.billing_sec a svg {\r\n  margin-top: -3px;\r\n}\r\n\r\n.recentappoint_part {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 5px 14px;\r\n}\r\n\r\n.recentappoint_part h4 {\r\n  margin: 0;\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 19px;\r\n  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));\r\n  background-color: $green;\r\n  display: block;\r\n  color: $iboost-white;\r\n  text-align: center;\r\n  line-height: 38px;\r\n}\r\n\r\n.billing_sec .recentappoint_name strong {\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  color: $dark_blue;\r\n}\r\n\r\n.billing_sec .recentappoint_name p {\r\n  margin: 0;\r\n  opacity: 0.502;\r\n  font-size: 12px;\r\n}\r\n\r\n.recentappoint_part span {\r\n  font-size: 12px;\r\n  color: $green;\r\n  font-family: \"Poppins\";\r\n  background-color: $light_green;\r\n  padding: 3px 5px;\r\n  border-radius: 5px;\r\n  font-weight: 600;\r\n}\r\n\r\n.billing_sec .recentappoint_sec p {\r\n  margin: 0;\r\n  font-size: 15px;\r\n}\r\n\r\n.billing_sec.two {\r\n  justify-content: unset;\r\n  padding: 0;\r\n}\r\n\r\n.recentappoint_sec {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 15px;\r\n  margin-bottom: 10px;\r\n  border-bottom: 2px solid #eaecee;\r\n}\r\n\r\n.billing_sec .recentappoint_sec a {\r\n  padding: 0;\r\n  background-color: unset;\r\n}\r\n\r\n.recentappoint_name.mes {\r\n  width: 70%;\r\n}\r\n\r\n.douctorlist_sec {\r\n  filter: $iboost-box-shadow;\r\n  background-color: $iboost-white;\r\n  border-radius: $radius_15;\r\n  padding: 30px 30px 5px;\r\n}\r\n\r\n.douctorlist_head h4 {\r\n  margin: 0;\r\n  color: $dark_blue;\r\n  font-size: 20px;\r\n  font-family: $iboost-font-semibold;\r\n}\r\n\r\n.douctorlist_head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1.5em;\r\n}\r\n\r\n.douctorlist_part span img {\r\n  width: 58px;\r\n  height: 50px;\r\n  object-fit: cover;\r\n  border-radius: 29px;\r\n}\r\n\r\n.douctorlist_name p {\r\n  margin: 0;\r\n}\r\n\r\n.douctorlist_part span {\r\n  width: 15%;\r\n  display: inline-block;\r\n}\r\n\r\n.douctorlist_name {\r\n  width: 65%;\r\n}\r\n\r\n.douctorlist_part {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin: 18px 0;\r\n}\r\n\r\n.douctorlist_part svg {\r\n  font-size: 25px;\r\n}\r\n\r\n.douctorlist_head a {\r\n  text-decoration: unset;\r\n  color: $green;\r\n}\r\n\r\n.patientsname_sec {\r\n  filter: $iboost-box-shadow;\r\n  background-color: $iboost-white;\r\n  border-radius: $radius_15;\r\n  padding: 30px 30px 5px;\r\n}\r\n\r\n.patientsname_top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.patientsname_top_left h2 {\r\n  font-size: 20px;\r\n  color: $dark_blue;\r\n  margin: 0;\r\n}\r\n\r\n.patientsname_top_left a {\r\n  text-decoration: unset;\r\n  font-size: 13px;\r\n  color: $green;\r\n}\r\n\r\n.patientsname_top_right a {\r\n  font-size: 13px;\r\n  line-height: 17px;\r\n  color: $iboost-white;\r\n  background-color: $green;\r\n  border-radius: 5px;\r\n  text-decoration: unset;\r\n  padding: 8px 20px;\r\n}\r\n\r\n.patientsearch_form input[type=\"text\"] {\r\n  outline: unset;\r\n  height: 34px;\r\n  border-radius: 5px;\r\n  border: 1px solid #35495912;\r\n  font-size: 13px;\r\n  padding-left: 2em;\r\n}\r\n\r\n.patientstable_sec tr th {\r\n  font-size: 13px;\r\n  color: $dark_blue;\r\n  font-weight: 100;\r\n  opacity: 0.502;\r\n}\r\n\r\n.patientstable_sec tr td {\r\n  font-size: 13px;\r\n  color: $dark_blue;\r\n  font-weight: 100;\r\n  opacity: 0.502;\r\n}\r\n\r\n.patientstable_sec thead,\r\ntbody,\r\ntfoot,\r\ntr,\r\ntd,\r\nth {\r\n  border: 0 !important;\r\n}\r\n\r\n.patientstable_sec thead {\r\n  border: 2px solid #eaecee !important;\r\n  border-left: unset !important;\r\n  border-right: unset !important;\r\n}\r\n\r\n.patientstable_sec tbody tr td:last-child {\r\n  padding: 5px;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.patientstable_sec tbody tr td:last-child button {\r\n  border: 1px solid $dark_blue;\r\n  border-radius: 5px;\r\n  background-color: unset;\r\n}\r\n\r\n.dashpatient_wrap {\r\n  width: 65%;\r\n}\r\n\r\n.dashdoctor_wrap {\r\n  width: 35%;\r\n}\r\n\r\n.dashbottom_wrap {\r\n  float: left;\r\n  width: 100%;\r\n  display: flex;\r\n}\r\n\r\n.patientstable_sec thead tr th {\r\n  padding: 0.8rem 0.5rem;\r\n}\r\n\r\n.hospital-drop {\r\n  width: 250px\r\n}\r\n\r\n.headersearch_section input[type=\"text\"] {\r\n  width: 70%;\r\n  border: unset;\r\n  font-size: 18px;\r\n  outline: unset;\r\n}\r\n\r\n.headersearch_section {\r\n  width: 100%;\r\n  padding-left: 3em;\r\n  position: relative;\r\n}\r\n\r\n.headersearch_wrap {\r\n  width: 78%;\r\n}\r\n\r\n.headersearch_section svg {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: -2px;\r\n  font-size: 30px;\r\n}\r\n\r\n.headersearch_section svg {\r\n  fill: $dark_blue;\r\n  opacity: 0.702;\r\n}\r\n\r\n.headernotify_section svg {\r\n  font-size: 40px;\r\n}\r\n\r\n.headernotify_section path {\r\n  fill: $dark_blue;\r\n}\r\n\r\n.headernotify_section {\r\n  position: relative;\r\n}\r\n\r\n.headernotify_section:after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 1px;\r\n  right: 5px;\r\n  width: 0.75em;\r\n  height: 0.75em;\r\n  border-radius: 50%;\r\n  background-color: $green;\r\n}\r\n\r\n.headernotify_section:before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 1px;\r\n  right: 5px;\r\n  width: 0.75em;\r\n  height: 0.75em;\r\n  border-radius: 50%;\r\n  background-color: $green;\r\n}\r\n\r\n.headernotify_section::before {\r\n  animation: ping 1.7s ease infinite;\r\n  opacity: 0.70;\r\n}\r\n\r\n/****doctorpage****/\r\n.panel_top_section {\r\n  border-bottom: 2px solid #eee;\r\n  padding-bottom: 1.3em;\r\n\r\n  h1 {\r\n    color: $dark_blue;\r\n    font-size: 28px;\r\n    display: inline-block;\r\n    padding-top: 4px;\r\n  }\r\n\r\n  .btn_gradian {\r\n    height: 43px;\r\n    border-radius: 10px;\r\n  }\r\n\r\n}\r\n\r\n.grid_list_icons span {\r\n  color: $text_gray;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n\r\n.docotr_innder_section {\r\n  border-radius: $radius_15;\r\n  filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\r\n}\r\n\r\n.doctor_image img {\r\n  width: 116px;\r\n  height: 116px;\r\n  object-fit: cover;\r\n  border-radius: 50%;\r\n}\r\n\r\n.doctor_detail {\r\n  h4 {\r\n    font-size: 18px;\r\n    line-height: 31px;\r\n    font-family: $poppins-700;\r\n  }\r\n\r\n  p {\r\n    font-size: 12px;\r\n    letter-spacing: 0px;\r\n    line-height: 17px;\r\n    margin-bottom: 10px;\r\n    color: $dark_blue;\r\n  }\r\n\r\n  ul {\r\n    padding: 0 1em;\r\n    text-align: left;\r\n    margin-bottom: 10px;\r\n\r\n    li {\r\n      list-style-type: none;\r\n\r\n      gap: 15px;\r\n      padding: 5px 0 5px;\r\n      align-items: center;\r\n    }\r\n\r\n    P {\r\n      margin: 0;\r\n      display: inline;\r\n    }\r\n\r\n    a {\r\n      font-size: 12px;\r\n      letter-spacing: 0px;\r\n      line-height: 17px;\r\n      color: $dark_blue;\r\n      text-decoration: none;\r\n    }\r\n\r\n    span {\r\n      display: inline-block;\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.profossional span {\r\n  min-width: 156px;\r\n  height: 27px;\r\n  border-radius: 5px;\r\n  color: $green;\r\n  background-color: $light_green;\r\n  display: inline-block;\r\n  font-size: 15px;\r\n  line-height: 29px;\r\n\r\n  font-family: 'Poppins';\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n  text-transform: uppercase;\r\n  padding: 0 10px;\r\n}\r\n\r\n.delete_btn {\r\n  min-width: 153px;\r\n  height: 36px;\r\n  border-radius: 5px;\r\n  background-color: $button_gray;\r\n  border: 0;\r\n  color: #fff;\r\n  margin: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.card_bottom {\r\n  display: flex;\r\n}\r\n\r\n.btn_gradian {\r\n  min-width: 153px;\r\n  height: 36px;\r\n  border-radius: 5px;\r\n  background-image: $bg_gradiant;\r\n  border: 0;\r\n  color: #fff;\r\n  margin: 5px;\r\n  cursor: pointer;\r\n  padding: 0 15px;\r\n  transition: 0.5s;\r\n}\r\n\r\n.sidebar-active {\r\n  background-image: $bg_gradiant !important;\r\n  border-radius: $iboost-border-radius;\r\n}\r\n\r\n.btn_gradian_disabled {\r\n  min-width: 153px;\r\n  height: 36px;\r\n  border-radius: 5px;\r\n  // background-image: $bg_gradiant;\r\n  border: 0;\r\n  // color: #fff;\r\n  margin: 5px;\r\n  padding: 0 15px;\r\n}\r\n\r\n.notification-body {\r\n  font-size: 13px;\r\n  // margin-left: 20px;\r\n}\r\n\r\n.btn_gradian:hover {\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n  transition: 0.5s;\r\n  background-image: linear-gradient(to right, #335539, #3c7546, );\r\n\r\n}\r\n\r\n.delet_patiens {\r\n  min-width: 50px;\r\n  height: 42px;\r\n  border-radius: 7px;\r\n  background-image: $bg_gradiant;\r\n  border: 0;\r\n  color: #fff;\r\n}\r\n\r\n.dark_btn {\r\n  background-image: unset;\r\n  background-color: $dark_blue;\r\n}\r\n\r\n@keyframes ping {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 0.5;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/****listpage***/\r\n.list_head {\r\n  background-color: $bg_green_100;\r\n  text-align: center;\r\n\r\n  th {\r\n    padding: 1.5em 1em;\r\n  }\r\n}\r\n\r\ntr.list_detail:hover {\r\n  background-color: #e5f5ec;\r\n  cursor: pointer;\r\n  transition: .5s;\r\n}\r\n\r\ntr.list_detail.active {\r\n  background-color: #e5f5ec;\r\n}\r\n\r\n.list_detail {\r\n  text-align: center;\r\n  background-color: $white;\r\n  border-bottom: 1px solid #eee !important;\r\n  transition: .5s;\r\n\r\n  td {\r\n    padding: 15px 10px 15px;\r\n    font-size: 15px;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    display: inline-block;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  a {\r\n    color: $green;\r\n    text-decoration: none;\r\n  }\r\n\r\n  td span img {\r\n    width: 63px;\r\n    height: 63px;\r\n    object-fit: cover;\r\n    border-radius: 31px;\r\n    filter: drop-shadow(9.962px 0.872px 9px rgba(0, 0, 0, 0.11));\r\n  }\r\n\r\n  .dost_btn {\r\n    width: 37px;\r\n    height: 36px;\r\n    background-color: #eaecee;\r\n    display: inline-block;\r\n    line-height: 37px;\r\n    border-radius: 50%;\r\n  }\r\n\r\n}\r\n\r\n.action {\r\n  width: 112px;\r\n  height: 36px;\r\n  background-color: #eaecee;\r\n  display: inline-block;\r\n  line-height: 37px;\r\n  border-radius: 18px;\r\n  text-align: center;\r\n\r\n  button {\r\n    border: 0;\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n.refill-action {\r\n  display: flex;\r\n  gap: 10px;\r\n\r\n  button {\r\n    border-radius: 5px;\r\n    border: none;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .accept-btn {\r\n    background-color: $accept_back;\r\n    color: $textgreen;\r\n  }\r\n\r\n  .reject-btn {\r\n    background-color: $reject_back;\r\n    color: $reject_color;\r\n  }\r\n}\r\n\r\n.drop_list {\r\n  transform: scale(0.1);\r\n  opacity: 0;\r\n  transition: 0.5s;\r\n  top: 100%;\r\n}\r\n\r\n.toast-header .btn-close {\r\n  color: $white;\r\n}\r\n\r\n.three_dots:hover .drop_list {\r\n  transform: scale(1);\r\n  opacity: 1;\r\n  transition: 0.5s;\r\n}\r\n\r\n.exclamation_btn:hover .drop_list {\r\n  transform: scale(1);\r\n  opacity: 1;\r\n  transition: 0.5s;\r\n}\r\n\r\n.pagination_list {\r\n  ul {\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  li {\r\n    display: inline-block;\r\n    padding: 10px 5px;\r\n  }\r\n\r\n  a {\r\n    width: 31px;\r\n    height: 31px;\r\n    border-radius: 16px;\r\n    display: inline-block;\r\n    line-height: 31px;\r\n    color: #000;\r\n  }\r\n\r\n  .active a {\r\n    background-color: #059fac;\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n/***doctor-detail***/\r\n.doctore_detail_wrap {\r\n  border-radius: 17px;\r\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\r\n  background-color: $white;\r\n  margin: 2em 0 2em;\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.doctor_detail_image {\r\n  border-radius: $radius_15;\r\n  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));\r\n  background-color: $iboost-body;\r\n\r\n  img {\r\n    border-radius: $radius_15;\r\n    height: 277px;\r\n    object-fit: cover;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.doctor_detail_page {\r\n  float: left;\r\n  width: 100%;\r\n\r\n  ul {\r\n    padding: 0;\r\n\r\n    h5 {\r\n      font-size: 15px;\r\n      line-height: 20px;\r\n      color: $green;\r\n      margin: 0;\r\n\r\n    }\r\n\r\n    li {\r\n      list-style-type: none;\r\n      float: left;\r\n      width: 100%;\r\n      padding: 5px 0 5px;\r\n    }\r\n\r\n    a {\r\n      color: $dark_blue;\r\n      font-size: 12px;\r\n      text-decoration: none;\r\n    }\r\n\r\n    P {\r\n      margin-bottom: 5px;\r\n      font-size: 12px;\r\n    }\r\n\r\n    .right_box {\r\n      width: 75%;\r\n      padding-left: 10px;\r\n    }\r\n\r\n  }\r\n}\r\n\r\n.doctor_right_block {\r\n  h1 {\r\n    font-size: 25px;\r\n    line-height: 31px;\r\n    color: $dark_blue;\r\n    font-family: $poppins-700;\r\n  }\r\n\r\n  p {\r\n    font-size: 15px;\r\n    letter-spacing: 0px;\r\n    line-height: 28px;\r\n    color: $dark_blue;\r\n    margin-top: 1em;\r\n  }\r\n}\r\n\r\n.doctor_right_top {\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.col-right {\r\n  text-align: right;\r\n\r\n  button {\r\n    border: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    margin-left: 10px;\r\n    border-radius: 20px;\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .dots_btn {\r\n    position: relative;\r\n\r\n    button {\r\n      background-color: $white;\r\n    }\r\n\r\n    :after {\r\n      content: \"\";\r\n      display: inline-block;\r\n      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n      background-color: $white;\r\n      width: 10px;\r\n      height: 9px;\r\n      position: absolute;\r\n      right: 15px;\r\n      top: -8px;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.drop_list {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 43px;\r\n  filter: drop-shadow(4.532px 2.113px 6.5px rgba(53, 73, 89, 0.19));\r\n  border-radius: 4px;\r\n  min-width: 70px;\r\n  z-index: 1;\r\n\r\n  li {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    color: $dark_blue;\r\n    list-style-type: none;\r\n    display: block;\r\n    text-align: left;\r\n  }\r\n\r\n  a {\r\n    color: $dark_blue;\r\n    text-decoration: none;\r\n  }\r\n\r\n  :after {\r\n    content: \"\";\r\n    display: inline-block;\r\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\r\n    background-color: $white;\r\n    width: 10px;\r\n    height: 9px;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: -8px;\r\n  }\r\n}\r\n\r\n.add_pdf {\r\n  min-width: 200px;\r\n}\r\n\r\n.sigCanvas {\r\n  width: 100%;\r\n  border: 1px solid black;\r\n}\r\n\r\n/***add-docor-page***/\r\n\r\n.card_box {\r\n  border-radius: $radius_15;\r\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\r\n  background-color: $white;\r\n}\r\n\r\n.form-control {\r\n  height: 44px;\r\n}\r\n\r\n.form-control.multiple_choose {\r\n  height: auto;\r\n  min-height: 64px;\r\n}\r\n\r\n.textarea_input.form-control {\r\n  height: 63px;\r\n}\r\n\r\n.form-select {\r\n  height: 44px;\r\n}\r\n\r\n.add_doctor_fom p {\r\n  font-family: $poppins-500;\r\n}\r\n\r\n.upload_btn {\r\n  display: inline-block;\r\n  width: 170px;\r\n  height: 47px;\r\n  border-radius: 10px;\r\n  background-image: $bg_gradiant;\r\n  font-size: 18px;\r\n  letter-spacing: 0px;\r\n  color: #ffffff;\r\n  text-align: center;\r\n  line-height: 47px;\r\n}\r\n\r\n.up_arrow {\r\n  font-size: 44px;\r\n  padding-top: 4px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-right: 10px;\r\n}\r\n\r\n.form_bottom_btn button {\r\n  height: 43px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/****patient_detail_page***/\r\n.pateint_profile img {\r\n  width: 113px;\r\n  height: 100px;\r\n  border-radius: $radius_15;\r\n  filter: drop-shadow(10.876px 5.071px 14.5px rgba(8, 131, 142, 0.16));\r\n  background-color: $iboost-body;\r\n}\r\n\r\n.tab_navigation li {\r\n  border-bottom: 1px solid transparent;\r\n}\r\n\r\n.tab_navigation li.active {\r\n  border-bottom: 1px solid $bg_green;\r\n}\r\n\r\n.location_map img {\r\n  height: 200px;\r\n  object-fit: cover;\r\n}\r\n\r\n.location_map_image img {\r\n  height: 412px;\r\n  object-fit: cover;\r\n}\r\n\r\n.list_head.billing_head {\r\n  text-align: left;\r\n\r\n  th {\r\n    padding: 1.5em 0.5em;\r\n    font-size: 14px;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.list_detail.billing_detail {\r\n  // text-align: left;\r\n\r\n  td {\r\n    padding: 1.5em 0.5em;\r\n    font-size: 14px;\r\n\r\n  }\r\n}\r\n\r\n.po_pending {\r\n  min-width: 90px;\r\n}\r\n\r\n.percentage {\r\n  background-color: #33a8b2;\r\n}\r\n\r\n.demo_card {\r\n  position: relative;\r\n  top: -5em;\r\n  margin-bottom: -4em;\r\n}\r\n\r\n.payment_request {\r\n  background-image: linear-gradient(82deg, #335539 0%, #3c7546 100%);\r\n}\r\n\r\n.payment_button button {\r\n  padding: 12px 0 12px;\r\n\r\n  font-size: 20px;\r\n  text-transform: uppercase;\r\n  border-radius: 10px;\r\n}\r\n\r\n.card_details {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-around;\r\n  padding: 1em 3em;\r\n}\r\n\r\n.card_type {\r\n  text-align: right;\r\n}\r\n\r\n.select_drop_down {\r\n  color: $text_gray !important;\r\n\r\n  option {\r\n    color: $dark_blue;\r\n  }\r\n}\r\n\r\n.payment_tab {\r\n  margin-bottom: 2em;\r\n}\r\n\r\n.payment_tab ul {\r\n  border-radius: 34px;\r\n  // filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.15));\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 6px;\r\n}\r\n\r\n.payment_tab ul li {\r\n  text-align: center;\r\n  display: inline-block;\r\n  float: left;\r\n  width: 48%;\r\n  border-radius: 40px;\r\n}\r\n\r\n.payment_tab ul li .nav-link {\r\n  font-size: 20px;\r\n  text-transform: uppercase;\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n  display: flex;\r\n  height: 65px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 35px;\r\n  background-color: #00929f;\r\n}\r\n\r\n.payment_tab ul li .nav-link.active {\r\n  background-color: #354959;\r\n}\r\n\r\n.service_tab {\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.service_tab ul {\r\n  // border-radius: 34px;\r\n  // filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.15));\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  align-items: center !important;\r\n  // justify-content: center;\r\n  // padding: 4px 6px;\r\n}\r\n\r\n.service_tab ul li {\r\n  text-align: center;\r\n  display: inline-block;\r\n  // float: left;\r\n  width: 48%;\r\n  border-radius: 40px;\r\n}\r\n\r\n.service_tab ul li .nav-link {\r\n  // font-size: 14px;\r\n  /* text-transform: uppercase; */\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n  display: flex;\r\n  /* height: 65px; */\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 35px;\r\n  background-color: #00929f;\r\n  padding: 5px;\r\n}\r\n\r\n.service_tab ul li .nav-link.active {\r\n  background-color: #354959;\r\n}\r\n\r\n.chat-users {\r\n  height: 400px;\r\n  max-height: 400px;\r\n}\r\n\r\n/***calend-style***/\r\n.calender_block .react-calendar {\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  border: 0;\r\n}\r\n\r\n.calender_block .react-calendar__navigation {\r\n  background-color: $dark_blue;\r\n}\r\n\r\n.calender_block .react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: $bg_green;\r\n}\r\n\r\n.calender_block .react-calendar__month-view__weekdays__weekday {\r\n\r\n  font-size: 17px;\r\n  letter-spacing: 0px;\r\n  line-height: 17px;\r\n  color: $dark_blue;\r\n  font-family: 'Poppins-Medium';\r\n}\r\n\r\n.calender_block .react-calendar__month-view__weekdays__weekday abbr[title] {\r\n  text-decoration: none;\r\n}\r\n\r\n.calender_block .react-calendar button {\r\n  color: $dark_blue;\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n\r\n}\r\n\r\n.calender_block.doctor_calender .react-calendar button {\r\n  border-radius: 36px;\r\n}\r\n\r\n.calender_block.doctor_calender .react-calendar button {\r\n  font-size: 17px;\r\n  line-height: 32px;\r\n  overflow: unset !important;\r\n  position: relative;\r\n}\r\n\r\n.cal_count {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 18px;\r\n  color: #ffffff;\r\n  background-color: $bg_green;\r\n  font-size: 11px;\r\n  line-height: 18px;\r\n}\r\n\r\n.calender_block .react-calendar__month-view {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.calender_block .react-calendar__year-view .react-calendar__tile,\r\n.react-calendar__decade-view .react-calendar__tile,\r\n.react-calendar__century-view .react-calendar__tile {\r\n  padding: 1.28em 0.5em;\r\n}\r\n\r\n.calender_block .react-calendar__year-view .react-calendar__tile,\r\n.react-calendar__decade-view .react-calendar__tile,\r\n.react-calendar__century-view .react-calendar__tile {\r\n  padding: 1.28em 0.5em;\r\n}\r\n\r\n.calender_block .react-calendar__year-view .react-calendar__tile,\r\n.react-calendar__decade-view .react-calendar__tile,\r\n.react-calendar__century-view .react-calendar__tile {\r\n  padding: 1.28em 0.5em;\r\n}\r\n\r\n.calender_block .react-calendar__tile:enabled:hover,\r\n.react-calendar__tile:enabled:focus {\r\n  background-color: $bg_green;\r\n  color: #fff;\r\n}\r\n\r\n.calender_block .react-calendar__tile--now {\r\n  background: $bg_green;\r\n  color: #fff !important;\r\n  background: unset;\r\n  color: $black !important;\r\n  border: 1px solid $bg_green;\r\n}\r\n\r\n.calender_block .react-calendar__tile--active {\r\n  background: $bg_green;\r\n  color: #fff !important;\r\n}\r\n\r\n.calender_block .react-calendar__viewContainer {\r\n  padding: 0 20px;\r\n}\r\n\r\n.calender_block .react-calendar button {\r\n  border-radius: 20px;\r\n}\r\n\r\n.calender_block .react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: $bg_green !important;\r\n  color: $white;\r\n}\r\n\r\n.calender_block .react-calendar__tile--hasActive {\r\n  background: $light_green;\r\n  color: $dark_blue !important;\r\n}\r\n\r\n.calender_block .react-calendar__tile--active:enabled:hover,\r\n.react-calendar__tile--active:enabled:focus {\r\n  background: $dark_blue;\r\n}\r\n\r\n.calender_block .react-calendar__tile--now:enabled:hover,\r\n.react-calendar__tile--now:enabled:focus {\r\n  background: $bg_green;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.calender_block .react-calendar__year-view .react-calendar__tile,\r\n.react-calendar__decade-view .react-calendar__tile,\r\n.react-calendar__century-view .react-calendar__tile {\r\n  padding: 1.28em 0.5em !important;\r\n}\r\n\r\n.react-calendar__tile:disabled {\r\n  background-color: #fff !important;\r\n  opacity: 0.5;\r\n}\r\n\r\n.calender_block .react-calendar__navigation {\r\n  display: flex;\r\n  height: 65px;\r\n  margin-bottom: 1em;\r\n  border-top-left-radius: 15px;\r\n  border-top-right-radius: 15px;\r\n  overflow: hidden;\r\n\r\n  button {\r\n    min-width: 44px;\r\n    background: none;\r\n    font-size: 20px;\r\n    letter-spacing: 0px;\r\n    line-height: 17px;\r\n    color: #ffffff;\r\n    font-family: 'Poppins';\r\n    border-radius: 0 !important;\r\n  }\r\n}\r\n\r\n.local-participant {\r\n  position: absolute;\r\n  z-index: 1;\r\n  bottom: 10px;\r\n  right: 20px\r\n}\r\n\r\n.participants {\r\n  position: relative;\r\n  width: 640px\r\n}\r\n\r\n.call_attend {\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button {\r\n  font-size: 0 !important;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev-button:after {\r\n  content: \"\\F284\";\r\n  font-family: bootstrap-icons !important;\r\n  font-size: 17px;\r\n  line-height: 33px;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button {\r\n  font-size: 0 !important;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next-button:after {\r\n  content: \"\\F285\";\r\n  font-family: bootstrap-icons !important;\r\n  font-size: 17px;\r\n  line-height: 33px;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button {\r\n  font-size: 0 !important;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__next2-button:after {\r\n  content: \"\\F280\";\r\n  font-family: bootstrap-icons !important;\r\n  font-size: 17px;\r\n  line-height: 33px;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button {\r\n  font-size: 0 !important;\r\n}\r\n\r\n.calender_block .react-calendar__navigation__arrow.react-calendar__navigation__prev2-button:after {\r\n  content: \"\\F27F\";\r\n  font-family: bootstrap-icons !important;\r\n  font-size: 17px;\r\n  line-height: 33px;\r\n}\r\n\r\n.date_btn {\r\n  button {\r\n    border-radius: 5px;\r\n    background-color: $white;\r\n    border: 2px solid $textgreen;\r\n    padding: 7px 10px;\r\n    margin: 5px 7px;\r\n    color: $textgreen;\r\n    min-width: 125px;\r\n    text-align: center;\r\n  }\r\n\r\n  .active {\r\n    background-color: $textgreen;\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.attachment span {\r\n  vertical-align: middle;\r\n}\r\n\r\n.app_content p {\r\n  margin: 0;\r\n}\r\n\r\n.treatment p {\r\n  text-align: justify;\r\n  line-height: 23px;\r\n}\r\n\r\n/***message***/\r\n.user_chat_img img {\r\n  width: 65px;\r\n  height: 65px;\r\n  border-radius: 5px;\r\n  object-fit: cover;\r\n}\r\n\r\n.user_chat:hover {\r\n  background-color: $bg_green_100;\r\n  transition: 0.5s;\r\n}\r\n\r\n.user_chat:hover .chat_group {\r\n  border-color: transparent !important;\r\n}\r\n\r\n.user_chat:last-child .chat_group {\r\n  border-color: transparent !important;\r\n}\r\n\r\n.count {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 10px;\r\n  background-color: $bg_green;\r\n  line-height: 20px;\r\n  font-size: 12px;\r\n}\r\n\r\n.col-right.chat_tools button {\r\n  width: 27px;\r\n  height: 27px;\r\n  font-size: 12px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.chat_send {\r\n  border-radius: 8px;\r\n  border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.chat_receive {\r\n  border-radius: 8px;\r\n  border-bottom-left-radius: 0 !important;\r\n}\r\n\r\n.message_box .inner_location {\r\n  min-height: 100%;\r\n}\r\n\r\n.chat_message.custom_scroll {\r\n  height: 17vw;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.chat_height.custom_scroll {\r\n  height: 21vw;\r\n  overflow-y: scroll;\r\n}\r\n\r\n\r\n\r\n.left_user.custom_scroll {\r\n  height: 23.4vw;\r\n  overflow-y: scroll;\r\n}\r\n\r\n/* width */\r\n.custom_scroll::-webkit-scrollbar {\r\n  width: 4px;\r\n  height: 4px;\r\n}\r\n\r\n/* Track */\r\n.custom_scroll::-webkit-scrollbar-track {\r\n  background: transparent;\r\n  border-radius: 10px;\r\n\r\n}\r\n\r\n/* Handle */\r\n.custom_scroll::-webkit-scrollbar-thumb {\r\n  background: $bg_green_100;\r\n}\r\n\r\n/* Handle on hover */\r\n.custom_scroll::-webkit-scrollbar-thumb:hover {\r\n  background: $light_green;\r\n}\r\n\r\n.patient_info_profile img {\r\n  width: 155px;\r\n  height: 145px;\r\n  border-radius: 5px;\r\n  background-color: $iboost-body;\r\n  object-fit: cover;\r\n}\r\n\r\n.post_image img {\r\n  width: 88px;\r\n  height: 88px;\r\n  border-radius: 5px;\r\n  background-color: $iboost-body;\r\n  object-fit: cover;\r\n}\r\n\r\n.online {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 8px;\r\n  // background-color: $green;\r\n  border: 1px solid $white;\r\n  right: 30px;\r\n  bottom: -5px !important;\r\n}\r\n\r\n.online1 {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 8px;\r\n  // background-color: #00929f;\r\n  border: 1px solid #fff;\r\n  right: -5px;\r\n  bottom: -5px !important;\r\n}\r\n\r\n.post_pdf span {\r\n  vertical-align: middle;\r\n}\r\n\r\n.user_chat_img.chat_detail_img img {\r\n  width: 30px;\r\n  height: 28px;\r\n  border-radius: 50% !important;\r\n  background-color: $iboost-body;\r\n}\r\n\r\n.user_chat_img.chat_detail_img span {\r\n  width: 30px;\r\n  height: 28px;\r\n  border-radius: 50% !important;\r\n  background-color: $iboost-body;\r\n  display: inline-block;\r\n}\r\n\r\n.chat_msg_content p {\r\n  font-size: 15px;\r\n  letter-spacing: 0px;\r\n  line-height: 28px;\r\n  color: $dark_blue;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.regards p {\r\n  margin: 0;\r\n}\r\n\r\n.chat_message.chat_msg_content.custom_scroll {\r\n  height: 610px;\r\n}\r\n\r\n.chat_tab {\r\n  button {\r\n    background-color: $iboost-body;\r\n  }\r\n\r\n  .active {\r\n    background-color: $white;\r\n    color: $green;\r\n  }\r\n}\r\n\r\n.tele_messgage {\r\n  height: 365px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.user_chat:hover .send_btn {\r\n  background-image: $bg_gradiant;\r\n  transition: 0.5s;\r\n}\r\n\r\n.left_refil {\r\n  height: 512px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.map {\r\n  -webkit-filter: grayscale(100%);\r\n  -moz-filter: grayscale(100%);\r\n  -ms-filter: grayscale(100%);\r\n  -o-filter: grayscale(100%);\r\n  filter: grayscale(100%);\r\n}\r\n\r\n.select_pharmacy {\r\n  border: 1px solid $textgreen !important;\r\n  color: $text_gray !important;\r\n}\r\n\r\n.user_\r\n {\r\n  outline: none !important;\r\n  border: 0 !important\r\n}\r\n\r\n.sidebar_left span {\r\n  opacity: 0.800;\r\n  color: #333333;\r\n}\r\n\r\n.sidebar_left .active {\r\n  background-color: $light_green !important;\r\n  color: $green;\r\n}\r\n\r\n.sidebar_left .active i {\r\n\r\n  color: $green;\r\n}\r\n\r\n.switch_toggle .form-switch .form-check-input:checked {\r\n  background-color: $light_green !important;\r\n}\r\n\r\n.switch_toggle .form-switch .form-check-inputt {\r\n  background-color: #c2c8cd !important;\r\n  height: 22px;\r\n  width: 52px;\r\n}\r\n\r\n.switch_toggle .form-check-input:focus {\r\n  border-color: #b2dee2;\r\n  outline: 0;\r\n  box-shadow: unset;\r\n}\r\n\r\n.switch {\r\n  position: absolute;\r\n  display: inline-block;\r\n  width: 54px;\r\n  height: 22px;\r\n  left: -30px;\r\n  top: 6px;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #c2c8cd;\r\n  -webkit-transition: .4s;\r\n  transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 30px;\r\n  width: 30px;\r\n  left: -1px;\r\n  bottom: -4px;\r\n  background-color: white;\r\n  transition: 0.4s;\r\n  border: 1px solid #c2c8cd;\r\n}\r\n\r\ninput:checked+.slider {\r\n  background-color: #b2dee2;\r\n}\r\n\r\ninput:focus+.slider {\r\n  box-shadow: 0 0 1px #b2dee2;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n  -webkit-transform: translateX(26px);\r\n  -ms-transform: translateX(26px);\r\n  transform: translateX(26px);\r\n  background-color: #00929f;\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round_toggle {\r\n  border-radius: 34px;\r\n}\r\n\r\n.slider.round_toggle:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.vidoe_button {\r\n  button {\r\n    width: 42px;\r\n    height: 42px;\r\n    border-radius: 21px;\r\n    background-color: rgb(0 0 0 / 38%);\r\n    border: 0;\r\n    margin: 0 10px;\r\n    color: #fff;\r\n    font-size: 21px;\r\n    transition: 0.5s;\r\n  }\r\n\r\n  button:hover {\r\n    background-color: #008b89;\r\n    transition: 0.5s;\r\n  }\r\n}\r\n\r\n.time_record {\r\n  background-color: rgb(0 0 0 / 46%);\r\n}\r\n\r\n.small_video {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 23px;\r\n\r\n  img {\r\n    width: 136px;\r\n    height: 154px;\r\n    border-radius: 15px;\r\n    filter: drop-shadow(4.981px 0.436px 5px rgba(53, 73, 89, 0.05));\r\n    background-color: #ffffff;\r\n    object-fit: cover;\r\n  }\r\n}\r\n\r\n/** File Renderer **/\r\n.file-details-container {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.name-container .file-size {\r\n  font-size: 11px;\r\n}\r\n\r\n.download-btn {\r\n  margin-left: auto;\r\n}\r\n\r\n/***admin-setting***/\r\n.admin_setting .inner_location {\r\n  min-height: 785px;\r\n}\r\n\r\n.type_check_box {\r\n  border: 2px solid #00929f;\r\n}\r\n\r\n.type_check_box .form-type_control {\r\n  border: 0;\r\n  border-bottom: 2px solid #00929f;\r\n  outline: none;\r\n}\r\n\r\n.admin_input .edit_btn {\r\n  width: 40px;\r\n  height: 128px;\r\n  border-radius: 21px;\r\n  filter: drop-shadow(4.532px 2.113px 12px rgba(53, 73, 89, 0.24));\r\n  right: -38px;\r\n  top: -4px;\r\n}\r\n\r\n.switch.check_switch_box {\r\n  left: auto;\r\n  right: 0;\r\n  width: 40px;\r\n  height: 15px;\r\n}\r\n\r\n.check_switch_box .slider:before {\r\n  height: 20px;\r\n  width: 20px;\r\n  bottom: -2px;\r\n  left: -4px;\r\n}\r\n\r\n.type_check_box input[type=date] {\r\n  border: 1px solid #00929f !important;\r\n}\r\n\r\n.admin_calender .react-calendar {\r\n  width: 100%;\r\n}\r\n\r\n.admin_calender .react-calendar__navigation {\r\n  background-color: $white;\r\n  color: $dark_blue;\r\n  font-size: 15px;\r\n}\r\n\r\n.admin_calender abbr[title] {\r\n  -webkit-text-decoration: none;\r\n  ;\r\n  text-decoration: none;\r\n  font-family: 'Poppins-Medium';\r\n}\r\n\r\n.admin_calender .react-calendar__tile--active {\r\n  background: $light_green;\r\n  color: $dark_blue;\r\n}\r\n\r\n.admin_calender .react-calendar__tile--active:enabled:hover,\r\n.react-calendar__tile--active:enabled:focus {\r\n  background: $light_green !important;\r\n  color: $dark_blue !important;\r\n}\r\n\r\n.admin_calender .react-calendar__tile--now {\r\n  background: $green;\r\n  color: $white;\r\n  border-radius: 26px;\r\n}\r\n\r\n.admin_calender .react-calendar__tile--now:enabled:hover,\r\n.react-calendar__tile--now:enabled:focus {\r\n  background: $green;\r\n}\r\n\r\n.admin_calender .react-calendar__tile--now:enabled:hover,\r\n.react-calendar__tile--now:enabled:focus {\r\n  background: $green !important;\r\n}\r\n\r\n.admin_calender .react-calendar__tile:enabled:hover,\r\n.react-calendar__tile:enabled:focus {\r\n  background: $green !important;\r\n  color: $white !important;\r\n}\r\n\r\n.admin_calender .react-calendar__tile {\r\n  font-family: 'Poppins-Regular';\r\n  border-radius: 26px;\r\n}\r\n\r\n.admin_calender .react-calendar__year-view .react-calendar__tile,\r\n.react-calendar__decade-view .react-calendar__tile,\r\n.react-calendar__century-view .react-calendar__tile {\r\n  padding: 1em 0.5em;\r\n}\r\n\r\n.admin_calender .react-calendar {\r\n  border: 1px solid #eee;\r\n  filter: drop-shadow(4.532px 2.113px 5px rgba(53, 73, 89, 0.05));\r\n}\r\n\r\n.react-calendar__month-view__days__day--weekend {\r\n  color: #d10000;\r\n}\r\n\r\n/******doctor-level*****/\r\n.recentappoint_doctor span {\r\n  display: inline-block;\r\n  width: 23px;\r\n  height: 23px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n  font-size: 11px;\r\n  line-height: 26px;\r\n  color: #354959;\r\n  background-color: #b8bfc5;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.billing_sec .recentappoint_doctor {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  justify-content: space-between;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.billing_sec .recentappoint_doctor .recentappoint_name p {\r\n  font-size: 13px;\r\n  line-height: 31px;\r\n  color: #354959;\r\n  opacity: 1;\r\n  display: inline-block;\r\n}\r\n\r\n.billing_sec .recentappoint_doctor .recentappoint_name strong {\r\n  font-size: 13px;\r\n}\r\n\r\n.billing_sec .recentappoint_doctor .recentappoint_name {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.close_btn {\r\n  opacity: 0.502;\r\n  width: 21px;\r\n  height: 20px;\r\n  border-radius: 5px;\r\n  background-color: $white;\r\n  border: 1px solid $dark;\r\n  padding: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.check_btn {\r\n  width: 21px;\r\n  height: 20px;\r\n  border-radius: 5px;\r\n  background-color: #ffffff;\r\n  border: 1px solid $textgreen;\r\n  padding: 0;\r\n  color: $textgreen;\r\n  line-height: 20px;\r\n}\r\n\r\n.user_chat:hover .user_chat_detail span {\r\n  color: $textgreen;\r\n}\r\n\r\n.user_chat_img.patient_chat_img img {\r\n  width: 101px;\r\n  height: 101px;\r\n  border-radius: 51px;\r\n  filter: drop-shadow(7.97px 0.697px 10.5px rgba(0, 0, 0, 0.07));\r\n  background-color: #333333;\r\n}\r\n\r\n.patient_enquiery button {\r\n  border: 1px solid #00929f;\r\n}\r\n\r\n// .show_option {\r\n//   position: absolute;\r\n//   right: 0;\r\n//   left: 0;\r\n//   max-width: 90px;\r\n//   display: inline-block;\r\n//   margin: 0 auto;\r\n//   top: 20px;\r\n//   transform: scale(0);\r\n//   transition: 0.5s;\r\n// }\r\n.dost_btn:hover .show_option {\r\n  transform: scale(1);\r\n  transition: 0.5s;\r\n}\r\n\r\n.vidoe_large_img img {\r\n  height: 535px;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n/****staff-dashoboard****/\r\n@at-root .staff_graph img {\r\n  height: 280px;\r\n  object-fit: cover;\r\n}\r\n\r\n.location_map_staff img {\r\n  height: 230px;\r\n  object-fit: cover;\r\n}\r\n\r\n.filter_blur {\r\n  opacity: 0.502;\r\n}\r\n\r\n.filter_right {\r\n  filter: blur(3px);\r\n}\r\n\r\n.requested_access {\r\n  z-index: 2;\r\n}\r\n\r\n/***break-poinst***/\r\n@media (max-width: 1200px) {\r\n  .border-r {\r\n    border-right: 0 !important;\r\n    border-bottom: 1.8px solid #ccc !important;\r\n  }\r\n\r\n  .demo_card {\r\n    top: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .headersearch_wrap {\r\n    width: 75%;\r\n  }\r\n\r\n  .headernotify_section svg {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .login_img {\r\n    max-width: 40px;\r\n  }\r\n\r\n  .headersearch_wrap {\r\n    width: 68%;\r\n  }\r\n\r\n  .headersearch_section svg {\r\n    font-size: 20px;\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .headersearch_section {\r\n    padding-left: 2.5em;\r\n  }\r\n\r\n  .headersearch_section input[type=text] {\r\n    width: 80%;\r\n  }\r\n\r\n  .user_login {\r\n    padding-right: 0;\r\n    gap: 0 !important;\r\n  }\r\n\r\n  .admin_setting .inner_location {\r\n    min-height: auto;\r\n  }\r\n\r\n  .user_chat_img.patient_chat_img img {\r\n    height: 75px;\r\n    width: 100px;\r\n  }\r\n\r\n  .left_user.custom_scroll {\r\n    height: 400px;\r\n    overflow-y: scroll;\r\n  }\r\n\r\n  .user_chat_img img {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 5px;\r\n    object-fit: cover;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .online1 {\r\n    bottom: 10px !important;\r\n  }\r\n\r\n  .chat_message.custom_scroll {\r\n    height: 400px;\r\n    overflow-y: scroll;\r\n  }\r\n\r\n  .chat_height.custom_scroll {\r\n    height: 380px;\r\n    overflow-y: scroll;\r\n  }\r\n\r\n}\r\n\r\n\r\n@media (max-width: 576px) {\r\n  .wrapper.container-fluid {\r\n    padding-left: 5px !important;\r\n    padding-right: 5px !important;\r\n  }\r\n\r\n  .headersearch_section svg {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .delete_btn {\r\n    min-width: 115px;\r\n  }\r\n\r\n  .btn_gradian {\r\n    min-width: 115px;\r\n  }\r\n\r\n  .panel_top_section h1,\r\n  .panel_top_section .h1 {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .sidebarArea {\r\n    margin-left: -324px;\r\n  }\r\n\r\n  .list_detail p {\r\n    padding-left: 0;\r\n    font-size: 14px;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .panel_top_section .btn_gradian {\r\n    min-width: auto;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .icons_patients {\r\n    // position: absolute;\r\n    right: 0;\r\n    top: -5px;\r\n  }\r\n\r\n  .list_head th {\r\n    min-width: 150px;\r\n  }\r\n\r\n  .appointment_table table tr td {\r\n    min-width: 118px;\r\n    width: 100%;\r\n    padding: 10px !important;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .list_detail_new td {\r\n    min-width: 118px;\r\n    width: 100%;\r\n  }\r\n\r\n  .list_detail_new th {\r\n    min-width: 118px;\r\n    width: 100%;\r\n  }\r\n\r\n  .record_img a img {\r\n    max-width: 20px;\r\n  }\r\n\r\n  .record_img {\r\n    display: flex;\r\n  }\r\n\r\n  .full_width {\r\n    width: 100%;\r\n  }\r\n\r\n  .upload_delete {\r\n    position: absolute;\r\n    right: 10px;\r\n    left: auto !important;\r\n    text-align: right;\r\n  }\r\n\r\n  .user_chat_detail p {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .user_chat_detail span {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .vidoe_large_img img {\r\n    height: 300px;\r\n  }\r\n\r\n  .small_video img {\r\n    width: 80px;\r\n    height: 100px;\r\n  }\r\n\r\n  .vidoe_button button {\r\n    width: 35px;\r\n    height: 33px;\r\n    border: 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .mobile-search-icon.d-none {\r\n    display: block !important;\r\n  }\r\n\r\n  .mobile-logo.d-none {\r\n    display: block !important;\r\n  }\r\n\r\n  .headersearch_section {\r\n    display: none !important;\r\n  }\r\n\r\n  .mobile-search-icon.d-none input {\r\n    position: absolute;\r\n    bottom: -45px;\r\n    left: 0;\r\n  }\r\n\r\n  .mobile-search-icon.d-none svg {\r\n    font-size: 28px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .header-nav .container-fluid {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .header-nav button.user_login {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .header-nav .align-items-center {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  nav.header-nav {\r\n    padding-left: 15px !important;\r\n    padding-right: 15px !important;\r\n  }\r\n\r\n  .table-responsive,\r\n  .table-responsive.m-0 {\r\n    margin-top: 35px !important;\r\n  }\r\n\r\n  input#search_input {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -30px;\r\n  }\r\n\r\n  .panel_top_section {\r\n    position: relative;\r\n  }\r\n\r\n  .header-profile {\r\n    display: none;\r\n  }\r\n\r\n  .grid_icons.float-end {\r\n    margin: 0 auto;\r\n    float: unset !important;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .headersearch_wrap {\r\n    width: 100%;\r\n    padding-left: 15px;\r\n  }\r\n\r\n  .billing-container input#search_input {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -2em;\r\n    width: 100%;\r\n  }\r\n\r\n  .appointment-container input#search_input {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: -17em;\r\n    width: 100%;\r\n  }\r\n\r\n  .appointment-container {\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .table-responsive.m-0.appoint {\r\n    margin-top: 50px !important;\r\n  }\r\n\r\n  .payment_tab ul li .nav-link {\r\n    font-size: 13px;\r\n    height: 45px\r\n  }\r\n\r\n  .service_tab ul li .nav-link {\r\n    font-size: 13px !important;\r\n    height: 45px\r\n  }\r\n\r\n  .payment-method {\r\n    padding: 30px !important;\r\n  }\r\n\r\n  .order-number {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .pat_group.py-2.d-flex {\r\n    display: grid !important;\r\n    grid-template-columns: 1fr 1fr;\r\n  }\r\n\r\n  .d-flex.justify-content-between.mt-2 {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .btn_gradian {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .popup {\r\n    width: 100% !important\r\n  }\r\n\r\n  .grid_icons.float-end.billing-filter {\r\n    margin: 0 auto;\r\n    float: right !important;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .patient-ques {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .ques-title {\r\n    font-size: 20px !important;\r\n  }\r\n\r\n  .invoice-header-text {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .dropdown-menu.show {\r\n    display: block;\r\n    width: 100%;\r\n    float: left;\r\n  }\r\n\r\n  .header-dropdown {\r\n    position: absolute !important;\r\n    bottom: -45px;\r\n    left: 5px;\r\n    /* z-index: 1; */\r\n    width: 100%;\r\n    float: left;\r\n    right: 0;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .hospital-drop {\r\n    width: 300px;\r\n  }\r\n}","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","/*!\n * Bootstrap Icons v1.11.3 (https://icons.getbootstrap.com/)\n * Copyright 2019-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/icons/blob/main/LICENSE)\n */\n\n$bootstrap-icons-font: \"bootstrap-icons\" !default;\n$bootstrap-icons-font-dir: \"./fonts\" !default;\n$bootstrap-icons-font-file: \"#{$bootstrap-icons-font-dir}/#{$bootstrap-icons-font}\" !default;\n$bootstrap-icons-font-hash: \"24e3eb84d0bcaf83d77f904c78ac1f47\" !default;\n$bootstrap-icons-font-src: url(\"#{$bootstrap-icons-font-file}.woff2?#{$bootstrap-icons-font-hash}\") format(\"woff2\"),\n                           url(\"#{$bootstrap-icons-font-file}.woff?#{$bootstrap-icons-font-hash}\") format(\"woff\") !default;\n\n@font-face {\n  font-display: block;\n  font-family: $bootstrap-icons-font;\n  src: $bootstrap-icons-font-src;\n}\n\n.bi::before,\n[class^=\"bi-\"]::before,\n[class*=\" bi-\"]::before {\n  display: inline-block;\n  font-family: $bootstrap-icons-font !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n$bootstrap-icons-map: (\n  \"123\": \"\\f67f\",\n  \"alarm-fill\": \"\\f101\",\n  \"alarm\": \"\\f102\",\n  \"align-bottom\": \"\\f103\",\n  \"align-center\": \"\\f104\",\n  \"align-end\": \"\\f105\",\n  \"align-middle\": \"\\f106\",\n  \"align-start\": \"\\f107\",\n  \"align-top\": \"\\f108\",\n  \"alt\": \"\\f109\",\n  \"app-indicator\": \"\\f10a\",\n  \"app\": \"\\f10b\",\n  \"archive-fill\": \"\\f10c\",\n  \"archive\": \"\\f10d\",\n  \"arrow-90deg-down\": \"\\f10e\",\n  \"arrow-90deg-left\": \"\\f10f\",\n  \"arrow-90deg-right\": \"\\f110\",\n  \"arrow-90deg-up\": \"\\f111\",\n  \"arrow-bar-down\": \"\\f112\",\n  \"arrow-bar-left\": \"\\f113\",\n  \"arrow-bar-right\": \"\\f114\",\n  \"arrow-bar-up\": \"\\f115\",\n  \"arrow-clockwise\": \"\\f116\",\n  \"arrow-counterclockwise\": \"\\f117\",\n  \"arrow-down-circle-fill\": \"\\f118\",\n  \"arrow-down-circle\": \"\\f119\",\n  \"arrow-down-left-circle-fill\": \"\\f11a\",\n  \"arrow-down-left-circle\": \"\\f11b\",\n  \"arrow-down-left-square-fill\": \"\\f11c\",\n  \"arrow-down-left-square\": \"\\f11d\",\n  \"arrow-down-left\": \"\\f11e\",\n  \"arrow-down-right-circle-fill\": \"\\f11f\",\n  \"arrow-down-right-circle\": \"\\f120\",\n  \"arrow-down-right-square-fill\": \"\\f121\",\n  \"arrow-down-right-square\": \"\\f122\",\n  \"arrow-down-right\": \"\\f123\",\n  \"arrow-down-short\": \"\\f124\",\n  \"arrow-down-square-fill\": \"\\f125\",\n  \"arrow-down-square\": \"\\f126\",\n  \"arrow-down-up\": \"\\f127\",\n  \"arrow-down\": \"\\f128\",\n  \"arrow-left-circle-fill\": \"\\f129\",\n  \"arrow-left-circle\": \"\\f12a\",\n  \"arrow-left-right\": \"\\f12b\",\n  \"arrow-left-short\": \"\\f12c\",\n  \"arrow-left-square-fill\": \"\\f12d\",\n  \"arrow-left-square\": \"\\f12e\",\n  \"arrow-left\": \"\\f12f\",\n  \"arrow-repeat\": \"\\f130\",\n  \"arrow-return-left\": \"\\f131\",\n  \"arrow-return-right\": \"\\f132\",\n  \"arrow-right-circle-fill\": \"\\f133\",\n  \"arrow-right-circle\": \"\\f134\",\n  \"arrow-right-short\": \"\\f135\",\n  \"arrow-right-square-fill\": \"\\f136\",\n  \"arrow-right-square\": \"\\f137\",\n  \"arrow-right\": \"\\f138\",\n  \"arrow-up-circle-fill\": \"\\f139\",\n  \"arrow-up-circle\": \"\\f13a\",\n  \"arrow-up-left-circle-fill\": \"\\f13b\",\n  \"arrow-up-left-circle\": \"\\f13c\",\n  \"arrow-up-left-square-fill\": \"\\f13d\",\n  \"arrow-up-left-square\": \"\\f13e\",\n  \"arrow-up-left\": \"\\f13f\",\n  \"arrow-up-right-circle-fill\": \"\\f140\",\n  \"arrow-up-right-circle\": \"\\f141\",\n  \"arrow-up-right-square-fill\": \"\\f142\",\n  \"arrow-up-right-square\": \"\\f143\",\n  \"arrow-up-right\": \"\\f144\",\n  \"arrow-up-short\": \"\\f145\",\n  \"arrow-up-square-fill\": \"\\f146\",\n  \"arrow-up-square\": \"\\f147\",\n  \"arrow-up\": \"\\f148\",\n  \"arrows-angle-contract\": \"\\f149\",\n  \"arrows-angle-expand\": \"\\f14a\",\n  \"arrows-collapse\": \"\\f14b\",\n  \"arrows-expand\": \"\\f14c\",\n  \"arrows-fullscreen\": \"\\f14d\",\n  \"arrows-move\": \"\\f14e\",\n  \"aspect-ratio-fill\": \"\\f14f\",\n  \"aspect-ratio\": \"\\f150\",\n  \"asterisk\": \"\\f151\",\n  \"at\": \"\\f152\",\n  \"award-fill\": \"\\f153\",\n  \"award\": \"\\f154\",\n  \"back\": \"\\f155\",\n  \"backspace-fill\": \"\\f156\",\n  \"backspace-reverse-fill\": \"\\f157\",\n  \"backspace-reverse\": \"\\f158\",\n  \"backspace\": \"\\f159\",\n  \"badge-3d-fill\": \"\\f15a\",\n  \"badge-3d\": \"\\f15b\",\n  \"badge-4k-fill\": \"\\f15c\",\n  \"badge-4k\": \"\\f15d\",\n  \"badge-8k-fill\": \"\\f15e\",\n  \"badge-8k\": \"\\f15f\",\n  \"badge-ad-fill\": \"\\f160\",\n  \"badge-ad\": \"\\f161\",\n  \"badge-ar-fill\": \"\\f162\",\n  \"badge-ar\": \"\\f163\",\n  \"badge-cc-fill\": \"\\f164\",\n  \"badge-cc\": \"\\f165\",\n  \"badge-hd-fill\": \"\\f166\",\n  \"badge-hd\": \"\\f167\",\n  \"badge-tm-fill\": \"\\f168\",\n  \"badge-tm\": \"\\f169\",\n  \"badge-vo-fill\": \"\\f16a\",\n  \"badge-vo\": \"\\f16b\",\n  \"badge-vr-fill\": \"\\f16c\",\n  \"badge-vr\": \"\\f16d\",\n  \"badge-wc-fill\": \"\\f16e\",\n  \"badge-wc\": \"\\f16f\",\n  \"bag-check-fill\": \"\\f170\",\n  \"bag-check\": \"\\f171\",\n  \"bag-dash-fill\": \"\\f172\",\n  \"bag-dash\": \"\\f173\",\n  \"bag-fill\": \"\\f174\",\n  \"bag-plus-fill\": \"\\f175\",\n  \"bag-plus\": \"\\f176\",\n  \"bag-x-fill\": \"\\f177\",\n  \"bag-x\": \"\\f178\",\n  \"bag\": \"\\f179\",\n  \"bar-chart-fill\": \"\\f17a\",\n  \"bar-chart-line-fill\": \"\\f17b\",\n  \"bar-chart-line\": \"\\f17c\",\n  \"bar-chart-steps\": \"\\f17d\",\n  \"bar-chart\": \"\\f17e\",\n  \"basket-fill\": \"\\f17f\",\n  \"basket\": \"\\f180\",\n  \"basket2-fill\": \"\\f181\",\n  \"basket2\": \"\\f182\",\n  \"basket3-fill\": \"\\f183\",\n  \"basket3\": \"\\f184\",\n  \"battery-charging\": \"\\f185\",\n  \"battery-full\": \"\\f186\",\n  \"battery-half\": \"\\f187\",\n  \"battery\": \"\\f188\",\n  \"bell-fill\": \"\\f189\",\n  \"bell\": \"\\f18a\",\n  \"bezier\": \"\\f18b\",\n  \"bezier2\": \"\\f18c\",\n  \"bicycle\": \"\\f18d\",\n  \"binoculars-fill\": \"\\f18e\",\n  \"binoculars\": \"\\f18f\",\n  \"blockquote-left\": \"\\f190\",\n  \"blockquote-right\": \"\\f191\",\n  \"book-fill\": \"\\f192\",\n  \"book-half\": \"\\f193\",\n  \"book\": \"\\f194\",\n  \"bookmark-check-fill\": \"\\f195\",\n  \"bookmark-check\": \"\\f196\",\n  \"bookmark-dash-fill\": \"\\f197\",\n  \"bookmark-dash\": \"\\f198\",\n  \"bookmark-fill\": \"\\f199\",\n  \"bookmark-heart-fill\": \"\\f19a\",\n  \"bookmark-heart\": \"\\f19b\",\n  \"bookmark-plus-fill\": \"\\f19c\",\n  \"bookmark-plus\": \"\\f19d\",\n  \"bookmark-star-fill\": \"\\f19e\",\n  \"bookmark-star\": \"\\f19f\",\n  \"bookmark-x-fill\": \"\\f1a0\",\n  \"bookmark-x\": \"\\f1a1\",\n  \"bookmark\": \"\\f1a2\",\n  \"bookmarks-fill\": \"\\f1a3\",\n  \"bookmarks\": \"\\f1a4\",\n  \"bookshelf\": \"\\f1a5\",\n  \"bootstrap-fill\": \"\\f1a6\",\n  \"bootstrap-reboot\": \"\\f1a7\",\n  \"bootstrap\": \"\\f1a8\",\n  \"border-all\": \"\\f1a9\",\n  \"border-bottom\": \"\\f1aa\",\n  \"border-center\": \"\\f1ab\",\n  \"border-inner\": \"\\f1ac\",\n  \"border-left\": \"\\f1ad\",\n  \"border-middle\": \"\\f1ae\",\n  \"border-outer\": \"\\f1af\",\n  \"border-right\": \"\\f1b0\",\n  \"border-style\": \"\\f1b1\",\n  \"border-top\": \"\\f1b2\",\n  \"border-width\": \"\\f1b3\",\n  \"border\": \"\\f1b4\",\n  \"bounding-box-circles\": \"\\f1b5\",\n  \"bounding-box\": \"\\f1b6\",\n  \"box-arrow-down-left\": \"\\f1b7\",\n  \"box-arrow-down-right\": \"\\f1b8\",\n  \"box-arrow-down\": \"\\f1b9\",\n  \"box-arrow-in-down-left\": \"\\f1ba\",\n  \"box-arrow-in-down-right\": \"\\f1bb\",\n  \"box-arrow-in-down\": \"\\f1bc\",\n  \"box-arrow-in-left\": \"\\f1bd\",\n  \"box-arrow-in-right\": \"\\f1be\",\n  \"box-arrow-in-up-left\": \"\\f1bf\",\n  \"box-arrow-in-up-right\": \"\\f1c0\",\n  \"box-arrow-in-up\": \"\\f1c1\",\n  \"box-arrow-left\": \"\\f1c2\",\n  \"box-arrow-right\": \"\\f1c3\",\n  \"box-arrow-up-left\": \"\\f1c4\",\n  \"box-arrow-up-right\": \"\\f1c5\",\n  \"box-arrow-up\": \"\\f1c6\",\n  \"box-seam\": \"\\f1c7\",\n  \"box\": \"\\f1c8\",\n  \"braces\": \"\\f1c9\",\n  \"bricks\": \"\\f1ca\",\n  \"briefcase-fill\": \"\\f1cb\",\n  \"briefcase\": \"\\f1cc\",\n  \"brightness-alt-high-fill\": \"\\f1cd\",\n  \"brightness-alt-high\": \"\\f1ce\",\n  \"brightness-alt-low-fill\": \"\\f1cf\",\n  \"brightness-alt-low\": \"\\f1d0\",\n  \"brightness-high-fill\": \"\\f1d1\",\n  \"brightness-high\": \"\\f1d2\",\n  \"brightness-low-fill\": \"\\f1d3\",\n  \"brightness-low\": \"\\f1d4\",\n  \"broadcast-pin\": \"\\f1d5\",\n  \"broadcast\": \"\\f1d6\",\n  \"brush-fill\": \"\\f1d7\",\n  \"brush\": \"\\f1d8\",\n  \"bucket-fill\": \"\\f1d9\",\n  \"bucket\": \"\\f1da\",\n  \"bug-fill\": \"\\f1db\",\n  \"bug\": \"\\f1dc\",\n  \"building\": \"\\f1dd\",\n  \"bullseye\": \"\\f1de\",\n  \"calculator-fill\": \"\\f1df\",\n  \"calculator\": \"\\f1e0\",\n  \"calendar-check-fill\": \"\\f1e1\",\n  \"calendar-check\": \"\\f1e2\",\n  \"calendar-date-fill\": \"\\f1e3\",\n  \"calendar-date\": \"\\f1e4\",\n  \"calendar-day-fill\": \"\\f1e5\",\n  \"calendar-day\": \"\\f1e6\",\n  \"calendar-event-fill\": \"\\f1e7\",\n  \"calendar-event\": \"\\f1e8\",\n  \"calendar-fill\": \"\\f1e9\",\n  \"calendar-minus-fill\": \"\\f1ea\",\n  \"calendar-minus\": \"\\f1eb\",\n  \"calendar-month-fill\": \"\\f1ec\",\n  \"calendar-month\": \"\\f1ed\",\n  \"calendar-plus-fill\": \"\\f1ee\",\n  \"calendar-plus\": \"\\f1ef\",\n  \"calendar-range-fill\": \"\\f1f0\",\n  \"calendar-range\": \"\\f1f1\",\n  \"calendar-week-fill\": \"\\f1f2\",\n  \"calendar-week\": \"\\f1f3\",\n  \"calendar-x-fill\": \"\\f1f4\",\n  \"calendar-x\": \"\\f1f5\",\n  \"calendar\": \"\\f1f6\",\n  \"calendar2-check-fill\": \"\\f1f7\",\n  \"calendar2-check\": \"\\f1f8\",\n  \"calendar2-date-fill\": \"\\f1f9\",\n  \"calendar2-date\": \"\\f1fa\",\n  \"calendar2-day-fill\": \"\\f1fb\",\n  \"calendar2-day\": \"\\f1fc\",\n  \"calendar2-event-fill\": \"\\f1fd\",\n  \"calendar2-event\": \"\\f1fe\",\n  \"calendar2-fill\": \"\\f1ff\",\n  \"calendar2-minus-fill\": \"\\f200\",\n  \"calendar2-minus\": \"\\f201\",\n  \"calendar2-month-fill\": \"\\f202\",\n  \"calendar2-month\": \"\\f203\",\n  \"calendar2-plus-fill\": \"\\f204\",\n  \"calendar2-plus\": \"\\f205\",\n  \"calendar2-range-fill\": \"\\f206\",\n  \"calendar2-range\": \"\\f207\",\n  \"calendar2-week-fill\": \"\\f208\",\n  \"calendar2-week\": \"\\f209\",\n  \"calendar2-x-fill\": \"\\f20a\",\n  \"calendar2-x\": \"\\f20b\",\n  \"calendar2\": \"\\f20c\",\n  \"calendar3-event-fill\": \"\\f20d\",\n  \"calendar3-event\": \"\\f20e\",\n  \"calendar3-fill\": \"\\f20f\",\n  \"calendar3-range-fill\": \"\\f210\",\n  \"calendar3-range\": \"\\f211\",\n  \"calendar3-week-fill\": \"\\f212\",\n  \"calendar3-week\": \"\\f213\",\n  \"calendar3\": \"\\f214\",\n  \"calendar4-event\": \"\\f215\",\n  \"calendar4-range\": \"\\f216\",\n  \"calendar4-week\": \"\\f217\",\n  \"calendar4\": \"\\f218\",\n  \"camera-fill\": \"\\f219\",\n  \"camera-reels-fill\": \"\\f21a\",\n  \"camera-reels\": \"\\f21b\",\n  \"camera-video-fill\": \"\\f21c\",\n  \"camera-video-off-fill\": \"\\f21d\",\n  \"camera-video-off\": \"\\f21e\",\n  \"camera-video\": \"\\f21f\",\n  \"camera\": \"\\f220\",\n  \"camera2\": \"\\f221\",\n  \"capslock-fill\": \"\\f222\",\n  \"capslock\": \"\\f223\",\n  \"card-checklist\": \"\\f224\",\n  \"card-heading\": \"\\f225\",\n  \"card-image\": \"\\f226\",\n  \"card-list\": \"\\f227\",\n  \"card-text\": \"\\f228\",\n  \"caret-down-fill\": \"\\f229\",\n  \"caret-down-square-fill\": \"\\f22a\",\n  \"caret-down-square\": \"\\f22b\",\n  \"caret-down\": \"\\f22c\",\n  \"caret-left-fill\": \"\\f22d\",\n  \"caret-left-square-fill\": \"\\f22e\",\n  \"caret-left-square\": \"\\f22f\",\n  \"caret-left\": \"\\f230\",\n  \"caret-right-fill\": \"\\f231\",\n  \"caret-right-square-fill\": \"\\f232\",\n  \"caret-right-square\": \"\\f233\",\n  \"caret-right\": \"\\f234\",\n  \"caret-up-fill\": \"\\f235\",\n  \"caret-up-square-fill\": \"\\f236\",\n  \"caret-up-square\": \"\\f237\",\n  \"caret-up\": \"\\f238\",\n  \"cart-check-fill\": \"\\f239\",\n  \"cart-check\": \"\\f23a\",\n  \"cart-dash-fill\": \"\\f23b\",\n  \"cart-dash\": \"\\f23c\",\n  \"cart-fill\": \"\\f23d\",\n  \"cart-plus-fill\": \"\\f23e\",\n  \"cart-plus\": \"\\f23f\",\n  \"cart-x-fill\": \"\\f240\",\n  \"cart-x\": \"\\f241\",\n  \"cart\": \"\\f242\",\n  \"cart2\": \"\\f243\",\n  \"cart3\": \"\\f244\",\n  \"cart4\": \"\\f245\",\n  \"cash-stack\": \"\\f246\",\n  \"cash\": \"\\f247\",\n  \"cast\": \"\\f248\",\n  \"chat-dots-fill\": \"\\f249\",\n  \"chat-dots\": \"\\f24a\",\n  \"chat-fill\": \"\\f24b\",\n  \"chat-left-dots-fill\": \"\\f24c\",\n  \"chat-left-dots\": \"\\f24d\",\n  \"chat-left-fill\": \"\\f24e\",\n  \"chat-left-quote-fill\": \"\\f24f\",\n  \"chat-left-quote\": \"\\f250\",\n  \"chat-left-text-fill\": \"\\f251\",\n  \"chat-left-text\": \"\\f252\",\n  \"chat-left\": \"\\f253\",\n  \"chat-quote-fill\": \"\\f254\",\n  \"chat-quote\": \"\\f255\",\n  \"chat-right-dots-fill\": \"\\f256\",\n  \"chat-right-dots\": \"\\f257\",\n  \"chat-right-fill\": \"\\f258\",\n  \"chat-right-quote-fill\": \"\\f259\",\n  \"chat-right-quote\": \"\\f25a\",\n  \"chat-right-text-fill\": \"\\f25b\",\n  \"chat-right-text\": \"\\f25c\",\n  \"chat-right\": \"\\f25d\",\n  \"chat-square-dots-fill\": \"\\f25e\",\n  \"chat-square-dots\": \"\\f25f\",\n  \"chat-square-fill\": \"\\f260\",\n  \"chat-square-quote-fill\": \"\\f261\",\n  \"chat-square-quote\": \"\\f262\",\n  \"chat-square-text-fill\": \"\\f263\",\n  \"chat-square-text\": \"\\f264\",\n  \"chat-square\": \"\\f265\",\n  \"chat-text-fill\": \"\\f266\",\n  \"chat-text\": \"\\f267\",\n  \"chat\": \"\\f268\",\n  \"check-all\": \"\\f269\",\n  \"check-circle-fill\": \"\\f26a\",\n  \"check-circle\": \"\\f26b\",\n  \"check-square-fill\": \"\\f26c\",\n  \"check-square\": \"\\f26d\",\n  \"check\": \"\\f26e\",\n  \"check2-all\": \"\\f26f\",\n  \"check2-circle\": \"\\f270\",\n  \"check2-square\": \"\\f271\",\n  \"check2\": \"\\f272\",\n  \"chevron-bar-contract\": \"\\f273\",\n  \"chevron-bar-down\": \"\\f274\",\n  \"chevron-bar-expand\": \"\\f275\",\n  \"chevron-bar-left\": \"\\f276\",\n  \"chevron-bar-right\": \"\\f277\",\n  \"chevron-bar-up\": \"\\f278\",\n  \"chevron-compact-down\": \"\\f279\",\n  \"chevron-compact-left\": \"\\f27a\",\n  \"chevron-compact-right\": \"\\f27b\",\n  \"chevron-compact-up\": \"\\f27c\",\n  \"chevron-contract\": \"\\f27d\",\n  \"chevron-double-down\": \"\\f27e\",\n  \"chevron-double-left\": \"\\f27f\",\n  \"chevron-double-right\": \"\\f280\",\n  \"chevron-double-up\": \"\\f281\",\n  \"chevron-down\": \"\\f282\",\n  \"chevron-expand\": \"\\f283\",\n  \"chevron-left\": \"\\f284\",\n  \"chevron-right\": \"\\f285\",\n  \"chevron-up\": \"\\f286\",\n  \"circle-fill\": \"\\f287\",\n  \"circle-half\": \"\\f288\",\n  \"circle-square\": \"\\f289\",\n  \"circle\": \"\\f28a\",\n  \"clipboard-check\": \"\\f28b\",\n  \"clipboard-data\": \"\\f28c\",\n  \"clipboard-minus\": \"\\f28d\",\n  \"clipboard-plus\": \"\\f28e\",\n  \"clipboard-x\": \"\\f28f\",\n  \"clipboard\": \"\\f290\",\n  \"clock-fill\": \"\\f291\",\n  \"clock-history\": \"\\f292\",\n  \"clock\": \"\\f293\",\n  \"cloud-arrow-down-fill\": \"\\f294\",\n  \"cloud-arrow-down\": \"\\f295\",\n  \"cloud-arrow-up-fill\": \"\\f296\",\n  \"cloud-arrow-up\": \"\\f297\",\n  \"cloud-check-fill\": \"\\f298\",\n  \"cloud-check\": \"\\f299\",\n  \"cloud-download-fill\": \"\\f29a\",\n  \"cloud-download\": \"\\f29b\",\n  \"cloud-drizzle-fill\": \"\\f29c\",\n  \"cloud-drizzle\": \"\\f29d\",\n  \"cloud-fill\": \"\\f29e\",\n  \"cloud-fog-fill\": \"\\f29f\",\n  \"cloud-fog\": \"\\f2a0\",\n  \"cloud-fog2-fill\": \"\\f2a1\",\n  \"cloud-fog2\": \"\\f2a2\",\n  \"cloud-hail-fill\": \"\\f2a3\",\n  \"cloud-hail\": \"\\f2a4\",\n  \"cloud-haze-fill\": \"\\f2a6\",\n  \"cloud-haze\": \"\\f2a7\",\n  \"cloud-haze2-fill\": \"\\f2a8\",\n  \"cloud-lightning-fill\": \"\\f2a9\",\n  \"cloud-lightning-rain-fill\": \"\\f2aa\",\n  \"cloud-lightning-rain\": \"\\f2ab\",\n  \"cloud-lightning\": \"\\f2ac\",\n  \"cloud-minus-fill\": \"\\f2ad\",\n  \"cloud-minus\": \"\\f2ae\",\n  \"cloud-moon-fill\": \"\\f2af\",\n  \"cloud-moon\": \"\\f2b0\",\n  \"cloud-plus-fill\": \"\\f2b1\",\n  \"cloud-plus\": \"\\f2b2\",\n  \"cloud-rain-fill\": \"\\f2b3\",\n  \"cloud-rain-heavy-fill\": \"\\f2b4\",\n  \"cloud-rain-heavy\": \"\\f2b5\",\n  \"cloud-rain\": \"\\f2b6\",\n  \"cloud-slash-fill\": \"\\f2b7\",\n  \"cloud-slash\": \"\\f2b8\",\n  \"cloud-sleet-fill\": \"\\f2b9\",\n  \"cloud-sleet\": \"\\f2ba\",\n  \"cloud-snow-fill\": \"\\f2bb\",\n  \"cloud-snow\": \"\\f2bc\",\n  \"cloud-sun-fill\": \"\\f2bd\",\n  \"cloud-sun\": \"\\f2be\",\n  \"cloud-upload-fill\": \"\\f2bf\",\n  \"cloud-upload\": \"\\f2c0\",\n  \"cloud\": \"\\f2c1\",\n  \"clouds-fill\": \"\\f2c2\",\n  \"clouds\": \"\\f2c3\",\n  \"cloudy-fill\": \"\\f2c4\",\n  \"cloudy\": \"\\f2c5\",\n  \"code-slash\": \"\\f2c6\",\n  \"code-square\": \"\\f2c7\",\n  \"code\": \"\\f2c8\",\n  \"collection-fill\": \"\\f2c9\",\n  \"collection-play-fill\": \"\\f2ca\",\n  \"collection-play\": \"\\f2cb\",\n  \"collection\": \"\\f2cc\",\n  \"columns-gap\": \"\\f2cd\",\n  \"columns\": \"\\f2ce\",\n  \"command\": \"\\f2cf\",\n  \"compass-fill\": \"\\f2d0\",\n  \"compass\": \"\\f2d1\",\n  \"cone-striped\": \"\\f2d2\",\n  \"cone\": \"\\f2d3\",\n  \"controller\": \"\\f2d4\",\n  \"cpu-fill\": \"\\f2d5\",\n  \"cpu\": \"\\f2d6\",\n  \"credit-card-2-back-fill\": \"\\f2d7\",\n  \"credit-card-2-back\": \"\\f2d8\",\n  \"credit-card-2-front-fill\": \"\\f2d9\",\n  \"credit-card-2-front\": \"\\f2da\",\n  \"credit-card-fill\": \"\\f2db\",\n  \"credit-card\": \"\\f2dc\",\n  \"crop\": \"\\f2dd\",\n  \"cup-fill\": \"\\f2de\",\n  \"cup-straw\": \"\\f2df\",\n  \"cup\": \"\\f2e0\",\n  \"cursor-fill\": \"\\f2e1\",\n  \"cursor-text\": \"\\f2e2\",\n  \"cursor\": \"\\f2e3\",\n  \"dash-circle-dotted\": \"\\f2e4\",\n  \"dash-circle-fill\": \"\\f2e5\",\n  \"dash-circle\": \"\\f2e6\",\n  \"dash-square-dotted\": \"\\f2e7\",\n  \"dash-square-fill\": \"\\f2e8\",\n  \"dash-square\": \"\\f2e9\",\n  \"dash\": \"\\f2ea\",\n  \"diagram-2-fill\": \"\\f2eb\",\n  \"diagram-2\": \"\\f2ec\",\n  \"diagram-3-fill\": \"\\f2ed\",\n  \"diagram-3\": \"\\f2ee\",\n  \"diamond-fill\": \"\\f2ef\",\n  \"diamond-half\": \"\\f2f0\",\n  \"diamond\": \"\\f2f1\",\n  \"dice-1-fill\": \"\\f2f2\",\n  \"dice-1\": \"\\f2f3\",\n  \"dice-2-fill\": \"\\f2f4\",\n  \"dice-2\": \"\\f2f5\",\n  \"dice-3-fill\": \"\\f2f6\",\n  \"dice-3\": \"\\f2f7\",\n  \"dice-4-fill\": \"\\f2f8\",\n  \"dice-4\": \"\\f2f9\",\n  \"dice-5-fill\": \"\\f2fa\",\n  \"dice-5\": \"\\f2fb\",\n  \"dice-6-fill\": \"\\f2fc\",\n  \"dice-6\": \"\\f2fd\",\n  \"disc-fill\": \"\\f2fe\",\n  \"disc\": \"\\f2ff\",\n  \"discord\": \"\\f300\",\n  \"display-fill\": \"\\f301\",\n  \"display\": \"\\f302\",\n  \"distribute-horizontal\": \"\\f303\",\n  \"distribute-vertical\": \"\\f304\",\n  \"door-closed-fill\": \"\\f305\",\n  \"door-closed\": \"\\f306\",\n  \"door-open-fill\": \"\\f307\",\n  \"door-open\": \"\\f308\",\n  \"dot\": \"\\f309\",\n  \"download\": \"\\f30a\",\n  \"droplet-fill\": \"\\f30b\",\n  \"droplet-half\": \"\\f30c\",\n  \"droplet\": \"\\f30d\",\n  \"earbuds\": \"\\f30e\",\n  \"easel-fill\": \"\\f30f\",\n  \"easel\": \"\\f310\",\n  \"egg-fill\": \"\\f311\",\n  \"egg-fried\": \"\\f312\",\n  \"egg\": \"\\f313\",\n  \"eject-fill\": \"\\f314\",\n  \"eject\": \"\\f315\",\n  \"emoji-angry-fill\": \"\\f316\",\n  \"emoji-angry\": \"\\f317\",\n  \"emoji-dizzy-fill\": \"\\f318\",\n  \"emoji-dizzy\": \"\\f319\",\n  \"emoji-expressionless-fill\": \"\\f31a\",\n  \"emoji-expressionless\": \"\\f31b\",\n  \"emoji-frown-fill\": \"\\f31c\",\n  \"emoji-frown\": \"\\f31d\",\n  \"emoji-heart-eyes-fill\": \"\\f31e\",\n  \"emoji-heart-eyes\": \"\\f31f\",\n  \"emoji-laughing-fill\": \"\\f320\",\n  \"emoji-laughing\": \"\\f321\",\n  \"emoji-neutral-fill\": \"\\f322\",\n  \"emoji-neutral\": \"\\f323\",\n  \"emoji-smile-fill\": \"\\f324\",\n  \"emoji-smile-upside-down-fill\": \"\\f325\",\n  \"emoji-smile-upside-down\": \"\\f326\",\n  \"emoji-smile\": \"\\f327\",\n  \"emoji-sunglasses-fill\": \"\\f328\",\n  \"emoji-sunglasses\": \"\\f329\",\n  \"emoji-wink-fill\": \"\\f32a\",\n  \"emoji-wink\": \"\\f32b\",\n  \"envelope-fill\": \"\\f32c\",\n  \"envelope-open-fill\": \"\\f32d\",\n  \"envelope-open\": \"\\f32e\",\n  \"envelope\": \"\\f32f\",\n  \"eraser-fill\": \"\\f330\",\n  \"eraser\": \"\\f331\",\n  \"exclamation-circle-fill\": \"\\f332\",\n  \"exclamation-circle\": \"\\f333\",\n  \"exclamation-diamond-fill\": \"\\f334\",\n  \"exclamation-diamond\": \"\\f335\",\n  \"exclamation-octagon-fill\": \"\\f336\",\n  \"exclamation-octagon\": \"\\f337\",\n  \"exclamation-square-fill\": \"\\f338\",\n  \"exclamation-square\": \"\\f339\",\n  \"exclamation-triangle-fill\": \"\\f33a\",\n  \"exclamation-triangle\": \"\\f33b\",\n  \"exclamation\": \"\\f33c\",\n  \"exclude\": \"\\f33d\",\n  \"eye-fill\": \"\\f33e\",\n  \"eye-slash-fill\": \"\\f33f\",\n  \"eye-slash\": \"\\f340\",\n  \"eye\": \"\\f341\",\n  \"eyedropper\": \"\\f342\",\n  \"eyeglasses\": \"\\f343\",\n  \"facebook\": \"\\f344\",\n  \"file-arrow-down-fill\": \"\\f345\",\n  \"file-arrow-down\": \"\\f346\",\n  \"file-arrow-up-fill\": \"\\f347\",\n  \"file-arrow-up\": \"\\f348\",\n  \"file-bar-graph-fill\": \"\\f349\",\n  \"file-bar-graph\": \"\\f34a\",\n  \"file-binary-fill\": \"\\f34b\",\n  \"file-binary\": \"\\f34c\",\n  \"file-break-fill\": \"\\f34d\",\n  \"file-break\": \"\\f34e\",\n  \"file-check-fill\": \"\\f34f\",\n  \"file-check\": \"\\f350\",\n  \"file-code-fill\": \"\\f351\",\n  \"file-code\": \"\\f352\",\n  \"file-diff-fill\": \"\\f353\",\n  \"file-diff\": \"\\f354\",\n  \"file-earmark-arrow-down-fill\": \"\\f355\",\n  \"file-earmark-arrow-down\": \"\\f356\",\n  \"file-earmark-arrow-up-fill\": \"\\f357\",\n  \"file-earmark-arrow-up\": \"\\f358\",\n  \"file-earmark-bar-graph-fill\": \"\\f359\",\n  \"file-earmark-bar-graph\": \"\\f35a\",\n  \"file-earmark-binary-fill\": \"\\f35b\",\n  \"file-earmark-binary\": \"\\f35c\",\n  \"file-earmark-break-fill\": \"\\f35d\",\n  \"file-earmark-break\": \"\\f35e\",\n  \"file-earmark-check-fill\": \"\\f35f\",\n  \"file-earmark-check\": \"\\f360\",\n  \"file-earmark-code-fill\": \"\\f361\",\n  \"file-earmark-code\": \"\\f362\",\n  \"file-earmark-diff-fill\": \"\\f363\",\n  \"file-earmark-diff\": \"\\f364\",\n  \"file-earmark-easel-fill\": \"\\f365\",\n  \"file-earmark-easel\": \"\\f366\",\n  \"file-earmark-excel-fill\": \"\\f367\",\n  \"file-earmark-excel\": \"\\f368\",\n  \"file-earmark-fill\": \"\\f369\",\n  \"file-earmark-font-fill\": \"\\f36a\",\n  \"file-earmark-font\": \"\\f36b\",\n  \"file-earmark-image-fill\": \"\\f36c\",\n  \"file-earmark-image\": \"\\f36d\",\n  \"file-earmark-lock-fill\": \"\\f36e\",\n  \"file-earmark-lock\": \"\\f36f\",\n  \"file-earmark-lock2-fill\": \"\\f370\",\n  \"file-earmark-lock2\": \"\\f371\",\n  \"file-earmark-medical-fill\": \"\\f372\",\n  \"file-earmark-medical\": \"\\f373\",\n  \"file-earmark-minus-fill\": \"\\f374\",\n  \"file-earmark-minus\": \"\\f375\",\n  \"file-earmark-music-fill\": \"\\f376\",\n  \"file-earmark-music\": \"\\f377\",\n  \"file-earmark-person-fill\": \"\\f378\",\n  \"file-earmark-person\": \"\\f379\",\n  \"file-earmark-play-fill\": \"\\f37a\",\n  \"file-earmark-play\": \"\\f37b\",\n  \"file-earmark-plus-fill\": \"\\f37c\",\n  \"file-earmark-plus\": \"\\f37d\",\n  \"file-earmark-post-fill\": \"\\f37e\",\n  \"file-earmark-post\": \"\\f37f\",\n  \"file-earmark-ppt-fill\": \"\\f380\",\n  \"file-earmark-ppt\": \"\\f381\",\n  \"file-earmark-richtext-fill\": \"\\f382\",\n  \"file-earmark-richtext\": \"\\f383\",\n  \"file-earmark-ruled-fill\": \"\\f384\",\n  \"file-earmark-ruled\": \"\\f385\",\n  \"file-earmark-slides-fill\": \"\\f386\",\n  \"file-earmark-slides\": \"\\f387\",\n  \"file-earmark-spreadsheet-fill\": \"\\f388\",\n  \"file-earmark-spreadsheet\": \"\\f389\",\n  \"file-earmark-text-fill\": \"\\f38a\",\n  \"file-earmark-text\": \"\\f38b\",\n  \"file-earmark-word-fill\": \"\\f38c\",\n  \"file-earmark-word\": \"\\f38d\",\n  \"file-earmark-x-fill\": \"\\f38e\",\n  \"file-earmark-x\": \"\\f38f\",\n  \"file-earmark-zip-fill\": \"\\f390\",\n  \"file-earmark-zip\": \"\\f391\",\n  \"file-earmark\": \"\\f392\",\n  \"file-easel-fill\": \"\\f393\",\n  \"file-easel\": \"\\f394\",\n  \"file-excel-fill\": \"\\f395\",\n  \"file-excel\": \"\\f396\",\n  \"file-fill\": \"\\f397\",\n  \"file-font-fill\": \"\\f398\",\n  \"file-font\": \"\\f399\",\n  \"file-image-fill\": \"\\f39a\",\n  \"file-image\": \"\\f39b\",\n  \"file-lock-fill\": \"\\f39c\",\n  \"file-lock\": \"\\f39d\",\n  \"file-lock2-fill\": \"\\f39e\",\n  \"file-lock2\": \"\\f39f\",\n  \"file-medical-fill\": \"\\f3a0\",\n  \"file-medical\": \"\\f3a1\",\n  \"file-minus-fill\": \"\\f3a2\",\n  \"file-minus\": \"\\f3a3\",\n  \"file-music-fill\": \"\\f3a4\",\n  \"file-music\": \"\\f3a5\",\n  \"file-person-fill\": \"\\f3a6\",\n  \"file-person\": \"\\f3a7\",\n  \"file-play-fill\": \"\\f3a8\",\n  \"file-play\": \"\\f3a9\",\n  \"file-plus-fill\": \"\\f3aa\",\n  \"file-plus\": \"\\f3ab\",\n  \"file-post-fill\": \"\\f3ac\",\n  \"file-post\": \"\\f3ad\",\n  \"file-ppt-fill\": \"\\f3ae\",\n  \"file-ppt\": \"\\f3af\",\n  \"file-richtext-fill\": \"\\f3b0\",\n  \"file-richtext\": \"\\f3b1\",\n  \"file-ruled-fill\": \"\\f3b2\",\n  \"file-ruled\": \"\\f3b3\",\n  \"file-slides-fill\": \"\\f3b4\",\n  \"file-slides\": \"\\f3b5\",\n  \"file-spreadsheet-fill\": \"\\f3b6\",\n  \"file-spreadsheet\": \"\\f3b7\",\n  \"file-text-fill\": \"\\f3b8\",\n  \"file-text\": \"\\f3b9\",\n  \"file-word-fill\": \"\\f3ba\",\n  \"file-word\": \"\\f3bb\",\n  \"file-x-fill\": \"\\f3bc\",\n  \"file-x\": \"\\f3bd\",\n  \"file-zip-fill\": \"\\f3be\",\n  \"file-zip\": \"\\f3bf\",\n  \"file\": \"\\f3c0\",\n  \"files-alt\": \"\\f3c1\",\n  \"files\": \"\\f3c2\",\n  \"film\": \"\\f3c3\",\n  \"filter-circle-fill\": \"\\f3c4\",\n  \"filter-circle\": \"\\f3c5\",\n  \"filter-left\": \"\\f3c6\",\n  \"filter-right\": \"\\f3c7\",\n  \"filter-square-fill\": \"\\f3c8\",\n  \"filter-square\": \"\\f3c9\",\n  \"filter\": \"\\f3ca\",\n  \"flag-fill\": \"\\f3cb\",\n  \"flag\": \"\\f3cc\",\n  \"flower1\": \"\\f3cd\",\n  \"flower2\": \"\\f3ce\",\n  \"flower3\": \"\\f3cf\",\n  \"folder-check\": \"\\f3d0\",\n  \"folder-fill\": \"\\f3d1\",\n  \"folder-minus\": \"\\f3d2\",\n  \"folder-plus\": \"\\f3d3\",\n  \"folder-symlink-fill\": \"\\f3d4\",\n  \"folder-symlink\": \"\\f3d5\",\n  \"folder-x\": \"\\f3d6\",\n  \"folder\": \"\\f3d7\",\n  \"folder2-open\": \"\\f3d8\",\n  \"folder2\": \"\\f3d9\",\n  \"fonts\": \"\\f3da\",\n  \"forward-fill\": \"\\f3db\",\n  \"forward\": \"\\f3dc\",\n  \"front\": \"\\f3dd\",\n  \"fullscreen-exit\": \"\\f3de\",\n  \"fullscreen\": \"\\f3df\",\n  \"funnel-fill\": \"\\f3e0\",\n  \"funnel\": \"\\f3e1\",\n  \"gear-fill\": \"\\f3e2\",\n  \"gear-wide-connected\": \"\\f3e3\",\n  \"gear-wide\": \"\\f3e4\",\n  \"gear\": \"\\f3e5\",\n  \"gem\": \"\\f3e6\",\n  \"geo-alt-fill\": \"\\f3e7\",\n  \"geo-alt\": \"\\f3e8\",\n  \"geo-fill\": \"\\f3e9\",\n  \"geo\": \"\\f3ea\",\n  \"gift-fill\": \"\\f3eb\",\n  \"gift\": \"\\f3ec\",\n  \"github\": \"\\f3ed\",\n  \"globe\": \"\\f3ee\",\n  \"globe2\": \"\\f3ef\",\n  \"google\": \"\\f3f0\",\n  \"graph-down\": \"\\f3f1\",\n  \"graph-up\": \"\\f3f2\",\n  \"grid-1x2-fill\": \"\\f3f3\",\n  \"grid-1x2\": \"\\f3f4\",\n  \"grid-3x2-gap-fill\": \"\\f3f5\",\n  \"grid-3x2-gap\": \"\\f3f6\",\n  \"grid-3x2\": \"\\f3f7\",\n  \"grid-3x3-gap-fill\": \"\\f3f8\",\n  \"grid-3x3-gap\": \"\\f3f9\",\n  \"grid-3x3\": \"\\f3fa\",\n  \"grid-fill\": \"\\f3fb\",\n  \"grid\": \"\\f3fc\",\n  \"grip-horizontal\": \"\\f3fd\",\n  \"grip-vertical\": \"\\f3fe\",\n  \"hammer\": \"\\f3ff\",\n  \"hand-index-fill\": \"\\f400\",\n  \"hand-index-thumb-fill\": \"\\f401\",\n  \"hand-index-thumb\": \"\\f402\",\n  \"hand-index\": \"\\f403\",\n  \"hand-thumbs-down-fill\": \"\\f404\",\n  \"hand-thumbs-down\": \"\\f405\",\n  \"hand-thumbs-up-fill\": \"\\f406\",\n  \"hand-thumbs-up\": \"\\f407\",\n  \"handbag-fill\": \"\\f408\",\n  \"handbag\": \"\\f409\",\n  \"hash\": \"\\f40a\",\n  \"hdd-fill\": \"\\f40b\",\n  \"hdd-network-fill\": \"\\f40c\",\n  \"hdd-network\": \"\\f40d\",\n  \"hdd-rack-fill\": \"\\f40e\",\n  \"hdd-rack\": \"\\f40f\",\n  \"hdd-stack-fill\": \"\\f410\",\n  \"hdd-stack\": \"\\f411\",\n  \"hdd\": \"\\f412\",\n  \"headphones\": \"\\f413\",\n  \"headset\": \"\\f414\",\n  \"heart-fill\": \"\\f415\",\n  \"heart-half\": \"\\f416\",\n  \"heart\": \"\\f417\",\n  \"heptagon-fill\": \"\\f418\",\n  \"heptagon-half\": \"\\f419\",\n  \"heptagon\": \"\\f41a\",\n  \"hexagon-fill\": \"\\f41b\",\n  \"hexagon-half\": \"\\f41c\",\n  \"hexagon\": \"\\f41d\",\n  \"hourglass-bottom\": \"\\f41e\",\n  \"hourglass-split\": \"\\f41f\",\n  \"hourglass-top\": \"\\f420\",\n  \"hourglass\": \"\\f421\",\n  \"house-door-fill\": \"\\f422\",\n  \"house-door\": \"\\f423\",\n  \"house-fill\": \"\\f424\",\n  \"house\": \"\\f425\",\n  \"hr\": \"\\f426\",\n  \"hurricane\": \"\\f427\",\n  \"image-alt\": \"\\f428\",\n  \"image-fill\": \"\\f429\",\n  \"image\": \"\\f42a\",\n  \"images\": \"\\f42b\",\n  \"inbox-fill\": \"\\f42c\",\n  \"inbox\": \"\\f42d\",\n  \"inboxes-fill\": \"\\f42e\",\n  \"inboxes\": \"\\f42f\",\n  \"info-circle-fill\": \"\\f430\",\n  \"info-circle\": \"\\f431\",\n  \"info-square-fill\": \"\\f432\",\n  \"info-square\": \"\\f433\",\n  \"info\": \"\\f434\",\n  \"input-cursor-text\": \"\\f435\",\n  \"input-cursor\": \"\\f436\",\n  \"instagram\": \"\\f437\",\n  \"intersect\": \"\\f438\",\n  \"journal-album\": \"\\f439\",\n  \"journal-arrow-down\": \"\\f43a\",\n  \"journal-arrow-up\": \"\\f43b\",\n  \"journal-bookmark-fill\": \"\\f43c\",\n  \"journal-bookmark\": \"\\f43d\",\n  \"journal-check\": \"\\f43e\",\n  \"journal-code\": \"\\f43f\",\n  \"journal-medical\": \"\\f440\",\n  \"journal-minus\": \"\\f441\",\n  \"journal-plus\": \"\\f442\",\n  \"journal-richtext\": \"\\f443\",\n  \"journal-text\": \"\\f444\",\n  \"journal-x\": \"\\f445\",\n  \"journal\": \"\\f446\",\n  \"journals\": \"\\f447\",\n  \"joystick\": \"\\f448\",\n  \"justify-left\": \"\\f449\",\n  \"justify-right\": \"\\f44a\",\n  \"justify\": \"\\f44b\",\n  \"kanban-fill\": \"\\f44c\",\n  \"kanban\": \"\\f44d\",\n  \"key-fill\": \"\\f44e\",\n  \"key\": \"\\f44f\",\n  \"keyboard-fill\": \"\\f450\",\n  \"keyboard\": \"\\f451\",\n  \"ladder\": \"\\f452\",\n  \"lamp-fill\": \"\\f453\",\n  \"lamp\": \"\\f454\",\n  \"laptop-fill\": \"\\f455\",\n  \"laptop\": \"\\f456\",\n  \"layer-backward\": \"\\f457\",\n  \"layer-forward\": \"\\f458\",\n  \"layers-fill\": \"\\f459\",\n  \"layers-half\": \"\\f45a\",\n  \"layers\": \"\\f45b\",\n  \"layout-sidebar-inset-reverse\": \"\\f45c\",\n  \"layout-sidebar-inset\": \"\\f45d\",\n  \"layout-sidebar-reverse\": \"\\f45e\",\n  \"layout-sidebar\": \"\\f45f\",\n  \"layout-split\": \"\\f460\",\n  \"layout-text-sidebar-reverse\": \"\\f461\",\n  \"layout-text-sidebar\": \"\\f462\",\n  \"layout-text-window-reverse\": \"\\f463\",\n  \"layout-text-window\": \"\\f464\",\n  \"layout-three-columns\": \"\\f465\",\n  \"layout-wtf\": \"\\f466\",\n  \"life-preserver\": \"\\f467\",\n  \"lightbulb-fill\": \"\\f468\",\n  \"lightbulb-off-fill\": \"\\f469\",\n  \"lightbulb-off\": \"\\f46a\",\n  \"lightbulb\": \"\\f46b\",\n  \"lightning-charge-fill\": \"\\f46c\",\n  \"lightning-charge\": \"\\f46d\",\n  \"lightning-fill\": \"\\f46e\",\n  \"lightning\": \"\\f46f\",\n  \"link-45deg\": \"\\f470\",\n  \"link\": \"\\f471\",\n  \"linkedin\": \"\\f472\",\n  \"list-check\": \"\\f473\",\n  \"list-nested\": \"\\f474\",\n  \"list-ol\": \"\\f475\",\n  \"list-stars\": \"\\f476\",\n  \"list-task\": \"\\f477\",\n  \"list-ul\": \"\\f478\",\n  \"list\": \"\\f479\",\n  \"lock-fill\": \"\\f47a\",\n  \"lock\": \"\\f47b\",\n  \"mailbox\": \"\\f47c\",\n  \"mailbox2\": \"\\f47d\",\n  \"map-fill\": \"\\f47e\",\n  \"map\": \"\\f47f\",\n  \"markdown-fill\": \"\\f480\",\n  \"markdown\": \"\\f481\",\n  \"mask\": \"\\f482\",\n  \"megaphone-fill\": \"\\f483\",\n  \"megaphone\": \"\\f484\",\n  \"menu-app-fill\": \"\\f485\",\n  \"menu-app\": \"\\f486\",\n  \"menu-button-fill\": \"\\f487\",\n  \"menu-button-wide-fill\": \"\\f488\",\n  \"menu-button-wide\": \"\\f489\",\n  \"menu-button\": \"\\f48a\",\n  \"menu-down\": \"\\f48b\",\n  \"menu-up\": \"\\f48c\",\n  \"mic-fill\": \"\\f48d\",\n  \"mic-mute-fill\": \"\\f48e\",\n  \"mic-mute\": \"\\f48f\",\n  \"mic\": \"\\f490\",\n  \"minecart-loaded\": \"\\f491\",\n  \"minecart\": \"\\f492\",\n  \"moisture\": \"\\f493\",\n  \"moon-fill\": \"\\f494\",\n  \"moon-stars-fill\": \"\\f495\",\n  \"moon-stars\": \"\\f496\",\n  \"moon\": \"\\f497\",\n  \"mouse-fill\": \"\\f498\",\n  \"mouse\": \"\\f499\",\n  \"mouse2-fill\": \"\\f49a\",\n  \"mouse2\": \"\\f49b\",\n  \"mouse3-fill\": \"\\f49c\",\n  \"mouse3\": \"\\f49d\",\n  \"music-note-beamed\": \"\\f49e\",\n  \"music-note-list\": \"\\f49f\",\n  \"music-note\": \"\\f4a0\",\n  \"music-player-fill\": \"\\f4a1\",\n  \"music-player\": \"\\f4a2\",\n  \"newspaper\": \"\\f4a3\",\n  \"node-minus-fill\": \"\\f4a4\",\n  \"node-minus\": \"\\f4a5\",\n  \"node-plus-fill\": \"\\f4a6\",\n  \"node-plus\": \"\\f4a7\",\n  \"nut-fill\": \"\\f4a8\",\n  \"nut\": \"\\f4a9\",\n  \"octagon-fill\": \"\\f4aa\",\n  \"octagon-half\": \"\\f4ab\",\n  \"octagon\": \"\\f4ac\",\n  \"option\": \"\\f4ad\",\n  \"outlet\": \"\\f4ae\",\n  \"paint-bucket\": \"\\f4af\",\n  \"palette-fill\": \"\\f4b0\",\n  \"palette\": \"\\f4b1\",\n  \"palette2\": \"\\f4b2\",\n  \"paperclip\": \"\\f4b3\",\n  \"paragraph\": \"\\f4b4\",\n  \"patch-check-fill\": \"\\f4b5\",\n  \"patch-check\": \"\\f4b6\",\n  \"patch-exclamation-fill\": \"\\f4b7\",\n  \"patch-exclamation\": \"\\f4b8\",\n  \"patch-minus-fill\": \"\\f4b9\",\n  \"patch-minus\": \"\\f4ba\",\n  \"patch-plus-fill\": \"\\f4bb\",\n  \"patch-plus\": \"\\f4bc\",\n  \"patch-question-fill\": \"\\f4bd\",\n  \"patch-question\": \"\\f4be\",\n  \"pause-btn-fill\": \"\\f4bf\",\n  \"pause-btn\": \"\\f4c0\",\n  \"pause-circle-fill\": \"\\f4c1\",\n  \"pause-circle\": \"\\f4c2\",\n  \"pause-fill\": \"\\f4c3\",\n  \"pause\": \"\\f4c4\",\n  \"peace-fill\": \"\\f4c5\",\n  \"peace\": \"\\f4c6\",\n  \"pen-fill\": \"\\f4c7\",\n  \"pen\": \"\\f4c8\",\n  \"pencil-fill\": \"\\f4c9\",\n  \"pencil-square\": \"\\f4ca\",\n  \"pencil\": \"\\f4cb\",\n  \"pentagon-fill\": \"\\f4cc\",\n  \"pentagon-half\": \"\\f4cd\",\n  \"pentagon\": \"\\f4ce\",\n  \"people-fill\": \"\\f4cf\",\n  \"people\": \"\\f4d0\",\n  \"percent\": \"\\f4d1\",\n  \"person-badge-fill\": \"\\f4d2\",\n  \"person-badge\": \"\\f4d3\",\n  \"person-bounding-box\": \"\\f4d4\",\n  \"person-check-fill\": \"\\f4d5\",\n  \"person-check\": \"\\f4d6\",\n  \"person-circle\": \"\\f4d7\",\n  \"person-dash-fill\": \"\\f4d8\",\n  \"person-dash\": \"\\f4d9\",\n  \"person-fill\": \"\\f4da\",\n  \"person-lines-fill\": \"\\f4db\",\n  \"person-plus-fill\": \"\\f4dc\",\n  \"person-plus\": \"\\f4dd\",\n  \"person-square\": \"\\f4de\",\n  \"person-x-fill\": \"\\f4df\",\n  \"person-x\": \"\\f4e0\",\n  \"person\": \"\\f4e1\",\n  \"phone-fill\": \"\\f4e2\",\n  \"phone-landscape-fill\": \"\\f4e3\",\n  \"phone-landscape\": \"\\f4e4\",\n  \"phone-vibrate-fill\": \"\\f4e5\",\n  \"phone-vibrate\": \"\\f4e6\",\n  \"phone\": \"\\f4e7\",\n  \"pie-chart-fill\": \"\\f4e8\",\n  \"pie-chart\": \"\\f4e9\",\n  \"pin-angle-fill\": \"\\f4ea\",\n  \"pin-angle\": \"\\f4eb\",\n  \"pin-fill\": \"\\f4ec\",\n  \"pin\": \"\\f4ed\",\n  \"pip-fill\": \"\\f4ee\",\n  \"pip\": \"\\f4ef\",\n  \"play-btn-fill\": \"\\f4f0\",\n  \"play-btn\": \"\\f4f1\",\n  \"play-circle-fill\": \"\\f4f2\",\n  \"play-circle\": \"\\f4f3\",\n  \"play-fill\": \"\\f4f4\",\n  \"play\": \"\\f4f5\",\n  \"plug-fill\": \"\\f4f6\",\n  \"plug\": \"\\f4f7\",\n  \"plus-circle-dotted\": \"\\f4f8\",\n  \"plus-circle-fill\": \"\\f4f9\",\n  \"plus-circle\": \"\\f4fa\",\n  \"plus-square-dotted\": \"\\f4fb\",\n  \"plus-square-fill\": \"\\f4fc\",\n  \"plus-square\": \"\\f4fd\",\n  \"plus\": \"\\f4fe\",\n  \"power\": \"\\f4ff\",\n  \"printer-fill\": \"\\f500\",\n  \"printer\": \"\\f501\",\n  \"puzzle-fill\": \"\\f502\",\n  \"puzzle\": \"\\f503\",\n  \"question-circle-fill\": \"\\f504\",\n  \"question-circle\": \"\\f505\",\n  \"question-diamond-fill\": \"\\f506\",\n  \"question-diamond\": \"\\f507\",\n  \"question-octagon-fill\": \"\\f508\",\n  \"question-octagon\": \"\\f509\",\n  \"question-square-fill\": \"\\f50a\",\n  \"question-square\": \"\\f50b\",\n  \"question\": \"\\f50c\",\n  \"rainbow\": \"\\f50d\",\n  \"receipt-cutoff\": \"\\f50e\",\n  \"receipt\": \"\\f50f\",\n  \"reception-0\": \"\\f510\",\n  \"reception-1\": \"\\f511\",\n  \"reception-2\": \"\\f512\",\n  \"reception-3\": \"\\f513\",\n  \"reception-4\": \"\\f514\",\n  \"record-btn-fill\": \"\\f515\",\n  \"record-btn\": \"\\f516\",\n  \"record-circle-fill\": \"\\f517\",\n  \"record-circle\": \"\\f518\",\n  \"record-fill\": \"\\f519\",\n  \"record\": \"\\f51a\",\n  \"record2-fill\": \"\\f51b\",\n  \"record2\": \"\\f51c\",\n  \"reply-all-fill\": \"\\f51d\",\n  \"reply-all\": \"\\f51e\",\n  \"reply-fill\": \"\\f51f\",\n  \"reply\": \"\\f520\",\n  \"rss-fill\": \"\\f521\",\n  \"rss\": \"\\f522\",\n  \"rulers\": \"\\f523\",\n  \"save-fill\": \"\\f524\",\n  \"save\": \"\\f525\",\n  \"save2-fill\": \"\\f526\",\n  \"save2\": \"\\f527\",\n  \"scissors\": \"\\f528\",\n  \"screwdriver\": \"\\f529\",\n  \"search\": \"\\f52a\",\n  \"segmented-nav\": \"\\f52b\",\n  \"server\": \"\\f52c\",\n  \"share-fill\": \"\\f52d\",\n  \"share\": \"\\f52e\",\n  \"shield-check\": \"\\f52f\",\n  \"shield-exclamation\": \"\\f530\",\n  \"shield-fill-check\": \"\\f531\",\n  \"shield-fill-exclamation\": \"\\f532\",\n  \"shield-fill-minus\": \"\\f533\",\n  \"shield-fill-plus\": \"\\f534\",\n  \"shield-fill-x\": \"\\f535\",\n  \"shield-fill\": \"\\f536\",\n  \"shield-lock-fill\": \"\\f537\",\n  \"shield-lock\": \"\\f538\",\n  \"shield-minus\": \"\\f539\",\n  \"shield-plus\": \"\\f53a\",\n  \"shield-shaded\": \"\\f53b\",\n  \"shield-slash-fill\": \"\\f53c\",\n  \"shield-slash\": \"\\f53d\",\n  \"shield-x\": \"\\f53e\",\n  \"shield\": \"\\f53f\",\n  \"shift-fill\": \"\\f540\",\n  \"shift\": \"\\f541\",\n  \"shop-window\": \"\\f542\",\n  \"shop\": \"\\f543\",\n  \"shuffle\": \"\\f544\",\n  \"signpost-2-fill\": \"\\f545\",\n  \"signpost-2\": \"\\f546\",\n  \"signpost-fill\": \"\\f547\",\n  \"signpost-split-fill\": \"\\f548\",\n  \"signpost-split\": \"\\f549\",\n  \"signpost\": \"\\f54a\",\n  \"sim-fill\": \"\\f54b\",\n  \"sim\": \"\\f54c\",\n  \"skip-backward-btn-fill\": \"\\f54d\",\n  \"skip-backward-btn\": \"\\f54e\",\n  \"skip-backward-circle-fill\": \"\\f54f\",\n  \"skip-backward-circle\": \"\\f550\",\n  \"skip-backward-fill\": \"\\f551\",\n  \"skip-backward\": \"\\f552\",\n  \"skip-end-btn-fill\": \"\\f553\",\n  \"skip-end-btn\": \"\\f554\",\n  \"skip-end-circle-fill\": \"\\f555\",\n  \"skip-end-circle\": \"\\f556\",\n  \"skip-end-fill\": \"\\f557\",\n  \"skip-end\": \"\\f558\",\n  \"skip-forward-btn-fill\": \"\\f559\",\n  \"skip-forward-btn\": \"\\f55a\",\n  \"skip-forward-circle-fill\": \"\\f55b\",\n  \"skip-forward-circle\": \"\\f55c\",\n  \"skip-forward-fill\": \"\\f55d\",\n  \"skip-forward\": \"\\f55e\",\n  \"skip-start-btn-fill\": \"\\f55f\",\n  \"skip-start-btn\": \"\\f560\",\n  \"skip-start-circle-fill\": \"\\f561\",\n  \"skip-start-circle\": \"\\f562\",\n  \"skip-start-fill\": \"\\f563\",\n  \"skip-start\": \"\\f564\",\n  \"slack\": \"\\f565\",\n  \"slash-circle-fill\": \"\\f566\",\n  \"slash-circle\": \"\\f567\",\n  \"slash-square-fill\": \"\\f568\",\n  \"slash-square\": \"\\f569\",\n  \"slash\": \"\\f56a\",\n  \"sliders\": \"\\f56b\",\n  \"smartwatch\": \"\\f56c\",\n  \"snow\": \"\\f56d\",\n  \"snow2\": \"\\f56e\",\n  \"snow3\": \"\\f56f\",\n  \"sort-alpha-down-alt\": \"\\f570\",\n  \"sort-alpha-down\": \"\\f571\",\n  \"sort-alpha-up-alt\": \"\\f572\",\n  \"sort-alpha-up\": \"\\f573\",\n  \"sort-down-alt\": \"\\f574\",\n  \"sort-down\": \"\\f575\",\n  \"sort-numeric-down-alt\": \"\\f576\",\n  \"sort-numeric-down\": \"\\f577\",\n  \"sort-numeric-up-alt\": \"\\f578\",\n  \"sort-numeric-up\": \"\\f579\",\n  \"sort-up-alt\": \"\\f57a\",\n  \"sort-up\": \"\\f57b\",\n  \"soundwave\": \"\\f57c\",\n  \"speaker-fill\": \"\\f57d\",\n  \"speaker\": \"\\f57e\",\n  \"speedometer\": \"\\f57f\",\n  \"speedometer2\": \"\\f580\",\n  \"spellcheck\": \"\\f581\",\n  \"square-fill\": \"\\f582\",\n  \"square-half\": \"\\f583\",\n  \"square\": \"\\f584\",\n  \"stack\": \"\\f585\",\n  \"star-fill\": \"\\f586\",\n  \"star-half\": \"\\f587\",\n  \"star\": \"\\f588\",\n  \"stars\": \"\\f589\",\n  \"stickies-fill\": \"\\f58a\",\n  \"stickies\": \"\\f58b\",\n  \"sticky-fill\": \"\\f58c\",\n  \"sticky\": \"\\f58d\",\n  \"stop-btn-fill\": \"\\f58e\",\n  \"stop-btn\": \"\\f58f\",\n  \"stop-circle-fill\": \"\\f590\",\n  \"stop-circle\": \"\\f591\",\n  \"stop-fill\": \"\\f592\",\n  \"stop\": \"\\f593\",\n  \"stoplights-fill\": \"\\f594\",\n  \"stoplights\": \"\\f595\",\n  \"stopwatch-fill\": \"\\f596\",\n  \"stopwatch\": \"\\f597\",\n  \"subtract\": \"\\f598\",\n  \"suit-club-fill\": \"\\f599\",\n  \"suit-club\": \"\\f59a\",\n  \"suit-diamond-fill\": \"\\f59b\",\n  \"suit-diamond\": \"\\f59c\",\n  \"suit-heart-fill\": \"\\f59d\",\n  \"suit-heart\": \"\\f59e\",\n  \"suit-spade-fill\": \"\\f59f\",\n  \"suit-spade\": \"\\f5a0\",\n  \"sun-fill\": \"\\f5a1\",\n  \"sun\": \"\\f5a2\",\n  \"sunglasses\": \"\\f5a3\",\n  \"sunrise-fill\": \"\\f5a4\",\n  \"sunrise\": \"\\f5a5\",\n  \"sunset-fill\": \"\\f5a6\",\n  \"sunset\": \"\\f5a7\",\n  \"symmetry-horizontal\": \"\\f5a8\",\n  \"symmetry-vertical\": \"\\f5a9\",\n  \"table\": \"\\f5aa\",\n  \"tablet-fill\": \"\\f5ab\",\n  \"tablet-landscape-fill\": \"\\f5ac\",\n  \"tablet-landscape\": \"\\f5ad\",\n  \"tablet\": \"\\f5ae\",\n  \"tag-fill\": \"\\f5af\",\n  \"tag\": \"\\f5b0\",\n  \"tags-fill\": \"\\f5b1\",\n  \"tags\": \"\\f5b2\",\n  \"telegram\": \"\\f5b3\",\n  \"telephone-fill\": \"\\f5b4\",\n  \"telephone-forward-fill\": \"\\f5b5\",\n  \"telephone-forward\": \"\\f5b6\",\n  \"telephone-inbound-fill\": \"\\f5b7\",\n  \"telephone-inbound\": \"\\f5b8\",\n  \"telephone-minus-fill\": \"\\f5b9\",\n  \"telephone-minus\": \"\\f5ba\",\n  \"telephone-outbound-fill\": \"\\f5bb\",\n  \"telephone-outbound\": \"\\f5bc\",\n  \"telephone-plus-fill\": \"\\f5bd\",\n  \"telephone-plus\": \"\\f5be\",\n  \"telephone-x-fill\": \"\\f5bf\",\n  \"telephone-x\": \"\\f5c0\",\n  \"telephone\": \"\\f5c1\",\n  \"terminal-fill\": \"\\f5c2\",\n  \"terminal\": \"\\f5c3\",\n  \"text-center\": \"\\f5c4\",\n  \"text-indent-left\": \"\\f5c5\",\n  \"text-indent-right\": \"\\f5c6\",\n  \"text-left\": \"\\f5c7\",\n  \"text-paragraph\": \"\\f5c8\",\n  \"text-right\": \"\\f5c9\",\n  \"textarea-resize\": \"\\f5ca\",\n  \"textarea-t\": \"\\f5cb\",\n  \"textarea\": \"\\f5cc\",\n  \"thermometer-half\": \"\\f5cd\",\n  \"thermometer-high\": \"\\f5ce\",\n  \"thermometer-low\": \"\\f5cf\",\n  \"thermometer-snow\": \"\\f5d0\",\n  \"thermometer-sun\": \"\\f5d1\",\n  \"thermometer\": \"\\f5d2\",\n  \"three-dots-vertical\": \"\\f5d3\",\n  \"three-dots\": \"\\f5d4\",\n  \"toggle-off\": \"\\f5d5\",\n  \"toggle-on\": \"\\f5d6\",\n  \"toggle2-off\": \"\\f5d7\",\n  \"toggle2-on\": \"\\f5d8\",\n  \"toggles\": \"\\f5d9\",\n  \"toggles2\": \"\\f5da\",\n  \"tools\": \"\\f5db\",\n  \"tornado\": \"\\f5dc\",\n  \"trash-fill\": \"\\f5dd\",\n  \"trash\": \"\\f5de\",\n  \"trash2-fill\": \"\\f5df\",\n  \"trash2\": \"\\f5e0\",\n  \"tree-fill\": \"\\f5e1\",\n  \"tree\": \"\\f5e2\",\n  \"triangle-fill\": \"\\f5e3\",\n  \"triangle-half\": \"\\f5e4\",\n  \"triangle\": \"\\f5e5\",\n  \"trophy-fill\": \"\\f5e6\",\n  \"trophy\": \"\\f5e7\",\n  \"tropical-storm\": \"\\f5e8\",\n  \"truck-flatbed\": \"\\f5e9\",\n  \"truck\": \"\\f5ea\",\n  \"tsunami\": \"\\f5eb\",\n  \"tv-fill\": \"\\f5ec\",\n  \"tv\": \"\\f5ed\",\n  \"twitch\": \"\\f5ee\",\n  \"twitter\": \"\\f5ef\",\n  \"type-bold\": \"\\f5f0\",\n  \"type-h1\": \"\\f5f1\",\n  \"type-h2\": \"\\f5f2\",\n  \"type-h3\": \"\\f5f3\",\n  \"type-italic\": \"\\f5f4\",\n  \"type-strikethrough\": \"\\f5f5\",\n  \"type-underline\": \"\\f5f6\",\n  \"type\": \"\\f5f7\",\n  \"ui-checks-grid\": \"\\f5f8\",\n  \"ui-checks\": \"\\f5f9\",\n  \"ui-radios-grid\": \"\\f5fa\",\n  \"ui-radios\": \"\\f5fb\",\n  \"umbrella-fill\": \"\\f5fc\",\n  \"umbrella\": \"\\f5fd\",\n  \"union\": \"\\f5fe\",\n  \"unlock-fill\": \"\\f5ff\",\n  \"unlock\": \"\\f600\",\n  \"upc-scan\": \"\\f601\",\n  \"upc\": \"\\f602\",\n  \"upload\": \"\\f603\",\n  \"vector-pen\": \"\\f604\",\n  \"view-list\": \"\\f605\",\n  \"view-stacked\": \"\\f606\",\n  \"vinyl-fill\": \"\\f607\",\n  \"vinyl\": \"\\f608\",\n  \"voicemail\": \"\\f609\",\n  \"volume-down-fill\": \"\\f60a\",\n  \"volume-down\": \"\\f60b\",\n  \"volume-mute-fill\": \"\\f60c\",\n  \"volume-mute\": \"\\f60d\",\n  \"volume-off-fill\": \"\\f60e\",\n  \"volume-off\": \"\\f60f\",\n  \"volume-up-fill\": \"\\f610\",\n  \"volume-up\": \"\\f611\",\n  \"vr\": \"\\f612\",\n  \"wallet-fill\": \"\\f613\",\n  \"wallet\": \"\\f614\",\n  \"wallet2\": \"\\f615\",\n  \"watch\": \"\\f616\",\n  \"water\": \"\\f617\",\n  \"whatsapp\": \"\\f618\",\n  \"wifi-1\": \"\\f619\",\n  \"wifi-2\": \"\\f61a\",\n  \"wifi-off\": \"\\f61b\",\n  \"wifi\": \"\\f61c\",\n  \"wind\": \"\\f61d\",\n  \"window-dock\": \"\\f61e\",\n  \"window-sidebar\": \"\\f61f\",\n  \"window\": \"\\f620\",\n  \"wrench\": \"\\f621\",\n  \"x-circle-fill\": \"\\f622\",\n  \"x-circle\": \"\\f623\",\n  \"x-diamond-fill\": \"\\f624\",\n  \"x-diamond\": \"\\f625\",\n  \"x-octagon-fill\": \"\\f626\",\n  \"x-octagon\": \"\\f627\",\n  \"x-square-fill\": \"\\f628\",\n  \"x-square\": \"\\f629\",\n  \"x\": \"\\f62a\",\n  \"youtube\": \"\\f62b\",\n  \"zoom-in\": \"\\f62c\",\n  \"zoom-out\": \"\\f62d\",\n  \"bank\": \"\\f62e\",\n  \"bank2\": \"\\f62f\",\n  \"bell-slash-fill\": \"\\f630\",\n  \"bell-slash\": \"\\f631\",\n  \"cash-coin\": \"\\f632\",\n  \"check-lg\": \"\\f633\",\n  \"coin\": \"\\f634\",\n  \"currency-bitcoin\": \"\\f635\",\n  \"currency-dollar\": \"\\f636\",\n  \"currency-euro\": \"\\f637\",\n  \"currency-exchange\": \"\\f638\",\n  \"currency-pound\": \"\\f639\",\n  \"currency-yen\": \"\\f63a\",\n  \"dash-lg\": \"\\f63b\",\n  \"exclamation-lg\": \"\\f63c\",\n  \"file-earmark-pdf-fill\": \"\\f63d\",\n  \"file-earmark-pdf\": \"\\f63e\",\n  \"file-pdf-fill\": \"\\f63f\",\n  \"file-pdf\": \"\\f640\",\n  \"gender-ambiguous\": \"\\f641\",\n  \"gender-female\": \"\\f642\",\n  \"gender-male\": \"\\f643\",\n  \"gender-trans\": \"\\f644\",\n  \"headset-vr\": \"\\f645\",\n  \"info-lg\": \"\\f646\",\n  \"mastodon\": \"\\f647\",\n  \"messenger\": \"\\f648\",\n  \"piggy-bank-fill\": \"\\f649\",\n  \"piggy-bank\": \"\\f64a\",\n  \"pin-map-fill\": \"\\f64b\",\n  \"pin-map\": \"\\f64c\",\n  \"plus-lg\": \"\\f64d\",\n  \"question-lg\": \"\\f64e\",\n  \"recycle\": \"\\f64f\",\n  \"reddit\": \"\\f650\",\n  \"safe-fill\": \"\\f651\",\n  \"safe2-fill\": \"\\f652\",\n  \"safe2\": \"\\f653\",\n  \"sd-card-fill\": \"\\f654\",\n  \"sd-card\": \"\\f655\",\n  \"skype\": \"\\f656\",\n  \"slash-lg\": \"\\f657\",\n  \"translate\": \"\\f658\",\n  \"x-lg\": \"\\f659\",\n  \"safe\": \"\\f65a\",\n  \"apple\": \"\\f65b\",\n  \"microsoft\": \"\\f65d\",\n  \"windows\": \"\\f65e\",\n  \"behance\": \"\\f65c\",\n  \"dribbble\": \"\\f65f\",\n  \"line\": \"\\f660\",\n  \"medium\": \"\\f661\",\n  \"paypal\": \"\\f662\",\n  \"pinterest\": \"\\f663\",\n  \"signal\": \"\\f664\",\n  \"snapchat\": \"\\f665\",\n  \"spotify\": \"\\f666\",\n  \"stack-overflow\": \"\\f667\",\n  \"strava\": \"\\f668\",\n  \"wordpress\": \"\\f669\",\n  \"vimeo\": \"\\f66a\",\n  \"activity\": \"\\f66b\",\n  \"easel2-fill\": \"\\f66c\",\n  \"easel2\": \"\\f66d\",\n  \"easel3-fill\": \"\\f66e\",\n  \"easel3\": \"\\f66f\",\n  \"fan\": \"\\f670\",\n  \"fingerprint\": \"\\f671\",\n  \"graph-down-arrow\": \"\\f672\",\n  \"graph-up-arrow\": \"\\f673\",\n  \"hypnotize\": \"\\f674\",\n  \"magic\": \"\\f675\",\n  \"person-rolodex\": \"\\f676\",\n  \"person-video\": \"\\f677\",\n  \"person-video2\": \"\\f678\",\n  \"person-video3\": \"\\f679\",\n  \"person-workspace\": \"\\f67a\",\n  \"radioactive\": \"\\f67b\",\n  \"webcam-fill\": \"\\f67c\",\n  \"webcam\": \"\\f67d\",\n  \"yin-yang\": \"\\f67e\",\n  \"bandaid-fill\": \"\\f680\",\n  \"bandaid\": \"\\f681\",\n  \"bluetooth\": \"\\f682\",\n  \"body-text\": \"\\f683\",\n  \"boombox\": \"\\f684\",\n  \"boxes\": \"\\f685\",\n  \"dpad-fill\": \"\\f686\",\n  \"dpad\": \"\\f687\",\n  \"ear-fill\": \"\\f688\",\n  \"ear\": \"\\f689\",\n  \"envelope-check-fill\": \"\\f68b\",\n  \"envelope-check\": \"\\f68c\",\n  \"envelope-dash-fill\": \"\\f68e\",\n  \"envelope-dash\": \"\\f68f\",\n  \"envelope-exclamation-fill\": \"\\f691\",\n  \"envelope-exclamation\": \"\\f692\",\n  \"envelope-plus-fill\": \"\\f693\",\n  \"envelope-plus\": \"\\f694\",\n  \"envelope-slash-fill\": \"\\f696\",\n  \"envelope-slash\": \"\\f697\",\n  \"envelope-x-fill\": \"\\f699\",\n  \"envelope-x\": \"\\f69a\",\n  \"explicit-fill\": \"\\f69b\",\n  \"explicit\": \"\\f69c\",\n  \"git\": \"\\f69d\",\n  \"infinity\": \"\\f69e\",\n  \"list-columns-reverse\": \"\\f69f\",\n  \"list-columns\": \"\\f6a0\",\n  \"meta\": \"\\f6a1\",\n  \"nintendo-switch\": \"\\f6a4\",\n  \"pc-display-horizontal\": \"\\f6a5\",\n  \"pc-display\": \"\\f6a6\",\n  \"pc-horizontal\": \"\\f6a7\",\n  \"pc\": \"\\f6a8\",\n  \"playstation\": \"\\f6a9\",\n  \"plus-slash-minus\": \"\\f6aa\",\n  \"projector-fill\": \"\\f6ab\",\n  \"projector\": \"\\f6ac\",\n  \"qr-code-scan\": \"\\f6ad\",\n  \"qr-code\": \"\\f6ae\",\n  \"quora\": \"\\f6af\",\n  \"quote\": \"\\f6b0\",\n  \"robot\": \"\\f6b1\",\n  \"send-check-fill\": \"\\f6b2\",\n  \"send-check\": \"\\f6b3\",\n  \"send-dash-fill\": \"\\f6b4\",\n  \"send-dash\": \"\\f6b5\",\n  \"send-exclamation-fill\": \"\\f6b7\",\n  \"send-exclamation\": \"\\f6b8\",\n  \"send-fill\": \"\\f6b9\",\n  \"send-plus-fill\": \"\\f6ba\",\n  \"send-plus\": \"\\f6bb\",\n  \"send-slash-fill\": \"\\f6bc\",\n  \"send-slash\": \"\\f6bd\",\n  \"send-x-fill\": \"\\f6be\",\n  \"send-x\": \"\\f6bf\",\n  \"send\": \"\\f6c0\",\n  \"steam\": \"\\f6c1\",\n  \"terminal-dash\": \"\\f6c3\",\n  \"terminal-plus\": \"\\f6c4\",\n  \"terminal-split\": \"\\f6c5\",\n  \"ticket-detailed-fill\": \"\\f6c6\",\n  \"ticket-detailed\": \"\\f6c7\",\n  \"ticket-fill\": \"\\f6c8\",\n  \"ticket-perforated-fill\": \"\\f6c9\",\n  \"ticket-perforated\": \"\\f6ca\",\n  \"ticket\": \"\\f6cb\",\n  \"tiktok\": \"\\f6cc\",\n  \"window-dash\": \"\\f6cd\",\n  \"window-desktop\": \"\\f6ce\",\n  \"window-fullscreen\": \"\\f6cf\",\n  \"window-plus\": \"\\f6d0\",\n  \"window-split\": \"\\f6d1\",\n  \"window-stack\": \"\\f6d2\",\n  \"window-x\": \"\\f6d3\",\n  \"xbox\": \"\\f6d4\",\n  \"ethernet\": \"\\f6d5\",\n  \"hdmi-fill\": \"\\f6d6\",\n  \"hdmi\": \"\\f6d7\",\n  \"usb-c-fill\": \"\\f6d8\",\n  \"usb-c\": \"\\f6d9\",\n  \"usb-fill\": \"\\f6da\",\n  \"usb-plug-fill\": \"\\f6db\",\n  \"usb-plug\": \"\\f6dc\",\n  \"usb-symbol\": \"\\f6dd\",\n  \"usb\": \"\\f6de\",\n  \"boombox-fill\": \"\\f6df\",\n  \"displayport\": \"\\f6e1\",\n  \"gpu-card\": \"\\f6e2\",\n  \"memory\": \"\\f6e3\",\n  \"modem-fill\": \"\\f6e4\",\n  \"modem\": \"\\f6e5\",\n  \"motherboard-fill\": \"\\f6e6\",\n  \"motherboard\": \"\\f6e7\",\n  \"optical-audio-fill\": \"\\f6e8\",\n  \"optical-audio\": \"\\f6e9\",\n  \"pci-card\": \"\\f6ea\",\n  \"router-fill\": \"\\f6eb\",\n  \"router\": \"\\f6ec\",\n  \"thunderbolt-fill\": \"\\f6ef\",\n  \"thunderbolt\": \"\\f6f0\",\n  \"usb-drive-fill\": \"\\f6f1\",\n  \"usb-drive\": \"\\f6f2\",\n  \"usb-micro-fill\": \"\\f6f3\",\n  \"usb-micro\": \"\\f6f4\",\n  \"usb-mini-fill\": \"\\f6f5\",\n  \"usb-mini\": \"\\f6f6\",\n  \"cloud-haze2\": \"\\f6f7\",\n  \"device-hdd-fill\": \"\\f6f8\",\n  \"device-hdd\": \"\\f6f9\",\n  \"device-ssd-fill\": \"\\f6fa\",\n  \"device-ssd\": \"\\f6fb\",\n  \"displayport-fill\": \"\\f6fc\",\n  \"mortarboard-fill\": \"\\f6fd\",\n  \"mortarboard\": \"\\f6fe\",\n  \"terminal-x\": \"\\f6ff\",\n  \"arrow-through-heart-fill\": \"\\f700\",\n  \"arrow-through-heart\": \"\\f701\",\n  \"badge-sd-fill\": \"\\f702\",\n  \"badge-sd\": \"\\f703\",\n  \"bag-heart-fill\": \"\\f704\",\n  \"bag-heart\": \"\\f705\",\n  \"balloon-fill\": \"\\f706\",\n  \"balloon-heart-fill\": \"\\f707\",\n  \"balloon-heart\": \"\\f708\",\n  \"balloon\": \"\\f709\",\n  \"box2-fill\": \"\\f70a\",\n  \"box2-heart-fill\": \"\\f70b\",\n  \"box2-heart\": \"\\f70c\",\n  \"box2\": \"\\f70d\",\n  \"braces-asterisk\": \"\\f70e\",\n  \"calendar-heart-fill\": \"\\f70f\",\n  \"calendar-heart\": \"\\f710\",\n  \"calendar2-heart-fill\": \"\\f711\",\n  \"calendar2-heart\": \"\\f712\",\n  \"chat-heart-fill\": \"\\f713\",\n  \"chat-heart\": \"\\f714\",\n  \"chat-left-heart-fill\": \"\\f715\",\n  \"chat-left-heart\": \"\\f716\",\n  \"chat-right-heart-fill\": \"\\f717\",\n  \"chat-right-heart\": \"\\f718\",\n  \"chat-square-heart-fill\": \"\\f719\",\n  \"chat-square-heart\": \"\\f71a\",\n  \"clipboard-check-fill\": \"\\f71b\",\n  \"clipboard-data-fill\": \"\\f71c\",\n  \"clipboard-fill\": \"\\f71d\",\n  \"clipboard-heart-fill\": \"\\f71e\",\n  \"clipboard-heart\": \"\\f71f\",\n  \"clipboard-minus-fill\": \"\\f720\",\n  \"clipboard-plus-fill\": \"\\f721\",\n  \"clipboard-pulse\": \"\\f722\",\n  \"clipboard-x-fill\": \"\\f723\",\n  \"clipboard2-check-fill\": \"\\f724\",\n  \"clipboard2-check\": \"\\f725\",\n  \"clipboard2-data-fill\": \"\\f726\",\n  \"clipboard2-data\": \"\\f727\",\n  \"clipboard2-fill\": \"\\f728\",\n  \"clipboard2-heart-fill\": \"\\f729\",\n  \"clipboard2-heart\": \"\\f72a\",\n  \"clipboard2-minus-fill\": \"\\f72b\",\n  \"clipboard2-minus\": \"\\f72c\",\n  \"clipboard2-plus-fill\": \"\\f72d\",\n  \"clipboard2-plus\": \"\\f72e\",\n  \"clipboard2-pulse-fill\": \"\\f72f\",\n  \"clipboard2-pulse\": \"\\f730\",\n  \"clipboard2-x-fill\": \"\\f731\",\n  \"clipboard2-x\": \"\\f732\",\n  \"clipboard2\": \"\\f733\",\n  \"emoji-kiss-fill\": \"\\f734\",\n  \"emoji-kiss\": \"\\f735\",\n  \"envelope-heart-fill\": \"\\f736\",\n  \"envelope-heart\": \"\\f737\",\n  \"envelope-open-heart-fill\": \"\\f738\",\n  \"envelope-open-heart\": \"\\f739\",\n  \"envelope-paper-fill\": \"\\f73a\",\n  \"envelope-paper-heart-fill\": \"\\f73b\",\n  \"envelope-paper-heart\": \"\\f73c\",\n  \"envelope-paper\": \"\\f73d\",\n  \"filetype-aac\": \"\\f73e\",\n  \"filetype-ai\": \"\\f73f\",\n  \"filetype-bmp\": \"\\f740\",\n  \"filetype-cs\": \"\\f741\",\n  \"filetype-css\": \"\\f742\",\n  \"filetype-csv\": \"\\f743\",\n  \"filetype-doc\": \"\\f744\",\n  \"filetype-docx\": \"\\f745\",\n  \"filetype-exe\": \"\\f746\",\n  \"filetype-gif\": \"\\f747\",\n  \"filetype-heic\": \"\\f748\",\n  \"filetype-html\": \"\\f749\",\n  \"filetype-java\": \"\\f74a\",\n  \"filetype-jpg\": \"\\f74b\",\n  \"filetype-js\": \"\\f74c\",\n  \"filetype-jsx\": \"\\f74d\",\n  \"filetype-key\": \"\\f74e\",\n  \"filetype-m4p\": \"\\f74f\",\n  \"filetype-md\": \"\\f750\",\n  \"filetype-mdx\": \"\\f751\",\n  \"filetype-mov\": \"\\f752\",\n  \"filetype-mp3\": \"\\f753\",\n  \"filetype-mp4\": \"\\f754\",\n  \"filetype-otf\": \"\\f755\",\n  \"filetype-pdf\": \"\\f756\",\n  \"filetype-php\": \"\\f757\",\n  \"filetype-png\": \"\\f758\",\n  \"filetype-ppt\": \"\\f75a\",\n  \"filetype-psd\": \"\\f75b\",\n  \"filetype-py\": \"\\f75c\",\n  \"filetype-raw\": \"\\f75d\",\n  \"filetype-rb\": \"\\f75e\",\n  \"filetype-sass\": \"\\f75f\",\n  \"filetype-scss\": \"\\f760\",\n  \"filetype-sh\": \"\\f761\",\n  \"filetype-svg\": \"\\f762\",\n  \"filetype-tiff\": \"\\f763\",\n  \"filetype-tsx\": \"\\f764\",\n  \"filetype-ttf\": \"\\f765\",\n  \"filetype-txt\": \"\\f766\",\n  \"filetype-wav\": \"\\f767\",\n  \"filetype-woff\": \"\\f768\",\n  \"filetype-xls\": \"\\f76a\",\n  \"filetype-xml\": \"\\f76b\",\n  \"filetype-yml\": \"\\f76c\",\n  \"heart-arrow\": \"\\f76d\",\n  \"heart-pulse-fill\": \"\\f76e\",\n  \"heart-pulse\": \"\\f76f\",\n  \"heartbreak-fill\": \"\\f770\",\n  \"heartbreak\": \"\\f771\",\n  \"hearts\": \"\\f772\",\n  \"hospital-fill\": \"\\f773\",\n  \"hospital\": \"\\f774\",\n  \"house-heart-fill\": \"\\f775\",\n  \"house-heart\": \"\\f776\",\n  \"incognito\": \"\\f777\",\n  \"magnet-fill\": \"\\f778\",\n  \"magnet\": \"\\f779\",\n  \"person-heart\": \"\\f77a\",\n  \"person-hearts\": \"\\f77b\",\n  \"phone-flip\": \"\\f77c\",\n  \"plugin\": \"\\f77d\",\n  \"postage-fill\": \"\\f77e\",\n  \"postage-heart-fill\": \"\\f77f\",\n  \"postage-heart\": \"\\f780\",\n  \"postage\": \"\\f781\",\n  \"postcard-fill\": \"\\f782\",\n  \"postcard-heart-fill\": \"\\f783\",\n  \"postcard-heart\": \"\\f784\",\n  \"postcard\": \"\\f785\",\n  \"search-heart-fill\": \"\\f786\",\n  \"search-heart\": \"\\f787\",\n  \"sliders2-vertical\": \"\\f788\",\n  \"sliders2\": \"\\f789\",\n  \"trash3-fill\": \"\\f78a\",\n  \"trash3\": \"\\f78b\",\n  \"valentine\": \"\\f78c\",\n  \"valentine2\": \"\\f78d\",\n  \"wrench-adjustable-circle-fill\": \"\\f78e\",\n  \"wrench-adjustable-circle\": \"\\f78f\",\n  \"wrench-adjustable\": \"\\f790\",\n  \"filetype-json\": \"\\f791\",\n  \"filetype-pptx\": \"\\f792\",\n  \"filetype-xlsx\": \"\\f793\",\n  \"1-circle-fill\": \"\\f796\",\n  \"1-circle\": \"\\f797\",\n  \"1-square-fill\": \"\\f798\",\n  \"1-square\": \"\\f799\",\n  \"2-circle-fill\": \"\\f79c\",\n  \"2-circle\": \"\\f79d\",\n  \"2-square-fill\": \"\\f79e\",\n  \"2-square\": \"\\f79f\",\n  \"3-circle-fill\": \"\\f7a2\",\n  \"3-circle\": \"\\f7a3\",\n  \"3-square-fill\": \"\\f7a4\",\n  \"3-square\": \"\\f7a5\",\n  \"4-circle-fill\": \"\\f7a8\",\n  \"4-circle\": \"\\f7a9\",\n  \"4-square-fill\": \"\\f7aa\",\n  \"4-square\": \"\\f7ab\",\n  \"5-circle-fill\": \"\\f7ae\",\n  \"5-circle\": \"\\f7af\",\n  \"5-square-fill\": \"\\f7b0\",\n  \"5-square\": \"\\f7b1\",\n  \"6-circle-fill\": \"\\f7b4\",\n  \"6-circle\": \"\\f7b5\",\n  \"6-square-fill\": \"\\f7b6\",\n  \"6-square\": \"\\f7b7\",\n  \"7-circle-fill\": \"\\f7ba\",\n  \"7-circle\": \"\\f7bb\",\n  \"7-square-fill\": \"\\f7bc\",\n  \"7-square\": \"\\f7bd\",\n  \"8-circle-fill\": \"\\f7c0\",\n  \"8-circle\": \"\\f7c1\",\n  \"8-square-fill\": \"\\f7c2\",\n  \"8-square\": \"\\f7c3\",\n  \"9-circle-fill\": \"\\f7c6\",\n  \"9-circle\": \"\\f7c7\",\n  \"9-square-fill\": \"\\f7c8\",\n  \"9-square\": \"\\f7c9\",\n  \"airplane-engines-fill\": \"\\f7ca\",\n  \"airplane-engines\": \"\\f7cb\",\n  \"airplane-fill\": \"\\f7cc\",\n  \"airplane\": \"\\f7cd\",\n  \"alexa\": \"\\f7ce\",\n  \"alipay\": \"\\f7cf\",\n  \"android\": \"\\f7d0\",\n  \"android2\": \"\\f7d1\",\n  \"box-fill\": \"\\f7d2\",\n  \"box-seam-fill\": \"\\f7d3\",\n  \"browser-chrome\": \"\\f7d4\",\n  \"browser-edge\": \"\\f7d5\",\n  \"browser-firefox\": \"\\f7d6\",\n  \"browser-safari\": \"\\f7d7\",\n  \"c-circle-fill\": \"\\f7da\",\n  \"c-circle\": \"\\f7db\",\n  \"c-square-fill\": \"\\f7dc\",\n  \"c-square\": \"\\f7dd\",\n  \"capsule-pill\": \"\\f7de\",\n  \"capsule\": \"\\f7df\",\n  \"car-front-fill\": \"\\f7e0\",\n  \"car-front\": \"\\f7e1\",\n  \"cassette-fill\": \"\\f7e2\",\n  \"cassette\": \"\\f7e3\",\n  \"cc-circle-fill\": \"\\f7e6\",\n  \"cc-circle\": \"\\f7e7\",\n  \"cc-square-fill\": \"\\f7e8\",\n  \"cc-square\": \"\\f7e9\",\n  \"cup-hot-fill\": \"\\f7ea\",\n  \"cup-hot\": \"\\f7eb\",\n  \"currency-rupee\": \"\\f7ec\",\n  \"dropbox\": \"\\f7ed\",\n  \"escape\": \"\\f7ee\",\n  \"fast-forward-btn-fill\": \"\\f7ef\",\n  \"fast-forward-btn\": \"\\f7f0\",\n  \"fast-forward-circle-fill\": \"\\f7f1\",\n  \"fast-forward-circle\": \"\\f7f2\",\n  \"fast-forward-fill\": \"\\f7f3\",\n  \"fast-forward\": \"\\f7f4\",\n  \"filetype-sql\": \"\\f7f5\",\n  \"fire\": \"\\f7f6\",\n  \"google-play\": \"\\f7f7\",\n  \"h-circle-fill\": \"\\f7fa\",\n  \"h-circle\": \"\\f7fb\",\n  \"h-square-fill\": \"\\f7fc\",\n  \"h-square\": \"\\f7fd\",\n  \"indent\": \"\\f7fe\",\n  \"lungs-fill\": \"\\f7ff\",\n  \"lungs\": \"\\f800\",\n  \"microsoft-teams\": \"\\f801\",\n  \"p-circle-fill\": \"\\f804\",\n  \"p-circle\": \"\\f805\",\n  \"p-square-fill\": \"\\f806\",\n  \"p-square\": \"\\f807\",\n  \"pass-fill\": \"\\f808\",\n  \"pass\": \"\\f809\",\n  \"prescription\": \"\\f80a\",\n  \"prescription2\": \"\\f80b\",\n  \"r-circle-fill\": \"\\f80e\",\n  \"r-circle\": \"\\f80f\",\n  \"r-square-fill\": \"\\f810\",\n  \"r-square\": \"\\f811\",\n  \"repeat-1\": \"\\f812\",\n  \"repeat\": \"\\f813\",\n  \"rewind-btn-fill\": \"\\f814\",\n  \"rewind-btn\": \"\\f815\",\n  \"rewind-circle-fill\": \"\\f816\",\n  \"rewind-circle\": \"\\f817\",\n  \"rewind-fill\": \"\\f818\",\n  \"rewind\": \"\\f819\",\n  \"train-freight-front-fill\": \"\\f81a\",\n  \"train-freight-front\": \"\\f81b\",\n  \"train-front-fill\": \"\\f81c\",\n  \"train-front\": \"\\f81d\",\n  \"train-lightrail-front-fill\": \"\\f81e\",\n  \"train-lightrail-front\": \"\\f81f\",\n  \"truck-front-fill\": \"\\f820\",\n  \"truck-front\": \"\\f821\",\n  \"ubuntu\": \"\\f822\",\n  \"unindent\": \"\\f823\",\n  \"unity\": \"\\f824\",\n  \"universal-access-circle\": \"\\f825\",\n  \"universal-access\": \"\\f826\",\n  \"virus\": \"\\f827\",\n  \"virus2\": \"\\f828\",\n  \"wechat\": \"\\f829\",\n  \"yelp\": \"\\f82a\",\n  \"sign-stop-fill\": \"\\f82b\",\n  \"sign-stop-lights-fill\": \"\\f82c\",\n  \"sign-stop-lights\": \"\\f82d\",\n  \"sign-stop\": \"\\f82e\",\n  \"sign-turn-left-fill\": \"\\f82f\",\n  \"sign-turn-left\": \"\\f830\",\n  \"sign-turn-right-fill\": \"\\f831\",\n  \"sign-turn-right\": \"\\f832\",\n  \"sign-turn-slight-left-fill\": \"\\f833\",\n  \"sign-turn-slight-left\": \"\\f834\",\n  \"sign-turn-slight-right-fill\": \"\\f835\",\n  \"sign-turn-slight-right\": \"\\f836\",\n  \"sign-yield-fill\": \"\\f837\",\n  \"sign-yield\": \"\\f838\",\n  \"ev-station-fill\": \"\\f839\",\n  \"ev-station\": \"\\f83a\",\n  \"fuel-pump-diesel-fill\": \"\\f83b\",\n  \"fuel-pump-diesel\": \"\\f83c\",\n  \"fuel-pump-fill\": \"\\f83d\",\n  \"fuel-pump\": \"\\f83e\",\n  \"0-circle-fill\": \"\\f83f\",\n  \"0-circle\": \"\\f840\",\n  \"0-square-fill\": \"\\f841\",\n  \"0-square\": \"\\f842\",\n  \"rocket-fill\": \"\\f843\",\n  \"rocket-takeoff-fill\": \"\\f844\",\n  \"rocket-takeoff\": \"\\f845\",\n  \"rocket\": \"\\f846\",\n  \"stripe\": \"\\f847\",\n  \"subscript\": \"\\f848\",\n  \"superscript\": \"\\f849\",\n  \"trello\": \"\\f84a\",\n  \"envelope-at-fill\": \"\\f84b\",\n  \"envelope-at\": \"\\f84c\",\n  \"regex\": \"\\f84d\",\n  \"text-wrap\": \"\\f84e\",\n  \"sign-dead-end-fill\": \"\\f84f\",\n  \"sign-dead-end\": \"\\f850\",\n  \"sign-do-not-enter-fill\": \"\\f851\",\n  \"sign-do-not-enter\": \"\\f852\",\n  \"sign-intersection-fill\": \"\\f853\",\n  \"sign-intersection-side-fill\": \"\\f854\",\n  \"sign-intersection-side\": \"\\f855\",\n  \"sign-intersection-t-fill\": \"\\f856\",\n  \"sign-intersection-t\": \"\\f857\",\n  \"sign-intersection-y-fill\": \"\\f858\",\n  \"sign-intersection-y\": \"\\f859\",\n  \"sign-intersection\": \"\\f85a\",\n  \"sign-merge-left-fill\": \"\\f85b\",\n  \"sign-merge-left\": \"\\f85c\",\n  \"sign-merge-right-fill\": \"\\f85d\",\n  \"sign-merge-right\": \"\\f85e\",\n  \"sign-no-left-turn-fill\": \"\\f85f\",\n  \"sign-no-left-turn\": \"\\f860\",\n  \"sign-no-parking-fill\": \"\\f861\",\n  \"sign-no-parking\": \"\\f862\",\n  \"sign-no-right-turn-fill\": \"\\f863\",\n  \"sign-no-right-turn\": \"\\f864\",\n  \"sign-railroad-fill\": \"\\f865\",\n  \"sign-railroad\": \"\\f866\",\n  \"building-add\": \"\\f867\",\n  \"building-check\": \"\\f868\",\n  \"building-dash\": \"\\f869\",\n  \"building-down\": \"\\f86a\",\n  \"building-exclamation\": \"\\f86b\",\n  \"building-fill-add\": \"\\f86c\",\n  \"building-fill-check\": \"\\f86d\",\n  \"building-fill-dash\": \"\\f86e\",\n  \"building-fill-down\": \"\\f86f\",\n  \"building-fill-exclamation\": \"\\f870\",\n  \"building-fill-gear\": \"\\f871\",\n  \"building-fill-lock\": \"\\f872\",\n  \"building-fill-slash\": \"\\f873\",\n  \"building-fill-up\": \"\\f874\",\n  \"building-fill-x\": \"\\f875\",\n  \"building-fill\": \"\\f876\",\n  \"building-gear\": \"\\f877\",\n  \"building-lock\": \"\\f878\",\n  \"building-slash\": \"\\f879\",\n  \"building-up\": \"\\f87a\",\n  \"building-x\": \"\\f87b\",\n  \"buildings-fill\": \"\\f87c\",\n  \"buildings\": \"\\f87d\",\n  \"bus-front-fill\": \"\\f87e\",\n  \"bus-front\": \"\\f87f\",\n  \"ev-front-fill\": \"\\f880\",\n  \"ev-front\": \"\\f881\",\n  \"globe-americas\": \"\\f882\",\n  \"globe-asia-australia\": \"\\f883\",\n  \"globe-central-south-asia\": \"\\f884\",\n  \"globe-europe-africa\": \"\\f885\",\n  \"house-add-fill\": \"\\f886\",\n  \"house-add\": \"\\f887\",\n  \"house-check-fill\": \"\\f888\",\n  \"house-check\": \"\\f889\",\n  \"house-dash-fill\": \"\\f88a\",\n  \"house-dash\": \"\\f88b\",\n  \"house-down-fill\": \"\\f88c\",\n  \"house-down\": \"\\f88d\",\n  \"house-exclamation-fill\": \"\\f88e\",\n  \"house-exclamation\": \"\\f88f\",\n  \"house-gear-fill\": \"\\f890\",\n  \"house-gear\": \"\\f891\",\n  \"house-lock-fill\": \"\\f892\",\n  \"house-lock\": \"\\f893\",\n  \"house-slash-fill\": \"\\f894\",\n  \"house-slash\": \"\\f895\",\n  \"house-up-fill\": \"\\f896\",\n  \"house-up\": \"\\f897\",\n  \"house-x-fill\": \"\\f898\",\n  \"house-x\": \"\\f899\",\n  \"person-add\": \"\\f89a\",\n  \"person-down\": \"\\f89b\",\n  \"person-exclamation\": \"\\f89c\",\n  \"person-fill-add\": \"\\f89d\",\n  \"person-fill-check\": \"\\f89e\",\n  \"person-fill-dash\": \"\\f89f\",\n  \"person-fill-down\": \"\\f8a0\",\n  \"person-fill-exclamation\": \"\\f8a1\",\n  \"person-fill-gear\": \"\\f8a2\",\n  \"person-fill-lock\": \"\\f8a3\",\n  \"person-fill-slash\": \"\\f8a4\",\n  \"person-fill-up\": \"\\f8a5\",\n  \"person-fill-x\": \"\\f8a6\",\n  \"person-gear\": \"\\f8a7\",\n  \"person-lock\": \"\\f8a8\",\n  \"person-slash\": \"\\f8a9\",\n  \"person-up\": \"\\f8aa\",\n  \"scooter\": \"\\f8ab\",\n  \"taxi-front-fill\": \"\\f8ac\",\n  \"taxi-front\": \"\\f8ad\",\n  \"amd\": \"\\f8ae\",\n  \"database-add\": \"\\f8af\",\n  \"database-check\": \"\\f8b0\",\n  \"database-dash\": \"\\f8b1\",\n  \"database-down\": \"\\f8b2\",\n  \"database-exclamation\": \"\\f8b3\",\n  \"database-fill-add\": \"\\f8b4\",\n  \"database-fill-check\": \"\\f8b5\",\n  \"database-fill-dash\": \"\\f8b6\",\n  \"database-fill-down\": \"\\f8b7\",\n  \"database-fill-exclamation\": \"\\f8b8\",\n  \"database-fill-gear\": \"\\f8b9\",\n  \"database-fill-lock\": \"\\f8ba\",\n  \"database-fill-slash\": \"\\f8bb\",\n  \"database-fill-up\": \"\\f8bc\",\n  \"database-fill-x\": \"\\f8bd\",\n  \"database-fill\": \"\\f8be\",\n  \"database-gear\": \"\\f8bf\",\n  \"database-lock\": \"\\f8c0\",\n  \"database-slash\": \"\\f8c1\",\n  \"database-up\": \"\\f8c2\",\n  \"database-x\": \"\\f8c3\",\n  \"database\": \"\\f8c4\",\n  \"houses-fill\": \"\\f8c5\",\n  \"houses\": \"\\f8c6\",\n  \"nvidia\": \"\\f8c7\",\n  \"person-vcard-fill\": \"\\f8c8\",\n  \"person-vcard\": \"\\f8c9\",\n  \"sina-weibo\": \"\\f8ca\",\n  \"tencent-qq\": \"\\f8cb\",\n  \"wikipedia\": \"\\f8cc\",\n  \"alphabet-uppercase\": \"\\f2a5\",\n  \"alphabet\": \"\\f68a\",\n  \"amazon\": \"\\f68d\",\n  \"arrows-collapse-vertical\": \"\\f690\",\n  \"arrows-expand-vertical\": \"\\f695\",\n  \"arrows-vertical\": \"\\f698\",\n  \"arrows\": \"\\f6a2\",\n  \"ban-fill\": \"\\f6a3\",\n  \"ban\": \"\\f6b6\",\n  \"bing\": \"\\f6c2\",\n  \"cake\": \"\\f6e0\",\n  \"cake2\": \"\\f6ed\",\n  \"cookie\": \"\\f6ee\",\n  \"copy\": \"\\f759\",\n  \"crosshair\": \"\\f769\",\n  \"crosshair2\": \"\\f794\",\n  \"emoji-astonished-fill\": \"\\f795\",\n  \"emoji-astonished\": \"\\f79a\",\n  \"emoji-grimace-fill\": \"\\f79b\",\n  \"emoji-grimace\": \"\\f7a0\",\n  \"emoji-grin-fill\": \"\\f7a1\",\n  \"emoji-grin\": \"\\f7a6\",\n  \"emoji-surprise-fill\": \"\\f7a7\",\n  \"emoji-surprise\": \"\\f7ac\",\n  \"emoji-tear-fill\": \"\\f7ad\",\n  \"emoji-tear\": \"\\f7b2\",\n  \"envelope-arrow-down-fill\": \"\\f7b3\",\n  \"envelope-arrow-down\": \"\\f7b8\",\n  \"envelope-arrow-up-fill\": \"\\f7b9\",\n  \"envelope-arrow-up\": \"\\f7be\",\n  \"feather\": \"\\f7bf\",\n  \"feather2\": \"\\f7c4\",\n  \"floppy-fill\": \"\\f7c5\",\n  \"floppy\": \"\\f7d8\",\n  \"floppy2-fill\": \"\\f7d9\",\n  \"floppy2\": \"\\f7e4\",\n  \"gitlab\": \"\\f7e5\",\n  \"highlighter\": \"\\f7f8\",\n  \"marker-tip\": \"\\f802\",\n  \"nvme-fill\": \"\\f803\",\n  \"nvme\": \"\\f80c\",\n  \"opencollective\": \"\\f80d\",\n  \"pci-card-network\": \"\\f8cd\",\n  \"pci-card-sound\": \"\\f8ce\",\n  \"radar\": \"\\f8cf\",\n  \"send-arrow-down-fill\": \"\\f8d0\",\n  \"send-arrow-down\": \"\\f8d1\",\n  \"send-arrow-up-fill\": \"\\f8d2\",\n  \"send-arrow-up\": \"\\f8d3\",\n  \"sim-slash-fill\": \"\\f8d4\",\n  \"sim-slash\": \"\\f8d5\",\n  \"sourceforge\": \"\\f8d6\",\n  \"substack\": \"\\f8d7\",\n  \"threads-fill\": \"\\f8d8\",\n  \"threads\": \"\\f8d9\",\n  \"transparency\": \"\\f8da\",\n  \"twitter-x\": \"\\f8db\",\n  \"type-h4\": \"\\f8dc\",\n  \"type-h5\": \"\\f8dd\",\n  \"type-h6\": \"\\f8de\",\n  \"backpack-fill\": \"\\f8df\",\n  \"backpack\": \"\\f8e0\",\n  \"backpack2-fill\": \"\\f8e1\",\n  \"backpack2\": \"\\f8e2\",\n  \"backpack3-fill\": \"\\f8e3\",\n  \"backpack3\": \"\\f8e4\",\n  \"backpack4-fill\": \"\\f8e5\",\n  \"backpack4\": \"\\f8e6\",\n  \"brilliance\": \"\\f8e7\",\n  \"cake-fill\": \"\\f8e8\",\n  \"cake2-fill\": \"\\f8e9\",\n  \"duffle-fill\": \"\\f8ea\",\n  \"duffle\": \"\\f8eb\",\n  \"exposure\": \"\\f8ec\",\n  \"gender-neuter\": \"\\f8ed\",\n  \"highlights\": \"\\f8ee\",\n  \"luggage-fill\": \"\\f8ef\",\n  \"luggage\": \"\\f8f0\",\n  \"mailbox-flag\": \"\\f8f1\",\n  \"mailbox2-flag\": \"\\f8f2\",\n  \"noise-reduction\": \"\\f8f3\",\n  \"passport-fill\": \"\\f8f4\",\n  \"passport\": \"\\f8f5\",\n  \"person-arms-up\": \"\\f8f6\",\n  \"person-raised-hand\": \"\\f8f7\",\n  \"person-standing-dress\": \"\\f8f8\",\n  \"person-standing\": \"\\f8f9\",\n  \"person-walking\": \"\\f8fa\",\n  \"person-wheelchair\": \"\\f8fb\",\n  \"shadows\": \"\\f8fc\",\n  \"suitcase-fill\": \"\\f8fd\",\n  \"suitcase-lg-fill\": \"\\f8fe\",\n  \"suitcase-lg\": \"\\f8ff\",\n  \"suitcase\": \"\\f900\",\n  \"suitcase2-fill\": \"\\f901\",\n  \"suitcase2\": \"\\f902\",\n  \"vignette\": \"\\f903\",\n);\n\n@each $icon, $codepoint in $bootstrap-icons-map {\n  .bi-#{$icon}::before { content: $codepoint; }\n}\n",".sidebarArea {\r\n  flex-shrink: 0;\r\n  width: $iboost-sidebar-width;\r\n  background-color: $white;\r\n  filter: $iboost-box-shadow;\r\n  position: relative;\r\n  z-index: 1;\r\n  .sidenav-bg:hover {\r\n    background-color: $gray-100;\r\n    border-radius: $iboost-border-radius;\r\n  }\r\n  .sidenav-bg:hover a{\r\n    color: text-primary !important;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n  .sidebarArea {\r\n    position: fixed;\r\n    height: 100%;\r\n    overflow: auto;\r\n    z-index: 1;\r\n    margin-left: -$sidebarWidth;\r\n    transition: 0.2s ease-in;\r\n    &.showSidebar {\r\n      margin-left: 0px;\r\n    }\r\n  }\r\n}\r\n",".pageWrapper {\r\n  min-height: 100vh;\r\n}\r\n.contentArea {\r\n  flex-grow: 1;\r\n}\r\n.wrapper {\r\n  max-width: 1300px;\r\n  margin: 0 auto;\r\n}\r\n.card {\r\n  box-shadow: $card-box-shadow;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.circle-box {\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  text-align: center;\r\n  border-radius: 100%;\r\n  &.lg-box {\r\n    width: 60px;\r\n    height: 60px;\r\n    font-size: 21px;\r\n    line-height: 60px;\r\n  }\r\n}\r\n.button-group .btn {\r\n  margin: 3px;\r\n}\r\n\r\n.table>:not(:first-child) {\r\n  border-top: 2px solid;\r\n}\r\n.table-borderless>:not(:first-child) {\r\n  border-top-width: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
